/// <reference path="../typings/index.d.ts" />
declare var bootstrap: any;
namespace App.Modulos {
  export class Business {
    public static inicializar() {
      var business = new App.Business();
      business.inicializarEventos();
    }
  }
}

namespace App {
  export class Business {
    private ajax: IAjax;
    private idExtensao: string = null;
    private elBtnVincularConta: JQuery = $(".btn-vincular-conta");
    private elBtnVincularMultConta: JQuery = $(".btn-vincular-mult-conta");
    private elBtnTeste: JQuery = $("#btn-teste");
    private elBtnTestePrecoExterno: JQuery = $("#btn-teste-preco-externo");
    private elBtnBloqueiosFontes: JQuery = $("#btn-bloqueios-fontes");
    private intervaloBloqueiosFontes: number = null;
    private popoverBloqueiosInit: boolean = false;
    private elBtnExtrairDadosWebApp: JQuery = $("#btn-extrair-dados-webapp");
    private elBtnDesfragmentarLiberarEspacoDisco: JQuery = $("#btn-limpeza-disco");
    private elBtnAddPluginInicializacao: JQuery = $("#btn-add-plugin-inicializacao");
    private elBtnRemoverPluginInicializacao: JQuery = $("#btn-remover-plugin-inicializacao");
    private elBtnReiniciarVm: JQuery = $("#btn-reiniciar-vm");
    private elBtnReinstalarChrome: JQuery = $("#btnreinstalarchrome");
    private elBtnLimparLimites: JQuery = $("#btn-limpar-limits");
    private elBtnLimparLogs: JQuery = $("#btn-limpar-logs");
    private elBtnOtimizarRedeWindows: JQuery = $("#btn-otimizar-rede-windows");
    private elBtnAtualizarProxyFutTransfer: JQuery = $("#btn-atualizar-proxy-fut-transfer");
    private elBtnInterromperTarefas: JQuery = $(".btn-interromper-tarefas");
    private elBtnReiniciarPlugin: JQuery = $(".btn-reiniciar-plugin");
    private elBtnTesteNotificacaoTelegram: JQuery = $("#btn-teste-notificacao-telegram");
    private elBtnExportarDatabaseLocal: JQuery = $("#btn-exportar-database-local");
    private elBtnBackupRestauracao: JQuery = $("#btn-backup-restauracao");
    private arquivoRestauracaoSelecionado: File = null;
    private restauracaoEmAndamento: boolean = false;
    private restauracaoTimeoutReconexao: any = null;

    private elBtnSalvarConfigGeral: JQuery = $(".btn-salvar-config-geral");

    private elBtnAtualizar: JQuery = $(".btn-atualizar");
    private elBtnSalvarServidor: JQuery = $(".btn-add-servidor");

    private elFiltroExigido: JQuery = $(".filtro-exigido");
    private elAgendamentoExigido: JQuery = $(".agendamento-exigido");
    private elDataTableLogs: any = $("#datatableLogs");
    private elDataTableContas: any = $("#datatableContas");
    private elDropdownAplicarFiltroPro: JQuery = $(".aplicar-filtro-pro");
    private elDropdownSubstituirFiltroPro: JQuery = $(".substituir-filtro-pro");
    private elBtnLimparFiltroPro: JQuery = $(".limpar-filtro-pro");
    private elBtnAplicarProfile: JQuery = $(".btn-aplicar-profile");
    private elBtnAplicarFiltros: JQuery = $(".btn-aplicar-filtros");
    private elBtnAplicarProxy: JQuery = $(".btn-aplicar-proxy");
    private elBtnResolverDmeContas: JQuery = $(".btn-acao-resolver-dme-contas");
    private elBtnSelecionarTodosOsFiltros: JQuery = $(".btn-selecionar-todos-os-filtros");
    private elBtnApagarTodosOsFiltros: JQuery = $(".btn-apagar-todos-os-filtros");
    private elBtnAbrirContas: JQuery = $(".btn-abrir-contas");
    private elBtnLimparCache: JQuery = $(".btn-limpar-cache");
    private elBtnLimparDmesContas: JQuery = $(".btn-limpar-dmes-contas");
    private elBtnResetarTentativasAutoDmeContas: JQuery = $(".btn-resetar-tentativas-auto-dme-contas");
    private elBtnSincronizarDatabase: JQuery = $(".btn-sincronizar-database");
    private elBtnExecutarTarefaContas: JQuery = $(".btn-executar-tarefa-contas");
    private elBtnExecutarAutoDmeImediatoContas: JQuery = $(".btn-executar-auto-dme-imediato-contas");
    private elBtnResgatarRecompensasContas: JQuery = $(".btn-resgatar-recompensas-contas");
    private elBtnVenderCoins: JQuery = $(".btn-vender-coins");
    // ─── Transfer Between Accounts — beta ───────────────────────────────────
    private transferCoins: App.TransferCoins = null;
    // ─────────────────────────────────────────────────────────────────────────
    private elBtnResolverBugEa: JQuery = $(".btn-resolver-bug-ea");
    private elBtnAjustarLucro: JQuery = $(".btn-ajustar-lucro");
    private elBtncadastrarFiltroPro: JQuery = $("#cadastrarFiltro");
    private elBtnAtivarPilotoAutomatico: JQuery = $(".piloto-automatico");

    private elBtnSalvarFiltroProModalSniper: JQuery = $(".salvar-filtro-pro-modal-sniper");

    private elBtnAddConta: JQuery = $(".btn-iniciar-vincular-conta");


    private socketClientBot: any = null;
    private comunicacao: Comunicacao = null;
    private conectado: boolean = false;
    private pluginLigado: boolean = false;
    private versaoPlugin: any = null;
    private dmesHeaderResetTimer: number = null;
    private ipPlugin: string = null;
    private tarefaLigada: boolean = false;
    private filtrosEa: FiltrosEa = null;
    private objSelect2: ISelect2 = null;
    private alertPrecisaAddConta: any = null;
    private selectTextMilisegundosComplementoDefault: string = " milliseconds";
    public static dadosTeste: any = null;
    private objDataTableLogs: any = null;
    private objDataTableAutodme: any = null;
    private autodmeCatalogoDetalhesRequest: any = null;
    private autodmeCatalogoDetalhesCarregado: boolean = false;
    private objDataTableJogadoresConta: any = null;
    private filtroDataTableJogadoresContaRegistrado: boolean = false;
    private mapasTextoJogadoresConta: Record<string, Record<string, string>> = {};
    private excludesAutoDmeJogadoresContaAtual: any = null;
    public static objDataTableContas: any = null;
    private arrayContas: IConta[] = [];
    private arrayConsolidados: IContaConsolidado[] = [];
    private idContaSniperModalAberto: number = null;
    private tarefasSniperContas: any = {}
    private ocultarLoadListHabilitado: boolean = true
    private pendingStatusUpdatesByContaId: Record<number, any> = {}
    private statusQueueFlushScheduled: boolean = false
    private pendingSortContaIds: Set<number> = new Set<number>()
    private lastStatusSeqByContaId: Record<number, number> = {}
    private lastStatusSignatureByContaId: Record<number, string> = {}
    private metricStatusUpdatesReceived: number = 0
    private metricStatusUpdatesDeduped: number = 0
    private metricStatusFlushCount: number = 0
    private readonly logsDashboardLimit: number = 150
    private logsDashboardNextCursor: string = null
    private logsDashboardOffset: number = 0
    private logsDashboardHasMore: boolean = false
    private logsDashboardCarregando: boolean = false

    /** Debounce ao ajustar prioridade AutoDME na listagem (um POST após parar de clicar). */
    private prioridadeAutodmeDebounceTimers: Record<number, number> = {};
    private readonly prioridadeAutodmeDebounceMs = 550;
    private formAutodmePreenchido: number[] = [];

    public static cronometros: any = {};

    /**
     * Renderiza a coluna "DMEs" do #datatableContas a partir de `conta.dmes`
     * (fonte única: objeto EA nativo + `_autodme` metadata interna).
     *
     * Modos suportados (SBCRepeatabilityMode):
     *  - NON_REPEATABLE → círculos por desafio (challengesCompletedCount / challengesCount)
     *  - LIMITED        → barra timesCompleted / repeats (cumulativo vitalício)
     *  - REFRESH        → barra timesCompletedInInterval / repeats + countdown até fim do ciclo
     *  - UNLIMITED      → ciclos completos hoje UK por desafios enviados + bolinhas da rodada atual
     * Badges de status:
     *  - ✅ Completo       (status === "completo")
     *  - 🔄 Em andamento   (status === "em_andamento")
     *  - ⛔ Bloqueado      (status === "bloqueado", motivo em tooltip)
     *  - ⏳ Pendente       (status === "pendente")
     *  - 🕒 Expirado       (!notExpirable && endTime*1000 < agora)
     *
     * Resumo: se todos os DMEs “da rotina” (exceto `nao_disponivel_webapp`) estiverem
     * concluídos ou expirados, mostra badge **Tarefa Completa no Dia** + “Ver mais”; cadastros
     * não disponíveis na EA ficam por último na lista expandida.
     */
    public static renderColunaDmes(obj: IConta): string {
      const dmes: IDmeContaItem[] = Array.isArray((obj as any).dmes) ? (obj as any).dmes : [];
      if (!dmes.length) {
        return '<p class="font-size-12 text-limit-quebra-400">-</p>';
      }

      const agoraMs = Date.now();

      // Modos Piloto/Conjunto: o sistema NÃO percorre uma fila de pendentes — o planejador
      // escolhe, a cada passo, o que é viável com o clube atual. Logo "pendente" ali não é
      // "aguardando a vez", é "o planejador não conseguiu usar" = inviável agora.
      const modoExecucao = String(Business.modoExecucaoAutoDmeAtivo || "").toLowerCase();
      const modoPlanejado = modoExecucao === "piloto" || modoExecucao === "conjunto";

      // "Sem mais desafios viáveis no dia": carimbo gravado pelo servidor quando o mapa
      // comprovou que nenhum DME é executável no ciclo. Só vale se (a) for do ciclo EA
      // corrente e (b) nenhum DME teve sucesso DEPOIS dele — um sucesso posterior torna o
      // carimbo obsoleto (o clube mudou e o planejador voltaria a ter o que fazer).
      const cicloEsgotadoHoje = ((): boolean => {
        if (!modoPlanejado) return false;
        const carimbo = Number((obj as any).auto_dme_ciclo_esgotado_ms) || 0;
        if (carimbo <= 0) return false;
        const inicioCicloEa = App.Business.proximoResetDmesUkMs(agoraMs) - (24 * 60 * 60 * 1000);
        if (carimbo < inicioCicloEa) return false;
        let ultimoSucessoTs = 0;
        dmes.forEach((d) => {
          const ts = Number((d._autodme || ({} as any)).ultimo_sucesso_ts) || 0;
          if (ts > ultimoSucessoTs) ultimoSucessoTs = ts;
        });
        return carimbo >= ultimoSucessoTs;
      })();

      /** Cadastro que não existe no snapshot da EA — não entra na “rotina do dia” para o resumo. */
      const isIgnoradoResumoDia = (d: IDmeContaItem): boolean => {
        const meta = d._autodme || ({} as any);
        if (App.Business.dmeExpiradoHeuristica(d, agoraMs)) return false;
        const st = meta.status || "pendente";
        return st === "bloqueado" && String(meta.motivo_bloqueio || "") === "nao_disponivel_webapp";
      };

      const ordemOriginal = new Map<IDmeContaItem, number>();
      dmes.forEach((dme, idx) => ordemOriginal.set(dme, idx));
      const prioridadeVisual = (dme: IDmeContaItem): number => {
        const meta = dme && dme._autodme ? dme._autodme : null;
        const prioridade = Number(meta ? meta.prioridade_autodme : null);
        return Number.isFinite(prioridade) && prioridade > 0 ? prioridade : 9999;
      };
      const dmesOrdenados = [...dmes].sort((a: IDmeContaItem, b: IDmeContaItem) => {
        const pa = prioridadeVisual(a);
        const pb = prioridadeVisual(b);
        if (pa !== pb) return pa - pb;
        const ordemA = ordemOriginal.has(a) ? ordemOriginal.get(a) : 9999;
        const ordemB = ordemOriginal.has(b) ? ordemOriginal.get(b) : 9999;
        return ordemA - ordemB;
      });

      const obterStatusVisualDme = (dme: IDmeContaItem): string => {
        const meta = dme._autodme || ({} as any);
        const modo: string = String(dme.repeatabilityMode || "NON_REPEATABLE").toUpperCase();
        const exp = App.Business.dmeExpiradoHeuristica(dme, agoraMs);
        if (exp) return "expirado";
        const timesCompleted = Math.max(0, Number((dme as any).timesCompleted || 0));
        const repeatsCfg = Math.max(0, Number((dme as any).repeats || 0));
        const timesNoCiclo = Math.max(0, Number((dme as any).timesCompletedInInterval || 0));
        const solucoesHojeMeta = Math.max(0, Number(meta.solucoes_hoje != null ? meta.solucoes_hoje : meta.sucessos_hoje || 0));
        const limiteRefresh = Math.max(0, Number(meta.limite_ciclo_efetivo || 0))
          || repeatsCfg
          || Math.max(0, Number(meta.limite_solucoes_diarias || 0))
          || Math.max(0, Number(meta.limite_diario_efetivo || 0));
        const desafiosConcluidos = Math.max(0, Number((dme as any).challengesCompletedCount || 0));
        const cc = Math.max(0, Number((dme as any).challengesCount) || 0);
        const stMeta = String(meta.status || "pendente").toLowerCase();
        if (modo === "NON_REPEATABLE" && cc > 1 && desafiosConcluidos > 0 && desafiosConcluidos < cc && stMeta !== "bloqueado") {
          return "em_andamento";
        }
        const nonRepeatableCompleto =
          modo === "NON_REPEATABLE"
          && (cc > 1 ? desafiosConcluidos >= cc : timesCompleted > 0);
        const refreshCompleto = modo === "REFRESH"
          && limiteRefresh > 0
          && Math.max(timesNoCiclo, solucoesHojeMeta) >= limiteRefresh;
        const concluidoVisual =
          refreshCompleto
          || (modo === "LIMITED" && repeatsCfg > 0 && timesCompleted >= repeatsCfg)
          || nonRepeatableCompleto;
        if (concluidoVisual) return "completo";
        if (modo === "REFRESH" && meta.status) {
          return stMeta;
        }
        return String(meta.status || "pendente");
      };

      const renderResumoStatusDmes = (lista: IDmeContaItem[], rotinaCompleta: boolean): string => {
        const contagens: Record<string, number> = {
          completo: 0,
          em_andamento: 0,
          limite: 0,
          pendente: 0,
          expirado: 0,
        };

        lista.forEach((dme) => {
          let status = String(obterStatusVisualDme(dme) || "pendente").toLowerCase();
          // Sem mais desafios viáveis no dia: o que estava "em andamento" (multi-desafio
          // parcial) não vai avançar até a virada da EA — para o dia, está concluído.
          if (cicloEsgotadoHoje && status === "em_andamento") {
            status = "completo";
          }
          if (status === "bloqueado") {
            contagens.limite += 1;
          } else if (contagens[status] != null) {
            contagens[status] += 1;
          } else {
            contagens.limite += 1;
          }
        });

        const total = lista.length;
        const partesTitulo: string[] = [];
        const chip = (key: string, label: string, classe: string, titulo: string): string => {
          const totalKey = contagens[key] || 0;
          if (totalKey <= 0) return "";
          partesTitulo.push(`${totalKey} ${titulo}`);
          return `<span class="badge ${classe} dmes-status-chip" title="${titulo}: ${totalKey}">${label} ${totalKey}</span>`;
        };

        // Resumo da coluna DMEs (recolhido): SÓ "Concluídos" e "Em andamento" para não
        // confundir o usuário. Limite/Inviável/Expirado ficam apenas no detalhamento
        // ("Detalhes"), que continua completo.
        const chips = [
          chip("completo", "Concl.", "badge-success", "concluidos"),
          chip("em_andamento", "Andam.", "badge-info", "em andamento"),
        ].join("");

        const tituloBase = rotinaCompleta ? "Rotina do dia completa. " : "";
        const title = `${tituloBase}Resumo DMEs: ${partesTitulo.join("; ") || `${total} configurado(s)`}. Total: ${total}.`;
        return `<div class="dmes-status-summary" title="${title.replace(/"/g, "&quot;")}">${chips || `<span class="badge badge-secondary dmes-status-chip">DMEs ${total}</span>`}</div>`;
      };

      const renderItem = (dme: IDmeContaItem): string => {
        const meta = dme._autodme || ({} as any);
        const nomeTitulo = String(dme.nameptbr || dme.name || "").replace(/"/g, "&quot;");
        const nomeVisivel = String(dme.nameptbr || dme.name || "-");
        const prioridade = Number(meta.prioridade_autodme);
        const prioridadeLabel = Number.isFinite(prioridade) && prioridade > 0 ? String(Math.trunc(prioridade)) : "-";
        const prioridadeTitle = prioridadeLabel !== "-" ? `Prioridade ${prioridadeLabel}` : "Prioridade nao informada";
        const modo: string = String(dme.repeatabilityMode || "NON_REPEATABLE").toUpperCase();
        const sucessosHoje = (meta.sucessos_hoje != null) ? Number(meta.sucessos_hoje) : 0;
        const solucoesHojeEa = Math.max(0, Number(meta.solucoes_hoje != null ? meta.solucoes_hoje : sucessosHoje) || 0);
        const tentativasHoje = (meta.tentativas_hoje != null) ? Number(meta.tentativas_hoje) : 0;
        const falhasHoje = meta.falhas_hoje != null
          ? Math.max(0, Number(meta.falhas_hoje) || 0)
          : Math.max(0, tentativasHoje - sucessosHoje);

        const status: string = obterStatusVisualDme(dme);
        const refreshIntervalSeg = Number(dme.refreshInterval || (dme as any).repeatRefreshInterval) || 0;
        const formatarRefreshEa = (ts: number): string => {
          const dUtc = new Date(ts);
          const pad2 = (n: number): string => n < 10 ? `0${n}` : String(n);
          const utcLeg = `${pad2(dUtc.getUTCDate())}/${pad2(dUtc.getUTCMonth() + 1)} ${pad2(dUtc.getUTCHours())}:${pad2(dUtc.getUTCMinutes())} UTC`;
          let ukLeg = "";
          let localLeg = "";
          try {
            const optsUk: any = { timeZone: "Europe/London", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false };
            ukLeg = dUtc.toLocaleString("pt-BR", optsUk).replace(",", "");
          } catch (e) { }
          try {
            const optsLocal: any = { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false };
            localLeg = dUtc.toLocaleString("pt-BR", optsLocal).replace(",", "");
          } catch (e) { }
          const baseUk = ukLeg ? `18:00 UK (${ukLeg})` : "18:00 UK";
          return `${baseUk} | ${utcLeg}${localLeg ? ` | local ${localLeg}` : ""}`;
        };
        const proximoElegivelTs = meta.proximo_elegivel_ts ? Number(meta.proximo_elegivel_ts) : 0;
        const temCooldown = proximoElegivelTs > agoraMs;
        const faltaCooldown = temCooldown ? App.Business.formatarTempoRestanteCurto(proximoElegivelTs - agoraMs) : "";
        const primeiroNumeroPositivo = (...valores: any[]): number => {
          for (const valor of valores) {
            const n = Number(valor);
            if (Number.isFinite(n) && n > 0) return n;
          }
          return 0;
        };
        const totalDesafios = Math.max(1, primeiroNumeroPositivo(dme.challengesCount, 1));
        const desafiosConcluidos = Math.min(Math.max(0, Number(dme.challengesCompletedCount || 0)), totalDesafios);
        const totalLimitado = Math.max(1, primeiroNumeroPositivo(dme.repeats, 1));
        const limitadosFeitos = Math.min(Math.max(0, Number(dme.timesCompleted || 0)), totalLimitado);
        const totalRefresh = Math.max(1, primeiroNumeroPositivo(
          meta.limite_ciclo_efetivo,
          dme.repeats,
          meta.limite_solucoes_diarias_efetivo,
          meta.limite_solucoes_diarias,
          1
        ));
        const feitosRefreshRaw = Math.min(Math.max(0, Number(dme.timesCompletedInInterval || 0)), totalRefresh);
        const solucoesRefresh = Math.min(Math.max(solucoesHojeEa, 0), totalRefresh);
        const snapshotRefreshAntigo = modo === "REFRESH" && status !== "completo" && proximoElegivelTs <= agoraMs && feitosRefreshRaw >= totalRefresh;
        const feitosRefresh = snapshotRefreshAntigo ? solucoesRefresh : Math.max(feitosRefreshRaw, solucoesRefresh);
        const labelCiclo = `Ciclo ${feitosRefresh}/${totalRefresh}`;
        const labelDesafios = `Desafios ${desafiosConcluidos}/${totalDesafios}`;
        const limiteDiarioUnlimited = Math.max(0, Number(meta.limite_ciclo_efetivo || meta.limite_solucoes_diarias_efetivo || meta.limite_solucoes_diarias || 0));
        const desafiosLocaisHoje = Math.max(0, Number(meta.desafios_locais_hoje || 0));
        const desafiosPorCiclo = Math.max(1, Number(meta.desafios_por_ciclo || dme.challengesCount || 1));
        const parciaisCicloAtual = meta.desafios_parciais_ciclo_atual != null
          ? Math.max(0, Number(meta.desafios_parciais_ciclo_atual) || 0)
          : (desafiosLocaisHoje % desafiosPorCiclo);
        const labelHojeEa = limiteDiarioUnlimited > 0 ? `Hoje ${solucoesHojeEa}/${limiteDiarioUnlimited}` : `Hoje ${solucoesHojeEa}/&#8734;`;
        const rodadaEaAtual = `${desafiosConcluidos}/${totalDesafios}`;
        const titleHojeEa = limiteDiarioUnlimited > 0
          ? `Ciclos hoje UK: ${solucoesHojeEa}/${limiteDiarioUnlimited}. Desafios enviados hoje: ${desafiosLocaisHoje}; desafios por ciclo: ${desafiosPorCiclo}; parcial local atual: ${parciaisCicloAtual}/${desafiosPorCiclo}; rodada EA atual: ${rodadaEaAtual}.`
          : `Ciclos hoje UK: ${solucoesHojeEa}/infinito. Desafios enviados hoje: ${desafiosLocaisHoje}; desafios por ciclo: ${desafiosPorCiclo}; parcial local atual: ${parciaisCicloAtual}/${desafiosPorCiclo}; rodada EA atual: ${rodadaEaAtual}.`;
        const escapeTitle = (texto: string): string => String(texto || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        const tituloLimiteAtingido = (motivoBloqueio: string): string => {
          const motivoNorm = String(motivoBloqueio || "").toLowerCase();
          if (motivoNorm === "limite_tentativas_dme_dia") {
            const limite = meta.limite_tentativas_dia != null ? Number(meta.limite_tentativas_dia) : null;
            return limite != null && Number.isFinite(limite) && limite > 0
              ? `Limite de falhas do ciclo EA atingido (${falhasHoje}/${limite}; ${tentativasHoje} tentativas totais)`
              : `Limite de falhas do ciclo EA atingido (${falhasHoje} falhas; ${tentativasHoje} tentativas totais)`;
          }
          if (motivoNorm === "limite_solucoes_dme_dia") {
            return limiteDiarioUnlimited > 0
              ? `Limite de solucoes deste DME no ciclo EA atingido (${solucoesHojeEa}/${limiteDiarioUnlimited})`
              : `Limite de solucoes deste DME no ciclo EA atingido (${solucoesHojeEa})`;
          }
          if (motivoNorm === "limite_solucoes_conta_dia") {
            return "Limite de solucoes da conta no dia atingido";
          }
          if (motivoNorm === "limite_desafios_conta_dia") {
            return "Limite de desafios da conta no dia atingido";
          }
          if (motivoNorm === "limite_forragens_clube") {
            const totalForragens = meta.forragens_clube_total != null ? Number(meta.forragens_clube_total) : null;
            const faixas = Array.isArray(meta.limites_solucoes_por_forragens) ? meta.limites_solucoes_por_forragens : [];
            const detalheFaixas = faixas.length ? `; faixas ${faixas.map((f: any) => `${f.solucoes || 0}<${f.abaixo_de || 0}`).join("; ")}` : "";
            return `Limite por forragens do clube atingido${totalForragens != null && Number.isFinite(totalForragens) ? ` (${totalForragens} forragens)` : ""}${detalheFaixas}`;
          }
          if (motivoNorm === "sem_scan_forragens_clube") {
            return "Limite por forragens do clube nao calculado: sem scan local de forragens";
          }
          return "Limite atingido";
        };
        const conclusoesParaLabelBloqueado = solucoesHojeEa > 0 ? solucoesHojeEa : (
          modo === "REFRESH" ? feitosRefresh : desafiosConcluidos
        );
        const bloquearComoParcialCompleto =
          status === "bloqueado"
          && modo !== "UNLIMITED"
          && conclusoesParaLabelBloqueado > 0
          && String(meta.motivo_bloqueio || "") !== "nao_disponivel_webapp"
          && String(meta.motivo_bloqueio || "") !== "limite_forragens_clube"
          && String(meta.motivo_bloqueio || "") !== "sem_scan_forragens_clube";

        let badgeHtml = "";
        switch (status) {
          case "completo":
            if (modo === "REFRESH") {
              badgeHtml = `<span class="badge badge-success font-size-10" title="DME concluido no ciclo atual: ${labelCiclo}">Completo ${labelCiclo}</span>`;
            } else if (modo === "NON_REPEATABLE" && totalDesafios > 1) {
              badgeHtml = `<span class="badge badge-success font-size-10" title="DME concluido: ${labelDesafios}">Completo ${labelDesafios}</span>`;
            } else if (modo === "UNLIMITED") {
              badgeHtml = `<span class="badge badge-success font-size-10" title="${titleHojeEa.replace(/"/g, "&quot;")}">${labelHojeEa}</span>`;
            } else {
              badgeHtml = `<span class="badge badge-success font-size-10" title="DME concluido">Completo</span>`;
            }
            break;
          case "em_andamento":
            badgeHtml = cicloEsgotadoHoje
              ? `<span class="badge badge-success font-size-10" title="${escapeTitle(`Concluido para o dia: ${labelDesafios}. Os desafios restantes nao sao viaveis no ciclo atual; renovam na virada da EA (18:00 UK).`)}">Concluido no dia ${labelDesafios}</span>`
              : `<span class="badge badge-info font-size-10" title="Execucao em andamento">Em andamento</span>`;
            break;
          case "bloqueado": {
            const motivo = meta.motivo_bloqueio ? String(meta.motivo_bloqueio) : "";
            const isCooldown = motivo === "cooldown_tentativa" || motivo === "cooldown_dme" || motivo === "solver_timeout_temporario";
            if (isCooldown) {
              const tipo = motivo === "cooldown_dme" ? "entre envios" : (motivo === "solver_timeout_temporario" ? "por timeout do solver" : "entre tentativas");
              const tempoLabel = temCooldown ? ` (${faltaCooldown})` : "";
              badgeHtml = `<span class="badge badge-secondary font-size-10" title="Aguardando intervalo ${tipo}${tempoLabel}">Aguardando${tempoLabel}</span>`;
            } else {
              const diagnostico = (meta as any).ultimo_diagnostico || (meta as any).diagnostic || null;
              const motivoDisplayRaw = diagnostico && diagnostico.diagnosticTitle
                ? Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticTitle)
                : (motivo || "Bloqueado");
              if (modo === "UNLIMITED") {
                const limite = meta.limite_tentativas_dia != null ? Number(meta.limite_tentativas_dia) : null;
                const falhasDisplay = limite != null && Number.isFinite(limite) && limite > 0
                  ? ` Falhas locais: ${falhasHoje}/${limite}; tentativas totais: ${tentativasHoje}.`
                  : ` Falhas locais: ${falhasHoje}; tentativas totais: ${tentativasHoje}.`;
                const motivoEhLimiteUnlimited = String(motivo || "").toLowerCase().indexOf("limite_") === 0;
                const tituloUnlimited = motivoEhLimiteUnlimited
                  ? `${titleHojeEa} ${tituloLimiteAtingido(motivo)}. ${motivoDisplayRaw}.${falhasDisplay}`
                  : `${titleHojeEa} ${motivoDisplayRaw}.${falhasDisplay}`;
                badgeHtml = `<span class="badge badge-info font-size-10" title="${escapeTitle(tituloUnlimited)}">${labelHojeEa}</span>`;
              } else if (bloquearComoParcialCompleto) {
                const limite = meta.limite_tentativas_dia != null ? Number(meta.limite_tentativas_dia) : null;
                const limiteDisplay = limite != null && Number.isFinite(limite) && limite > 0
                  ? ` (${falhasHoje}/${limite} falhas no ciclo EA; ${tentativasHoje} tentativas totais)`
                  : "";
                const tituloLimite = `${conclusoesParaLabelBloqueado} concluido(s); ${tituloLimiteAtingido(motivo)}${limiteDisplay && tituloLimiteAtingido(motivo) === "Limite atingido" ? limiteDisplay : ""}`;
                badgeHtml = `<span class="badge badge-success font-size-10" title="${escapeTitle(tituloLimite)}">Limite atingido ${conclusoesParaLabelBloqueado} Completo</span>`;
              } else if (motivo === "limite_forragens_clube" || motivo === "sem_scan_forragens_clube") {
                const tituloLimite = `${tituloLimiteAtingido(motivo)}. ${motivoDisplayRaw}`;
                badgeHtml = `<span class="badge badge-default font-size-10" title="${escapeTitle(tituloLimite)}">Invi&aacute;vel</span>`;
              } else {
                const texto = motivo === "limite_tentativas_dme_dia"
                  ? "Sem solucao, limite atingido"
                  : (motivo === "nao_disponivel_webapp" ? "Indisponivel" : "Limite atingido");
                const motivoEhLimite = String(motivo || "").toLowerCase().indexOf("limite_") === 0;
                const tituloBadge = motivoEhLimite ? `${tituloLimiteAtingido(motivo)}. ${motivoDisplayRaw}` : motivoDisplayRaw;
                badgeHtml = `<span class="badge badge-default font-size-10" title="${escapeTitle(tituloBadge)}">${texto}</span>`;
              }
            }
            break;
          }
          case "expirado":
            badgeHtml = `<span class="badge badge-secondary font-size-10" title="DME expirado">Expirado</span>`;
            break;
          case "pendente":
          default:
            if (modo === "UNLIMITED") {
              badgeHtml = `<span class="badge badge-info font-size-10" title="${titleHojeEa.replace(/"/g, "&quot;")}">${labelHojeEa}</span>`;
            } else if (modoPlanejado) {
              // Piloto/Conjunto não têm fila: se sobrou "pendente", o planejador não
              // conseguiu montar este DME com o clube atual.
              // MAS "não montou AINDA" ≠ "não vai montar": enquanto o ciclo não esgotou, o
              // planejador volta neste DME a cada passo (o clube muda a cada execução) e ele
              // provavelmente ainda será resolvido hoje. Rotular de "Inviável" no meio do voo
              // é falso — só é verdade depois que o mapa comprovou que acabou o dia
              // (`cicloEsgotadoHoje`). Antes disso: nenhum rótulo, melhor que um errado.
              badgeHtml = cicloEsgotadoHoje
                ? `<span class="badge badge-default font-size-10" title="${escapeTitle("Inviavel no ciclo atual: o planejador ja fechou o dia e nao conseguiu monta-lo com o clube atual. Volta sozinho na virada da EA (18:00 UK) ou quando entrarem cartas que fechem o que falta.")}">Invi&aacute;vel</span>`
                : "";
            } else {
              badgeHtml = `<span class="badge badge-warning font-size-10" title="Aguardando execucao">Pendente</span>`;
            }
            break;
        }

        let resumoLinha = "";
        if (modo === "NON_REPEATABLE") {
          resumoLinha = (totalDesafios > 1 && status !== "completo" && !bloquearComoParcialCompleto)
            ? labelDesafios
            : "";
        } else if (modo === "LIMITED") {
          resumoLinha = `Limitado ${limitadosFeitos}/${totalLimitado}`;
        } else if (modo === "REFRESH") {
          resumoLinha = "";
          if (proximoElegivelTs > 0 && (status === "completo" || proximoElegivelTs > agoraMs)) {
            resumoLinha = formatarRefreshEa(proximoElegivelTs);
          }
          if (temCooldown) {
            resumoLinha += (resumoLinha ? " | " : "") + faltaCooldown;
          }
        } else if (modo === "UNLIMITED") {
          resumoLinha = "";
        } else {
          resumoLinha = modo;
        }

        const barH = 3;
        const barW = 52;
        let progressoCiclo = "";
        if (modo === "NON_REPEATABLE") {
          const totalCirculos = Math.max(1, Number(dme.challengesCount || 1));
          const concluidos = Math.min(Number(dme.challengesCompletedCount || 0), totalCirculos);
          const circles = Array.from({ length: totalCirculos })
            .map((_, idx) => `<span class="challenge-circle ${idx < concluidos ? "completed" : "pending"}" style="width:8px;height:8px;"></span>`)
            .join("");
          progressoCiclo = `<div class="dme-ciclo-barra" title="Desafios ${concluidos}/${totalCirculos}"><div class="challenge-circles" style="gap:3px;">${circles}</div></div>`;
        } else if (modo === "LIMITED") {
          const pct = Math.min(100, Math.round((limitadosFeitos / totalLimitado) * 100));
          const cor = limitadosFeitos >= totalLimitado ? "bg-success" : (limitadosFeitos > 0 ? "bg-info" : "bg-secondary");
          progressoCiclo = `
            <div class="dme-ciclo-barra" title="Limitado: ${limitadosFeitos}/${totalLimitado}">
              <div class="progress mt-0" style="height:${barH}px;width:${barW}px">
                <div class="progress-bar ${cor}" style="width:${pct}%"></div>
              </div>
            </div>`;
        } else if (modo === "REFRESH") {
          const pct = Math.min(100, Math.round((feitosRefresh / totalRefresh) * 100));
          const cor = feitosRefresh >= totalRefresh ? "bg-success" : (feitosRefresh > 0 ? "bg-info" : "bg-secondary");
          let extraTitulo = labelCiclo;
          if (refreshIntervalSeg === 86400) {
            extraTitulo += " | diario";
          } else if (refreshIntervalSeg === 172800) {
            extraTitulo += " | 2d";
          } else if (refreshIntervalSeg > 0) {
            extraTitulo += ` | ${App.Business.formatarTempoRestanteCurto(refreshIntervalSeg * 1000)}`;
          }
          progressoCiclo = `
            <div class="dme-ciclo-barra" title="${String(extraTitulo).replace(/"/g, "&quot;")}">
              <div class="progress mt-0" style="height:${barH}px;width:${barW}px">
                <div class="progress-bar ${cor}" style="width:${pct}%"></div>
              </div>
              ${resumoLinha ? `<span class="dme-refresh-info font-size-10 text-muted text-nowrap" title="${resumoLinha.replace(/"/g, "&quot;")}">${resumoLinha}</span>` : ``}
            </div>`;
        } else if (modo === "UNLIMITED") {
          const totalCirculos = Math.max(1, Number(dme.challengesCount || 1));
          const concluidos = Math.min(Number(dme.challengesCompletedCount || 0), totalCirculos);
          if (totalCirculos > 1) {
            const circles = Array.from({ length: totalCirculos })
              .map((_, idx) => `<span class="challenge-circle ${idx < concluidos ? "completed" : "pending"}" style="width:8px;height:8px;"></span>`)
              .join("");
            progressoCiclo = `<div class="dme-ciclo-barra" title="Rodada atual: ${concluidos}/${totalCirculos} desafios"><div class="challenge-circles" style="gap:3px;">${circles}</div></div>`;
          } else {
            progressoCiclo = "";
          }
        }

        const resumoEsc = resumoLinha.replace(/"/g, "&quot;");
        const resumoBloco = resumoLinha && modo !== "REFRESH"
          ? `<span class="font-size-10 text-muted text-nowrap" title="${resumoEsc}">${resumoLinha}</span>`
          : "";
        const progressoRefreshBloco = modo === "REFRESH" && status !== "completo" && feitosRefresh > 0
          ? `<span class="badge badge-info font-size-10" title="${labelCiclo}">${labelCiclo}</span>`
          : "";

        return `
          <div class="dme-item">
            <div class="dme-info dme-info-coluna">
              <div class="dme-item-linha1 d-flex align-items-center flex-wrap" style="gap:4px;line-height:1.15;">
                <span class="dme-prioridade-bolinha" title="${prioridadeTitle}">${prioridadeLabel}</span>
                <span title="${nomeTitulo}" class="dme-name text-limit-100 font-weight-bold font-size-12">${nomeVisivel}</span>
                ${badgeHtml}
                ${progressoRefreshBloco}
                ${resumoBloco}
              </div>
              ${progressoCiclo}
            </div>
          </div>
        `;
      };

      /** Status já com a leitura do dia aplicada (em andamento sem mais desafios viáveis = concluído). */
      const statusExibicaoDme = (d: IDmeContaItem): string => {
        const st = obterStatusVisualDme(d);
        return (cicloEsgotadoHoje && st === "em_andamento") ? "completo" : st;
      };

      const todosConcluidosLiteral = dmesOrdenados.every((d) => {
        const st = statusExibicaoDme(d);
        return st === "completo" || st === "expirado";
      });

      const relevantesRotinaDia = dmesOrdenados.filter((d) => !isIgnoradoResumoDia(d));
      const diaRotinaCompleta =
        relevantesRotinaDia.length > 0
        && relevantesRotinaDia.every((d) => {
          const st = statusExibicaoDme(d);
          return st === "completo" || st === "expirado";
        });

      const mostrarResumoDiaCompleto = todosConcluidosLiteral || diaRotinaCompleta;

      const todosHtml = dmesOrdenados.map(renderItem).join("");
      const totalDmes = dmesOrdenados.length;
      return `
        <div class="dmes-container">
          <div class="dmes-summary">
            ${renderResumoStatusDmes(dmesOrdenados, mostrarResumoDiaCompleto)}
            <div class="dmes-toggle-container">
              <button type="button" class="dmes-toggle" data-label-collapsed="Detalhes (${totalDmes})" data-label-expanded="Menos" onclick="App.Util.toggleDmes(this)">Detalhes (${totalDmes})</button>
            </div>
          </div>
          <div class="dmes-expanded" style="display: none;">
            ${todosHtml}
          </div>
        </div>
      `;
    }

    /** Formatação curta para countdown no modo REFRESH (1h23m, 45m, 30s). */
    public static formatarTempoRestanteCurto(ms: number): string {
      if (!ms || ms < 0) return "0s";
      const s = Math.floor(ms / 1000);
      if (s < 60) return `${s}s`;
      const m = Math.floor(s / 60);
      if (m < 60) return `${m}m`;
      const h = Math.floor(m / 60);
      const mr = m % 60;
      return mr > 0 ? `${h}h${mr}m` : `${h}h`;
    }

    private static partesNoFuso(ms: number, timeZone: string): any {
      const fmt = new Intl.DateTimeFormat("en-GB", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
        hour12: false,
      } as any);
      const partes = (fmt as any).formatToParts(new Date(ms));
      const out: any = {};
      partes.forEach((parte: any) => {
        if (parte.type !== "literal") out[parte.type] = Number(parte.value);
      });
      return {
        year: out.year,
        month: out.month,
        day: out.day,
        hour: out.hour === 24 ? 0 : out.hour,
        minute: out.minute,
        second: out.second,
      };
    }

    private static addDiasData(year: number, month: number, day: number, dias: number): any {
      const d = new Date(Date.UTC(year, month - 1, day + dias, 12, 0, 0, 0));
      return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
    }

    private static dataFusoParaUtcMs(year: number, month: number, day: number, hour: number, minute: number, timeZone: string): number {
      let guess = Date.UTC(year, month - 1, day, hour, minute, 0, 0);
      for (let i = 0; i < 3; i++) {
        const atual = App.Business.partesNoFuso(guess, timeZone);
        const atualWall = Date.UTC(atual.year, atual.month - 1, atual.day, atual.hour, atual.minute, atual.second || 0, 0);
        const desejadoWall = Date.UTC(year, month - 1, day, hour, minute, 0, 0);
        const diff = desejadoWall - atualWall;
        if (diff === 0) break;
        guess += diff;
      }
      return guess;
    }

    public static proximoResetDmesUkMs(agoraMs: number = Date.now()): number {
      const timeZone = "Europe/London";
      try {
        const partesAgora = App.Business.partesNoFuso(agoraMs, timeZone);
        const resetHoje = App.Business.dataFusoParaUtcMs(partesAgora.year, partesAgora.month, partesAgora.day, 18, 0, timeZone);
        if (resetHoje > agoraMs) return resetHoje;
        const amanha = App.Business.addDiasData(partesAgora.year, partesAgora.month, partesAgora.day, 1);
        return App.Business.dataFusoParaUtcMs(amanha.year, amanha.month, amanha.day, 18, 0, timeZone);
      } catch (e) {
        const fallback = new Date(agoraMs);
        fallback.setHours(18, 0, 0, 0);
        if (fallback.getTime() <= agoraMs) fallback.setDate(fallback.getDate() + 1);
        return fallback.getTime();
      }
    }

    private atualizarHeaderResetDmesUk(): void {
      const $alvo = $(".js-dmes-head-reset-uk");
      if ($alvo.length) {
        const agora = Date.now();
        const proximoReset = App.Business.proximoResetDmesUkMs(agora);
        const faltam = Math.max(0, proximoReset - agora);
        const labelTempo = App.Business.formatarTempoRestanteCurto(faltam);
        let horarioUk = "";
        try {
          horarioUk = new Date(proximoReset).toLocaleString("pt-BR", {
            timeZone: "Europe/London",
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          } as any).replace(",", "");
        } catch (e) { }

        $alvo.text(`Reset UK ${labelTempo}`);
        $alvo.attr("title", `Proximo reset do ciclo Auto DME: 18:00 UK${horarioUk ? ` (${horarioUk})` : ""}. Faltam ${labelTempo}.`);
      }
      this.atualizarHeaderFilaAutoDme();
    }

    private inicializarHeaderResetDmesUk(): void {
      this.atualizarHeaderResetDmesUk();
      this.carregarModoExecucaoHeaderAutoDme();
      if (this.dmesHeaderResetTimer) {
        window.clearInterval(this.dmesHeaderResetTimer);
      }
      this.dmesHeaderResetTimer = window.setInterval(() => this.atualizarHeaderResetDmesUk(), 60000);
    }

    private obterContasResumoFilaAutoDme(): IConta[] {
      if ($.fn && $.fn.dataTable && Business.objDataTableContas instanceof $.fn.dataTable.Api) {
        return Business.objDataTableContas.rows().data().toArray() as IConta[];
      }
      return $.isArray(this.arrayContas) ? this.arrayContas : [];
    }

    private perfilContaTemAutoDmeConfigurado(conta: IConta): boolean {
      const autodmes = conta && conta.perfil && conta.perfil.dados
        ? (conta.perfil.dados as any).autodmes
        : null;
      return $.isArray(autodmes) && autodmes.length > 0;
    }

    private estadoFilaDmeConta(dme: IDmeContaItem, agoraMs: number): "pronto" | "aguardando" | null {
      if (!dme || App.Business.dmeExpiradoHeuristica(dme, agoraMs)) {
        return null;
      }
      const meta: any = dme._autodme || null;
      if (!meta) {
        return "pronto";
      }

      const status = String(meta.status || "pendente").trim().toLowerCase();
      const motivo = String(meta.motivo_bloqueio || "").trim().toLowerCase();
      if (motivo === "nao_disponivel_webapp") {
        return null;
      }

      const proximoElegivelTs = Number(meta.proximo_elegivel_ts || 0);
      const emEsperaTemporal = proximoElegivelTs > agoraMs
        || motivo === "cooldown_tentativa"
        || motivo === "cooldown_dme"
        || motivo === "aguardando_dmes_anteriores_finalizarem";

      if (status === "pendente" || status === "em_andamento") {
        return emEsperaTemporal ? "aguardando" : "pronto";
      }
      if (status === "bloqueado" && emEsperaTemporal) {
        return "aguardando";
      }
      return null;
    }

    private obterResumoFilaAutoDmeDashboard(): { totalConfiguradas: number; contasNaFila: number; prontas: number; aguardando: number; finalizadas: number } {
      const contas = this.obterContasResumoFilaAutoDme();
      const agoraMs = Date.now();
      let totalConfiguradas = 0;
      let prontas = 0;
      let aguardando = 0;

      (contas || []).forEach((conta: IConta) => {
        const dmes = Array.isArray((conta as any).dmes) ? ((conta as any).dmes as IDmeContaItem[]) : [];
        const temAutoDme = dmes.length > 0 || this.perfilContaTemAutoDmeConfigurado(conta);
        if (!temAutoDme) return;

        totalConfiguradas += 1;
        if (!dmes.length) {
          prontas += 1;
          return;
        }

        let contaPronta = false;
        let contaAguardando = false;
        dmes.forEach((dme: IDmeContaItem) => {
          const estado = this.estadoFilaDmeConta(dme, agoraMs);
          if (estado === "pronto") contaPronta = true;
          else if (estado === "aguardando") contaAguardando = true;
        });

        if (contaPronta) prontas += 1;
        else if (contaAguardando) aguardando += 1;
      });

      const contasNaFila = prontas + aguardando;
      return {
        totalConfiguradas,
        contasNaFila,
        prontas,
        aguardando,
        finalizadas: Math.max(0, totalConfiguradas - contasNaFila),
      };
    }

    private atualizarHeaderFilaAutoDme(): void {
      const $alvo = $(".js-dmes-head-fila-auto-dme");
      if (!$alvo.length) return;

      const resumo = this.obterResumoFilaAutoDmeDashboard();
      $alvo.removeClass("dmes-head-fila-on dmes-head-fila-off dmes-head-fila-empty");

      if (resumo.totalConfiguradas <= 0) {
        $alvo
          .addClass("dmes-head-fila-empty")
          .html(`<i class="fa-solid fa-stop"></i><span>Sem Auto DME</span>`)
          .attr("title", "Nenhuma conta da tabela possui Auto DME configurado.");
        return;
      }

      if (resumo.contasNaFila > 0) {
        const texto = resumo.aguardando > 0 && resumo.prontas <= 0 ? `Aguard. ${resumo.aguardando}` : `Fila ${resumo.contasNaFila}`;
        $alvo
          .addClass("dmes-head-fila-on")
          .html(`<i class="fa-solid fa-play"></i><span>${texto}</span>`)
          .attr("title", `Auto DME ainda tem conta(s) na fila: ${resumo.prontas} pronta(s) agora, ${resumo.aguardando} aguardando cooldown/sincronizacao e ${resumo.finalizadas} fora da fila neste ciclo.`);
        return;
      }

      $alvo
        .addClass("dmes-head-fila-off")
        .html(`<i class="fa-solid fa-stop"></i><span>Sem fila</span>`)
        .attr("title", `Todas as ${resumo.totalConfiguradas} conta(s) com Auto DME estao fora da fila neste ciclo: completas, expiradas ou bloqueadas por limite/condicao final.`);
    }

    private dmesHeaderModoExecucao: string = null;

    /**
     * Espelho ESTÁTICO do modo de execução Auto DME ativo (normal | piloto | conjunto).
     * `renderColunaDmes` é estático e precisa do modo para rotular os status: em Piloto e
     * Conjunto o sistema não percorre uma fila — o planejador escolhe o que é viável — então
     * "pendente" ali significa "o planejador não conseguiu", não "está na fila".
     * Null (config ainda não carregada) = comportamento antigo, sem renomear nada.
     */
    public static modoExecucaoAutoDmeAtivo: string = null;

    private rotuloModoExecucaoAutoDme(modo: string): { texto: string; classe: string; titulo: string } {
      const m = String(modo || "").toLowerCase();
      if (m === "normal") {
        return { texto: "Normal", classe: "dmes-head-modo-normal", titulo: "Modo de execução Auto DME ativo: Normal — percorre os Auto DMEs cadastrados." };
      }
      if (m === "conjunto") {
        return { texto: "Conjunto", classe: "dmes-head-modo-conjunto", titulo: "Modo de execução Auto DME ativo: Conjunto — segue o plano definido pelo usuário." };
      }
      if (m === "piloto") {
        return { texto: "Piloto", classe: "dmes-head-modo-piloto", titulo: "Modo de execução Auto DME ativo: Piloto — mapeia e decide a sequência viável." };
      }
      return { texto: "--", classe: "dmes-head-modo-desconhecido", titulo: "Modo de execução Auto DME ainda não carregado." };
    }

    private atualizarHeaderModoExecucaoAutoDme(modo?: string): void {
      if (modo != null && String(modo).length) {
        this.dmesHeaderModoExecucao = String(modo);
        // Espelha ANTES do early-return do header: a coluna DMEs precisa do modo mesmo
        // em telas onde o chip do cabeçalho não existe.
        Business.modoExecucaoAutoDmeAtivo = this.dmesHeaderModoExecucao;
      }
      const $alvo = $(".js-dmes-head-modo");
      if (!$alvo.length) return;
      const info = this.rotuloModoExecucaoAutoDme(this.dmesHeaderModoExecucao || "");
      $alvo
        .removeClass("dmes-head-modo-normal dmes-head-modo-piloto dmes-head-modo-conjunto dmes-head-modo-desconhecido")
        .addClass(info.classe)
        .html(`<i class="fa-solid fa-gears"></i><span>${info.texto}</span>`)
        .attr("title", info.titulo);
    }

    private carregarModoExecucaoHeaderAutoDme(): void {
      // A tabela de contas também consome o modo (rótulos da coluna DMEs), então basta
      // uma das duas existir para valer a requisição.
      if (!$(".js-dmes-head-modo").length && !$("#datatableContas").length) return;
      if (!this.ajax) this.ajax = new App.Ajax();
      this.ajax.get(this.labDmeUrlConfiguracaoExecucao, {}, (resposta: IRespostaSucessoAjx) => {
        const envelope = this.labDmeExtrairEnvelopeConfiguracao(resposta.dadosRetornados);
        const configuracao = envelope && envelope.valida && envelope.configuracao
          ? this.labDmeNormalizarConfiguracao(envelope.configuracao)
          : this.labDmeConfiguracaoPadrao();
        this.atualizarHeaderModoExecucaoAutoDme(configuracao.modo_execucao);
      }, () => { /* silencioso: mantém o rótulo "--" no header */ }, null, false);
    }

    private chartJsLucro: any = null;
    private chartJsCaptchas: any = null;
    private chartJsVendasApi: any = null;
    private chartJsRequests: any = null;
    private chartJsTempoUso: any = null;
    private chartJsComprasBuscas: any = null;
    private chartJsScansClube: any = null;

    private inicializacaoDashBoardConcluida: boolean = false;
    private cacheInfoContas: any = {};
    private cacheInfoContasSaveTimer: number = null;
    private cacheInfoContasAlterado: boolean = false;
    private static readonly STORAGE_KEY_CACHE_CONTAS = "futsniper_cache_info_contas";

    private configuracoesGeraisExecucao: IConfiguracoesGeraisExecucao = {
      contas_simultaneas: 1,
      intervalo_abertura_conta: 20,
      intervalo_proxima_execucao: 30,
      minutos_log_exibicao: 1440,
      dias_log_retencao: 1,
      jogadores_overall_clube_exibicao: "83-99",
      exibir_escudo_clube: false,
      proxy_server_port: 4500,
      exibir_cronometro: true,
      notificar_falha_autocaptcha: false,
      notificar_falha_carregamento: false,
      notificar_sniper_parado: true,
      info_tempo_real: true,
      registrar_logs_filtros: false,
      iniciar_tarefa_imediata_apos_fechamento_conta: false,
      usar_chrome_default: false,
      reiniciar_plugin_monitor_sniper: true,
      otimizar_rede_windows: false,
      tarefa_ligada_sniper: true,
      tarefa_ligada_venda_coins: false,
      tarefa_ligada_auto_dme: true,
      tarefas_simultaneas_auto_dme: 1,
      prioridade_tarefas_automaticas: ["sniper", "auto_dme", "venda_coins"],

      notificar_venda_bloqueada: false,
      notificar_previa_pacote: false,
      notificar_banimento: false,
      notificar_compra: false,
      notificar_erro_login: false,
      notificar_compra_nao_confirmada_api: true,
      configuracao_auto_dme: {
        auto_dme_habilitado: false,
        intervalo_minutos_execucao_autodme_conta: 10,
        maximo_dme_dia: 100,
        maximo_desafio_dia: 1000,
      },
      reutilizar_vagas_auto_dme_outras_tarefas: false,
    };

    private elCheckBoxAtivarDesativar: JQuery = $("input[name=status_filtro]");
    private elCheckBoxAtivarDesativarConfigRemota: JQuery = $("input[name=config_remota]");
    private elBtbAcaoResolverDme: JQuery = $(".btn-acao-resolver-dme");
    private executandoTarefa: boolean = false;
    private atualizandoContas: boolean = false;
    private indiceAtualListaContas: number = 0;
    private intervaloVinculoListaContas: any = 0;
    // Estado do NOVO vínculo (row provisória): credenciais por chaveVinculo (para retentar) e
    // callbacks de código 2FA pendentes por chaveVinculo (entrada inline, não-bloqueante).
    private dadosVinculoPorChave: { [chave: string]: any } = {};
    private pendentesCodigo2FA: { [chave: string]: any } = {};
    private vendendoCoinsContaLista: boolean = false;
    private executandoResolverBugEa: boolean = false;
    private executandoResgateRecompensas: boolean = false;
    private executandoAcaoLoteContas: boolean = false;
    private progressoSincronizacaoAtivo: any = null;
    private util: any = null;
    private static tempoMilisegundoEntreAberturaContaVendaCoins: number = 40000;
    private ip: string = null;
    private infoPlanoAtual: IInfoPlanoAtual = { ehPlanoCloud: false, ehPlanoPro: false, ehPlanoProCloud: false, ehAdmin: false };
    private processarAlertasUtil: any = null;
    private quantidadeFalhaConexaoPlugin: number = 0;
    private dadosServidor: IServidor = null
    private diagnosticoContaTarefasAtual: any = null;
    private pluginServerBaseUrl: string = "http://localhost:5033";
    /** Configurações remotas do usuário e qual delas o servidor em contexto usa (null = legado local). */
    private configuracoesProDisponiveis: any[] = [];
    private idConfiguracaoProEfetiva: number = null;

    public async inicializarEventos() {
      this.idExtensao = $('#idExtensao').val();
      this.inicializarAutoDmeParaModaisPro();
      this.inicializarHeaderResetDmesUk();
      this.iniciarComunicacaoSocket();
      Util.unpinSidenav();
      this.processarAlertasUtil = App.Util.processarAlertas;
      App.Util.processarAlertas = () => { };

      this.elBtnVincularConta.on("click", (e) => { this.vincularConta(e) });
      this.elBtnVincularMultConta.on("click", (e) => { this.vincularMultConta(e) });
      this.elBtnTeste.on("click", (e) => { this.teste(e) });
      this.elBtnTestePrecoExterno.on("click", (e) => { this.abrirModalTestePrecoExterno(e) });
      this.inicializarEventosFontesPreco();
      this.elBtnExtrairDadosWebApp.on("click", (e) => { this.extrairDadosWebAppAgora(e) });
      this.elBtnDesfragmentarLiberarEspacoDisco.on("click", (e) => { this.executarDesfragmentarLiberarEspacoDisco(e) });
      this.elBtnAddPluginInicializacao.on("click", (e) => { this.adicionarPluginNaInicializacaoWindows(e) });
      this.elBtnRemoverPluginInicializacao.on("click", (e) => { this.removerPluginNaInicializacaoWindows(e) });
      this.elBtnReiniciarVm.on("click", (e) => { this.reiniciarVm(e) });
      this.elBtnReinstalarChrome.on("click", (e) => { this.reinstalarChrome(e) });
      this.elBtnLimparLimites.on("click", (e) => { this.limparLimitesContas(e) });
      this.elBtnLimparLogs.on("click", (e) => { this.limparLogs(e) });
      this.elBtnOtimizarRedeWindows.on("click", (e) => { this.otimizarRedeWindows(e) });
      this.elBtnAtualizarProxyFutTransfer.on("click", (e) => { this.atualizarProxyFutTransfer(e) });
      this.elBtnInterromperTarefas.on("click", (e) => { this.imterromperTarefas(e) });
      // Cloudflare agora é resolvido automaticamente na aba do Chrome da própria conta
      // (fluxo conta_browser). O botão manual "Resolver Cloudflare"/preview /bw-view foi removido.
      // Em vez dele, um ícone de escudo mostra o último bloqueio por fonte (+ se foi resolvido).
      this.iniciarMonitorBloqueiosFontes();
      this.elBtnReiniciarPlugin.on("click", (e) => { this.reiniciarPlugin(e) });
      this.elBtnTesteNotificacaoTelegram.on("click", (e) => { this.testeNotificacaoTelegram(e) });
      this.elBtnSalvarConfigGeral.on("click", (e) => { this.salvarConfigGeral(e) });
      this.elBtnExportarDatabaseLocal.on("click", (e) => { this.exportarDataBaseLocal(e) });
      this.elBtnBackupRestauracao.on("click", (e) => { this.abrirModalBackupRestauracao(e) });
      $(document).on("click", "#btn-modal-exportar-database", (e) => { this.exportarDataBaseLocal(e) });
      $(document).on("change", "#backup-restauracao-file", (e) => { this.aoSelecionarArquivoRestauracao(e) });
      $(document).on("click", "#btn-modal-restaurar-database", (e) => { this.iniciarRestauracaoBackup(e) });

      $(document).on("change", "#formConfiguracoesGeralBot input[name=tarefa_ligada_sniper]", (e) => {
        this.aoToggleTarefaSniperConfigGeral($(e.currentTarget));
      });
      $(document).on("change", "#formConfiguracoesGeralBot input[name=tarefa_ligada_auto_dme]", (e) => {
        this.aoToggleTarefaAutoDmeConfigGeral($(e.currentTarget));
      });
      $(document).on("input change", "#formConfiguracoesGeralBot input[name=contas_simultaneas], #formConfiguracoesGeralBot input[name=tarefas_simultaneas_auto_dme]", () => {
        this.atualizarResumoPoolConfigGeralModal();
      });
      $(document).on("change", "#formConfiguracoesGeralBot input[name=reutilizar_vagas_auto_dme_outras_tarefas]", () => {
        this.atualizarResumoPoolConfigGeralModal();
      });
      $("#modalConfigGeral").on("show.bs.modal", () => {
        // O seletor decide o que carregar (configuração efetiva desta VPS, ou a local no legado):
        // por isso ele é o ÚNICO ponto de entrada — antes havia duas buscas concorrentes.
        if (this.infoPlanoAtual && this.infoPlanoAtual.ehPlanoCloud) {
          this.obterConfiguracaoGeralAtualizada(() => this.atualizarResumoPoolConfigGeralModal());
          return;
        }
        this.carregarConfiguracoesProDoModal(() => this.atualizarResumoPoolConfigGeralModal());
      });
      $(document).on("change", "#selectConfiguracaoPro", () => {
        this.aoTrocarConfiguracaoProSelecionada();
      });
      $(document).on("click", ".btn-salvar-configuracao-pro", () => {
        this.salvarConfiguracaoProSelecionada();
      });
      $(document).on("click", ".btn-aplicar-configuracao-pro", () => {
        this.aplicarConfiguracaoProNoServidor();
      });
      $(document).on("click", ".btn-excluir-configuracao-pro", () => {
        this.excluirConfiguracaoProSelecionada();
      });
      $("#modalConfigServidor").on("show.bs.modal", () => {
        this.obterConfiguracaoServidorLocalAtualizada();
      });
      $(document).on("click", ".btn-salvar-config-servidor", (e) => {
        this.salvarConfigServidor(e);
      });

      this.elBtnAtualizar.on("click", (e) => { this.atualizar(e) });
      this.elBtnSalvarServidor.on("click", (e) => { this.salvarServidor(e) });
      this.elFiltroExigido.on("click", (e) => { this.aoClicarAgendamentoSemFiltro(e) });
      this.elAgendamentoExigido.on("click", (e) => { this.aoClicarAgendamentoExigido(e) });

      this.elCheckBoxAtivarDesativar.on("change", (e) => { this.aoAtivarDesativarFiltro(e) });
      this.elCheckBoxAtivarDesativarConfigRemota.on("change", (e) => { this.aoAtivarDesativarConfigRemota(e) });
      this.elBtbAcaoResolverDme.on("click", (e) => { this.executarResolverDmeImediato(e) });

      $(document).on('click', '.btn-salvar-credenciais', (e) => { this.salvarCredenciais(e) });
      $(document).on('click', '.abrir-sniper', (e) => { this.aoAbrirSniper(e) });
      $(document).on('click', '.btn-abrir-conta-rapida', (e) => { this.abrirContaRapida(e) });
      $(document).on('click', '.btn-parar-tarefa', (e) => { this.pararTarefa(e) });
      $(document).on('click', '.btn-acessar', (e) => { this.acessarSniper(e, true) });
      $(document).on('click', '.btn-fechar-sniper', (e) => { this.fecharSniper(e) });
      $(document).on('click', '.btn-iniciar-venda-de-coins-imediata', (e) => { this.executarVendaCoinsImediata(e) });
      $(document).on('click', '.btn-iniciar-resolver-dme-imediato', (e) => { this.aoClicarResolverDmeImediato(e) });
      $(document).on('click', '.btn-atualizar-info-jogadores-clube', (e) => { this.atualizarInfoJogadoresClube(e) });
      $(document).on('click', '.btn-ver-jogadores-conta', (e) => { this.aoVerJogadoresConta(e) });
      $(document).on('click', '.btn-modal-atualizar-jogadores-conta', (e) => { this.atualizarInfoJogadoresClube(e) });
      $(document).on('click', '.btn-atualizar-agenda', (e) => { this.aoAtualizarAgenda(e) });
      $(document).on('click', '.remover-conta', (e) => { this.aoExcluirConta(e) });
      $(document).on('click', '.btn-autenticar', (e) => { this.acessarSniper(e) });
      $(document).on('click', '.btn-sincronizar-conta-local', (e) => { this.sincronizarContaNaMaquinaLocal(e) });
      $(document).on('click', '.btn-resolver-captcha', (e) => { this.acessarSniper(e, true) });
      $(document).on('click', '.btn-resolver-captcha-auto', (e) => { this.resolverCaptchaAutomaticamente(e) });
      $(document).on('click', '.btn-ver-mais', (e) => { this.aoVerEstatisticas(e) });
      $(document).on('click', '.btn-ver-conta-diagnostico', (e) => { this.aoVerEstadoAutoDmeConta(e) });
      $(document).on('click', '.btn-laboratorio-dme', (e) => { this.aoAbrirLaboratorioDme(e) });
      $(document).on('change', '#labDmeContaSelect', (e) => { this.labDmeSelecionarConta(e) });
      $(document).on('change', '#labDmeModoExecucao, #labDmeLiberarEspeciaisReservadas, #labDmeLiberarExclusoesInteligentes, #labDmePeriodos', () => { this.labDmeMarcarConfigAlterada() });
      $(document).on('click', '#btnLabDmeSalvarConfig, #btnLabDmeSalvarConjuntos', () => { this.labDmeSalvarConfiguracao() });
      $(document).on('click', '#btnLabDmeAddConjunto', () => { this.labDmeAdicionarConjunto() });
      $(document).on('click', '.btn-lab-dme-remover-conjunto', (e) => { this.labDmeRemoverConjunto(e) });
      $(document).on('click', '.btn-lab-dme-add-passo', (e) => { this.labDmeAdicionarPasso(e) });
      $(document).on('click', '.btn-lab-dme-remover-passo', (e) => { this.labDmeRemoverPasso(e) });
      $(document).on('click', '.btn-lab-dme-mover-passo', (e) => { this.labDmeMoverPasso(e) });
      $(document).on('change', '#modalLaboratorioDme .lab-dme-campo', (e) => { this.labDmeAoAlterarCampo(e) });
      $(document).on('click', '#btnLabDmeMapear', () => { this.labDmeMapear() });
      $(document).on('click', '#btnLabDmeExecutar', () => { this.labDmeExecutar() });
      $(document).on('click', '#btnLabDmeLimparRascunho', () => { this.labDmeLimparRascunho() });
      $(document).on('click', '.btn-lab-dme-resolver-linha', (e) => { this.labDmeResolverLinha(e) });
      $(document).on('click', '#btnLabDmeSugerir', () => { this.labDmeSugerirProximoPasso() });
      $(document).on('click', '#btnLabDmePiloto', () => { this.labDmePilotoAutomatico() });
      $(document).on('click', '.btn-lab-dme-ajustar-config', (e) => { this.labDmeAjustarConfigRegistro(e) });
      $(document).on('click', '.js-tab-diagnostico-tarefa', (e) => { this.aoTrocarAbaDiagnosticoTarefa(e) });
      $(document).on('click', '.btn-dt-ajustar-lucro', (e) => { this.aoClicarAjustarLucro(e) });

      $(document).on('click', '.btn-cancelar-venda-coins', (e) => { this.cancelarVendaCoins(e) });
      $(document).on('click', '.btn-encontrar-jogadores-para-sniper', (e) => { this.aoBuscarJogadoresParaSnipar(e) });
      $(document).on('click', '.btn-aplicar-jogador-filtro', (e) => { this.aoAplicarjogadorFiltro(e) });
      $(document).on('click', '.btn-mostrar-telawebapp', (e) => {
        if (this.ip && this.ipPlugin && this.ip != this.ipPlugin) {
          this.acessarSniper(e, true, true)
        } else {
          this.mostrarTelaWebApp(e)
        }
      });

      $(document).on('change', 'input[name=agenda_ativa]', (e) => { this.aoLigarDesligarAgenda(e); });
      $(document).on('click', 'span.email-conta', (e) => { this.aoClicarEmailConta(e) });

      $(document).on('click', '.btn-iniciar-correcao-bug-ea', (e) => { this.executarResolverBugContaEa(e) });

      this.elDropdownAplicarFiltroPro.on("click", (e) => { this.aoAplicarFiltroPro(e) });
      this.elDropdownSubstituirFiltroPro.on("click", (e) => { this.aoSubstituirFiltroPro(e) });
      this.elBtnLimparFiltroPro.on("click", (e) => { this.aoLimparFiltroPro(e) });
      this.elBtnAplicarProfile.on("click", (e) => { this.aoAplicarPerfil(e) });
      this.elBtnAplicarFiltros.on("click", (e) => { this.aoAplicarFiltros(e) });
      this.elBtnAplicarProxy.on("click", (e) => { this.aoAplicarProxy(e) });
      $(document).on("click", ".btn-testar-proxy", (e) => { this.testarProxy(e) });
      this.elBtnResolverDmeContas.on("click", (e) => { this.executarResolverDmeImediato(e, $("#modalResolverDmeContasSelecionadas"), this.getIdsContasSelecionadas()) });
      this.elBtnSelecionarTodosOsFiltros.on("click", (e) => { this.aoSelecionarTodosOsFiltros(e) });
      this.elBtnApagarTodosOsFiltros.on("click", (e) => { this.aoApagarTodosOsFiltros(e) });
      this.elBtnAbrirContas.on("click", (e) => { this.abrirContas() });
      this.elBtnLimparCache.on("click", (e) => { this.limparCacheContas() });
      this.elBtnLimparDmesContas.on("click", (e) => { this.limparDmesSnapshotContas() });
      this.elBtnResetarTentativasAutoDmeContas.on("click", (e) => { this.aoResetarTentativasAutoDmeContas(e) });
      this.elBtnSincronizarDatabase.on("click", (e) => { this.sincronizarDataBaseContas() });
      this.elBtnExecutarTarefaContas.on("click", (e) => { this.executarTarefaContas() });
      this.elBtnExecutarAutoDmeImediatoContas.on("click", (e) => { this.executarAutoDmeImediatoContas() });
      this.elBtnResgatarRecompensasContas.on("click", (e) => { this.executarResgateRecompensasIdsContas() });
      this.elBtnVenderCoins.on("click", (e) => { this.executarVendaCoinsIdsContas() });
      $(document).on("submit", "#formTestePrecoExterno", (e) => { this.executarTestePrecoExterno(e) });
      $(document).on("change", "#testePrecoExternoZyteApi", () => { this.atualizarToggleZyteApiTestePrecoExterno() });
      $(document).on("change", "#testePrecoExternoModo", () => { this.atualizarModoTestePrecoExterno() });
      $(document).on("change", "#testePrecoExternoForcarChromeReal", () => { this.atualizarPularCacheTestePrecoExterno() });
      $(document).on("click", "#testePrecoExternoToggleTecnico", () => { this.alternarLogTecnicoTestePrecoExterno() });
      $("#modalTestePrecoExterno").on("shown.bs.modal", () => {
        this.atualizarToggleZyteApiTestePrecoExterno();
        this.atualizarModoTestePrecoExterno();
      });

      // ─── Transfer Between Accounts — beta (modal + toolbar DataTable) ─────
      $(document).on('click', '.btn-transferir-contas', () => { this.abrirModalTransfer(); });
      // ─────────────────────────────────────────────────────────────────────
      this.elBtnResolverBugEa.on("click", (e) => { this.executarResolverBugIdsContas() });
      this.elBtnAjustarLucro.on("click", (e) => { this.ajustarLucro(e) });

      //quando clicar no new filter chamar essa funcao
      this.elBtncadastrarFiltroPro.on("click", (e) => { this.estadoVazioFiltroPro(e) });

      this.elBtnAtivarPilotoAutomatico.on('change', (e) => { this.aoSelecionarPilotoAutomatico(e); });

      this.elBtnSalvarFiltroProModalSniper.on("click", (e) => { this.aoSalvarFiltroModalSniper(e); });
      this.elBtnAddConta.on("click", (e) => { this.aoAbirFormAddConta(e); });

      $("input[name=tarefa_ligada]").on("click", (e) => { this.aoSelecionarLigarDesligarTarefa(e); });

      $("#searchclearSniperPro").click((e) => {
        var formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
        formSniperPro.find("#imgJogador").attr('src', "images/default.png");
        formSniperPro.find(".campo-jogador").select2('val', '0');
        formSniperPro.find('.campo-jogador').find("option").remove();
      });

      $('#modalCadastrarFiltroProCad').on('shown.bs.modal', function (e) {
        $(e.currentTarget).find('input[name=id]').val("")
      });

      $('#modalSniperPro').on('hidden.bs.modal', (e) => {
        $('.conteudo-loading-sniper-pro').modal('hide')
        this.desativarInteracaoSniper($(e.currentTarget).find('input[name=id]').val())
        $(".modal-backdrop.show").remove()
      });

      $('.btn-estimar-lucro').on("click", (e) => { this.iniciarSniper(e) });
      $('.btn-criar-filtro').on("click", (e) => { this.getJogadoresMultRaridadesPorUrlFutbin(e) });
      $('.dropdown-menu-criar-filtro').on("click", (e) => { e.stopPropagation() });
      $(document).on('show.bs.dropdown', '.menu-criar-filtro .dropdown', (e) => {
        if (!this.extensaoCriarFiltroInstalada()) {
          e.preventDefault();
          this.exibirMensagemExtensaoObrigatoriaCriarFiltro();
        }
      });

      this.inicializarCrudFiltroPro()
      this.inicializarCrudAgendamento()
      this.inicializarCrudPerfil()
      this.inicializarCrudAutodme()
      this.inicializarCrudApiVendaCoins()
      this.inicializarCrudApiIntegracao()
      this.inicializarCrudProxy()
      this.inicializarCrudPeriodo()
      this.inicializarCrudServidor()

      App.Util.exebirSweetConfirmacao = App.Bot.exibirSweetConfirmacaoHtml;

      this.objSelect2 = new Select2();
      this.getPlayers(() => {
        this.continuarInicializacao();
      });

      App.Util.verificarSessaoLoginPorClick(['btn-atualizar', 'btn-agendar', 'btn-iniciar-vincular-conta', 'btn-add-servidor', 'remover-conta', 'dropdown-item-config'])
      this.infoPlanoAtual = $('#cardBodyDashboard') && $('#cardBodyDashboard').data('infoPlano') ? $('#cardBodyDashboard').data('infoPlano') : this.infoPlanoAtual
      this.util = new Util()
      this.obterConfiguracaoGeralAtualizada()

      this.ip = await App.Util.getPublicIP()

      // ─── Transfer Between Accounts — beta ───────────────────────────────
      if ((this.infoPlanoAtual as any).ehTransferBeta) {
        this.transferCoins = new App.TransferCoins(this.comunicacao, this.arrayContas, this.idExtensao);
      }
      // ─────────────────────────────────────────────────────────────────────

      this.inicializarMetodosEnvioCromprovante()
      this.verificarSituacaoDaConta()
    }

    private inicializarAutoDmeParaModaisPro(): void {
      // O AutoDme é necessário para inicializar noUiSlider/select2/pills nos modais PRO.
      // Em algumas rotas, o SniperExtensao pode não rodar, então garantimos instância aqui.
      const anyWindow = window as any;
      if (anyWindow && anyWindow.autoDme) return;
      if (!App || !(App as any).AutoDme) return;

      const exibirLog = (..._args: any[]) => { /* noop: PRO usa o fluxo do Business para logs */ };
      try {
        new (App as any).AutoDme(this.idExtensao || '', exibirLog);
      } catch (e) {
        console.error('Falha ao inicializar AutoDme (Business)', e);
      }
    }

    private fecharDropdownCriarFiltro() {
      try {
        var dropdown = $('.dropdown-toggle-criar-filtro');
        dropdown.click()
      } catch (e) {
        console.log("ERRO FECHAR DROPDOWN", e)
      }
    }

    private extensaoCriarFiltroInstalada(): boolean {
      if (!this.idExtensao) {
        this.idExtensao = $('#idExtensao').val();
      }

      return this.idExtensao !== null && this.idExtensao !== undefined && this.idExtensao !== '';
    }

    private exibirMensagemExtensaoObrigatoriaCriarFiltro() {
      const urlExtensao = App.Util.config && App.Util.config.urlExtensaoChromeFse
        ? App.Util.config.urlExtensaoChromeFse
        : 'https://chrome.google.com/webstore/detail/futsniperextension/pnenhoomfmddepcbmmkpkbdoplmjohge';
      swal.fire({
        title: "Extensão necessária",
        html: "A funcionalidade <b>Criar Filtro</b> exige a extensão <b>FutSniperExtension</b> instalada no seu navegador. <br/><br/><a href=\"" + urlExtensao + "\" target=\"_blank\" style=\"color:#3740FF;text-decoration:underline;\">Instalar extensão FutSniperExtension</a>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Instalar extensão",
        confirmButtonColor: '#3740FF',
        cancelButtonText: "Fechar"
      }).then((result: any) => {
        if (result && result.value) {
          window.open(urlExtensao, '_blank');
        }
      });
    }

    private aoAtivarDesativarFiltro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcao($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id"), status: $(e.target).is(':checked') });
    }

    private inicializarMetodosEnvioCromprovante() {
      setTimeout(() => {
        this.processarAlertasUtil()
        App.Util.processarAlertas = this.processarAlertasUtil
        this.processarAlertasUtil = () => { };

        Util.exibirNotificacaoPlanoExpirando()

      }, 4000);
    }

    private inicializarCrudFiltroPro() {
      var modelViewFiltroPro = new ModelView();
      modelViewFiltroPro.elBtnEditar = $(".btn-editar-filtro-pro");
      modelViewFiltroPro.elBtnCopiar = $(".btn-copiar-filtro");
      modelViewFiltroPro.inicializar($('#formFiltroPro, #formFiltroProCad'), false, () => {
        App.Util.exibirModalPaginaCarregando();
        window.location.href = $("#formFiltroPro").data('url-aba-filtro');
      });
      modelViewFiltroPro._this = this;
      modelViewFiltroPro.aoEditarRegistro = this.aoEditarRegistroFiltroPro;
      this.ajax = new App.Ajax();
      modelViewFiltroPro.validacaoAntesDeSalvar = (e: JQueryEventObject, continuar: any) => {
        var dadosFormFiltroPro: IFormDadosSniperPro = this.ajax.convertFormToJSON($(e.currentTarget));
        if (App.Util.validarFiltroSniper(dadosFormFiltroPro)) {
          continuar()
        }
      }

      modelViewFiltroPro.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }


      $("#formFiltroProCad").on("change", "input:not([name=nome]), select:not([name=nome])", (e) => {
        let formSniperPro: any = $(e.currentTarget).parents('#formFiltroProCad');
        let nomeFiltro = this.obterNomeFiltro('#' + formSniperPro.attr('id'));
        formSniperPro.find('input[name=nome').val(nomeFiltro);
      });

      modelViewFiltroPro.ojDataTableCarregado.elDataTable = $("#dataTableFiltros");

      modelViewFiltroPro.ojDataTableCarregado.metodoSelecionarDeselecionarComplemento = (count: number) => {
        $('.btn-ativar-selecionados').html(count > 0 ? `Ativar (${count})` : `Ativar`)
        $('.btn-desativar-selecionados').html(count > 0 ? `Desativar (${count})` : `Desativar`)
      }

      modelViewFiltroPro.ojDataTableCarregado.acoesButtonExtra = [
        {
          className: "btn-sm btn-outline-primary btn-ativar-selecionados",
          text: 'Ativar',
          action: () => {
            let itensSelecionados = modelViewFiltroPro.getContasSelecionadas()
            let count = itensSelecionados.count();
            if (count) {
              this.aoAtivaDesativarRegistros(modelViewFiltroPro, true, itensSelecionados.ids().toArray())
            }
          }
        },
        {
          className: "btn-sm btn-outline-primary btn-desativar-selecionados",
          text: 'Desativar',
          action: () => {
            let itensSelecionados = modelViewFiltroPro.getContasSelecionadas()
            let count = itensSelecionados.count();
            if (count) {
              this.aoAtivaDesativarRegistros(modelViewFiltroPro, false, itensSelecionados.ids().toArray())
            }
          }
        }
      ]

      modelViewFiltroPro.carregardataTable()
      App.Util.desabilitarAutocompleteDataTables(modelViewFiltroPro.ojDataTableCarregado.elDataTable);
    }

    private inicializarCrudAgendamento() {
      let agendaPreenchida: number[] = []
      var modelViewAgendamento = new ModelView();
      modelViewAgendamento.elBtnEditar = $(".btn-editar-agendamento");
      modelViewAgendamento.elBtnExcluir = $(".btn-excluir-agendamento");
      modelViewAgendamento.elBtnCopiar = $(".btn-copiar-agendamento");

      modelViewAgendamento.inicializar($('.form-step-config-agendamento'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewAgendamento._this = this;
      modelViewAgendamento.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarAgendamento${idRegistro}`);
        var form: JQuery = modal.find('form');
        modal.modal('show');

        var objAgendamento: IObjAgendamento = { id: $(e.currentTarget).data("id"), nome: $(e.currentTarget).data("nome"), dados: $(e.currentTarget).data("dados") }
        _.contains(agendaPreenchida, idRegistro) || this.preencherAgendamentos(form, modal, objAgendamento)
        agendaPreenchida.push(idRegistro)

        //console.log("REGISTRO EDIT::", $(e.currentTarget).data("id"), objAgendamento)
      }

      modelViewAgendamento.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formAgendamento = $(e.target);
        var modalAgendamento = $(e.target).parents('.modal-step-config');
        var invalido = false;
        let idRegistro = formAgendamento.data('id');

        formAgendamento.find(".select-filtro").each((index, value) => {
          //console.log("Sel", value)
          var containerItem = $(value).parents('.container-item-sch')
          var pilotoAutomatico = containerItem.find("input[name=piloto_automatico]").is(':checked')
          if ($(value).val().length <= 0 && !pilotoAutomatico) {
            invalido = true;
            $('.collapse').collapse('hide')
            setTimeout(() => {
              $(value).parents('.collapse').collapse('show')
              $(value).parents('.espaco-filtro').find('.error-filtro').show()
              setTimeout(() => {
                document.getElementById($(value).attr('id')).scrollIntoView();
              }, 1000)
            }, 1000)
          }
        });

        if (invalido) {
          toastr.warning("O agendamento precisa ter pelo menos 1 filtro", "Informe o Filtro!");
          return
        } else {
          formAgendamento.find('.error-filtro').hide()
        }

        var objAgendamentosContas: { nome: string, dados: any } = { nome: formAgendamento.find("input[name=nome]").val(), dados: this.obterObjetoAgendamento(formAgendamento, null) }

        //console.log("FORM::", objAgendamentosContas)

        modalAgendamento.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));
        try {
          this.ajax = new App.Ajax();
          this.ajax.postAcao(`${formAgendamento.data('url')}/${idRegistro}`, objAgendamentosContas, (objVinculoConta: IRespostaAjaxPostAcao) => {
            if (objVinculoConta.hasOwnProperty('status') && objVinculoConta.status == "success") {
              modalAgendamento.find('.nao-salvo-geral').hide()
              let dadosResposta: { atualizar_agenda: { idUser: number, data: string, contasIds: number[] }, dados: any, id: number, nome: string } = objVinculoConta.dadosRetornados.dadosResposta;
              this.atualizarContasByIdsContas(dadosResposta.atualizar_agenda ? this.getIdsAllContas() : null)

              let tempoTotalExecucao = 0
              $.each(objVinculoConta.dadosEnviados.dados, (index: any, agendamento: IAgendamentoConfiguracao) => {
                var elementoContainer: JQuery = formAgendamento.find('#containerItem' + index);
                let infoFiltrosSalvos: string = this.obterInfoNomeFiltrosSalvosAposSalvarAgendamento(index, objVinculoConta.dadosRetornados)
                let infoTempoExecucao = this.obterTempoExecucaoAposSalvarAgendamento(index, objVinculoConta.dadosRetornados)
                tempoTotalExecucao += infoTempoExecucao.tempo
                //console.log("SALVAR 02", agendamento, infoFiltrosSalvos, objVinculoConta.dadosRetornados)
                this.atualizarViewContainerAgendamento(elementoContainer, agendamento, true, infoFiltrosSalvos, infoTempoExecucao.info)
              });

              this.atualizarTempoTotalExecucao(formAgendamento, tempoTotalExecucao)
              this.atualizarListaAgendamento(idRegistro, objAgendamentosContas)
            } else {
              modalAgendamento.modal('show');
            }
            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          //console.log("ERRO SALVAR AGENDAMENTO", e)
          App.Util.ocultarModalPaginaCarregando()
          modalAgendamento.modal('show');
        }
      }

      modelViewAgendamento.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }
    }

    private inicializarCrudPerfil() {
      let formPreenchido: number[] = []
      var modelViewPerfil = new ModelView();
      modelViewPerfil.elBtnEditar = $(".btn-editar-perfil");
      modelViewPerfil.elBtnExcluir = $(".btn-excluir-perfil");
      modelViewPerfil.elBtnCopiar = $(".btn-copiar-perfil");

      modelViewPerfil.inicializar($('.form-step-config-perfil'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      $(document).on('change', '.form-step-config-perfil select[name=comportamento_auto_dme_limite_requests]', function () {
        const $form = $(this).closest('form');
        $form.find('.js-margem-requests-auto-dme-wrap').toggle($(this).val() === '2');
      });

      $(document).on('change', '.form-step-config-perfil input[name=descarte_negociavel_ativo]', (e: JQueryEventObject) => {
        const $form = $(e.currentTarget).closest('form');
        this.atualizarVisibilidadeOpcoesRegrasDescartes($form);
        if ($(e.currentTarget).is(':checked')) {
          this.initDescarteNegociavelSliders($form.closest('.modal'));
        }
      });

      $(document).on('change', '.form-step-config-perfil input[name=usar_lista_completa_autodmes]', (e: JQueryEventObject) => {
        this.atualizarDisponibilidadeSelecaoAutodmes($(e.currentTarget).closest('form'));
      });

      $(document).on('shown.bs.modal', '.parent-perfil .modal', (e: JQueryEventObject) => {
        const $modal = $(e.currentTarget);
        const $formPerfil = $modal.find('form.form-step-config-perfil');
        this.atualizarVisibilidadeOpcoesRegrasDescartes($formPerfil);
        this.atualizarDisponibilidadeSelecaoAutodmes($formPerfil);
        this.initDescarteNegociavelSliders($modal);
      });

      modelViewPerfil._this = this;
      modelViewPerfil.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarPerfil${idRegistro}`);
        var form: JQuery = modal.find('form');
        modal.modal('show');

        var objPerfil: IPerfil = { id: $(e.currentTarget).data("id"), nome: $(e.currentTarget).data("nome"), dados: $(e.currentTarget).data("dados") }
        _.contains(formPreenchido, idRegistro) || this.preencherFormPerfil(form, modal, objPerfil)
        formPreenchido.push(idRegistro)

        //console.log("REGISTRO EDIT::", objPerfil)
      }

      modelViewPerfil.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formRegistro = $(e.target);
        var modalAgendamento = $(e.target).parents('.modal-step-config');
        let idRegistro = formRegistro.data('id');

        this.ajax = new App.Ajax();
        let dadosForm: any = this.ajax.convertFormToJSON(formRegistro)

        const zyteApiAtivo = formRegistro.find("input[name='zyte_api']").is(":checked");
        const zyteApiKey = String(formRegistro.find("input[name='zyte_api_key']").val() || "").trim();
        dadosForm['zyte_api'] = zyteApiAtivo;
        dadosForm['zyte_api_key'] = zyteApiKey;
        dadosForm['buscar_preco_externo_solver_auto_dme'] = formRegistro.find("input[name='buscar_preco_externo_solver_auto_dme']").is(":checked");
        dadosForm['usar_cache_preco_ea'] = formRegistro.find("input[name='usar_cache_preco_ea']").is(":checked");
        // A ORDEM DA LISTA no formulário é a prioridade (arrastar para reordenar).
        // Formato salvo continua o mesmo de antes: array de strings, só das fontes ativas.
        const fontesPrecoSelecionadas = this.lerFontesPrecoDoForm(formRegistro);
        dadosForm['fontes_preco'] = fontesPrecoSelecionadas.length > 0
          ? fontesPrecoSelecionadas
          : Business.FONTES_PRECO_PADRAO.slice();
        delete dadosForm['fontes_preco[]'];

        const apiIntegracoesSelecionadas: string[] = [];
        formRegistro.find("select[name='api_integracoes[]'] option:selected").each(function () {
          apiIntegracoesSelecionadas.push($(this).val() as string);
        });
        dadosForm['api_integracoes'] = apiIntegracoesSelecionadas;
        delete dadosForm['api_integracoes[]'];

        var objDadosRegistro: { nome: string, dados: any } = { nome: formRegistro.find("input[name=nome]").val(), dados: _.omit(dadosForm, ['_token', 'id', 'nome']) }

        // if (objDadosRegistro && objDadosRegistro.dados && objDadosRegistro.dados.recarregar_webapp) {
        objDadosRegistro.dados.recarregar_webapp = false;
        // }

        console.log("FORM::", objDadosRegistro)
        modalAgendamento.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));

        try {
          this.ajax.postAcao(`${formRegistro.data('url')}/${idRegistro}`, objDadosRegistro, (objResposta: IRespostaAjaxPostAcao) => {
            if (objResposta.hasOwnProperty('status') && objResposta.status == "success") {
              let dadosResposta: { atualizar_agenda: { idUser: number, data: string, contasIds: number[] }, dados: any, id: number, nome: string } = objResposta.dadosRetornados.dadosResposta;
              this.atualizarContasByIdsContas(dadosResposta.atualizar_agenda ? this.getIdsAllContas() : null)
              this.atualizarListaPerfil(idRegistro, objDadosRegistro)
            } else {
              modalAgendamento.modal('show');
            }
            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          console.log("ERRO SALVAR Registro", e)
          App.Util.ocultarModalPaginaCarregando()
          modalAgendamento.modal('show');
        }
      }

      modelViewPerfil.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }
    }

    private inicializarCrudAutodme() {
      var modelViewAutodme = new ModelView();
      modelViewAutodme.elBtnEditar = $(".btn-editar-autodme");
      modelViewAutodme.elBtnExcluir = $(".btn-excluir-autodme");
      modelViewAutodme.elBtnCopiar = $(".btn-copiar-autodme");

      modelViewAutodme.inicializar($('.form-step-config-autodme'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewAutodme._this = this;
      modelViewAutodme.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        e.preventDefault();
        this.abrirModalEditarAutodme(e);
      };

      modelViewAutodme.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formRegistro = $(e.target);
        let idRegistro = formRegistro.data('id');
        var modal = $(e.target).parents('.modal-step-config');

        this.ajax = new App.Ajax();
        let dadosForm: any = this.ajax.convertFormToJSON(formRegistro);
        dadosForm = App.Util.normalizarPayloadSalvarAutodme(formRegistro, dadosForm);
        const $dmeSelecionado = formRegistro.find(".js-select-dme-autodme-pro option:selected");
        const idDmeSelecionado = String(formRegistro.find(".js-select-dme-autodme-pro").val() || "").trim();
        if (idDmeSelecionado) {
          dadosForm.id_dme = idDmeSelecionado;
        }
        const nomeDmeReferencia = String($dmeSelecionado.data("name") || $dmeSelecionado.text() || "").trim();
        if (idDmeSelecionado && nomeDmeReferencia) {
          dadosForm.nome_dme_referencia = nomeDmeReferencia;
        }
        const prioridade = Math.max(1, parseInt(String(dadosForm.prioridade || '1'), 10) || 1);
        const categoriaTarefa = parseInt(String(dadosForm.categoria_tarefa || '1'), 10) || 1;
        const corRaw = String(formRegistro.find('.js-cor-linha-autodme-hidden').val() || '').trim();
        const corSalvar = corRaw === '' ? null : corRaw;
        var objDadosRegistro: { nome: string, dados: any, prioridade: number, categoria_tarefa: number, cor: string | null } = {
          nome: formRegistro.find("input[name=nome]").val(),
          dados: _.omit(dadosForm, ['_token', 'id', 'nome', 'prioridade', 'categoria_tarefa', 'cor']),
          prioridade: prioridade,
          categoria_tarefa: categoriaTarefa,
          cor: corSalvar,
        }
        // console.log("AUTODME::", dadosForm, objDadosRegistro)

        if (!App.Util.validarFormAutoDme(dadosForm)) {
          return;
        }

        modal.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));

        try {
          this.ajax.postAcao(`${formRegistro.data('url')}/${idRegistro}`, objDadosRegistro, (objResposta: IRespostaAjaxPostAcao) => {
            if (objResposta.hasOwnProperty('status') && objResposta.status == "success") {
              let dadosResposta: { atualizar_agenda: { idUser: number, data: string, contasIds: number[] }, dados: any, id: number, nome: string, prioridade?: number, categoria_tarefa?: number, cor?: string } = objResposta.dadosRetornados.dadosResposta;
              this.atualizarContasByIdsContas(dadosResposta.atualizar_agenda ? this.getIdsAllContas() : null)
              this.atualizarListaAutodme(idRegistro, {
                nome: dadosResposta && dadosResposta.nome ? dadosResposta.nome : objDadosRegistro.nome,
                dados: dadosResposta && dadosResposta.dados ? dadosResposta.dados : objDadosRegistro.dados,
                prioridade: dadosResposta && dadosResposta.prioridade != null ? dadosResposta.prioridade : objDadosRegistro.prioridade,
                categoria_tarefa: dadosResposta && dadosResposta.categoria_tarefa != null ? dadosResposta.categoria_tarefa : objDadosRegistro.categoria_tarefa,
                cor: dadosResposta && dadosResposta.hasOwnProperty('cor') ? dadosResposta.cor : objDadosRegistro.cor,
              })
            } else {
              modal.modal('show');
            }

            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          console.log("ERRO SALVAR Registro", e)
          App.Util.ocultarModalPaginaCarregando()
          modal.modal('show');
        }
      }

      modelViewAutodme.acaoAposCopiarRegistro = (dados: IRespostaSucessoAjx) => {
        document.location.reload();
      }

      $(document).on("change", ".js-cor-linha-autodme-picker", (e: JQueryEventObject) => {
        const $form = $(e.currentTarget).closest("form");
        $form.find(".js-cor-linha-autodme-hidden").val(String($(e.currentTarget).val() || ""));
      });
      $(document).on("click", ".js-cor-linha-autodme-limpar", (e: JQueryEventObject) => {
        e.preventDefault();
        const $form = $(e.currentTarget).closest("form");
        $form.find(".js-cor-linha-autodme-hidden").val("");
        $form.find(".js-cor-linha-autodme-picker").val("#ffffff");
      });

      $(document).on("select2:select", ".form-step-config-autodme .js-select-dme-autodme-pro", (e: JQueryEventObject) => {
        this.agendarAplicarConfigPadraoAutodmeSelecionado($(e.currentTarget));
      });

      $(document).on("change", ".form-step-config-autodme .js-select-dme-autodme-pro", (e: JQueryEventObject) => {
        if ((e as any).originalEvent) {
          this.agendarAplicarConfigPadraoAutodmeSelecionado($(e.currentTarget));
        }
      });

      $(document).on("click", ".js-autodme-salvar-config-padrao", (e: JQueryEventObject) => {
        e.preventDefault();
        this.salvarConfigPadraoAutodmePeloFormulario($(e.currentTarget));
      });

      $(document).on("click", ".js-autodme-sugerir-config", (e: JQueryEventObject) => {
        e.preventDefault();
        this.sugerirConfiguracaoAutodmePeloFormulario($(e.currentTarget));
      });

      // Abrir o modal ja com um DME selecionado (edicao) nao dispara o change do select.
      $(document).on("shown.bs.modal", ".modal-step-config", (e: JQueryEventObject) => {
        const $form = $(e.currentTarget).find("form.form-step-config-autodme").first();
        if (!$form.length || !$form.find(".js-autodme-assistente-admin").length) {
          return;
        }
        const setId = this.normalizarSetIdAutodmeValor($form.find(".js-select-dme-autodme-pro").first().val());
        if (setId) {
          this.carregarConfigAssistenteAutodmeNoFormulario($form, setId);
        }
      });

      $(document).on("click", ".btn-prioridade-autodme", (e: JQueryEventObject) => {
        e.preventDefault();
        const el = $(e.currentTarget);
        const id = parseInt(String(el.data("id") || "0"), 10);
        const delta = parseInt(String(el.data("delta") || "0"), 10);
        const url = String(el.data("url") || "");
        if (!id || !delta || !url) {
          return;
        }

        const $tr = el.closest("tr");
        const $campo = $tr.find(".js-prioridade-autodme-valor");
        const cur = this.lerPrioridadeAutodmeCampo($campo);
        const next = Math.max(1, cur + delta);
        this.agendarSalvarPrioridadeAutodme(id, url, $tr, next);
      });

      $(document).on("change blur", ".autodme-prioridade-input", (e: JQueryEventObject) => {
        const el = $(e.currentTarget);
        const id = parseInt(String(el.data("id") || "0"), 10);
        const url = String(el.data("url") || "");
        if (!id || !url) {
          return;
        }
        const $tr = el.closest("tr");
        const prioridade = this.lerPrioridadeAutodmeCampo(el);
        const original = parseInt(String(el.data("prioridade-original") || el.attr("data-prioridade-original") || prioridade), 10) || prioridade;
        if (prioridade === original) {
          this.escreverPrioridadeAutodmeCampo($tr, prioridade);
          return;
        }
        this.agendarSalvarPrioridadeAutodme(id, url, $tr, prioridade);
      });

      $(document).on("keydown", ".autodme-prioridade-input", (e: JQueryEventObject) => {
        if ((e as any).key === "Enter") {
          e.preventDefault();
          $(e.currentTarget).trigger("change");
          $(e.currentTarget).blur();
        }
      });

      $(document).on("click", ".btn-ajustar-prioridade-autodme-pool", (e: JQueryEventObject) => {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const url = String($btn.data("url") || "");
        if (!url) {
          return;
        }

        const aplicar = () => {
          const htmlOriginal = $btn.html();
          $btn.prop("disabled", true);
          $btn.html('<i class="fas fa-spinner fa-spin mr-1"></i> Ajustando...');
          this.ajax = new App.Ajax();
          this.ajax.postAcao(
            url,
            {},
            (objResposta: IRespostaAjaxPostAcao) => {
              $btn.prop("disabled", false);
              $btn.html(htmlOriginal);
              if (!objResposta.hasOwnProperty("status") || objResposta.status !== "success") {
                return;
              }

              const dr: any = objResposta.dadosRetornados;
              const dados = dr && dr.dadosResposta ? dr.dadosResposta : {};
              const atualizados = Array.isArray(dados.atualizados) ? dados.atualizados : [];
              atualizados.forEach((item: any) => {
                const id = parseInt(String(item.id || "0"), 10);
                const prioridade = parseInt(String(item.prioridade || "0"), 10);
                if (id > 0 && prioridade > 0) {
                  this.atualizarLinhaPrioridadeListagemAutodme(id, prioridade);
                }
              });

              if (this.objDataTableAutodme) {
                this.objDataTableAutodme.order([[9, "asc"]]).draw(false);
              }

              const total = parseInt(String(dados.total || atualizados.length || "0"), 10) || 0;
              const ordenadosPorPool = parseInt(String(dados.ordenadosPorPool || "0"), 10) || 0;
              toastr.success(
                `${total} Auto DME(s) reordenado(s). ${ordenadosPorPool} seguiram a sequencia de forragens sugerida.`,
                "Prioridades atualizadas"
              );
            },
            null,
            true,
            true
          );
        };

        if (typeof swal !== "undefined" && swal && typeof swal.fire === "function") {
          swal.fire({
            title: "Ajustar prioridades?",
            text: "Todos os Auto DMEs da lista serao reordenados pela sequencia de forragens sugerida.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, ajustar",
            cancelButtonText: "Cancelar"
          }).then((result: any) => {
            if (result && result.isConfirmed) {
              aplicar();
            }
          });
        } else if (confirm("Ajustar prioridades dos Auto DMEs pela sequencia de forragens sugerida?")) {
          aplicar();
        }
      });

      $(document).on("click", ".js-autodme-requisitos-toggle", (e: JQueryEventObject) => {
        e.preventDefault();
        this.alternarDetalhesRequisitosListagemAutodme($(e.currentTarget));
      });

      this.inicializarDataTableAutodme();
      this.carregarDetalhesDmesAutodmeParaListagem(() => this.atualizarRequisitosListagemAutodme());
      this.bootstrapAutodmeDaSbcInfo();
    }

    private static normalizarTextoDiagnosticoAutoDme(valor: any): string {
      const raridadesConhecidas: Record<string, string> = {
        "0": "Comum",
        "1": "Raro",
        "2": "Prata raro",
      };
      const gruposRaridadeConhecidos: Record<string, string> = {
        "4": "Raros",
      };
      const rotulo = (nome: string | undefined, id: string) => nome ? `${nome} (#${id})` : `#${id}`;
      return String(valor != null ? valor : "")
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/\bgrupo de raridade\s+#?(\d+)\b/gi, (_m, id) => `grupo de raridade ${rotulo(gruposRaridadeConhecidos[String(id)], String(id))}`)
        .replace(/\braridade\s+#?(\d+)\b/gi, (_m, id) => `raridade ${rotulo(raridadesConhecidas[String(id)], String(id))}`)
        .replace(/\bclube\s+#?(\d+)\b/gi, "clube #$1")
        .replace(/\bliga\s+#?(\d+)\b/gi, "liga #$1")
        .replace(/\bnacionalidade\s+#?(\d+)\b/gi, "nacionalidade #$1")
        .replace(/\bna[cç][aã]o\s+#?(\d+)\b/gi, "nacao #$1");
    }

    private resumirExclusionAuditAutoDme(audit: any): string[] {
      if (!audit || typeof audit !== "object") return [];
      const filtros = audit.filters && typeof audit.filters === "object" ? audit.filters : {};
      const linhas: string[] = [];
      const lista = (valor: any): string[] => Array.isArray(valor)
        ? valor.map((item) => Business.normalizarTextoDiagnosticoAutoDme(item)).filter(Boolean)
        : [];
      const appendLista = (destino: string[], label: string, valor: any) => {
        const itens = lista(valor);
        if (!itens.length) return;
        const exibidos = itens.slice(0, 8).join(", ");
        const extra = itens.length > 8 ? ` (+${itens.length - 8})` : "";
        destino.push(`${label}: ${exibidos}${extra}`);
      };

      const filtrosAtivos: string[] = [];
      appendLista(filtrosAtivos, "ligas", filtros.ligas);
      appendLista(filtrosAtivos, "nacoes", filtros.nacoes);
      appendLista(filtrosAtivos, "clubes", filtros.clubes);
      appendLista(filtrosAtivos, "raridades", filtros.raridades);
      appendLista(filtrosAtivos, "ratings", filtros.ratings);
      appendLista(filtrosAtivos, "jogadores", filtros.jogadores);

      const jogadoresTotal = Number(filtros.jogadoresTotal);
      if (Number.isFinite(jogadoresTotal) && jogadoresTotal > lista(filtros.jogadores).length) {
        filtrosAtivos.push(`jogadores excluidos no total: ${jogadoresTotal}`);
      }

      [
        ["especiais", "especiais"],
        ["negociaveis", "negociaveis"],
        ["sbcSquads", "SBC squads"],
        ["ativoNoElenco", "ativos no elenco"],
        ["extintos", "extintos"],
        ["storage", "somente storage"],
      ].forEach(([key, label]) => {
        if (filtros[key]) filtrosAtivos.push(label);
      });

      const faixas: string[] = [];
      if (filtros.minRating != null && filtros.minRating !== "") faixas.push(`min rating ${filtros.minRating}`);
      if (filtros.maxRating != null && filtros.maxRating !== "") faixas.push(`max rating ${filtros.maxRating}`);
      if (filtros.ratingRange != null && filtros.ratingRange !== "") faixas.push(`range rating ${filtros.ratingRange}`);
      if (filtros.precoMaximoJogadorNegociavel != null && filtros.precoMaximoJogadorNegociavel !== "") faixas.push(`preco max. jog. negociavel ${filtros.precoMaximoJogadorNegociavel}`);
      if (filtros.precoMaximoJogadorInegociavel != null && filtros.precoMaximoJogadorInegociavel !== "") faixas.push(`preco max. jog. inegociavel ${filtros.precoMaximoJogadorInegociavel}`);
      if (faixas.length) filtrosAtivos.push(faixas.join(", "));

      if (filtrosAtivos.length) linhas.push(`Exclusoes/filtros ativos: ${filtrosAtivos.join("; ")}.`);

      const impact = audit.impact && typeof audit.impact === "object" ? audit.impact : {};
      const impactos = [
        ["antes", impact.beforeRequirementFilter],
        ["apos requisitos", impact.afterRequirementFilter],
        ["apos filtros baratos", impact.afterCheapFilters],
        ["enviados ao solver", impact.sentToSolver],
      ]
        .filter(([, valor]) => valor != null && valor !== "")
        .map(([label, valor]) => `${label}: ${valor}`);
      if (impactos.length) linhas.push(`Impacto no pool: ${impactos.join("; ")}.`);

      const rejeicoes = Array.isArray(audit.rejectedByReason) ? audit.rejectedByReason : [];
      const resumoRejeicoes = rejeicoes.slice(0, 5).map((item: any) => {
        const label = Business.normalizarTextoDiagnosticoAutoDme(item && (item.label || item.key || "motivo"));
        const count = Number(item && item.count) || 0;
        const exemplos = lista(item && item.examples).slice(0, 3);
        return `${label}: ${count}${exemplos.length ? ` (${exemplos.join(", ")})` : ""}`;
      }).filter(Boolean);
      if (resumoRejeicoes.length) linhas.push(`Rejeicoes mais comuns: ${resumoRejeicoes.join("; ")}.`);

      return linhas;
    }

    private renderizarExclusionAuditAutoDme(audit: any): string {
      const linhas = this.resumirExclusionAuditAutoDme(audit);
      if (!linhas.length) return "";
      return linhas.map((linha) => `<div class="text-muted">${this.escapeHtmlEstadoDme(linha)}</div>`).join("");
    }

    private motivoLimiteTentativasDmeParaHumano(meta: any): string {
      const tentativasHoje = meta && meta.tentativas_hoje != null ? Math.max(0, Number(meta.tentativas_hoje) || 0) : 0;
      const sucessosHoje = meta && meta.sucessos_hoje != null ? Math.max(0, Number(meta.sucessos_hoje) || 0) : 0;
      const falhasHoje = meta && meta.falhas_hoje != null
        ? Math.max(0, Number(meta.falhas_hoje) || 0)
        : Math.max(0, tentativasHoje - sucessosHoje);
      const limite = meta && meta.limite_tentativas_dia != null ? Number(meta.limite_tentativas_dia) : null;
      const modo = meta && (meta.repeatabilityMode || meta.modoRaw)
        ? String(meta.repeatabilityMode || meta.modoRaw).toUpperCase()
        : "";
      const sufixoLimite = limite != null && Number.isFinite(limite) && limite > 0
        ? ` Falhas no ciclo EA: ${falhasHoje}/${limite}. Tentativas totais: ${tentativasHoje}.`
        : ` Falhas no ciclo EA: ${falhasHoje}. Tentativas totais: ${tentativasHoje}.`;

      if (modo === "UNLIMITED" && sucessosHoje > 0) {
        const textoBase = `<span class="text-success font-weight-600">${sucessosHoje} sucesso(s) local(is), limite de falhas atingido.</span>${sufixoLimite}`;
        if (falhasHoje > 0) {
          const diagnostico = this.getUltimoDiagnosticoAutoDme(meta);
          if (diagnostico) {
            const titulo = this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticTitle || diagnostico.diagnosticCode || "Diagnostico"));
            const mensagem = diagnostico.diagnosticMessage
              ? this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticMessage))
              : "sem detalhes adicionais";
            return `${textoBase} <span class="text-muted">${falhasHoje} tentativa(s) tambem ficaram registradas como falha/interrupcao. Ultimo diagnostico: ${titulo} - ${mensagem}.</span>`;
          }
          return `${textoBase} <span class="text-muted">${falhasHoje} tentativa(s) tambem ficaram registradas como falha/interrupcao, sem diagnostico gravado.</span>`;
        }
        return textoBase;
      }

      if (sucessosHoje > 0 && falhasHoje === 0) {
        return `Executado com sucesso ${sucessosHoje} vez(es) no ciclo EA. O limite de falhas foi sinalizado, mas nao ha falhas registradas neste ciclo.${sufixoLimite}`;
      }

      const diagnostico = this.getUltimoDiagnosticoAutoDme(meta);
      if (falhasHoje > 0) {
        if (diagnostico) {
          const prefixo = `Sem solucao nas ultimas tentativas (${falhasHoje} falha(s) no ciclo EA); limite de falhas do ciclo atingido.${sufixoLimite}`;
          const titulo = this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticTitle || diagnostico.diagnosticCode || "Solver"));
          const mensagem = diagnostico.diagnosticMessage
            ? this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticMessage))
            : "sem detalhes adicionais";
          return `${prefixo} Ultimo retorno do solver: ${titulo} - ${mensagem}.`;
        }
        return `Falha/interrupcao registrada nas ultimas tentativas (${falhasHoje} falha(s) no ciclo EA); limite de falhas do ciclo atingido.${sufixoLimite} Sem diagnostico do solver gravado nesta tentativa.`;
      }

      if (diagnostico) {
        const titulo = this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticTitle || diagnostico.diagnosticCode || "Solver"));
        const mensagem = diagnostico.diagnosticMessage
          ? this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diagnostico.diagnosticMessage))
          : "sem detalhes adicionais";
        return `Limite de falhas deste ciclo EA atingido.${sufixoLimite} Ultimo retorno do solver: ${titulo} - ${mensagem}.`;
      }

      return `Limite de falhas deste ciclo EA atingido.${sufixoLimite} Sem diagnostico do solver gravado nesta tentativa.`;
    }

    private motivoLimiteSolucoesDmeParaHumano(meta: any): string {
      const solucoesHoje = meta && meta.solucoes_hoje != null
        ? Math.max(0, Number(meta.solucoes_hoje) || 0)
        : (meta && meta.sucessos_hoje != null ? Math.max(0, Number(meta.sucessos_hoje) || 0) : 0);
      const limiteDiario = meta && meta.limite_solucoes_diarias != null
        ? Math.max(0, Number(meta.limite_solucoes_diarias) || 0)
        : 0;
      const limiteEfetivo = meta && meta.limite_ciclo_efetivo != null
        ? Math.max(0, Number(meta.limite_ciclo_efetivo) || 0)
        : (meta && meta.limite_solucoes_diarias_efetivo != null ? Math.max(0, Number(meta.limite_solucoes_diarias_efetivo) || 0) : limiteDiario);
      const limiteTxt = limiteEfetivo > 0
        ? `${solucoesHoje}/${limiteEfetivo}`
        : `${solucoesHoje}`;
      const faixasForragens = meta && Array.isArray(meta.limites_solucoes_por_forragens) ? meta.limites_solucoes_por_forragens : [];
      const detalheForragens = faixasForragens.length
        ? ` Forragens: ${meta.forragens_clube_total != null ? meta.forragens_clube_total : "-"} no clube; faixas ${faixasForragens.map((f: any) => `${f.solucoes || 0} abaixo de ${f.abaixo_de || 0}`).join("; ")}; limite efetivo: ${meta.limite_solucoes_diarias_efetivo != null ? meta.limite_solucoes_diarias_efetivo : limiteEfetivo}.`
        : "";
      const detalheLimiteCadastro = limiteDiario > 0 && limiteEfetivo > 0 && limiteDiario !== limiteEfetivo
        ? ` Limite do cadastro por ciclo EA: ${limiteDiario}; teto efetivo usado: ${limiteEfetivo}.`
        : "";
      return `Limite de solucoes do ciclo EA deste DME atingido (${limiteTxt}).${detalheLimiteCadastro}${detalheForragens}`;
    }

    private getUltimoDiagnosticoAutoDme(meta: any): any {
      if (!meta) return null;
      const diag = meta.ultimo_diagnostico || meta.ultimoDiagnostico || meta.diagnostic || null;
      if (!diag || typeof diag !== "object") return null;
      if (diag.diagnosticTitle || diag.diagnosticCode || diag.diagnosticMessage) return diag;
      return null;
    }

    private getUltimosDiagnosticosFalhaAutoDme(meta: any): any[] {
      if (!meta) return [];
      const origem = Array.isArray(meta.ultimos_diagnosticos_falha)
        ? meta.ultimos_diagnosticos_falha
        : (Array.isArray(meta.ultimosDiagnosticosFalha) ? meta.ultimosDiagnosticosFalha : []);
      const candidatos = origem.length ? origem : [this.getUltimoDiagnosticoAutoDme(meta)].filter(Boolean);
      const vistos: Record<string, boolean> = {};
      const saida: any[] = [];
      candidatos.forEach((diag: any) => {
        if (!diag || typeof diag !== "object") return;
        const titulo = Business.normalizarTextoDiagnosticoAutoDme(diag.diagnosticTitle || diag.diagnosticCode || "");
        const mensagem = Business.normalizarTextoDiagnosticoAutoDme(diag.diagnosticMessage || "");
        if (!titulo && !mensagem) return;
        const chave = `${titulo.toLowerCase()}|${mensagem.toLowerCase()}`;
        if (vistos[chave]) return;
        vistos[chave] = true;
        saida.push(diag);
      });
      return saida.slice(0, 3);
    }

    private renderizarDiagnosticosFalhaAutoDme(meta: any, falhasHoje: number): string {
      if (!falhasHoje || falhasHoje <= 0) return "";
      const diagnosticos = this.getUltimosDiagnosticosFalhaAutoDme(meta);
      if (!diagnosticos.length) {
        return `<div class="font-size-10 text-muted mt-1">Falha registrada sem diagnostico do solver gravado.</div>`;
      }
      const itens = diagnosticos.map((diag: any) => {
        const titulo = this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diag.diagnosticTitle || diag.diagnosticCode || "Motivo nao identificado"));
        const mensagem = diag.diagnosticMessage
          ? this.escapeHtmlEstadoDme(Business.normalizarTextoDiagnosticoAutoDme(diag.diagnosticMessage))
          : "";
        const audit = this.renderizarExclusionAuditAutoDme(diag.exclusionAudit);
        return `<div class="mt-1"><span class="font-weight-600">• ${titulo}</span>${mensagem ? `<div class="text-muted">${mensagem}</div>` : ""}${audit}</div>`;
      }).join("");
      return `<div class="font-size-10 mt-1 conta-diagnostico-falha-detalhes"><div class="font-weight-600 text-danger">Diagnostico da nao solucao:</div>${itens}</div>`;
    }

    private renderizarPoolForragensAutoDme(modal: JQuery, dados: any) {
      const wrap = modal.find(".js-estado-tarefa-pool-forragens-wrap");
      const body = modal.find(".js-estado-tarefa-pool-forragens-body");
      const resumos: any[] = Array.isArray(dados && dados.poolForragensUltimosDias)
        ? dados.poolForragensUltimosDias
        : [];

      if (!resumos.length) {
        wrap.hide();
        body.html("");
        return;
      }

      const numero = (valor: any): number => Number(valor) || 0;
      const formatarNumero = (valor: any): string => numero(valor).toLocaleString("pt-BR");
      const total = (contadores: any): number => numero(contadores && contadores.total);
      const formatarSaldo = (valor: number): string => valor > 0 ? `+${formatarNumero(valor)}` : formatarNumero(valor);
      const formatarData = (data: string): string => {
        if (!data || data.length < 10) return "-";
        const partes = data.split("-");
        return partes.length === 3 ? `${partes[2]}/${partes[1]}` : this.escapeHtmlEstadoDme(String(data));
      };
      const detalheSaldo = (saldo: any): string => {
        const partes: string[] = [];
        const add = (label: string, chave: string) => {
          const valor = numero(saldo && saldo[chave]);
          if (valor !== 0) partes.push(`${label} ${formatarSaldo(valor)}`);
        };
        add("B", "bronze");
        add("P", "prata");
        add("OC", "ouro_comum");
        add("OR", "ouro_raro");
        add("OVR", "ovr_alto");
        const negociavel = numero(saldo && saldo.negociavel);
        const inegociavel = numero(saldo && saldo.inegociavel);
        if (negociavel !== 0 || inegociavel !== 0) {
          partes.push(`Neg ${formatarSaldo(negociavel)}`);
          partes.push(`Ineg ${formatarSaldo(inegociavel)}`);
        }
        return partes.length ? partes.join(" | ") : "-";
      };

      const linhas = resumos.map((item: any) => {
        const recebidos = total(item && item.recebidos);
        const usados = total(item && item.usados);
        const saldo = total(item && item.saldo);
        const saldoClass = saldo > 0 ? "text-success" : (saldo < 0 ? "text-danger" : "text-muted");
        return `
          <tr>
            <td class="font-size-12 text-muted">${formatarData(item && item.data)}</td>
            <td class="font-size-12">${formatarNumero(recebidos)}</td>
            <td class="font-size-12">${formatarNumero(usados)}</td>
            <td class="font-size-12 font-weight-600 ${saldoClass}">${formatarSaldo(saldo)}</td>
            <td class="font-size-12">${this.escapeHtmlEstadoDme(detalheSaldo(item && item.saldo))}</td>
          </tr>`;
      }).join("");

      body.html(linhas);
      wrap.show();
    }

    private getContaDiagnosticoAutoDmeAtual(): IConta {
      const payload = this.diagnosticoContaTarefasAtual || {};
      const contaDiag: any = payload.conta || {};
      const contaLocal: IConta = contaDiag && contaDiag.id ? App.Util.getItemArrayById(this.arrayContas, contaDiag.id) : null;
      const conta: any = Object.assign({}, contaLocal || {}, contaDiag || {});
      if ((!Array.isArray(conta.players) || !conta.players.length) && contaLocal && Array.isArray(contaLocal.players)) {
        conta.players = contaLocal.players;
      }
      if (!conta.listas && contaLocal && contaLocal.listas) {
        conta.listas = contaLocal.listas;
      }
      return conta as IConta;
    }

    private getQuantidadeCartasNecessariasDme(dme: any): number {
      const challenges = Array.isArray(dme && dme.challenges) ? dme.challenges : [];
      if (!challenges.length) {
        const totalDesafios = Math.max(1, Number(dme && (dme.challengesCount || dme.totalDesafiosDme)) || 1);
        return totalDesafios * 11;
      }

      let total = 0;
      challenges.forEach((challenge: IDmeChallengeUi) => {
        const textos: string[] = [];
        if (Array.isArray(challenge.requirements)) {
          challenge.requirements.forEach((texto: any) => textos.push(String(texto || "")));
        }
        if (Array.isArray(challenge.requirementItems)) {
          challenge.requirementItems.forEach((item: any) => {
            if (item && item.text) textos.push(String(item.text));
            if (item && item.raw && item.raw.text) textos.push(String(item.raw.text));
          });
        }

        let qtdDesafio = 0;
        textos.forEach((texto) => {
          const normalizado = texto.toLowerCase();
          if (!/(players in squad|jogadores no elenco|jogadores no plantel|numero de jogadores|number of players)/i.test(normalizado)) {
            return;
          }
          const match = texto.match(/(\d{1,2})/g);
          if (match && match.length) {
            qtdDesafio = Math.max(qtdDesafio, Number(match[match.length - 1]) || 0);
          }
        });
        total += qtdDesafio > 0 ? qtdDesafio : 11;
      });
      return Math.max(11, total);
    }

    private textoNormalizadoDiagnostico(valor: any): string {
      return String(valor || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    }

    private inferirTagRequisitoCartas(texto: string, item: any = null): string {
      const rawKey = item && item.raw ? Number(item.raw.key) : NaN;
      if (rawKey === 10 || rawKey === 4) return "nation";
      if (rawKey === 11 || rawKey === 5) return "league";
      if (rawKey === 6) return "team";
      if (rawKey === 26 || rawKey === 28) return "rating";

      const tag = item && item.tag ? String(item.tag) : "";
      if (tag === "league" || tag === "nation" || tag === "team" || tag === "rating") {
        return tag;
      }

      const s = this.textoNormalizadoDiagnostico(texto);
      if (/(totw|team of the week|equipe da semana|if\b|inform)/i.test(s)) return "totw";
      if (/(special|especial|raridade)/i.test(s)) return "special";
      if (/\d/.test(s) && /(rating|overall|classificacao|ovr|ger)/i.test(s)) return "rating";
      if (/\bliga\b|\bleague\b|mesma liga|same league|atletas de liga/i.test(s)) return "league";
      if (/nacao|nacionalidade|\bpais\b|\bnation\b|paises|regioes|atletas de paises/i.test(s)) return "nation";
      if (/\bclube\b|\btime\b|\bclub\b|mesmo clube|same club|atletas de clube/i.test(s)) return "team";
      return "";
    }

    private extrairIdRequisitoCartas(item: any, tag: string, texto: string): number {
      const raw = item && item.raw && typeof item.raw === "object" ? item.raw : null;
      if (raw && raw.value != null) {
        const rawValue = typeof raw.value === "object" && raw.value && raw.value.id != null ? raw.value.id : raw.value;
        const nRaw = Number(rawValue);
        if (Number.isFinite(nRaw) && nRaw > 0) return nRaw;
      }

      const candidatos = tag === "team"
        ? [item && item.teamId, item && item.clubId]
        : (tag === "league" ? [item && item.leagueId] : [item && item.nationId, item && item.nation]);
      for (let i = 0; i < candidatos.length; i++) {
        const n = Number(candidatos[i]);
        if (Number.isFinite(n) && n > 0) return n;
      }

      const w = window as any;
      const lookups = w.FSW_DME_ENTITY_LOOKUPS || {};
      const mapa = tag === "team" ? lookups.teamsById : (tag === "league" ? lookups.leaguesById : lookups.nationsById);
      if (mapa && typeof mapa === "object") {
        const textoNorm = this.textoNormalizadoDiagnostico(texto);
        for (const id in mapa) {
          if (!mapa.hasOwnProperty(id)) continue;
          const nomeNorm = this.textoNormalizadoDiagnostico(mapa[id]);
          if (nomeNorm && textoNorm.indexOf(nomeNorm) !== -1) {
            const n = Number(id);
            if (Number.isFinite(n) && n > 0) return n;
          }
        }
      }

      return 0;
    }

    private extrairRatingRequisitoCartas(texto: string): { op: string, valor: number } | null {
      const matches = String(texto || "").match(/\d{2,3}/g);
      if (!matches || !matches.length) return null;
      const valor = Number(matches[matches.length - 1]);
      if (!Number.isFinite(valor) || valor <= 0) return null;
      const s = this.textoNormalizadoDiagnostico(texto);
      const op = /(max|maximo|maximum)/i.test(s) ? "max" : "min";
      return { op, valor };
    }

    private obterNomeEntidadeRequisitoCartas(tag: string, id: number, textoFallback: string): string {
      const w = window as any;
      const lookups = w.FSW_DME_ENTITY_LOOKUPS || {};
      const mapa = tag === "team" ? lookups.teamsById : (tag === "league" ? lookups.leaguesById : lookups.nationsById);
      const nome = mapa && (mapa[String(id)] || mapa[id]);
      if (nome) return this.escapeHtmlEstadoDme(String(nome));
      return this.escapeHtmlEstadoDme(String(textoFallback || id).replace(/\s+/g, " ").trim()).slice(0, 48);
    }

    private coletarRequisitosCartasDme(dme: any): Array<{ texto: string, tag: string, item: any }> {
      const challenges = Array.isArray(dme && dme.challenges) ? dme.challenges : [];
      const requisitos: Array<{ texto: string, tag: string, item: any }> = [];
      challenges.forEach((challenge: any) => {
        const items = Array.isArray(challenge && challenge.requirementItems) ? challenge.requirementItems : [];
        items.forEach((item: any) => {
          const texto = String((item && (item.text || (item.raw && item.raw.text))) || "").trim();
          const tag = this.inferirTagRequisitoCartas(texto, item);
          if (texto && tag) requisitos.push({ texto, tag, item });
        });

        const reqs = Array.isArray(challenge && challenge.requirements) ? challenge.requirements : [];
        reqs.forEach((req: any) => {
          const texto = typeof req === "string"
            ? String(req || "").trim()
            : String((req && (req.text || req.textPtBr || req.text_pt || req.textEn || req.description || req.label || req.title)) || "").trim();
          const tag = this.inferirTagRequisitoCartas(texto, req);
          if (texto && tag) requisitos.push({ texto, tag, item: req });
        });
      });
      return requisitos;
    }

    private renderizarDetalhesRequisitosCartasDme(dme: any, players: IContaPlayerResumo[]): string {
      if (!Array.isArray(players) || !players.length) return "";

      const vistos: any = {};
      const linhas: string[] = [];
      const requisitos = this.coletarRequisitosCartasDme(dme);
      requisitos.forEach((req) => {
        let chave = "";
        let label = "";
        let qtd = 0;

        if (req.tag === "totw") {
          chave = "totw";
          label = "TOTW";
          qtd = players.filter((p: any) => Number(p && p.rareflag) === 3).length;
        } else if (req.tag === "special") {
          chave = "special";
          label = "Especiais";
          qtd = players.filter((p: any) => Number(p && p.rareflag) > 2 || (Number(p && p.assetId) > 0 && Number(p && p.resourceId) > 0 && Number(p.assetId) !== Number(p.resourceId))).length;
        } else if (req.tag === "rating") {
          const rating = this.extrairRatingRequisitoCartas(req.texto);
          if (!rating) return;
          chave = `rating:${rating.op}:${rating.valor}`;
          label = rating.op === "max" ? `Rating max. ${rating.valor}` : `Rating min. ${rating.valor}`;
          qtd = players.filter((p: any) => {
            const r = Number(p && p.rating);
            return Number.isFinite(r) && (rating.op === "max" ? r <= rating.valor : r >= rating.valor);
          }).length;
        } else if (req.tag === "league" || req.tag === "nation" || req.tag === "team") {
          const id = this.extrairIdRequisitoCartas(req.item, req.tag, req.texto);
          if (!id) return;
          chave = `${req.tag}:${id}`;
          const nomeCurto = this.obterNomeEntidadeRequisitoCartas(req.tag, id, req.texto);
          label = req.tag === "league" ? `Liga ${nomeCurto}` : (req.tag === "nation" ? `País ${nomeCurto}` : `Clube ${nomeCurto}`);
          qtd = players.filter((p: any) => {
            const valor = req.tag === "league" ? Number(p && p.leagueId) : (req.tag === "nation" ? Number(p && (p.nation != null ? p.nation : p.nationId)) : Number(p && (p.teamid != null ? p.teamid : p.teamId)));
            return Number.isFinite(valor) && valor === id;
          }).length;
        }

        if (!chave || vistos[chave]) return;
        vistos[chave] = true;
        linhas.push(`<div class="text-muted font-size-10">${label}: <span class="font-weight-600">${qtd}</span></div>`);
      });

      return linhas.length ? `<div class="mt-1 conta-diagnostico-requisitos-cartas">${linhas.slice(0, 4).join("")}</div>` : "";
    }

    private renderizarSuficienciaCartasDme(dme: any): string {
      const conta = this.getContaDiagnosticoAutoDmeAtual();
      const players = this.getPlayersConta(conta);
      const totalPlayers = players.length || Number((conta && conta.listas && conta.listas.clube_total) || 0) || 0;
      const scanAt = conta && (conta as any).players_scan_at ? this.formatarDataEstadoAutoDme((conta as any).players_scan_at) : "-";

      if (totalPlayers <= 1) {
        return `<span class="badge badge-secondary font-size-10" title="Sem scan de jogadores salvo em conta.players/listas.clube_total">Sem scan</span>`;
      }

      const necessario = this.getQuantidadeCartasNecessariasDme(dme);
      const faltam = Math.max(0, necessario - totalPlayers);
      const detalhes = `Checagem leve por contagem: ${totalPlayers}/${necessario} carta(s). Ultimo scan: ${scanAt}. Nao valida quimica, posicoes ou solucao final.`;
      if (faltam > 0) {
        return `<span class="badge badge-warning font-size-10" title="${this.escapeHtmlEstadoDme(detalhes)}">Falta ${faltam}</span>${this.renderizarDetalhesRequisitosCartasDme(dme, players)}`;
      }

      return `<span class="badge badge-success font-size-10" title="${this.escapeHtmlEstadoDme(detalhes)}">OK</span><div class="text-muted font-size-10">${totalPlayers}/${necessario}</div>${this.renderizarDetalhesRequisitosCartasDme(dme, players)}`;
    }

    /**
     * Abre o modal de novo Auto DME pré-preenchido quando o usuário chega em /pro/app
     * vindo do botão "Registrar Auto DME" da tela /sbc-info (redirect com query params).
     */
    private bootstrapAutodmeDaSbcInfo(): void {
      if (typeof window === "undefined" || typeof URLSearchParams === "undefined") {
        return;
      }
      var params = new URLSearchParams(window.location.search);
      var setIdRaw = params.get("novoAutodmeSetId");
      if (!setIdRaw) {
        return;
      }
      var setId = parseInt(setIdRaw, 10);
      if (!setId || setId <= 0) {
        return;
      }
      var exigeEspecial = params.get("novoAutodmeExigeEspecial") === "1";

      try {
        var novaUrl = window.location.pathname + window.location.hash;
        window.history.replaceState(null, "", novaUrl || window.location.pathname);
      } catch (_) { /* noop */ }

      var $modal = $("#modalCadastrarAutodme");
      if (!$modal.length) {
        return;
      }

      var $tabLink = $('a[href="#tabs-autodme"]');
      if ($tabLink.length && typeof ($tabLink as any).tab === "function") {
        ($tabLink as any).tab("show");
      }

      var $select = $modal.find("#select-dme-novo");
      if (!$select.length) {
        $select = $modal.find(".js-select-dme-autodme-pro").first();
      }
      if (!$select.length) {
        return;
      }

      $select.val(String(setId));
      var $option = $select.find('option[value="' + String(setId) + '"]');
      var nomeSugerido = String(($option.attr("data-name") || $option.text() || "")).trim();
      ($select as any).trigger("change");

      if (nomeSugerido) {
        var $nome = $modal.find('input[name="nome"]');
        if ($nome.length && !String($nome.val() || "").trim()) {
          $nome.val(nomeSugerido);
        }
      }

      var $excluir = $modal.find("#excluirEspeciais-novo");
      if (!$excluir.length) {
        $excluir = $modal.find('input[name="excluirEspeciais"]').first();
      }
      if ($excluir.length) {
        $excluir.prop("checked", !exigeEspecial);
      }

      try {
        var rawConfig = window.sessionStorage ? window.sessionStorage.getItem("sbcinfoNovoAutodmeDefaultConfig") : null;
        if (rawConfig) {
          window.sessionStorage.removeItem("sbcinfoNovoAutodmeDefaultConfig");
          var configPadrao = JSON.parse(rawConfig);
          if (configPadrao && typeof configPadrao === "object") {
            configPadrao.id_dme = setId;
            this.preencherFormAutodme($modal.find("form").first(), $modal, {
              id: null as any,
              nome: nomeSugerido || ("SBC #" + setId),
              dados: configPadrao
            } as any);
          }
        }
      } catch (_) { /* noop */ }

      window.setTimeout(function () {
        ($modal as any).modal("show");
      }, 50);
    }

    private inicializarDataTableAutodme(): void {
      const $tbl = $("table.list-autodme");
      if (!$tbl.length || typeof $.fn.dataTable === "undefined") {
        return;
      }
      if ($.fn.dataTable.isDataTable($tbl[0])) {
        this.objDataTableAutodme = $tbl.DataTable();
        App.Util.desabilitarAutocompleteDataTables($tbl);
        return;
      }
      this.objDataTableAutodme = $tbl.DataTable({
        language: { url: "/datatable-pt-br.json" },
        // Ordena por Prioridade. A coluna "Períodos" saiu (índice 7) ao migrar o período para a
        // config de execução (17/08/2026), então Prioridade passou de índice 9 para 8.
        order: [[8, "asc"]],
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
        lengthChange: true,
        dom: "lfrtip",
        columnDefs: [{ targets: -1, orderable: false, searchable: false }],
      } as any);
      App.Util.desabilitarAutocompleteDataTables($tbl);

      $('a[data-toggle="tab"][href="#tabs-autodme"]').on("shown.bs.tab", () => {
        this.carregarDetalhesDmesAutodmeParaListagem(() => this.atualizarRequisitosListagemAutodme());
        if (this.objDataTableAutodme) {
          this.objDataTableAutodme.columns.adjust().draw(false);
        }
      });
      if ($("#tabs-autodme").hasClass("active")) {
        setTimeout(() => {
          this.carregarDetalhesDmesAutodmeParaListagem(() => this.atualizarRequisitosListagemAutodme());
          if (this.objDataTableAutodme) {
            this.objDataTableAutodme.columns.adjust().draw(false);
          }
        }, 100);
      }
    }

    private inicializarCrudApiVendaCoins() {
      let formPreenchido: number[] = []
      var modelViewApiVendaCoins = new ModelView();
      modelViewApiVendaCoins.elBtnEditar = $(".btn-editar-api-venda-coins");
      modelViewApiVendaCoins.elBtnExcluir = $(".btn-excluir-api-venda-coins");

      $('.form-step-config-api-venda-coins').find('select[name=id_servico]').on('change', function () {
        let formApi = $(this).parents('form')
        let selectedOption = $(this).val();
        switch (selectedOption) {
          case '1':
          case '6':
            formApi.find(".espaco-campo-user-email").hide()
            break;
          default:
            formApi.find(".espaco-campo-user-email").show()
            break;
        }
      });

      modelViewApiVendaCoins.inicializar($('.form-step-config-api-venda-coins'), false, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewApiVendaCoins._this = this;
      modelViewApiVendaCoins.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarApiVendaCoins${idRegistro}`);
        var form: JQuery = modal.find('form');
        modal.modal('show');

        var objApiVendaCoins: IObjFormApiVendaCoins = { id: $(e.currentTarget).data("id"), nome: $(e.currentTarget).data("nome"), dados: $(e.currentTarget).data("dados") }
        _.contains(formPreenchido, idRegistro) || this.preencherFormApiVendaCoins(form, modal, objApiVendaCoins)
        formPreenchido.push(idRegistro)

        //console.log("REGISTRO EDIT::", objApiVendaCoins)
      }

      modelViewApiVendaCoins.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        e.preventDefault();
        var formRegistro = $(e.target);
        var modalAgendamento = $(e.target).parents('.modal-step-config');
        let idRegistro = formRegistro.data('id');

        this.ajax = new App.Ajax();
        let dadosForm: any = this.ajax.convertFormToJSON(formRegistro)
        var objDadosRegistro: { nome: string, dados: any } = { nome: formRegistro.find("input[name=nome]").val(), dados: _.omit(dadosForm, ['_token', 'id', 'nome']) }

        //console.log("FORM::", objDadosRegistro)

        modalAgendamento.modal('hide');
        App.Util.exibirModalPaginaCarregando(parseInt(idRegistro));

        try {
          this.ajax.postAcao(`${formRegistro.data('url')}/${idRegistro}`, objDadosRegistro, (objResposta: IRespostaAjaxPostAcao) => {
            if (objResposta.hasOwnProperty('status') && objResposta.status == "success") {
              this.atualizarListaApiVendaCoins(idRegistro, objDadosRegistro)
            } else {
              modalAgendamento.modal('show');
            }
            App.Util.ocultarModalPaginaCarregando()
          }, null, false);
        } catch (e) {
          console.log("ERRO SALVAR Registro", e)
          App.Util.ocultarModalPaginaCarregando()
          modalAgendamento.modal('show');
        }
      }
    }

    private inicializarCrudProxy() {
      var modelViewProxy = new ModelView();
      modelViewProxy.elBtnEditar = $(".btn-editar-proxy");
      modelViewProxy.elBtnExcluir = $(".btn-excluir-proxy");

      modelViewProxy.inicializar($('.form-step-config-proxy'), true, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewProxy.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarProxy${idRegistro}`);
        modal.modal('show');
      };
    }

    private inicializarCrudApiIntegracao() {
      var modelViewApiIntegracao = new ModelView();
      modelViewApiIntegracao.elBtnEditar = $(".btn-editar-api-integracao");
      modelViewApiIntegracao.elBtnExcluir = $(".btn-excluir-api-integracao");
      var atualizarCamposTipoIntegracao = (form: JQuery) => {
        var tipo = String(form.find("select[name='tipo']").val() || "1");
        form.find(".campos-integracao-tipo").hide().find(":input").prop("disabled", true);
        form.find(".campos-integracao-tipo-" + tipo).show().find(":input").prop("disabled", false);
      };

      $('.form-step-config-api-integracao').each((index, item) => {
        atualizarCamposTipoIntegracao($(item));
      });

      $('.form-step-config-api-integracao').find("select[name='tipo']").on('change', (e) => {
        atualizarCamposTipoIntegracao($(e.currentTarget).parents('.form-step-config-api-integracao'));
      });

      $("input[name=status_api_integracao]").on("change", (e) => {
        this.ajax = new App.Ajax();
        this.ajax.postAcao($(e.currentTarget).data("url"), {
          id: $(e.currentTarget).data("id"),
          status: $(e.target).is(':checked')
        });
      });

      modelViewApiIntegracao.inicializar($('.form-step-config-api-integracao'), true, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewApiIntegracao.aoSalvarRegistroPorModal = (e: JQueryEventObject, validar: boolean = false) => {
        var form = $(e.currentTarget);
        if (validar && !form.valid()) {
          e.preventDefault();
          return;
        }

        var seletorModalContexto: string = "#" + form.parents('.modal').attr('id');
        atualizarCamposTipoIntegracao(form);
        this.ajax = new App.Ajax();
        this.ajax.postModal(e, seletorModalContexto, () => {
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }, true);
      };

      modelViewApiIntegracao.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarApiIntegracao${idRegistro}`);
        modal.modal('show');
      };
    }

    private inicializarCrudPeriodo() {
      const modelViewPeriodo = new ModelView();
      modelViewPeriodo.elBtnEditar = $(".btn-editar-periodo");
      modelViewPeriodo.elBtnExcluir = $(".btn-excluir-periodo");

      modelViewPeriodo.inicializar($('.form-step-config-periodo'), true, (dados: IRespostaSucessoAjx) => {
        const e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewPeriodo.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        const idRegistro = $(e.currentTarget).data("id");
        const modal = $(`#modalCadastrarPeriodo${idRegistro}`);
        modal.modal('show');
      };

      // ...existing code...
      modelViewPeriodo.aoSalvarRegistroPorModal = (e: JQueryEventObject) => {
        const $form = $(e.currentTarget);
        var modal = $form.parents('.modal-step-config');
        const totalMarcados = $form.find("input[name='dias[]']:checked").length;
        const $horaInicio = $form.find("input[name='hora_inicio']");
        const $horaFim = $form.find("input[name='hora_fim']");

        const horaInicioExiste = $horaInicio.length > 0;
        const horaFimExiste = $horaFim.length > 0;

        const horaInicioVal = horaInicioExiste ? String($horaInicio.val() || "").trim() : "";
        const horaFimVal = horaFimExiste ? String($horaFim.val() || "").trim() : "";

        const bloquear = (titulo: string, msg: string) => {
          e.preventDefault();
          e.stopPropagation();
          App.Util.exibirSweetAlertaFireSimples(titulo, msg, "error");
        };

        if (!totalMarcados) {
          return bloquear("Obrigatório!", "Informe ao menos 1 dia da semana.");
        }

        if (!horaInicioExiste || !horaFimExiste) {
          return bloquear("Obrigatório!", "Campos de hora de início e fim não encontrados no formulário.");
        }

        if (!horaInicioVal || !horaFimVal) {
          return bloquear("Obrigatório!", "Informe a hora de início e a hora de fim.");
        }

        if (horaInicioVal === horaFimVal) {
          return bloquear("Invalido!", "A hora de inicio e a hora de fim nao podem ser iguais.");
        }

        modal.modal('hide');
      };

      this.inicializarSugestaoNomePeriodo();
    }


    private inicializarCrudServidor() {
      var modelViewServidor = new ModelView();
      modelViewServidor.elBtnEditar = $(".btn-editar-servidor");
      modelViewServidor.elBtnExcluir = $(".btn-excluir-servidor");

      modelViewServidor.inicializar($('.form-step-config-servidor'), true, (dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        Business.removerTrListagemCrudPosExclusao(e);
      });

      modelViewServidor.aoEditarRegistro = (e: JQueryEventObject, _this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarServidor${idRegistro}`);
        modal.modal('show');
      };

      modelViewServidor.ojDataTableCarregado.elDataTable = $("#dataTableServidores");
      let ehAdmin = Number(modelViewServidor.ojDataTableCarregado.elDataTable.data('ehAdmin')) === 1;
      let podeManutencaoServidoresPro = Number(modelViewServidor.ojDataTableCarregado.elDataTable.data('podeManutencaoServidoresPro')) === 1;
      // Admin ou USER_TESTERS (fase de testes) — quem decide e o backend; aqui so escondemos o botao.
      let podeAtualizarContasServidores = Number(modelViewServidor.ojDataTableCarregado.elDataTable.data('podeAtualizarContas')) === 1;
      let obterServidoresAlvo = () => {
        let dataTable = modelViewServidor.ojDataTableCarregado.objDataTable;
        let selecionados = dataTable.rows({ selected: true });
        let linhasAlvo = selecionados.count() ? selecionados : dataTable.rows();
        return linhasAlvo.nodes().toArray().map((node: any) => {
          let $tr = $(node);
          let id = $tr.attr('id');
          return {
            id: id,
            nome: $.trim($tr.find(`.nome-servidor${id}`).text()) || `Servidor ${id}`,
            address: $.trim($tr.find(`.nome-address${id}`).text())
          };
        });
      };
      let acoesButtonExtraServidor: any[] = [
        {
          className: "btn-sm btn-outline-primary btn-abrir-servidores",
          text: 'Abrir Servidor',
          action: () => {
            let itensSelecionados = modelViewServidor.ojDataTableCarregado.objDataTable.rows({ selected: true })
            let count = itensSelecionados.count();
            if (count) {
              itensSelecionados.ids().toArray().forEach((id: number) => {
                let urlHref = $(`#${id}`).find('.btn-acessar-servidor').attr('href');
                window.open(urlHref, '_blank');
              });

              if (count > 1) {
                toastr.warning("Para que nosso sistema consiga abrir varias abas em seu nevegador, pode ser necessário uma autorização de sua parte para abertura de pop-ups", "Importante!");
              }
            }
          }
        }
      ]

      acoesButtonExtraServidor.push({
        className: "btn-sm btn-outline-danger btn-reiniciar-plugins-servidores",
        text: 'Reiniciar Plugins',
        action: () => {
          this.reiniciarPluginsServidores(obterServidoresAlvo());
        }
      });

      if (podeAtualizarContasServidores && modelViewServidor.ojDataTableCarregado.elDataTable.data("urlAtualizarContas")) {
        acoesButtonExtraServidor.push({
          className: "btn-sm btn-outline-success btn-atualizar-contas-servidores",
          text: 'Atualizar Contas',
          action: () => {
            this.atualizarContasServidores(obterServidoresAlvo());
          }
        });
      }

      if (podeManutencaoServidoresPro && modelViewServidor.ojDataTableCarregado.elDataTable.data("urlReiniciarWindows")) {
        acoesButtonExtraServidor.push({
          className: "btn-sm btn-outline-danger btn-reiniciar-windows-servidores",
          text: 'Reiniciar Windows',
          action: () => {
            this.reiniciarWindowsServidores(obterServidoresAlvo());
          }
        });
      }

      if (podeManutencaoServidoresPro && modelViewServidor.ojDataTableCarregado.elDataTable.data("urlSincronizarDatabase")) {
        acoesButtonExtraServidor.push({
          className: "btn-sm btn-outline-info btn-sincronizar-database-servidores",
          text: 'Sincronizar/Limpar Cache Contas',
          action: () => {
            this.sincronizarDatabaseServidores(obterServidoresAlvo());
          }
        });
      }

      if (podeManutencaoServidoresPro && modelViewServidor.ojDataTableCarregado.elDataTable.data("urlLimparDisco")) {
        acoesButtonExtraServidor.push({
          className: "btn-sm btn-outline-secondary btn-limpar-disco-servidores",
          text: 'Limpar Disco',
          action: () => {
            this.limparDiscoServidores(obterServidoresAlvo());
          }
        });
      }

      if (ehAdmin && modelViewServidor.ojDataTableCarregado.elDataTable.data("urlForcarAtualizacaoPlugins")) {
        acoesButtonExtraServidor.push({
          className: "btn-sm btn-outline-warning btn-forcar-atualizacao-plugins-servidores",
          text: 'Forcar Atualizacao',
          action: () => {
            this.forcarAtualizacaoPluginsServidores(obterServidoresAlvo());
          }
        });
      }

      modelViewServidor.ojDataTableCarregado.acoesButtonExtra = acoesButtonExtraServidor

      modelViewServidor.ojDataTableCarregado.metodoSelecionarDeselecionarComplemento = (count: number) => {
        $('.btn-abrir-servidores').html(count > 0 ? `Abrir Servidor (${count})` : `Abrir Servidor`)
        $('.btn-reiniciar-plugins-servidores').html(count > 0 ? `Reiniciar Plugins (${count})` : `Reiniciar Plugins`)
        if (podeManutencaoServidoresPro) {
          $('.btn-reiniciar-windows-servidores').html(count > 0 ? `Reiniciar Windows (${count})` : `Reiniciar Windows`)
          $('.btn-sincronizar-database-servidores').html(count > 0 ? `Sincronizar/Limpar Cache Contas (${count})` : `Sincronizar/Limpar Cache Contas`)
          $('.btn-limpar-disco-servidores').html(count > 0 ? `Limpar Disco (${count})` : `Limpar Disco`)
        }
        if (podeAtualizarContasServidores) {
          $('.btn-atualizar-contas-servidores').html(count > 0 ? `Atualizar Contas (${count})` : `Atualizar Contas`)
        }
        if (ehAdmin) {
          $('.btn-forcar-atualizacao-plugins-servidores').html(count > 0 ? `Forcar Atualizacao (${count})` : `Forcar Atualizacao`)
        }
      }

      modelViewServidor.carregardataTable()
      App.Util.desabilitarAutocompleteDataTables(modelViewServidor.ojDataTableCarregado.elDataTable);
    }

    public aoSalvarFiltroModalSniper(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      let dadosForm: any = this.ajax.convertFormToJSON(formSniperPro);
      let nomeFiltro = formSniperPro.find('input[name=nome]').val()

      try {
        let campoNomeDigitavel = formSniperPro.find('input[name=campo_nome_filtro]').val()
        nomeFiltro = campoNomeDigitavel ? campoNomeDigitavel : nomeFiltro
      } catch (e) { }

      if (App.Util.validarFiltroSniper(dadosForm)) {
        let dadosFormatado = _.omit(dadosForm, ['descanso', 'intervalo', 'limite_compra', 'piloto_automatico', 'tempo', 'velocidade']);
        dadosFormatado.nome = nomeFiltro ? nomeFiltro : this.obterNomeFiltro("#formSniperPro");
        this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url-salvar-filtro-modal-sniper") + "?nao-regarregar=true", dadosFormatado, App.SalvarFiltro.acaoAposSalvarFiltro);
      }
    }

    private obterNomeFiltro(seletor: any) {
      var elemento = $(seletor);
      var jogador = elemento.find('.select2-selection__choice').find(".name").text();
      var qualidade = $.trim(elemento.find('#qualidade option:selected').text());
      var raridade = $.trim(elemento.find('#raridade option:selected').text());
      var posicao = $.trim(elemento.find('#posicao option:selected').text());
      var estilo = $.trim(elemento.find('#estilo option:selected').text());
      var estiloJogo = $.trim(elemento.find('#estiloJogo option:selected').text());
      var nacionalidade = $.trim(elemento.find('#pais option:selected').text());
      var liga = $.trim(elemento.find('#liga option:selected').text());
      var time = $.trim(elemento.find('#time option:selected').text());

      var valorOferta = null;
      var valorPorLucro = null;
      var ehPrecoCompra = $(seletor).find("input[name=precoCompra]").prop('checked');

      if (ehPrecoCompra) {
        valorOferta = elemento.find("input[name='maxBuyNow']").val() + " Coins";
      } else {
        valorPorLucro = elemento.find("input[name='lucro']").val() + "%";
      }

      var nomeFiltro = (qualidade.indexOf('Limpar') !== -1 ? "" : qualidade + " ") +
        (raridade.indexOf('Limpar') !== -1 ? "" : raridade.substring(0, 7) + " ") + (posicao.indexOf('Limpar') !== -1 ? "" : posicao.substring(0, 3) + " ") +
        (estilo.indexOf('Limpar') !== -1 ? "" : estilo.substring(0, 3) + " ") + (nacionalidade.indexOf('Limpar') !== -1 ? "" : nacionalidade.substring(0, 15).replace(/ /g, "") + " ") +
        (liga.indexOf('Limpar') !== -1 ? "" : liga.substring(0, 8).replace(/ /g, "") + " ") + (time.indexOf('Limpar') !== -1 ? "" : time.substring(0, 15).replace(/ /g, "") + " ") + (estiloJogo.indexOf('Limpar') !== -1 ? "" : estiloJogo.substring(0, 3) + " ") +
        (valorOferta ? valorOferta : valorPorLucro);
      nomeFiltro = nomeFiltro.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
      var nomeFiltroCompleto = (jogador.indexOf('Limpar') !== -1 ? "" : jogador.replace(/ /g, "") + " ") + nomeFiltro;

      return Util.removeAspasEAcentos(nomeFiltroCompleto);
    }

    private continuarInicializacao() {
      this.carregarCacheInfoContas();
      this.limparCacheAvataresAntigos();
      $('.piloto-automatico-agendamento').on('change', (e) => { this.aoSelecionarPilotoAutomaticoAgendamento(e); });
      $('.modal-step-config').each((index, value) => {
        var cloneData = new CloneData();
        cloneData.inicializarCampo($('a#' + $(value).find('.add-more-sch').attr('id')), 0, 20, $(value).find('.main-container-sch').attr('id'), $(value).find('.container-item-sch').data('classContainerItem'), $(value).find('.remove-item-sch').data('classRemove'), Util.getOptionsSelectTag(), () => {
          $('.piloto-automatico-agendamento').off('change');
          $('.piloto-automatico-agendamento').on('change', (e) => { this.aoSelecionarPilotoAutomaticoAgendamento(e); });
          $('.copy-item-sch').unbind("click");
          $('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });
        }, () => {
          $(value).find('.nao-salvo-geral').show()
        });
      });
      $('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });
      $('.espaco-collapse-agenda').on('show.bs.collapse', function (e) {
        if (_.contains(['a', 'i', 'input'], (event.target as any).nodeName.toLowerCase())) {
          e.preventDefault();
          e.stopPropagation();
        }
      })
      this.objSelect2.inicializarCampo($('.select2'));
      this.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());

      this.filtrosEa = new FiltrosEa();
      this.filtrosEa.inicializarEventos();
      App.Util.ocultarModalPaginaCarregando()
    }

    private carregarCacheInfoContas() {
      try {
        const stored = localStorage.getItem(Business.STORAGE_KEY_CACHE_CONTAS);
        if (stored) {
          this.cacheInfoContas = JSON.parse(stored);
        }
      } catch (e) {
        console.error("Erro ao carregar cacheInfoContas", e);
        this.cacheInfoContas = {};
      }
    }

    private salvarCacheInfoContas() {
      try {
        localStorage.setItem(Business.STORAGE_KEY_CACHE_CONTAS, JSON.stringify(this.cacheInfoContas));
      } catch (e) {
        console.error("Erro ao salvar cacheInfoContas", e);
      }
    }

    private agendarSalvarCacheInfoContas() {
      this.cacheInfoContasAlterado = true;
      if (this.cacheInfoContasSaveTimer) {
        return;
      }
      this.cacheInfoContasSaveTimer = window.setTimeout(() => {
        this.cacheInfoContasSaveTimer = null;
        if (!this.cacheInfoContasAlterado) {
          return;
        }
        this.cacheInfoContasAlterado = false;
        this.salvarCacheInfoContas();
      }, 300);
    }

    private atualizarCacheInfoConta(conta: IConta) {
      if (!conta || !conta.id || !conta.dadosEa) {
        return;
      }
      if (!this.cacheInfoContas[conta.id]) {
        this.cacheInfoContas[conta.id] = {
          corAvatar: App.Util.obterCorRandomica(),
          nomeAvatar: App.Util.getNomeAvatar(conta.dadosEa.clubeName)
        };
      }
      this.cacheInfoContas[conta.id].lastUsed = Date.now();
      this.agendarSalvarCacheInfoContas();
    }

    private limparCacheAvataresAntigos() {
      const trintaDiasEmMs = 30 * 24 * 60 * 60 * 1000;
      const agora = Date.now();
      let alterado = false;

      for (const id in this.cacheInfoContas) {
        if (this.cacheInfoContas.hasOwnProperty(id)) {
          const entry = this.cacheInfoContas[id];
          if (entry.lastUsed && agora - entry.lastUsed > trintaDiasEmMs) {
            delete this.cacheInfoContas[id];
            alterado = true;
          }
        }
      }

      if (alterado) {
        this.salvarCacheInfoContas();
      }
    }

    private getPlayers(metodoCallback: any) {
      const hoje = new Date();
      const parametroCache = `${hoje.getFullYear()}-${hoje.getMonth() + 1}-${hoje.getDate()}`; // Gera o parâmetro baseado na data atual
      $.getJSON("/players.json", { _: parametroCache }, (data) => {
        App.Util.objPlayers = data.Players;
        metodoCallback();
      });
    }

    private aoLimparLog(e: JQueryEventObject) {
      var id: number = $(e.currentTarget).data("id");
      $(`.espaco-log-${id}`).html('');
    }


    public aoEditarRegistroFiltroPro(e: JQueryEventObject, _this: this) {
      var modal = $("#modalCadastrarFiltroPro");
      modal.modal('show');
      var id: number = $(e.currentTarget).data("id");
      var nome: string = $(e.currentTarget).data("nome");
      var nomeOriginal: string = $(e.currentTarget).data("nomeOnly");

      var dados: IDataFiltroPro = $(e.currentTarget).data("dados");
      _this.filtrosEa.setCampoInputName("id", id);
      _this.filtrosEa.setCampoInputName("nome", nomeOriginal);
      if (dados.data.maskedDefId && dados.data.maskedDefId.length) {
        _this.filtrosEa.setCampoJogador(dados.data.maskedDefId, App.Util.objPlayers);
      } else {
        modal.modal('show');
        modal.find("#searchclear").click();
      }

      _this.filtrosEa.setCampoSelect2("quality", dados.data.quality);
      _this.filtrosEa.setCampoSelect2("icontraits", dados.data.icontraits);
      _this.filtrosEa.setCampoSelect2("rarity[]", dados.data.rarity);
      _this.filtrosEa.setCampoSelect2("position", dados.data.position);
      _this.filtrosEa.setCampoSelect2("chemical", dados.data.chemical);
      _this.filtrosEa.setCampoSelect2("nation", dados.data.nation);
      _this.filtrosEa.setCampoSelect2("league", dados.data.league);
      _this.filtrosEa.setCampoSelect2("club", dados.data.club);
      _this.filtrosEa.setCampoInputName("minBuyNow", dados.data.minBuyNow);
      _this.filtrosEa.setCampoInputName("maxBuyNow", dados.data.maxBuyNow);
      _this.filtrosEa.setCampoInputName("variar", dados.data.variar, true);
      _this.filtrosEa.setCampoInputRadio("precoCompra", dados.data.lucro ? "2" : "1");
      _this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", !App.Util.empty(dados.venda));
      _this.filtrosEa.setCampoInputCheckbox("precoInteligente", !App.Util.empty(dados.venda) && dados.venda.precoInteligente);
      _this.filtrosEa.setCampoInputCheckbox("precoFutbin", !App.Util.empty(dados.venda) && dados.venda.precoFutbin);
      _this.filtrosEa.setCampoInputName("lucro", dados.data.lucro);
      _this.filtrosEa.setCampoInputCheckbox("turbo", !App.Util.empty(dados.data.turbo) && dados.data.turbo);
      _this.filtrosEa.setCampoInputName("porcentagemMaisBarato", !App.Util.empty(dados.venda) && dados.venda.porcentagemMaisBarato ? dados.venda.porcentagemMaisBarato : 0);
      _this.filtrosEa.setCampoInputName("valor_lance_minimo", !App.Util.empty(dados.venda) && dados.venda.valorLanceMinimo ? dados.venda.valorLanceMinimo : "");
      _this.filtrosEa.setCampoInputName("valor_venda", !App.Util.empty(dados.venda) && dados.venda.valorVenda ? dados.venda.valorVenda : "");
      _this.filtrosEa.setCampoInputName("limite_compra_min", dados.data.limiteCompraMin);
      _this.filtrosEa.setCampoInputName("limite_compra_max", dados.data.limiteCompraMax);
    }

    private exibirAlertaRestartMonitorSniper(request: any, reiniciandoAgora: boolean = false): void {
      const mensagem = request && request.mensagem
        ? request.mensagem
        : reiniciandoAgora
          ? "Monitor Sniper confirmou a falha. O plugin sera reiniciado agora."
          : "Monitor Sniper detectou falha. O plugin sera reiniciado em ~3 minutos se o problema continuar.";
      toastr.warning(mensagem, (request && request.titulo) || "Monitor Sniper", {
        timeOut: reiniciandoAgora ? 12000 : 18000,
        extendedTimeOut: reiniciandoAgora ? 8000 : 12000,
        closeButton: true,
        progressBar: true,
      });
    }

    private async iniciarComunicacaoSocket() {
      let pct: string = null
      let srv: string = null
      let prt: any = null

      let idServidor = Util.getIdServidorByUrl(window.location.href)
      this.dadosServidor = await this.getDadosServidorByTid(idServidor) || { id: null, tid: null, nome: null, address: null, password: null, port: null }
      if (this.dadosServidor && this.dadosServidor.hasOwnProperty('address') && this.dadosServidor.address) {
        pct = this.dadosServidor.protocolo
        srv = this.dadosServidor.address
        prt = this.dadosServidor.port
      } else {
        let objParametrosAtuais = Util.getObjParametrosUrlLocation()
        pct = objParametrosAtuais.get('pct') ? objParametrosAtuais.get('pct') : `http`
        srv = objParametrosAtuais.get('srv') ? objParametrosAtuais.get('srv') : `localhost`
        prt = objParametrosAtuais.get('prt') ? objParametrosAtuais.get('prt') : `5033`
        // console.log("objParametrosAtuais", objParametrosAtuais, srv, prt)
      }
      let objSocketIo = new SocketIo();
      this.pluginServerBaseUrl = `${pct}://${srv}:${prt}`;
      this.socketClientBot = objSocketIo.inicializarCampo(this.pluginServerBaseUrl, App.Util.usuario.id, App.Util.usuario.api_token, this.dadosServidor.address, this.dadosServidor.password, this.dadosServidor.port);
      this.comunicacao = new Comunicacao(this.socketClientBot);
      if (this.transferCoins) this.transferCoins.setComunicacao(this.comunicacao);
      this.comunicacao.socket.on('disconnect', () => {
        //console.log("Disconect");
        $('.btn-autenticar').hide()
        $('.menu-api-venda-coins').hide()
        this.conectado = false;
        this.exibirViewConexao();
      });
      this.comunicacao.socket.on('connect', () => {
        //console.log("connect");
        $('.btn-autenticar').show()
        this.conectado = true;
        this.exibirViewConexao();
        // this.salvarAutorizacaoCertificadoConexaoHttps(pct, srv, prt)
        this.fecharSwalSeNaoForModalReinicioPlugins()
      });

      this.comunicacao.socket.on(Comunicacao.CANAL_RECEIVE, async (acao: number | string, request: any, callback: any = null) => {
        switch (acao) {
          case "plugin_ligado":
            this.executarAcoesAoLigarDesligarPlugin(request);
            return;
          case "status":
            this.atualizarStatusConta(request);
            return;
          case "contas_dashboard_hidratadas":
            this.atualizarContasDashboardHidratadas(request && request.contas ? request.contas : []);
            return;
          case "plx":
            this.exibirPlanoExpirado(request);
            return;
          case "log":
            this.receberLogs(request.data)
            return;
          case "busca":
            this.tratarBuscaSniper(request, callback)
            return;
          case "erro_login":
            this.exibirFalhaNaAutenticacao(request);
            return;
          case "vinculo_progresso":
            this.atualizarProgressoVinculo(request);
            return;
          case "update_consolidado_conta":
            this.updateConsolidadosContaDatatable(request.consolidado.id, request.consolidado);
            return;
          case "atualizar_creditos":
            this.atualizarCreditos(request.id, request.creditos, request.lucro);
            return;
          case "conta_agendada":
            this.atualizarViewInfoAgendamento(request.id, request.programacao)
            if (request.ocultarLoad) {
              this.ocultarLoadListConta(request.id)
            }
            return;
          case "codigo_autenticacao_solicitado":
            App.Util.ocultarModalPaginaCarregando()
            return await this.solicitarCodigoValidacao(request, callback)
          case "informar_codigo_autenticacao_solicitado":
            App.Util.ocultarModalPaginaCarregando()
            swal.fire({
              icon: 'info',
              title: `Informe o código de autenticação`,
              text: `vá até o navegador da conta ${request.email} e informe o código enviado pela EA.`,
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            return
          case "acao":
            this.tratarAcao(request, callback)
            return;
          case "error":
            this.tratarError(request, callback)
            return;
          case "base_dados_corrompido":
            this.informarBaseDadosCorrompida(request);
            return;
          case "progresso_restauracao":
            this.tratarProgressoRestauracao(request);
            return;
          case "progresso_sincronizacao_contas":
            this.tratarProgressoSincronizacaoContas(request);
            return;
          case "progresso_laboratorio_dme":
            this.tratarProgressoLaboratorioDme(request);
            return;
          case "init_view_webapp":
            this.iniciarVisualizacaoTelaWebAppRemota(request);
            return;
          case "instalar_chrome_bin":
            this.informarSobreInstalacaoChrome(request);
            return;

          // ─── Transfer Between Accounts — beta ─────────────────────────
          case "sniper_monitor_restart_agendado":
            this.exibirAlertaRestartMonitorSniper(request, false);
            return;
          case "sniper_monitor_restart_alerta":
            this.exibirAlertaRestartMonitorSniper(request, true);
            return;
          case "transfer_status":
            if (this.transferCoins) this.transferCoins.onTransferStatus(request);
            return;
          case "fut_transfer_integracao":
            if (request && request.status === false) {
              toastr.warning(request.message || "Falha na integracao Fut Transfer", "Fut Transfer");
            } else if (request && request.status === true) {
              toastr.success(request.message || "Integracao Fut Transfer atualizada", "Fut Transfer");
            }
            return;
          case "transfer_jogadores":
            if (this.transferCoins) this.transferCoins.onTransferJogadores(request);
            return;
          // ──────────────────────────────────────────────────────────────
        }
      });

      this.comunicacao.socket.on("connect_error", (err: any) => {
        if (pct == "http") {
          return;
        }
        console.log("sock", this.quantidadeFalhaConexaoPlugin, err.message); // prints the message associated with the error
        if (!this.getAutorizacaoCertificadoConexaoHttps(pct, srv, prt)) {
          this.quantidadeFalhaConexaoPlugin++;
          let exibirManutencaoPlugin = Boolean(this.quantidadeFalhaConexaoPlugin >= 6);
          if (exibirManutencaoPlugin && this.quantidadeFalhaConexaoPlugin == 6) {
            this.fecharSwalSeNaoForModalReinicioPlugins()
          }

          if (!swal.isVisible()) {
            swal.fire({
              title: 'Conectando ao Servidor!',
              confirmButtonText: "Autorizar",
              showDenyButton: exibirManutencaoPlugin,
              denyButtonText: `Iniciar Manutenção`,
              confirmButtonColor: "#2dce89",
              text: 'Por segurança o chrome exige que você autorize a conexão com nosso servidor, se ainda não autorizou, clique em autorizar e siga os passos mostrados na imagem acima para se conectar.',
              imageUrl: '/img/gifs/autorizar-servidor.gif',
              imageWidth: 500,
              imageAlt: 'Autorizar servidor',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((result: any) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                console.log("Saved!", "", "success");
                window.location.href = `${pct}://${srv}:${prt}?tid=${this.dadosServidor.tid}&nome=${this.dadosServidor.nome}`
              } else if (result.isDenied) {
                this.ajax.postAcao(App.Util.config.urlSolicitarManutencao, this.dadosServidor, (dadosSucesso: IRespostaSucessoAjx) => {
                  console.log("Manutenção", dadosSucesso.dadosRetornados)
                  swal.fire("Manutenção Programada!", "Uma manutenção programada será iniciada em seu servidor. Aguarde aproximadamente 5 minutos para que seu dashboard seja reconectado. Se necessário, recarregue esta página e clique em 'Autorizar' novamente após esse tempo.", "info");
                });
              }
            });
          }
        }
      });
    }

    private async getDadosServidorByTid(idServidor: string) {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          if (!this.ajax) {
            this.ajax = new Ajax();
          }

          this.ajax.get(App.Util.config.urlGetServidor, { "tid": idServidor }, (dadosSucesso: IRespostaSucessoAjx) => {
            resolve(dadosSucesso.dadosRetornados)
          }, null, null, false)
        } catch (e) {
          resolve(null)
        }
      })
    }

    private salvarAutorizacaoCertificadoConexaoHttps(pct: string, srv: string, prt: string) {
      let chaveAutorizacaoCertificado = `${pct}${srv}${prt}`
      localStorage.setItem(chaveAutorizacaoCertificado, new Date().toISOString());
    }

    private getAutorizacaoCertificadoConexaoHttps(pct: string, srv: string, prt: string) {
      let chaveAutorizacaoCertificado = `${pct}${srv}${prt}`
      return false;
      // return localStorage.getItem(chaveAutorizacaoCertificado) || null;
    }

    private getElementoListConta(idConta: number): JQuery {
      return $(`tr#${idConta}`)
    }

    private receberLogs(dataLog: IDataLog) {
      // console.log("RECEBER_LOG::", dataLog);

      if (dataLog.tipo == Util.EVENTO_TIPO_COMPRA) {
        this.atualizarConsolidadoDaConta(dataLog.idConta)
      }

      this.exibirLogsSniper(dataLog)
      this.carregarTabelaLogs(dataLog);
    }

    private async solicitarCodigoValidacao(request: any, callback: any) {
      Util.ocultarModalPaginaCarregando();

      // Se for um vínculo em andamento (existe row provisória), pede o código INLINE na própria row —
      // não bloqueia a fila das outras contas. Caso contrário (abertura de conta existente), usa o swal.
      const chaveVinculo = request && request.email ? this.gerarChaveVinculo(request.email) : null;
      if (chaveVinculo && this.getRowProvisoria(chaveVinculo)) {
        this.pendentesCodigo2FA[chaveVinculo] = callback;
        // O campo de código é renderizado na coluna de status da row (renderColunaStatusVinculo).
        this.setEstadoVinculo(chaveVinculo, { etapa: "aguardando_2fa", status: "pausa", codigoErro: !!(request && request.codigoErro) });
        return;
      }

      var result = await swal.fire({
        title: `Informe o código da conta ${request.email} enviado pela EA`,
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Enviar`,
        denyButtonText: `Solicitar outro`,
        denyButtonColor: "#5e72e4",
        confirmButtonColor: "#2dce89",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      if (result.isConfirmed) {
        Util.exibirModalPaginaCarregando();
        return this.responderServidor(true, { codigo: result.value }, callback);
      } else if (result.isDenied) {
        // Solicitar novo código
        Util.exibirModalPaginaCarregando();
        return this.responderServidor(true, { codigo: 0 }, callback);
      } else {
        // Cancelou processo informação de codigo
        return this.responderServidor(true, { codigo: null }, callback);
      }

    }

    private iniciarConfiguracoesDeConta(idContaEa: string) {
      try {
        $(".modal-config-extensao").each((index, el) => {
          var configuracoesConta = new App.ConfiguracoesConta($(el), 2);
          configuracoesConta.executarCallbackChange = (obj: IConfiguracoesConta, id: number, data: any = null) => {
            if (App.Util.isset(obj.ativar_proxy)) {
              this.atualizarViewProxyConta(id, obj.ativar_proxy, data)
            }
          }
        });
      } catch (e) {
        console.log("ERRO iniciarConfiguracoesDeConta", e)
      }
    }

    private getIdsContasEaVinculadas(): any {
      return _.pluck(App.Util.usuario.contas, 'id_conta_ea')
    }
    private getIdsContasEaVinculadasPlugin(): any {
      return _.pluck(this.arrayContas, 'id')
    }

    private async getContasPlugin(): Promise<any> {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONTAS, {
            ids: this.getIdsContasEaVinculadas(),
            dashboardBootstrap: true
          }, (response: IRespostaMensagem) => {
            const result = response ? response.result : null;
            resolve(result && $.isArray(result.contas) ? result.contas : (result || []))
          })

        } catch (e) {
          resolve([])
        }
      });
    }

    private async getConsolidadosPlugin(id: number = null): Promise<any> {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONSOLIDADOS, { id: id }, (response: IRespostaMensagem) => {
            resolve(response.result)
          })
        } catch (e) {
          resolve([])
        }
      });
    }

    private async sincronizarAtualizarDadosGeraisEntrePluginInterface() {
      App.Util.exibirLoadingTableContas()
      this.arrayConsolidados = await this.getConsolidadosPlugin()
      this.arrayContas = await this.getContasPlugin();
      if (this.transferCoins) this.transferCoins.setArrayContas(this.arrayContas);
      this.carregarTabelaContas(this.arrayContas);
      this.updateLucroGeralPorPlataforma()
      this.updateCoinsGeralPorPlataforma()
      this.updateEncontradosPorFiltro()
      App.Util.ocultarLoadingTableContas()
      this.carregarPartialsViewsContas()
      await this.continuarinicializacaodashBoard()
    }

    private async atualizarConsolidadoDaConta(id: any, consolidado: IContaConsolidado = null) {
      if (!consolidado) {
        consolidado = await this.getConsolidadosPlugin(parseInt(id)) as IContaConsolidado
      }
      this.updateConsolidadosContaDatatable(id, consolidado)
    }


    private getProgressoConsolidadoTempoExecucao(tempoExecucaoSegundos: number): { label?: string, labelAbreviado?: string, limite?: number, tempo?: number, percent?: number, color: string } {
      var consolidadoTempoExecucao: { label?: string, labelAbreviado?: string, limite?: number, tempo?: number, percent?: number, color: string } = { color: '#00e673' }
      if (tempoExecucaoSegundos < 3600) {
        consolidadoTempoExecucao.labelAbreviado = "min";
        consolidadoTempoExecucao.label = "minutos";
        consolidadoTempoExecucao.limite = 120;
        consolidadoTempoExecucao.tempo = App.Util.parseSegundosParaMinutos(tempoExecucaoSegundos);
        consolidadoTempoExecucao.percent = Math.round(consolidadoTempoExecucao.tempo * 100 / consolidadoTempoExecucao.limite)
        consolidadoTempoExecucao.color = consolidadoTempoExecucao.percent > 80 ? "#ff1a1a" : (consolidadoTempoExecucao.percent > 50 ? "#ffff00" : consolidadoTempoExecucao.color)
      } else {
        consolidadoTempoExecucao.labelAbreviado = "h";
        consolidadoTempoExecucao.label = "horas";
        consolidadoTempoExecucao.limite = 2;
        consolidadoTempoExecucao.tempo = App.Util.parseSegundosParaHoras(tempoExecucaoSegundos);
        consolidadoTempoExecucao.percent = Math.round(consolidadoTempoExecucao.tempo * 100 / consolidadoTempoExecucao.limite)
        consolidadoTempoExecucao.color = consolidadoTempoExecucao.percent > 80 ? "#ff1a1a" : (consolidadoTempoExecucao.percent > 50 ? "#ffff00" : consolidadoTempoExecucao.color)
      }

      return consolidadoTempoExecucao;
    }

    private getProgressoDinamico(valor: number, limite: number, label: string): { label?: string, limite?: number, valor?: number, percent?: number, color: string } {
      var consolidadoprogresso: { label?: string, limite?: number, valor?: number, percent?: number, color: string } = { color: '#00e673' }
      consolidadoprogresso.label = label;
      consolidadoprogresso.limite = limite;
      consolidadoprogresso.valor = valor;
      consolidadoprogresso.percent = Math.round(consolidadoprogresso.valor * 100 / consolidadoprogresso.limite)
      consolidadoprogresso.color = consolidadoprogresso.percent > 80 ? "#ff1a1a" : (consolidadoprogresso.percent > 50 ? "#ffff00" : consolidadoprogresso.color)

      return consolidadoprogresso;
    }

    private getConsolidadoLucro(valor: number, label: string): { label?: string, valor?: number, class: string, classIcon: string } {
      var consolidado: { label?: string, valor?: number, class: string, classIcon: string } = { class: 'text-default', classIcon: '' }
      consolidado.label = label;
      consolidado.valor = this.normalizarNumeroFinanceiro(valor);

      consolidado.class = consolidado.valor < 0 ? "text-danger" : (consolidado.valor > 0 ? "text-success" : consolidado.class)
      consolidado.classIcon = consolidado.valor < 0 ? "fa fa-arrow-down" : (consolidado.valor > 0 ? "fa fa-arrow-up" : consolidado.classIcon)

      return consolidado;
    }

    private normalizarNumeroFinanceiro(valor: any): number {
      if (typeof valor === "number") {
        return Number.isFinite(valor) ? valor : 0;
      }

      if (valor === null || valor === undefined) {
        return 0;
      }

      let texto = String(valor).trim();
      if (!texto) {
        return 0;
      }

      if (texto.indexOf(",") >= 0) {
        texto = texto.replace(/\./g, "").replace(",", ".");
      }

      const numero = Number(texto);
      if (Number.isFinite(numero)) {
        return numero;
      }

      const parseado = parseFloat(texto.replace(/[^\d.-]/g, ""));
      return Number.isFinite(parseado) ? parseado : 0;
    }

    private vincularConta(e: JQueryEventObject) {
      $("#modalAddConta").modal('hide')
      var credenciais: IDadosCredenciais = this.getCredenciaisConta();
      this.aoVincularConta(credenciais.email, (resposta: { id: number, status_conta: boolean, conta_encontrada_do_usuario: boolean, tem_espaco_vinculo: boolean }) => {
        console.log("aoVincularConta", resposta);
        // se é plano cloud e a conta ja existe do usuario mas está inutilizada, status=false
        if (this.infoPlanoAtual.ehPlanoCloud && resposta.conta_encontrada_do_usuario && !resposta.status_conta) {
          swal.fire({
            icon: 'warning',
            title: 'Conta EA já removida Anteriormente!',
            text: `A conta EA que você deseja adicionar no sistema já foi vinculada e removida/Inutilizada anteriormente, caso deseje voltar a utiliza-la, favor entrar em contato conosco pelo email: contato@futsniperweb.com.br`
          })
          return
        }

        // // se a conta não foi encontrada e não tem espaço para mais vinculos, avisar limite atingido
        // if (!resposta.conta_encontrada_do_usuario && !resposta.tem_espaco_vinculo) {
        //   swal.fire({
        //     icon: 'warning',
        //     title: 'Limite de Conta Atingido!',
        //     text: `Não há espaço para adicionar uma nova conta, exclua uma de suas contas atuais ou considere fazer um upgrade do seu plano para poder adicionar mais contas.`
        //   })
        //   return
        // }


        this.iniciarSessaoConta(null, credenciais, false, true)
      })
    }

    private vincularMultConta(e: JQueryEventObject) {
      $("#modalAddMultConta").modal('hide')
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_VINCULAR_MULT_CONTAS, this.getCredenciaisMultConta(), (response: IRespostaMensagem) => {
        //console.log("REAGENDAR", response)
      })
    }

    private acessarSniper(e: JQueryEventObject, navegadorVisivel: boolean = false, mostrarTelaWebApp: boolean = false) {
      var idConta = $(e.currentTarget).data('idContaEa');
      var credenciais = this.getCredenciaisConta(idConta);
      this.iniciarSessaoConta(idConta, credenciais, navegadorVisivel, false, mostrarTelaWebApp)
    }

    private pararTarefa(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Parando Tarefa...")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_PARAR_TAREFA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private atualizarExecucaoConta(idConta: number) {
      //console.log("atualizarExecucaoConta", idConta);
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_UPDATE_EXECUCAO_CONTA, { id: idConta });
    }

    private cancelarVendaCoins(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Cancelando...")
      //console.log("Cancelar venda", idConta, Util.ACAO_COMUNICACAO_CANCELAR_VENDA_COINS, { id: idConta })
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CANCELAR_VENDA_COINS, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private async atualizarContasByIdsContas(contasIds: number[]) {
      //console.log("DADOS", contasIds)
      if (!contasIds || !contasIds.length) {
        return
      }

      // semCache = true OBRIGATORIO: esta funcao roda logo depois de salvar perfil/agendamento/autodme,
      // e o plugin tem cache de perfil de 180s. Com cache, a acao 9 devolvia o perfil ANTERIOR e o
      // plugin REGRAVAVA o perfil velho no dbfs — desfazendo a alteracao que o usuario acabou de fazer
      // (era o que mantinha `hora_inicio`/`hora_fim` antigos e as contas fora do periodo).
      await this.atualizarContasNoPluginAposDadosAplicados(contasIds, true)

      this.avisarSobreReagendamentoPluginDesconectado()
    }

    private pararTarefaByModal(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_PARAR_TAREFA, { id: idConta }, (response: IRespostaMensagem) => {
        setTimeout(() => {
          let conta: IConta = response.result.conta
          $('.conteudo-loading-sniper-pro').modal('hide')
          this.atualizarEstadoModalSniper(conta.id, conta.status)
        }, 3000);
      });
    }

    private ativarEstadoConectado() {
    }

    private ativarEstadoDesconectado() {
    }

    private fecharSniper(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Fechando Conta...")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_FECHAR_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private executarVendaCoinsImediata(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Executar Venda de Coins")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_VENDER_COINS_NA_CONTA, id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private resolverCaptchaAutomaticamente(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Resolver Captcha Automaticamente")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_CAPTCHA_AUTOMATICAMENTE, id: idConta }, (response: IRespostaMensagem) => {
        console.log("resolverCaptchaAutomaticamente", idConta, response)
        this.ocultarLoadListConta(idConta)
      });
    }

    private atualizarInfoJogadoresClube(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.exibirLoadListConta(idConta, "Atualizando jogadores")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_ATUALIZAR_INFO_JOGADORES_CLUBE, id: idConta }, (response: IRespostaMensagem) => {
        //console.log("atualizarInfoJogadoresClube", response, response.status)
        if (response.status) {
          if (response.result && response.result.contaAtualizada) {
            this.updateContaDatatable(response.result.contaAtualizada);
            this.atualizarModalJogadoresContaSeAberto(response.result.contaAtualizada);
          }
          this.atualizarContaNoPlugin({ id: idConta }, (response: IRespostaMensagem) => {
            //console.log("ATUALIZAR NO PLUGIN::", response);
            if (response.status && response.result && response.result.contaAtualizada) {
              this.updateContaDatatable(response.result.contaAtualizada);
              this.atualizarModalJogadoresContaSeAberto(response.result.contaAtualizada);
            }
          })
        }
        this.ocultarLoadListConta(idConta)
      });
    }

    private htmlEscape(valor: any): string {
      return String(valor == null ? '' : valor)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    private isPlayerConta(item: IContaPlayerResumo): boolean {
      if (!item) {
        return false;
      }

      const itemType = item.itemType != null ? String(item.itemType).toLowerCase() : "";
      if (itemType) {
        return itemType == "player";
      }

      const nome = String(item.name || "").toLowerCase();
      return !/(sbc|upgrade|player pick|pack|provisions|league|daily|challenge|marquee matchups)/.test(nome);
    }

    private getItensConta(conta: IConta): IContaPlayerResumo[] {
      return conta && $.isArray(conta.players) ? conta.players : [];
    }

    private getPlayersConta(conta: IConta): IContaPlayerResumo[] {
      return this.getItensConta(conta).filter((item) => this.isPlayerConta(item));
    }

    private getResumoPlayersConta(conta: IConta) {
      const players = this.getPlayersConta(conta);
      const ratingNum = (player: IContaPlayerResumo) => {
        const n = Number(player && player.rating);
        return isNaN(n) ? 0 : n;
      };
      const topRating = players.slice().sort((a, b) => ratingNum(b) - ratingNum(a)).slice(0, 3);
      const negociaveis = players.filter((player) => !player.untradeable).length;
      const inegociaveis = players.filter((player) => player.untradeable).length;
      return { total: players.length, negociaveis, inegociaveis, topRating };
    }

    private formatarDataScanPlayersConta(conta: IConta): string {
      const valor = conta && (conta as any).players_scan_at ? String((conta as any).players_scan_at) : "";
      if (!valor) {
        return "Ultimo scan do clube: -";
      }

      const origem = conta && (conta as any).players_scan_origem ? String((conta as any).players_scan_origem) : "";
      const dataFormatada = this.formatarDataEstadoAutoDme(valor);
      return `Ultimo scan do clube: ${dataFormatada}${origem ? ` (${this.htmlEscape(origem)})` : ""}`;
    }

    private getMapaTextoOpcaoJogadoresConta(tipo: string): Record<string, string> {
      if (this.mapasTextoJogadoresConta && this.mapasTextoJogadoresConta[tipo]) {
        return this.mapasTextoJogadoresConta[tipo];
      }

      const seletores: Record<string, string> = {
        raridade: "select[name='rarity[]'] option, select[name='raridade[]'] option, select[name='excludeRarity'] option, select[name='excludeRarity[]'] option, #raridade option",
        liga: "select[name='league'] option, select[name='liga'] option, #liga option",
        nacao: "select[name='nation'] option, select[name='pais'] option, #pais option",
        time: "select[name='club'] option, select[name='time'] option, #time option",
      };
      const mapa: Record<string, string> = {};
      const seletor = seletores[tipo] || "";
      if (!seletor) {
        return mapa;
      }

      $(seletor).each((_, el) => {
        const option = $(el);
        const value = String(option.attr("value") || "").trim();
        const texto = String(option.text() || "").trim();
        if (value && value !== "0" && texto && !mapa[value]) {
          mapa[value] = texto;
        }
      });
      this.mapasTextoJogadoresConta[tipo] = mapa;
      return mapa;
    }

    private renderValorComNomeJogadoresConta(tipo: string, valor: any, type: string): string {
      if (valor === null || typeof valor === "undefined" || valor === "") {
        return "-";
      }

      const id = String(valor);
      const nome = this.getMapaTextoOpcaoJogadoresConta(tipo)[id] || "";
      if (type !== "display") {
        return nome || id;
      }

      const texto = nome ? `${nome} (#${id})` : `#${id}`;
      return `<span title="${this.htmlEscape(id)}">${this.htmlEscape(texto)}</span>`;
    }

    private normalizarArrayNumericoJogadoresConta(valor: any): number[] {
      if (Array.isArray(valor)) {
        return valor.map((x: any) => Number(x)).filter((n: number) => Number.isFinite(n));
      }
      if (valor === null || typeof valor === "undefined" || valor === "") {
        return [];
      }
      if (typeof valor === "string") {
        return valor.split(",").map((x: string) => Number(String(x).trim())).filter((n: number) => Number.isFinite(n));
      }
      const n = Number(valor);
      return Number.isFinite(n) ? [n] : [];
    }

    private montarExcludesAutoDmeJogadoresConta(conta: IConta) {
      const makeSet = () => new Set<number>();
      const out: any = {
        players: makeSet(),
        leagues: makeSet(),
        nations: makeSet(),
        teams: makeSet(),
        rarity: makeSet(),
        rating: makeSet(),
        totalRegras: 0,
      };
      const autodmes = conta && conta.perfil && conta.perfil.dados && $.isArray((conta.perfil.dados as any).autodmes)
        ? (conta.perfil.dados as any).autodmes
        : [];

      autodmes.forEach((cfg: any) => {
        [
          ["excludePlayers", out.players],
          ["excludeLeagues", out.leagues],
          ["excludeNations", out.nations],
          ["excludeTeams", out.teams],
          ["excludeRarity", out.rarity],
          ["excludeRating", out.rating],
        ].forEach(([key, set]: any[]) => {
          this.normalizarArrayNumericoJogadoresConta(cfg ? cfg[key] : []).forEach((id) => set.add(id));
        });
      });

      out.totalRegras = out.players.size + out.leagues.size + out.nations.size + out.teams.size + out.rarity.size + out.rating.size;
      return out;
    }

    private jogadorEstaExcluidoAutoDme(player: IContaPlayerResumo): boolean {
      const ex = this.excludesAutoDmeJogadoresContaAtual;
      if (!player || !ex || !ex.totalRegras) {
        return false;
      }

      const idsJogador = [
        Number(player.id),
        Number(player.assetId),
        Number(player.resourceId),
      ].filter((n) => Number.isFinite(n));

      if (idsJogador.some((id) => ex.players.has(id))) return true;
      if (ex.leagues.has(Number(player.leagueId))) return true;
      if (ex.nations.has(Number(player.nation))) return true;
      if (ex.teams.has(Number(player.teamid))) return true;
      if (ex.rarity.has(Number(player.rareflag))) return true;
      if (ex.rating.has(Number(player.rating))) return true;
      return false;
    }

    private jogadorEhEmprestimoOuTemporario(player: IContaPlayerResumo): boolean {
      if (!player) {
        return false;
      }

      const loansRaw = (player as any).loans;
      const loans = Number(loansRaw);
      if (loansRaw !== null && typeof loansRaw !== "undefined" && loans > 0) {
        return true;
      }

      const loanRaw = (player as any).loan;
      const loan = Number(loanRaw);
      if (loanRaw !== null && typeof loanRaw !== "undefined" && loan > 0) {
        return true;
      }

      const loanType = String((player as any).loanType || "").trim().toUpperCase();
      if (loanType && loanType !== "NONE") {
        return true;
      }

      return (player as any).jogadorTemporario === true || (player as any).temporary === true || (player as any).isTemporary === true;
    }

    private getQualidadeJogadorConta(player: IContaPlayerResumo): string {
      const rareflag = Number(player && player.rareflag);
      if (Number.isFinite(rareflag) && rareflag > 2) {
        return "especial";
      }

      const rating = Number(player && player.rating);
      if (!Number.isFinite(rating)) {
        return "";
      }
      if (rating < 65) {
        return "bronze";
      }
      if (rating < 75) {
        return "prata";
      }
      return "ouro";
    }

    private getLabelQualidadeJogadorConta(qualidade: string): string {
      const labels: Record<string, string> = {
        bronze: "Bronze",
        prata: "Prata",
        ouro: "Ouro",
        especial: "Especial",
      };
      return labels[qualidade] || qualidade;
    }

    private getContaModalJogadoresContaAtual(): IConta {
      const idConta = Number($('#modalJogadoresConta').data('idContaEa'));
      return idConta ? App.Util.getItemArrayById(this.arrayContas, idConta) : null;
    }

    private atualizarFiltrosJogadoresConta(players: IContaPlayerResumo[]) {
      const modal = $('#modalJogadoresConta');
      const filtros = modal.find('.js-modal-jogadores-conta-filtros');
      filtros.toggle(!!players.length);
      const filtroUsoAutoDme = modal.find('.js-filtro-jogador-conta[data-filtro="uso_autodme"]');
      const temExcludesAutoDme = !!(this.excludesAutoDmeJogadoresContaAtual && this.excludesAutoDmeJogadoresContaAtual.totalRegras > 0);
      const filtrosInicializados = modal.data('filtrosJogadoresContaInicializados') === true;
      const usoAtualRaw = String(filtroUsoAutoDme.val() || "");
      const usoAtual = usoAtualRaw || (!filtrosInicializados && temExcludesAutoDme ? "utilizaveis" : "");
      const playersBaseUsoAutoDme = players.filter((player) => !this.jogadorEhEmprestimoOuTemporario(player));
      const totalExcluidosAutoDme = temExcludesAutoDme ? playersBaseUsoAutoDme.filter((player) => this.jogadorEstaExcluidoAutoDme(player)).length : 0;
      const totalUtilizaveisAutoDme = Math.max(0, playersBaseUsoAutoDme.length - totalExcluidosAutoDme);
      filtroUsoAutoDme.empty()
        .append('<option value="">Todos</option>')
        .append(`<option value="utilizaveis">Utilizaveis (${totalUtilizaveisAutoDme})</option>`)
        .append(`<option value="excluidos">Excluidos (${totalExcluidosAutoDme})</option>`);
      if (usoAtual && ['utilizaveis', 'excluidos'].indexOf(usoAtual) !== -1) {
        filtroUsoAutoDme.val(usoAtual);
      }
      filtroUsoAutoDme.prop('disabled', !temExcludesAutoDme)
        .attr('title', temExcludesAutoDme ? 'Filtra usando os excludes configurados nos Auto DMEs do perfil desta conta.' : 'Esta conta nao tem excludes de Auto DME no perfil atual.');
      if (!temExcludesAutoDme) {
        filtroUsoAutoDme.val('');
      }

      const filtroTipoDme = modal.find('.js-filtro-jogador-conta[data-filtro="tipo_dme"]');
      const tipoDmeAtualRaw = String(filtroTipoDme.val() || "");
      const tipoDmeAtual = ['uteis', 'emprestimos_temporarios'].indexOf(tipoDmeAtualRaw) !== -1 ? tipoDmeAtualRaw : "uteis";
      const totalEmprestimosTemporarios = players.filter((player) => this.jogadorEhEmprestimoOuTemporario(player)).length;
      const totalUteisDme = Math.max(0, players.length - totalEmprestimosTemporarios);
      filtroTipoDme.empty()
        .append('<option value="">Todos</option>')
        .append(`<option value="uteis">Uteis DME (${totalUteisDme})</option>`)
        .append(`<option value="emprestimos_temporarios">Emprest./temp. (${totalEmprestimosTemporarios})</option>`);
      filtroTipoDme.val(tipoDmeAtual);

      const getValorAtual = (filtro: string) => String(modal.find(`.js-filtro-jogador-conta[data-filtro="${filtro}"]`).val() || "");
      const setOptions = (filtro: string, valores: Array<{ value: string, label: string }>, placeholder: string) => {
        const select = modal.find(`.js-filtro-jogador-conta[data-filtro="${filtro}"]`);
        const atual = getValorAtual(filtro);
        select.empty().append(`<option value="">${placeholder}</option>`);
        valores.forEach((item) => {
          select.append(`<option value="${this.htmlEscape(item.value)}">${this.htmlEscape(item.label)}</option>`);
        });
        if (atual && valores.some((item) => item.value === atual)) {
          select.val(atual);
        }
      };

      const contagensRating: Record<string, number> = {};
      const contagensQualidade: Record<string, number> = {};
      const contagensRaridade: Record<string, number> = {};
      const posicoes: Record<string, boolean> = {};
      const playersParaOpcoes = players.filter((player) => {
        const emprestimoOuTemporario = this.jogadorEhEmprestimoOuTemporario(player);
        if (tipoDmeAtual === "emprestimos_temporarios") return emprestimoOuTemporario;
        return !emprestimoOuTemporario;
      });
      playersParaOpcoes.forEach((player) => {
        const rating = player && player.rating != null ? String(player.rating) : "";
        const qualidade = this.getQualidadeJogadorConta(player);
        const raridade = player && player.rareflag != null ? String(player.rareflag) : "";
        const posicao = player && player.preferredPosition ? String(player.preferredPosition) : "";
        if (rating) contagensRating[rating] = (contagensRating[rating] || 0) + 1;
        if (qualidade) contagensQualidade[qualidade] = (contagensQualidade[qualidade] || 0) + 1;
        if (raridade) contagensRaridade[raridade] = (contagensRaridade[raridade] || 0) + 1;
        if (posicao) posicoes[posicao] = true;
      });

      setOptions("rating", Object.keys(contagensRating).sort((a, b) => Number(b) - Number(a)).map((rating) => ({
        value: rating,
        label: `${rating} (${contagensRating[rating]})`,
      })), "Todos");

      const ordemQualidade = ["bronze", "prata", "ouro", "especial"];
      setOptions("qualidade", ordemQualidade.filter((qualidade) => contagensQualidade[qualidade] > 0).map((qualidade) => ({
        value: qualidade,
        label: `${this.getLabelQualidadeJogadorConta(qualidade)} (${contagensQualidade[qualidade]})`,
      })), "Todas");

      const mapaRaridade = this.getMapaTextoOpcaoJogadoresConta("raridade");
      setOptions("raridade", Object.keys(contagensRaridade).sort((a, b) => {
        const ta = mapaRaridade[a] || a;
        const tb = mapaRaridade[b] || b;
        return ta.localeCompare(tb);
      }).map((raridade) => ({
        value: raridade,
        label: `${mapaRaridade[raridade] || "#" + raridade} (${contagensRaridade[raridade]})`,
      })), "Todas");

      setOptions("posicao", Object.keys(posicoes).sort().map((posicao) => ({ value: posicao, label: posicao })), "Todas");
      modal.data('filtrosJogadoresContaInicializados', true);
    }

    private registrarFiltroDataTableJogadoresConta() {
      if (this.filtroDataTableJogadoresContaRegistrado || !$.fn || !($.fn as any).dataTable) {
        return;
      }

      this.filtroDataTableJogadoresContaRegistrado = true;
      ($.fn as any).dataTable.ext.search.push((settings: any, data: any[], dataIndex: number, rowData: IContaPlayerResumo) => {
        if (!settings || !settings.nTable || settings.nTable.id !== "datatableJogadoresConta") {
          return true;
        }

        const modal = $('#modalJogadoresConta');
        const filtroRating = String(modal.find('.js-filtro-jogador-conta[data-filtro="rating"]').val() || "");
        const filtroQualidade = String(modal.find('.js-filtro-jogador-conta[data-filtro="qualidade"]').val() || "");
        const filtroNegociavel = String(modal.find('.js-filtro-jogador-conta[data-filtro="negociavel"]').val() || "");
        const filtroRaridade = String(modal.find('.js-filtro-jogador-conta[data-filtro="raridade"]').val() || "");
        const filtroPosicao = String(modal.find('.js-filtro-jogador-conta[data-filtro="posicao"]').val() || "");
        const filtroUsoAutoDme = String(modal.find('.js-filtro-jogador-conta[data-filtro="uso_autodme"]').val() || "");
        const filtroTipoDme = String(modal.find('.js-filtro-jogador-conta[data-filtro="tipo_dme"]').val() || "");
        const player: IContaPlayerResumo = rowData || (settings.aoData && settings.aoData[dataIndex] ? settings.aoData[dataIndex]._aData : null);
        if (!player) {
          return true;
        }

        if (filtroRating && String(player.rating) !== filtroRating) return false;
        if (filtroQualidade && this.getQualidadeJogadorConta(player) !== filtroQualidade) return false;
        if (filtroRaridade && String(player.rareflag) !== filtroRaridade) return false;
        if (filtroPosicao && String(player.preferredPosition || "") !== filtroPosicao) return false;
        if (filtroNegociavel === "negociavel" && !!player.untradeable) return false;
        if (filtroNegociavel === "inegociavel" && !player.untradeable) return false;
        if (filtroUsoAutoDme) {
          const excluidoAutoDme = this.jogadorEstaExcluidoAutoDme(player);
          if (filtroUsoAutoDme === "utilizaveis" && excluidoAutoDme) return false;
          if (filtroUsoAutoDme === "excluidos" && !excluidoAutoDme) return false;
        }
        if (filtroTipoDme) {
          const emprestimoOuTemporario = this.jogadorEhEmprestimoOuTemporario(player);
          if (filtroTipoDme === "uteis" && emprestimoOuTemporario) return false;
          if (filtroTipoDme === "emprestimos_temporarios" && !emprestimoOuTemporario) return false;
        }
        return true;
      });

      $(document).on('change', '#modalJogadoresConta .js-filtro-jogador-conta', (e) => {
        if (String($(e.currentTarget).data('filtro') || "") === "tipo_dme") {
          const conta = this.getContaModalJogadoresContaAtual();
          if (conta) {
            this.atualizarFiltrosJogadoresConta(this.getPlayersConta(conta));
          }
        }
        if (this.objDataTableJogadoresConta) {
          this.objDataTableJogadoresConta.draw();
        }
      });
      $(document).on('input keyup change', '#modalJogadoresConta .js-pesquisar-jogadores-conta', (e) => {
        if (this.objDataTableJogadoresConta) {
          this.objDataTableJogadoresConta.search(String($(e.currentTarget).val() || "")).draw();
        }
      });
      $(document).on('click', '#modalJogadoresConta .js-limpar-filtros-jogadores-conta', () => {
        $('#modalJogadoresConta .js-filtro-jogador-conta').val('');
        $('#modalJogadoresConta .js-filtro-jogador-conta[data-filtro="tipo_dme"]').val('uteis');
        $('#modalJogadoresConta .js-pesquisar-jogadores-conta').val('');
        const conta = this.getContaModalJogadoresContaAtual();
        if (conta) {
          this.atualizarFiltrosJogadoresConta(this.getPlayersConta(conta));
        }
        if (this.objDataTableJogadoresConta) {
          this.objDataTableJogadoresConta.search('').draw();
        }
      });
    }

    private renderResumoPlayersConta(conta: IConta): string {
      const resumo = this.getResumoPlayersConta(conta);
      if (!resumo.total) {
        return ``;
      }

      const topHtml = resumo.topRating.map((player: IContaPlayerResumo) => {
        return `<div><b>${this.htmlEscape(player.rating || '-')}</b> ${this.htmlEscape(player.name || '?')}</div>`;
      }).join('');
      const popover = `<div style="min-width: 190px;">
        <div><b>Total:</b> ${resumo.total}</div>
        <div><b>Neg.:</b> ${resumo.negociaveis} &nbsp; <b>Ineg.:</b> ${resumo.inegociaveis}</div>
        <hr style="margin: 4px 0;" />
        ${topHtml || '<div>-</div>'}
      </div>`;

      return `<button type="button" data-id-conta-ea="${conta.id}" class="btn btn-sm btn-link btn-info-jogadores-conta btn-ver-jogadores-conta mr-0" data-html="true"
        data-container="body" data-toggle="popover" data-color="default" data-placement="top"
        data-content='${popover}' data-original-title="" title="Jogadores"
        style="padding: 0px 2px 0px 2px;vertical-align: baseline;line-height: 10px;">
        <i class="fa-solid fa-users text-success" style="font-size: 10px;"></i>
        <span class="badge badge-success badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;">${resumo.total}</span>
      </button>`;
    }

    private aoVerJogadoresConta(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      var conta: IConta = App.Util.getItemArrayById(this.arrayContas, idConta);
      if (!conta) {
        return;
      }

      this.preencherModalJogadoresConta(conta);
      $('#modalJogadoresConta').modal('show');

      const players = this.getPlayersConta(conta);
      const contaAberta = conta.status == Util.STATUS_CONTA_ABERTA || conta.status == Util.STATUS_CONTA_PARADA;
      if (!players.length && contaAberta && this.conectado) {
        this.atualizarInfoJogadoresClube(e);
      }
    }

    private preencherModalJogadoresConta(conta: IConta) {
      const players = this.getPlayersConta(conta);
      const resumo = this.getResumoPlayersConta(conta);
      const itensOcultos = this.getItensConta(conta).length - players.length;
      const textoResumo = `${resumo.total} jogador(es) | ${resumo.negociaveis} negociavel(is) | ${resumo.inegociaveis} inegociavel(is)`;
      this.mapasTextoJogadoresConta = {};
      this.excludesAutoDmeJogadoresContaAtual = this.montarExcludesAutoDmeJogadoresConta(conta);
      $('#modalJogadoresConta').data('idContaEa', conta.id);
      $('#modalJogadoresConta').data('filtrosJogadoresContaInicializados', false);
      $('.js-modal-jogadores-conta-title').text(conta.dadosEa && conta.dadosEa.clubeName ? conta.dadosEa.clubeName : conta.email);
      $('.js-modal-jogadores-conta-subtitle').text(textoResumo + (itensOcultos > 0 ? ` | ${itensOcultos} item(ns) nao-player oculto(s)` : ""));
      $('.js-modal-jogadores-conta-scan').html(this.formatarDataScanPlayersConta(conta));
      $('.btn-modal-atualizar-jogadores-conta').attr('data-id-conta-ea', String(conta.id)).data('idContaEa', conta.id);
      $('#modalJogadoresContaEmpty').toggle(!players.length);
      $('#datatableJogadoresConta').closest('.table-responsive').toggle(!!players.length);
      this.atualizarFiltrosJogadoresConta(players);
      this.carregarTabelaJogadoresConta(players);
    }

    private atualizarModalJogadoresContaSeAberto(conta: IConta) {
      const modal = $('#modalJogadoresConta');
      if (!modal.hasClass('show')) {
        return;
      }

      if (Number(modal.data('idContaEa')) == Number(conta.id)) {
        this.preencherModalJogadoresConta(conta);
      }
    }

    private carregarTabelaJogadoresConta(players: IContaPlayerResumo[]) {
      this.registrarFiltroDataTableJogadoresConta();
      if (this.objDataTableJogadoresConta) {
        this.objDataTableJogadoresConta.clear();
        this.objDataTableJogadoresConta.rows.add(players);
        this.objDataTableJogadoresConta.draw();
        this.objDataTableJogadoresConta.columns.adjust();
        return;
      }

      this.objDataTableJogadoresConta = $('#datatableJogadoresConta').DataTable({
        data: players,
        language: { url: "/datatable-pt-br.json" },
        pageLength: 25,
        deferRender: true,
        searchDelay: 250,
        dom: 'lrtip',
        order: [[1, "desc"], [0, "asc"]],
        autoWidth: false,
        columns: [
          { data: 'name', render: (data) => this.htmlEscape(data || '-') },
          { data: 'rating', render: (data) => Number(data || 0) },
          { data: 'rareflag', render: (data, type) => this.renderValorComNomeJogadoresConta("raridade", data, type) },
          {
            data: 'untradeable',
            render: (data) => data ? '<span class="badge badge-warning">Inegociavel</span>' : '<span class="badge badge-success">Negociavel</span>'
          },
          { data: 'preferredPosition', render: (data) => this.htmlEscape(data || '-') },
          { data: 'leagueId', render: (data, type) => this.renderValorComNomeJogadoresConta("liga", data, type) },
          { data: 'nation', render: (data, type) => this.renderValorComNomeJogadoresConta("nacao", data, type) },
          { data: 'teamid', render: (data, type) => this.renderValorComNomeJogadoresConta("time", data, type) },
          { data: 'pile', render: (data) => this.htmlEscape(data || '-') },
          { data: 'discardValue', render: (data) => Number(data || 0) },
          { data: 'resourceId', render: (data) => this.htmlEscape(data || '-') },
          { data: 'assetId', render: (data) => this.htmlEscape(data || '-') },
        ]
      });
      App.Util.desabilitarAutocompleteDataTables($('#datatableJogadoresConta'));
    }

    private aoAtualizarAgenda(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.atualizarContaNoPlugin({ id: idConta, semCache: true })
      this.avisarSobreReagendamentoPluginDesconectado("O plugin está desconectado, para poder reagendar a conta, conecte ao plugin.")
    }

    private salvarCredenciais(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      var credenciais = this.getCredenciaisConta(idConta);
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CREDENCIAIS, credenciais, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Credenciais foram salvas", "Sucessso!");
          $(`#modalConfigCredenciais${idConta}`).modal('hide')
        }
      })
    }
    private salvarConfigGeral(e: JQueryEventObject) {
      var form = $(`#formConfiguracoesGeralBot`)
      App.Util.exibirLoadingFormModal($('.loading-form-modal'))
      if (this.usandoConfiguracaoGeralRemota()) {
        // Grava na configuração SELECIONADA (não na padrão) e sem tocar em `status`: salvar não pode
        // mudar quem usa o quê nem tirar do legado as VPS que não optaram.
        const selecionadaSalvar = this.getConfiguracaoProSelecionada();
        this.salvarOuAtualizarConfigRemota(true, selecionadaSalvar ? selecionadaSalvar.id : null, (objRepostaAtualizacaoConfigRemota: IRespostaAjaxPostAcao) => {
          App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
          console.log("objRepostaAtualizacaoConfigRemota", objRepostaAtualizacaoConfigRemota);
          if (objRepostaAtualizacaoConfigRemota && objRepostaAtualizacaoConfigRemota.status == "success") {
            toastr.success("Configurações foram salvas", "Sucessso!");
            form.parents('.modal').modal('hide')
            if (objRepostaAtualizacaoConfigRemota.dadosRetornados) {
              const configRemotaRetornada: any = this.removerCamposServidorLocalConfigGeral(objRepostaAtualizacaoConfigRemota.dadosRetornados.dados || {});
              this.configuracoesGeraisExecucao = $.extend(true, {}, this.configuracoesGeraisExecucao || {}, configRemotaRetornada);
              const configAplicarPlugin: any = $.extend(true, {}, configRemotaRetornada);
              configAplicarPlugin.usuario_email = this.getUsuarioEmailConfig();
              this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SALVAR_CONFIG_GERAL, configAplicarPlugin, () => { });
              if (!this.configuracoesGeraisExecucao.exibir_cronometro) {
                $.each(App.Business.cronometros, (index: any, id: number) => {
                  Util.pararCronometroMult(App.Business.cronometros[id]);
                });
              }
            }
          }
        })
      } else {
        var dadosForm: IConfiguracoesGeraisExecucao = this.ajax.convertFormAninhadoToJSON(form);
        dadosForm.prioridade_tarefas_automaticas = this.normalizarPrioridadeTarefasAutomaticas(dadosForm);
        this.normalizarConfiguracaoAutoDmeGeral(dadosForm, this.getConfiguracaoAutoDmeAtual());
        (dadosForm as any).usuario_email = this.getUsuarioEmailConfig();
        //console.log("DDDD", dadosForm)
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SALVAR_CONFIG_GERAL, dadosForm, (response: IRespostaMensagem) => {
          App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
          if (response && response.status) {
            toastr.success("Configurações foram salvas", "Sucessso!");
            form.parents('.modal').modal('hide')
            if (response.result && response.result.configuracao) {
              this.configuracoesGeraisExecucao = response.result.configuracao
              if (response.result.proxy_server) {
                this.salvarProxyServidor(response.result.proxy_server);
              }
              if (!this.configuracoesGeraisExecucao.exibir_cronometro) {
                $.each(App.Business.cronometros, (index: any, id: number) => {
                  Util.pararCronometroMult(App.Business.cronometros[id]);
                });
              }
            }
          }
        })
      }
    }

    private salvarConfigServidor(e: JQueryEventObject) {
      if (e) {
        e.preventDefault();
      }

      const form = $("#formConfigServidor");
      App.Util.exibirLoadingFormModal(form.find(".loading-form-modal"));

      const dadosServidor: any = this.ajax.convertFormAninhadoToJSON(form);
      const dadosForm: any = $.extend(true, {}, this.configuracoesGeraisExecucao || {});

      dadosForm.ativar_proxy_server = form.find("input[name=ativar_proxy_server]").is(":checked");
      dadosForm.proxy_server_port = this.normalizarProxyServerPortConfig(form.find("input[name=proxy_server_port]").val(), this.getProxyServerPortConfig());
      dadosForm.usar_chrome_default = form.find("input[name=usar_chrome_default]").is(":checked");
      dadosForm.reiniciar_plugin_monitor_sniper = form.find("input[name=reiniciar_plugin_monitor_sniper]").is(":checked");
      dadosForm.configuracao_auto_dme = $.extend(true, {}, dadosForm.configuracao_auto_dme || {}, dadosServidor.configuracao_auto_dme || {});

      this.normalizarConfiguracaoAutoDmeGeral(dadosForm, this.getConfiguracaoAutoDmeAtual());
      dadosForm.usuario_email = this.getUsuarioEmailConfig();

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SALVAR_CONFIG_GERAL, dadosForm, (response: IRespostaMensagem) => {
        App.Util.ocultarLoadingFormModal(form.find(".loading-form-modal"));
        if (!response || !response.status) {
          toastr.error("Nao foi possivel salvar as configuracoes deste servidor.", "Config Servidor");
          return;
        }

        toastr.success("Configuracoes deste servidor foram salvas.", "Config Servidor");
        form.parents(".modal").modal("hide");

        if (response.result && response.result.configuracao) {
          this.configuracoesGeraisExecucao = response.result.configuracao;
          this.preencherConfiguracaoServidor(response.result.configuracao);
          if (response.result.proxy_server) {
            this.salvarProxyServidor(response.result.proxy_server);
          }
        }
      });
    }

    private atualizarContasVinculadasNoPlugin() {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATUALIZAR_CONTAS_VINCULADAS, this.getIdsContasEaVinculadas())
    }

    private teste(e: JQueryEventObject) {
      //console.log("TESTE", App.Business.dadosTeste)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_TESTE, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        console.log("TESTE", response)
        if (response.status) {
          toastr.success(response.status, "Sucessso!");
        }
      })
    }

    private getPluginServerUrl(path: string): string {
      const base = (this.pluginServerBaseUrl || "http://localhost:5033").replace(/\/$/, "");
      return base + path;
    }

    private nomeFontePrecoExterno(source: string): string {
      const nomes: any = {
        futbin: "Futbin",
        futgg: "FutGG",
        ftwiz: "FutWiz",
        futnext: "FutNext",
      };
      return nomes[source] || source || "Fonte externa";
    }

    // Fluxo "Resolver Cloudflare" manual (Chrome real da VPS + preview /bw-view + endpoints
    // /api/external-browser-challenge/*) REMOVIDO: o Cloudflare agora é resolvido automaticamente
    // na aba do Chrome da própria conta (fluxo conta_browser no plugin-server).

    // ── Ícone de status dos últimos bloqueios por fonte (Cloudflare/429) ──────────
    private iniciarMonitorBloqueiosFontes() {
      if (!this.elBtnBloqueiosFontes.length) {
        return;
      }
      this.atualizarBloqueiosFontes();
      if (this.intervaloBloqueiosFontes) {
        return;
      }
      this.intervaloBloqueiosFontes = window.setInterval(() => {
        this.atualizarBloqueiosFontes();
      }, 30000);
    }

    private atualizarBloqueiosFontes() {
      if (!this.elBtnBloqueiosFontes.length) {
        return;
      }
      if (!this.pluginLigado) {
        $("#li-bloqueios-fontes").hide();
        return;
      }
      $.ajax({
        url: this.getPluginServerUrl("/api/prices/source-blocks"),
        method: "GET",
        dataType: "json",
        timeout: 3000,
      }).done((resp: any) => {
        this.renderizarBloqueiosFontes(resp && $.isArray(resp.blocks) ? resp.blocks : []);
      }).fail(() => {
        $("#li-bloqueios-fontes").hide();
      });
    }

    private nomeMotivoBloqueio(reason: string): string {
      if (reason === "cloudflare_hard_block") return "Bloqueio Permanente";
      if (reason === "http_429") return "Bloqueio Cloudflare (429)";
      return "Bloqueio Cloudflare";
    }

    private formatarDataBloqueio(ts: number): string {
      const n = Number(ts);
      if (!n) return "-";
      const d = new Date(n);
      const p = (v: number) => (v < 10 ? "0" + v : String(v));
      return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
    }

    private renderizarBloqueiosFontes(blocks: any[]) {
      const li = $("#li-bloqueios-fontes");
      if (!blocks || !blocks.length) {
        li.hide();
        return;
      }
      const nomeFonte: any = { futbin: "Futbin", futgg: "FutGG", ftwiz: "FutWiz", futnext: "FutNext" };
      let algumAtivo = false;
      const linhas = blocks.map((b: any) => {
        const resolvido = !!b.resolved && !b.ativo;
        if (!resolvido) algumAtivo = true;
        const nome = nomeFonte[b.source] || b.source || "Fonte";
        const motivo = this.nomeMotivoBloqueio(b.reason);
        const quando = this.formatarDataBloqueio(b.blockedAt);
        const statusTxt = resolvido
          ? '<span class="text-success">Resolvido</span>'
          : '<span class="text-danger">Nao resolvido</span>';
        return `<div style="white-space: nowrap;"><b>${nome}</b>: ${motivo}, ${quando} - ${statusTxt}</div>`;
      }).join("");

      this.elBtnBloqueiosFontes
        .removeClass("text-muted text-danger text-success")
        .addClass(algumAtivo ? "text-danger" : "text-success")
        .attr("data-content", linhas);

      if (!this.popoverBloqueiosInit) {
        (this.elBtnBloqueiosFontes as any).popover({
          html: true,
          trigger: "focus",
          placement: "bottom",
          title: "Últimos bloqueios das fontes",
          content: () => (this.elBtnBloqueiosFontes.attr("data-content") || ""),
        });
        this.popoverBloqueiosInit = true;
      }
      li.show();
    }

    private preencherContasTestePrecoExterno() {
      const select = $("#testePrecoExternoConta");
      select.empty();
      select.append(`<option value="">Primeira disponível</option>`);
      (this.arrayContas || []).forEach((conta: IConta) => {
        const dadosEa: any = (conta as any).dadosEa || {};
        const nome = dadosEa.clubeName || conta.email || `Conta ${conta.id}`;
        select.append(`<option value="${conta.id}">${conta.id} - ${nome}</option>`);
      });
    }

    /**
     * Busca jogador de conceito no MESMO catalogo que serve o solver
     * (storage/app/concepts, via /api/jogador/concept-players). Antes isto baixava
     * public/concepts.json inteiro — 1,8 MB gzip / 25 MB parseados em memoria — so para filtrar
     * no cliente, e obrigava a manter DOIS arquivos de conceito em lugares diferentes.
     * A busca por nome roda contra o mapa de nomes do indice: ~5ms no servidor, sem ler o disco.
     */
    private buscarConceitosTestePrecoExterno(termo: string): any {
      return $.getJSON("/api/jogador/concept-players", {
        q: termo,
        ordem: "rating_desc",
        perPage: 30,
        page: 1,
      }).then((resposta: any) => {
        const lista = resposta && $.isArray(resposta.data) ? resposta.data : [];
        return lista.map((jogador: any) => this.montarItemSelectJogadorTestePrecoExterno(jogador));
      });
    }

    private primeiroValorTestePrecoExterno(obj: any, campos: string[]): any {
      for (let i = 0; i < campos.length; i++) {
        const campo = campos[i];
        if (obj && Object.prototype.hasOwnProperty.call(obj, campo) && obj[campo] !== null && typeof obj[campo] !== "undefined" && obj[campo] !== "") {
          return obj[campo];
        }
      }
      return "";
    }

    private normalizarPosicaoTestePrecoExterno(valor: any): string {
      if (valor === null || typeof valor === "undefined" || valor === "") {
        return "";
      }
      const texto = String(valor);
      if (isNaN(Number(texto))) {
        return texto;
      }
      const mapa: any = {
        0: "GK", 1: "SW", 2: "RWB", 3: "RB", 4: "RCB", 5: "CB", 6: "LCB", 7: "LB", 8: "LWB",
        9: "RDM", 10: "CDM", 11: "LDM", 12: "RM", 13: "RCM", 14: "CM", 15: "LCM", 16: "LM",
        17: "RAM", 18: "CAM", 19: "LAM", 20: "RF", 21: "CF", 22: "LF", 23: "RW", 24: "RS",
        25: "ST", 26: "LS", 27: "LW",
      };
      return mapa[Number(texto)] || texto;
    }

    private montarUrlFutnextTestePrecoExterno(tipo: string, id: any): string {
      if (!id) {
        return "";
      }
      const pathTipo: any = {
        player: "player",
        nation: "nation",
        club: "club",
        league: "league",
        rarity: "rarity",
      };
      const nomeArquivo = tipo === "rarity" ? `e_${id}_0` : id;
      return `https://cdn.futnext.com/${pathTipo[tipo]}/${nomeArquivo}.png`;
    }

    private montarItemSelectJogadorTestePrecoExterno(jogador: any): any {
      const definitionId = this.primeiroValorTestePrecoExterno(jogador, ["definitionId", "resourceId", "id", "assetId"]);
      const assetId = this.primeiroValorTestePrecoExterno(jogador, ["assetId", "resourceId", "definitionId", "id"]);
      const rating = jogador.rating ? String(jogador.rating) : "-";
      const rareflag = this.primeiroValorTestePrecoExterno(jogador, ["rarityId", "rareflag", "cardsubtypeid"]);
      const ratingTier = this.primeiroValorTestePrecoExterno(jogador, ["ratingTier", "tier"]);
      const cardType = jogador.cardType || (rareflag !== "" ? `Rareflag ${rareflag}` : "-");
      const name = jogador.name || "Jogador sem nome";
      const teamId = this.primeiroValorTestePrecoExterno(jogador, ["teamId", "teamid", "clubId", "normalizeClubId"]);
      const nationId = this.primeiroValorTestePrecoExterno(jogador, ["nationId", "nation", "nationid"]);
      const leagueId = this.primeiroValorTestePrecoExterno(jogador, ["leagueId", "leagueid"]);
      const teamName = this.primeiroValorTestePrecoExterno(jogador, ["teamName", "clubName", "club_name", "team_name", "nomeClube", "nome_clube"]) || "Clube";
      const nationName = this.primeiroValorTestePrecoExterno(jogador, ["nationName", "nation_name", "countryName", "country_name", "nationalityName", "nomePais", "nome_pais"]) || "Pais";
      const leagueName = this.primeiroValorTestePrecoExterno(jogador, ["leagueName", "league_name", "nomeLiga", "nome_liga"]) || "Liga";
      const preferredPositionRaw = this.primeiroValorTestePrecoExterno(jogador, ["preferredPosition", "preferredPositionName"]);
      const preferredPosition = this.normalizarPosicaoTestePrecoExterno(preferredPositionRaw);
      const price = this.primeiroValorTestePrecoExterno(jogador, ["price", "futggPrice"]);
      return {
        id: String(definitionId),
        text: `${name} (${preferredPosition || rating}) - ${cardType} #${definitionId}`,
        name,
        assetId: String(assetId || definitionId),
        definitionId: String(definitionId),
        rating,
        cardType,
        teamId,
        nationId,
        leagueId,
        teamName,
        nationName,
        leagueName,
        rareflag,
        ratingTier,
        preferredPosition,
        price,
        playerImgUrl: this.montarUrlFutnextTestePrecoExterno("player", assetId || definitionId),
        nationImgUrl: this.montarUrlFutnextTestePrecoExterno("nation", nationId),
        clubImgUrl: this.montarUrlFutnextTestePrecoExterno("club", teamId),
        leagueImgUrl: this.montarUrlFutnextTestePrecoExterno("league", leagueId),
        rarityImgUrl: this.montarUrlFutnextTestePrecoExterno("rarity", rareflag),
      };
    }

    private inicializarSelectJogadorTestePrecoExterno() {
      const select = $("#testePrecoExternoJogadorSelect");
      if (!select.length || select.data("select2")) {
        return;
      }

      this.objSelect2.inicializarCampo(select, {
        dropdownParent: $("#modalTestePrecoExterno"),
        placeholder: "Digite ao menos 3 letras do nome",
        allowClear: true,
        // 3 caracteres + 500ms de debounce: cada tecla agora custa uma requisicao ao servidor
        // (antes era filtro local sobre um arquivo ja baixado), entao vale esperar o usuario
        // terminar de digitar em vez de disparar busca a cada letra.
        minimumInputLength: 3,
        ajax: {
          delay: 500,
          transport: (params: any, success: any, failure: any) => {
            const termo = params && params.data ? (params.data.term || params.data.q || "") : "";
            let requisicao: any = null;
            if (String(termo).trim().length < 3) {
              success({ results: [] });
            } else {
              requisicao = this.buscarConceitosTestePrecoExterno(String(termo).trim());
              requisicao.then((resultados: any[]) => {
                success({ results: resultados });
              }, (erro: any) => {
                failure(erro);
              });
            }
            return {
              // Cancela a busca anterior quando o usuario continua digitando.
              abort: () => {
                if (requisicao && typeof requisicao.abort === "function") {
                  try { requisicao.abort(); } catch (_e) { /* jqXHR ja finalizado */ }
                }
              },
            };
          },
        },
        templateResult: (item: any) => {
          if (item.loading) {
            return item.text;
          }
          return this.montarCardSelectJogadorTestePrecoExterno(item);
        },
        templateSelection: (item: any) => {
          if (!item || !item.name) {
            return item && item.text ? item.text : "";
          }
          return this.montarCardSelectJogadorTestePrecoExterno(item, true);
        },
      });

      select.on("select2:select", (e: any) => {
        const item = e && e.params ? e.params.data : null;
        if (!item) {
          return;
        }
        $("#testePrecoExternoIdJogador").val(item.definitionId || item.id || "");
        $("#testePrecoExternoNomeJogador").val(item.name || "");
        $("#testePrecoEaRareflag").val(typeof item.rareflag !== "undefined" ? item.rareflag : "");
        $("#testePrecoEaTeamId").val(item.teamId || "");
        $("#testePrecoEaNomePosicao").val(item.preferredPosition || "");
        const precoAtual = String($("#testePrecoEaPrecoConhecido").val() || "");
        if ((!precoAtual || precoAtual === "0") && item.price) {
          $("#testePrecoEaPrecoConhecido").val(item.price);
        }
      });
    }

    private montarCardSelectJogadorTestePrecoExterno(item: any, selecionado: boolean = false): JQuery {
      const container = $("<div/>")
        .addClass("teste-preco-player-card")
        .toggleClass("teste-preco-player-card-selected", selecionado);
      const thumb = $("<div/>")
        .addClass("teste-preco-player-thumb")
        .css("background-image", item.rarityImgUrl ? `url(${item.rarityImgUrl})` : "")
        .appendTo(container);

      const addMetaIcon = (url: string, titleText: string, meta: JQuery) => {
        if (!url) return;
        $("<img/>")
          .addClass("teste-preco-player-meta-icon")
          .attr("src", url)
          .attr("alt", titleText)
          .attr("title", titleText)
          .on("error", function () { $(this).remove(); })
          .appendTo(meta);
      };

      const fallback = $("<span/>")
        .addClass("teste-preco-player-fallback")
        .text(String(item.name || "?").substring(0, 1).toUpperCase())
        .appendTo(thumb);

      if (item.playerImgUrl) {
        fallback.hide();
        $("<img/>")
          .addClass("teste-preco-player-photo")
          .attr("src", item.playerImgUrl)
          .attr("alt", item.name || "Jogador")
          .on("error", function () {
            $(this).remove();
            fallback.show();
          })
          .appendTo(thumb);
      }

      const body = $("<div/>").addClass("teste-preco-player-body").appendTo(container);
      const title = $("<div/>").addClass("teste-preco-player-title").appendTo(body);
      $("<span/>").addClass("teste-preco-player-name").text(item.name || item.text || "Jogador").appendTo(title);
      if (item.preferredPosition) {
        $("<span/>").addClass("teste-preco-player-position").text(item.preferredPosition).appendTo(title);
      }

      const meta = $("<div/>").addClass("teste-preco-player-meta").appendTo(body);
      $("<span/>").addClass("teste-preco-player-id").text(`#${item.definitionId || item.id || "-"}`).appendTo(meta);
      addMetaIcon(item.clubImgUrl, item.teamName || "Clube", meta);
      addMetaIcon(item.nationImgUrl, item.nationName || "Pais", meta);
      addMetaIcon(item.leagueImgUrl, item.leagueName || "Liga", meta);

      const side = $("<div/>").addClass("teste-preco-player-side").appendTo(container);
      const rarityRow = $("<span/>").addClass("teste-preco-player-rarity-row").appendTo(side);
      $("<span/>").addClass("teste-preco-player-rarity").text(item.cardType || `Rareflag ${item.rareflag || "-"}`).appendTo(rarityRow);
      if (item.rarityImgUrl) {
        $("<img/>")
          .addClass("teste-preco-player-rarity-img")
          .attr("src", item.rarityImgUrl)
          .attr("alt", "Raridade")
          .attr("title", item.cardType || "Raridade")
          .on("error", function () { $(this).remove(); })
          .appendTo(rarityRow);
      }
      if (Number(item.price || 0) > 0) {
        $("<span/>").addClass("teste-preco-player-price").text(this.formatarPrecoTestePrecoExterno(item.price)).appendTo(side);
      }
      $("<span/>")
        .addClass("teste-preco-player-rating")
        .text(item.rating || "-")
        .appendTo(container);

      return container;
    }

    private abrirModalTestePrecoExterno(e: JQueryEventObject) {
      e.preventDefault();
      this.preencherContasTestePrecoExterno();
      this.inicializarSelectJogadorTestePrecoExterno();
      const idDefault = $(e.currentTarget).data("dados");
      if (idDefault) {
        $("#testePrecoExternoIdJogador").val(idDefault);
      }
      $("#testePrecoExternoJogadorSelect").val(null).trigger("change");
      $("#testePrecoExternoModo").val("externo");
      $("#testePrecoExternoFontes input[name=fontes_preco]").prop("checked", false);
      $("#testePrecoExternoFontes input[value=futbin]").prop("checked", true);
      $("#testePrecoEaMotorInteligente").prop("checked", false);
      $("#testePrecoEaMinimoVenda").val("3");
      $("#testePrecoEaMinimoCompra").val("3");
      $("#testePrecoEaSuspeitoVenda").val("30");
      $("#testePrecoEaSuspeitoCompra").val("50");
      $("#testePrecoExternoForcarChromeReal").prop("checked", false);
      $("#testePrecoExternoPularCache").prop("checked", false).prop("disabled", false);
      $("#testePrecoExternoIgnorarBloqueio").prop("checked", false);
      $("#testePrecoExternoLogHumano")
        .addClass("d-none")
        .html("");
      $("#testePrecoExternoEstadoInicial").removeClass("d-none");
      $("#testePrecoExternoToggleTecnico").addClass("d-none").text("Log tecnico");
      $("#testePrecoExternoLogTecnico").addClass("d-none");
      $("#testePrecoExternoResultado").text("");
      this.atualizarModoTestePrecoExterno();
      $("#modalTestePrecoExterno").modal("show");
    }

    private alternarLogTecnicoTestePrecoExterno() {
      const logTecnico = $("#testePrecoExternoLogTecnico");
      const visivel = !logTecnico.hasClass("d-none");
      logTecnico.toggleClass("d-none", visivel);
      $("#testePrecoExternoToggleTecnico").text(visivel ? "Log tecnico" : "Ocultar tecnico");
    }

    private escaparHtmlTestePrecoExterno(valor: any): string {
      if (valor === null || typeof valor === "undefined") {
        return "";
      }
      return $("<div/>").text(String(valor)).html();
    }

    private formatarPrecoTestePrecoExterno(valor: any): string {
      const numero = Number(valor || 0);
      if (!numero || isNaN(numero)) {
        return "0";
      }
      return numero.toLocaleString("pt-BR");
    }

    private obterResumoTestePrecoExterno(result: any, payload: any, sucesso: boolean): any {
      const modoTeste = String(result.modo_teste || payload.modo_teste || "externo");
      const ehTesteEa = modoTeste === "ea";
      const resposta = result && result.resposta ? result.resposta : {};
      const dadosPreco = resposta && resposta.response ? resposta.response : {};
      const diagnostico = result && result.diagnostico ? result.diagnostico : {};
      const requisicoes = diagnostico && $.isArray(diagnostico.requisicoes) ? diagnostico.requisicoes : [];
      const preco = result && typeof result.preco !== "undefined" ? result.preco : (ehTesteEa ? resposta.buyNowPrice : dadosPreco.preco);
      const precoEncontrado = Number(preco || 0) > 0;
      const fontesPayload = payload && $.isArray(payload.fontes_preco) ? payload.fontes_preco.join(", ") : "";
      const modo = result.modo || diagnostico.modo || "desconhecido";
      const modoLabel: any = {
        cache: "Cache",
        extensao: "Extensao",
        conta_browser: "Conta (Cloudflare)",
        chrome_real: "Chrome real",
        zyte: "Zyte",
        zyte_api: "Zyte",
        ea: "EA",
        desconhecido: "Desconhecido",
      };
      const conta = result && result.conta ? result.conta : {};
      const contaTexto = conta.email ? conta.email : (conta.id ? String(conta.id) : "Primeira disponivel");
      const clubeTexto = conta.clube ? " / " + conta.clube : "";
      const titulo = precoEncontrado ? "Preco encontrado" : (sucesso ? "Teste executado sem preco" : "Falha no teste");
      const mensagem = result.mensagem || (sucesso ? "Teste executado." : "Nao foi possivel executar o teste.");
      const jogador = result.nomeJogador || payload.nomeJogador || dadosPreco.nome || "Jogador nao informado";
      const idJogador = resposta.resourceId || dadosPreco.id || result.idJogador || payload.idJogador || "-";
      const fonte = ehTesteEa ? "EA Transfer Market" : (result.fonte_preco_label || resposta.fonte_preco_label || resposta.fonte_preco || resposta.fonte || result.fonte || fontesPayload || "-");
      const atualizado = dadosPreco.ultimaAtualizacao || "-";
      const motorEa = ehTesteEa
        ? (resposta.motor_preco_ea || (payload.usar_motor_preco_ea_inteligente ? "inteligente" : "classico"))
        : "-";
      const regrasEa = ehTesteEa
        ? "Venda min " + (resposta.quantidade_minima_preco || payload.preco_de_venda_ea_minimo_cartas || 3)
        + " / Susp. venda " + (payload.preco_de_venda_ea_percentual_suspeito || 30) + "%"
        + " / Compra min " + (payload.preco_de_compra_ea_minimo_cartas || 3)
        + " / Susp. compra " + (payload.preco_de_compra_ea_percentual_suspeito || 50) + "%"
        : "-";

      return {
        titulo,
        mensagem,
        tipo: ehTesteEa ? "Preco EA" : "Preco externo",
        jogador,
        idJogador,
        preco,
        precoFormatado: this.formatarPrecoTestePrecoExterno(preco),
        precoEncontrado,
        fonte,
        modo: modoLabel[modo] || modo,
        cache: payload.ignorarCachePreco ? "Pulou cache" : "Normal",
        plataforma: ehTesteEa ? "-" : (payload.platform || "-"),
        conta: contaTexto + clubeTexto,
        requisicoes: String(requisicoes.length),
        atualizado,
        motorEa,
        regrasEa,
      };
    }

    private montarLogHumanoTestePrecoExterno(result: any, payload: any, sucesso: boolean): string {
      const resumo = this.obterResumoTestePrecoExterno(result, payload, sucesso);
      const classe = resumo.precoEncontrado ? "success" : "warning";
      const item = (label: string, valor: any) => {
        return "<div class=\"teste-preco-log-item\"><span class=\"teste-preco-log-label\">" + this.escaparHtmlTestePrecoExterno(label) + "</span><strong>" + this.escaparHtmlTestePrecoExterno(valor) + "</strong></div>";
      };
      const itensResumo = [
        item("Tipo", resumo.tipo),
        item("Jogador", resumo.jogador),
        item("ResourceId", resumo.idJogador),
        item("Fonte", resumo.fonte),
        item("Modo usado", resumo.modo),
      ];
      if (payload && payload.modo_teste === "ea") {
        itensResumo.push(item("Motor EA", resumo.motorEa));
        itensResumo.push(item("Regras EA", resumo.regrasEa));
      }
      itensResumo.push(
        item("Cache", resumo.cache),
        item("Conta", resumo.conta),
        item("Plataforma", resumo.plataforma),
        item("Requisicoes externas", resumo.requisicoes),
        item("Atualizacao", resumo.atualizado),
      );

      return [
        "<div class=\"teste-preco-result-head " + classe + "\">",
        "<div class=\"d-flex align-items-start justify-content-between\">",
        "<div>",
        "<strong>" + this.escaparHtmlTestePrecoExterno(resumo.titulo) + "</strong>",
        "<div class=\"small mt-1\">" + this.escaparHtmlTestePrecoExterno(resumo.mensagem) + "</div>",
        "</div>",
        "<div class=\"text-right ml-3\">",
        "<span class=\"teste-preco-log-label\">Preco</span>",
        "<div class=\"teste-preco-price\">" + this.escaparHtmlTestePrecoExterno(resumo.precoFormatado) + "</div>",
        "</div>",
        "</div>",
        "</div>",
        "<div class=\"teste-preco-log-grid\">",
        itensResumo.join(""),
        "</div>",
      ].join("");
    }

    private atualizarToggleZyteApiTestePrecoExterno() {
      const ativo = $("#testePrecoExternoZyteApi").is(":checked");
      $("#testePrecoExternoZyteApiKey")
        .attr("type", "text")
        .attr("autocomplete", "off")
        .attr("autocorrect", "off")
        .attr("autocapitalize", "off")
        .attr("spellcheck", "false")
        .attr("data-lpignore", "true")
        .attr("data-1p-ignore", "true")
        .attr("data-form-type", "other")
        .prop("disabled", false)
        .attr("placeholder", ativo ? "Informe a Zyte API Key" : "Chave salva; so sera usada com Zyte API ativo");
    }

    private atualizarPularCacheTestePrecoExterno() {
      const modoTeste = String($("#testePrecoExternoModo").val() || "externo");
      const forcarChromeReal = modoTeste === "externo" && $("#testePrecoExternoForcarChromeReal").is(":checked");
      const pularCache = $("#testePrecoExternoPularCache");
      if (forcarChromeReal) {
        pularCache.prop("checked", true).prop("disabled", true);
      } else {
        pularCache.prop("disabled", false);
      }
    }

    private atualizarModoTestePrecoExterno() {
      const modoTeste = String($("#testePrecoExternoModo").val() || "externo");
      const ehEa = modoTeste === "ea";
      const ehFsw = modoTeste === "fsw";
      // Fontes externas, "forcar aba" e "ignorar bloqueio" so existem no fluxo externo.
      $(".js-teste-preco-externo-campos").toggleClass("d-none", ehEa || ehFsw);
      $(".js-teste-preco-ea-campos").toggleClass("d-none", !ehEa);
      // Plataforma vale p/ externo E p/ FSW: o cache central e por plataforma.
      $(".js-teste-preco-plataforma").toggleClass("d-none", ehEa);
      // FSW le o banco do proprio site: nao usa conta, extensao, nome do jogador nem cache local.
      $(".js-teste-preco-nao-fsw").toggleClass("d-none", ehFsw);
      this.atualizarPularCacheTestePrecoExterno();
    }

    /** O detalhe do diagnostico FSW referente ao jogador pedido. */
    private obterDetalheTestePrecoFsw(result: any, idJogador: string): any {
      const diag = result && result.diagnostico ? result.diagnostico : null;
      const detalhes = diag && $.isArray(diag.detalhes) ? diag.detalhes : [];
      for (let i = 0; i < detalhes.length; i++) {
        if (String(detalhes[i].resourceId) === String(idJogador)) {
          return detalhes[i];
        }
      }
      return detalhes.length ? detalhes[0] : null;
    }

    /**
     * Preco que o cache central REALMENTE serviria a um plugin agora. Diferente do preco
     * guardado na linha: em quarentena ou fora da janela de idade a linha existe mas o id volta
     * como faltando — e essa diferenca e justamente o que o teste precisa mostrar.
     */
    private obterPrecoServidoTestePrecoFsw(result: any, idJogador: string): number {
      const encontrados = result && result.encontrados ? result.encontrados : null;
      const hit = encontrados ? encontrados[String(idJogador)] : null;
      const externo = hit && hit.externo ? hit.externo : null;
      const preco = externo ? Number(externo.preco) : 0;
      return preco > 0 ? preco : 0;
    }

    private montarLogHumanoTestePrecoFsw(result: any, payload: any): string {
      const item = (label: string, valor: any) => {
        return "<div class=\"teste-preco-log-item\"><span class=\"teste-preco-log-label\">"
          + this.escaparHtmlTestePrecoExterno(label) + "</span><strong>"
          + this.escaparHtmlTestePrecoExterno(valor) + "</strong></div>";
      };
      const cabecalho = (classe: string, titulo: string, mensagem: string, preco: string) => {
        return [
          "<div class=\"teste-preco-result-head " + classe + "\">",
          "<div class=\"d-flex align-items-start justify-content-between\">",
          "<div>",
          "<strong>" + this.escaparHtmlTestePrecoExterno(titulo) + "</strong>",
          "<div class=\"small mt-1\">" + this.escaparHtmlTestePrecoExterno(mensagem) + "</div>",
          "</div>",
          "<div class=\"text-right ml-3\">",
          "<span class=\"teste-preco-log-label\">Preco</span>",
          "<div class=\"teste-preco-price\">" + this.escaparHtmlTestePrecoExterno(preco) + "</div>",
          "</div>",
          "</div>",
          "</div>",
        ].join("");
      };

      if (result && result.desativado) {
        return cabecalho(
          "warning",
          "Cache central DESLIGADO",
          result.mensagem || "PRECO_JOGADORES_FSW=false no .env da web.",
          "-"
        ) + "<div class=\"teste-preco-log-grid\">"
          + item("Tipo", "Cache central FSW")
          + item("Efeito", "Nenhum plugin consulta nem publica preco compartilhado")
          + "</div>";
      }

      const idJogador = String(payload && payload.idJogador ? payload.idJogador : "");
      const detalhe = this.obterDetalheTestePrecoFsw(result, idJogador);
      const precoServido = this.obterPrecoServidoTestePrecoFsw(result, idJogador);
      const externo = detalhe && detalhe.externo ? detalhe.externo : null;
      const ea = detalhe && detalhe.ea ? detalhe.ea : null;
      const quarentena = detalhe && detalhe.quarentena ? detalhe.quarentena : null;
      const config = result && result.config ? result.config : null;
      const precoGuardado = externo && Number(externo.preco) > 0 ? Number(externo.preco) : 0;

      const titulo = precoServido > 0
        ? "Cache central TEM preco para este jogador"
        : (precoGuardado > 0 ? "Preco guardado, mas NAO servido agora" : "Cache central sem preco para este jogador");
      const mensagem = precoServido > 0
        ? "Um plugin pedindo este id agora receberia este preco, sem buscar externo nem na EA."
        : (detalhe && detalhe.motivoTexto ? detalhe.motivoTexto : "O id voltaria como faltando e o plugin seguiria para a busca externa/EA.");

      const itens = [
        item("Tipo", "Cache central FSW"),
        item("ResourceId", idJogador || "-"),
        item("Plataforma", payload && payload.plataforma ? payload.plataforma : "-"),
        item("Preco servido", precoServido > 0 ? String(precoServido) : "nao serve"),
      ];

      if (detalhe && detalhe.existe === false) {
        itens.push(item("Linha no banco", "nao existe"));
      } else if (externo) {
        itens.push(item("Preco guardado", precoGuardado > 0 ? String(precoGuardado) : "0"));
        itens.push(item("Fonte", externo.fonte || "-"));
        itens.push(item("Idade", externo.idadeMin === null || externo.idadeMin === undefined ? "-" : (externo.idadeMin + " min")));
        itens.push(item("Janela de idade", (externo.dentroDaJanela ? "dentro" : "FORA") + " (" + externo.janelaMin + " min)"));
        itens.push(item("Capturado em", externo.capturadoAt || "-"));
      }

      if (ea && Number(ea.preco) > 0) {
        itens.push(item("Preco EA", String(ea.preco) + " (" + (ea.idadeMin === null || ea.idadeMin === undefined ? "-" : ea.idadeMin + " min") + ", " + (ea.dentroDaJanela ? "dentro" : "FORA") + " da janela de " + ea.janelaMin + " min)"));
      }

      if (quarentena && quarentena.ativa) {
        itens.push(item("Quarentena", "ATIVA — pendente " + quarentena.precoPendente + ", " + quarentena.leituras + " leitura(s), desde " + (quarentena.desde || "-")));
      }

      if (detalhe && detalhe.nome) {
        itens.push(item("Jogador", detalhe.nome));
      }
      itens.push(item("Servidor", config && config.url ? config.url : "proprio servidor do site"));

      const classe = precoServido > 0 ? "success" : "warning";
      const precoTexto = precoServido > 0 ? String(precoServido) : (precoGuardado > 0 ? String(precoGuardado) + "*" : "-");
      return cabecalho(classe, titulo, mensagem, precoTexto)
        + "<div class=\"teste-preco-log-grid\">" + itens.join("") + "</div>";
    }

    /**
     * Teste do CACHE CENTRAL FSW: consulta a rota web /precos-fsw/consultar (sessao do site,
     * SOMENTE leitura). Nao envolve conta, extensao nem plugin-server — responde "o que o
     * servidor compartilhado tem para este jogador agora e, se nao tem, por que".
     */
    private executarTestePrecoFsw(form: JQuery, idJogador: string) {
      const platform = String(form.find("[name=platform]").val() || "ps");
      const payload: any = {
        modo_teste: "fsw",
        idJogador,
        platform,
        // O cache central so conhece 'console' e 'pc' (xbox cai no mercado unificado de console).
        plataforma: platform === "pc" ? "pc" : "console",
        ids: [idJogador],
      };

      const btn = $("#btn-executar-teste-preco-externo");
      const resultado = $("#testePrecoExternoResultado");
      const logHumano = $("#testePrecoExternoLogHumano");
      const logTecnico = $("#testePrecoExternoLogTecnico");
      btn.prop("disabled", true).text("Consultando...");
      $("#testePrecoExternoEstadoInicial").addClass("d-none");
      $("#testePrecoExternoToggleTecnico").addClass("d-none").text("Log tecnico");
      logTecnico.addClass("d-none");
      resultado.text("");
      logHumano
        .removeClass("d-none")
        .html("<div class=\"teste-preco-result-head warning\"><strong>Consultando o cache central...</strong><div class=\"small mt-1\">Lendo o servidor FSW compartilhado.</div></div>");

      $.ajax({
        url: "/precos-fsw/consultar",
        method: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(payload),
        beforeSend: (jqXHR: JQueryXHR) => {
          jqXHR.setRequestHeader("X-CSRF-TOKEN", $("meta[name=csrf-token]").attr("content"));
        },
      }).done((resp: any) => {
        btn.prop("disabled", false).text("Executar teste");
        const result: any = resp ? resp : {};
        logHumano.removeClass("d-none").html(this.montarLogHumanoTestePrecoFsw(result, payload));
        $("#testePrecoExternoToggleTecnico").removeClass("d-none").text("Log tecnico");
        logTecnico.addClass("d-none");
        resultado.text(JSON.stringify({ payload, result }, null, 2));

        if (result.desativado) {
          toastr.warning("Cache central DESLIGADO no .env da web (PRECO_JOGADORES_FSW=false).", "Teste de precos");
          return;
        }
        const precoServido = this.obterPrecoServidoTestePrecoFsw(result, idJogador);
        if (precoServido > 0) {
          toastr.success(`Cache central serviria ${precoServido} para este jogador.`, "Teste de precos");
          return;
        }
        const detalhe = this.obterDetalheTestePrecoFsw(result, idJogador);
        toastr.warning(
          detalhe && detalhe.motivoTexto ? detalhe.motivoTexto : "O cache central nao tem preco para este jogador.",
          "Teste de precos"
        );
      }).fail((jq: JQueryXHR) => {
        btn.prop("disabled", false).text("Executar teste");
        const status = jq && jq.status ? jq.status : 0;
        logHumano.removeClass("d-none").html(
          "<div class=\"teste-preco-result-head warning\"><strong>Falha ao consultar o cache central</strong><div class=\"small mt-1\">HTTP "
          + status + "</div></div>"
        );
        resultado.text(JSON.stringify({ payload, erro: { status: status, resposta: jq && jq.responseText ? jq.responseText : null } }, null, 2));
        $("#testePrecoExternoToggleTecnico").removeClass("d-none").text("Log tecnico");
        toastr.warning("Nao foi possivel consultar o cache central (HTTP " + status + ").", "Teste de precos");
      });
    }

    private executarTestePrecoExterno(e: JQueryEventObject) {
      e.preventDefault();
      const form = $("#formTestePrecoExterno");
      const idJogador = String(form.find("[name=idJogador]").val() || "").trim();
      if (!idJogador) {
        toastr.warning("Informe o id/resourceId do jogador.", "Teste de preços");
        return;
      }
      const modoTeste = String(form.find("[name=modo_teste]").val() || "externo");
      // FSW le o cache central no proprio site (rota web, SO leitura): nao passa pela conta,
      // pela extensao nem pelo socket do plugin. Por isso sai antes de montar o payload deles.
      if (modoTeste === "fsw") {
        this.executarTestePrecoFsw(form, idJogador);
        return;
      }
      const forcarChromeReal = modoTeste === "externo" && form.find("[name=forcarChromeReal]").is(":checked");
      const ignorarCachePreco = form.find("[name=ignorarCachePreco]").is(":checked") || forcarChromeReal;
      const ignorarBloqueioMemorizado = modoTeste === "externo" && form.find("[name=ignorarBloqueioMemorizado]").is(":checked");
      const fontes: string[] = [];
      form.find("#testePrecoExternoFontes input[name=fontes_preco]:checked").each((_index, el) => {
        const fonte = String($(el).val() || "").trim();
        if (fonte) {
          fontes.push(fonte);
        }
      });
      const zyteApiAtivo = form.find("[name=zyte_api]").is(":checked");
      const payload: any = {
        modo_teste: modoTeste,
        idConta: form.find("[name=idConta]").val() || null,
        idJogador,
        nomeJogador: String(form.find("[name=nomeJogador]").val() || "").trim(),
        ignorarCachePreco,
      };
      if (modoTeste === "ea") {
        const rareflag = String(form.find("[name=rareflag]").val() || "").trim();
        const teamId = String(form.find("[name=teamId]").val() || "").trim();
        if (!rareflag || !teamId) {
          toastr.warning("Informe rareflag e teamId para testar preço EA.", "Teste de preços");
          return;
        }
        payload.precoConhecido = form.find("[name=precoConhecido]").val() || 0;
        payload.rareflag = rareflag;
        payload.teamId = teamId;
        payload.nomePosicao = String(form.find("[name=nomePosicao]").val() || "").trim();
        payload.estiloEntrosamento = form.find("[name=estiloEntrosamento]").val() || null;
        payload.tentativas = form.find("[name=tentativas]").val() || 10;
        payload.usar_motor_preco_ea_inteligente = form.find("[name=usar_motor_preco_ea_inteligente]").is(":checked");
        payload.preco_de_venda_ea_minimo_cartas = form.find("[name=preco_de_venda_ea_minimo_cartas]").val() || 3;
        payload.preco_de_compra_ea_minimo_cartas = form.find("[name=preco_de_compra_ea_minimo_cartas]").val() || 3;
        payload.preco_de_venda_ea_percentual_suspeito = form.find("[name=preco_de_venda_ea_percentual_suspeito]").val() || 30;
        payload.preco_de_compra_ea_percentual_suspeito = form.find("[name=preco_de_compra_ea_percentual_suspeito]").val() || 50;
      } else {
        if (!fontes.length) {
          toastr.warning("Selecione pelo menos uma fonte.", "Teste de precos");
          return;
        }
        payload.platform = form.find("[name=platform]").val() || "ps";
        payload.fontes_preco = fontes;
        payload.zyte_api = zyteApiAtivo;
        payload.zyte_api_key = zyteApiAtivo ? String(form.find("[name=zyte_api_key]").val() || "").trim() : "";
        payload.forcarChromeReal = forcarChromeReal;
        payload.ignorarBloqueioMemorizado = ignorarBloqueioMemorizado;
      }
      const btn = $("#btn-executar-teste-preco-externo");
      const resultado = $("#testePrecoExternoResultado");
      const logHumano = $("#testePrecoExternoLogHumano");
      const logTecnico = $("#testePrecoExternoLogTecnico");
      btn.prop("disabled", true).text("Executando...");
      $("#testePrecoExternoEstadoInicial").addClass("d-none");
      $("#testePrecoExternoToggleTecnico").addClass("d-none").text("Log tecnico");
      logTecnico.addClass("d-none");
      resultado.text("");
      logHumano
        .removeClass("d-none")
        .html("<div class=\"teste-preco-result-head warning\"><strong>Executando teste...</strong><div class=\"small mt-1\">Aguardando resposta da conta/extensao.</div></div>");
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_TESTE_PRECO_EXTERNO, payload, (response: IRespostaMensagem) => {
        btn.prop("disabled", false).text("Executar teste");
        const result: any = response && response.result ? response.result : {};
        logHumano
          .removeClass("d-none")
          .html(this.montarLogHumanoTestePrecoExterno(result, payload, !!(response && response.status)));
        $("#testePrecoExternoToggleTecnico").removeClass("d-none").text("Log tecnico");
        logTecnico.addClass("d-none");
        resultado.text(JSON.stringify({ payload, result }, null, 2));
        if (response && response.status) {
          const precoOk = Number((result && result.preco) || 0) > 0;
          if (precoOk) {
            toastr.success(`Preço ${result.preco} encontrado (modo: ${result.modo || "desconhecido"})`, "Teste de preços");
          } else {
            toastr.warning(`Teste executado, mas SEM preço externo (modo: ${result.modo || "desconhecido"}).`, "Teste de preços");
          }
        } else {
          toastr.warning(result.mensagem || "Não foi possível executar o teste.", "Teste de preços");
        }
      });
    }

    private abrirContaRapida(e: JQueryEventObject) {
      e.preventDefault();
      const idConta = $(e.currentTarget).data("id-conta-ea");
      if (!idConta) return;
      this.exibirLoadListConta(idConta, "Abrindo conta rápido...");
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ABRIR_CONTA_RAPIDA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta);
        if (response && response.status) {
          const conta = response.result && response.result.conta ? response.result.conta : null;
          if (conta) {
            this.updateContaDatatable(conta);
          }
          toastr.success("Conta aberta em modo rápido.", "Conta pronta");
        } else {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível abrir a conta.";
          toastr.warning(msg, "Abertura rápida");
        }
      });
    }

    private extrairDadosWebAppAgora(e: JQueryEventObject) {
      e.preventDefault();
      const respostaModo = prompt(
        "Selecione o modo de extracao:\n1 - Extracao comum\n2 - Concepts players filtrado para Auto DME\n3 - Concepts players bruto EA",
        "1"
      );
      if (respostaModo === null) {
        return;
      }

      const modoSelecionado = String(respostaModo).trim();
      if (modoSelecionado !== "1" && modoSelecionado !== "2" && modoSelecionado !== "3") {
        toastr.warning("Modo invalido. Informe 1, 2 ou 3.", "Atencao!");
        return;
      }

      const payload: any = {
        modo: modoSelecionado === "2" ? "concepts_players" : (modoSelecionado === "3" ? "concepts_players_raw" : "comum")
      };
      if (payload.modo === "concepts_players") {
        const respostaPreco = prompt("Preco maximo por jogador (0 = sem limite). Ex: 200000", "0");
        if (respostaPreco === null) {
          return;
        }
        const parsed = parseInt(String(respostaPreco).replace(/\D/g, ""), 10);
        payload.conceptImportMaxPrice = isNaN(parsed) ? 0 : Math.max(0, parsed);
      }

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXTRAI_DADOS_WEBAPP_AGORA, payload, (response: any) => {
        const result = response && response.result ? response.result : null;
        console.log("EXTRACAO WEBAPP", response)
        if (response && response.status) {
          if (result && typeof result === "object") {
            if (result.modo === "concepts_players" || result.modo === "concepts_players_raw") {
              const infoQuantidade = typeof result.quantidade === "number" ? ` (${result.quantidade} jogadores)` : "";
              toastr.success((result.mensagem || "Extracao de concepts players concluida.") + infoQuantidade, "Sucesso!");
            } else {
              toastr.success(result.mensagem || "Extracao de dados WebApp iniciada/concluida.", "Sucesso!");
            }
          } else {
            toastr.success(typeof result === "string" ? result : "Extracao de dados WebApp iniciada/concluida.", "Sucesso!");
          }
        } else {
          let mensagemErro = "Nao foi possivel executar a extracao agora.";
          if (result && typeof result === "object" && result.mensagem) {
            mensagemErro = result.mensagem;
          } else if (typeof result === "string") {
            mensagemErro = result;
          }
          toastr.warning(mensagemErro, "Atencao!");
        }
      })
    }
    private testeNotificacaoTelegram(e: JQueryEventObject) {
      //console.log("TESTE_NOTIFICACAO_TELEGRAM", App.Business.dadosTeste)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_TESTE_NOTIFICACAO_TELEGRAM, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success(response.status, "Sucessso!");
        }
      })
    }

    private ativarInteracaoSniper(id: number) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INTERACAO_SNIPER, { status: true, id: id }, (response: IRespostaMensagem) => { })
    }

    private desativarInteracaoSniper(id: number) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INTERACAO_SNIPER, { status: false, id: id }, (response: IRespostaMensagem) => { })
    }

    private getCredenciaisConta(idConta: number = null): IDadosCredenciais {
      let elementoCredenciais = null;
      if (idConta) {
        elementoCredenciais = $(`#formCredenciaisBot${(idConta)}`);
      } else {
        elementoCredenciais = $(`#formConfiguracoesBotAddConta`);
      }

      if (elementoCredenciais.length) {
        return {
          id: idConta, email: elementoCredenciais.find('input[name=email]').val() || null, senha: elementoCredenciais.find('input[name=senha]').val() || null,
          auth: elementoCredenciais.find('input[name=auth]').val() || null,
          persona: elementoCredenciais.find('select[name=select_persona]').val() || null,
          tipoAuth: elementoCredenciais.find('input[name=modo_auth2]:checked').val(),
          resolverBug: elementoCredenciais.find('input[name=modo_resolver_bug]').is(':checked') ? true : false
        }
      }

      return { id: idConta, email: null, senha: null, auth: null, persona: null, tipoAuth: null, resolverBug: false }
    }

    private getCredenciaisMultConta(idConta: number = null): any {
      let elementoFormCredenciais = $(`#formConfiguracoesBotAddMultConta`);

      let lista = null
      if (elementoFormCredenciais.length) {
        try {
          lista = elementoFormCredenciais.find('textarea[name=lista_contas]').val() || null
          //console.log("List", lista)
          lista = JSON.parse(JSON.stringify(lista))
        } catch (e) {
          console.log("error", e)
          toastr.warning("Confira se os dados estão no padrão correto conforme informado no exemplo default.", "Dados Incorretos!");
          lista = null

        }
        if (!lista) {
          toastr.warning("Informe os dados no padrão conforme informado no exemplo default.", "Informe os dados das contas!");
        }
        return lista
      }

      return lista
    }

    private getListaContasVinculo(listaContas: string): IListaContasVinculo[] {
      var linhas = listaContas.split('\n').map(function (linha) {
        return linha.trim().replace('"', '');
      }).filter(function (linha) {
        return linha !== '';
      });

      // Mapeia cada linha para um objeto com as propriedades desejadas
      var contasArray: IListaContasVinculo[] = linhas.map(function (linha) {
        var dados = linha.split(',').map(function (valor) {
          return valor.trim();
        });

        return {
          email: dados[0],
          senha: dados[1],
          auth: dados[2] && dados[2] != "0" ? dados[2] : null,
          proxy: dados[3] && dados[3] != "0" ? dados[3] : null,
          tipoAuth: dados[4] && dados[4] != "0" ? dados[4] : null,
          persona: dados[5] && dados[5] != "0" ? dados[5] : null
        };
      });

      return contasArray
    }

    // NOVO batch: adiciona TODAS as rows provisórias e envia a lista de uma vez.
    // O ritmo (intervalo_abertura_conta) e a concorrência (cap) são controlados pelo PLUGIN.
    private async vincularListaContas(contasArray: IListaContasVinculo[], navegadorVisivel: boolean = false, exibirLoading: boolean = false) {
      try {
        if (!contasArray || !contasArray.length) return;
        const lista: any[] = [];
        for (let i = 0; i < contasArray.length; i++) {
          const conta = contasArray[i];
          if (!conta || !conta.email) continue;
          let proxy: any = conta.proxy || null;
          try {
            // proxy numérico = id → resolve o objeto do proxy.
            if (proxy && !isNaN(proxy)) {
              const p = await this.getProxyById(proxy);
              if (p) proxy = p;
            }
          } catch (e) { console.log("ERRO BUSCA PROXY", e); }

          const chaveVinculo = this.gerarChaveVinculo(conta.email);
          const creds = { email: conta.email, senha: conta.senha, auth: conta.auth, persona: conta.persona, tipoAuth: conta.tipoAuth, proxy: proxy };
          this.adicionarLinhaProvisoriaVinculo(conta.email, chaveVinculo, creds, i + 1, contasArray.length);
          lista.push({ ...creds, chaveVinculo: chaveVinculo });
        }

        if (exibirLoading) App.Util.ocultarLoadingTableContas();
        if (!lista.length) return;

        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_VINCULAR_MULT_CONTAS, { lista: lista, navegadorVisivel: navegadorVisivel, persona: this.getPersona() }, (response: IRespostaMensagem) => {
          console.log("VINCULO LISTA ACEITO", response);
        });
      } catch (e) {
        console.log("ERRO vincularListaContas", e);
        App.Util.ocultarLoadingTableContas();
      }
    }

    private iniciarSessaoConta(idConta: number = null, credenciais: IDadosCredenciais = null, navegadorVisivel: boolean = false, exibirLoading: boolean = false, mostrarTelaWebApp: boolean = false) {
      if (idConta && (!credenciais.email || !credenciais.senha)) {
        $(`#modalConfigCredenciais${idConta}`).modal('show')
        return
      }
      if (exibirLoading) {
        App.Util.exibirLoadingTableContas()
      }

      try {
        if (!idConta) {
          let arrLista: IListaContasVinculo[] = null;
          let elementoCredenciais = $(`#formConfiguracoesBotAddConta`);
          let listaContas = elementoCredenciais.find('textarea[name=lista]').val()
          if (listaContas) {
            arrLista = this.getListaContasVinculo(listaContas)
            console.log("LISTA", arrLista, this.configuracoesGeraisExecucao.intervalo_abertura_conta)
          }

          if (arrLista && arrLista.length) {
            // O plugin controla ritmo (intervalo_abertura_conta) e concorrência (cap): envio único do lote.
            this.vincularListaContas(arrLista, navegadorVisivel, exibirLoading)
            return
          }
        }
      } catch (e) {
        console.log("ERROR LISTA", e)
      }


      this.exibirLoadListConta(idConta, "Iniciando Conta...")

      this.comunicarIniciarConta(idConta, credenciais, navegadorVisivel, exibirLoading, null, mostrarTelaWebApp)
    }

    // ─── NOVO VÍNCULO — row provisória + progresso ao vivo ───────────────────────────────
    private escaparHtml(txt: any): string {
      return String(txt == null ? "" : txt).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    private gerarChaveVinculo(email: string): string {
      const base = String(email || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
      let hash = 0;
      const s = String(email || "");
      for (let i = 0; i < s.length; i++) { hash = ((hash << 5) - hash + s.charCodeAt(i)) | 0; }
      return "vinc_" + base + "_" + Math.abs(hash).toString(36);
    }

    private getRowProvisoria(chaveVinculo: string): any {
      if (!App.Business.objDataTableContas || !chaveVinculo) return null;
      const row = App.Business.objDataTableContas.row(`#${chaveVinculo}`);
      return row && row.length ? row : null;
    }

    private setEstadoVinculo(chaveVinculo: string, estado: any): void {
      const row = this.getRowProvisoria(chaveVinculo);
      if (!row) return;
      const obj: any = row.data();
      obj._vinculoEstado = { ...(obj._vinculoEstado || {}), ...estado };
      obj.loadList = null;
      row.data(obj).draw(false);
    }

    // Coluna de INFO da linha em vínculo: deixa claro que é uma conta sendo vinculada AGORA + o email.
    private renderColunaInfoVinculo(obj: any): string {
      const email = this.escaparHtml(obj.email);
      return `<div class="media align-items-center conta-info-compact">
        <span class="avatar rounded-circle mr-2" style="width:22px;height:22px;background-color:#5e60ce;color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:10px;"><i class="fas fa-link"></i></span>
        <div class="media-body conta-info-main">
          <span class="name mb-0 text-sm font-size-10 bold-600 text-uppercase" style="color:#5e60ce;">Vinculando conta</span>
          <div><small class="text-muted">${email}</small></div>
        </div>
      </div>`;
    }

    // Coluna de STATUS da linha em vínculo: passo atual + progresso, 2FA inline, edição ou falha com ações.
    private renderColunaStatusVinculo(obj: any): string {
      const estado = obj._vinculoEstado || { etapa: "queued", mensagem: "Na fila…" };
      const chave = obj.chaveVinculo;
      const etapa = estado.etapa || "queued";
      const mensagem = this.escaparHtml(estado.mensagem || "Processando…");

      if (etapa === "falha") {
        const permiteRetentar = estado.motivo !== "conta_desabilitada" && estado.motivo !== "limite_plano";
        const botoes = (permiteRetentar
          ? `<a class="btn btn-sm btn-warning btn-editar-vinculo" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Editar</a> `
            + `<a class="btn btn-sm btn-success btn-retentar-vinculo" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Tentar novamente</a> `
          : "")
          + `<a class="btn btn-sm btn-outline-secondary btn-remover-linha-vinculo" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Remover</a>`;
        return `<div class="text-center">
          <span class="badge badge-danger text-uppercase" style="font-size:9px;">✗ Falha no vínculo</span>
          <div class="font-size-10 text-danger mt-1">${mensagem}</div>
          <div class="mt-1">${botoes}</div>
        </div>`;
      }

      if (etapa === "editar") {
        const creds = this.dadosVinculoPorChave[chave] || {};
        return `<div class="text-left" style="font-size:11px;max-width:210px;margin:0 auto;">
          <input class="form-control form-control-sm mb-1 inp-vinc-email" data-chave="${chave}" placeholder="email" value="${this.escaparHtml(creds.email || "")}" style="font-size:11px;" />
          <input class="form-control form-control-sm mb-1 inp-vinc-senha" data-chave="${chave}" placeholder="senha" value="${this.escaparHtml(creds.senha || "")}" style="font-size:11px;" />
          <input class="form-control form-control-sm mb-1 inp-vinc-auth" data-chave="${chave}" placeholder="auth (opcional)" value="${this.escaparHtml(creds.auth || "")}" style="font-size:11px;" />
          <a class="btn btn-sm btn-success btn-salvar-retentar-vinculo" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Salvar e tentar</a>
          <a class="btn btn-sm btn-outline-secondary btn-remover-linha-vinculo" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Cancelar</a>
        </div>`;
      }

      if (etapa === "aguardando_2fa") {
        const erro = estado.codigoErro ? `<div style="color:#d33;font-size:9px;">Código inválido, tente novamente.</div>` : "";
        return `<div class="text-center">
          <span class="badge badge-warning text-uppercase" style="font-size:9px;">Aguardando código 2FA</span>
          <div class="mt-1" style="max-width:200px;margin:0 auto;">
            ${erro}
            <input class="form-control form-control-sm mb-1 inp-codigo-2fa" data-chave="${chave}" placeholder="código enviado pela EA" autocomplete="off" style="font-size:11px;" />
            <a class="btn btn-sm btn-success btn-enviar-codigo-2fa" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Enviar</a>
            <a class="btn btn-sm btn-primary btn-solicitar-outro-2fa" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Outro</a>
            <a class="btn btn-sm btn-outline-secondary btn-cancelar-2fa" data-chave="${chave}" style="font-size:9px;padding:2px 6px;">Cancelar</a>
          </div>
        </div>`;
      }

      // andamento (queued / abrindo_navegador / login / verificando)
      const percentuais: any = { queued: 15, abrindo_navegador: 35, login: 55, verificando: 85 };
      const perc = percentuais[etapa] || 20;
      return `<div class="text-center">
        <span class="badge text-uppercase" style="font-size:9px;background-color:#eae9ff;color:#5e60ce;"><i class="fas fa-link mr-1"></i>Vinculando</span>
        <div class="d-flex align-items-center justify-content-center mt-1" style="gap:5px;">
          <div class="spinner-border text-primary" style="width:0.85rem;height:0.85rem;" role="status"><span class="sr-only">...</span></div>
          <span class="font-size-10 text-muted">${mensagem}</span>
        </div>
        <div class="progress mt-1" style="height:4px;max-width:150px;margin:4px auto 0;">
          <div class="progress-bar" role="progressbar" style="width:${perc}%;background-color:#5e60ce;"></div>
        </div>
      </div>`;
    }

    private adicionarLinhaProvisoriaVinculo(email: string, chaveVinculo: string, credenciais: any = null, indice: number = null, total: number = null): void {
      try {
        if (!App.Business.objDataTableContas) return;
        this.inicializarEventosVinculo();
        if (credenciais) this.dadosVinculoPorChave[chaveVinculo] = { ...credenciais, email: email };
        const posicao = (indice && total) ? ` (${indice}/${total})` : "";
        // Shape completo com defaults seguros para NÃO quebrar os renders das colunas (dadosEa, dmes, etc.).
        const objProvisorio: any = {
          id: chaveVinculo, email: email, clube: email, plataforma: "",
          status: Util.STATUS_CONTA_PARADA, navegador_status: false, agenda_ativa: 0, coins: 0,
          dadosEa: { idConta: null, idUsuario: null, clubeName: email, plataforma: "", coins: 0, token: null, img: "", urlApi: null, endPoint: null, mercado: true, status: 1 },
          dmes: [], players: [], listas: null, partidas: null, programacao: [],
          proxy: null, proxyUrl: null, ultima_execucao: null,
          _vinculoProvisorio: true, chaveVinculo: chaveVinculo,
          _vinculoEstado: { etapa: "queued", status: "andamento", mensagem: `Na fila…${posicao}` }
        };
        const jaExiste = this.getRowProvisoria(chaveVinculo);
        if (jaExiste) {
          jaExiste.data(objProvisorio).draw(false);
        } else {
          App.Business.objDataTableContas.row.add(objProvisorio).draw(false);
        }
        // A própria linha já mostra o status/progresso — esconder o spinner que cobre a tabela,
        // senão ele fica na frente e impede o usuário de digitar o código 2FA na linha.
        try { App.Util.ocultarLoadingTableContas(); } catch (e) { }
      } catch (e) { console.log("ERRO adicionarLinhaProvisoriaVinculo", e); }
    }

    private atualizarProgressoVinculo(request: any): void {
      try {
        const chave = request ? request.chaveVinculo : null;
        if (!chave) return;
        if (request.status === "sucesso" && request.etapa === "vinculado" && request.conta) {
          this.substituirLinhaProvisoriaPorReal(chave, request.conta);
          delete this.pendentesCodigo2FA[chave];
          delete this.dadosVinculoPorChave[chave];
          return;
        }
        if (request.status === "erro" || request.etapa === "falha") {
          this.marcarFalhaLinhaVinculo(chave, request.mensagem || "Falha no vínculo.", request.motivo);
          delete this.pendentesCodigo2FA[chave];
          return;
        }
        // andamento / pausa. O estado "aguardando_2fa" com campo inline é montado em solicitarCodigoValidacao.
        if (request.etapa === "aguardando_2fa") return;
        this.setEstadoVinculo(chave, { etapa: request.etapa || "andamento", status: request.status, mensagem: request.mensagem || "Processando…" });
      } catch (e) { console.log("ERRO atualizarProgressoVinculo", e); }
    }

    private substituirLinhaProvisoriaPorReal(chaveVinculo: string, conta: IConta): void {
      try {
        if (!App.Business.objDataTableContas) return;
        const idReal: any = conta && conta.dadosEa ? conta.dadosEa.idConta : (conta ? conta.id : null);
        const rowProv = this.getRowProvisoria(chaveVinculo);
        // Re-link: a linha real já existe → só remove a provisória.
        if (idReal && App.Business.objDataTableContas.row(`#${idReal}`).length) {
          if (rowProv) rowProv.remove();
          App.Business.objDataTableContas.draw(false);
          return;
        }
        if (rowProv) rowProv.remove();
        // Defaults seguros primeiro; os valores reais da conta sobrescrevem.
        let contaReal: any = { dmes: [], players: [], listas: null, partidas: null, programacao: [], coins: 0, ...conta, id: idReal, loadList: null, _vinculoProvisorio: false };
        try { contaReal = this.normalizarContaTabela(contaReal); } catch (e) { }
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, idReal, contaReal);
        App.Business.objDataTableContas.row.add(contaReal).draw(false);
        toastr.success(`Conta vinculada: ${conta && conta.dadosEa && conta.dadosEa.clubeName ? conta.dadosEa.clubeName : conta.email}`, "Vínculo");
      } catch (e) { console.log("ERRO substituirLinhaProvisoriaPorReal", e); }
    }

    private marcarFalhaLinhaVinculo(chaveVinculo: string, mensagem: string, motivo: string = null): void {
      this.setEstadoVinculo(chaveVinculo, { etapa: "falha", status: "erro", mensagem: mensagem, motivo: motivo });
    }

    private mostrarEdicaoCredenciaisVinculo(chaveVinculo: string): void {
      this.setEstadoVinculo(chaveVinculo, { etapa: "editar" });
    }

    private retentarVinculo(chaveVinculo: string, novasCredenciais: any = null): void {
      const creds = novasCredenciais || this.dadosVinculoPorChave[chaveVinculo];
      if (!creds || !creds.email) return;
      this.dadosVinculoPorChave[chaveVinculo] = creds;
      this.setEstadoVinculo(chaveVinculo, { etapa: "queued", status: "andamento", mensagem: "Na fila…" });
      this.comunicarIniciarConta(null, creds, false, false, creds.proxy || null);
    }

    private removerLinhaVinculo(chaveVinculo: string): void {
      const row = this.getRowProvisoria(chaveVinculo);
      if (row) row.remove().draw(false);
      delete this.dadosVinculoPorChave[chaveVinculo];
      delete this.pendentesCodigo2FA[chaveVinculo];
    }

    /** Ordem de busca padrao quando o perfil nao define nada (ou desmarca tudo). */
    private static readonly FONTES_PRECO_PADRAO: string[] = ['futbin', 'futgg', 'ftwiz', 'futnext'];

    /** Le as fontes ativas na ORDEM em que aparecem no formulario (a lista e a prioridade). */
    private lerFontesPrecoDoForm(form: JQuery): string[] {
      const fontes: string[] = [];
      form.find(".js-fonte-preco-item").each(function () {
        const item = $(this);
        const check = item.find("input[name='fontes_preco[]']");
        if (!check.is(":checked")) return;
        const fonte = String(check.val() || item.data("fonte") || "").trim();
        if (fonte && fontes.indexOf(fonte) === -1) fontes.push(fonte);
      });
      return fontes;
    }

    /**
     * Reordena a lista do formulario conforme a ordem salva no perfil e marca as ativas.
     * Fontes que nao estao no perfil ficam no fim, desmarcadas, mantendo a ordem padrao —
     * assim o usuario continua enxergando (e podendo reativar) todas as fontes.
     */
    private aplicarOrdemFontesPreco(form: JQuery, fontesAtivas: string[]): void {
      const lista = form.find(".js-fontes-preco-lista");
      if (!lista.length) return;

      const ativas = Array.isArray(fontesAtivas) ? fontesAtivas.map((f) => String(f || "").trim()).filter(Boolean) : [];

      ativas.forEach((fonte) => {
        const item = lista.find(`.js-fonte-preco-item[data-fonte='${fonte}']`);
        if (item.length) lista.append(item);
      });

      lista.find(".js-fonte-preco-item").each(function () {
        const item = $(this);
        const fonte = String(item.data("fonte") || "");
        const ativa = ativas.indexOf(fonte) >= 0;
        item.find("input[name='fontes_preco[]']").prop('checked', ativa);
        if (!ativa) lista.append(item);
      });

      this.atualizarVisualFontesPreco(lista);
    }

    /** Renumera a lista e destaca visualmente as fontes desmarcadas. */
    private atualizarVisualFontesPreco(lista: JQuery): void {
      let ordem = 0;
      lista.find(".js-fonte-preco-item").each(function () {
        const item = $(this);
        const ativa = item.find("input[name='fontes_preco[]']").is(":checked");
        item.toggleClass('is-inativa', !ativa);
        if (ativa) {
          ordem++;
          item.find(".js-fonte-preco-ordem").text(String(ordem));
        } else {
          item.find(".js-fonte-preco-ordem").text('-');
        }
      });
    }

    /**
     * Arrastar para reordenar as fontes de preco (mesmo padrao HTML5 do assistente de Auto DME,
     * sem biblioteca externa). Se o drag falhar por qualquer motivo, os checkboxes continuam
     * funcionando e a ordem vigente da lista e a que sera salva — nada quebra.
     */
    private inicializarEventosFontesPreco(): void {
      if ((this as any)._eventosFontesPrecoIniciados) return;
      (this as any)._eventosFontesPrecoIniciados = true;
      const self = this;
      let itemArrastado: HTMLElement = null;

      $(document).on("dragstart", ".js-fonte-preco-handle", function (event: any) {
        const item = $(this).closest(".js-fonte-preco-item");
        if (!item.length) return;
        itemArrastado = item[0];
        item.addClass('is-dragging');
        const original = event.originalEvent;
        if (original && original.dataTransfer) {
          original.dataTransfer.effectAllowed = 'move';
          original.dataTransfer.setData('text/plain', String(item.data("fonte") || ""));
        }
      });

      $(document).on("dragover", ".js-fonte-preco-item", function (event: any) {
        if (!itemArrastado || itemArrastado === this) return;
        const alvo = $(this);
        const lista = alvo.closest(".js-fontes-preco-lista");
        // So reordena dentro da MESMA lista (a pagina tem um modal de perfil por perfil).
        if (!lista.length || !$.contains(lista[0], itemArrastado)) return;

        event.preventDefault();
        const original = event.originalEvent || {};
        if (original.dataTransfer) original.dataTransfer.dropEffect = 'move';

        const rect = this.getBoundingClientRect();
        const depois = original.clientY > (rect.top + (rect.height / 2));
        lista.find(".js-fonte-preco-item").removeClass('is-drop-target');
        alvo.addClass('is-drop-target');
        if (depois) {
          alvo.after(itemArrastado);
        } else {
          alvo.before(itemArrastado);
        }
        self.atualizarVisualFontesPreco(lista);
      });

      $(document).on("drop", ".js-fonte-preco-item", function (event: any) {
        if (!itemArrastado) return;
        event.preventDefault();
        const lista = $(this).closest(".js-fontes-preco-lista");
        lista.find(".js-fonte-preco-item").removeClass('is-drop-target');
        self.atualizarVisualFontesPreco(lista);
      });

      $(document).on("dragend", ".js-fonte-preco-handle", function () {
        const lista = $(this).closest(".js-fontes-preco-lista");
        $(".js-fonte-preco-item").removeClass('is-dragging is-drop-target');
        itemArrastado = null;
        if (lista.length) self.atualizarVisualFontesPreco(lista);
      });

      $(document).on("change", ".js-fonte-preco-check", function () {
        self.atualizarVisualFontesPreco($(this).closest(".js-fontes-preco-lista"));
      });
    }

    private inicializarEventosVinculo(): void {
      if ((this as any)._eventosVinculoIniciados) return;
      (this as any)._eventosVinculoIniciados = true;
      const self = this;
      $(document).on("click", ".btn-retentar-vinculo", function () { self.retentarVinculo($(this).data("chave")); });
      $(document).on("click", ".btn-editar-vinculo", function () { self.mostrarEdicaoCredenciaisVinculo($(this).data("chave")); });
      $(document).on("click", ".btn-remover-linha-vinculo", function () { self.removerLinhaVinculo($(this).data("chave")); });
      $(document).on("click", ".btn-salvar-retentar-vinculo", function () {
        const chave = $(this).data("chave");
        const novas = {
          email: String($(`.inp-vinc-email[data-chave='${chave}']`).val() || "").trim(),
          senha: String($(`.inp-vinc-senha[data-chave='${chave}']`).val() || "").trim(),
          auth: String($(`.inp-vinc-auth[data-chave='${chave}']`).val() || "").trim() || null,
        };
        self.retentarVinculo(chave, novas);
      });
      // 2FA inline (Fase 2)
      $(document).on("click", ".btn-enviar-codigo-2fa", function () {
        const chave = $(this).data("chave");
        const codigo = String($(`.inp-codigo-2fa[data-chave='${chave}']`).val() || "").trim();
        self.responderCodigo2FA(chave, codigo || null);
      });
      $(document).on("click", ".btn-solicitar-outro-2fa", function () { self.responderCodigo2FA($(this).data("chave"), 0); });
      $(document).on("click", ".btn-cancelar-2fa", function () { self.responderCodigo2FA($(this).data("chave"), null); });
    }

    private responderCodigo2FA(chaveVinculo: string, codigo: any): void {
      const callback = this.pendentesCodigo2FA[chaveVinculo];
      if (!callback) return;
      delete this.pendentesCodigo2FA[chaveVinculo];
      if (codigo === null) {
        this.setEstadoVinculo(chaveVinculo, { etapa: "falha", status: "erro", mensagem: "Vínculo cancelado (2FA)." });
      } else {
        this.setEstadoVinculo(chaveVinculo, { etapa: "login", status: "andamento", mensagem: "Enviando código…" });
      }
      this.responderServidor(true, { codigo: codigo }, callback);
    }

    private comunicarIniciarConta(idConta: number = null, credenciais: IDadosCredenciais = null, navegadorVisivel: boolean = false, exibirLoading: boolean = false, proxy: IProxy = null, mostrarTelaWebApp: boolean = false) {
      console.log("CREDENCIAIS INICIAR CONTA", idConta, {
        email: credenciais ? credenciais.email : null,
        tipoAuth: credenciais ? credenciais.tipoAuth : null,
        possuiSenha: Boolean(credenciais && credenciais.senha),
        possuiAuth: Boolean(credenciais && credenciais.auth),
        resolverBug: Boolean(credenciais && credenciais.resolverBug)
      })
      const ehVinculo = !idConta;
      // Vínculo (NOVO): row provisória guiada por "vinculo_progresso"; o PLUGIN registra a conta.
      const chaveVinculo = ehVinculo ? this.gerarChaveVinculo(credenciais.email) : null;
      if (ehVinculo) {
        this.adicionarLinhaProvisoriaVinculo(credenciais.email, chaveVinculo, { ...credenciais, proxy: proxy });
      }
      var conta: IConta = { id: (!idConta ? 'vinculo' : idConta) as any, email: credenciais.email, senha: credenciais.senha, auth: credenciais.auth, tokenUser: App.Util.usuario.token, tipoAuth: credenciais.tipoAuth, userAgent: null, proxy: proxy ? proxy : this.getDadosProxyVinculo(idConta) }
      if (ehVinculo) { (conta as any).chaveVinculo = chaveVinculo; }
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INICIAR_CONTA, { conta: conta, navegadorVisivel: navegadorVisivel, proxy: proxy ? proxy : this.getDadosProxyVinculo(idConta), persona: this.getPersona(), abrirComBrowserRemoto: mostrarTelaWebApp, resolverBug: credenciais.resolverBug }, (response: IRespostaMensagem) => {
        if (exibirLoading) {
          App.Util.ocultarLoadingTableContas()
        }

        // Fluxo de VÍNCULO: a row é dirigida pelos eventos "vinculo_progresso"; aqui só tratamos falha de transporte.
        if (ehVinculo) {
          if (!response.status) {
            const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível iniciar o vínculo da conta.";
            this.marcarFalhaLinhaVinculo(chaveVinculo, msg, "transporte");
          }
          return;
        }

        // Fluxo de ABERTURA de conta EXISTENTE (comportamento mantido).
        this.ocultarLoadListConta(idConta)
        if (response.status) {
          var contaIniciada: IConta = response.result.conta
          try {
            if (contaIniciada && !contaIniciada.proxy && (proxy || this.getDadosProxyVinculo(idConta))) {
              contaIniciada.proxy = proxy ? proxy : this.getDadosProxyVinculo(idConta)
            }
          } catch (e) { console.log("ERRO PREPARACAO VINCULO PROXY", e) }
          if (!$.isArray(this.arrayContas)) {
            this.arrayContas = []
            this.arrayContas.push(contaIniciada)
          }
          this.updateContaDatatable(contaIniciada);
          // Conta existente: mantém a sincronização web atual (comportamento legado preservado).
          this.vincularContaEa(contaIniciada, response.result.recarregar, exibirLoading, false);
        } else {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível iniciar a conta.";
          toastr.warning(msg, "Conta");
        }

        if (mostrarTelaWebApp) {
          console.log("comunicarIniciarConta", response)
        }
      });
    }

    private atualizarContaNoPlugin(dados: { id: number, semCache?: boolean, atualizarProxyFutTransfer?: boolean }, callback: any = (response: IRespostaMensagem) => { }) {
      if (!this.conectado) {
        return
      }
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATUALIZAR_CONTA, dados, callback);
    }

    private vincularContaEa(conta: IConta, recarregar: boolean = false, ocultarLoading: boolean = false, vinculoInicial: boolean = false) {
      console.log("vincular conta", conta.dadosEa, App.Util.config.urlSalvarContaEa);
      var obj: IVinculoConta = {
        clube: conta.dadosEa.clubeName,
        coins: conta.dadosEa.coins,
        datan: null,
        email: conta.email,
        id: conta.dadosEa.idConta,
        usuario_id: conta.dadosEa.idUsuario,
        id_img_clube: conta.dadosEa.img,
        token: conta.dadosEa.token,
        ptf: conta.dadosEa.plataforma,
        eh_vinculo: vinculoInicial,
        id_proxy: conta.proxy ? conta.proxy.id : null,
        tipo: "pro",
      };

      this.ajax = new App.Ajax();
      this.ajax.postAcao(App.Util.config.urlSalvarContaEa, obj, (objVinculoConta: IVinculoConta) => {
        console.log("vincular conta REsp", vinculoInicial, objVinculoConta, obj);
        if (!App.Util.inArray(objVinculoConta.id.toString(), this.getIdsAllContas()) || recarregar) {
          if (ocultarLoading) {
            App.Util.ocultarModalPaginaCarregando()
          }

          toastr.success("O recarregamento da página é necessário para visualizar a conta na lista.", `Conta adicionada: ${objVinculoConta.clube}`)
          if (this.infoPlanoAtual.ehPlanoCloud) {
            swal.fire({
              icon: 'success',
              title: 'Conta adicionada: ' + objVinculoConta.clube,
              text: 'Essa tela será recarregada para finalizar o processo.'
            })
            setTimeout(() => {
              document.location.reload();
            }, 5000);
          }
        }
      }, obj, false);

    }

    private aoExcluirConta(e: JQueryEventObject) {
      var textoExclusao: string = this.infoPlanoAtual.ehPlanoCloud ? "Essa conta EA será removida e desvinculada do seu Plano FutSniperWeb e não será mais exibida em seu dashboard." : "Escolha entre excluir da máquina local ou excluír e desvinculada a conta do seu Plano FutSniperWeb.";
      var idConta = $(e.currentTarget).data('idContaEa');
      swal.fire({
        title: 'Deseja excluir a Conta?',
        text: textoExclusao,
        icon: 'warning',
        confirmButtonText: 'Excluir e desvincular',
        denyButtonText: `Excluir Local`,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showDenyButton: this.infoPlanoAtual.ehPlanoCloud ? false : true,
        denyButtonColor: "#db7250",
        confirmButtonColor: "#db5250",
        allowOutsideClick: true,
        allowEscapeKey: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          console.log("Excluir geral")
          this.excluirContaPlugin(idConta)
        } else if (result.isDenied) {
          console.log("Excluir local")
          this.excluirContaPlugin(idConta, true)
        }
      });
      return;
    }

    private excluirContaPlugin(idConta: number, excluirLocalApenas: boolean = false) {
      this.exibirLoadListConta(idConta, "Excluindo Conta...")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXCLUIR_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
        App.Util.exibirModalPaginaCarregando()

        if (excluirLocalApenas) {
          swal.fire({
            icon: 'success',
            title: 'Conta excluída(LOCAL)!',
            text: "Conta excluida com sucesso em sua máquina local, reinicie seu plugin para que todas as alterações após exclusão sejam concluídas."
          })
          this.deleteContaDataTable(idConta)
          App.Util.ocultarModalPaginaCarregando()
        } else {
          this.ajax = new App.Ajax();
          this.ajax.postAcao(App.Util.config.urlSalvarContaEa, { id_conta_ea: idConta, agenda_ativa: false, excluir: true }, (resposta: any) => {

            try {
              let msgExclusao = this.infoPlanoAtual.ehPlanoCloud ? 'Seu Plugin será reiniciado, considere reativar suas tarefas automaticas caso estivesse ativa antes.' : 'Conta excluida com sucesso, reinicie seu plugin para que todas as alterações após exclusão sejam concluídas.';
              swal.fire({
                icon: 'success',
                title: 'Conta excluida!',
                text: msgExclusao
              })

              if (this.infoPlanoAtual.ehPlanoCloud) {
                $(".btn-reiniciar-plugin").click()
                setTimeout(() => {
                  this.elBtnAtualizar.click()
                }, 5000);
              }

              this.deleteContaDataTable(idConta)
            } catch (e) {
              console.log("Error processo exclusao conta", e);
            }

            App.Util.ocultarModalPaginaCarregando()
          })
        }
      });
    }

    private async atualizar(e: JQueryEventObject) {
      await this.sincronizarAtualizarDadosGeraisEntrePluginInterface();
    }

    private async salvarServidor(e: JQueryEventObject) {
      try {
        let urlSalvarServidor = $('.btn-add-servidor').data('url');
        let ip: string = $('.btn-add-servidor').data('ip').trim()
        let dadoosServidor: IServidor = { address: ip, nome: `SV_${ip}` }

        this.ajax.postAcao(urlSalvarServidor, dadoosServidor, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { perfil: { id: number, nome: string } } } }) => {
          swal.fire({
            icon: 'success',
            title: 'Servidor Salvo!',
            text: 'A seguir, essa página será atualizada.'
          })

        });
      } catch (e) {
        console.log("Error ao salvar servidor", e);
      }
    }

    private preencherCredenciais(conta: IConta) {
      let elementoCredenciais = $(`#formCredenciaisBot${conta.id}`);
      if (elementoCredenciais.length) {
        elementoCredenciais.find('input[name=email]').val(conta.email)
        elementoCredenciais.find('input[name=senha]').val(conta.senha)
        elementoCredenciais.find('input[name=auth]').val(conta.auth)
        elementoCredenciais.find('select[name=select_persona]').val(conta.persona)
      }
    }



    private preencherFormularioApiVendaCoins(form: any, configuracoesServicoVendaCoins: any) {
      for (const [prop, valor] of (Object as any).entries(configuracoesServicoVendaCoins)) {
        if (prop == "status") {
          form.find(`select[name=${prop}]`).val(valor)
        } else if (prop == "mydgn") {
          for (const [p, val] of (Object as any).entries(valor.credenciais)) {
            form.find(`input[name=${p}]`).val(val)
          }
        } else {
          form.find(`input[name=${prop}]`).val(valor)
          form.find(`select[name=${prop}]`).val(valor).trigger("change");
        }
      }
    }

    private atualizarViewCreditosConta(id: number, creditos: number) {
      this.updateCoinsContaDatatable(id, creditos)
    }
    private atualizarViewLucroConta(id: number, lucro: number) {
      this.updateLucroContaDatatable(id, lucro)
    }

    private atualizarStatusContaSemMercado(id: number) {
      let elementoConta = this.getElementoListConta(id);
      elementoConta.find('.badge-sem-mercado').show()
    }

    private normalizarStatusContaPeloNavegador(status: any, navegadorStatus: any): number {
      const statusNumerico = Number(status);
      if (statusNumerico === Util.STATUS_CONTA_ABERTA && navegadorStatus !== true) {
        return Util.STATUS_CONTA_PARADA;
      }
      return statusNumerico;
    }

    private normalizarRequestStatusConta(request: any): any {
      if (!request) {
        return request;
      }
      const navegadorStatus = request.hasOwnProperty('navegador_status') ? request.navegador_status : undefined;
      const statusNormalizado = this.normalizarStatusContaPeloNavegador(request.status, navegadorStatus);
      if (statusNormalizado !== Number(request.status)) {
        request = Object.assign({}, request, {
          status: statusNormalizado,
          navegador_status: false,
        });
      }
      return request;
    }

    private normalizarContaTabela(conta: IConta): IConta {
      if (!conta) {
        return conta;
      }
      const statusNormalizado = this.normalizarStatusContaPeloNavegador(conta.status, (conta as any).navegador_status);
      if (statusNormalizado !== Number(conta.status)) {
        conta.status = statusNormalizado;
        (conta as any).navegador_status = false;
      }
      const execucaoAtual: any = (conta as any).execucao;
      const manterExecucaoAberta = statusNormalizado === Util.STATUS_CONTA_ABERTA && Boolean(execucaoAtual && (execucaoAtual.funcionamentoAtual || execucaoAtual.tarefaAtual));
      if (statusNormalizado !== Util.STATUS_CONTA_EXECUCAO && !manterExecucaoAberta) {
        delete (conta as any).execucao;
      }
      if (this.contaExecutandoTarefaSniper(conta)) {
        delete (conta as any).loadList;
      }
      return conta;
    }

    private getTarefaAtualConta(objConta: IConta): any {
      return objConta && objConta.execucao && objConta.execucao.tarefaAtual
        ? (objConta.execucao.tarefaAtual as any)
        : null;
    }

    private tarefaContaEhTipo(tarefaAtual: any, tipo: number): boolean {
      if (!tarefaAtual) {
        return false;
      }
      return Number(tarefaAtual.id) === tipo || Number(tarefaAtual.tipo) === tipo;
    }

    private getNomeFiltroExecucaoConta(objConta: IConta): string {
      const funcionamentoAtual: any = objConta && objConta.execucao ? objConta.execucao.funcionamentoAtual : null;
      const filtro = funcionamentoAtual && funcionamentoAtual.filtro !== undefined ? funcionamentoAtual.filtro : null;
      if (filtro === null || filtro === undefined) {
        return "";
      }
      if ($.isArray(filtro)) {
        return filtro.map((item: any) => String(item == null ? "" : item).trim()).filter(Boolean).join(", ");
      }
      if (typeof filtro === "object") {
        return String((filtro as any).nome || (filtro as any).name || (filtro as any).label || "").trim();
      }
      return String(filtro).trim();
    }

    private contaExecutandoTarefaSniper(objConta: IConta): boolean {
      if (!objConta || objConta.status !== Util.STATUS_CONTA_EXECUCAO) {
        return false;
      }
      const tarefaAtual = this.getTarefaAtualConta(objConta);
      if (this.tarefaContaEhTipo(tarefaAtual, Util.TAREFA_SNIPER)) {
        return true;
      }
      if (this.tarefaContaEhTipo(tarefaAtual, Util.TAREFA_AUTO_DME) || this.tarefaContaEhTipo(tarefaAtual, Util.TAREFA_VENDA_COINS)) {
        return false;
      }
      const nomeTarefa = tarefaAtual && tarefaAtual.nome ? String(tarefaAtual.nome).toLowerCase() : "";
      if (nomeTarefa.indexOf("auto dme") >= 0 || nomeTarefa.indexOf("venda") >= 0 || nomeTarefa.indexOf("coins") >= 0) {
        return false;
      }
      return Boolean(this.getNomeFiltroExecucaoConta(objConta));
    }

    private renderStatusContaCompacto(obj: IConta, objStatus: any, statusVisual: number): string {
      const executando = statusVisual === Util.STATUS_CONTA_EXECUCAO;
      const nomeFiltro = executando ? this.getNomeFiltroExecucaoConta(obj) : "";
      const spinner = executando
        ? `<span class="spinner-border spinner-border-sm conta-status-spinner" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>`
        : ``;
      const cronometro = executando
        ? `<span class="cronometro${obj.id} conta-status-cronometro"><span class="values font-size-12 text-muted font-weight-600"></span></span>`
        : ``;
      const filtroChip = nomeFiltro
        ? `<span title="Filtro em execucao: ${this.htmlEscape(nomeFiltro)}" class="conta-filtro-execucao-chip"><i class="fas fa-funnel-dollar"></i><span class="info-filtro">${this.htmlEscape(nomeFiltro)}</span></span>`
        : ``;
      const limiteAtingidoHtml = this.renderLimitesConta(obj);

      return `
                <div class="conta-status-compact">
                  <span class="badge badge-${objStatus.class} text-uppercase conta-status-badge ${executando ? 'conta-status-badge-executando' : ''}">${spinner}<span>${this.htmlEscape(objStatus.status)}</span>${cronometro}</span>
                  ${limiteAtingidoHtml}
                  ${filtroChip}
                </div>
                `;
    }

    private atualizarStatusConta(request: { dadosEa: any, status: number, id: number, data: any, tarefa: any, navegador_status: boolean, seq?: number, updatedAt?: string }) {
      request = this.normalizarRequestStatusConta(request);
      var { status, id, data, tarefa, navegador_status } = request;
      var apenasAtualizacaoDeStatus = !(request.hasOwnProperty('dadosEa') && request.dadosEa.idConta)

      // if (apenasAtualizacaoDeStatus) {
      //   return
      // }

      if (this.arrayContas.length) {
        this.atualizarEstadoModalSniper(id, status)
      }
      this.enfileirarAtualizacaoStatusConta(request)
    }

    private enfileirarAtualizacaoStatusConta(request: { status: number, id: number, data: any, tarefa: any, navegador_status: boolean, seq?: number, updatedAt?: string, force_emit_status?: boolean, _retryMissingRow?: number, limite_atingido?: any, limite_compras_atingido?: any, limite_compras_sniper_atingido?: any, limite_requests_compra_atingido?: any }) {
      if (!request || !request.id) {
        return;
      }
      const idConta = Number(request.id);
      request = this.normalizarRequestStatusConta(request);
      this.metricStatusUpdatesReceived += 1;
      const seqRequest = request.seq ? Number(request.seq) : 0;
      const seqAtual = this.lastStatusSeqByContaId[idConta] || 0;
      const forceEmitStatus = request.force_emit_status === true;
      if (!forceEmitStatus && seqRequest > 0 && seqRequest < seqAtual) {
        this.metricStatusUpdatesDeduped += 1;
        return;
      }

      const assinatura = JSON.stringify({
        status: request.status,
        navegador_status: request.hasOwnProperty('navegador_status') ? request.navegador_status : null,
        data: request.data || null,
        tarefaId: request.tarefa && (request.tarefa as any).id ? (request.tarefa as any).id : null,
        limite_atingido: request.hasOwnProperty('limite_atingido') ? request.limite_atingido : null,
        limite_compras_atingido: request.hasOwnProperty('limite_compras_atingido') ? request.limite_compras_atingido : null,
        limite_compras_sniper_atingido: request.hasOwnProperty('limite_compras_sniper_atingido') ? request.limite_compras_sniper_atingido : null,
        limite_requests_compra_atingido: request.hasOwnProperty('limite_requests_compra_atingido') ? request.limite_requests_compra_atingido : null,
      });

      if (!forceEmitStatus && this.lastStatusSignatureByContaId[idConta] === assinatura && (!seqRequest || seqRequest === seqAtual)) {
        this.metricStatusUpdatesDeduped += 1;
        return;
      }

      const pendenteAtual = this.pendingStatusUpdatesByContaId[idConta] || {};
      this.pendingStatusUpdatesByContaId[idConta] = {
        ...pendenteAtual,
        ...request,
        _retryMissingRow: 0,
      };
      this.agendarFlushStatusContas();
    }

    private agendarFlushStatusContas() {
      if (this.statusQueueFlushScheduled) {
        return;
      }
      this.statusQueueFlushScheduled = true;
      const flush = () => this.flushAtualizacoesStatusContas();
      if (typeof window !== "undefined" && window.requestAnimationFrame) {
        window.requestAnimationFrame(flush);
      } else {
        setTimeout(flush, 16);
      }
    }

    private flushAtualizacoesStatusContas() {
      this.statusQueueFlushScheduled = false;
      if (!App.Business.objDataTableContas) {
        this.agendarFlushStatusContas();
        return;
      }
      const updates = this.pendingStatusUpdatesByContaId;
      this.pendingStatusUpdatesByContaId = {};
      const idsContas = Object.keys(updates).map((id: string) => parseInt(id));
      if (!idsContas.length) {
        return;
      }

      let houveMudanca = false;
      for (const idConta of idsContas) {
        const request = updates[idConta];
        const seqRequest = request && request.seq ? Number(request.seq) : 0;
        const seqAtual = this.lastStatusSeqByContaId[idConta] || 0;
        const forceEmitStatus = request && request.force_emit_status === true;
        if (!forceEmitStatus && seqRequest > 0 && seqRequest < seqAtual) {
          this.metricStatusUpdatesDeduped += 1;
          continue;
        }
        const navegadorInf = request && request.hasOwnProperty('navegador_status') ? request.navegador_status : undefined;
        const alterou = this.updateStatusContaDatatable(
          idConta,
          request.status,
          request.data,
          request.tarefa,
          navegadorInf,
          { draw: false, reorder: false, extraConta: request }
        );
        if (alterou) {
          houveMudanca = true;
          const assinatura = JSON.stringify({
            status: request.status,
            navegador_status: request.hasOwnProperty('navegador_status') ? request.navegador_status : null,
            data: request.data || null,
            tarefaId: request.tarefa && (request.tarefa as any).id ? (request.tarefa as any).id : null,
            limite_atingido: request.hasOwnProperty('limite_atingido') ? request.limite_atingido : null,
            limite_compras_atingido: request.hasOwnProperty('limite_compras_atingido') ? request.limite_compras_atingido : null,
            limite_compras_sniper_atingido: request.hasOwnProperty('limite_compras_sniper_atingido') ? request.limite_compras_sniper_atingido : null,
            limite_requests_compra_atingido: request.hasOwnProperty('limite_requests_compra_atingido') ? request.limite_requests_compra_atingido : null,
          });
          this.lastStatusSignatureByContaId[idConta] = assinatura;
          if (seqRequest > 0) {
            this.lastStatusSeqByContaId[idConta] = seqRequest;
          }
        } else if (forceEmitStatus) {
          const retryMissingRow = Number(request._retryMissingRow || 0) + 1;
          if (retryMissingRow <= 600) {
            this.pendingStatusUpdatesByContaId[idConta] = {
              ...request,
              _retryMissingRow: retryMissingRow,
            };
          }
        }
      }

      if (houveMudanca && App.Business.objDataTableContas) {
        App.Business.objDataTableContas.draw(false);
      }
      if (this.pendingSortContaIds.size && App.Business.objDataTableContas) {
        App.Business.objDataTableContas.order([2, 'asc']).draw(false);
        this.pendingSortContaIds.clear();
      }
      if (Object.keys(this.pendingStatusUpdatesByContaId).length) {
        this.agendarFlushStatusContas();
      }
      this.metricStatusFlushCount += 1;
      if (this.metricStatusFlushCount % 50 === 0) {
        console.log("STATUS_QUEUE_METRICS", {
          recebidos: this.metricStatusUpdatesReceived,
          dedupados: this.metricStatusUpdatesDeduped,
          flushes: this.metricStatusFlushCount
        });
      }
    }

    private getStateViewAcoes(id: number, status: number): IViewAcoes {
      if (status == Util.STATUS_CONTA_ABERTA) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else if (status == Util.STATUS_CONTA_EXECUCAO) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: true,
          btnPararTarefa: true,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else if (status == Util.STATUS_CONTA_VENDENDO_COINS) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: true
        }
      } else if (status == Util.STATUS_CONTA_PARADA || status == Util.STATUS_ERROS_REPETIDOS_EM_SEQUENCIA) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else if (status == Util.STATUS_POSSIVEL_SOFTBAN_BUSCA || status == Util.STATUS_POSSIVEL_SOFTBAN_COMPRA
        || status == Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_1 || status == Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_2) {
        return {
          btnResolverCatptcha: false,
          btnAutenticar: false,
          btnParar: false,
          btnPararTarefa: false,
          btnAbrirSniper: true,
          btnPararVendaCoins: false
        }
      } else {
        var ehCaptcha = status == Util.STATUS_CONTA_CAPTCHA || status == Util.STATUS_CONTA_CAPTCHA_FALHA_AUTOCAPTCHA;
        if (ehCaptcha) {
          // if (Util.loadCarregamentoId == id) {
          //   Util.ocultarModalPaginaCarregando();
          // }
          return {
            btnResolverCatptcha: true,
            btnAutenticar: false,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        } else if (status == Util.STATUS_CONTA_SEM_MERCADO) {
          return {
            btnResolverCatptcha: false,
            btnAutenticar: false,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        } else if (status == Util.STATUS_CONTA_DESABILITADA_PELA_EA) {
          // RedBan: não abre automaticamente, mas permite abertura manual (Autenticar) para reativar
          // caso a EA reabilite a conta.
          return {
            btnResolverCatptcha: false,
            btnAutenticar: true,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        } else {
          return {
            btnResolverCatptcha: false,
            btnAutenticar: true,
            btnParar: false,
            btnPararTarefa: false,
            btnAbrirSniper: false,
            btnPararVendaCoins: false
          }
        }
      }
    }

    private async continuarinicializacaodashBoard() {
      if (this.inicializacaoDashBoardConcluida) {
        return
      }
      return new Promise(async (resolve: any, reject: any) => {
        this.iniciarConfiguracoesDeConta(null);
        this.obterConfiguracaoGeralAtualizada(() => {
          this.obterLogsDoDia();
          this.obterMediaDelay();
          this.atualizarContasVinculadasNoPlugin()
          this.inicializacaoDashBoardConcluida = true
          resolve()
        });

      })
    }

    private async obterViewPartialsContas(ids: number[]) {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          this.ajax.get(App.Util.config.urlPartialsViewContas, { "ids": ids }, (dadosSucesso: IRespostaSucessoAjx) => {
            $("#modalsFormViewPartialsContas").append(dadosSucesso.dadosRetornados);
            for (let id of ids) {
              this.preencherCredenciais((this.arrayContas as any).find((conta: IConta) => conta.id == id))
            }
            resolve()
          }, null, null, false)
        } catch (error) {
          console.log("error obterViewPartialsContas", error)
          resolve()
        }
      })
    }

    private async carregarPartialsViewsContas() {
      let modalsFormViewPartialsContas = document.getElementById('modalsFormViewPartialsContas');
      if (modalsFormViewPartialsContas.childNodes.length) {
        return
      }

      return new Promise(async (resolve: any, reject: any) => {
        try {
          if (!this.ajax) {
            this.ajax = new Ajax();
          }
          $("#modalsFormViewPartialsContas").html('')
          let arrayIdsContasVinculadas = this.getIdsContasEaVinculadasPlugin()
          // console.log("arrayIdsContasVinculadas", arrayIdsContasVinculadas)
          // preciso a cada 10 ids chamar a view parcial
          let arrayIdsContasVinculadasChunks = _.chunk(arrayIdsContasVinculadas, 50)
          for await (let ids of arrayIdsContasVinculadasChunks) {
            await this.obterViewPartialsContas(ids)
          }

          resolve()
        } catch (e) {
          console.log("error carregarPartialsViewsContas", e)
          resolve()
        }

      })
    }

    private executarAcoesAoLigarDesligarPlugin(request: any) {
      var { status, tarefa_ligada, versao, ip, otimizacao_rede_windows_status, hd_espaco, proxy_server_ativo, restauracao } = request;
      this.pluginLigado = status;
      this.tarefaLigada = tarefa_ligada;
      this.versaoPlugin = versao;
      this.ipPlugin = ip;

      // Conclusão de restauração: se o plugin trouxe o marcador, usa o detalhe (sucesso/falha).
      // Fallback: se estávamos aguardando e o plugin reconectou sem marcador, considera concluída
      // (a reconexão após o restart já indica que a restauração foi aplicada) — evita travar em 95%.
      if (restauracao) {
        this.tratarConclusaoRestauracao(restauracao);
      } else if (this.restauracaoEmAndamento) {
        this.tratarConclusaoRestauracao({ sucesso: true });
      }
      // Atualiza a disponibilidade da importação no modal (conexão)
      this.atualizarDisponibilidadeRestauracao();
      // console.log("PLUGIN LIGADO", this.pluginLigado, this.versaoPlugin, App.Util.config.versaoAtualPluginVersaoPro)
      if (this.pluginLigado) {
        this.sincronizarAtualizarDadosGeraisEntrePluginInterface();
      }

      try {
        if (this.versaoPlugin) {
          $(".plugin-versao").html(this.versaoPlugin.toString());
        }
      } catch (e) { }

      if (this.versaoPlugin && App.Util.config.versaoAtualPluginVersaoPro && App.Util.config.avisarSobreAtualizacaoPlugin) {
        try {
          // console.log({ versaoPlugin: Util.parseVersion(this.versaoPlugin), versaoAtual: Util.parseVersion(App.Util.config.versaoAtualPluginVersaoPro) })
          if (Util.parseVersion(this.versaoPlugin) < Util.parseVersion(App.Util.config.versaoAtualPluginVersaoPro)) {
            if (App.Util.config.pluginFazerDownload) {
              swal.fire({
                icon: 'warning',
                title: "Plugin desatualizado!",
                text: "Existe uma versão mais nova do Plugin FutSniperWeb PRO, é importante que você desligue-o, faça download e instale a nova versão " + App.Util.config.versaoAtualPluginVersaoPro,
                type: "info",
                showCancelButton: false,
                confirmButtonText: "Download",
                confirmButtonColor: '#3740FF'
              }).then(function (result: any) {
                if (result.hasOwnProperty('value') && result.value) {
                  window.open(
                    App.Util.config.urlPluginFswPro,
                    '_blank'
                  );
                  return;
                }
              });
            } else {
              swal.fire({
                icon: 'warning',
                title: "Plugin desatualizado!",
                text: "Atualize seu plugin para a nova versão " + App.Util.config.versaoAtualPluginVersaoPro + ", Reinicie o Plugin no menu superior(Reiniciar Plugin) do dashboard ou clique em atualizar agora.",
                type: "info",
                showCancelButton: false,
                confirmButtonText: "Atualizar Agora",
                confirmButtonColor: '#2dce89'
              }).then((result: any) => {
                if (result.hasOwnProperty('value') && result.value) {
                  $(".btn-reiniciar-plugin").click()
                  return;
                }
              });
            }
          }
        } catch (e) {
          console.log("error conferencia versao plugin", e)
        }
      }

      $('input[name=tarefa_ligada]').prop("checked", this.tarefaLigada)
      $('input[name=ativar_proxy_server]').prop("checked", !!proxy_server_ativo)

      this.atualizarExibicaoOtimizacaoRedeWindows(otimizacao_rede_windows_status);
      this.atualizarExibicaoHdServidor(hd_espaco);

      if (request && request.ip && $('.btn-add-servidor') && $('.btn-add-servidor').data('ips')) {
        let ipsServidores = JSON.parse(JSON.stringify($('.btn-add-servidor').data('ips')))
        let objIps = JSON.parse(JSON.stringify($('.btn-add-servidor').data('objips')))

        $('.btn-add-servidor').attr('data-ip', request.ip)
        $('.btn-add-servidor').prop('data-ip', request.ip)
        // console.log("REQ SERVER", request, ipsServidores, objIps);

        if (!ipsServidores.includes(request.ip.toString())) {
          // console.log("SERVER NAO SALVO")
          $('.btn-add-servidor .text-servidor').html('<i class="fas fa-save"></i>&nbsp;Salvar Servidor')
          $('.btn-add-servidor .text-ip').html(request.ip)
          $('.btn-add-servidor').show()
          $('.info-servidor').hide()
        } else {
          // console.log("SERVER SALVO", `.` + `linha-servidor${request.ip}`.replace(/\./g, ''))
          $('.info-servidor .text-servidor').html(objIps[request.ip])
          $('.info-servidor .text-ip').html(request.ip)
          $('.info-servidor').show()
          $('.btn-add-servidor').hide()
          $(`.` + `linha-servidor${request.ip}`.replace(/\./g, '')).addClass('bg-servidor-select')
        }
      } else {
        $('.btn-add-servidor').hide()
        $('.info-servidor').hide()
      }
    }

    private atualizarExibicaoOtimizacaoRedeWindows(status: string) {
      try {
        const $el = $(".info-otimizacao-rede-windows");
        const $badge = $(".info-otimizacao-rede-windows-badge");
        if (!this.infoPlanoAtual.ehAdmin || this.infoPlanoAtual.ehPlanoCloud || !status || status === 'desabilitada' || status === 'nao_windows' || !this.pluginLigado) {
          $el.hide();
          return;
        }
        $el.show().attr("title", status === 'aplicada'
          ? "Otimização de rede Windows aplicada"
          : "Otimização de rede pendente. Inicie o plugin pelo menos uma vez como Administrador para aplicar.");
        if (status === 'aplicada') {
          $badge.html('<i class="fas fa-network-wired mr-1"></i><span class="text-success">Rede optimizada ✓</span>');
        } else {
          $badge.html('<i class="fas fa-network-wired mr-1"></i><span class="text-warning">Rede não optimizada ⚠ (admin)</span>');
        }
      } catch (error) {
        console.log("error atualizarExibicaoOtimizacaoRedeWindows", error)
      }
    }

    private atualizarExibicaoHdServidor(hd: { total: number; livre: number } | null) {
      try {
        const $el = $(".info-hd-servidor");
        const $badge = $(".info-hd-servidor-badge");
        // Só exibe quando o plugin está conectado e enviou o espaço em disco do servidor.
        if (!this.pluginLigado || !hd || !(Number(hd.total) > 0)) {
          $el.hide();
          return;
        }
        const gb = (bytes: number) => Number(bytes) / (1024 * 1024 * 1024);
        const totalGb = gb(hd.total);
        const livreGb = gb(Math.max(0, Number(hd.livre) || 0));
        const percentLivre = totalGb > 0 ? (livreGb / totalGb) * 100 : 0;
        const fmt = (v: number) => v >= 100 ? v.toFixed(0) : v.toFixed(1);
        const cor = percentLivre <= 10 ? 'text-danger' : (percentLivre <= 25 ? 'text-warning' : 'text-primary');
        $el.show().attr("title", `Espaço em disco do servidor: ${fmt(livreGb)} GB livres de ${fmt(totalGb)} GB (${percentLivre.toFixed(0)}% livre)`);
        $badge.html(`<span class="${cor}">${fmt(livreGb)} / ${fmt(totalGb)} GB livre</span>`);
      } catch (error) {
        console.log("error atualizarExibicaoHdServidor", error)
      }
    }

    private informarBaseDadosCorrompida(request: { status: boolean, caminho: string }) {
      if (request.status) {
        swal.fire({
          icon: 'warning',
          title: 'Base de dados Corrompida foi Restaurada!',
          text: `Isso pode acontecer quando o seu computador é desligado de forma repentina/incorreta, o último backup encontrado foi restaurado, os backups automáticos são executados aproximadamente de 5 em 5 minutos.`
        })

      } else {
        swal.fire({
          icon: 'warning',
          title: 'Base de dados Corrompida!',
          text: `Isso pode acontecer quando o seu computador é desligado de forma repentina/incorreta, não encontramos nenhum backup anterior para restauração, o arquivo corrompido deve ser excluido no caminho informado a seguir e o plugin deve ser reiniciado. Caminho do arquivo: ${request.caminho}`
        })
      }
    }

    private exibirPlanoExpirado(request: any) {
      swal.fire({
        icon: 'warning',
        title: 'Plano Expirado',
        text: 'Seu Plano expirou, recarregue a pagina para ativar um novo Plano'
      })

      setTimeout(() => {
        document.location.reload();
      }, 20000);
    }

    private exibirViewConexao() {
      if (this.conectado) {
        $(".btn-conectado").show();
        $(".btn-desconectado").hide();
        $("input[name=agenda_ativa]").prop('disabled', false);
        this.quantidadeFalhaConexaoPlugin = 0
      } else {
        $(".btn-conectado").hide();
        $(".btn-desconectado").show();
        this.desabilitarInfoAgendamento();
        $("input[name=agenda_ativa]").prop('disabled', true);
        $(".plugin-versao").html('');
        $(".info-otimizacao-rede-windows").hide();
        $(".info-hd-servidor").hide();
      }
    }

    private exibirFalhaNaAutenticacao(conta: IConta) {
      Util.ocultarModalPaginaCarregando();
      swal.fire({
        icon: 'error',
        title: 'Falha na Autenticação: ' + conta.email,
        text: 'Email ou senha inválido!'
      })
    }

    private atualizarCreditos(id: number, creditos: number, lucro: number = null) {
      this.atualizarViewCreditosConta(id, creditos)
      if (lucro) {
        this.atualizarViewLucroConta(id, lucro)
      }
    }

    public responderServidor(status: boolean, request: any, callback: any = null) {
      return callback && callback({ status: status, result: request });
    }

    private atualizarViewInfoAgendamento(idConta: number, programacao: any[] = []) {
      if (programacao.length) {
        this.updateAgendaContaDatatable(idConta, programacao)
      }
    }

    private desabilitarInfoAgendamento() {
      $('.btn-info-agenda').hide();
      $('.btn-info-agenda').attr('data-content', '');
    }

    private aoClicarAgendamentoSemFiltro(e: JQueryEventObject) {
      this.exibirAlertaNecessarioCadastrarFiltro();
    }
    private aoClicarAgendamentoExigido(e: JQueryEventObject) {
      this.exibirAlertaNecessarioCadastrarUmaAgenda();
    }

    public exibirAlertaNecessarioCadastrarUmaAgenda(): void {
      this.alertPrecisaAddConta = swal.fire({
        title: 'Adicione um agendamento!',
        confirmButtonColor: "#f9ca3b",
        text: 'Antes de criar um perfil é necessário que você tenha cadastrado pelo menos 1 agendamento, clique na aba "Agendamentos" para cadastrar um agendamento',
        imageUrl: '/img/gifs/add-filtro.png',
        imageWidth: 405,
        imageAlt: 'Cadastre Agendamento',
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    }
    public exibirAlertaNecessarioCadastrarFiltro(): void {
      this.alertPrecisaAddConta = swal.fire({
        title: 'Crie um filtro!',
        confirmButtonColor: "#f9ca3b",
        text: 'Antes de agendar uma tarefa é necessário que você tenha cadastrado pelo menos 1 filtro, clique na aba "Filtros" para cadastrar um filtro',
        imageUrl: '/img/gifs/add-filtro.png',
        imageWidth: 405,
        imageAlt: 'Cadastre filtro',
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    }

    private obterTempoExecucaoAposSalvarAgendamento(index: number, dadosRetornados: IRespostaDadosRetornadosAjaxPostAcao): { tempo: number, info: string } {
      let objInfo = { tempo: 0, info: "" }
      if (dadosRetornados.hasOwnProperty("dadosResposta") && dadosRetornados.dadosResposta.dados && dadosRetornados.dadosResposta.dados.length) {
        let agendamentos = dadosRetornados.dadosResposta.dados
        if (agendamentos.length) {
          let objAgendamento = agendamentos[index];
          if (objAgendamento && objAgendamento.tarefa && objAgendamento.tarefa.data) {
            objInfo.tempo = Util.parseMilisegundosParaMinutos(objAgendamento.tarefa.data.tempo)
            objInfo.info = Util.getDescricaoHumanaMilissegundos(objAgendamento.tarefa.data.tempo)
          }
        }

        return objInfo
      }
    }

    private obterInfoNomeFiltrosSalvosAposSalvarAgendamento(index: number, dadosRetornados: IRespostaDadosRetornadosAjaxPostAcao): string {
      let infoNamesFiltros = ""
      if (dadosRetornados.hasOwnProperty("dadosResposta") && dadosRetornados.dadosResposta.dados && dadosRetornados.dadosResposta.dados.length) {
        let agendamentos = dadosRetornados.dadosResposta.dados
        if (agendamentos.length) {
          let objAgendamento = agendamentos[index];
          if (objAgendamento && objAgendamento.tarefa && objAgendamento.tarefa.data) {
            let filtros = objAgendamento.tarefa.data.filtros
            if (filtros && filtros.length) {
              infoNamesFiltros = _.pluck(filtros, 'nome').join(', ')
            }
          }
        }

        return infoNamesFiltros
      }
    }

    private preencherItemAgendamento(modal: JQuery, formConta: JQuery, objAgendamento: IObjAgendamento, agendamentoConfig: IAgendamentoConfiguracao, index: number): void {
      // console.log("PREENCHER::", index, agendamentoConfig)
      if (index > 0) {
        modal.find(`#add-more${objAgendamento.id}`).click();
      }

      var elementoContainer: JQuery = formConta.find('#containerItem' + index);
      elementoContainer.find("select[name='dia[]']").val(agendamentoConfig.dia);
      elementoContainer.find("input[name='hora[]']").val(agendamentoConfig.hora);

      var pilotoAutomatico = !agendamentoConfig.tarefa.data || (agendamentoConfig.tarefa.data.filtros && !agendamentoConfig.tarefa.data.filtros.length)
      elementoContainer.find('input[name=piloto_automatico]').prop("checked", pilotoAutomatico).trigger("change");

      let temFiltros: boolean = false;
      let infoNamesFiltros: string = "";
      let infoExecucao: string = "";

      var agendamento: IFuncaoSniperOptions = agendamentoConfig.tarefa.data;
      if (!pilotoAutomatico) {
        var selectVelocidade: JQuery = elementoContainer.find("select[name='velocidade[]']");
        var selectDescanso: JQuery = elementoContainer.find("select[name='descanso[]']");
        var selectIntervalo: JQuery = elementoContainer.find("select[name='intervalo[]']");
        var selectTempo: JQuery = elementoContainer.find("select[name='tempo[]']");

        this.objSelect2.setSelectTag(selectVelocidade, { id: agendamento.velocidade.toString(), text: (agendamento.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectDescanso, { id: agendamento.descanso.toString(), text: (agendamento.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectIntervalo, { id: agendamento.intervalo.toString(), text: (agendamento.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectTempo, { id: agendamento.tempo.toString(), text: (agendamento.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

        var filtrosSelect: string[] = [];
        elementoContainer.find("input[name='porcentagem_eficacia[]']").val(agendamento.porcentagem_eficacia);
        elementoContainer.find("input[name='tempo_minimo_eficacia[]']").val(agendamento.tempo_minimo_eficacia);
        elementoContainer.find("input[name='limite_compra[]']").val(agendamento.limite_compra);

        temFiltros = agendamento.filtros && agendamento.filtros.length > 0;

        if (temFiltros) {
          infoNamesFiltros = _.pluck(agendamento.filtros, 'nome').join(', ')
          // console.log("FILTROS", infoNamesFiltros)
          $.each(agendamento.filtros, function (index2: any, filtro: IFiltroOptions) {
            filtrosSelect.push(filtro.id);
          });
        }

        infoExecucao = Util.getDescricaoHumanaMilissegundos(agendamento.tempo)


        // console.log("filtrosSelect", formConta, index, filtrosSelect)

        formConta.find('select.select2').eq(index).val(filtrosSelect).trigger('change').trigger('select2:select');
      } else {
        var selectTempo: JQuery = elementoContainer.find("select[name='tempo[]']");
        this.objSelect2.setSelectTag(selectTempo, { id: agendamento.tempo.toString(), text: (agendamento.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })
        elementoContainer.find("input[name='limite_compra[]']").val(agendamento.limite_compra);
      }

      this.atualizarViewContainerAgendamento(elementoContainer, agendamentoConfig, temFiltros, infoNamesFiltros, infoExecucao)

    }
    private preencherAgendamentos(formConta: JQuery, modal: JQuery, objAgendamento: IObjAgendamento): void {
      formConta.find('input[name=id]').val(objAgendamento.id);
      formConta.find('input[name=nome]').val(objAgendamento.nome);

      var tempoTotalExecucao = objAgendamento.dados.reduce((accumulator, object: IAgendamentoConfiguracao) => {
        return accumulator + (object.tarefa.data && object.tarefa.data.tempo ? Util.parseMilisegundosParaMinutos(object.tarefa.data.tempo) : 0);
      }, 0);
      this.atualizarTempoTotalExecucao(formConta, tempoTotalExecucao)
      // console.log("tempoTotalExecucao::", tempoTotalExecucao)
      $.each(objAgendamento.dados, (index: any, agendamentoConfig: IAgendamentoConfiguracao) => {
        this.preencherItemAgendamento(modal, formConta, objAgendamento, agendamentoConfig, index)
      });
    }

    private preencherFormPerfil(formConta: JQuery, modal: JQuery, objPerfil: IPerfil): void {
      formConta.find('input[name=id]').val(objPerfil.id);
      formConta.find('input[name=nome]').val(objPerfil.nome);
      // Remove chaves com [] do dados antes do preenchimento genérico — arrays (exceto_dia, filtros, etc.) tratados abaixo
      const dadosSemArrayKeys = (Object as any).fromEntries(
        (Object as any).entries(objPerfil.dados || {}).filter(([k]: any) => !k.includes('[]'))
      );
      Util.preencherFormularioComCamposAninhados(formConta, dadosSemArrayKeys)

      formConta.find('input[name=piloto_automatico]').prop("checked", objPerfil.dados.piloto_automatico).trigger("change");

      var selectVelocidade: JQuery = formConta.find("select[name='velocidade']");
      var selectDescanso: JQuery = formConta.find("select[name='descanso']");
      var selectIntervalo: JQuery = formConta.find("select[name='intervalo']");
      var selectTempo: JQuery = formConta.find("select[name='tempo']");
      // console.log("PREENCHENDO PERFIL::", objPerfil.dados.velocidade, objPerfil.dados)

      this.objSelect2.setSelectTag(selectVelocidade, { id: objPerfil.dados.velocidade.toString(), text: (objPerfil.dados.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
      this.objSelect2.setSelectTag(selectDescanso, { id: objPerfil.dados.descanso.toString(), text: (objPerfil.dados.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
      this.objSelect2.setSelectTag(selectIntervalo, { id: objPerfil.dados.intervalo.toString(), text: (objPerfil.dados.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
      this.objSelect2.setSelectTag(selectTempo, { id: objPerfil.dados.tempo.toString(), text: (objPerfil.dados.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

      // formConta.find("input[name='porcentagem_eficacia[]']").val(objPerfil.dados.porcentagem_eficacia);
      // formConta.find("input[name='tempo_minimo_eficacia[]']").val(objPerfil.dados.tempo_minimo_eficacia);
      formConta.find("input[name='limite_compra']").val(objPerfil.dados.limite_compra);


      if (objPerfil.dados.exceto_dia && objPerfil.dados.exceto_dia.length > 0) {
        formConta.find("select[name='exceto_dia[]']").val(objPerfil.dados.exceto_dia).trigger('change').trigger('select2:select')
      }

      if (objPerfil.dados.filtros && objPerfil.dados.filtros.length > 0) {
        formConta.find("select[name='filtros[]']").val(_.pluck(objPerfil.dados.filtros, 'id')).trigger('change').trigger('select2:select')
      }

      if (objPerfil.dados.autodmes && objPerfil.dados.autodmes.length > 0) {
        formConta.find("select[name='autodmes[]']").val(_.pluck(objPerfil.dados.autodmes, 'id')).trigger('change').trigger('select2:select')
      }
      // "Ativar Lista Completa" ligada: desabilita/limpa a seleção manual (sobrepõe o fill acima).
      this.atualizarDisponibilidadeSelecaoAutodmes(formConta);

      // Preenche campo comportamento_auto_dme_limite_requests se existir
      if (objPerfil.dados && objPerfil.dados.comportamento_auto_dme_limite_requests != null) {
        const compReq = String(objPerfil.dados.comportamento_auto_dme_limite_requests);
        formConta.find("select[name='comportamento_auto_dme_limite_requests']").val(compReq).trigger('change');
      }

      // Preenche campo api_integracoes se existir
      if (objPerfil.dados.api_integracoes && objPerfil.dados.api_integracoes.length > 0) {
        formConta.find("select[name='api_integracoes[]']").val(objPerfil.dados.api_integracoes.map((id: number) => String(id))).trigger('change').trigger('select2:select');
      }

      const fontesAtivas: string[] = Array.isArray(objPerfil.dados.fontes_preco)
        ? objPerfil.dados.fontes_preco
        : Business.FONTES_PRECO_PADRAO.slice();
      this.aplicarOrdemFontesPreco(formConta, fontesAtivas);
      const zyteApiValorPerfil: any = (objPerfil.dados as any).zyte_api;
      const zyteApiAtivoPerfil = zyteApiValorPerfil === true
        || zyteApiValorPerfil === "true"
        || zyteApiValorPerfil === 1
        || zyteApiValorPerfil === "1";
      const zyteApiKeyPerfil = objPerfil.dados.zyte_api_key ? String(objPerfil.dados.zyte_api_key) : "";
      formConta.find("input[name='zyte_api']").prop('checked', zyteApiAtivoPerfil);
      formConta.find("input[name='zyte_api_key']")
        .val(zyteApiKeyPerfil)
        .attr('type', 'text')
        .attr('autocomplete', 'off')
        .attr('autocorrect', 'off')
        .attr('autocapitalize', 'off')
        .attr('spellcheck', 'false')
        .attr('data-lpignore', 'true')
        .attr('data-1p-ignore', 'true')
        .attr('data-form-type', 'other')
        .prop('disabled', false)
        .attr('placeholder', 'Informe a Zyte API Key');

      const buscarPrecoSolverValorPerfil: any = (objPerfil.dados as any).buscar_preco_externo_solver_auto_dme;
      const buscarPrecoSolverAtivoPerfil = buscarPrecoSolverValorPerfil === true
        || buscarPrecoSolverValorPerfil === "true"
        || buscarPrecoSolverValorPerfil === 1
        || buscarPrecoSolverValorPerfil === "1";
      formConta.find("input[name='buscar_preco_externo_solver_auto_dme']").prop('checked', buscarPrecoSolverAtivoPerfil);

      // Cache de preco EA: opt-in. Ausente no perfil = desativado (busca no mercado como antes).
      const usarCachePrecoEaValorPerfil: any = (objPerfil.dados as any).usar_cache_preco_ea;
      const usarCachePrecoEaAtivoPerfil = usarCachePrecoEaValorPerfil === true
        || usarCachePrecoEaValorPerfil === "true"
        || usarCachePrecoEaValorPerfil === 1
        || usarCachePrecoEaValorPerfil === "1";
      formConta.find("input[name='usar_cache_preco_ea']").prop('checked', usarCachePrecoEaAtivoPerfil);

      const dn = (objPerfil.dados || {}) as any;
      const temCampoDescarte = (campo: string) => Object.prototype.hasOwnProperty.call(dn, campo);
      formConta.find('input[name=descarte_negociavel_ativo]').prop('checked', !temCampoDescarte('descarte_negociavel_ativo') || !!dn.descarte_negociavel_ativo);
      formConta.find('input[name=descarte_negociavel_trava_especial]').prop('checked', !temCampoDescarte('descarte_negociavel_trava_especial') || !!dn.descarte_negociavel_trava_especial);
      formConta.find('input[name=usar_regras_descarte_na_relistagem]').prop('checked', !temCampoDescarte('usar_regras_descarte_na_relistagem') || !!dn.usar_regras_descarte_na_relistagem);
      formConta.find('input[name=descarte_negociavel_proteger_exigencias_dme]').prop('checked', false);
      formConta.find('input[name=vender_cartas_clube]').prop('checked', !!dn.vender_cartas_clube);
      formConta.find('input[name=vender_cartas_clube_nao_vender_elenco_ativo]').prop('checked', !temCampoDescarte('vender_cartas_clube_nao_vender_elenco_ativo') || !!dn.vender_cartas_clube_nao_vender_elenco_ativo);
      const rl = dn.descarte_negociavel_rating_limite != null ? parseInt(String(dn.descarte_negociavel_rating_limite), 10) : 0;
      const pl = dn.descarte_negociavel_preco_limite != null ? parseInt(String(dn.descarte_negociavel_preco_limite), 10) : 900;
      const spl = dn.descarte_negociavel_especial_preco_limite != null ? parseInt(String(dn.descarte_negociavel_especial_preco_limite), 10) : 0;
      const vcmn = dn.vender_cartas_clube_rating_min != null ? parseInt(String(dn.vender_cartas_clube_rating_min), 10) : 79;
      const vcmx = dn.vender_cartas_clube_rating_max != null ? parseInt(String(dn.vender_cartas_clube_rating_max), 10) : 99;
      formConta.find('input[name=descarte_negociavel_rating_limite]').val(String(isNaN(rl) ? 0 : rl));
      formConta.find('input[name=descarte_negociavel_preco_limite]').val(String(isNaN(pl) ? 900 : pl));
      formConta.find('input[name=descarte_negociavel_especial_preco_limite]').val(String(isNaN(spl) ? 0 : spl));
      formConta.find('input[name=vender_cartas_clube_rating_min]').val(String(isNaN(vcmn) ? 79 : vcmn));
      formConta.find('input[name=vender_cartas_clube_rating_max]').val(String(isNaN(vcmx) ? 99 : vcmx));
      this.atualizarVisibilidadeOpcoesRegrasDescartes(formConta);
      setTimeout(() => this.initDescarteNegociavelSliders(modal), 80);
    }

    /** Mostra/oculta opções da área Regras Descartes conforme descarte_negociavel_ativo (QuickSell). */
    private atualizarVisibilidadeOpcoesRegrasDescartes($form: JQuery): void {
      if (!$form || !$form.length) {
        return;
      }
      const ativo = $form.find('input[name=descarte_negociavel_ativo]').is(':checked');
      $form.find('.js-regras-descartes-opcoes').toggle(ativo);
    }

    /** "Ativar Lista Completa" ligada: desabilita e limpa a seleção manual de autodmes (o sistema usa todos). */
    private atualizarDisponibilidadeSelecaoAutodmes($form: JQuery): void {
      if (!$form || !$form.length) {
        return;
      }
      const usarTodos = $form.find('input[name=usar_lista_completa_autodmes]').is(':checked');
      const $select = $form.find("select[name='autodmes[]']");
      if (usarTodos) {
        $select.val(null).trigger('change');
      }
      $select.prop('disabled', usarTodos).trigger('change.select2');
    }

    /** Sliders noUiSlider: limites de descarte de negociáveis ao abrir pacote (aba Regras de descarte). */
    private initDescarteNegociavelSliders(modal: JQuery): void {
      const noUiSliderLib = (window as any).noUiSlider;
      if (typeof noUiSliderLib === 'undefined' || !noUiSliderLib.create) return;
      const $form = modal.find('form.form-step-config-perfil');
      if (!$form.length) return;

      const $ratingHidden = $form.find('input[name=descarte_negociavel_rating_limite]');
      const $precoHidden = $form.find('input[name=descarte_negociavel_preco_limite]');
      const $especialPrecoHidden = $form.find('input[name=descarte_negociavel_especial_preco_limite]');
      const $venderClubeRatingMinHidden = $form.find('input[name=vender_cartas_clube_rating_min]');
      const $venderClubeRatingMaxHidden = $form.find('input[name=vender_cartas_clube_rating_max]');
      const ratingEl = $form.find('.js-perfil-descarte-rating-slider').get(0) as any;
      const precoEl = $form.find('.js-perfil-descarte-preco-slider').get(0) as any;
      const especialPrecoEl = $form.find('.js-perfil-descarte-especial-preco-slider').get(0) as any;
      const venderClubeRatingEl = $form.find('.js-perfil-vender-clube-rating-slider').get(0) as any;
      const $ratingLabel = $form.find('.js-perfil-descarte-rating-label');
      const $precoLabel = $form.find('.js-perfil-descarte-preco-label');
      const $especialPrecoLabel = $form.find('.js-perfil-descarte-especial-preco-label');
      const $venderClubeRatingLabel = $form.find('.js-perfil-vender-clube-rating-label');

      let ratingVal = Math.max(0, Math.min(99, parseInt(String($ratingHidden.val() || '0'), 10) || 0));
      if (ratingVal > 0 && ratingVal < 45) {
        ratingVal = 45;
      }
      let precoVal = Math.max(0, Math.min(500000, parseInt(String($precoHidden.val() || '0'), 10) || 0));
      let especialPrecoVal = Math.max(0, Math.min(500000, parseInt(String($especialPrecoHidden.val() || '0'), 10) || 0));
      let venderClubeRatingMinVal = Math.max(45, Math.min(99, parseInt(String($venderClubeRatingMinHidden.val() || '79'), 10) || 79));
      let venderClubeRatingMaxVal = Math.max(45, Math.min(99, parseInt(String($venderClubeRatingMaxHidden.val() || '99'), 10) || 99));
      if (venderClubeRatingMinVal > venderClubeRatingMaxVal) {
        venderClubeRatingMinVal = 79;
        venderClubeRatingMaxVal = 99;
      }
      // Steps iguais ao WebApp (pricesTiers via Util.tratarValorDeFiltro).
      if (precoVal > 0) {
        precoVal = Math.min(500000, Math.max(0, parseInt(String(App.Util.tratarValorDeFiltro(precoVal)), 10) || 0));
      }
      if (especialPrecoVal > 0) {
        especialPrecoVal = Math.min(500000, Math.max(0, parseInt(String(App.Util.tratarValorDeFiltro(especialPrecoVal)), 10) || 0));
      }

      const updateRatingLabel = (v: number) => {
        $ratingHidden.val(String(v));
        $ratingLabel.text(v === 0 ? 'Desligado' : 'Descarta se overall < ' + v);
      };
      const updatePrecoLabel = (v: number) => {
        $precoHidden.val(String(v));
        $precoLabel.text(v === 0 ? 'Desligado' : 'Descarta se preço < ' + v.toLocaleString('pt-BR') + ' coins');
      };

      const updateEspecialPrecoLabel = (v: number) => {
        $especialPrecoHidden.val(String(v));
        $especialPrecoLabel.text(v === 0 ? 'Desligado' : 'Descarta especiais se preco < ' + v.toLocaleString('pt-BR') + ' coins');
      };

      const updateVenderClubeRatingLabel = (min: number, max: number) => {
        $venderClubeRatingMinHidden.val(String(min));
        $venderClubeRatingMaxHidden.val(String(max));
        $venderClubeRatingLabel.text('Lista negociaveis do clube entre ' + min + ' e ' + max + ' OVR');
      };

      // Range de preço alinhado a pricesTiers do WebApp:
      // >=100000 step 1000 | >=50000 step 500 | >=10000 step 250 | >=1000 step 100 | >=150 step 50 | >=0 step 150
      const precoSliderRange: any = {
        'min': [0, 150],
        '5%': [150, 50],
        '25%': [1000, 100],
        '50%': [10000, 250],
        '70%': [50000, 500],
        '85%': [100000, 1000],
        'max': [500000]
      };

      const normalizarPrecoSlider = (valorBruto: number): number => {
        let v = parseInt(String(valorBruto), 10);
        if (!Number.isFinite(v) || v <= 0) {
          return 0;
        }
        v = Math.min(500000, Math.max(0, parseInt(String(App.Util.tratarValorDeFiltro(v)), 10) || 0));
        return v > 0 ? v : 0;
      };

      if (ratingEl) {
        if (ratingEl.noUiSlider) {
          ratingEl.noUiSlider.destroy();
        }
        noUiSliderLib.create(ratingEl, {
          start: ratingVal,
          connect: [true, false],
          // 0 = desligado; próximo valor válido começa em 45 até 99
          range: {
            'min': [0, 45],
            '1%': [45, 1],
            'max': [99]
          }
        });
        ratingEl.noUiSlider.on('update', (values: string[]) => {
          let v = parseInt(values[0], 10);
          if (!Number.isFinite(v) || v < 0) {
            v = 0;
          } else if (v > 0 && v < 45) {
            v = 45;
          } else if (v > 99) {
            v = 99;
          }
          updateRatingLabel(v);
        });
        updateRatingLabel(ratingVal);
      }

      if (venderClubeRatingEl) {
        if (venderClubeRatingEl.noUiSlider) {
          venderClubeRatingEl.noUiSlider.destroy();
        }
        noUiSliderLib.create(venderClubeRatingEl, {
          start: [venderClubeRatingMinVal, venderClubeRatingMaxVal],
          connect: true,
          range: { min: 45, max: 99 },
          step: 1
        });
        venderClubeRatingEl.noUiSlider.on('update', (values: string[]) => {
          let min = parseInt(values[0], 10);
          let max = parseInt(values[1], 10);
          if (!Number.isFinite(min) || min < 45) {
            min = 45;
          }
          if (!Number.isFinite(max) || max < 45) {
            max = 99;
          }
          if (min > 99) {
            min = 99;
          }
          if (max > 99) {
            max = 99;
          }
          updateVenderClubeRatingLabel(min, max);
        });
        updateVenderClubeRatingLabel(venderClubeRatingMinVal, venderClubeRatingMaxVal);
      }

      if (precoEl) {
        if (precoEl.noUiSlider) {
          precoEl.noUiSlider.destroy();
        }
        noUiSliderLib.create(precoEl, {
          start: precoVal,
          connect: [true, false],
          range: precoSliderRange
        });
        precoEl.noUiSlider.on('update', (values: string[]) => {
          updatePrecoLabel(normalizarPrecoSlider(parseInt(values[0], 10)));
        });
        updatePrecoLabel(precoVal);
      }

      if (especialPrecoEl) {
        if (especialPrecoEl.noUiSlider) {
          especialPrecoEl.noUiSlider.destroy();
        }
        noUiSliderLib.create(especialPrecoEl, {
          start: especialPrecoVal,
          connect: [true, false],
          range: precoSliderRange
        });
        especialPrecoEl.noUiSlider.on('update', (values: string[]) => {
          updateEspecialPrecoLabel(normalizarPrecoSlider(parseInt(values[0], 10)));
        });
        updateEspecialPrecoLabel(especialPrecoVal);
      }
    }

    private normalizarDadosAutodme(dados: any): any {
      if (!dados) {
        return {};
      }
      if (typeof dados === "string") {
        const decodificarHtml = (valor: string): string => {
          if (typeof document === "undefined") return valor;
          const textarea = document.createElement("textarea");
          textarea.innerHTML = valor;
          return textarea.value;
        };
        const tentarJson = (valor: string): any => {
          try {
            const parsed = JSON.parse(valor);
            if (typeof parsed === "string" && parsed !== valor) {
              return tentarJson(parsed);
            }
            return parsed && typeof parsed === "object" ? parsed : {};
          } catch (e) {
            return null;
          }
        };
        const candidatos = [dados, decodificarHtml(dados)]
          .map((valor: string) => String(valor || "").trim())
          .filter((valor: string, index: number, arr: string[]) => valor !== "" && arr.indexOf(valor) === index);
        for (const candidato of candidatos) {
          const parsed = tentarJson(candidato);
          if (parsed && typeof parsed === "object") {
            return parsed;
          }
        }
        return {};
      }
      return typeof dados === "object" ? dados : {};
    }

    private obterDadosJsonModalAutodme(modal: JQuery): any {
      if (!modal || !modal.length) {
        return {};
      }
      return this.normalizarDadosAutodme(modal.find(".js-autodme-dados-json").first().text());
    }

    private mesclarDadosAutodme(dadosBase: any, dadosPreferenciais: any): any {
      const base = this.normalizarDadosAutodme(dadosBase);
      const preferenciais = this.normalizarDadosAutodme(dadosPreferenciais);
      return { ...base, ...preferenciais };
    }

    private preencherModalEditarAutodmeQuandoPronto(modal: JQuery, form: JQuery, objAutodme: IAutodme): void {
      modal.data("autodmeObjEditar", objAutodme);
      const aplicacaoToken = String(new Date().getTime()) + "-" + String(Math.random());
      modal.data("autodmeEditarAplicacaoInicialPendente", true);
      modal.data("autodmeEditarAplicacaoToken", aplicacaoToken);

      const aplicacaoPendente = () => {
        return !!modal.data("autodmeEditarAplicacaoInicialPendente")
          && modal.data("autodmeEditarAplicacaoToken") === aplicacaoToken;
      };

      const obterObjAtual = () => {
        return (modal.data("autodmeObjEditar") || objAutodme) as IAutodme;
      };

      const obterDadosAtuais = (objAtual: IAutodme) => {
        return this.mesclarDadosAutodme(this.obterDadosJsonModalAutodme(modal), objAtual ? objAtual.dados : {});
      };

      const dadosPossuemSelecaoDesafios = (dadosAutodme: any) => {
        return dadosAutodme && Object.prototype.hasOwnProperty.call(dadosAutodme, "desafios_dme");
      };

      const aplicarInicial = () => {
        if (!aplicacaoPendente()) {
          return;
        }
        const objAtual = obterObjAtual();
        this.aplicarCamposDinamicosAutodmeAoEditar(form, modal, objAtual);
        window.setTimeout(() => aplicarAposRenderInicial(0), 120);
      };

      const aplicarAposRenderInicial = (tentativa: number = 0) => {
        if (!aplicacaoPendente()) {
          return;
        }
        const objAtual = obterObjAtual();
        const dadosAutodme = obterDadosAtuais(objAtual);
        const aguardandoPillsDesafios = dadosPossuemSelecaoDesafios(dadosAutodme)
          && form.find('input[name="desafios_dme[]"]').length === 0;
        if (aguardandoPillsDesafios && tentativa < 8) {
          window.setTimeout(() => aplicarAposRenderInicial(tentativa + 1), 120);
          return;
        }
        this.aplicarCamposDinamicosAutodmeAoEditar(form, modal, objAtual);
        modal.data("autodmeEditarAplicacaoInicialPendente", false);
      };

      modal
        .off('autodme:pro-modal-ready.editarAutodme')
        .on('autodme:pro-modal-ready.editarAutodme', aplicarInicial);

      modal
        .off('autodme:pro-dme-rendered.editarAutodme')
        .on('autodme:pro-dme-rendered.editarAutodme', () => aplicarAposRenderInicial(0));

      if (modal.data('autoDmeProInited')) {
        setTimeout(aplicarInicial, 0);
      }
    }

    private removerFormAutodmePreenchido(idRegistro: number): void {
      this.formAutodmePreenchido = this.formAutodmePreenchido.filter((id: number) => id !== idRegistro);
    }

    private abrirModalEditarAutodme(e: JQueryEventObject): void {
      const $btn = $(e.currentTarget);
      const idRegistro = parseInt(String($btn.data("id") || "0"), 10);
      if (!idRegistro) {
        return;
      }
      const modal = $(`#modalCadastrarAutodme${idRegistro}`);
      const form: JQuery = modal.find('form');
      if (!modal.length || !form.length) {
        return;
      }

      let dadosBotao: any = {};
      [$btn.data("dados"), $btn.attr("data-dados-json"), $btn.attr("data-dados")].some((rawDados: any) => {
        dadosBotao = this.normalizarDadosAutodme(rawDados);
        return Object.keys(dadosBotao).length > 0;
      });
      const dadosModal = this.obterDadosJsonModalAutodme(modal);
      const objAutodme: IAutodme = {
        id: idRegistro,
        nome: $btn.data("nome"),
        dados: this.mesclarDadosAutodme(dadosModal, dadosBotao)
      };
      ; (objAutodme as any).prioridade = $btn.data("prioridade");
      ; (objAutodme as any).categoria_tarefa = $btn.data("categoria-tarefa");
      ; (objAutodme as any).cor = $btn.data("cor");
      this.preencherModalEditarAutodmeQuandoPronto(modal, form, objAutodme);
      modal.modal('show');
      this.preencherFormAutodme(form, modal, objAutodme);
    }

    private normalizarSetIdAutodmeValor(valor: any): string {
      const raw = valor == null ? "" : String(valor).trim();
      if (!raw) return "";
      const n = parseInt(raw, 10);
      return n > 0 ? String(n) : "";
    }

    private clonarObjetoAutodme(obj: any): any {
      if (!obj || typeof obj !== "object") {
        return {};
      }
      try {
        return JSON.parse(JSON.stringify(obj));
      } catch (_e) {
        return $.extend(true, {}, obj);
      }
    }

    private encontrarOpcaoDmeAutodmePorSetId(setId: any): JQuery {
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (!sid) return $();
      return $(".js-select-dme-autodme-pro option").filter((_: number, option: Element) => {
        return String($(option).val()) === sid;
      }).first();
    }

    private lerConfigPadraoAutodmeDaOption($opt: JQuery): any | null {
      const raw = $opt && $opt.length ? String($opt.attr("data-autodme-default-config") || "") : "";
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
      } catch (_e) {
        return null;
      }
    }

    private normalizarDetailInlineAutodme(raw: any): Record<string, any> | null {
      if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
        return null;
      }
      return Object.keys(raw).length ? raw as Record<string, any> : null;
    }

    private hidratarMapaDetalhesDmesAutodme(): void {
      if (typeof document === "undefined") {
        return;
      }
      const w: any = window as any;
      if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== "object") {
        w.FSW_DMES_DETAIL_BY_SET_ID = {};
      }

      const el = document.getElementById("fsw-dmes-client-bootstrap");
      if (!el || !el.textContent) {
        return;
      }
      try {
        const payload = JSON.parse(el.textContent);
        const inline = this.normalizarDetailInlineAutodme(payload && payload.detailInline);
        if (inline) {
          w.FSW_DMES_DETAIL_BY_SET_ID = $.extend({}, w.FSW_DMES_DETAIL_BY_SET_ID, inline);
        }
        if (payload && payload.detailUrl) {
          w.FSW_DMES_CATALOGO_DETAIL_URL = payload.detailUrl;
        }
      } catch (_e) {
        /* ignore */
      }
    }

    private obterUrlCatalogoDetalhesDmesAutodme(): string {
      const w: any = window as any;
      const urlGlobal = typeof w.FSW_DMES_CATALOGO_DETAIL_URL === "string" ? w.FSW_DMES_CATALOGO_DETAIL_URL.trim() : "";
      if (urlGlobal) {
        return urlGlobal;
      }
      const $select = $("select.js-select-dme-autodme-pro[data-dmes-detail-url]").first();
      const urlSelect = $select.length ? String($select.attr("data-dmes-detail-url") || "").trim() : "";
      if (urlSelect) {
        w.FSW_DMES_CATALOGO_DETAIL_URL = urlSelect;
      }
      return urlSelect;
    }

    private obterDadosAutodmeLinhaListagem($tr: JQuery): any {
      const $btn = $tr.find(".btn-editar-autodme, [class*='edit-autodme']").first();
      let dados: any = {};
      if (!$btn.length) {
        return dados;
      }
      [$btn.data("dados"), $btn.attr("data-dados-json"), $btn.attr("data-dados")].some((rawDados: any) => {
        dados = this.normalizarDadosAutodme(rawDados);
        return Object.keys(dados).length > 0;
      });
      return dados;
    }

    private listagemAutodmeTemDmeSemDetalheCatalogo(): boolean {
      let faltando = false;
      $("table.list-autodme tbody tr").each((_: number, tr: Element) => {
        if (faltando) return;
        const dados = this.obterDadosAutodmeLinhaListagem($(tr));
        const sid = this.normalizarSetIdAutodmeValor(dados && dados.id_dme);
        if (!sid) return;
        const detail = this.obterDmeCatalogoAtualAutodme(sid);
        if (!detail || !Array.isArray(detail.challenges) || detail.challenges.length === 0) {
          faltando = true;
        }
      });
      return faltando;
    }

    private carregarDetalhesDmesAutodmeParaListagem(done: () => void): void {
      this.hidratarMapaDetalhesDmesAutodme();
      const url = this.obterUrlCatalogoDetalhesDmesAutodme();
      if (!url || this.autodmeCatalogoDetalhesCarregado || !this.listagemAutodmeTemDmeSemDetalheCatalogo()) {
        done();
        return;
      }
      if (this.autodmeCatalogoDetalhesRequest) {
        this.autodmeCatalogoDetalhesRequest.always(() => done());
        return;
      }

      this.autodmeCatalogoDetalhesRequest = $.getJSON(url)
        .done((data: any) => {
          let map: any = null;
          if (data && typeof data === "object" && !Array.isArray(data)) {
            map = data.bySetId != null ? data.bySetId : data;
          }
          if (map && typeof map === "object" && !Array.isArray(map)) {
            const w: any = window as any;
            if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== "object") {
              w.FSW_DMES_DETAIL_BY_SET_ID = {};
            }
            w.FSW_DMES_DETAIL_BY_SET_ID = $.extend({}, w.FSW_DMES_DETAIL_BY_SET_ID, map);
          }
        })
        .always(() => {
          this.autodmeCatalogoDetalhesCarregado = true;
          this.autodmeCatalogoDetalhesRequest = null;
          done();
        });
    }

    private obterDmeCatalogoAtualAutodme(setId: any): any | null {
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (!sid) return null;
      const w: any = window as any;
      const map = w.FSW_DMES_DETAIL_BY_SET_ID && typeof w.FSW_DMES_DETAIL_BY_SET_ID === "object"
        ? w.FSW_DMES_DETAIL_BY_SET_ID
        : {};
      const detail = map[sid] || map[parseInt(sid, 10)];
      if (detail && typeof detail === "object") {
        return detail;
      }

      const $opt = this.encontrarOpcaoDmeAutodmePorSetId(sid);
      if (!$opt.length) {
        return null;
      }
      return {
        setId: parseInt(sid, 10),
        name: String($opt.attr("data-name") || $opt.text() || "").trim(),
        autodmeDefaultConfig: this.lerConfigPadraoAutodmeDaOption($opt),
        _temAutodmeDefaultConfigAdmin: String($opt.attr("data-tem-autodme-default-admin") || "") === "1",
      };
    }

    private obterNomeDmeCatalogoAtualAutodme(setId: any): string {
      const detail = this.obterDmeCatalogoAtualAutodme(setId);
      return detail ? String(detail.name || detail.nome || "").trim() : "";
    }

    private obterNomeDmeSelecionadoAutodme($select: JQuery, setId: any): string {
      const $opt = $select.find("option:selected").first();
      const nomeOpt = String($opt.attr("data-name") || $opt.text() || "").trim();
      if (nomeOpt) return nomeOpt;
      return this.obterNomeDmeCatalogoAtualAutodme(setId);
    }

    private obterConfigPadraoAutodmePorSetId(setId: any, $select?: JQuery): any | null {
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (!sid) return null;
      const detail = this.obterDmeCatalogoAtualAutodme(sid);
      if (detail && detail.autodmeDefaultConfig && typeof detail.autodmeDefaultConfig === "object") {
        return this.clonarObjetoAutodme(detail.autodmeDefaultConfig);
      }
      const $opt = $select && $select.length ? $select.find("option:selected").first() : this.encontrarOpcaoDmeAutodmePorSetId(sid);
      const configOpt = this.lerConfigPadraoAutodmeDaOption($opt);
      return configOpt ? this.clonarObjetoAutodme(configOpt) : null;
    }

    private limparConfigPadraoAutodme(config: any, setId: any, nomeDme: string): any {
      const dados = this.clonarObjetoAutodme(config);
      [
        "_token",
        "id",
        "id_autodme",
        "nome",
        "prioridade",
        "categoria_tarefa",
        "cor",
        "periodos",
        "links",
        "excludedChallengeIndices",
        "nome_dme_referencia",
      ].forEach((k: string) => delete dados[k]);
      Object.keys(dados).forEach((k: string) => {
        if (k.indexOf("link_desafio_futbin_") === 0) {
          delete dados[k];
        }
      });
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (sid) {
        dados.id_dme = parseInt(sid, 10);
      }
      if (nomeDme) {
        dados.nome_dme_referencia = nomeDme;
      }
      return dados;
    }

    private agendarAplicarConfigPadraoAutodmeSelecionado($select: JQuery): void {
      const $form = $select.closest("form.form-step-config-autodme");
      const $modal = $select.closest(".modal-step-config");
      const setId = this.normalizarSetIdAutodmeValor($select.val());
      if (!$form.length || !$modal.length || !setId) {
        return;
      }
      window.setTimeout(() => {
        this.aplicarConfigPadraoAutodmeSelecionado($form, $modal, $select, setId);
      }, 0);
    }

    private aplicarConfigPadraoAutodmeSelecionado($form: JQuery, $modal: JQuery, $select: JQuery, setId: string): void {
      this.carregarConfigAssistenteAutodmeNoFormulario($form, setId);
      const config = this.obterConfigPadraoAutodmePorSetId(setId, $select);
      if (!config) {
        return;
      }
      const nomeDme = this.obterNomeDmeSelecionadoAutodme($select, setId);
      const dados = this.limparConfigPadraoAutodme(config, setId, nomeDme);

      this.preencherFormAutodme($form, $modal, {
        id: $form.data("id") || null,
        nome: String($form.find("input[name=nome]").val() || ""),
        dados,
        prioridade: parseInt(String($form.find("input[name=prioridade]").val() || "1"), 10) || 1,
        categoria_tarefa: parseInt(String($form.find("select[name=categoria_tarefa]").val() || "1"), 10) || 1,
        cor: String($form.find(".js-cor-linha-autodme-hidden").val() || ""),
      } as any);
    }

    /**
     * "Sugerir configuração": pede ao servidor a config padrao admin do DME de assinatura
     * mais proxima e aplica no formulario pelo MESMO caminho da config padrao (limpar +
     * preservar periodos + preencherFormAutodme). Sem match, o formulario fica intacto.
     */
    private sugerirConfiguracaoAutodmePeloFormulario($btn: JQuery): void {
      const $form = $btn.closest("form.form-step-config-autodme");
      const $modal = $btn.closest(".modal-step-config");
      const url = String($form.data("sugerir-config-url") || "");
      if (!$form.length || !$modal.length || !url) {
        return;
      }
      const $select = $form.find(".js-select-dme-autodme-pro").first();
      const setId = this.normalizarSetIdAutodmeValor($select.val());
      if (!setId) {
        toastr.warning("Escolha o DME antes de pedir a sugestão.", "Sugerir configuração");
        return;
      }

      $btn.prop("disabled", true);
      $.get(url, { set_id: setId })
        .done((resp: any) => {
          // O usuario pode ter trocado de DME enquanto a resposta vinha (o GET e pesado no
          // servidor). Aplicar a config do DME antigo com o select ja no novo deixaria o
          // form silenciosamente inconsistente — mesmo guard do fluxo do assistente.
          if (this.normalizarSetIdAutodmeValor($form.find(".js-select-dme-autodme-pro").first().val()) !== setId) {
            toastr.info("Sugestão descartada: o DME selecionado mudou durante a busca.", "Sugerir configuração");
            return;
          }
          if (resp && resp.status === "success" && resp.config && typeof resp.config === "object") {
            const nomeDme = this.obterNomeDmeSelecionadoAutodme($select, setId);
            const dados = this.limparConfigPadraoAutodme(resp.config, setId, nomeDme);

            this.preencherFormAutodme($form, $modal, {
              id: $form.data("id") || null,
              nome: String($form.find("input[name=nome]").val() || ""),
              dados,
              prioridade: parseInt(String($form.find("input[name=prioridade]").val() || "1"), 10) || 1,
              categoria_tarefa: parseInt(String($form.find("select[name=categoria_tarefa]").val() || "1"), 10) || 1,
              cor: String($form.find(".js-cor-linha-autodme-hidden").val() || ""),
            } as any);

            const origem: any = resp.origem && typeof resp.origem === "object" ? resp.origem : {};
            if (origem.tipo === "propria") {
              toastr.success("Este DME já tem configuração padrão própria — aplicada no formulário.", "Sugerir configuração");
            } else {
              toastr.success(
                "Configuração sugerida a partir de \"" + String(origem.nome || "DME similar") + "\" (semelhança " + String(origem.score || 0) + "%). Revise e salve.",
                "Sugerir configuração"
              );
            }
          } else if (resp && resp.status === "sem_match") {
            toastr.warning("Nenhum DME de assinatura parecida tem configuração padrão salva. O formulário não foi alterado.", "Sugerir configuração");
          } else if (resp && resp.status === "nao_encontrado") {
            toastr.warning("O DME selecionado não está no catálogo atual.", "Sugerir configuração");
          } else {
            toastr.error("Não foi possível montar a sugestão.", "Sugerir configuração");
          }
        })
        .fail(() => {
          toastr.error("Não foi possível montar a sugestão.", "Sugerir configuração");
        })
        .always(() => {
          $btn.prop("disabled", false);
        });
    }

    private prepararConfigPadraoAutodmeParaSalvar(dadosForm: any, setId: string, nomeDme: string): any {
      const dados = this.limparConfigPadraoAutodme(dadosForm || {}, setId, nomeDme);
      delete dados.periodos;
      delete dados.links;
      delete dados.excludedChallengeIndices;
      delete dados.nome_dme_referencia;
      Object.keys(dados).forEach((k: string) => {
        if (k.indexOf("link_desafio_futbin_") === 0) {
          delete dados[k];
        }
      });
      return dados;
    }

    private atualizarConfigPadraoAutodmeEmMemoria(setId: string, config: any): void {
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (!sid || !config || typeof config !== "object") {
        return;
      }
      const w: any = window as any;
      if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== "object") {
        w.FSW_DMES_DETAIL_BY_SET_ID = {};
      }
      const atual = w.FSW_DMES_DETAIL_BY_SET_ID[sid] && typeof w.FSW_DMES_DETAIL_BY_SET_ID[sid] === "object"
        ? w.FSW_DMES_DETAIL_BY_SET_ID[sid]
        : {};
      w.FSW_DMES_DETAIL_BY_SET_ID[sid] = $.extend(true, {}, atual, {
        setId: parseInt(sid, 10),
        autodmeDefaultConfig: config,
        _temAutodmeDefaultConfigAdmin: true,
      });

      $(".js-select-dme-autodme-pro option").filter((_: number, option: Element) => String($(option).val()) === sid)
        .attr("data-autodme-default-config", JSON.stringify(config))
        .attr("data-tem-autodme-default-admin", "1");
    }

    /** Curadoria do assistente por setId, para nao repetir o GET a cada troca de DME no modal. */
    private static cacheConfigAssistenteAutodme: { [setId: string]: any } = {};

    private niveisAssistenteParaValorSelect(niveis: any): string {
      const lista: string[] = Array.isArray(niveis) ? niveis.map((n: any) => String(n)) : [];
      const temBasica = lista.indexOf("basica") > -1;
      const temAvancada = lista.indexOf("avancada") > -1;
      if (temBasica && !temAvancada) return "basica";
      if (temAvancada && !temBasica) return "avancada";
      return "ambas";
    }

    private valorSelectParaNiveisAssistente(valor: string): string[] {
      if (valor === "basica") return ["basica"];
      if (valor === "avancada") return ["avancada"];
      return ["basica", "avancada"];
    }

    private preencherConfigAssistenteAutodmeNoFormulario($form: JQuery, config: any): void {
      const $bloco = $form.find(".js-autodme-assistente-admin").first();
      if (!$bloco.length) {
        return;
      }
      const cfg = config && typeof config === "object" ? config : {};
      const objetivosValidos = ["aumentar_pool", "obter_lucro", "melhorar_pool", "neutro"];
      let objetivo = String(cfg.objective || "");
      if (objetivosValidos.indexOf(objetivo) === -1) {
        objetivo = "neutro";
      }
      const habilitado = cfg.enabled === undefined ? objetivo !== "neutro" : !!cfg.enabled;
      const ordem = cfg.order === null || cfg.order === undefined || cfg.order === ""
        ? ""
        : String(parseInt(String(cfg.order), 10) || "");

      $bloco.find(".js-autodme-assistente-enabled").val(habilitado ? "1" : "0");
      $bloco.find(".js-autodme-assistente-objective").val(objetivo);
      $bloco.find(".js-autodme-assistente-order").val(ordem);
      $bloco.find(".js-autodme-assistente-niveis").val(this.niveisAssistenteParaValorSelect(cfg.niveis_configuracao));
    }

    /** null quando o bloco admin nao existe no DOM (usuario comum) — o payload entao nao carrega a chave. */
    private lerConfigAssistenteAutodmeDoFormulario($form: JQuery): any {
      const $bloco = $form.find(".js-autodme-assistente-admin").first();
      if (!$bloco.length) {
        return null;
      }
      const ordemRaw = String($bloco.find(".js-autodme-assistente-order").val() || "").trim();
      let ordem: number | null = null;
      if (ordemRaw !== "") {
        const n = parseInt(ordemRaw, 10);
        if (!isNaN(n) && n > 0) {
          ordem = Math.min(9999, n);
        }
      }

      return {
        enabled: String($bloco.find(".js-autodme-assistente-enabled").val()) === "1",
        objective: String($bloco.find(".js-autodme-assistente-objective").val() || "neutro"),
        order: ordem,
        niveis_configuracao: this.valorSelectParaNiveisAssistente(String($bloco.find(".js-autodme-assistente-niveis").val() || "ambas")),
      };
    }

    private carregarConfigAssistenteAutodmeNoFormulario($form: JQuery, setId: string): void {
      const $bloco = $form.find(".js-autodme-assistente-admin").first();
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (!$bloco.length || !sid) {
        return;
      }
      const emCache = Business.cacheConfigAssistenteAutodme[sid];
      if (emCache) {
        this.preencherConfigAssistenteAutodmeNoFormulario($form, emCache);
        return;
      }
      const url = String($bloco.data("assistente-config-url") || "");
      if (!url) {
        return;
      }
      $.ajax({ url, method: "GET", dataType: "json", data: { setId: parseInt(sid, 10) } })
        .done((resp: any) => {
          const cfg = resp && resp.dados && resp.dados.autodmeAssistantConfig ? resp.dados.autodmeAssistantConfig : null;
          if (!cfg) {
            return;
          }
          Business.cacheConfigAssistenteAutodme[sid] = cfg;
          // O usuario pode ter trocado de DME enquanto a resposta vinha.
          if (this.normalizarSetIdAutodmeValor($form.find(".js-select-dme-autodme-pro").first().val()) === sid) {
            this.preencherConfigAssistenteAutodmeNoFormulario($form, cfg);
          }
        });
    }

    private salvarConfigPadraoAutodmePeloFormulario($btn: JQuery): void {
      const $form = $btn.closest("form.form-step-config-autodme");
      const $select = $form.find(".js-select-dme-autodme-pro").first();
      const setId = this.normalizarSetIdAutodmeValor($select.val());
      const url = String($btn.data("url") || $form.data("config-padrao-url") || "");
      if (!$form.length || !setId || !url) {
        App.Util.exibirSweetAlertaFireSimples("Obrigatorio!", "Selecione um DME antes de salvar a configuracao padrao.", "error");
        return;
      }

      const ajax = new App.Ajax();
      let dadosForm: any = ajax.convertFormToJSON($form);
      dadosForm = App.Util.normalizarPayloadSalvarAutodme($form, dadosForm);
      const nomeDme = this.obterNomeDmeSelecionadoAutodme($select, setId) || ("SBC #" + setId);
      const config = this.prepararConfigPadraoAutodmeParaSalvar(dadosForm, setId, nomeDme);
      const assistantConfig = this.lerConfigAssistenteAutodmeDoFormulario($form);
      const payload: any = {
        setId: parseInt(setId, 10),
        nome: nomeDme,
        autodmeDefaultConfig: config,
      };
      if (assistantConfig) {
        payload.autodmeAssistantConfig = assistantConfig;
      }
      const htmlOriginal = $btn.html();
      $btn.prop("disabled", true).html('<i class="fas fa-spinner fa-spin mr-1"></i> Salvando...');
      $.ajax({
        url,
        method: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(payload),
        beforeSend: (jqXHR: JQueryXHR) => {
          jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
        },
      }).done((resp: any) => {
        if (!resp || resp.status !== "success") {
          App.Util.exibirSweetAlertaFireSimples("Erro", "Nao foi possivel salvar a configuracao padrao.", "error");
          return;
        }
        const configSalva = resp.dados && resp.dados.autodmeDefaultConfig ? resp.dados.autodmeDefaultConfig : config;
        this.atualizarConfigPadraoAutodmeEmMemoria(setId, configSalva);
        if (assistantConfig) {
          const assistenteSalvo = resp.dados && resp.dados.autodmeAssistantConfig ? resp.dados.autodmeAssistantConfig : assistantConfig;
          Business.cacheConfigAssistenteAutodme[String(setId)] = assistenteSalvo;
          this.preencherConfigAssistenteAutodmeNoFormulario($form, assistenteSalvo);
        }
        App.Util.exibirSweetAlertaFireSimples(
          "Sucesso!",
          assistantConfig
            ? "Configuracao padrao e curadoria do assistente atualizadas para este DME."
            : "Configuracao padrao atualizada para este DME.",
          "success"
        );
      }).fail((xhr: JQueryXHR) => {
        const msg = xhr && xhr.responseJSON && xhr.responseJSON.message
          ? xhr.responseJSON.message
          : "Nao foi possivel salvar a configuracao padrao.";
        App.Util.exibirSweetAlertaFireSimples("Erro", msg, "error");
      }).always(() => {
        $btn.prop("disabled", false).html(htmlOriginal);
      });
    }

    // Período saiu do registro em 17/08/2026 (foi para a config de execução): esta função agora
    // só aplica o DME selecionado ao form (antes também aplicava os períodos do registro).
    private aplicarDmeSelecionadoAutodme(formConta: JQuery, dadosAutodme: any): void {
      const $dmeSel = formConta.find('.js-select-dme-autodme-pro');
      const idDme = dadosAutodme && dadosAutodme.id_dme != null && String(dadosAutodme.id_dme) !== ''
        ? String(dadosAutodme.id_dme)
        : '';
      if (!$dmeSel.length || !idDme) {
        return;
      }

      const optionExiste = $dmeSel.find("option").filter((idx: number, option: Element) => {
        return String($(option).val()) === idDme;
      }).length > 0;
      if (!optionExiste) {
        if (String($dmeSel.val() || "") !== "") {
          $dmeSel.val("").trigger('change').trigger('change.select2');
        } else {
          $dmeSel.trigger('change.select2');
        }
        return;
      }
      if (String($dmeSel.val() || "") === idDme) {
        $dmeSel.trigger('change.select2');
        return;
      }
      $dmeSel.val(idDme).trigger('change').trigger('change.select2');
    }

    private aplicarCamposDinamicosAutodmeAoEditar(formConta: JQuery, modal: JQuery, objAutodme: IAutodme): void {
      const dadosModal = this.obterDadosJsonModalAutodme(modal);
      const dadosAutodme = this.mesclarDadosAutodme(dadosModal, objAutodme ? objAutodme.dados : {});
      if (!dadosAutodme || Object.keys(dadosAutodme).length === 0) {
        return;
      }
      this.aplicarDmeSelecionadoAutodme(formConta, dadosAutodme);
      Util.aplicarDadosAutodmeDesafiosELinksNoForm(formConta, dadosAutodme);
    }

    private preencherFormAutodme(formConta: JQuery, modal: JQuery, objAutodme: IAutodme): void {
      const dadosModal = this.obterDadosJsonModalAutodme(modal);
      let dadosAutodme = this.mesclarDadosAutodme(dadosModal, objAutodme.dados);
      modal.data("autodmeObjEditar", {
        ...objAutodme,
        dados: dadosAutodme
      });
      modal.find(".js-autodme-dados-json").first().text(JSON.stringify(dadosAutodme || {}));
      formConta.find('input[name=id]').val(objAutodme.id);
      formConta.find('input[name=nome]').val(objAutodme.nome);
      const prioridadeAutodme = (objAutodme as any).prioridade;
      const categoriaTarefaAutodme = (objAutodme as any).categoria_tarefa;
      const corAutodme = (objAutodme as any).cor;
      const corStr = typeof corAutodme === "string" && /^#[0-9A-Fa-f]{6}$/.test(corAutodme.trim()) ? corAutodme.trim() : "";
      formConta.find('input[name=prioridade]').val(prioridadeAutodme && Number(prioridadeAutodme) > 0 ? prioridadeAutodme : 1);
      if (categoriaTarefaAutodme) {
        formConta.find('select[name=categoria_tarefa]').val(String(categoriaTarefaAutodme));
      }
      formConta.find(".js-cor-linha-autodme-hidden").val(corStr);
      formConta.find(".js-cor-linha-autodme-picker").val(corStr || "#ffffff");
      const dadosBase = { ...dadosAutodme };
      [
        'id_dme',
        'periodos',
        'desafios_dme',
        'links',
        'excludeLeagues',
        'excludeNations',
        'excludeTeams',
        'excludeRarity',
        'excludeRating',
        'excludePlayers',
        'limites_solucoes_por_forragens',
        'dimensoes_exclusoes_inteligentes',
        'dimensoes_exclusoes_inteligentes[]',
        'ignorar_exclusoes_para_carta_especial',
        'ignorar_exclusoes_para_carta_especial[]',
        'exclusoes_inteligentes_origens',
      ].forEach((k) => delete dadosBase[k]);
      Object.keys(dadosBase).forEach((k) => {
        if (k.indexOf('link_desafio_futbin_') === 0) delete dadosBase[k];
      });
      Util.preencherFormulario(formConta, dadosBase);
      this.aplicarCamposDinamicosAutodmeAoEditar(formConta, modal, objAutodme);
    }

    private preencherFormApiVendaCoins(formConta: JQuery, modal: JQuery, objApiVendaCoins: IObjAgendamento): void {
      formConta.find('input[name=id]').val(objApiVendaCoins.id);
      formConta.find('input[name=nome]').val(objApiVendaCoins.nome);
      this.preencherFormularioApiVendaCoins(formConta, objApiVendaCoins.dados)
    }


    private atualizarListaPerfil(id: number, objRegistro: { nome: string, dados: any }) {
      if (id) {
        let listRegistro = $('.list-perfil')
        listRegistro.find(`.nome-perfil${id}`).html(objRegistro.nome)
        listRegistro.find(`.edit-perfil${id}`).data('dados', objRegistro.dados);
        listRegistro.find(`.edit-perfil${id}`).data('nome', objRegistro.nome);
      } else {
        document.location.reload();
      }
    }

    private obterChallengesDmeCatalogoAtualAutodme(setId: any): any[] {
      const sid = this.normalizarSetIdAutodmeValor(setId);
      if (!sid) return [];
      const detail = this.obterDmeCatalogoAtualAutodme(sid);
      if (detail && Array.isArray(detail.challenges)) {
        return detail.challenges;
      }
      const $opt = this.encontrarOpcaoDmeAutodmePorSetId(sid);
      const raw = $opt.length ? String($opt.attr("data-challenges") || "") : "";
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_e) {
        return [];
      }
    }

    private textoRequisitoListagemAutodme(entry: any): string {
      if (typeof entry === "string") {
        return String(entry || "").trim();
      }
      if (!entry || typeof entry !== "object") {
        return "";
      }
      return String(
        entry.text ||
        (entry.raw && entry.raw.text) ||
        entry.textPtBr ||
        entry.text_pt ||
        entry.textEn ||
        entry.text_en ||
        entry.description ||
        entry.descriptionPtBr ||
        entry.label ||
        entry.title ||
        ""
      ).trim();
    }

    private rotuloCurtoRequisitoListagemAutodme(tag: string): string {
      if (tag === "rating") return "OVR";
      if (tag === "league") return "Liga";
      if (tag === "nation") return "Pais";
      if (tag === "team") return "Clube";
      if (tag === "totw") return "TOTW";
      if (tag === "special") return "Esp.";
      return "Req.";
    }

    private coletarRequisitosListagemAutodme(dadosAutodme: any): Array<{ texto: string; tag: string }> {
      const setId = this.normalizarSetIdAutodmeValor(dadosAutodme && dadosAutodme.id_dme);
      const challenges = this.obterChallengesDmeCatalogoAtualAutodme(setId);
      if (!challenges.length) {
        return [];
      }

      const vistos: Record<string, boolean> = {};
      const requisitos: Array<{ texto: string; tag: string }> = [];
      challenges.forEach((challenge: any) => {
        const entradas: any[] = [];
        if (Array.isArray(challenge && challenge.requirementItems)) {
          challenge.requirementItems.forEach((item: any) => entradas.push(item));
        }
        if (Array.isArray(challenge && challenge.requirements)) {
          challenge.requirements.forEach((item: any) => entradas.push(item));
        }
        entradas.forEach((entry: any) => {
          const texto = this.textoRequisitoListagemAutodme(entry).replace(/\s+/g, " ");
          if (!texto) return;
          const tag = this.inferirTagRequisitoCartas(texto, entry);
          const chave = `${tag || "req"}:${texto.toLowerCase()}`;
          if (vistos[chave]) return;
          vistos[chave] = true;
          requisitos.push({ texto, tag });
        });
      });

      return requisitos;
    }

    private renderizarChipRequisitoListagemAutodme(req: { texto: string; tag: string }): string {
      const label = this.rotuloCurtoRequisitoListagemAutodme(req.tag);
      const texto = req.texto.length > 52 ? `${req.texto.slice(0, 49)}...` : req.texto;
      return `<span class="autodme-chip"><span>${this.htmlEscape(label)}</span> ${this.htmlEscape(texto)}</span>`;
    }

    private renderizarBotaoDetalhesRequisitosListagemAutodme(total: number): string {
      if (total <= 0) {
        return "";
      }
      return `<button type="button" class="autodme-requisitos-toggle js-autodme-requisitos-toggle" data-label-collapsed="detalhes" data-label-expanded="menos">detalhes</button>`;
    }

    private renderizarCelulaRequisitosListagemAutodme(dadosAutodme: any): string {
      const requisitos = this.coletarRequisitosListagemAutodme(dadosAutodme);
      if (!requisitos.length) {
        return '<span class="autodme-requisitos-cell text-muted" title="-">-</span>';
      }

      const todos = requisitos.map((req) => `${this.rotuloCurtoRequisitoListagemAutodme(req.tag)} ${req.texto}`);
      const rating = requisitos.filter((req) => req.tag === "rating")[0] || null;
      const resumo = rating || requisitos[0];
      const detalhes = requisitos.length > 1
        ? this.renderizarBotaoDetalhesRequisitosListagemAutodme(requisitos.length)
        : "";
      return `<div class="autodme-requisitos-cell autodme-requisitos-compact" title="${this.htmlEscape(todos.join(" | "))}">${this.renderizarChipRequisitoListagemAutodme(resumo)}${detalhes}</div>`;
    }

    private renderizarDetalhesRequisitosListagemAutodme(dadosAutodme: any): string {
      const requisitos = this.coletarRequisitosListagemAutodme(dadosAutodme);
      if (!requisitos.length) {
        return '<div class="autodme-requisitos-detail text-muted">Sem requisitos do catalogo.</div>';
      }
      const chips = requisitos.map((req) => this.renderizarChipRequisitoListagemAutodme(req)).join("");
      return `<div class="autodme-requisitos-detail"><div class="autodme-stack">${chips}</div></div>`;
    }

    private renderizarCelulaDmeListagemAutodme(dadosAutodme: any): string {
      const setId = this.normalizarSetIdAutodmeValor(dadosAutodme && dadosAutodme.id_dme);
      if (!setId) {
        return '<span class="autodme-dme-cell text-muted" title="-">-</span>';
      }
      const nomeCatalogo = this.obterNomeDmeCatalogoAtualAutodme(setId);
      if (nomeCatalogo) {
        return `<span class="autodme-dme-cell text-muted" title="${this.htmlEscape(nomeCatalogo)}">${this.htmlEscape(nomeCatalogo)}</span>`;
      }
      const nomeReferencia = dadosAutodme && dadosAutodme.nome_dme_referencia != null
        ? String(dadosAutodme.nome_dme_referencia).trim()
        : "";
      const title = `SetId antigo #${setId}${nomeReferencia ? " | Nome de referencia: " + nomeReferencia : ""}. Se a renovacao por nome estiver ativa, o plugin pode atualizar o registro automaticamente quando encontrar exatamente um novo DME.`;
      const detalhe = nomeReferencia ? `${nomeReferencia} (#${setId})` : `#${setId}`;
      return `<span class="badge badge-danger" title="${this.htmlEscape(title)}">DME inexistente</span><div class="text-muted font-size-10" title="${this.htmlEscape(title)}">${this.htmlEscape(detalhe)}</div>`;
    }

    private atualizarRequisitosListagemAutodme(): void {
      const atualizarLinha = ($tr: JQuery) => {
        const $td = $tr.find(".js-autodme-td-requisitos").first();
        if (!$td.length) {
          return;
        }
        const dadosAutodme = this.obterDadosAutodmeLinhaListagem($tr);
        const html = this.renderizarCelulaRequisitosListagemAutodme(dadosAutodme);
        const temRequisitos = html.indexOf('title="-"') === -1;
        $td.html(html).attr("data-order", temRequisitos ? "1" : "0");
      };

      if (this.objDataTableAutodme && typeof this.objDataTableAutodme.rows === "function") {
        this.objDataTableAutodme.rows().every(function (this: any) {
          const node = typeof this.node === "function" ? this.node() : null;
          if (node) {
            atualizarLinha($(node));
          }
        });
        this.objDataTableAutodme.rows().invalidate("dom");
        this.objDataTableAutodme.columns.adjust().draw(false);
        return;
      }

      $("table.list-autodme tbody tr").each((_: number, tr: Element) => atualizarLinha($(tr)));
    }

    private alternarDetalhesRequisitosListagemAutodme($btn: JQuery): void {
      if (!this.objDataTableAutodme || typeof this.objDataTableAutodme.row !== "function") {
        return;
      }
      const $tr = $btn.closest("tr");
      const row = this.objDataTableAutodme.row($tr);
      if (!row || !row.length) {
        return;
      }

      const labelCollapsed = String($btn.attr("data-label-collapsed") || "detalhes");
      const labelExpanded = String($btn.attr("data-label-expanded") || "menos");
      if (row.child && row.child.isShown && row.child.isShown()) {
        row.child.hide();
        $tr.removeClass("autodme-requisitos-open-row");
        $btn.text(labelCollapsed);
        return;
      }

      const dadosAutodme = this.obterDadosAutodmeLinhaListagem($tr);
      row.child(this.renderizarDetalhesRequisitosListagemAutodme(dadosAutodme)).show();
      $tr.addClass("autodme-requisitos-open-row");
      $btn.text(labelExpanded);
    }

    private atualizarListaAutodme(id: number, objRegistro: { nome: string, dados: any, prioridade?: number, categoria_tarefa?: number, cor?: string | null }) {
      if (!id) {
        document.location.reload();
        return;
      }
      const $tr = this.obterTrListagemAutodme(id);
      if (!$tr.length) {
        document.location.reload();
        return;
      }
      $tr.find(`.nome-autodme${id}`).html(objRegistro.nome);
      const $edit = $tr.find(`.edit-autodme${id}`);
      const dadosAutodme = this.normalizarDadosAutodme(objRegistro.dados);
      $edit.data("dados", dadosAutodme);
      $edit.data("nome", objRegistro.nome);
      $edit.attr("data-dados", JSON.stringify(dadosAutodme || {}));
      $edit.attr("data-dados-json", JSON.stringify(dadosAutodme || {}));
      $edit.attr("data-nome", objRegistro.nome || "");
      const $modalAutodme = $(`#modalCadastrarAutodme${id}`);
      $modalAutodme.find(".js-autodme-dados-json").first().text(JSON.stringify(dadosAutodme || {}));
      $modalAutodme.data("autodmeObjEditar", {
        id: id,
        nome: objRegistro.nome,
        dados: dadosAutodme,
        prioridade: objRegistro.prioridade,
        categoria_tarefa: objRegistro.categoria_tarefa,
        cor: objRegistro.cor
      });
      this.removerFormAutodmePreenchido(id);
      $tr.find(".js-autodme-td-dme").html(this.renderizarCelulaDmeListagemAutodme(dadosAutodme));
      $tr.find(".js-autodme-td-requisitos").html(this.renderizarCelulaRequisitosListagemAutodme(dadosAutodme));
      if (objRegistro.prioridade != null) {
        $edit.data("prioridade", objRegistro.prioridade);
        this.escreverPrioridadeAutodmeCampo($tr, objRegistro.prioridade);
        $tr.find("td.js-autodme-td-prioridade").attr("data-order", String(objRegistro.prioridade));
      }
      if (objRegistro.categoria_tarefa != null) {
        $edit.data("categoria-tarefa", objRegistro.categoria_tarefa);
      }
      if (objRegistro.hasOwnProperty("cor")) {
        const c = objRegistro.cor && String(objRegistro.cor).trim() !== "" ? String(objRegistro.cor).trim() : "";
        $edit.data("cor", c);
        this.aplicarCorLinhaListagemCrud($tr, c || null);
      }
    }

    /** Reutilizável em outras listagens CRUD: fundo da linha (#RRGGBB) ou padrão. */
    private aplicarCorLinhaListagemCrud($tr: JQuery, corHex: string | null | undefined): void {
      if (!$tr || !$tr.length) {
        return;
      }
      const c = corHex && String(corHex).trim() !== "" ? String(corHex).trim() : "";
      if (c && /^#[0-9A-Fa-f]{6}$/.test(c)) {
        $tr.css("background-color", c);
      } else {
        $tr.css("background-color", "");
      }
    }

    private obterTrListagemAutodme(id: number): JQuery {
      return $(`.edit-autodme${id}`).closest("tr");
    }

    private lerPrioridadeAutodmeCampo($campo: JQuery): number {
      const raw = $campo.is("input") ? $campo.val() : $campo.text();
      const prioridade = parseInt(String(raw || "1").trim(), 10);
      return Math.max(1, isNaN(prioridade) ? 1 : prioridade);
    }

    private escreverPrioridadeAutodmeCampo($tr: JQuery, prioridade: number): void {
      const $campo = $tr.find(".js-prioridade-autodme-valor");
      if ($campo.is("input")) {
        $campo.val(String(prioridade));
        $campo.data("prioridade-original", prioridade);
        $campo.attr("data-prioridade-original", String(prioridade));
      } else {
        $campo.text(String(prioridade));
      }
    }

    private agendarSalvarPrioridadeAutodme(id: number, url: string, $tr: JQuery, prioridade: number): void {
      const next = Math.max(1, prioridade);
      this.escreverPrioridadeAutodmeCampo($tr, next);
      $tr.find(`.edit-autodme${id}`).data("prioridade", next);
      $tr.find("td.js-autodme-td-prioridade").attr("data-order", String(next));

      if (this.prioridadeAutodmeDebounceTimers[id]) {
        clearTimeout(this.prioridadeAutodmeDebounceTimers[id]);
      }
      this.prioridadeAutodmeDebounceTimers[id] = window.setTimeout(() => {
        const finalP = this.lerPrioridadeAutodmeCampo($tr.find(".js-prioridade-autodme-valor"));
        delete this.prioridadeAutodmeDebounceTimers[id];
        App.Util.preparaCabecalhoRequisicaoAjax();
        $.post(url, JSON.stringify({ id: id, prioridade: finalP })).done((dados: any) => {
          if (dados && dados.dadosResposta && dados.dadosResposta.prioridade != null) {
            this.atualizarLinhaPrioridadeListagemAutodme(
              parseInt(String(dados.dadosResposta.id), 10),
              parseInt(String(dados.dadosResposta.prioridade), 10)
            );
          }
        }).fail(() => {
          const original = parseInt(String($tr.find(".autodme-prioridade-input").data("prioridade-original") || "1"), 10) || 1;
          this.escreverPrioridadeAutodmeCampo($tr, original);
          $tr.find(`.edit-autodme${id}`).data("prioridade", original);
          $tr.find("td.js-autodme-td-prioridade").attr("data-order", String(original));
        });
      }, this.prioridadeAutodmeDebounceMs);
    }

    private atualizarLinhaPrioridadeListagemAutodme(id: number, prioridade: number): void {
      const $tr = this.obterTrListagemAutodme(id);
      if (!$tr.length) {
        return;
      }
      const $edit = $tr.find(`.edit-autodme${id}`);
      $edit.data("prioridade", prioridade);
      this.escreverPrioridadeAutodmeCampo($tr, prioridade);
      $tr.find("td.js-autodme-td-prioridade").attr("data-order", String(prioridade));
      if (this.objDataTableAutodme) {
        this.objDataTableAutodme.row($tr).invalidate("dom");
      }
    }

    private atualizarListaApiVendaCoins(id: number, objRegistro: { nome: string, dados: any }) {
      if (id) {
        let listRegistro = $('.list-api-venda-coins')
        listRegistro.find(`.nome-api-venda-coins${id}`).html(objRegistro.nome)
        listRegistro.find(`.edit-api-venda-coins${id}`).data('dados', objRegistro.dados);
        listRegistro.find(`.edit-api-venda-coins${id}`).data('nome', objRegistro.nome);
      } else {
        document.location.reload();
      }
    }

    private atualizarListaAgendamento(id: number, objAgendamento: { nome: string, dados: any }) {
      if (id) {
        var tempoTotalExecucao = objAgendamento.dados.reduce((accumulator: any, object: IAgendamentoConfiguracao) => {
          return accumulator + Util.parseMilisegundosParaMinutos(object.tarefa.data.tempo);
        }, 0);

        let mili = Util.parseMinutosParaMilisegundos(tempoTotalExecucao)
        let listAgendamento = $('.list-agendameto')
        listAgendamento.find(`.nome-agendamento${id}`).html(objAgendamento.nome)
        listAgendamento.find(`.tempo-agendamento${id}`).html(Util.getDescricaoHumanaMilissegundos(mili))
        listAgendamento.find(`.edit-agendamento${id}`).data('dados', objAgendamento.dados);
        listAgendamento.find(`.edit-agendamento${id}`).data('nome', objAgendamento.nome);
      } else {
        document.location.reload();
      }
    }

    private atualizarTempoTotalExecucao(formAgendamento: JQuery, tempoTotal: any) {
      let milis = Util.parseMinutosParaMilisegundos(tempoTotal)
      formAgendamento.find('.info-tempo-total-execucao').html(Util.getDescricaoHumanaMilissegundos(milis));
    }

    private atualizarViewContainerAgendamento(elementoContainer: JQuery, agendamentoConfig: IAgendamentoConfiguracao = null, containerSalvo: boolean = true, infoNamesFiltros: string = "", infoTempoExecucao: string = "") {
      if (agendamentoConfig) {
        elementoContainer.find('.info-quando').html(App.Util.ARRAY_DIAS_AGENDAMENTO[parseInt(agendamentoConfig.dia)]);
        elementoContainer.find('.info-hora').html(agendamentoConfig.hora);
      }

      elementoContainer.find('.info-names-filtros').html(infoNamesFiltros);
      elementoContainer.find('.info-tempo-execucao').html(infoTempoExecucao);

      if (containerSalvo) {
        let strInfoFiltros = `&nbsp;<span class="badge badge-pill badge-success agenda-salva">salvo</span>`
        elementoContainer.find('.info-filtros').html(strInfoFiltros);
      }
    }

    private obterObjetoAgendamento(form: JQuery, dadosResponse: any = null): any[] {
      var arrayElementosAdd = form.find('.container-item-sch');
      var dadosEnviados: any = form.serializeObject();

      var agendamentos: any[] = [];

      $.each(arrayElementosAdd, (index: any, containerItem: any) => {
        var pilotoAutomatico = $(containerItem).find("input[name=piloto_automatico]").is(':checked')
        var arrFiltros = dadosEnviados.hasOwnProperty(`filtro${index}`) ? dadosEnviados[`filtro${index}`] : []

        var objAgendamentoConfiguracao: IAgendamentoConfiguracao = {};

        var objDataTarefa: IFuncaoSniperOptions = {};
        objAgendamentoConfiguracao.dia = dadosEnviados.dia[index];
        objAgendamentoConfiguracao.hora = dadosEnviados.hora[index];

        if (!pilotoAutomatico) {
          objDataTarefa.porcentagem_eficacia = dadosEnviados.hasOwnProperty('porcentagem_eficacia') ? dadosEnviados.porcentagem_eficacia[index] : 10;
          objDataTarefa.tempo_minimo_eficacia = dadosEnviados.hasOwnProperty('tempo_minimo_eficacia') ? dadosEnviados.tempo_minimo_eficacia[index] : 10;
          objDataTarefa.descanso = dadosEnviados.descanso[index];
          objDataTarefa.intervalo = dadosEnviados.intervalo[index];
          objDataTarefa.limite_compra = dadosEnviados.limite_compra[index];
          objDataTarefa.tempo = dadosEnviados.tempo[index];
          objDataTarefa.velocidade = dadosEnviados.velocidade[index];
          objDataTarefa.filtros = [];

          $.each(arrFiltros, (index2: any, filtroId: any) => {
            objDataTarefa.filtros.push(filtroId);
          });

          objAgendamentoConfiguracao.tarefa = {};
          objAgendamentoConfiguracao.tarefa.id = dadosEnviados.id_tarefa
          objAgendamentoConfiguracao.tarefa.data = objDataTarefa
        } else {
          objDataTarefa.tempo = dadosEnviados.tempo[index];
          objDataTarefa.limite_compra = dadosEnviados.limite_compra[index];
          objDataTarefa.filtros = [];

          objAgendamentoConfiguracao.tarefa = {};
          objAgendamentoConfiguracao.tarefa.id = dadosEnviados.id_tarefa
          objAgendamentoConfiguracao.tarefa.data = objDataTarefa
        }

        agendamentos.push(objAgendamentoConfiguracao)
      });

      return agendamentos;
    }

    private obterLogsDoDia(carregarMais: boolean = false) {
      if (this.logsDashboardCarregando) {
        return;
      }
      if (carregarMais && !this.logsDashboardHasMore) {
        return;
      }
      if (!carregarMais) {
        this.logsDashboardNextCursor = null;
        this.logsDashboardOffset = 0;
        this.logsDashboardHasMore = false;
      }

      this.logsDashboardCarregando = true;
      this.atualizarBotaoVerMaisLogs();
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_LOGS, {
        paginacao: true,
        limit: this.logsDashboardLimit,
        before: null,
        offset: carregarMais ? this.logsDashboardOffset : 0
      }, (response: IRespostaMensagem) => {
        this.logsDashboardCarregando = false;
        if (response.status) {
          const result = response.result || {};
          const logs = $.isArray(result) ? result : (result.logs || []);
          this.logsDashboardNextCursor = result && result.nextCursor ? result.nextCursor : null;
          this.logsDashboardOffset = result && result.nextOffset != null ? Number(result.nextOffset) : (this.logsDashboardOffset + logs.length);
          this.logsDashboardHasMore = Boolean(result && result.hasMore);
          this.carregarTabelaLogs(logs, carregarMais);
        }
        this.atualizarBotaoVerMaisLogs();
      });
    }

    private atualizarBotaoVerMaisLogs() {
      const $btn = $('.btn-ver-mais-logs');
      if (!$btn.length) {
        return;
      }
      $btn.prop('disabled', this.logsDashboardCarregando || !this.logsDashboardHasMore);
      $btn.text(this.logsDashboardCarregando ? 'Carregando...' : (this.logsDashboardHasMore ? 'Ver mais' : 'Sem mais logs'));
    }

    private carregarTabelaLogs(dataLog: IDataLog[] | IDataLog, append: boolean = false) {

      if (dataLog && !$.isArray(dataLog) && (dataLog as any).logs) {
        append = Boolean((dataLog as any).append);
        dataLog = (dataLog as any).logs;
      }

      if ($.isArray(dataLog)) {
        dataLog = (dataLog as any).filter((log: IDataLog) => {
          return !_.contains([Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO, Util.EVENTO_WEBAPP_COMPLETOU_CARREGAMENTO, Util.EVENTO_CONTA_FILTROS_NAO_ATUALIZADOS, Util.EVENTO_CONTA_PERFIL_DEFAULT], log.tipo)
        })
      }

      if (this.objDataTableLogs instanceof $.fn.dataTable.Api) {
        if ($.isArray(dataLog)) {
          if (!append) {
            this.objDataTableLogs.clear().draw();
          }
          this.objDataTableLogs.rows.add(dataLog);
        } else {
          try {
            if ((dataLog as any).tipo != Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO) {
              this.objDataTableLogs.row.add(dataLog);
            }
          } catch (error) {
            this.objDataTableLogs.row.add(dataLog);
          }
        }
        this.objDataTableLogs.columns.adjust().draw();
      } else {
        this.objDataTableLogs = this.elDataTableLogs.DataTable({
          data: dataLog,
          order: [[3, "desc"]],
          lengthChange: false,
          pageLength: 100,
          dom: "Bfrtip",
          buttons: {
            buttons: [
              { extend: 'copy', className: 'btn-link' },
              { extend: 'print', className: 'btn-link' },
              {
                text: 'Ver mais',
                className: 'btn-link btn-ver-mais-logs',
                action: () => {
                  this.obterLogsDoDia(true);
                }
              }
            ]
          },
          language: {
            paginate: {
              previous: "<i class='fas fa-angle-left'>",
              next: "<i class='fas fa-angle-right'>"
            }
          },
          columnDefs: [
            {
              targets: 0,
              className: "name",
              render: (data: any, tipo: any, obj: IDataLog, meta: any) => {
                try {
                  data = `<div class="media align-items-center">
                          <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">
                            <img alt="Clube Name" src="/favicon.ico">
                          </a>
                          <div class="media-body">
                            <span class="name mb-0 text-sm">Plugin</span>
                          </div>
                         </div>`;
                  var conta: IConta = App.Util.getItemArrayById(this.arrayContas, obj.idConta);
                  if (conta && conta.hasOwnProperty('dadosEa') && conta.dadosEa) {
                    if (!this.configuracoesGeraisExecucao.exibir_escudo_clube) {
                      this.atualizarCacheInfoConta(conta);
                    }

                    let viewImageConta = this.configuracoesGeraisExecucao.exibir_escudo_clube
                      ? `<div class="media align-items-center">
                          <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">
                            <img alt="Clube Name" src="${conta.dadosEa.img}">
                          </a>
                          <div class="media-body">
                            <span class="name mb-0 text-sm">${conta.dadosEa.clubeName}</span>
                          </div>
                         </div>`
                      : `<div class="media align-items-center">
                          <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;background-color:${this.cacheInfoContas[conta.id].corAvatar}">${this.cacheInfoContas[conta.id].nomeAvatar}</a>
                          <div class="media-body">
                            <span class="name mb-0 text-sm">${conta.dadosEa.clubeName}</span>
                          </div>
                         </div>`

                    data = viewImageConta
                  } else if (conta) {
                    data = '<div class="media align-items-center">\n\
                                            <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">\n\
                                            <img alt="Clube Name" src="/img/escudo-default.png">\n\
                                            </a><div class="media-body">\n\
                                            <span class="name mb-0 text-sm">Account ' + conta.id + '</span>\n\
                                            </div>\n\
                                            </div>';
                  }
                } catch (e) { }

                return data;
              }
            },
            {
              targets: 1,
              className: "tipo",
              render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                try {
                  var dadosLog = Util.getObjStatusViewLog(obj);
                  data = '<span class="badge badge-' + dadosLog.class + '">' + dadosLog.texto + '</span>'
                  return data;
                } catch (e) {
                  return '-'
                }
              }
            },
            {
              targets: 2,
              width: '75%',
              className: "text-muted info",
              render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                return Util.getObjInfoViewLog(obj);
              }
            },
            {
              targets: 3,
              className: "date",
              render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                data = '<div class="text-right">\n\
                                        <small class="text-muted">'+ obj.createdAt + '&nbsp;&nbsp;<i class="fas fa-clock mr-1"></i></small>\n\
                                        </div>';
                return data;
              }
            }
          ],
        });
        App.Util.desabilitarAutocompleteDataTables(this.elDataTableLogs);
      }
      this.atualizarBotaoVerMaisLogs();
    }


    private atualizarViewFuncionamentoAtual(id: number, status: number, navegador_status: boolean) {
      let elementoCronometro: string = `.cronometro${id} .values`
      // Remover badge "Aberta" do navegador antes de qualquer return: ao sair de EXECUÇÃO
      // o return antigo impedia esta limpeza e o DOM ficava desatualizado em relação ao DataTables.
      if (!navegador_status && $(`.conta-navegador-aberto${id}`).length) {
        $(`.conta-navegador-aberto${id}`).remove();
      }

      if (status != Util.STATUS_CONTA_EXECUCAO) {
        // Util.pararCronometroMult(App.Business.cronometros[id]);
        return;
      }

      var conta: IConta = App.Util.getItemArrayById(this.arrayContas, id);
      if (conta.execucao && conta.execucao.funcionamentoAtual) {
        // if (this.configuracoesGeraisExecucao.exibir_cronometro) {
        //   App.Business.cronometros[id] = Util.iniciarCronometroMult(App.Business.cronometros[id], elementoCronometro, conta.execucao.funcionamentoAtual.tempo / 1000);
        // }
      } else {
        Util.pararCronometroMult(App.Business.cronometros[id]);

        if (status == Util.STATUS_CONTA_EXECUCAO) {
          this.atualizarExecucaoConta(id)
        }
      }
    }

    private atualizarEstadoModalSniper(idConta: number, status: number) {
      if (this.idContaSniperModalAberto == idConta) {
        this.updateLogsAcoesContaModalSniper(idConta);
        $('.btn-snipar-pro').prop("disabled", status == Util.STATUS_CONTA_EXECUCAO);
        $('.btn-snipar-pro').html(status == Util.STATUS_CONTA_EXECUCAO ? "Snipando..." : "Snipar")
        if (status == Util.STATUS_CONTA_EXECUCAO) {
          $('.conteudo-loading-sniper-pro').modal('show')
          App.Util.reinicializarTentativas($('.conteudo-loading-sniper-pro').find('.tentativas'))
          App.Util.reinicializarQuantidadeComprasModalSniper()
        } else {
          $('.conteudo-loading-sniper-pro').modal('hide')
        }
      }
    }

    private updateLogsAcoesContaModalSniper(idConta: number) {
      if ($("#modalSniperPro .espaco-log-acoes").find(".conteudo-log-acoes-sniper-pro").length) {
        $("#modalSniperPro .espaco-log-acoes").find(".conteudo-log-acoes-sniper-pro").remove()
      }
      $("#modalSniperPro .espaco-log-acoes").append($(`#conteudoLogAcoesSniperPro${idConta}`).clone());

      $('.btn-snipar-pro').on("click", (e) => { this.iniciarSniper(e) });
      $('.btn-parar-tarefa-sniper').on("click", (e) => { this.pararTarefaByModal(e) });
      $(".limpar-log-pro").on('click', (e) => { this.aoLimparLog(e); });

    }
    private aoAbrirSniper(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.idContaSniperModalAberto = idConta;
      var conta: IConta = App.Util.getItemArrayById(this.arrayContas, idConta);


      let elementoRowConta: any = this.getElementoListConta(idConta)
      $('.espaco-nome-conta').html(elementoRowConta.find('td.info-conta').clone())


      this.ativarInteracaoSniper(idConta)
      this.preencherCamposModalSniperTarefaAtual(idConta, conta.status == Util.STATUS_CONTA_EXECUCAO && this.tarefasSniperContas[idConta] && this.tarefasSniperContas[idConta].hasOwnProperty("data") ? this.tarefasSniperContas[idConta].data.filtros[0] : null)
      this.updateLogsAcoesContaModalSniper(idConta);

      if (conta.status == Util.STATUS_CONTA_EXECUCAO) {
        $('.conteudo-loading-sniper-pro').modal('show')
        $('.btn-snipar-pro').prop("disabled", true);
        $('.btn-snipar-pro').html('Snipando...')
      } else {
        $('.btn-snipar-pro').prop("disabled", false);
        $('.btn-snipar-pro').html('Snipar')
        $('.conteudo-loading-sniper-pro').modal('hide')
      }
      $('#modalSniperPro').find(`input[name=id]`).val(idConta);
      $('#modalSniperPro').modal('show')
    }

    private iniciarSniper(e: JQueryEventObject) {
      var estimar = $(e.currentTarget).data('estimar')
      var parent = $(e.target).parents('.parent-sniper-pro');
      var form = parent.find('form')
      var tarefaSniper: ITarefaSniper = this.obterObjetoFormSniper($(form))
      var idConta = this.idContaSniperModalAberto
      if (!tarefaSniper) {
        return
      }

      $('#modalSniperPro').modal('hide')

      this.exibirLoadListConta(idConta, "Aguarde...")
      if (Boolean(estimar)) {
        tarefaSniper.id = Util.TAREFA_ESTIMAR_LUCRO_FILTRO
      } else {
        this.tarefasSniperContas[idConta] = tarefaSniper;
      }

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SNIPAR, { id: idConta, tarefa: tarefaSniper }, (response: IRespostaMensagem) => {
        let conta: IConta = response.result.conta
        if (response.status) {
          $(`#abrirSniper${conta.id}`).trigger("click")
        }
      });
    }

    private obterObjetoFormSniper(form: JQuery): ITarefaSniper {
      this.ajax = new App.Ajax();
      var dadosForm: IFormDadosSniperPro = this.ajax.convertFormToJSON(form);
      // console.log("DATA FORM", dadosForm);

      if (App.Util.validarFiltroSniper(dadosForm)) {
        var tarefa: ITarefaSniper = {};
        if (dadosForm.piloto_automatico) {
          tarefa.id = App.Util.TAREFA_SNIPER
          tarefa.data = null
          return tarefa
        }


        tarefa.id = App.Util.TAREFA_SNIPER
        tarefa.data = {}
        tarefa.data.descanso = dadosForm.descanso
        tarefa.data.intervalo = dadosForm.intervalo
        tarefa.data.limite_compra = dadosForm.limite_compra
        tarefa.data.quantidade = dadosForm.limite_compra
        tarefa.data.tempo = dadosForm.tempo
        tarefa.data.velocidade = dadosForm.velocidade
        tarefa.data.tempo_minimo_eficacia = 10
        tarefa.data.porcentagem_eficacia = 10
        tarefa.data.filtros = []
        tarefa.data.filtros.push(this.obterObjetoFormFiltro(dadosForm))
        return tarefa
      }

      return null;
    }

    private obterObjetoFormFiltro(dadosForm: IFormDadosSniperPro): IFiltroOptions {
      return {
        data: {
          maskedDefId: !App.Util.empty(dadosForm.maskedDefId) ? dadosForm.maskedDefId : null,
          minBid: !App.Util.empty(dadosForm.minBid) ? dadosForm.minBid : null,
          maxBid: !App.Util.empty(dadosForm.maxBid) ? dadosForm.maxBid : null,
          quality: !App.Util.empty(dadosForm.quality) ? dadosForm.quality : null,
          icontraits: !App.Util.empty(dadosForm.icontraits) ? dadosForm.icontraits : null,
          rarity: !App.Util.empty(dadosForm.rarity) ? dadosForm.rarity : null,
          position: !App.Util.empty(dadosForm.position) ? dadosForm.position : null,
          chemical: !App.Util.empty(dadosForm.chemical) ? dadosForm.chemical : null,
          nation: !App.Util.empty(dadosForm.nation) ? dadosForm.nation : null,
          league: !App.Util.empty(dadosForm.league) ? dadosForm.league : null,
          club: !App.Util.empty(dadosForm.club) ? dadosForm.club : null,
          minBuyNow: !App.Util.empty(dadosForm.minBuyNow) ? dadosForm.minBuyNow : null,
          maxBuyNow: !App.Util.empty(dadosForm.maxBuyNow) && dadosForm.precoCompra == 1 ? dadosForm.maxBuyNow : null,
          variar: !App.Util.empty(dadosForm.variar) && dadosForm.variar >= 1 ? dadosForm.variar : null,
          lucro: !App.Util.empty(dadosForm.lucro) && dadosForm.precoCompra == 2 ? dadosForm.lucro : null,
          turbo: !App.Util.empty(dadosForm.turbo) && dadosForm.turbo ? true : null,
          limiteCompraMin: !App.Util.empty(dadosForm.limite_compra_min) ? dadosForm.limite_compra_min : null,
          limiteCompraMax: !App.Util.empty(dadosForm.limite_compra_max) ? dadosForm.limite_compra_max : null,
        },
        venda: dadosForm.ativar_venda_automatica
          ? {
            duracao: 3600,
            valorLanceMinimo: !App.Util.empty(dadosForm.valor_lance_minimo) ? dadosForm.valor_lance_minimo : null,
            valorVenda: !App.Util.empty(dadosForm.valor_venda) ? dadosForm.valor_venda : null,
            precoFutbin: dadosForm.precoFutbin,
            porcentagemMaisBarato: !App.Util.empty(dadosForm.porcentagemMaisBarato) ? dadosForm.porcentagemMaisBarato : 0,
            precoInteligente: dadosForm.precoInteligente
          }
          : null,
        id: dadosForm.id ? dadosForm.id : null,
        nome: "SNIPER"
      }
    }

    private exibirLogsSniper(dadosLog: IDataLog) {
      if ($.isArray(dadosLog)) {
        return
      }

      let elementoEspacoLogConta = $(`.espaco-log-${dadosLog.idConta}`)

      switch (dadosLog.tipo) {
        case Util.EVENTO_TIPO_COMPRA:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          if (dadosLog.status) {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-success', "Comprou", descricao)
            this.atualizarContadorModalSniper(dadosLog.idConta)
          } else {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-secondary', "Disputa Perdida", descricao)
          }
          break;
        case Util.EVENTO_TIPO_ENVIOU_TRANSFERENCIA:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Movido para Transferência", descricao)
          break;
        case Util.EVENTO_TIPO_COLOCOU_A_VENDA:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Colocou à venda", descricao)
          break;
        case Util.EVENTO_INICIOU_SNIPER:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "Iniciou", "Sniper foi iniciado.")
          break;
        case Util.EVENTO_PAROU_SNIPER:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Parou", "Sniper parou.")
          break;
        case Util.EVENTO_PAROU_SNIPER_LIMITE_ATINGIDO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite Compra", "Limite de compra atingido.")
          break;
        case Util.EVENTO_PAROU_CAPACIDADE_LISTAS_ATINGIDA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Lista Cheia", "Sua lista está cheia.")
          break;
        case Util.EVENTO_TIPO_ERRO:
          var objErroLogCf: IErroProcesso = Util.getObjResponseLog(dadosLog);
          if (objErroLogCf && objErroLogCf.processo === 'preco_externo_cloudflare') {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-amarelo-second', "Cloudflare", objErroLogCf.error || "Bloqueio Cloudflare na busca de preço externo.")
          } else if (objErroLogCf && objErroLogCf.processo === 'preco_externo_cloudflare_ok') {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-success', "Cloudflare OK", objErroLogCf.error || "Fonte externa voltou ao normal.")
          } else {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Erro Indefinido", "Um erro ocorreu.")
          }
          break;
        case Util.EVENTO_TIPO_ENVIOU_CLUBE:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Enviou para o clube", "Item enviado ao clube.")
          break;
        case Util.EVENTO_TIPO_RELISTOU:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Relistagem", "Itens foram relistados à venda.")
          break;
        case Util.EVENTO_TIPO_LIMPAR_VENDIDOS:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Vendidos Removidos", "Removeu itens vendidos da lista de itens vendidos.")
          break;
        case Util.EVENTO_TIPO_LISTA_NAO_ATRIBUIDOS_CHEIA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Lista Cheia", "Lista de não atribuídos cheia.")
          break;
        case Util.EVENTO_TIPO_CAPTCHA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-warning', "Captcha Solicitado", "Um captcha foi solicitado em sua conta.")
          break;
        case Util.EVENTO_TIPO_SOFTBAN:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-warning', "Softban", "Parece que há um softban nesse momento em sua conta.")
          break;
        case Util.EVENTO_TIPO_ERROS_EM_SEQUENCIA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-warning', "Erro de conexao", "Parece que ocorreu um erro de conexão em sua conta.")
          break;
        case Util.EVENTO_TIPO_INCIANDO_AUTOCAPTCHA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "Iniciando AutoCaptcha", "O sistema irá tentar resolver o captcha automaticamente.")
          break;
        case Util.EVENTO_TIPO_AUTOCAPTCHA_RESOLVIDO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-success', "Captcha Resolvido", "O sistema resolveu seu captcha automaticamente.")
          break;
        case Util.EVENTO_TIPO_AUTOCAPTCHA_NAO_RESOLVIDO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Captcha Não Resolvido", "O sistema não conseguiu resolver o captcha automaticamente.")
          break;
        case Util.EVENTO_TIPO_LUCRO_INCOMPATIVEL_COM_FILTRO:
          var descricao = Util.getObjInfoViewLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Lucro Incompatível", descricao)
          break;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_BAIXO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Lucro Baixo", "Esse filtro no momento está obtendo lucro muito baixo.")
          break;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_INUTIL:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Lucro Impossível", "Não é possível obter lucro com esse filtro, por esse motivo o sniper está parando.")
          break;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO:
          var dadosLucro: any = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          var descricao = parseInt(dadosLucro.lucroEstimado) <= 0 ? `É Previsto que você tenha prejuízo nesse filtro, preço de venda mais barato encontrado é de <b>${dadosLucro.precoVenda} Coins</b>.` : `É Previsto um lucro mínimo de <b>${dadosLucro.lucroEstimado} Coins</b> por compra, comprando por até <b>${dadosLucro.precoCompra} Coins</b> e Vendendo por no mínimo <b>${dadosLucro.precoVenda} Coins</b> nesse filtro.`;
          Util.salvarLogSniper(elementoEspacoLogConta, parseInt(dadosLucro.lucroEstimado) <= 0 ? 'badge-danger' : 'badge-success', "Lucro Estimado", descricao)
          break;
        case Util.EVENTO_TIPO_NENHUM_FILTRO_ENCONTRADO_PARA_TAREFA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Filtro nao encontrado", "Não foi possível iniciar a tarefa, nenhum filtro foi encontrado.")
          break;
        case Util.EVENTO_ERROR_INICIAR_INSTANCIA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Erro ao abrir conta", "Não foi possível abrir o WebApp.")
          break;
        case Util.EVENTO_ERROR_INICIAR_INSTANCIA_COM_PROXY:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Erro proxy", "Proxy incorreto, verifique as configurações de proxy da sua conta.")
          break;
        case Util.EVENTO_TIPO_SALDO_INSUFICIENTE:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Saldo insuficiente", "Você não tem uma quantidade de coins suficiente.")
          break;
        case Util.EVENTO_TIPO_VENDA_NAO_INFORMADA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Não Colocado à Venda", "Valor de venda não encontrado para esse item.")
          break;
        case Util.EVENTO_TIPO_VENDA_BLOQUEADA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Venda Bloqueada", "Item não pode ser vendido, o valor de venda é <b>inferior ao comprado ou listado</b> anteriormente, para desativar essa trava de segurança vá para <b>preferências em seu menu configurações</b>")
          break;
        case Util.EVENTO_RELISTAGEM_DESCARTE:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Descarte", "Itens foram descartados na lista de transferência")
          break;
        case Util.EVENTO_PACOTE_DESCARTE_NEGOCIAVEL:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Descarte pacote", "Jogadores negociáveis descartados ao abrir pacote")
          break;
        case Util.EVENTO_CONTA_ABERTA_COM_RESOLVER_BUG_EA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Resolver Bug EA", "Conta iniciada com resolver bug EA ativo")
          break;
        case Util.EVENTO_TIPO_CONTA_CARREGADA:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "WebApp recarregado", "Seu WebApp foi recarregado, essa é uma medida do sistema para liberar memória em sua máquina")
          break;
        case Util.EVENTO_TIPO_TRAVA_CONFERENCIA_FILTRO:
          var dadosConferenciaFiltro: { conferenciaFiltro: any, filtroSelecionado: any } = Util.getObjResponseLog(dadosLog);
          console.log("dadosConferenciaFiltro", dadosConferenciaFiltro)
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo-vermelho', "Conferência de Filtro", Util.getMensagemConferenciaFiltro(dadosConferenciaFiltro.conferenciaFiltro))
          break;
        case Util.EVENTO_TIPO_ATUALIZACAO_PRECO_COMPRA_FILTRO_LUCRO:
          var dadosAtualizacaoPreco: { preco: number, minutosmaximoAtualizacao: number } = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-primary', "Preço Compra Atualizado", `Seu filtro teve o preço de compra atualizado para <b>${dadosAtualizacaoPreco.preco} Coins</b> , essa é uma medida para evitar prejuízo`)
          break;
        case Util.EVENTO_TESTE_PRECO:
          var dadosTestePreco: { html: string } = Util.getObjResponseLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-info', "Teste de Preco", dadosTestePreco && dadosTestePreco.html ? dadosTestePreco.html : "Teste de preco executado.")
          break;
        case Util.EVENTO_RESGATE_RECOMPENSAS_INICIALIZACAO:
          var dadosClaimRewardsInicializacao: { html: string } = Util.getObjResponseLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, (dadosLog.status as any) === false ? 'badge-danger' : 'badge-info', "Resgate recompensas", dadosClaimRewardsInicializacao && dadosClaimRewardsInicializacao.html ? dadosClaimRewardsInicializacao.html : "Resgate opcional de recompensas executado.")
          break;
        case Util.EVENTO_LIMITE_VENDA_ATIVA_ATINGIDO:
          var resposta: { capacidadeVendaAtiva: number } = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          if (resposta.capacidadeVendaAtiva >= 100) {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite de Venda Ativa Atingido!", `Impossível listar em venda, você atingiu o limite máximo de <b>${resposta.capacidadeVendaAtiva} itens</b> em venda ativa`)
          } else {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite de Venda Ativa Atingido!", `Só é permitido colocar até <b>${resposta.capacidadeVendaAtiva} itens</b> em venda ativa no WebApp, essa é uma nova regra da EA, caso queira burlar esse limite e assumir os riscos, vá em <a class="btn btn-sm btn-link" data-config="config" data-id-conta-ea="" data-toggle="modal" data-target="#modalConfigExtensao" href=""><i class="fa fa-cog" style="margin-right: 0.5rem;"></i>Preferências</a> e ative a opção "Aumentar Capacidade de Venda Ativa"`)
          }
          break;
        case Util.EVENTO_LIMITE_ATINGIDO:
          var respostaLimiteAtingido: { id_conta: number, limite_atual: number, id_perfil: number, requests: number } = Util.getObjResponseLog(dadosLog);;

          let msgPerfil = !respostaLimiteAtingido.id_perfil ?
            `Sua conta está sem um perfil, para continuar, <b>crie um perfil para a conta</b>, coloque um limite acima do atual no <b>campo "Limite de Requests dia"</b>, salve esse perfil e aplique-o na conta,`
            : ' Para continuar, <b>edite o perfil da conta</b>, coloque um limite acima do atual no campo "Limite de Requests dia", salve o perfil'
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-danger', "Limite Atingido",
            `O limite diário de buscas da sua conta foi atingido: <b>Limite Atual(${respostaLimiteAtingido.limite_atual})</b>.<br />
           ${msgPerfil} depois clique em "remover limites" no menu "mais opções" do dashboard.`)
          break;
        case Util.EVENTO_AUTODME_DME_NAO_ENCONTRADO:
        case Util.EVENTO_AUTODME_DME_RESOLVIDO:
        case Util.EVENTO_PACOTE_ANALISE:
        case Util.EVENTO_AUTODME_ACOES:
          var dadosLogAutoDme: { html: string } = Util.getObjResponseLog(dadosLog);
          console.log("dadosConferenciaFiltro", dadosLogAutoDme)
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-cinza-escuro', "Auto DME", dadosLogAutoDme.html)
          break;
        case Util.EVENTO_PACOTE_ABERTO:
          var dadosLogAutoDme: { html: string } = Util.getObjResponseLog(dadosLog);
          console.log("dadosConferenciaFiltro", dadosLogAutoDme)
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-pacote-aberto', "Pacote Aberto", dadosLogAutoDme.html)
          break;
        case Util.EVENTO_CLUBE_JOGADORES_SCAN_EA: {
          const dadosClubScanSn: { html: string } = Util.getObjResponseLog(dadosLog);
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-cinza-escuro', 'Clube (EA)', dadosClubScanSn && dadosClubScanSn.html ? dadosClubScanSn.html : '—')
          break;
        }
        case Util.EVENTO_FILTROS_DEFINIDOS:
          var dadosFiltros: { nomeFiltroExecucao: string, nomeFiltrosDefinidos: string, evento: string, precoCompra: string, vaiVariarPrecoBusca: boolean } = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
          let infoVariarPreco = dadosFiltros.vaiVariarPrecoBusca ? ' com variação' : '';
          let infoEvento = '';
          if (dadosFiltros.evento == "STARTED") {
            infoEvento = "no início da tarefa";
          } else if (dadosFiltros.evento == "RESUMED") {
            infoEvento = "na continuação da tarefa";
          }
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-filtro', "Filtro Definido", `Filtro Definido: <b>${dadosFiltros.nomeFiltroExecucao}</b> ${infoEvento} | Preço de Compra: <b>${dadosFiltros.precoCompra}</b>${infoVariarPreco}<br/>Filtros disponíveis na execução: <b>${dadosFiltros.nomeFiltrosDefinidos}</b>`)
          break;
        case Util.EVENTO_ERRO_AUTENTICACAO:
          Util.salvarLogSniper(elementoEspacoLogConta, 'badge-alerta-amarelo', "Autenticação Expirou", "Foi necessário fechar a conta para fazer uma nova autenticação.")
          break;
        case Util.EVENTO_EXECUTAR_TAREFA_AUTOMATICA:
          var dadosTarefaLog: { tarefa: number } = Util.getObjResponseLog(dadosLog);
          if (dadosTarefaLog.tarefa == Util.TAREFA_VENDA_COINS) {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-tarefa-auto', "Tarefa Automática", "Uma tarefa automática de <b>venda de coins</b> foi iniciada.")
          }

          if (dadosTarefaLog.tarefa == Util.TAREFA_AUTO_DME) {
            Util.salvarLogSniper(elementoEspacoLogConta, 'badge-tarefa-auto', "Tarefa Automática", "Uma tarefa automática de <b>Auto Dme</b> foi iniciada.")
          }
          break;
      }

    }

    private preencherCamposModalSniperTarefaAtual(idConta: number, dadosFiltroAplicar: IFiltroOptions = null, nomeOriginal: string = ''): void {
      var tarefaAtual: ITarefaSniper = null
      if (dadosFiltroAplicar && this.tarefasSniperContas[idConta] && this.tarefasSniperContas[idConta].hasOwnProperty("data")) {
        this.tarefasSniperContas[idConta].data.filtros[0] = dadosFiltroAplicar
        tarefaAtual = this.tarefasSniperContas[idConta]
      } else if (dadosFiltroAplicar) {
        tarefaAtual = {}
        tarefaAtual.data = {}
        tarefaAtual.data.filtros = []
        tarefaAtual.data.tempo = null
        tarefaAtual.data.filtros[0] = dadosFiltroAplicar
      }

      if (!tarefaAtual) {
        return
      }

      var modalSniperPro = $("#modalSniperPro");

      var pilotoAutomatico = !tarefaAtual.data
      if (pilotoAutomatico) {
        modalSniperPro.find('input[name=piloto_automatico]').prop("checked", true).trigger('change');
        return
      } else {
        modalSniperPro.find('input[name=piloto_automatico]').prop("checked", false).trigger('change');
      }

      var dadosFiltro: IFiltroOptions = tarefaAtual.data.filtros[0]

      this.filtrosEa.setCampoInputName("id", dadosFiltro.id);
      this.filtrosEa.setCampoInputName("nome", dadosFiltro.nome);
      try {
        modalSniperPro.find('input[name=campo_nome_filtro]').val(nomeOriginal)
      } catch (e) { }


      if (dadosFiltro.data.maskedDefId && dadosFiltro.data.maskedDefId.length) {
        this.filtrosEa.setCampoJogadorFiltroPro(dadosFiltro.data.maskedDefId, App.Util.objPlayers, modalSniperPro.find('select[name="maskedDefId[]"]'), "#searchclearSniperPro");
      } else {
        modalSniperPro.find("#searchclearSniperPro").click();
      }

      /**
       * Filtro e Venda automatica
       */
      this.filtrosEa.setCampoSelect2("quality", dadosFiltro.data.quality);
      this.filtrosEa.setCampoSelect2("icontraits", dadosFiltro.data.icontraits);
      this.filtrosEa.setCampoSelect2("rarity[]", dadosFiltro.data.rarity);
      this.filtrosEa.setCampoSelect2("position", dadosFiltro.data.position);
      this.filtrosEa.setCampoSelect2("chemical", dadosFiltro.data.chemical);
      this.filtrosEa.setCampoSelect2("nation", dadosFiltro.data.nation);
      this.filtrosEa.setCampoSelect2("league", dadosFiltro.data.league);
      this.filtrosEa.setCampoSelect2("club", dadosFiltro.data.club);
      this.filtrosEa.setCampoInputName("minBuyNow", dadosFiltro.data.minBuyNow);
      this.filtrosEa.setCampoInputName("maxBuyNow", dadosFiltro.data.maxBuyNow);
      this.filtrosEa.setCampoInputName("variar", dadosFiltro.data.variar, true);
      this.filtrosEa.setCampoInputRadio("precoCompra", dadosFiltro.data.lucro ? "2" : "1");
      this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", !App.Util.empty(dadosFiltro.venda));
      this.filtrosEa.setCampoInputCheckbox("precoInteligente", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.precoInteligente);
      this.filtrosEa.setCampoInputCheckbox("precoFutbin", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.precoFutbin);
      this.filtrosEa.setCampoInputName("lucro", dadosFiltro.data.lucro);
      this.filtrosEa.setCampoInputCheckbox("turbo", !App.Util.empty(dadosFiltro.data.turbo) && dadosFiltro.data.turbo);
      this.filtrosEa.setCampoInputName("porcentagemMaisBarato", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.porcentagemMaisBarato ? dadosFiltro.venda.porcentagemMaisBarato : 0);
      this.filtrosEa.setCampoInputName("valor_lance_minimo", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.valorLanceMinimo ? dadosFiltro.venda.valorLanceMinimo : "");
      this.filtrosEa.setCampoInputName("valor_venda", !App.Util.empty(dadosFiltro.venda) && dadosFiltro.venda.valorVenda ? dadosFiltro.venda.valorVenda : "");
      this.filtrosEa.setCampoInputName("limiteCompraMin", dadosFiltro.data.limiteCompraMin);
      this.filtrosEa.setCampoInputName("limiteCompraMax", dadosFiltro.data.limiteCompraMax);

      /**
       * Configuracões comportamento
       */
      if (tarefaAtual.data.tempo) {
        var selectVelocidade: JQuery = modalSniperPro.find("select[name='velocidade']");
        var selectDescanso: JQuery = modalSniperPro.find("select[name='descanso']");
        var selectIntervalo: JQuery = modalSniperPro.find("select[name='intervalo']");
        var selectTempo: JQuery = modalSniperPro.find("select[name='tempo']");

        this.objSelect2.setSelectTag(selectVelocidade, { id: tarefaAtual.data.velocidade.toString(), text: (tarefaAtual.data.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectDescanso, { id: tarefaAtual.data.descanso.toString(), text: (tarefaAtual.data.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectIntervalo, { id: tarefaAtual.data.intervalo.toString(), text: (tarefaAtual.data.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
        this.objSelect2.setSelectTag(selectTempo, { id: tarefaAtual.data.tempo.toString(), text: (tarefaAtual.data.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

        modalSniperPro.find("input[name='porcentagem_eficacia']").val(tarefaAtual.data.porcentagem_eficacia);
        modalSniperPro.find("input[name='tempo_minimo_eficacia']").val(tarefaAtual.data.tempo_minimo_eficacia);
        modalSniperPro.find("input[name='limite_compra']").val(tarefaAtual.data.limite_compra);
      }
    }

    private aoAplicarFiltroPro(e: JQueryEventObject) {
      var idContaEa: any = $(e.currentTarget).data('idContaEa');

      var filtro: IFiltroOptions = $(e.currentTarget).data('filtro');
      filtro.id = $(e.currentTarget).data('id');
      filtro.nome = $(e.currentTarget).data('nome');
      let nomeOriginal = $(e.currentTarget).data("nomeOnly");

      this.preencherCamposModalSniperTarefaAtual(idContaEa, filtro, nomeOriginal);
    }

    private aoLimparFiltroPro(e: JQueryEventObject) {
      var formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      formSniperPro.find("#searchclearSniperPro").click();
      formSniperPro.find("input[name=max]").val('200').trigger('input').trigger('change');
      formSniperPro.find('#qualidade').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#raridade').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#posicao').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#estilo').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#estiloJogo').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#pais').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#liga').val('').trigger('change').trigger('select2:select');
      formSniperPro.find('#time').val('').trigger('change').trigger('select2:select');
    }

    private estadoVazioFiltroPro(e: JQueryEventObject) {
      var formFiltroProCad: any = $('#formFiltroProCad');
      $(e.currentTarget).find('#formFiltroProCad').find("#searchclearSniperPro").click();
      formFiltroProCad.find("input[name=minBuyNow]").val('').trigger('input').trigger('change');
      formFiltroProCad.find("input[name=maxBuyNow]").val('200').trigger('input').trigger('change');
      formFiltroProCad.find("input[name=variar]").val('').trigger('input').trigger('change');
      formFiltroProCad.find("input[name=turbo]").val('');
      formFiltroProCad.find('#qualidade').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#raridade').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#posicao').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#estilo').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#estiloJogo').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#pais').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#liga').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find('#time').val('').trigger('change').trigger('select2:select');
      formFiltroProCad.find(".conteudoGeralVendaAutomatica").find('input[name=ativar_venda_automatica]').prop('checked', false);
      formFiltroProCad.find(".conteudoGeralVendaAutomatica").find('input[name=precoInteligente]').prop('checked', false);
      formFiltroProCad.find(".conteudoGeralVendaAutomatica").find('input[name=precoFutbin]').prop('checked', false);
      formFiltroProCad.find("#filterName").val('');

      $(".corpoVendaAutomatica").hide();
    }

    private aoSelecionarPilotoAutomatico(e: JQueryEventObject) {
      var parent = $(e.target).parents('.parent-sniper-pro');
      if ($(e.target).is(':checked')) {
        parent.find('.espaco-formulario-pro').hide()
        parent.find('.espaco-piloto-automatico-pro').show()
        parent.find('.opcoes-form-sniper-pro').hide()
      } else {
        parent.find('.espaco-formulario-pro').show()
        parent.find('.opcoes-form-sniper-pro').show()
        parent.find('.espaco-piloto-automatico-pro').hide()
      }
    }

    private aoSelecionarPilotoAutomaticoAgendamento(e: JQueryEventObject) {
      var parent = $(e.target).parents('.card-espaco-configuracoes');
      if ($(e.target).is(':checked')) {
        parent.find('.condicao-piloto').hide()
        parent.find('.condicao-info-piloto').show()
      } else {
        parent.find('.condicao-piloto').show()
        parent.find('.condicao-info-piloto').hide()
      }
    }
    private copiarItemAgendamento(e: JQueryEventObject) {
      let itemLi = $(e.target).parents('li.container-item-sch');
      itemLi.find('.accordion .collapse').collapse('hide');
      let modal: JQuery = $(e.target).parents('.modal');
      let form: JQuery = modal.find('form');
      let idRegistro = form.find('input[name=id]').val();
      let index = itemLi.data('index')
      form.find(`#containerItem${index}`).find('.espaco-collapse-agenda').collapse('hide');
      let namesFiltros = itemLi.find('.info-names-filtros').html().split(",");
      let indexNext = form.find('li.container-item-sch').length

      var objAgendamento: IObjAgendamento = { id: form.find("input[name=id]").val(), nome: form.find("input[name=nome]").val(), dados: this.obterObjetoAgendamento(form, null) }

      let agendaCopy = objAgendamento.dados[index];
      agendaCopy.tarefa.data.filtros
      $.each(agendaCopy.tarefa.data.filtros, function (index: any, id: number) {
        agendaCopy.tarefa.data.filtros[index] = { nome: namesFiltros[index], id: id };
      });
      // console.log("OBJ AGEDAMENTO COPY", objAgendamento, agendaCopy, index, indexNext)
      this.preencherItemAgendamento(modal, form, objAgendamento, agendaCopy, indexNext)
      // $(`#containerItem${indexNext}`).find('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });



      // var main = $(e.target).parents('.clone-data');
      // let mainId = main.attr('id')
      // var itemLi = $(e.target).parents('li.container-item-sch');
      // let nextIndex = $(`#${mainId}`).find('.container-item-sch').length
      // console.log("COPY ITEM", nextIndex, main, itemLi);
      // let itemClone = itemLi.clone();
      // itemClone.attr('data-index', nextIndex)
      // itemClone.data('index', nextIndex)
      // itemClone.attr('id', `containerItem${nextIndex}`)
      // let idAccordion = itemClone.find('.accordion').attr('id').replace(/[0-9]/g, `${nextIndex}`);
      // itemClone.find('.accordion').attr('id', idAccordion)
      // let idHeading = itemClone.find('.card-header.checklist-item').attr('id').replace(/[0-9]/g, `${nextIndex}`);
      // let idCollapse = idHeading.replace('heading-', 'collapse-');
      // itemClone.find('.card-header.checklist-item').attr('id', idHeading)
      // itemClone.find('.card-header.checklist-item').attr('data-target', `#${idCollapse}`)
      // itemClone.find('.card-header.checklist-item').attr('aria-controls', `#${idCollapse}`)
      // itemClone.find('.card-header.checklist-item').data('target', `#${idCollapse}`)
      // let idDivCollapse = itemClone.find('div.collapse').attr('id').replace(/[0-9]/g, `${nextIndex}`);
      // itemClone.find('div.collapse').attr('id', idDivCollapse)
      // itemClone.find('div.collapse').attr('aria-labelledby', idHeading)
      // itemClone.find('div.collapse').attr('data-parent', `#${idAccordion}`)
      // itemClone.find('div.collapse').data('parent', `#${idAccordion}`)
      // itemClone.find('.copy-item-sch').on("click", (e) => { this.copiarItemAgendamento(e) });
      // itemClone.find('.select2.select2-container').remove()
      // if (itemClone.find('select.select2').length > 0) {
      //   this.objSelect2.inicializarCampo(itemClone.find('select.select2'));
      //   this.objSelect2.inicializarCampo(itemClone.find('select.select-tag'), Util.getOptionsSelectTag());
      // }
      // main.append(itemClone);
    }

    private atualizarContadorModalSniper(idConta: number) {
      if (idConta == this.idContaSniperModalAberto) {
        App.Util.incrementarComprasModalSniper()
      }
    }

    private tratarBuscaSniper(dados: any, callback: any) {
      // console.log("BUSCA...", dados);
      var comunicacaoEstabelecida = dados.id == this.idContaSniperModalAberto && $('#modalSniperPro').hasClass('show')
      if (comunicacaoEstabelecida) {
        switch (dados.tipo) {
          case 1:
            App.Util.incrementarTentativa($('#modalSniperPro .tentativas'), "fas fa-hourglass-half");
            break;
          case 0:
          default:
            App.Util.incrementarTentativa($('#modalSniperPro .tentativas'));
            break;
        }
      }

      return this.responderServidor(comunicacaoEstabelecida, {}, callback);
    }

    private tratarAcao(dados: any, callback: any = null) {
      // console.log("ACAO...", dados);
      var idConta = dados.id;
      switch (dados.tipo) {
        case 'abrindoWebApp':
          this.exibirLoadListConta(idConta, "Abrindo WebApp...")
          break;
        case 'inicializando':
          this.exibirLoadListConta(idConta, "Inicializando...")
          break;
        case 'executandoTarefasIniciais':
          this.exibirLoadListConta(idConta, "Executando Tarefas Iniciais...")
          break;
        case 'revendaJogadores':
          this.exibirLoadListConta(idConta, "Vendendo Jogadores de transferência coins...")
          break;
        case 'verificarVendaCoins':
          this.exibirLoadListConta(idConta, "Verificando venda de coins...")
          break;
        case 'iniciandoTarefa':
          this.exibirLoadListConta(idConta, "Iniciando Tarefa...")
          break;
        case 'fazendoLoginConta':
          this.exibirLoadListConta(idConta, "Login na conta...")
          break;
        case 'vendendoCoins':
          this.exibirLoadListConta(idConta, "Vendendo Coins...", true)
          break;
        case 'resolvendoDme':
          this.exibirLoadListConta(idConta, "Resolvendo DME 🎯...", false)
          break;
        case 'resolvaCaptcha':
          this.exibirMensagemPedindoResolucaoManualDeCaptcha(dados.data)
          break;
        case 'listando':
          this.tratarAcaoDeListagem(idConta, dados.data)
          break;
        case 'agendando':
          this.exibirLoadListConta(idConta, "Agendando...")
          break;
        case 'ocultarLoadListConta':
          this.ocultarLoadListConta(idConta)
          break;
      }
    }

    private tratarError(dados: any, callback: any = null) {
      // console.log("ERROR...", dados);
      var idConta = dados.id;
      switch (dados.tipo) {
        case 'erroIniciarInstancia':
          swal.fire({
            icon: 'error',
            title: 'Conta não iniciada:' + (dados.data ? dados.data.nome : idConta),
            text: 'Um erro ocorreu ao iniciar a conta, o navegador se desconectou ou algum outro problema ocorreu, tente novamente, se o erro persistir desligue e ligue seu plugin e carregue essa tela novamente.'
          })
          this.ocultarLoadListConta(idConta)
          App.Util.ocultarModalPaginaCarregando()
          break;
        case 'erroIniciarComProxy':
          swal.fire({
            icon: 'error',
            title: 'Proxy incorreto:' + (dados.data ? dados.data.nome : idConta),
            text: 'Proxy incorreto, verifique as configurações de proxy da sua conta, se o erro persistir desligue e ligue seu plugin novamente.'
          })
          this.ocultarLoadListConta(idConta)
          App.Util.ocultarModalPaginaCarregando()
          break;
        case 'erroContaNaoHabilitadaAgendamento':
          swal.fire({
            icon: 'error',
            title: 'Conta não pode ser agendada:' + (dados.data ? dados.data.nome : idConta),
            text: 'Verifique o status da conta, se houver captcha resolva antes de agendar nova tarefa, se o erro persistir recarregue o dashboard e desligue e ligue seu plugin novamente..'
          })
          this.ocultarLoadListConta(idConta)
          break;
      }
    }

    private atualizarViewProxyConta(idConta: number, checked: boolean = false, data: IDadosProxy) {
      // console.log("CHEGOU", idConta, checked, data)
      let infoProxy = this.getElementoListConta(idConta).find('.info-proxy');
      let strDataPopovers = `<p class="mb-0"><small>PROTOCOLO: ${data.protocolo ? data.protocolo : ''}</small></p><p class="mb-0"><small>IP: ${data.proxy_address ? data.proxy_address : ''}</small></p><p class="mb-0"><small>PORTA: ${data.proxy_port ? data.proxy_port : ''}</small></p>`
      if (checked) {
        infoProxy.show()
        infoProxy.attr('data-content', `${strDataPopovers}`);
      } else {
        infoProxy.hide()
        infoProxy.attr('data-content', ``);
      }
    }

    private getDadosProxyVinculo(idConta: number): IProxy {
      // se tem id da conta não é vinculo então nao precisa de proxy de vinculo de conta
      if (idConta) {
        return null;
      }

      let selectProxy = $(".form-vinculo-proxy").find('select[name=select_proxy]').find(':selected')
      if (!selectProxy.val()) {
        return null
      }

      let proxyVinculo = {
        id: selectProxy.val(),
        nome: selectProxy.data('nome'),
        protocolo: selectProxy.data('protocolo'),
        address: selectProxy.data('address'),
        port: selectProxy.data('port'),
        login: selectProxy.data('login'),
        password: selectProxy.data('password')
      }
      // console.log("VAI COM PROXY", proxyVinculo)

      return proxyVinculo.address && proxyVinculo.port && proxyVinculo.protocolo ? proxyVinculo : null
    }

    private getPersona() {
      let selectPersona = $(".form-persona").find('select[name=select_persona]').find(':selected');
      if (!selectPersona.val()) {
        return null
      }
      return selectPersona.val();
    }

    public ordenaListagemDeContas(id: number, status: number) {
      if (_.contains(Util.ARRAY_STATUS_CONTA_HABILITADA, status)) {
        App.Business.objDataTableContas.order([2, 'asc']).draw(false);
      }
    }

    public exibirMensagemPedindoResolucaoManualDeCaptcha(dados: any) {
      swal.fire({
        icon: 'warning',
        title: 'Conta com Captcha:' + dados.email,
        text: 'Resolva o Captcha na Conta em outro navegador antes de vincula-la'
      })
    }

    public tratarAcaoDeListagem(idConta: number, dados: any) {
      if (dados.status) {
        this.exibirLoadListConta(idConta, "Listando...")
      }
    }

    private getContasSelecionadas() {
      return Business.objDataTableContas.rows({ selected: true })
    }

    private atualizarTextoBotaoAcaoSelecionada(selector: string, texto: string) {
      const botoes = $(selector);
      const labels = botoes.find('.js-action-label');
      if (labels.length) {
        labels.text(texto);
        return;
      }
      botoes.html(texto);
    }

    private getDataExecucaoContaCurta(data: string): string {
      const partes = data.match(/(\d{2})\/(\d{2})\/\d{4}.*?(\d{2}:\d{2})/)
      return partes ? `${partes[1]}/${partes[2]} ${partes[3]}` : data
    }

    private getLimiteContaFormatado(obj: IConta, campo: "limite_atingido" | "limite_compras_atingido" | "limite_compras_sniper_atingido" | "limite_requests_compra_atingido"): string {
      const valor = obj ? (obj as any)[campo] : null;
      return valor && valor >= Util.getDateStringDefault()
        ? Util.parseDataUtcStringToDateLocale(valor)
        : ``
    }

    private getLimiteRequestsContaFormatado(obj: IConta): string {
      return this.getLimiteContaFormatado(obj, "limite_atingido")
    }

    private renderLimiteContaChip(obj: IConta, campo: "limite_atingido" | "limite_compras_atingido" | "limite_compras_sniper_atingido" | "limite_requests_compra_atingido", titulo: string, label: string = ""): string {
      const limiteAtingido = this.getLimiteContaFormatado(obj, campo)
      return limiteAtingido
        ? `<span title="${this.htmlEscape(titulo)}: ${limiteAtingido}" class="conta-exec-data"><i class="fa-solid fa-lock"></i>${label ? `<span class="font-weight-bold mr-1">${this.htmlEscape(label)}</span>` : ``}${this.getDataExecucaoContaCurta(limiteAtingido)}</span>`
        : ``
    }

    private renderLimiteRequestsConta(obj: IConta): string {
      return this.renderLimiteContaChip(obj, "limite_atingido", "Limite requests atingido")
    }

    private renderLimitesConta(obj: IConta): string {
      return [
        this.renderLimiteRequestsConta(obj),
        this.renderLimiteContaChip(obj, "limite_compras_atingido", "Limite compras gerais atingido", "G"),
        this.renderLimiteContaChip(obj, "limite_compras_sniper_atingido", "Limite compras sniper atingido", "S"),
        this.renderLimiteContaChip(obj, "limite_requests_compra_atingido", "Limite requests de compra atingido", "R"),
      ].join("")
    }

    private renderInfoExecucaoConta(obj: IConta): string {
      const existeAutoDmes = obj.perfil && obj.perfil.dados && obj.perfil.dados.autodmes && obj.perfil.dados.autodmes.length
      const autoDmeInfo = existeAutoDmes
        ? `<p style="word-wrap: break-word;width: 400px;white-space: normal;" class="m-0 pl-2 pr-2">${Util.getInfoAutoDmes(obj.perfil.dados.autodmes)}</p>`
        : ``
      const strAgenda = obj.perfil && obj.perfil.dados && obj.perfil.dados.piloto_automatico
        ? `<span class="badge badge-info" style="margin-left: 5px;color: #ffffff;font-size: 10px;background-color: #686868;cursor: auto;border: none;font-weight: 700;">PILOTO AUTO.</span>`
        : (obj.perfil && obj.perfil.dados && obj.perfil.dados.filtros ? `<p style="word-wrap: break-word;width: 400px;white-space: normal;" class="m-0 pl-2 pr-2">${Util.getFiltrosGeralAgenda(obj.perfil.dados.filtros)}</p>` : ``)

      return `
        <div class="conta-execucao-compact">
          <div class="btn-group conta-exec-chip" style="${obj.perfil && obj.perfil.id ? '' : 'display:none;'}">
            <a class="dropdown-toggle conta-exec-chip-link" data-toggle="dropdown" data-boundary="window" href="#" aria-expanded="false" title="Perfil: ${obj.perfil && obj.perfil.id ? obj.perfil.nome : ''}">
              <i class="fas fa-cog"></i>
              <span class="conta-exec-chip-text">${obj.perfil && obj.perfil.id ? obj.perfil.nome : ''}</span>
              ${obj.filtros && $.isArray(obj.filtros) && obj.filtros.length ? `<span class="conta-exec-flag">Filtro</span>` : ``}
            </a>
            <div class="dropdown-menu p-0 pt-1 pb-1" x-placement="top-start" style="max-width: 400px;position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(4px, 5px, 0px);border-radius: 3px;">
              ${strAgenda}
            </div>
          </div>

          <div class="btn-group conta-exec-chip" style="${existeAutoDmes ? '' : 'display:none;'}">
            <a class="dropdown-toggle conta-exec-chip-link" data-toggle="dropdown" data-boundary="window" href="#" aria-expanded="false" title="Auto DME">
              <i class="fa-solid fa-brain"></i>
              <span>DME</span>
            </a>
            <div class="dropdown-menu p-0 pt-1 pb-1" x-placement="top-start" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(4px, 5px, 0px);border-radius: 3px;">
              ${autoDmeInfo}
            </div>
          </div>

          <span class="conta-exec-extra">
            ${obj.perfil && obj.perfil.dados && obj.perfil.dados.resolver_captcha_automaticamente ? `
            <span class="conta-exec-chip conta-exec-chip-muted" title="Autocaptcha ativo">
              <i class="fas fa-robot"></i>Captcha
            </span>`: ''}

            ${obj.proxy ? `
            <span data-html="true" data-container="body" data-toggle="popover" data-color="default" data-placement="top"
            data-content="${obj.proxy.address}:${obj.proxy.port}" data-original-title="${obj.proxy.address}:${obj.proxy.port}" title="${obj.proxy.address}:${obj.proxy.port}">
              <span class="conta-exec-chip conta-exec-chip-muted">
                <i class="fa-solid fa-globe"></i>Proxy
              </span>
            </span>`: ''}

            ${obj.perfil && obj.perfil.api_venda_coins ? `
            <span title="${obj.perfil.api_venda_coins.nome}">
              <span class="conta-exec-chip conta-exec-chip-muted">
                <i class="fa-solid fa-dollar-sign"></i>API
              </span>
            </span>`: ''}
          </span>
        </div>
      `
    }

    private getAllContas() {
      return Business.objDataTableContas.rows()
    }

    private getIdsContasSelecionadas(): number[] {
      try {
        let contasSelecionadas = this.getContasSelecionadas()
        return contasSelecionadas.ids().toArray()
      } catch (error) {
        return []
      }
    }

    private getIdsAllContas(): number[] {
      try {
        let contasDash = this.getAllContas()
        return contasDash.ids().toArray()
      } catch (error) {
        return null
      }
    }

    // private getIdsServidoresSelecionados(): number[] {
    //   let servidoresSelecionados = this.getContasSelecionadas()
    //   return servidoresSelecionados.ids().toArray()
    // }

    // private getServidoresSelecionados() {
    //   return this.objDataTableServidores.rows({ selected: true })
    // }

    private async atualizarContaNoPluginAsync(id: any, semCache: boolean = false, atualizarProxyFutTransfer: boolean = false): Promise<IRespostaMensagem> {
      return new Promise((resolve: any, reject: any) => {
        this.atualizarContaNoPlugin({ id: id, semCache: semCache, atualizarProxyFutTransfer: atualizarProxyFutTransfer }, (response: IRespostaMensagem) => {
          if (response.status && response.result && response.result.contaAtualizada) {
            resolve(response);
          } else {
            resolve(null);
          }
        });
      });
    }

    private async atualizarContasNoPluginAposDadosAplicados(contas_ids: number[], semCache: boolean = false, callbackSucessoFinal: () => void = () => { }, atualizarProxyFutTransfer: boolean = false) {
      const delay = (ms: number) => new Promise((resolve: any) => setTimeout(resolve, ms)); // Função para criar o delay

      try {
        for (const id of contas_ids) {
          const response = await this.atualizarContaNoPluginAsync(id, semCache, atualizarProxyFutTransfer);
          console.log("Conta Atualizada no Plugin:", id, response);
          if (response && response.result && response.result.contaAtualizada) {
            this.updateContaDatatable(response.result.contaAtualizada);
          }
          // Adiciona um delay de 3 segundos antes de continuar para a próxima conta
          await delay(3000);

          // ao final desse for, preciso chamar callback de sucesso
          if (id === contas_ids[contas_ids.length - 1]) {
            callbackSucessoFinal();
          }
        }
      } catch (error) {
        console.log('Erro ao atualizar contas:', error);
      }
    }

    private aoAplicarPerfil(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarPerfil"))
      dadosForm.contas_ids = this.getIdsContasSelecionadas()
      // console.log("IDS", dadosForm)

      $("#modalAplicarPerfil").modal('hide')
      this.ajax.postAcao(App.Util.config.urlAplicarProfile, dadosForm, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { perfil: { id: number, nome: string } } } }) => {
        // console.log("APP PERFIL::", resposta.dadosRetornados.dadosResposta.perfil);
        swal.fire({
          icon: 'success',
          title: 'Perfil Aplicado!',
          text: 'O Perfil foi aplicado nas contas selecionadas, aguarde um momento para que a parte visual seja atualizada.'
        })

        await this.atualizarContasNoPluginAposDadosAplicados(dadosForm.contas_ids, true)
      });
    }

    private aoAplicarFiltros(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarFiltros"))
      dadosForm.contas_ids = this.getIdsContasSelecionadas()
      // console.log("APP FILTROS", dadosForm)

      $("#modalAplicarFiltros").modal('hide')
      this.ajax.postAcao(App.Util.config.urlAplicarFiltros, dadosForm, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { filtros: any[] } } }) => {
        // console.log("APP FILTROS::", resposta.dadosRetornados.dadosResposta);
        swal.fire({
          icon: 'success',
          title: 'Filtro Aplicado!',
          text: 'O Filtro foi aplicado nas contas selecionadas, aguarde um momento para que a parte visual seja atualizada.'
        })

        await this.atualizarContasNoPluginAposDadosAplicados(dadosForm.contas_ids, true)
      });
    }

    private aoAplicarProxy(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarProxy"))
      dadosForm.contas_ids = this.getIdsContasSelecionadas()
      // console.log("IDS", dadosForm)

      $("#modalAplicarProxy").modal('hide')
      this.ajax.postAcao(App.Util.config.urlAplicarProxy, dadosForm, async (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { proxy: IProxy } } }) => {
        // console.log("ADD PROXY::", resposta.dadosRetornados.dadosResposta, resposta);
        swal.fire({
          icon: 'success',
          title: 'Proxy Aplicado!',
          text: 'O Proxy foi aplicado nas contas selecionadas, aguarde um momento para que a parte visual seja atualizada.'
        })

        await this.atualizarContasNoPluginAposDadosAplicados(dadosForm.contas_ids, true)
      });
    }

    private avisarSobreReagendamentoPluginDesconectado(mensagem: string = null) {
      // if (!this.conectado) {
      //   swal.fire({
      //     icon: 'warning',
      //     title: 'Impossível Reagendar!',
      //     text: mensagem ? mensagem : 'A interface não está conectada ao plugin, alterações de perfil e agendamentos serão atualizados automaticamente pelo plugin após alguns minutos, se desejar alteração imediata, conecte ao plugin e clique em "atualizar agenda" no menu da conta ou se estiver na mesma maquina do plugin, apenas inicie-o.'
      //   })
      // }
    }

    private inicializarEventosDataTables() {
      let aoSelecionarOuDeselecionar = (e: any, dt: any, type: any, indexes: any) => {
        if (type === 'row') {
          let contasSelecionadas = this.getContasSelecionadas()
          var count = contasSelecionadas.count();
          $('.btn-aplicar').html(count > 0 ? `+ Perfil (${count})` : `+ Perfil`)
          $('.btn-dt-aplicar-filtros').html(count > 0 ? `+ Filtros (${count})` : `+ Filtros`)
          $('.btn-dt-aplicar-proxy').html(count > 0 ? `+ Proxy (${count})` : `+ Proxy`)
          $('.btn-dt-atualizar').html(count > 0 ? `Atualizar (${count})` : `Atualizar`)
          $('.btn-executar-tarefa').html(count > 0 ? `Exec. Tarefa (${count})` : `Exec. Tarefa`)
          $('.btn-executar-auto-dme-imediato').html(count > 0 ? `Auto DME (${count})` : `Auto DME`)
          $('.btn-dt-acoes').html(count > 0 ? `+ Ações (${count})` : `+ Ações`)
          $('.btn-dt-resolver-dme').html(count > 0 ? `Resolver Dme (${count})` : `Resolver Dme`)
          $('.btn-dt-transferir-contas').html(count > 0 ? `💰⇆ Transferir Coins (${count})` : `💰⇆ Transferir Coins`)

          $('.btn-aplicar-profile').html(count > 0 ? `Aplicar (${count})` : `Aplicar`)
          $('.btn-aplicar-filtros').html(count > 0 ? `Aplicar (${count})` : `Aplicar`)
          $('.btn-aplicar-proxy').html(count > 0 ? `Aplicar (${count})` : `Aplicar`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-abrir-contas', count > 0 ? `Abrir Contas (${count})` : `Abrir Contas`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-executar-tarefa-contas', count > 0 ? `Exec. Tarefa (${count})` : `Exec. Tarefa`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-executar-auto-dme-imediato-contas', count > 0 ? `Exec. Auto DME (${count})` : `Exec. Auto DME`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-resgatar-recompensas-contas', count > 0 ? `Resgatar Recompensas (${count})` : `Resgatar Recompensas`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-acao-resolver-dme-contas', count > 0 ? `Resolver (${count})` : `Resolver`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-vender-coins', count > 0 ? `Exec. Venda Coins (${count})` : `Exec. Venda Coins`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-resolver-bug-ea', count > 0 ? `Resolver Bug EA (${count})` : `Resolver Bug EA`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-limpar-cache', count > 0 ? `Limpar Cache/Sincronizar (${count})` : `Limpar Cache/Sincronizar`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-limpar-dmes-contas', count > 0 ? `Limpar snapshot Auto DME (${count})` : `Limpar snapshot Auto DME`)
          this.atualizarTextoBotaoAcaoSelecionada('.btn-resetar-tentativas-auto-dme-contas', count > 0 ? `Resetar Tentativas Auto DME (${count})` : `Resetar Tentativas Auto DME`)
        }
      }

      Business.objDataTableContas.on('user-select', function (e: any, dt: any, type: any, cell: any, originalEvent: any) {
        if (_.contains(['a', 'i', 'input'], originalEvent.target.nodeName.toLowerCase())) {
          return false;
        }
      });

      Business.objDataTableContas.on('select', aoSelecionarOuDeselecionar);
      Business.objDataTableContas.on('deselect', aoSelecionarOuDeselecionar);

    }

    private carregarTabelaContas(dataContas: IConta[]) {
      const contasAtuaisPorId: any = this.getContasAtuaisTabelaPorId();
      if ($.isArray(dataContas)) {
        dataContas = dataContas.map((conta: IConta) => {
          const anterior = conta && conta.id ? contasAtuaisPorId[Number(conta.id)] : null;
          return this.normalizarContaTabela(anterior ? this.mergeContaTabela(conta, anterior) : conta);
        });
        this.arrayContas = dataContas;
        if (this.transferCoins) this.transferCoins.setArrayContas(this.arrayContas);
      } else {
        const contaUnica = dataContas as any;
        const anterior = contaUnica && contaUnica.id ? contasAtuaisPorId[Number(contaUnica.id)] : null;
        dataContas = this.normalizarContaTabela(anterior ? this.mergeContaTabela(contaUnica, anterior) : contaUnica) as any;
      }

      if (Business.objDataTableContas instanceof $.fn.dataTable.Api) {
        if ($.isArray(dataContas)) {
          Business.objDataTableContas.clear().draw(false);
          Business.objDataTableContas.rows.add(dataContas);
        } else {
          Business.objDataTableContas.row.add(dataContas);
        }
        Business.objDataTableContas.columns.adjust().draw(false);
        Business.objDataTableContas.order([2, 'asc']).draw(false);
        if (Object.keys(this.pendingStatusUpdatesByContaId).length) {
          this.agendarFlushStatusContas();
        }
      } else {

        Business.objDataTableContas = this.elDataTableContas.DataTable({
          language: {
            url: "/datatable-pt-br.json",
            // searchPanes: {
            //   collapse: { 0: 'Filtros', _: 'Filtros Aplicados (%d)' }
            // }
          },
          pageLength: 200,
          deferRender: true,
          bLengthChange: false,
          bInfo: false,
          order: [[2, 'asc']],
          // searchPanes: {
          //   viewTotal: true,
          //   cascadePanes: true,
          //   columns: [0, 1]
          // },
          // buttons: [
          //   'searchPanes'
          // ],
          data: dataContas,
          bAutoWidth: false,
          createdRow: (row: any, data: IConta, dataIndex: any) => {
            this.preencherCredenciais(data)
          },
          rowId: 'id',
          dom: 'Bfrtip',
          select: {
            style: 'os'
          },
          buttons: [
            {
              className: "btn-sm btn-outline-primary btn-selecionar-tudo",
              text: '<i title="Select/Unselect all" class="fas fa-check-double font-size-11 m-0"></i>',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  Business.objDataTableContas.rows().deselect();
                } else {
                  Business.objDataTableContas.rows().select();
                }
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-aplicar",
              text: '+ Perfil',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAplicarPerfil").modal("show")
                }
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-dt-aplicar-filtros",
              text: '+ Filtros',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAplicarFiltros").modal("show")
                }
              }
            },
            {
              className: `btn-sm btn-outline-primary btn-dt-aplicar-proxy ${this.infoPlanoAtual.ehPlanoCloud ? ' display-none' : ''}`,
              text: '+ Proxy',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAplicarProxy").modal("show")
                }
              }
            },
            {
              className: `btn-sm btn-outline-primary btn-dt-atualizar`,
              text: 'Atualizar',
              action: async () => {
                this.atualizarContas()
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-executar-tarefa",
              text: 'Exec. Tarefa',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  if (this.executandoTarefa) {
                    return
                  }

                  this.executandoTarefa = true;
                  $('.btn-executar-tarefa').text("Aguarde...");
                  $('.btn-executar-tarefa-contas').click()
                  setTimeout(() => {
                    $('.btn-executar-tarefa').text("Exec. Tarefa");
                    this.executandoTarefa = false
                  }, 6000);
                }
              }
            },
            {
              className: "btn-sm btn-outline-primary btn-executar-auto-dme-imediato",
              text: 'Auto DME',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  this.executarAutoDmeImediatoContas()
                }
              }
            },
            {
              className: `btn-sm btn-outline-primary btn-dt-resolver-dme`,
              text: 'Resolver Dme',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalResolverDmeContasSelecionadas").modal("show")
                }
              }
            },
            ...((this.infoPlanoAtual as any).ehTransferBeta ? [{
              className: 'btn-sm btn-outline-warning btn-dt-transferir-contas btn-transferir-contas',
              text: '💰⇆ Transferir Coins',
              action: () => {
                this.abrirModalTransfer();
              }
            }] : []),
            {
              className: "btn-sm btn-outline-primary btn-dt-acoes",
              text: '+ Ações',
              action: () => {
                let contasSelecionadas = this.getContasSelecionadas()
                var count = contasSelecionadas.count();
                if (count) {
                  $("#modalAcoesContas").modal("show")
                }
              }
            }
          ],
          drawCallback: (settings: any) => {
            this.atualizarHeaderFilaAutoDme();
            $('.btn-info-agenda').not('[data-popover-init="1"]').attr('data-popover-init', '1').popover({
              "html": true,
              trigger: 'hover',
              placement: 'top'
            })
            $('.btn-info-jogadores-conta').not('[data-popover-init="1"]').attr('data-popover-init', '1').popover({
              "html": true,
              trigger: 'hover',
              placement: 'top'
            })
          },
          columnDefs: [
            {
              targets: 0,
              visible: false,
              render: function (data: any, tipo: any, obj: IConta, meta: any) {
                return obj.id;
              }
            },
            {
              targets: 1,
              className: "info-conta",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                if ((obj as any)._vinculoProvisorio) { return this.renderColunaInfoVinculo(obj); }
                if (!this.configuracoesGeraisExecucao.exibir_escudo_clube) {
                  this.atualizarCacheInfoConta(obj);
                }

                let partidas = ``
                let viewImageConta = this.configuracoesGeraisExecucao.exibir_escudo_clube
                  ? `<a href="#" class="avatar rounded-circle mr-2" style="width: 20px;height: 20px;"><img alt="Image conta" src="${obj.dadosEa.img}"></a>`
                  : `<a href="#" class="avatar rounded-circle mr-2" style="width: 20px;height: 20px;background-color:${this.cacheInfoContas[obj.id].corAvatar}">${this.cacheInfoContas[obj.id].nomeAvatar}</a>`


                if (obj.partidas) {
                  partidas = `V${obj.partidas.won}-E${obj.partidas.draw}-D${obj.partidas.loss}`
                }

                let strDataPopovers = '';
                if (obj.programacao && obj.programacao.length) {
                  $.each(obj.programacao, (index: any, descAgenda: string) => {
                    strDataPopovers += `<p class="mb-0"><span><i class="ni ni-time-alarm text-success font-size-10"></i></span>&nbsp;<small>${descAgenda}</small></p>`
                  });
                }

                let cemiterioHtml = ``
                let transferenciaHtml = ``
                let clubeHtml = ``
                const clubeTotalJogadores = Math.max(Number(obj && obj.listas ? (obj.listas.clube_total || 0) : 0), this.getPlayersConta(obj).length);
                let navegadorAbertoHtml = obj.navegador_status == true
                  ? `<span class="conta-navegador-aberto${obj.id} badge badge-info text-uppercase font-size-8" title="Navegador aberto" style="vertical-align: baseline;padding: 2px 4px;">Aberta</span>`
                  : ``;

                if (obj.listas) {
                  cemiterioHtml = obj.listas.cemiterio_total ? `
                  <span title="Quantidade no cemitério" class="badge badge-info badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;background-color: #ebff77;color: #000000;">${obj.listas.cemiterio_total}</span>
                  ` : ``

                  transferenciaHtml = obj.listas.transferencia_total ? `
                  <span title="Quantidade no na lista de transferência" class="badge badge-info badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;background-color: #77ecff;color: #000000;">${obj.listas.transferencia_total}</span>
                  ` : ``

                }
                clubeHtml = clubeTotalJogadores > 1 ? `
                  <span title="Quantidade aproximada de cartas valiosas no clube por overal" class="badge badge-info badge-plataforma text-uppercase font-size-8" style="vertical-align: baseline;padding: 2px 4px;background-color: #edc8ed;color: #000000;">${clubeTotalJogadores}</span>
                  ` : ``
                const ultimaExecucaoConta = obj.ultima_execucao ? Util.parseDataUtcStringToDateLocale(obj.ultima_execucao) : ``
                const ultimaExecucaoHtml = ultimaExecucaoConta ? `
                  <span title="Ultima execucao: ${ultimaExecucaoConta}" class="conta-exec-data conta-ultima-execucao-nome">
                    <i class="fas fa-clock"></i>${this.getDataExecucaoContaCurta(ultimaExecucaoConta)}
                  </span>
                  ` : ``

                if (!obj.proxyUrl && obj.proxy) {
                  obj.proxyUrl = `${obj.proxy.protocolo}://${obj.proxy.address}`
                }

                data = `<div class="media align-items-center conta-info-compact">
                      ${viewImageConta}
                      <div class="media-body conta-info-main">
                        <div class="conta-info-meta conta-info-principal">
                         ${cemiterioHtml}
                         ${transferenciaHtml}
                         ${clubeHtml}
                         ${ultimaExecucaoHtml}
                        </div>

                        <div class="conta-info-top">
                          <span class="badge badge-secondary badge-plataforma text-uppercase font-size-8"
                            style="vertical-align: baseline;">
                            ${obj.dadosEa.plataforma}
                          </span>
                          <span class="name mb-0 text-sm conta-clube-nome font-size-10 bold-600 text-uppercase" title="${obj.dadosEa.clubeName}">${obj.dadosEa.clubeName}</span>
                          ${partidas ? `<span class="partidas">${partidas}</span>` : ``}
                          ${navegadorAbertoHtml}
                        </div>

                        <div class="conta-info-meta">
                          <span class="email-conta" title="${obj.email}">${obj.email}</span>
                        </div>

                        <div class="conta-info-meta">
                          <span class="badge badge-info mr-0" data-html="true"
                          data-container="body" data-toggle="popover" data-color="default" data-placement="top"
                          data-content="${obj.proxyUrl ? obj.proxyUrl : ''}" data-original-title="${obj.proxyUrl ? obj.proxyUrl : ''}" title="${obj.proxyUrl ? obj.proxyUrl : ''}"
                          style="padding: 2px 2px 2px 2px;text-transform: uppercase;font-weight: 600;font-size: 10px;border: 1px solid #cbcbcb;color: #000000;${obj.proxy && obj.proxyUrl && (_.contains(Util.ARRAY_STATUS_CONTA_WEBAPP_ABERTO, obj.status) || obj.status == Util.STATUS_CONTA_SEM_MERCADO) ? '' : 'display: none;'}">
                          <span class="text-black font-size-8"><i class="fa-solid fa-globe m-0"></i></span>
                          <small style="font-weight: 600;">${obj.proxy ? obj.proxy.address : 'proxy'}</small>
                          </span>

                          <button type="button" class="btn btn-sm btn-link btn-info-agenda mr-0" data-html="true"
                          data-container="body" data-toggle="popover" data-color="default" data-placement="top"
                          data-content='${strDataPopovers ? strDataPopovers : ''}' data-original-title="" title=""
                          style="padding: 0px 0px 0px 0px;${strDataPopovers ? '' : 'display: none;'}">
                          <i class="ni ni-calendar-grid-58 text-primary"
                          style="font-size: 11px;vertical-align: inherit;"></i>
                          </button>
                        </div>
                      </div>
                </div>`

                return data;
              }
            },
            {
              targets: 2,
              // searchPanes: {
              //   show: true,
              //   header: 'Status',
              //   options: [
              //     {
              //       label: 'executando',
              //       value: function (obj: IConta, rowIdx: any) {
              //         return !obj.status;
              //       }
              //     },
              //     {
              //       label: 'aberta',
              //       value: function (obj: IConta, rowIdx: any) {
              //         return obj.status;
              //       }
              //     },
              //     {
              //       label: 'captcha solicitado',
              //       value: function (obj: IConta, rowIdx: any) {
              //         return obj.status;
              //       }
              //     }
              //   ]
              // },
              className: "status text-center",
              render: (data: any, type: any, obj: IConta, meta: any) => {
                if ((obj as any)._vinculoProvisorio) { return type == 'sort' ? -1 : this.renderColunaStatusVinculo(obj); }
                if (type == 'sort') {
                  return this.getPesoOrdenacaoConta(obj);
                }

                const statusVisual = this.normalizarStatusContaPeloNavegador(obj.status, (obj as any).navegador_status);
                let objStatus = Util.getStatusDescContaById(statusVisual)
                return this.renderStatusContaCompacto(obj, objStatus, statusVisual);
              }
            },
            {
              targets: 3,
              data: 'dadosEa.coins',
              type: 'num',
              // searchPanes: {
              //   show: false
              // },
              render: function (data: any, tipo: any, obj: IConta, meta: any) {
                if ((obj as any)._vinculoProvisorio) { return (tipo === 'sort' || tipo === 'type') ? 0 : ''; }
                let coins = Number(data || 0)

                if (tipo === 'sort' || tipo === 'type') {
                  return coins
                }

                return `<span class="mr-2"><i class="ni ni-money-coins" style="color: #fff18e;"></i>
                <span class="coins font-size-12">${coins.toLocaleString('pt-BR')}</span>
                </span>`
              }
            },
            {
              targets: 4,
              // searchPanes: {
              //   show: false
              // },
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                if ((obj as any)._vinculoProvisorio) { return (tipo === 'sort' || tipo === 'type') ? 0 : ''; }
                let consolidado: IContaConsolidado = Util.getItemArrayById(this.arrayConsolidados, obj.id, {
                  id: obj.id, tempo_execucao: 0, captchas: 0, compras: 0, buscas: 0, scans_clube: 0, vendas: 0, requests: 0, lucro: 0, ajuste_lucro: 0
                })

                const lucro = this.normalizarNumeroFinanceiro(consolidado.lucro);
                if (tipo === 'sort' || tipo === 'type') {
                  return lucro;
                }

                var consolidadoLucro = this.getConsolidadoLucro(lucro, 'lucro')
                const sinalLucro = lucro > 0 ? "+" : "";
                const vendaCoins = consolidado.venda_coins || {};
                const coinsVendidas = Number(vendaCoins.coins_vendidas || 0);
                const itensVendidos = Number(vendaCoins.itens_vendidos || 0);
                const htmlVenda = coinsVendidas > 0
                  ? `<div class="font-size-10 text-muted mt-1">Venda: <span class="text-danger">-${coinsVendidas.toLocaleString('pt-BR')}</span> (${itensVendidos.toLocaleString('pt-BR')})</div>`
                  : "";

                return `
                  <div class="d-inline-block text-left">
                    <a class="${consolidadoLucro.class} font-size-12 mr-2 btn-dt-ajustar-lucro btn btn-link p-0" data-ajuste-lucro="${consolidado.ajuste_lucro}" data-id-conta-ea="${obj.id}">${sinalLucro}${lucro.toLocaleString('pt-BR')}</a>
                    ${htmlVenda}
                  </div>`
              }
            },
            {
              targets: 5,
              className: "dmes",
              render: function (data: any, tipo: any, obj: IConta, meta: any) {
                if ((obj as any)._vinculoProvisorio) { return ''; }
                return App.Business.renderColunaDmes(obj);
              }
            },
            {
              targets: 6,
              // searchPanes: {
              //   show: false
              // },
              className: "execucao info-execucao",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                if ((obj as any)._vinculoProvisorio) { return ''; }
                return this.renderInfoExecucaoConta(obj)
              }
            },

            {
              targets: 7,
              // searchPanes: {
              //   show: false
              // },
              className: "estatisticas",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                if ((obj as any)._vinculoProvisorio) { return ''; }
                let consolidado: IContaConsolidado = Util.getItemArrayById(this.arrayConsolidados, obj.id, {
                  id: obj.id, tempo_execucao: 0, captchas: 0, compras: 0, buscas: 0, scans_clube: 0, vendas: 0, requests: 0
                })

                // var consolidadoProgressoBuscas = this.getProgressoDinamico(consolidado.buscas, 5500, 'buscas')
                var consolidadoProgressoCompras = this.getProgressoDinamico(consolidado.compras, 200, 'compras')
                // var consolidadoProgressoCaptchas = this.getProgressoDinamico(consolidado.captchas, 10, 'captchas')
                var consolidadoProgressoRequests = this.getProgressoDinamico(consolidado.requests, 6000, 'requests')
                var consolidadoProgressoTempoExecucao = this.getProgressoConsolidadoTempoExecucao(consolidado.tempo_execucao)

                var htmlEstatisticasBuscasCaptchas = ``;
                // var htmlEstatisticasBuscasCaptchas = `
                // <div class="col pl-2 p-0">
                // <div class="">
                //   <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoBuscas.valor} ${consolidadoProgressoBuscas.label}</span>
                // </div>
                // <div class="progress" style="width: 70%;">
                //   <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoBuscas.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoBuscas.limite}" style="width: ${consolidadoProgressoBuscas.percent}%;background-color: ${consolidadoProgressoBuscas.color};"></div>
                // </div>
                // </div>
                // <div class="col pl-2 p-0">
                //     <div class="">
                //       <span class="completion mr-2" style="font-size: 10px;">${consolidadoProgressoCaptchas.valor} ${consolidadoProgressoCaptchas.label}</span>
                //     </div>
                //     <div class="progress" style="width: 70%;">
                //       <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoCaptchas.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoCaptchas.limite}" style="width: ${consolidadoProgressoCaptchas.percent}%;background-color: ${consolidadoProgressoCaptchas.color};"></div>
                //     </div>
                // </div>`

                return `
                       <div class="conta-estatisticas-execucao">
                         <div class="conta-estatisticas-linha">
                          <div class="conta-estatistica-item">
                            <div>
                              <span class="completion" style="font-size: 10px;">${consolidadoProgressoCompras.valor} ${consolidadoProgressoCompras.label}</span>
                            </div>
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoCompras.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoCompras.limite}" style="width: ${consolidadoProgressoCompras.percent}%;background-color: ${consolidadoProgressoCompras.color};"></div>
                            </div>
                          </div>
                          ${htmlEstatisticasBuscasCaptchas}
                          <div class="conta-estatistica-item">
                              <div>
                                <span class="completion" style="font-size: 10px;">${consolidadoProgressoTempoExecucao.tempo} ${consolidadoProgressoTempoExecucao.label}</span>
                              </div>
                              <div class="progress">
                                <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoTempoExecucao.tempo}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoTempoExecucao.limite}" style="width: ${consolidadoProgressoTempoExecucao.percent}%;background-color: ${consolidadoProgressoTempoExecucao.color};"></div>
                              </div>
                          </div>
                          <div class="conta-estatistica-item">
                              <div>
                                <span class="completion" style="font-size: 10px;">${consolidadoProgressoRequests.valor} ${consolidadoProgressoRequests.label}</span>
                              </div>
                              <div class="progress">
                                <div class="progress-bar" role="progressbar" aria-valuenow="${consolidadoProgressoRequests.valor}" aria-valuemin="0" aria-valuemax="${consolidadoProgressoRequests.limite}" style="width: ${consolidadoProgressoRequests.percent}%;background-color: ${consolidadoProgressoRequests.color};"></div>
                              </div>
                          </div>
                          <div>
                              <a class="btn btn-link btn-ver-mais font-size-10 text-primary m-0 p-0" data-id-conta-ea="${obj.id}">detalhes</a>
                          </div>
                         </div>
                       </div>
                       `
              }
            },
            {
              targets: 8,
              // searchPanes: {
              //   show: false
              // },
              className: "acoes",
              render: (data: any, tipo: any, obj: IConta, meta: any) => {
                if ((obj as any)._vinculoProvisorio) { return ''; }
                let statusViewAcoes = this.getStateViewAcoes(obj.id, obj.status)
                let menuVenderCoins = ``;
                let menuResolverDme = ``;
                let menuAtualizarQuantidadeItensClube = ``;
                let menuVerJogadores = ``;
                let menuCorrigirBugEa = ``;
                let menuEstadoAutoDme = ``;
                let menuLaboratorioDme = ``;

                menuCorrigirBugEa = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="" class="dropdown-item btn-iniciar-correcao-bug-ea">
                🐛 Corrigir Bug EA
                </a>`

                if (obj.perfil && obj.perfil.api_venda_coins && !this.infoPlanoAtual.ehPlanoCloud) {
                  menuVenderCoins = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Executar venda de coins se estiver habilitado e no nomento permitido de venda de acordo com suas configurações de API" class="dropdown-item btn-iniciar-venda-de-coins-imediata">
                  <i class="fa-solid fa-dollar-sign"></i>Executar Venda Coins
                  </a>`
                }

                menuResolverDme = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Iniciar tarefa para resolver dme" class="dropdown-item btn-iniciar-resolver-dme-imediato">
                  <i class="fa-solid fa-brain"></i>Resolver DME GC
                  </a>`

                menuEstadoAutoDme = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Visualizar estado da conta por tarefa" class="dropdown-item btn-ver-conta-diagnostico">
                  <i class="fa-solid fa-circle-info"></i>Diagnóstico Tarefas
                  </a>`

                menuLaboratorioDme = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Configurar e testar os modos de execução do Auto DME" class="dropdown-item btn-laboratorio-dme">
                  <i class="fa-solid fa-gears"></i>Modo Execução Auto DME
                  </a>`

                menuVerJogadores = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Ver jogadores salvos desta conta" class="dropdown-item btn-ver-jogadores-conta">
                  <i class="fa-solid fa-users"></i>Ver Jogadores
                  </a>`

                if (obj.status == Util.STATUS_CONTA_ABERTA || obj.status == Util.STATUS_CONTA_PARADA) {
                  menuAtualizarQuantidadeItensClube = ` <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Sincroniza as forragens de jogadores da conta" class="dropdown-item btn-atualizar-info-jogadores-clube">
                  <i class="fas fa-sync-alt"></i>Atualizar Jogadores
                  </a>`
                }

                const executandoSniper = this.contaExecutandoTarefaSniper(obj);
                if (executandoSniper && obj.loadList) {
                  delete (obj as any).loadList;
                }

                if (!executandoSniper && !obj.loadList) {
                  const loadListAutoInicial = this.obterLoadListAutomaticoPorEstadoConta(obj);
                  if (loadListAutoInicial) {
                    obj.loadList = loadListAutoInicial as any
                  }
                }

                let loadingConta = !executandoSniper && obj.loadList ? `
                <div id="loadListConta${obj.id}" class="col-md-12 load-list-conta" style="padding: 10px;width: 98.8%;background-color: #ececec;opacity: 0.9;z-index: 4;border-radius: 5px;position: absolute;left: 0px;">
                  <div class="text-center pt-1">
                    <div class="spinner-border" style="width: 1.2rem;height: 1.2rem;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <span class="text-load pb-1 mb-0" style="font-size: 12px;font-weight: 600;"> ${obj.loadList.texto}</span>
                    ${obj.loadList.exibirBotaoCancelar ? `<a class="btn-danger btn-condicional btn-cancelar-venda-coins" data-id-conta-ea="${obj.id}" style="cursor: pointer;border-radius: 4px;padding: 1px 3px;color: #ffffff;text-transform: uppercase;font-size: 9px;position: absolute;top: 51px;left: 48%;cursor: pointer;">cancelar</a>` : ''}
                    <a class="btn-link btn-fechar-load-list" onclick="$(this).parents('.load-list-conta').hide()" style="cursor: pointer">x</a>
                  </div>
                </div>` : ``

                let infoExecucao = `
                <div class="row mt-1 justify-content-end">
                  <div class="d-flex flex-column pr-3 text-muted" style="line-height: 12px;">
                    ${obj.ultima_execucao ? `<span title="Ultima execução de tarefa automática" class="text-muted" style="font-size: 9px;"><span class="text-uppercase"><i class="fas fa-clock mr-1"></i></span><span class="font-weight-bold">${Util.parseDataUtcStringToDateLocale(obj.ultima_execucao)}</span></span>` : ``}
                    ${this.renderLimitesConta(obj)}
                  </div>
                </div>
                `
                const botaoAbrirContaRapida = this.infoPlanoAtual && this.infoPlanoAtual.ehAdmin ? `
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnAbrirSniper ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-abrir-conta-rapida btn btn-sm btn-outline-default line-height-0-2" title="Abrir conta rápido sem tarefas iniciais">
                      <i class="fa-solid fa-bolt"></i>
                      </a>` : ``

                data =
                  `<div class="" style="float: right;">
                  <div class="row justify-content-end">

                      <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="btn-autenticar btn btn-sm btn-outline-default line-height-0-2 pt-2" title="O sistema irá autenticar sua conta EA" style="${statusViewAcoes.btnAutenticar ? '' : 'display: none;'}">
                      Autenticar
                      </a>

                      <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="btn-sincronizar-conta-local btn btn-sm btn-outline-default line-height-0-2 pt-2" title="O sistema ira sincronizar/limpar cache desta conta na maquina local"
                      style="color: #ef8411;border-color: #ef8411; ${obj.tem_diretorio === false ? '' : 'display: none;'}">
                      Sincronizar/Limpar Cache
                      </a>

                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnResolverCatptcha ? 'display: none;' : ''}" id="abrirSniper${obj.id}" style="${statusViewAcoes.btnAbrirSniper ? '' : 'display: none;'}" href="javascript:void(0)" class="abrir-sniper btn btn-sm btn-default line-height-0-2" title="Abrir Sniper">
                      <i class="fa-solid fa-play"></i>
                      </a>
                      ${botaoAbrirContaRapida}
                      <a href="javascript:void(0)" style="" data-id-conta-ea="${obj.id}" title="Exibir a janela do WebApp da sua conta" class="btn btn-sm btn-outline-default btn-mostrar-telawebapp">
                              <i class="fa-solid fa-eye"></i> ${statusViewAcoes.btnResolverCatptcha ? 'Resolver no Preview' : ''}
                      </a>
                      <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Mostrar diagnostico das tarefas da conta" class="btn btn-sm btn-info btn-ver-conta-diagnostico">
                        <i class="fa-solid fa-circle-info"></i>
                      </a>
                      <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" title="Ver jogadores da conta" class="btn btn-sm btn-outline-success btn-ver-jogadores-conta">
                        <i class="fa-solid fa-users"></i>
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnPararTarefa ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-parar-tarefa btn btn-sm btn-outline-danger line-height-0-2" title="O sistema irá para a tarefa atual na conta">
                      <i class="fa fa-stop"></i>
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnResolverCatptcha ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-resolver-captcha-auto btn btn-sm btn-outline-danger line-height-0-2 pt-2" title="O sistema tentará resolver o captcha de forma automática">
                      Resolver Auto.
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnResolverCatptcha && !this.infoPlanoAtual.ehPlanoCloud ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-resolver-captcha btn btn-sm btn-outline-danger line-height-0-2 pt-2" title="O sistema irá abrir o navegador com sua conta EA para você resolver o captcha">
                      Resolver Manual
                      </a>
                      <a data-id-conta-ea="${obj.id}" style="${statusViewAcoes.btnPararVendaCoins ? '' : 'display: none;'}" href="javascript:void(0)" class="btn-cancelar-venda-coins btn btn-sm btn-outline-danger line-height-0-2" title="Parar a venda de coins agora">
                      <i class="fa fa-stop"></i>
                      </a>

                      <div class="dropdown">
                        <button type="button" class="btn btn-sm btn-secondary line-height-0-2 padding-bt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-h"></i></button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="dropdown-item btn-acessar" title="Abrir navegador com a conta logada"><i class="ni ni-controller text-success"></i>Abrir
                          WebApp
                          </a>

                          <a data-id-conta-ea="${obj.id}" href="javascript:void(0)" class="dropdown-item btn-fechar-sniper" title="O sistema irá fechar o navegador da respectiva conta EA">
                          <i class="fa fa-window-close"></i>Fechar
                          WebApp
                          </a>

                         ${menuVenderCoins}

                         ${menuResolverDme}

                          ${menuEstadoAutoDme}

                          ${menuLaboratorioDme}

                          ${menuVerJogadores}

                          ${menuAtualizarQuantidadeItensClube}

                         ${menuCorrigirBugEa}

                          <a data-id="${obj.id}" href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalConfigCredenciais${obj.id}" title="Configurar conta"><i class="ni ni-key-25 text-success"></i>Credenciais
                          </a>

                          <a href="javascript:void(0)" data-id-conta-ea="${obj.id}" class="dropdown-item remover-conta">
                            <i class="fa fa-trash text-danger"></i>Excluir Conta
                          </a>

                        </div>
                      </div>

                      <div class="ligar-desligar-conta mr-2">
                        <label class="custom-toggle custom-toggle-success mr-2"">
                          <input type="checkbox" ${this.conectado ? '' : 'disabled'} data-id-conta-ea="${obj.id}" ${obj.agenda_ativa ? 'checked' : ''}  name="agenda_ativa">
                          <span class="custom-toggle-slider rounded-circle" data-label-off="Desl" data-label-on="Lig"></span>
                        </label>
                      </div>

                        ${loadingConta}
                    </div>
                  </div>
                  `
                return data;
              }
            }
          ],

        });

        App.Util.desabilitarAutocompleteDataTables(this.elDataTableContas);
        this.inicializarEventosDataTables()
        $.each(dataContas, (index: any, conta: IConta) => {
          if (conta.status == Util.STATUS_CONTA_EXECUCAO) {
            // console.log("ARRAY", conta.id, conta.status)
            this.atualizarViewFuncionamentoAtual(conta.id, conta.status, conta.navegador_status);
          }
        });
        if (Object.keys(this.pendingStatusUpdatesByContaId).length) {
          this.agendarFlushStatusContas();
        }
      }
      this.atualizarHeaderFilaAutoDme();
    }

    /**
     * Preserva `conta.dmes` (IDmeContaItem[] — fonte única Auto DME) quando o payload parcial
     * omite o campo, evitando flicker ou "sumiço" da coluna DMEs na grid em atualizações
     * incrementais. Substitui o antigo `mergeDmesTarefaHojeNaConta`, que operava sobre o
     * campo deprecated `dmes_tarefa_hoje`.
     */
    private mergeDmesNaConta(novo: IConta, anterior: IConta): IConta {
      const anteriorDmes = (anterior as any).dmes;
      const novoDmes = (novo as any).dmes;
      const tinhaArr = Array.isArray(anteriorDmes) && anteriorDmes.length > 0;
      const novoOmitiu = novoDmes === undefined || novoDmes === null;
      if (tinhaArr && novoOmitiu) {
        return { ...novo, dmes: anteriorDmes } as IConta;
      }
      return novo;
    }

    private mergeExecucaoNaConta(novo: IConta, anterior: IConta): IConta {
      if (!novo || !anterior) {
        return novo;
      }
      const novoStatus = this.normalizarStatusContaPeloNavegador(novo.status, (novo as any).navegador_status);
      const anteriorStatus = this.normalizarStatusContaPeloNavegador(anterior.status, (anterior as any).navegador_status);
      const novaExecucao: any = (novo as any).execucao;
      const anteriorExecucao: any = (anterior as any).execucao;
      const novoOmitiuExecucao = !novaExecucao || (!novaExecucao.funcionamentoAtual && !novaExecucao.tarefaAtual);
      const anteriorTemExecucao = Boolean(anteriorExecucao && (anteriorExecucao.funcionamentoAtual || anteriorExecucao.tarefaAtual));

      if (novoStatus === Util.STATUS_CONTA_EXECUCAO && anteriorStatus === Util.STATUS_CONTA_EXECUCAO && novoOmitiuExecucao && anteriorTemExecucao) {
        return { ...novo, execucao: anteriorExecucao } as IConta;
      }
      return novo;
    }

    private mergeLimitesNaConta(novo: IConta, anterior: IConta): IConta {
      if (!novo || !anterior) {
        return novo;
      }
      ["limite_atingido", "limite_compras_atingido", "limite_compras_sniper_atingido", "limite_requests_compra_atingido"].forEach((campo: string) => {
        if (!(novo as any).hasOwnProperty(campo) && (anterior as any).hasOwnProperty(campo)) {
          (novo as any)[campo] = (anterior as any)[campo];
        }
      });
      return novo;
    }

    private mergeContaTabela(novo: IConta, anterior: IConta): IConta {
      let merged = this.mergeDmesNaConta(novo, anterior);
      merged = this.mergeExecucaoNaConta(merged, anterior);
      merged = this.mergeLimitesNaConta(merged, anterior);
      return merged;
    }

    private getContasAtuaisTabelaPorId(): any {
      const porId: any = {};
      const adicionar = (conta: IConta) => {
        if (conta && conta.id != null) {
          porId[Number(conta.id)] = conta;
        }
      };

      if (Business.objDataTableContas instanceof $.fn.dataTable.Api) {
        const dados = Business.objDataTableContas.rows().data().toArray();
        $.each(dados, (index: any, conta: IConta) => adicionar(conta));
      } else if ($.isArray(this.arrayContas)) {
        $.each(this.arrayContas, (index: any, conta: IConta) => adicionar(conta));
      }
      return porId;
    }

    private obterLoadListAutomaticoPorEstadoConta(objConta: IConta): { texto: string, exibirBotaoCancelar: boolean, autoExecucao: boolean } | null {
      if (!objConta) {
        return null;
      }
      if (this.contaExecutandoTarefaSniper(objConta)) {
        return null;
      }
      if (objConta.status === Util.STATUS_CONTA_VENDENDO_COINS) {
        return { texto: "Vendendo Coins...", exibirBotaoCancelar: true, autoExecucao: false };
      }

      const tarefaAtual = (objConta.execucao && objConta.execucao.tarefaAtual) ? (objConta.execucao.tarefaAtual as any) : null;
      const funcionamentoAtual = (objConta.execucao && objConta.execucao.funcionamentoAtual) ? objConta.execucao.funcionamentoAtual : null;
      const temTarefaAtiva = Boolean(tarefaAtual && (tarefaAtual.id || tarefaAtual.tipo || tarefaAtual.nome || tarefaAtual.data));
      const deveExibir = objConta.status === Util.STATUS_CONTA_EXECUCAO
        || (objConta.status === Util.STATUS_CONTA_ABERTA && (temTarefaAtiva || Boolean(funcionamentoAtual)));
      if (!deveExibir) {
        return null;
      }

      if (tarefaAtual && tarefaAtual.nome) {
        return { texto: `Executando tarefa: ${tarefaAtual.nome}`, exibirBotaoCancelar: false, autoExecucao: true };
      }
      return { texto: "Executando tarefa...", exibirBotaoCancelar: false, autoExecucao: true };
    }

    private getPesoOrdenacaoConta(objConta: IConta): number {
      const statusConta = this.normalizarStatusContaPeloNavegador(objConta.status, (objConta as any).navegador_status);
      const base = Util.getSortByStatusConta(statusConta);
      const temLoadingAtivo = Boolean(objConta && objConta.loadList);

      if (statusConta === Util.STATUS_CONTA_EXECUCAO) {
        return 1;
      }
      if (statusConta === Util.STATUS_CONTA_ABERTA) {
        return temLoadingAtivo ? 2 : 3;
      }
      if (temLoadingAtivo && base > 3) {
        return 3.5;
      }
      return base;
    }

    public updateStatusContaDatatable(idConta: number, status: number, dadosFuncionamentoAtual?: IFuncionamentoAtual | null, tarefa?: ITarefa | null, navegador_status?: boolean, options: { draw?: boolean, reorder?: boolean, extraConta?: any } = {}) {
      if (!App.Business.objDataTableContas) {
        return false;
      }
      const draw = options.draw !== false;
      const reorder = options.reorder !== false;
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        const statusAnterior = objConta.status
        const navegadorStatusAtualizado = navegador_status !== undefined ? navegador_status : (objConta as any).navegador_status;
        const statusNormalizado = this.normalizarStatusContaPeloNavegador(status, navegadorStatusAtualizado);

        objConta.status = statusNormalizado
        if (navegador_status !== undefined) {
          objConta.navegador_status = navegador_status
        }
        if (statusNormalizado !== Number(status)) {
          objConta.navegador_status = false
        }
        const extraConta = options && options.extraConta ? options.extraConta : null;
        if (extraConta) {
          ["limite_atingido", "limite_compras_atingido", "limite_compras_sniper_atingido", "limite_requests_compra_atingido"].forEach((campo: string) => {
            if (extraConta.hasOwnProperty(campo)) {
              (objConta as any)[campo] = extraConta[campo];
            }
          });
        }
        // Payload do plugin (ex.: validarAtualizarStatusConta) muitas vezes só traz status/id/navegador_status;
        // não apagar execução/tarefa já exibida quando data e tarefa vêm ausentes no socket.
        if (dadosFuncionamentoAtual !== undefined || tarefa !== undefined) {
          objConta.execucao = {
            funcionamentoAtual: dadosFuncionamentoAtual !== undefined ? dadosFuncionamentoAtual : (objConta.execucao && objConta.execucao.funcionamentoAtual),
            tarefaAtual: tarefa !== undefined ? tarefa : (objConta.execucao && objConta.execucao.tarefaAtual)
          }
        }
        const execucaoAtualizada: any = (objConta as any).execucao;
        const manterExecucaoAberta = statusNormalizado === Util.STATUS_CONTA_ABERTA && Boolean(execucaoAtualizada && (execucaoAtualizada.funcionamentoAtual || execucaoAtualizada.tarefaAtual));
        if (statusNormalizado !== Util.STATUS_CONTA_EXECUCAO && !manterExecucaoAberta) {
          delete (objConta as any).execucao;
        }

        if (tarefa !== undefined) {
          this.tarefasSniperContas[idConta] = tarefa
        }

        if (this.contaExecutandoTarefaSniper(objConta)) {
          delete (objConta as any).loadList;
        } else {
          const loadListAuto = this.obterLoadListAutomaticoPorEstadoConta(objConta);
          if ((!objConta.loadList || (objConta.loadList as any).autoExecucao) && loadListAuto) {
            objConta.loadList = loadListAuto as any
          } else if (objConta.loadList && !loadListAuto && (objConta.loadList as any).autoExecucao) {
            objConta.loadList = null
          }
        }

        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta);
        if (draw) {
          rowConta.draw(false);
        }

        const navView = navegador_status !== undefined ? navegador_status : !!objConta.navegador_status
        this.atualizarViewFuncionamentoAtual(idConta, statusNormalizado, navView)
        const mudouPrioridadeOrdenacao = Util.getSortByStatusConta(statusAnterior) !== Util.getSortByStatusConta(statusNormalizado)
        if (mudouPrioridadeOrdenacao) {
          this.pendingSortContaIds.add(idConta)
        }
        if (reorder && mudouPrioridadeOrdenacao) {
          this.ordenaListagemDeContas(idConta, statusNormalizado)
        }
        return true;
      }
      return false;
    }

    public updateCoinsContaDatatable(idConta: number, coins: number) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        objConta.dadosEa.coins = coins
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw(false);
      }
      this.updateCoinsGeralPorPlataforma()
    }

    public updateAgendaContaDatatable(idConta: number, programacao: string[]) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        objConta.programacao = programacao
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw(false);
      }
    }

    public updateDadoContaDatatable(idConta: number, prop: string, valor: any) {
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        let objConta: any = rowConta.data()
        objConta[prop] = valor
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw(false);
      }
    }
    public updateDadoContaArrayContas(idConta: number, prop: string, valor: any) {
      let objConta: any = Util.getItemArrayById(this.arrayContas, idConta)
      if (objConta) {
        objConta[prop] = valor
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
      }
    }

    public updateLucroContaDatatable(idConta: number, lucro: number) {
      let consolidado: IContaConsolidado = Util.getItemArrayById(this.arrayConsolidados, idConta)
      consolidado.lucro = lucro
      this.arrayConsolidados = Util.updateOrCreateItemArrayById(this.arrayConsolidados, idConta, consolidado)
      let rowConta = App.Business.objDataTableContas.row(`#${idConta}`)
      if (rowConta.length) {
        rowConta.draw(false);
      }
      this.updateLucroGeralPorPlataforma();
    }

    public updateContaDatatable(objConta: IConta) {
      let rowConta = App.Business.objDataTableContas.row(`#${objConta.id}`)
      if (rowConta.length) {
        const anterior = rowConta.data() as IConta;
        const merged = this.normalizarContaTabela(this.mergeContaTabela(objConta, anterior));
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, merged.id, merged)
        rowConta.data(merged).draw(false);
      }
    }

    private atualizarContasDashboardHidratadas(contas: IConta[]) {
      if (!$.isArray(contas) || !App.Business.objDataTableContas) {
        return;
      }
      let alterou = false;
      $.each(contas, (index: any, objConta: IConta) => {
        if (!objConta || !objConta.id) {
          return;
        }
        let rowConta = App.Business.objDataTableContas.row(`#${objConta.id}`)
        if (rowConta.length) {
          const anterior = rowConta.data() as IConta;
          const merged = this.normalizarContaTabela(this.mergeContaTabela(objConta, anterior));
          this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, merged.id, merged)
          rowConta.data(merged);
          alterou = true;
        }
      });
      if (alterou) {
        if (this.transferCoins) this.transferCoins.setArrayContas(this.arrayContas);
        App.Business.objDataTableContas.order([2, 'asc']).draw(false);
      }
    }

    public updateConsolidadosContaDatatable(idConta: number, consolidado: IContaConsolidado) {
      // console.log("updateConsolidadosContaDatatable", idConta, consolidado)
      this.arrayConsolidados = Util.updateOrCreateItemArrayById(this.arrayConsolidados, consolidado.id, consolidado)
      if (!App.Business.objDataTableContas) {
        return;
      }
      let dadosAtt = App.Business.objDataTableContas.row(`#${idConta}`).data()
      App.Business.objDataTableContas.row(`#${idConta}`).data(dadosAtt).draw(false)
    }

    private exibirLoadListConta(id: number, txt: string = "Carregando...", exibirBotaoCancelar: boolean = false) {
      try {
        if (!App.Business.objDataTableContas) {
          return;
        }
        let rowConta = App.Business.objDataTableContas.row(`#${id}`)
        if (rowConta.length) {
          let objConta: IConta = rowConta.data()
          objConta.loadList = { texto: txt, exibirBotaoCancelar: exibirBotaoCancelar }
          this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
          rowConta.data(objConta).draw(false);
        }
      } catch (e) { }
    }

    private ocultarLoadListConta(id: number) {
      if (!App.Business.objDataTableContas) {
        return;
      }
      let rowConta = App.Business.objDataTableContas.row(`#${id}`)
      if (rowConta.length) {
        let objConta: IConta = rowConta.data()
        objConta.loadList = null
        this.arrayContas = Util.updateOrCreateItemArrayById(this.arrayContas, objConta.id, objConta)
        rowConta.data(objConta).draw(false);
      }
    }

    private aoLigarDesligarAgenda(e: JQueryEventObject) {
      let idConta = $(e.currentTarget).data("idContaEa")
      let ligado = $(e.target).is(':checked');
      console.log("aoLigarDesligarAgenda", idConta, ligado)
      this.updateDadoContaArrayContas(idConta, 'agenda_ativa', $(e.target).is(':checked'))
      this.ajax = new App.Ajax();
      this.ajax.postAcao(App.Util.config.urlSalvarContaEa, { id_conta_ea: idConta, agenda_ativa: ligado }, (obj: { dadosEnviados: { agenda_ativa: boolean, id_conta_ea: number }, dadosRetornados: { conta: IConta, status: boolean } }) => {
        if (obj.dadosRetornados && obj.dadosRetornados.status) {
          // console.log("MANDAR REAGENDAR", obj)
          this.atualizarContaNoPlugin({ id: idConta, semCache: true })
        }
        this.avisarSobreReagendamentoPluginDesconectado()
      })
    }

    private updateLucroGeralPorPlataforma() {
      let resultadoSomaLucro = { consoles: 0, pc: 0 }
      let somaLucro = this.arrayConsolidados.reduce((accumulator, consolidado: IContaConsolidado) => {
        const lucro = this.normalizarNumeroFinanceiro(consolidado.lucro);
        try {
          let objConta: IConta = Util.getItemArrayById(this.arrayContas, consolidado.id)
          objConta.dadosEa.plataforma != "PC" ? resultadoSomaLucro.consoles += lucro : resultadoSomaLucro.pc += lucro;
        } catch (e) {
          return accumulator + 0;
        }

        return accumulator + lucro;
      }, 0);

      for (var [key, value] of (Object as any).entries(resultadoSomaLucro)) {
        let lucroFormatado = this.getConsolidadoLucro(value, 'lucro');
        $(`.info-lucro-geral-${key}`).html(`<span class="${lucroFormatado.class} font-size-10 mr-2"><i class="${lucroFormatado.classIcon}"></i> ${lucroFormatado.valor.toLocaleString('pt-BR')}</span>`)
      }
    }

    private updateCoinsGeralPorPlataforma() {
      let resultadoSomaCoins = { consoles: 0, pc: 0 }
      let somaCoins = this.arrayContas.reduce((accumulator, conta: IConta) => {
        conta.dadosEa.plataforma != "PC" ? resultadoSomaCoins.consoles += conta.dadosEa.coins : resultadoSomaCoins.pc += conta.dadosEa.coins;
        return accumulator + conta.dadosEa.coins;
      }, 0);

      $(`.info-coins-geral`).html(`<span class="font-size-10 mr-2"><i class=""></i> ${somaCoins.toLocaleString('pt-BR')}</span>`)
      // for (var [key, value] of (Object as any).entries(resultadoSomaCoins)) {
      //   $(`.info-coins-geral-${key}`).html(`<span class="font-size-10 mr-2"><i class=""></i> ${value.toLocaleString('pt-BR')}</span>`)
      // }
    }

    private aoVerEstatisticas(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      //console.log("aoVerEstatisticas", idConta)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_ESTATISTICAS_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        //console.log("RESP Estatisticas", response)
        this.iniciarEstatisticas(response.result)
      });
    }

    private aoVerEstadoAutoDmeConta(e: JQueryEventObject) {
      const idConta = $(e.currentTarget).data('idContaEa');
      const modal = $("#modalContaDiagnostico");
      this.prepararEstadoAutoDmeModal(modal);
      modal.modal("show");

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_ESTADO_AUTO_DME_CONTA, { id: idConta }, (response: IRespostaMensagem) => {
        if (!response || !response.status || !response.result) {
          const msgErro = response && response.result && response.result.mensagem
            ? response.result.mensagem
            : "Nao foi possivel obter o diagnostico da conta.";
          this.exibirErroEstadoAutoDmeModal(modal, msgErro);
          return;
        }

        this.diagnosticoContaTarefasAtual = response.result;
        this.renderizarEstadoAutoDmeModal(modal, this.diagnosticoContaTarefasAtual);
      });
    }

    // ─── Configuração e testes dos modos de execução Auto DME (ações 72-78) ───

    private labDmeContaId: number = null;
    private labDmePlano: IPlanoConjuntosAutoDme = null;
    private labDmeConfiguracao: IConfiguracaoExecucaoAutoDme = null;
    private labDmeRevisao: string | number = null;
    private labDmeConfigPersistida: boolean = false;
    private labDmeConfigValida: boolean = true;
    private labDmePilotoAtivo: boolean = false;
    private readonly labDmeUrlConfiguracaoExecucao: string = '/autodme/configuracao-execucao';

    private labDmePlanoVazio(): IPlanoConjuntosAutoDme {
      return { conjuntos: [] };
    }

    private labDmeConfiguracaoPadrao(): IConfiguracaoExecucaoAutoDme {
      return {
        modo_execucao: 'piloto',
        liberar_especiais_reservadas_apos_ciclo_auto_dme: false,
        liberar_exclusoes_inteligentes_apos_ciclo_auto_dme: false,
        plano_conjuntos: this.labDmePlanoVazio(),
        periodos: [],
      };
    }

    // IDs de periodo saneados (int>0, sem duplicata, ordem asc). TS 2.4.2: sem
    // Array.includes/flatMap — usar indexOf e loop explicito. Espelha o
    // normalizarPeriodos do AutodmeConfiguracaoExecucaoService (paridade sha256).
    private labDmeNormalizarPeriodos(valor: any): number[] {
      const lista: number[] = [];
      const bruto = Array.isArray(valor) ? valor : [];
      for (let i = 0; i < bruto.length; i++) {
        const id = Math.floor(Number(bruto[i]));
        if (!isFinite(id) || id <= 0) continue;
        if (lista.indexOf(id) === -1) lista.push(id);
      }
      lista.sort((a: number, b: number): number => a - b);
      return lista;
    }

    private labDmeDadosRegistroGlobal(idRegistro: number): { id_dme: number | null; nome: string | null } {
      if (!idRegistro) return { id_dme: null, nome: null };
      const option = $(`#labDmeRegistrosGlobais option[value="${idRegistro}"]`).first();
      const idDme = Number(option.attr('data-id-dme'));
      return {
        id_dme: idDme > 0 ? idDme : null,
        nome: option.length ? String(option.attr('data-nome') || option.text() || '') : null,
      };
    }

    private labDmeNormalizarPlano(plano: any): IPlanoConjuntosAutoDme {
      const normalizado: IPlanoConjuntosAutoDme = this.labDmePlanoVazio();
      const conjuntos = plano && $.isArray(plano.conjuntos) ? plano.conjuntos : [];
      conjuntos.forEach((conjunto: any) => {
        const passos: IPassoPlanoConjuntosAutoDme[] = [];
        ($.isArray(conjunto && conjunto.passos) ? conjunto.passos : []).forEach((passo: any) => {
          const idRegistro = passo && passo.id_registro != null && Number(passo.id_registro) > 0 ? Number(passo.id_registro) : null;
          const registro = this.labDmeDadosRegistroGlobal(idRegistro);
          const idDme = passo && passo.id_dme != null && Number(passo.id_dme) > 0 ? Number(passo.id_dme) : registro.id_dme;
          const opcoes = passo && passo.opcoes ? passo.opcoes : {};
          const politicaFalha = passo && passo.politica_falha ? passo.politica_falha : opcoes.politica_falha;
          const pularSeProximo = passo && passo.pular_se_proximo_viavel != null
            ? passo.pular_se_proximo_viavel
            : opcoes.pular_se_proximo_viavel;
          passos.push({
            id_registro: idRegistro,
            id_dme: idDme,
            nome: passo && passo.nome ? String(passo.nome) : registro.nome,
            vezes: Math.max(1, Math.min(10, Number(passo && passo.vezes) || 1)),
            politica_falha: politicaFalha === 'abortar_conjunto' ? 'abortar_conjunto' : 'pular',
            pular_se_proximo_viavel: !!pularSeProximo,
          });
        });
        const ehFlag = (valor: any): boolean => valor === true || valor === 1 || valor === '1' || valor === 'true';
        normalizado.conjuntos.push({
          nome: conjunto && conjunto.nome ? String(conjunto.nome) : `Conjunto ${normalizado.conjuntos.length + 1}`,
          repeticoes: Math.max(1, Math.min(10, Number(conjunto && conjunto.repeticoes) || 1)),
          ignorar_exclusoes_inteligentes: ehFlag(conjunto && conjunto.ignorar_exclusoes_inteligentes),
          ordem_inteligente_piloto: ehFlag(conjunto && conjunto.ordem_inteligente_piloto),
          passos: passos,
        });
      });
      return normalizado;
    }

    private labDmeNormalizarConfiguracao(configuracao: any): IConfiguracaoExecucaoAutoDme {
      const modoRaw = configuracao && configuracao.modo_execucao ? String(configuracao.modo_execucao) : 'piloto';
      const modo: ModoExecucaoAutoDme = modoRaw === 'normal' || modoRaw === 'conjunto' ? modoRaw as ModoExecucaoAutoDme : 'piloto';
      const ehVerdadeiro = (valor: any): boolean => valor === true || valor === 1 || valor === '1' || valor === 'true';
      return {
        modo_execucao: modo,
        liberar_especiais_reservadas_apos_ciclo_auto_dme: ehVerdadeiro(configuracao && configuracao.liberar_especiais_reservadas_apos_ciclo_auto_dme),
        liberar_exclusoes_inteligentes_apos_ciclo_auto_dme: ehVerdadeiro(configuracao && configuracao.liberar_exclusoes_inteligentes_apos_ciclo_auto_dme),
        plano_conjuntos: this.labDmeNormalizarPlano(configuracao && configuracao.plano_conjuntos),
        periodos: this.labDmeNormalizarPeriodos(configuracao && configuracao.periodos),
      };
    }

    private labDmePopularContas(idSelecionado: number) {
      const select = $('#labDmeContaSelect');
      select.html('<option value="">Selecione uma conta</option>');
      this.obterContasResumoFilaAutoDme().forEach((conta: IConta) => {
        const id = Number(conta && conta.id);
        if (!id) return;
        const nome = String((conta as any).nome || '').trim();
        const email = String(conta.email || '').trim();
        const rotulo = nome && email ? `${nome} — ${email}` : (email || nome || `Conta ${id}`);
        select.append(`<option value="${id}">${this.escaparHtml(rotulo)}</option>`);
      });
      select.val(idSelecionado ? String(idSelecionado) : '');
    }

    private labDmeAtualizarContaSelecionada(idConta: number) {
      this.labDmeContaId = idConta && idConta > 0 ? idConta : null;
      const temConta = this.labDmeContaId != null;
      $('#labDmeBtnFecharConta, #labDmeBtnPararPiloto')
        .attr('data-id-conta-ea', temConta ? String(this.labDmeContaId) : '')
        .data('idContaEa', temConta ? this.labDmeContaId : null);
      $('#labDmeBtnFecharConta').toggleClass('d-none', !temConta);
      $('#btnLabDmeMapear, #btnLabDmeSugerir, #btnLabDmePiloto, #btnLabDmeExecutar, #labDmeBtnPararPiloto')
        .toggleClass('disabled', !temConta);
    }

    private labDmeSelecionarConta(e: JQueryEventObject) {
      const valor = String($(e.currentTarget).val() || '');
      const idConta = valor && Number(valor) > 0 ? Number(valor) : null;
      this.labDmeAtualizarContaSelecionada(idConta);
      $('#labDmeSugestao, #labDmeProgresso, #labDmeResumoExecucao').html('');
      $('#labDmeMapa').html(idConta
        ? '<div class="text-muted small">Clique em <b>Mapear agora</b> para testar a viabilidade desta conta.</div>'
        : '<div class="alert alert-warning small mb-0">Selecione uma conta para testar o mapa, o piloto ou os conjuntos.</div>');
    }

    private aoAbrirLaboratorioDme(e: JQueryEventObject) {
      const valorConta = $(e.currentTarget).attr('data-id-conta-ea');
      const idConta = valorConta && Number(valorConta) > 0 ? Number(valorConta) : null;
      this.labDmePopularContas(idConta);
      this.labDmeAtualizarContaSelecionada(idConta);
      this.labDmeInicializarSelect2Periodos();
      this.labDmeConfiguracao = this.labDmeConfiguracaoPadrao();
      this.labDmeAplicarConfiguracaoNoModal();

      $('#labDmeSugestao, #labDmeProgresso, #labDmeResumoExecucao').html('');
      $('#labDmeMapa').html(idConta
        ? '<div class="text-muted small">Clique em <b>Mapear agora</b> para testar a viabilidade desta conta.</div>'
        : '<div class="alert alert-warning small mb-0">Selecione uma conta para testar o mapa, o piloto ou os conjuntos.</div>');
      $('#btnLabDmeSalvarConfig, #btnLabDmeSalvarConjuntos').prop('disabled', true);
      $('#labDmeConfigStatus').removeClass('text-danger text-success').addClass('text-muted').text('Carregando configuração...');
      $('#labDmeConfigDiagnostico').html('');
      (idConta ? $('#labDmeTabMapaLink') : $('#labDmeTabConfigLink')).trigger('click');
      $('#modalLaboratorioDme').modal('show');
      this.labDmeCarregarConfiguracao();
    }

    private labDmeExtrairEnvelopeConfiguracao(retorno: any): IRespostaConfiguracaoExecucaoAutoDme {
      if (retorno && retorno.dadosResposta) return retorno.dadosResposta as IRespostaConfiguracaoExecucaoAutoDme;
      if (retorno && retorno.dados) return retorno.dados as IRespostaConfiguracaoExecucaoAutoDme;
      return retorno as IRespostaConfiguracaoExecucaoAutoDme;
    }

    private labDmeInicializarSelect2Periodos(): void {
      const $el = $('#labDmePeriodos');
      if (!$el.length) return;
      if (typeof (window as any).$.fn.select2 !== 'function') return;
      // Mesmo padrao do multiselect do modal de registro (excludeLeagues etc.): dropdownParent no modal
      // para o dropdown posicionar certo dentro do scroll; multiple + width 100% + allowClear.
      let $dropdownParent: JQuery = $el.closest('.modal').first();
      if (!$dropdownParent.length) $dropdownParent = $el.closest('.modal-content').first();
      try { if ($el.hasClass('select2-hidden-accessible')) ($el as any).select2('destroy'); } catch (e) { /* ignore */ }
      const opts: any = { multiple: true, width: '100%', placeholder: 'Selecione um ou mais periodos (vazio = roda 24/7)', allowClear: true };
      if ($dropdownParent.length) opts.dropdownParent = $dropdownParent;
      ($el as any).select2(opts);
    }

    private labDmeAplicarConfiguracaoNoModal() {
      const configuracao = this.labDmeConfiguracao || this.labDmeConfiguracaoPadrao();
      this.labDmePlano = this.labDmeNormalizarPlano(configuracao.plano_conjuntos);
      $('#labDmeModoExecucao').val(configuracao.modo_execucao);
      $('#labDmeLiberarEspeciaisReservadas').prop('checked', configuracao.liberar_especiais_reservadas_apos_ciclo_auto_dme);
      $('#labDmeLiberarExclusoesInteligentes').prop('checked', configuracao.liberar_exclusoes_inteligentes_apos_ciclo_auto_dme);
      const periodosSelecionados = this.labDmeNormalizarPeriodos(configuracao.periodos);
      $('#labDmePeriodos').val(periodosSelecionados.map((id: number): string => String(id))).trigger('change.select2');
      this.labDmeRenderConjuntos();
    }

    private labDmeAtualizarStatusConfiguracao() {
      const revisao = this.labDmeRevisao != null ? ` · revisão ${this.labDmeRevisao}` : '';
      const texto = this.labDmeConfigPersistida
        ? `Configuração salva${revisao}.`
        : 'Padrão Piloto em uso; ainda não existe configuração persistida.';
      $('#labDmeConfigStatus').removeClass('text-danger text-success').addClass('text-muted').text(texto);
    }

    private labDmeCarregarConfiguracao() {
      if (!this.ajax) this.ajax = new App.Ajax();
      this.ajax.get(this.labDmeUrlConfiguracaoExecucao, {}, (resposta: IRespostaSucessoAjx) => {
        const envelope = this.labDmeExtrairEnvelopeConfiguracao(resposta.dadosRetornados);
        this.labDmeConfigValida = !!(envelope && envelope.valida);
        this.labDmeRevisao = envelope ? envelope.revisao : null;
        this.labDmeConfigPersistida = !!(envelope && envelope.persistida);
        this.labDmeConfiguracao = this.labDmeConfigValida && envelope.configuracao
          ? this.labDmeNormalizarConfiguracao(envelope.configuracao)
          : this.labDmeConfiguracaoPadrao();
        this.labDmeAplicarConfiguracaoNoModal();
        if (this.labDmeConfigValida) this.atualizarHeaderModoExecucaoAutoDme(this.labDmeConfiguracao.modo_execucao);
        $('#btnLabDmeSalvarConfig, #btnLabDmeSalvarConjuntos').prop('disabled', false);

        if (!this.labDmeConfigValida) {
          let diagnostico = envelope && envelope.diagnostico ? envelope.diagnostico : 'A configuração persistida não pôde ser validada.';
          if (typeof diagnostico !== 'string') {
            try { diagnostico = JSON.stringify(diagnostico); } catch (err) { diagnostico = 'Dados inválidos.'; }
          }
          $('#labDmeConfigDiagnostico').html(`<div class="alert alert-danger small">Configuração inválida: ${this.escaparHtml(String(diagnostico).slice(0, 2000))}. Revise e salve para corrigir.</div>`);
          $('#labDmeConfigStatus').removeClass('text-muted text-success').addClass('text-danger').text('A configuração salva é inválida; os padrões seguros foram exibidos para correção manual.');
          return;
        }
        $('#labDmeConfigDiagnostico').html('');
        this.labDmeAtualizarStatusConfiguracao();
      }, () => {
        $('#btnLabDmeSalvarConfig, #btnLabDmeSalvarConjuntos').prop('disabled', true);
        $('#labDmeConfigStatus').removeClass('text-muted text-success').addClass('text-danger').text('Não foi possível carregar a configuração.');
      }, null, false);
    }

    private labDmeLerConfiguracaoDoModal(): IConfiguracaoExecucaoAutoDme {
      const modoValor = String($('#labDmeModoExecucao').val() || 'piloto');
      const modo: ModoExecucaoAutoDme = modoValor === 'normal' || modoValor === 'conjunto' ? modoValor as ModoExecucaoAutoDme : 'piloto';
      return {
        modo_execucao: modo,
        liberar_especiais_reservadas_apos_ciclo_auto_dme: $('#labDmeLiberarEspeciaisReservadas').is(':checked'),
        liberar_exclusoes_inteligentes_apos_ciclo_auto_dme: $('#labDmeLiberarExclusoesInteligentes').is(':checked'),
        plano_conjuntos: this.labDmePlanoCanonicoParaSalvar(),
        periodos: this.labDmeNormalizarPeriodos($('#labDmePeriodos').val()),
      };
    }

    private labDmePlanoCanonicoParaSalvar(): IPlanoConjuntosAutoDme {
      const plano = this.labDmeNormalizarPlano(this.labDmePlano);
      return {
        conjuntos: plano.conjuntos.map((conjunto: IConjuntoPlanoAutoDme, ci: number): IConjuntoPlanoAutoDme => ({
          ordem: ci + 1,
          repeticoes: conjunto.repeticoes,
          ignorar_exclusoes_inteligentes: conjunto.ignorar_exclusoes_inteligentes === true,
          ordem_inteligente_piloto: conjunto.ordem_inteligente_piloto === true,
          passos: conjunto.passos.map((passo: IPassoPlanoConjuntosAutoDme, pi: number): IPassoPlanoConjuntosAutoDme => ({
            ordem: pi + 1,
            id_registro: passo.id_registro,
            vezes: passo.vezes,
            opcoes: {
              politica_falha: passo.politica_falha === 'abortar_conjunto' ? 'abortar_conjunto' : 'pular',
              pular_se_proximo_viavel: passo.pular_se_proximo_viavel === true,
            },
          })),
        })),
      };
    }

    private labDmeValidarConfiguracao(configuracao: IConfiguracaoExecucaoAutoDme): string | null {
      const conjuntos = configuracao && configuracao.plano_conjuntos ? configuracao.plano_conjuntos.conjuntos : [];
      let totalExecucoes = 0;
      for (let ci = 0; ci < conjuntos.length; ci++) {
        const conjunto = conjuntos[ci];
        if (!conjunto.passos.length) return `O Conjunto ${ci + 1} precisa ter ao menos um passo.`;
        for (let pi = 0; pi < conjunto.passos.length; pi++) {
          const passo = conjunto.passos[pi];
          if (!passo.id_registro) return `Selecione o DME do passo ${pi + 1} no Conjunto ${ci + 1}.`;
          if (!this.labDmeDadosRegistroGlobal(passo.id_registro).id_dme) return `O registro do passo ${pi + 1} no Conjunto ${ci + 1} não está mais disponível.`;
          totalExecucoes += passo.vezes * conjunto.repeticoes;
        }
      }
      // Sem teto de execuções no PLANO: o limite de 150 é de EXECUÇÃO (por sessão) e não da
      // configuração. Plano maior não é erro — a conta pausa no teto, o cursor guarda onde
      // parou e ela retoma na próxima abertura, dentro do mesmo ciclo EA.
      if (configuracao.modo_execucao === 'conjunto' && totalExecucoes < 1) return 'O modo Conjunto exige ao menos um passo válido.';
      return null;
    }

    private labDmeSalvarConfiguracao() {
      const configuracao = this.labDmeLerConfiguracaoDoModal();
      const erroValidacao = this.labDmeValidarConfiguracao(configuracao);
      if (erroValidacao) {
        $('#labDmeConfigStatus').removeClass('text-muted text-success').addClass('text-danger').text(erroValidacao);
        toastr.warning(erroValidacao, 'Modo Execução Auto DME');
        $('#labDmeTabConjuntosLink').trigger('click');
        return;
      }
      $('#btnLabDmeSalvarConfig, #btnLabDmeSalvarConjuntos').prop('disabled', true);
      $('#labDmeConfigStatus').removeClass('text-danger text-success').addClass('text-muted').text('Salvando configuração...');
      App.Util.preparaCabecalhoRequisicaoAjax();
      $.ajax({
        url: this.labDmeUrlConfiguracaoExecucao,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(configuracao),
      }).done((retorno: any) => {
        const envelope = this.labDmeExtrairEnvelopeConfiguracao(retorno);
        if (!envelope || !envelope.valida || !envelope.configuracao) {
          this.labDmeConfigValida = false;
          $('#labDmeConfigStatus').removeClass('text-muted text-success').addClass('text-danger').text('O servidor recusou a configuração.');
          toastr.warning('Revise a configuração informada.', 'Modo Execução Auto DME');
          return;
        }
        this.labDmeConfigValida = true;
        this.labDmeConfigPersistida = envelope.persistida !== false;
        this.labDmeRevisao = envelope.revisao;
        this.labDmeConfiguracao = this.labDmeNormalizarConfiguracao(envelope.configuracao);
        this.labDmeAplicarConfiguracaoNoModal();
        this.atualizarHeaderModoExecucaoAutoDme(this.labDmeConfiguracao.modo_execucao);
        $('#labDmeConfigDiagnostico').html('');
        $('#labDmeConfigStatus').removeClass('text-muted text-danger').addClass('text-success').text(`Configuração salva${this.labDmeRevisao != null ? ` · revisão ${this.labDmeRevisao}` : ''}.`);
        toastr.success('Configuração salva.', 'Modo Execução Auto DME');
        if (this.conectado) {
          // A resposta do plugin PRECISA ser lida: a ação 78 pode voltar com o Auto DME
          // bloqueado (linha corrompida) ou com a API fora do ar. Sem isto o usuário via
          // "aplicada para todas as contas" enquanto as contas seguiam no plano anterior.
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATUALIZAR_CONFIG_EXECUCAO_AUTO_DME, { revisao: this.labDmeRevisao }, (resposta: IRespostaMensagem) => {
            const dados: any = resposta && resposta.result ? resposta.result : null;
            const bloqueado = !dados || !!dados.bloquear_auto_dme;
            const mensagem = dados && dados.mensagem ? String(dados.mensagem) : '';
            if (!bloqueado && !mensagem) {
              $('#labDmeConfigStatus').removeClass('text-muted text-danger').addClass('text-success')
                .text(`Configuração aplicada no plugin${this.labDmeRevisao != null ? ` · revisão ${this.labDmeRevisao}` : ''}.`);
              return;
            }
            $('#labDmeConfigStatus').removeClass('text-muted text-success').addClass('text-danger')
              .text(mensagem || 'O plugin não conseguiu aplicar a configuração agora.');
            toastr.warning(mensagem || 'Salva no servidor, mas o plugin ainda não aplicou. As contas seguem com a configuração anterior.', 'Modo Execução Auto DME');
          });
        } else {
          $('#labDmeConfigStatus').removeClass('text-muted text-danger').addClass('text-success')
            .text('Configuração salva. O plugin aplica na próxima sincronização.');
        }
      }).fail(() => {
        $('#labDmeConfigStatus').removeClass('text-muted text-success').addClass('text-danger').text('Não foi possível salvar a configuração.');
        toastr.warning('Não foi possível salvar a configuração.', 'Modo Execução Auto DME');
      }).always(() => {
        $('#btnLabDmeSalvarConfig, #btnLabDmeSalvarConjuntos').prop('disabled', false);
      });
    }

    private labDmeMarcarConfigAlterada() {
      $('#labDmeConfigStatus').removeClass('text-danger text-success').addClass('text-muted').text('Alterações ainda não salvas.');
    }

    private labDmeSalvarRascunho() {
      this.labDmeMarcarConfigAlterada();
    }

    private labDmeLimparRascunho() {
      this.labDmePlano = this.labDmePlanoVazio();
      this.labDmeMarcarConfigAlterada();
      this.labDmeRenderConjuntos();
    }

    private labDmeOpcoesRegistrosHtml(selecionado: any): string {
      let html = `<option value="">— selecione o DME —</option>`;
      $('#labDmeRegistrosGlobais option').each((_: number, option: HTMLElement) => {
        const el = $(option);
        const idRegistro = Number(el.val());
        const idDme = Number(el.attr('data-id-dme'));
        const nome = String(el.attr('data-nome') || el.text() || `DME ${idDme}`);
        const nomeHtml = this.escaparHtml(nome);
        const nomeAtributo = nomeHtml.replace(/"/g, '&quot;');
        const sel = selecionado != null && Number(selecionado) === Number(idRegistro) ? 'selected' : '';
        html += `<option value="${idRegistro}" data-id-dme="${idDme}" data-nome="${nomeAtributo}" ${sel}>${nomeHtml}${idDme ? ` (set ${idDme})` : ''}</option>`;
      });
      return html;
    }

    private labDmeRenderConjuntos() {
      const container = $("#labDmeConjuntos");
      const plano = this.labDmePlano || this.labDmePlanoVazio();
      // Badge de contagem na aba (os conjuntos ficam em aba separada do mapa).
      const badge = $("#labDmeConjuntosBadge");
      if (plano.conjuntos.length) {
        badge.text(String(plano.conjuntos.length)).show();
      } else {
        badge.text('').hide();
      }
      if (!plano.conjuntos.length) {
        container.html('<div class="text-muted small py-2">Nenhum conjunto ainda. Clique em <b>+ Conjunto</b> e monte a sequência: os primeiros passos geram as cartas para os seguintes; o último passo é o alvo.</div>');
        return;
      }

      let html = '';
      plano.conjuntos.forEach((conjunto: any, ci: number) => {
        const passos = $.isArray(conjunto.passos) ? conjunto.passos : [];
        // Opção 2: quando o conjunto usa a "ordem inteligente do Piloto", a ordem/quantidade
        // manual dos passos é decidida pelo Piloto — os campos vezes/politica/condicional ficam
        // desabilitados (o DME e a posição do último passo=alvo continuam editáveis).
        const piloto = conjunto.ordem_inteligente_piloto === true;
        const desab = piloto ? 'disabled' : '';
        const estiloDesab = piloto ? 'opacity: 0.5;' : '';
        let passosHtml = '';
        passos.forEach((passo: any, pi: number) => {
          const ehUltimo = pi === passos.length - 1;
          passosHtml += `
            <div class="d-flex flex-wrap align-items-center mb-1 lab-dme-passo" data-ci="${ci}" data-pi="${pi}">
              <span class="badge badge-${ehUltimo ? 'success' : 'secondary'} mr-2" title="${ehUltimo ? 'Alvo do conjunto' : 'Passo ' + (pi + 1)}">${ehUltimo ? '🎯' : (pi + 1)}</span>
              <select class="form-control form-control-sm lab-dme-campo mr-1" data-campo="registro" data-ci="${ci}" data-pi="${pi}" style="flex: 1 1 200px; min-width: 180px; max-width: 320px;">${this.labDmeOpcoesRegistrosHtml(passo.id_registro)}</select>
              <input type="number" min="1" max="10" value="${Number(passo.vezes) || 1}" class="form-control form-control-sm lab-dme-campo mr-1" data-campo="vezes" data-ci="${ci}" data-pi="${pi}" style="width: 62px; ${estiloDesab}" title="${piloto ? 'Definido pelo Piloto (ordem inteligente ligada)' : 'Quantas vezes executar este DME neste passo'}" ${desab}>
              <select class="form-control form-control-sm lab-dme-campo mr-1" data-campo="politica_falha" data-ci="${ci}" data-pi="${pi}" style="width: 150px; ${estiloDesab}" title="Se este passo falhar" ${desab}>
                <option value="pular" ${passo.politica_falha !== 'abortar_conjunto' ? 'selected' : ''}>Falhou → segue</option>
                <option value="abortar_conjunto" ${passo.politica_falha === 'abortar_conjunto' ? 'selected' : ''}>Falhou → pula conjunto</option>
              </select>
              <label class="small mb-0 mr-2 d-flex align-items-center" style="white-space: nowrap; cursor: pointer; ${estiloDesab}" title="Passo condicional: antes de executar, verifica se o PRÓXIMO passo já está viável. (ex.:TOTW 84+ Upgrade, já tem a carta TOTW exigida) vai pular para o próximo sem fazer esse.">
                <input type="checkbox" class="lab-dme-campo mr-1" data-campo="pular_se_proximo_viavel" data-ci="${ci}" data-pi="${pi}" ${passo.pular_se_proximo_viavel ? 'checked' : ''} ${desab}>⏭ faze-lo se precisar
              </label>
              <a href="javascript:void(0)" class="btn btn-sm btn-outline-default btn-lab-dme-mover-passo px-2" data-ci="${ci}" data-pi="${pi}" data-dir="-1" title="Mover para cima">↑</a>
              <a href="javascript:void(0)" class="btn btn-sm btn-outline-default btn-lab-dme-mover-passo px-2" data-ci="${ci}" data-pi="${pi}" data-dir="1" title="Mover para baixo">↓</a>
              <a href="javascript:void(0)" class="btn btn-sm btn-outline-danger btn-lab-dme-remover-passo px-2" data-ci="${ci}" data-pi="${pi}" title="Remover passo">×</a>
            </div>`;
        });
        const notaPiloto = piloto
          ? '<div class="small text-info mt-1"><b>🧠 Ordem inteligente ligada:</b> o Piloto escolhe a ordem e a quantidade rumo ao 🎯 (último passo), usando só os DMEs deste conjunto. Os campos de vezes/condição acima ficam a cargo do Piloto.</div>'
          : '';

        html += `
          <div class="card mb-2 lab-dme-conjunto" data-ci="${ci}">
            <div class="card-body p-2">
              <div class="d-flex flex-wrap align-items-center mb-2">
                <b class="mr-3">Conjunto ${ci + 1}</b>
                <span class="small text-muted mr-1">Repetir conjunto</span>
                <input type="number" min="1" max="10" value="${Number(conjunto.repeticoes) || 1}" class="form-control form-control-sm lab-dme-campo mr-2" data-campo="repeticoes" data-ci="${ci}" style="width: 62px;" title="Quantas vezes o conjunto inteiro repete">
                <a href="javascript:void(0)" class="btn btn-sm btn-outline-primary btn-lab-dme-add-passo mr-1" data-ci="${ci}">+ Passo</a>
                <a href="javascript:void(0)" class="btn btn-sm btn-outline-danger btn-lab-dme-remover-conjunto mr-3" data-ci="${ci}" title="Remover conjunto">Remover</a>
                <label class="small mb-0 mr-3 d-flex align-items-center" style="white-space: nowrap; cursor: pointer;" title="Neste conjunto, o sistema escolhe a ORDEM e a QUANTIDADE (regra do Piloto) rumo ao alvo (🎯 último passo), usando só os DMEs deste conjunto. Quando ligado, a ordem/vezes manuais são ignoradas.">
                  <input type="checkbox" class="lab-dme-campo mr-1" data-campo="ordem_inteligente_piloto" data-ci="${ci}" ${piloto ? 'checked' : ''}>🧠 ordem inteligente (Piloto)
                </label>
                <label class="small mb-0 mr-2 d-flex align-items-center" style="white-space: nowrap; cursor: pointer;" title="Ignora, só neste conjunto, as reservas de 'exclusões inteligentes' que protegem DMEs FORA deste plano — libera cartas que o clube tem mas estão reservadas para outros DMEs que não estão no conjunto.">
                  <input type="checkbox" class="lab-dme-campo mr-1" data-campo="ignorar_exclusoes_inteligentes" data-ci="${ci}" ${conjunto.ignorar_exclusoes_inteligentes === true ? 'checked' : ''}>🔓 ignorar reservas de exclusões
                </label>
              </div>
              ${passosHtml || '<div class="text-muted small">Sem passos — clique em <b>+ Passo</b>.</div>'}
              ${notaPiloto}
            </div>
          </div>`;
      });
      container.html(html);
    }

    private labDmeAdicionarConjunto() {
      if (!this.labDmePlano) this.labDmePlano = this.labDmePlanoVazio();
      this.labDmePlano.conjuntos.push({ nome: `Conjunto ${this.labDmePlano.conjuntos.length + 1}`, repeticoes: 1, ignorar_exclusoes_inteligentes: false, ordem_inteligente_piloto: false, passos: [] });
      this.labDmeSalvarRascunho();
      this.labDmeRenderConjuntos();
    }

    private labDmeRemoverConjunto(e: JQueryEventObject) {
      const ci = Number($(e.currentTarget).data('ci'));
      if (!this.labDmePlano || !this.labDmePlano.conjuntos[ci]) return;
      this.labDmePlano.conjuntos.splice(ci, 1);
      this.labDmeSalvarRascunho();
      this.labDmeRenderConjuntos();
    }

    private labDmeAdicionarPasso(e: JQueryEventObject) {
      const ci = Number($(e.currentTarget).data('ci'));
      const conjunto = this.labDmePlano && this.labDmePlano.conjuntos[ci];
      if (!conjunto) return;
      if (!$.isArray(conjunto.passos)) conjunto.passos = [];
      conjunto.passos.push({ id_registro: null, id_dme: null, nome: null, vezes: 1, politica_falha: 'pular' });
      this.labDmeSalvarRascunho();
      this.labDmeRenderConjuntos();
    }

    private labDmeRemoverPasso(e: JQueryEventObject) {
      const ci = Number($(e.currentTarget).data('ci'));
      const pi = Number($(e.currentTarget).data('pi'));
      const conjunto = this.labDmePlano && this.labDmePlano.conjuntos[ci];
      if (!conjunto || !conjunto.passos[pi]) return;
      conjunto.passos.splice(pi, 1);
      this.labDmeSalvarRascunho();
      this.labDmeRenderConjuntos();
    }

    private labDmeMoverPasso(e: JQueryEventObject) {
      const el = $(e.currentTarget);
      const ci = Number(el.data('ci'));
      const pi = Number(el.data('pi'));
      const dir = Number(el.data('dir'));
      const conjunto = this.labDmePlano && this.labDmePlano.conjuntos[ci];
      if (!conjunto || !conjunto.passos[pi] || !conjunto.passos[pi + dir]) return;
      const tmp = conjunto.passos[pi];
      conjunto.passos[pi] = conjunto.passos[pi + dir];
      conjunto.passos[pi + dir] = tmp;
      this.labDmeSalvarRascunho();
      this.labDmeRenderConjuntos();
    }

    private labDmeAoAlterarCampo(e: JQueryEventObject) {
      const el = $(e.currentTarget);
      const campo = String(el.data('campo'));
      const ci = Number(el.data('ci'));
      const pi = el.data('pi') != null ? Number(el.data('pi')) : null;
      const conjunto = this.labDmePlano && this.labDmePlano.conjuntos[ci];
      if (!conjunto) return;

      let precisaRerender = false;
      if (campo === 'repeticoes') {
        conjunto.repeticoes = Math.max(1, Math.min(10, parseInt(String(el.val()), 10) || 1));
      } else if (campo === 'ignorar_exclusoes_inteligentes') {
        conjunto.ignorar_exclusoes_inteligentes = el.is(':checked');
      } else if (campo === 'ordem_inteligente_piloto') {
        // Toggle muda o estado visual (grisa os campos de passo) — re-render.
        conjunto.ordem_inteligente_piloto = el.is(':checked');
        precisaRerender = true;
      } else if (pi != null && conjunto.passos[pi]) {
        const passo = conjunto.passos[pi];
        if (campo === 'registro') {
          const opt = el.find('option:selected');
          passo.id_registro = el.val() ? Number(el.val()) : null;
          passo.id_dme = opt.data('idDme') ? Number(opt.data('idDme')) : null;
          passo.nome = opt.data('nome') ? String(opt.data('nome')) : null;
        } else if (campo === 'vezes') {
          passo.vezes = Math.max(1, Math.min(10, parseInt(String(el.val()), 10) || 1));
        } else if (campo === 'politica_falha') {
          passo.politica_falha = String(el.val()) === 'abortar_conjunto' ? 'abortar_conjunto' : 'pular';
        } else if (campo === 'pular_se_proximo_viavel') {
          passo.pular_se_proximo_viavel = el.is(':checked');
        }
      }
      this.labDmeSalvarRascunho();
      if (precisaRerender) this.labDmeRenderConjuntos();
    }

    private labDmeVereditoBadge(veredito: string): string {
      if (veredito === 'viavel') return '<span class="badge badge-success">Viável</span>';
      if (veredito === 'gap') return '<span class="badge badge-warning">Gap</span>';
      if (veredito === 'inviavel') return '<span class="badge badge-danger">Inviável</span>';
      if (veredito === 'completo') return '<span class="badge badge-info">Concluído hoje</span>';
      return '<span class="badge badge-secondary">Desconhecido</span>';
    }

    private labDmeRenderMapa(mapa: any) {
      const container = $("#labDmeMapa");
      if (!mapa) {
        container.html('<div class="alert alert-warning small mb-0">Mapa vazio.</div>');
        return;
      }

      let avisosHtml = '';
      ($.isArray(mapa.avisos) ? mapa.avisos : []).forEach((aviso: string) => {
        avisosHtml += `<div class="alert alert-warning small py-1 px-2 mb-1">${aviso}</div>`;
      });

      const cat = mapa.catalogo || {};
      const clube = mapa.clube || {};
      const infoHtml = `
        <div class="small text-muted mb-2">
          Catálogo: ${cat.disponivel ? `<b>${cat.qtdDmes}</b> DMEs${cat.idadeHoras != null ? ` (idade ${cat.idadeHoras}h)` : ''}` : '<b class="text-danger">indisponível</b>'}
          · Clube: ${clube.disponivel ? `<b>${clube.totalJogadores}</b> jogadores${clube.scanAt ? ` (scan ${clube.scanAt})` : ''}` : '<b class="text-danger">sem snapshot</b>'}
          · Gerado: ${mapa.geradoEm || '-'}${mapa.snapshotAtualizadoDaConta ? ' · <span class="text-success">DMEs relidos da conta agora</span>' : ''}
        </div>`;

      let linhas = '';
      ($.isArray(mapa.registros) ? mapa.registros : []).forEach((reg: any) => {
        const gaps = ($.isArray(reg.gaps) ? reg.gaps : []).map((g: any) => `<div>• ${g.descricao}</div>`).join('');
        const desafiosChip = ($.isArray(reg.desafios) ? reg.desafios : []).map((d: any) => {
          // ✓ concluído no ciclo (status COMPLETED aprendido da tela real): não conta como
          // "viável pendente" — o veredito/colheita do set considera só os pendentes.
          // ⚠ solver reprovou: o veredito do chip é HEURÍSTICO (pode seguir "viável") mas o
          // solver REAL acabou de falhar exatamente neste desafio — sem a marca o painel
          // pinta verde um desafio que não fecha (caso 1326: chip verde no 88-Rated).
          const solverReprovouEste = reg.solver_reprovou_pool_atual === true
            && reg.solver_reprovou_challenge_id != null
            && d.challengeId != null
            && Number(d.challengeId) === Number(reg.solver_reprovou_challenge_id)
            && d.concluido !== true;
          const cor = d.concluido === true ? 'info' : solverReprovouEste ? 'danger' : d.veredito === 'viavel' ? 'success' : d.veredito === 'gap' ? 'warning' : d.veredito === 'inviavel' ? 'danger' : 'secondary';
          const chips: string[] = [];
          if (d.concluido === true) chips.push('✓ concluído');
          if (solverReprovouEste) chips.push('⚠ solver reprovou com o pool atual');
          if (d.temQuimica) chips.push('química');
          if (d.preCheckProfundo && d.preCheckProfundo.status === 'confirmado') chips.push('✔ pré-check');
          if (d.preCheckProfundo && d.preCheckProfundo.status === 'nao_confirmado') chips.push('pré-check ✖');
          return `<span class="badge badge-${cor} mr-1" title="${(d.nome || '')}${chips.length ? ' — ' + chips.join(', ') : ''}">${d.habilitado === false ? '<s>' : ''}${(d.nome || d.challengeId || '?')}${d.habilitado === false ? '</s>' : ''}${chips.length ? ' (' + chips.join(', ') + ')' : ''}</span>`;
        }).join('');
        const estado = reg.estado_atual || {};
        const nomeEscapado = String(reg.nome || '').replace(/"/g, '&quot;');
        const ehCompletoCiclo = reg.veredito === 'completo';
        const btnResolver = ehCompletoCiclo
          ? `<a href="javascript:void(0)" class="btn btn-sm btn-outline-secondary disabled" title="Sem repetição disponível neste ciclo — renova na virada diária da EA (18:00 UK); o remapeamento reabilita sozinho">✔ Feito</a>`
          : `<a href="javascript:void(0)" class="btn btn-sm btn-outline-success btn-lab-dme-resolver-linha${this.labDmePilotoAtivo ? ' disabled' : ''}" data-id-registro="${reg.id_registro != null ? reg.id_registro : ''}" data-id-dme="${reg.id_dme}" data-nome="${nomeEscapado}" title="Resolver este DME agora — a conta abre se necessário e PERMANECE aberta para o próximo clique">▶ Resolver</a>`;

        // Ordem = prioridade do registro no Auto DME (a mesma da execução real).
        const infoPartes: string[] = [];
        if (reg.prioridade != null) infoPartes.push(`<span title="Ordem de execução configurada no Auto DME">#${reg.prioridade}</span>`);
        infoPartes.push(`set ${reg.id_dme}`);
        if (reg.premio_final_negociavel) infoPartes.push('<span class="text-success">prêmio negociável</span>');
        infoPartes.push(reg.pode_comprar ? 'pode comprar' : 'só clube');
        if (reg.exigir_todos_desafios_viaveis) infoPartes.push('<span class="text-info" title="Registro configurado para executar somente com TODOS os desafios viáveis">🔒 todos os desafios</span>');

        const linhaEstado = (estado.status || estado.tentativas_hoje != null)
          ? `<div class="small text-muted">hoje: ${estado.status || '—'}${estado.motivo_bloqueio ? ` (${estado.motivo_bloqueio})` : ''}${estado.tentativas_hoje != null ? ` · tent. ${estado.tentativas_hoje} · suc. ${estado.sucessos_hoje || 0}` : ''}</div>`
          : '';
        const linhaFutbin = reg.futbin && (reg.futbin.rewardValue || reg.futbin.cheapestPc)
          ? `<div class="small text-muted">${reg.futbin.rewardValue ? `recompensa ~${Number(reg.futbin.rewardValue).toLocaleString('pt-BR')}` : ''}${reg.futbin.rewardValue && reg.futbin.cheapestPc ? ' · ' : ''}${reg.futbin.cheapestPc ? `custo ~${Number(reg.futbin.cheapestPc).toLocaleString('pt-BR')}` : ''}</div>`
          : '';

        // 💰 Lucro médio REAL por execução (packs abertos de todos os usuários na janela
        // do PRO) — é o dado que o planejador usa no critério de lucro, acima do Futbin.
        let linhaLucroReal = '';
        if (reg.lucro_real_medio != null && Number(reg.lucro_real_medio) !== 0) {
          const janela = reg.lucro_real_janela_horas != null ? `${reg.lucro_real_janela_horas}h` : 'janela recente';
          const amostras = reg.lucro_real_amostras != null ? ` · ${reg.lucro_real_amostras} amostra(s)` : '';
          linhaLucroReal = `<div class="small" style="color: #2dce89;" title="Média de lucro por execução, observada nos pacotes abertos por TODOS os usuários (tabela user_pacote) na janela configurada no PRO. O planejador prefere este número ao Futbin no critério de lucro.">💰 lucro médio real (${janela}): ${Number(reg.lucro_real_medio).toLocaleString('pt-BR')}/execução${amostras}</div>`;
        }

        // Cadeia de insumos: o que o DME produz (awards + descrição EA), o que consome
        // por execução e quantas execuções ainda cabem no ciclo.
        const ass = reg.assinatura_producao;
        const cons = reg.assinatura_consumo;

        // ↻ Resolver repetindo: repetível → todas as repetições restantes do ciclo numa
        // sequência só; ilimitado/desconhecido → 2× por clique. Teto 10 (limite do passo).
        // O POOL também limita: não oferecer 5× quando o clube só alimenta 1 execução
        // (evita tempo perdido em repetições impossíveis; remap + novo clique cobre o resto).
        let btnRepetir = '';
        if (!ehCompletoCiclo) {
          let vezesRepetir = 2;
          let tituloRepetir = 'Resolve 2× em sequência (DME sem teto de ciclo conhecido) — a conta permanece aberta';
          if (ass && ass.execucoesRestantesCiclo != null) {
            vezesRepetir = Math.max(1, Math.min(10, Number(ass.execucoesRestantesCiclo)));
            tituloRepetir = `Resolve as ${vezesRepetir} repetição(ões) restantes do ciclo em sequência — a conta permanece aberta`;
          }
          const sustentaveis = reg.execucoes_sustentaveis_pool != null ? Number(reg.execucoes_sustentaveis_pool) : null;
          if (sustentaveis != null && sustentaveis > 0 && sustentaveis < vezesRepetir) {
            vezesRepetir = sustentaveis;
            tituloRepetir = `O pool atual sustenta ~${sustentaveis} execução(ões) — as recompensas podem liberar mais após o remapeamento`;
          }
          if (vezesRepetir > 1) {
            btnRepetir = `<a href="javascript:void(0)" class="btn btn-sm btn-outline-primary btn-lab-dme-resolver-linha d-block mt-1${this.labDmePilotoAtivo ? ' disabled' : ''}" data-id-registro="${reg.id_registro != null ? reg.id_registro : ''}" data-id-dme="${reg.id_dme}" data-nome="${nomeEscapado}" data-vezes="${vezesRepetir}" title="${tituloRepetir}">↻ ${vezesRepetir}×</a>`;
          }
        }

        let linhaCadeia = '';
        if (ass || cons) {
          const partesCadeia: string[] = [];
          if (ass) {
            let prod = `produz ${ass.descricao}`;
            if (ass.negociavel === true) prod += ' <span class="text-success">(negociável)</span>';
            if (ass.execucoesRestantesCiclo != null) prod += ` · restam <b>${ass.execucoesRestantesCiclo}</b>${ass.capacidadeCiclo != null ? `/${ass.capacidadeCiclo}` : ''} no ciclo`;
            else if (ass.capacidadeCiclo != null) prod += ` · até ${ass.capacidadeCiclo}/ciclo`;
            partesCadeia.push(prod);
          }
          if (cons) partesCadeia.push(`consome ${cons.descricao}`);
          if (reg.execucoes_sustentaveis_pool != null && Number(reg.execucoes_sustentaveis_pool) >= 0) {
            partesCadeia.push(`pool sustenta ~${reg.execucoes_sustentaveis_pool}× agora`);
          }
          linhaCadeia = `<div class="small" style="color: #5e72e4;">🔁 ${partesCadeia.join(' — ')}</div>`;
        }

        // Divergência mapa × solver real: mapa viável, solver falhou por pool — sinal
        // de bug no pool do solver (não rebaixa o veredito; alerta para investigar).
        let linhaDivergencia = '';
        if (reg.divergencia_solver) {
          linhaDivergencia = `<div class="small mt-1 p-1 border rounded" style="background: #fdecea;">⚠ <b>Divergência mapa × solver:</b> o mapa vê este DME viável, mas a última tentativa real falhou — <i>${reg.divergencia_solver}</i>. Se a montagem manual funciona na tela, é bug no pool do solver.</div>`;
        }

        // Exclusões inteligentes ativas: cartas bloqueadas para preservar outros DMEs.
        // Não ficam no registro (derivadas das exigências dos outros sets), então sem
        // esta linha o gap parece inexplicável — "tenho as cartas, por que não resolve?".
        let linhaExclusoesInteligentes = '';
        if (reg.exclusoes_inteligentes && reg.exclusoes_inteligentes.resumo) {
          const fontes = $.isArray(reg.exclusoes_inteligentes.setIdsFonte) ? reg.exclusoes_inteligentes.setIdsFonte : [];
          const titulo = fontes.length ? ('DMEs fonte: ' + fontes.join(', ')) : '';
          linhaExclusoesInteligentes = `<div class="small" style="color: #8898aa;" title="${titulo}">🛡 Exclusões inteligentes: ${reg.exclusoes_inteligentes.resumo}</div>`;
        }

        // Especiais (TOTW/TOTS/FOF) reservadas para outros DMEs da lista: ficam fora do
        // pool deste DME mesmo com "usar especiais" ligado, para não queimar a carta que
        // o outro set precisa. Sem esta linha, o gap pareceria arbitrário.
        let linhaEspeciaisReservadas = '';
        if (reg.especiais_reservadas && reg.especiais_reservadas.resumo) {
          linhaEspeciaisReservadas = `<div class="small" style="color: #8898aa;" title="Quantidade exigida por outros DMEs × execuções que eles ainda podem fazer; o excedente continua liberado aqui. 'Guardadas p/ o próximo ciclo' = o DME que exige a carta já terminou hoje, mas renova amanhã — ative a liberação na Config. Execução se quiser usá-las mesmo assim.">💎 ${reg.especiais_reservadas.total} especial(is) reservada(s): ${reg.especiais_reservadas.resumo}</div>`;
        }

        // O clube TEM o insumo, mas ele está bloqueado (reserva de especiais e/ou
        // exclusão inteligente): sem esta linha o veredito "Gap/Inviável" parece falta
        // de carta — e a decisão certa pode ser só ligar a opção de liberar após o ciclo.
        let linhaInsumoBloqueado = '';
        if (reg.insumo_bloqueado && reg.insumo_bloqueado.resumo) {
          const guardado = reg.insumo_bloqueado.preservado_proximo_ciclo === true;
          linhaInsumoBloqueado = `<div class="small mt-1 p-1 border rounded" style="background: #e8f4fd;" title="${guardado ? 'Para usar essas cartas hoje, ligue no perfil a opção de liberar (especiais/exclusões) após o ciclo dos DMEs dependentes e remapeie.' : 'As cartas existem no clube, mas outro DME da lista ainda conta com elas neste ciclo.'}">${guardado ? '🔒' : '⏳'} <b>Insumo existe, mas está bloqueado:</b> ${reg.insumo_bloqueado.resumo}</div>`;
        }

        // Regra "alvo pronto vence a disputa" (10/08): este é o alvo da vez e o único
        // bloqueio era a reserva da raridade disputada — ela foi suspensa contra ele.
        let linhaAlvoVenceuDisputa = '';
        if (reg.alvo_venceu_disputa_especiais === true) {
          linhaAlvoVenceuDisputa = `<div class="small mt-1 p-1 border rounded" style="background: #e6f9f0;" title="Regra: quando o alvo da vez está PRONTO (o único bloqueio é a reserva da raridade disputada), ele vence a disputa mesmo contra DMEs mais prioritários na ordem de configuração — mapa, planejador e solver passam a usar o mesmo pool.">🏁 <b>Alvo pronto — venceu a disputa das especiais:</b> as reservas da raridade disputada foram suspensas para este DME nesta rodada.</div>`;
        }

        // Config do registro é o impedimento? Mostra a sugestão inteligente com botão Ajustar.
        let linhaSugestaoConfig = '';
        if ($.isArray(reg.sugestoes_config) && reg.sugestoes_config.length) {
          const s = reg.sugestoes_config[0];
          const valorSugeridoJson = JSON.stringify(s.valor_sugerido).replace(/"/g, '&quot;');
          let rotuloValor = '';
          if ($.isArray(s.valor_sugerido)) rotuloValor = 'limpar lista';
          else if (s.campo === 'excluirEspeciais') rotuloValor = (s.valor_sugerido === false) ? 'usar especiais' : 'não usar especiais';
          else if (s.campo === 'maximo_rating_carta_especial') rotuloValor = 'especiais até ' + String(s.valor_sugerido);
          else if (s.valor_sugerido === false) rotuloValor = 'permitir';
          else if (s.valor_sugerido === true) rotuloValor = 'ativar';
          else rotuloValor = String(s.valor_sugerido);
          linhaSugestaoConfig = `<div class="small mt-1 p-1 border rounded" style="background: #fff8e1;">⚙ <b>Config limita:</b> ${s.motivo}
            <a href="javascript:void(0)" class="btn btn-sm btn-warning btn-lab-dme-ajustar-config ml-1 py-0" data-id-registro="${reg.id_registro != null ? reg.id_registro : ''}" data-campo="${s.campo}" data-rotulo="${String(s.rotulo || s.campo).replace(/"/g, '&quot;')}" data-valor-sugerido="${valorSugeridoJson}" data-nome="${nomeEscapado}" title="Aplica o ajuste no cadastro do Auto DME (PRO) e remapeia em seguida">Ajustar → ${rotuloValor}</a></div>`;
        }

        linhas += `
          <tr${ehCompletoCiclo ? ' style="opacity: 0.65;"' : ''}>
            <td class="align-middle" style="width: 92px;">${btnResolver}${btnRepetir}</td>
            <td class="align-middle" style="word-break: break-word; overflow-wrap: anywhere;">
              <b>${reg.nome}</b>
              <div class="small text-muted">${infoPartes.join(' · ')}</div>
              ${linhaEstado}
              ${linhaFutbin}
              ${linhaLucroReal}
              ${linhaCadeia}
              ${linhaExclusoesInteligentes}
              ${linhaEspeciaisReservadas}
              ${linhaInsumoBloqueado}
              ${linhaAlvoVenceuDisputa}
              ${linhaDivergencia}
              ${linhaSugestaoConfig}
            </td>
            <td class="align-middle" style="width: 96px;">${this.labDmeVereditoBadge(reg.veredito)}<div class="small text-muted">${reg.confiabilidade || ''}</div></td>
            <td class="align-middle small" style="white-space: normal; word-break: break-word; overflow-wrap: anywhere;">${gaps || '<span class="text-muted">—</span>'}</td>
            <td class="align-middle small" style="white-space: normal; word-break: break-word;">${desafiosChip || (ehCompletoCiclo ? '<span class="text-muted">—</span>' : '<span class="text-muted">sem catálogo</span>')}</td>
          </tr>`;
      });

      container.html(`
        ${avisosHtml}
        ${infoHtml}
        <div style="max-height: 460px; overflow-y: auto;">
          <table class="table table-sm table-hover mb-0" style="width: 100%; table-layout: fixed;">
            <thead><tr><th style="width: 92px;"></th><th style="width: 34%;">DME</th><th style="width: 96px;">Veredito</th><th style="width: 40%;">O que falta</th><th style="width: 18%;">Desafios</th></tr></thead>
            <tbody>${linhas || '<tr><td colspan="5" class="text-muted">Nenhum registro Auto DME no perfil desta conta.</td></tr>'}</tbody>
          </table>
        </div>`);
    }

    private labDmeMapear() {
      if (!this.conectado) {
        toastr.warning("Plugin não conectado.", "Modo Execução Auto DME");
        return;
      }
      if (!this.labDmeContaId) return;
      $("#labDmeMapa").html('<div class="text-center py-3"><div class="spinner-border" role="status"></div><div class="small text-muted mt-2">Mapeando viabilidade (sem abrir a conta)...</div></div>');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LAB_MAPEAR_CONJUNTOS_DME, { id: this.labDmeContaId, preCheckProfundo: false }, (response: IRespostaMensagem) => {
        if (!response || !response.status || !response.result || !response.result.mapa) {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível gerar o mapa.";
          $("#labDmeMapa").html(`<div class="alert alert-danger small mb-0">${this.escaparHtml(String(msg))}</div>`);
          return;
        }
        this.labDmeRenderMapa(response.result.mapa);
      });
    }

    private labDmePlanoParaEnvio(): any | null {
      const plano = this.labDmePlano;
      if (!plano || !$.isArray(plano.conjuntos) || !plano.conjuntos.length) return null;
      const conjuntos: any[] = [];
      for (const conjunto of plano.conjuntos) {
        const passos = ($.isArray(conjunto.passos) ? conjunto.passos : [])
          .filter((p: any) => p && Number(p.id_dme) > 0)
          .map((p: any) => ({
            id_registro: p.id_registro != null ? Number(p.id_registro) : null,
            id_dme: Number(p.id_dme),
            nome: p.nome || null,
            vezes: Math.max(1, Math.min(10, Number(p.vezes) || 1)),
            politica_falha: p.politica_falha === 'abortar_conjunto' ? 'abortar_conjunto' : 'pular',
            pular_se_proximo_viavel: p.pular_se_proximo_viavel === true,
          }));
        if (!passos.length) continue;
        conjuntos.push({
          nome: conjunto.nome || null,
          repeticoes: Math.max(1, Math.min(10, Number(conjunto.repeticoes) || 1)),
          ignorar_exclusoes_inteligentes: conjunto.ignorar_exclusoes_inteligentes === true,
          ordem_inteligente_piloto: conjunto.ordem_inteligente_piloto === true,
          passos,
        });
      }
      if (!conjuntos.length) return null;
      return {
        conjuntos,
        opcoes: {
          respeitar_limites: true,
          mapear_entre_passos: false,
        },
      };
    }

    private async labDmeExecutar() {
      if (!this.conectado) {
        toastr.warning("Plugin não conectado.", "Modo Execução Auto DME");
        return;
      }
      if (!this.labDmeContaId) return;
      const plano = this.labDmePlanoParaEnvio();
      if (!plano) {
        toastr.warning("Monte pelo menos um conjunto com um passo válido (DME selecionado).", "Modo Execução Auto DME");
        // Leva o usuário direto ao editor (aba separada do mapa).
        $('#labDmeTabConjuntosLink').trigger('click');
        return;
      }

      let totalExecucoes = 0;
      plano.conjuntos.forEach((c: any) => c.passos.forEach((p: any) => { totalExecucoes += p.vezes * c.repeticoes; }));

      const result = await swal.fire({
        title: 'Testar conjuntos nesta conta?',
        html: `A conta será aberta e executará <b>${plano.conjuntos.length}</b> conjunto(s), até <b>${totalExecucoes}</b> execução(ões) de DME em sequência.<br/><small class="text-muted">Este teste não altera o modo salvo. Acompanhe o progresso neste modal.</small>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#2dce89',
        confirmButtonText: 'Sim, executar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      $("#labDmeProgresso").html('<div class="small text-muted">Abrindo a conta e iniciando os conjuntos...</div>');
      $("#labDmeResumoExecucao").html('');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LAB_EXECUTAR_CONJUNTOS_DME, { id: this.labDmeContaId, plano }, (response: IRespostaMensagem) => {
        if (!response || !response.status) {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível iniciar a execução dos conjuntos.";
          toastr.warning(msg, "Modo Execução Auto DME");
          this.labDmeAppendProgresso(`<span class="text-danger">✖ ${msg}</span>`);
          return;
        }
        toastr.success("Teste dos conjuntos iniciado. Acompanhe o progresso.", "Modo Execução Auto DME");
      });
    }

    /** Renderiza a caixa de sugestão do planejador guiado por gap. */
    private labDmeRenderSugestao(sugestao: any) {
      const container = $("#labDmeSugestao");
      if (!sugestao) {
        container.html('');
        return;
      }
      // Produtores segurados de propósito (insumo sem demanda agora): transparência —
      // sem esta linha, "por que o TOTW Upgrade viável não é sugerido?" fica sem resposta.
      let linhaSegurados = '';
      if ($.isArray(sugestao.segurados) && sugestao.segurados.length) {
        const itens = sugestao.segurados
          .map((s: any) => `<div>⏸ <b>${s.nome}</b>: ${s.motivo}</div>`)
          .join('');
        linhaSegurados = `<div class="small text-muted mt-1" title="Produzem insumo exigido por outro DME da lista; rodam automaticamente quando a carta estiver FALTANDO, só na quantidade necessária.">${itens}</div>`;
      }
      if (sugestao.tipo === 'sem_sugestao') {
        container.html(`<div class="alert alert-warning small mb-0">💡 <b>Planejador:</b> ${sugestao.motivo}${linhaSegurados}</div>`);
        return;
      }
      const nomeEscapado = String(sugestao.nome || '').replace(/"/g, '&quot;');
      const ehAlvo = sugestao.tipo === 'executar_alvo';
      let detalhes = '';
      if ($.isArray(sugestao.detalhes) && sugestao.detalhes.length) {
        detalhes = sugestao.detalhes.map((d: string) => `<div class="small text-muted">${d}</div>`).join('');
      }
      // Cadeia de insumos em chips: quantas execuções, capacidade do ciclo e avisos.
      let chips = '';
      if (sugestao.execucoesSugeridas && Number(sugestao.execucoesSugeridas) > 0) {
        const restantes = sugestao.execucoesRestantesCiclo != null ? ` · restam ${sugestao.execucoesRestantesCiclo} no ciclo` : '';
        chips += `<span class="badge badge-info mr-1">Execuções sugeridas: ${sugestao.execucoesSugeridas}×${restantes}</span>`;
      }
      // Estratégia de rodadas: 1× por sugestão; o gap total fica visível para o usuário
      // entender que a sequência vai repetir (a→b→c→d) em vez de martelar o mesmo DME.
      if (sugestao.execucoesNecessarias != null && Number(sugestao.execucoesNecessarias) > Number(sugestao.execucoesSugeridas || 0)) {
        chips += `<span class="badge badge-secondary mr-1" title="O planejador executa 1× por rodada e remapeia; se continuar faltando, volta neste DME na próxima rodada — repetir a sequência entre os DMEs vale mais que repetir o mesmo desafio">gap total: ${sugestao.execucoesNecessarias}× · 1 por rodada</span>`;
      }
      if (sugestao.execucoesSustentaveisPool != null && Number(sugestao.execucoesNecessarias) > Number(sugestao.execucoesSustentaveisPool)) {
        chips += `<span class="badge badge-warning mr-1">pool sustenta ~${sugestao.execucoesSustentaveisPool}× agora</span>`;
      }
      if (sugestao.cobreGapTotalmente === false) {
        chips += `<span class="badge badge-warning mr-1">cobre só PARTE do gap neste ciclo</span>`;
      }
      if (sugestao.consumoCompeteComAlvo === true) {
        chips += `<span class="badge badge-warning mr-1">⚠ consome cartas do perfil do alvo</span>`;
      }
      if (chips) chips = `<div class="mt-1">${chips}</div>`;
      container.html(`
        <div class="alert alert-${ehAlvo ? 'success' : 'info'} small mb-0 d-flex align-items-center justify-content-between">
          <div class="pr-2">
            💡 <b>Planejador sugere:</b> ${ehAlvo ? '🎯 colher o ALVO' : 'preparar com a fonte'} <b>${sugestao.nome}</b>
            <div class="mt-1">${sugestao.motivo}</div>
            ${sugestao.gapAlvo ? `<div class="small text-muted">Gap do alvo: ${sugestao.gapAlvo}</div>` : ''}
            ${chips}
            ${detalhes}
            ${linhaSegurados}
          </div>
          <a href="javascript:void(0)" class="btn btn-sm btn-success btn-lab-dme-resolver-linha flex-shrink-0" data-id-registro="${sugestao.id_registro != null ? sugestao.id_registro : ''}" data-id-dme="${sugestao.setId}" data-nome="${nomeEscapado}" data-vezes="${Math.max(1, Math.min(10, Number(sugestao.execucoesSugeridas) || 1))}" title="Executar a sugestão agora com as execuções calculadas (a conta abre se necessário e permanece aberta)">▶ Resolver sugerido${Number(sugestao.execucoesSugeridas) > 1 ? ` ${Math.min(10, Number(sugestao.execucoesSugeridas))}×` : ''}</a>
        </div>`);
    }

    /** Ação 75: pede ao planejador a sugestão do próximo passo (sem executar) + mapa fresco. */
    private labDmeSugerirProximoPasso() {
      if (!this.conectado) {
        toastr.warning("Plugin não conectado.", "Modo Execução Auto DME");
        return;
      }
      if (!this.labDmeContaId) return;
      $("#labDmeSugestao").html('<div class="text-muted small"><div class="spinner-border spinner-border-sm mr-1" role="status"></div> Calculando a sugestão (catálogo × clube × gaps)...</div>');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LAB_SUGERIR_PROXIMO_PASSO, { id: this.labDmeContaId }, (response: IRespostaMensagem) => {
        if (!response || !response.status || !response.result) {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível calcular a sugestão.";
          $("#labDmeSugestao").html(`<div class="alert alert-danger small mb-0">${msg}</div>`);
          return;
        }
        if (response.result.mapa) {
          this.labDmeRenderMapa(response.result.mapa);
        }
        this.labDmeRenderSugestao(response.result.sugestao);
      });
    }

    /** Ação 76: piloto automático — executa a sugestão em loop, observável, com Parar. */
    private async labDmePilotoAutomatico() {
      if (!this.conectado) {
        toastr.warning("Plugin não conectado.", "Modo Execução Auto DME");
        return;
      }
      if (!this.labDmeContaId) return;

      const result = await swal.fire({
        title: 'Testar o piloto nesta conta?',
        html: `O planejador vai executar <b>1 passo por vez</b> (sugestão → executa → remapeia), continuar depois de cada alvo e parar quando o ciclo ficar sem sugestão ou atingir o teto de segurança de <b>150 passos</b>.<br/><small class="text-muted">Este teste não altera o modo salvo. Acompanhe cada decisão e use <b>■ Parar</b> para interromper.</small>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fb6340',
        confirmButtonText: 'Ligar piloto',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      this.labDmePilotoAtivo = true;
      $('.btn-lab-dme-resolver-linha').addClass('disabled');
      this.labDmeAppendProgresso(`<span class="text-muted">[${new Date().toLocaleTimeString()}]</span> 🤖 <b>Piloto automático ligado</b> (teto de segurança: 150 passos).`);
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LAB_PILOTO_AUTOMATICO, {
        id: this.labDmeContaId,
      }, (response: IRespostaMensagem) => {
        if (!response || !response.status) {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível ligar o piloto automático.";
          toastr.warning(msg, "Modo Execução Auto DME");
          this.labDmeAppendProgresso(`<div class="text-danger small">✖ ${msg}</div>`);
          this.labDmePilotoAtivo = false;
          $('.btn-lab-dme-resolver-linha').removeClass('disabled');
        }
      });
    }

    /** Aplica a sugestão inteligente de config no registro (ação 77) e remapeia. */
    private async labDmeAjustarConfigRegistro(e: JQueryEventObject) {
      if (!this.conectado) {
        toastr.warning("Plugin não conectado.", "Modo Execução Auto DME");
        return;
      }
      if (!this.labDmeContaId) return;
      const el = $(e.currentTarget);
      const idRegistro = Number(el.attr('data-id-registro'));
      const campo = String(el.attr('data-campo') || '');
      const rotulo = String(el.attr('data-rotulo') || campo);
      const nome = String(el.attr('data-nome') || '');
      let valor: any = null;
      try {
        valor = JSON.parse(String(el.attr('data-valor-sugerido')));
      } catch (err) {
        return;
      }
      if (!idRegistro || !campo) return;

      // Pergunta em linguagem humana: o campo do banco é "excluirEspeciais", então o valor
      // FALSE significa "usar cartas especiais". Mostrar "Usar cartas especiais → false"
      // dizia o oposto do que o clique faz.
      let tituloAjuste = 'Ajustar configuração do registro?';
      let descricaoAjuste = '';
      let valorTexto = $.isArray(valor) ? 'limpar lista' : String(valor);
      if (campo === 'excluirEspeciais') {
        const usarEspeciais = (valor === false);
        tituloAjuste = usarEspeciais ? 'Usar cartas especiais neste DME?' : 'Parar de usar cartas especiais neste DME?';
        valorTexto = usarEspeciais ? 'passa a USAR especiais' : 'passa a NÃO usar especiais';
        descricaoAjuste = usarEspeciais
          ? 'O solver continua priorizando cartas normais e só recorre às especiais quando precisa.'
          : 'As cartas especiais do clube deixam de entrar nas soluções deste DME.';
      } else if (campo === 'maximo_rating_carta_especial') {
        // Ajuste cirúrgico: abre a janela SÓ para especiais, sem soltar o rating geral.
        tituloAjuste = 'Permitir carta especial de overall mais alto neste DME?';
        valorTexto = Number(valor) > 0
          ? `cartas especiais passam a valer até ${valor} de overall`
          : 'volta a valer o rating máximo geral para as especiais';
        descricaoAjuste = Number(valor) > 0
          ? 'O rating máximo GERAL não muda: só as cartas especiais (TOTW/TOTS/FOF...) ganham essa folga. As comuns continuam limitadas como estão.'
          : '';
      } else if (campo === 'maximoRating' || campo === 'minimoRating') {
        tituloAjuste = 'Ajustar a faixa de rating deste DME?';
        valorTexto = `${rotulo} passa para ${valor}`;
      } else if ($.isArray(valor) && valor.length === 0) {
        tituloAjuste = `Limpar "${rotulo}" deste DME?`;
        valorTexto = 'a lista fica vazia (nada mais é excluído por ela)';
      }
      const result = await swal.fire({
        title: tituloAjuste,
        html: `<b>${nome}</b><br/>${valorTexto}<br/>${descricaoAjuste ? `<small>${descricaoAjuste}</small><br/>` : ''}<small class="text-muted">O ajuste é salvo no cadastro do Auto DME (PRO) e o mapa é recalculado em seguida.</small>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fb6340',
        confirmButtonText: 'Aplicar e remapear',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LAB_AJUSTAR_CONFIG_REGISTRO, { id: this.labDmeContaId, id_registro: idRegistro, campo, valor }, (response: IRespostaMensagem) => {
        if (!response || !response.status) {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível aplicar o ajuste.";
          toastr.warning(msg, "Modo Execução Auto DME");
          return;
        }
        toastr.success(`${rotulo} ajustado em "${nome}".`, "Modo Execução Auto DME");
        this.labDmeAppendProgresso(`<span class="text-muted">[${new Date().toLocaleTimeString()}]</span> ⚙ Config ajustada em <b>${nome}</b>: ${rotulo} → <b>${valorTexto}</b> (salvo no PRO). Remapeando...`);
        this.labDmeMapear();
      });
    }

    /** Modo manual interativo: resolve UM DME da linha do mapa; a conta permanece aberta entre cliques. */
    private labDmeResolverLinha(e: JQueryEventObject) {
      if (!this.conectado) {
        toastr.warning("Plugin não conectado.", "Modo Execução Auto DME");
        return;
      }
      if (!this.labDmeContaId) return;
      const el = $(e.currentTarget);
      if (el.hasClass('disabled')) return;
      const idRegistroRaw = el.attr('data-id-registro');
      const idRegistro = idRegistroRaw !== '' && idRegistroRaw != null ? Number(idRegistroRaw) : null;
      const idDme = Number(el.attr('data-id-dme'));
      const nome = String(el.attr('data-nome') || `DME ${idDme}`);
      // ↻ Resolver repetindo: o botão informa quantas vezes via data-vezes (default 1).
      const vezes = Math.max(1, Math.min(10, Number(el.attr('data-vezes')) || 1));
      if (!idDme) return;

      $('.btn-lab-dme-resolver-linha').addClass('disabled');
      this.labDmeAppendProgresso(`<span class="text-muted">[${new Date().toLocaleTimeString()}]</span> ▶ Resolvendo <b>${nome}</b>${vezes > 1 ? ` <b>${vezes}×</b> em sequência` : ''}... (a conta abre se necessário e permanece aberta)`);
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LAB_RESOLVER_DME_MAPA, {
        id: this.labDmeContaId,
        id_registro: idRegistro,
        id_dme: idDme,
        vezes: vezes,
      }, (response: IRespostaMensagem) => {
        if (!response || !response.status) {
          const msg = response && response.result && response.result.mensagem ? response.result.mensagem : "Não foi possível iniciar a resolução deste DME.";
          toastr.warning(msg, "Modo Execução Auto DME");
          this.labDmeAppendProgresso(`<div class="text-danger small">✖ ${msg}</div>`);
          $('.btn-lab-dme-resolver-linha').removeClass('disabled');
        }
      });
    }

    private labDmeAppendProgresso(html: string) {
      const container = $("#labDmeProgresso");
      container.append(`<div class="small">${html}</div>`);
      const linhas = container.children();
      if (linhas.length > 500) {
        linhas.slice(0, linhas.length - 500).remove();
      }
      const el = container.get(0);
      if (el) el.scrollTop = el.scrollHeight;
    }

    private tratarProgressoLaboratorioDme(request: any) {
      if (!$('#modalLaboratorioDme').hasClass('show')) return;
      if (!request || this.labDmeContaId == null || Number(request.idConta) !== Number(this.labDmeContaId)) return;
      const fase = String(request.fase || '');
      const hora = new Date().toLocaleTimeString();

      if (fase === 'inicio') {
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ▶ Sessão iniciada (até <b>${request.totalPassos || '?'}</b> execuções).`);
      } else if (fase === 'passo_inicio') {
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> <b>${request.conjuntoNome || ''}</b> ${request.repeticaoConjunto ? `(rodada ${request.repeticaoConjunto}/${request.repeticoesConjunto})` : ''} — passo ${request.passoIndex || '?'}/${request.totalPassos || '?'}: <b>${request.nome || request.setId}</b> ×${request.vezes || 1}...`);
      } else if (fase === 'passo_info') {
        if (request.motivo === 'colheita_parcial_somente_viaveis') {
          const quais = $.isArray(request.desafiosViaveis) ? request.desafiosViaveis.join(', ') : '';
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> &nbsp;&nbsp;↳ colheita parcial: só o(s) desafio(s) <b>${quais}</b> (os demais ficam de fora desta execução)`);
        } else if (request.detalhe) {
          // Emissões ricas (quarentena, bloqueio temporário, pulo fora da mesa) mandam o
          // texto legível em `detalhe`; antes só o slug de `motivo` aparecia.
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> &nbsp;&nbsp;↳ ${request.detalhe}`);
        } else if (request.motivo) {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> &nbsp;&nbsp;↳ ${request.motivo}`);
        }
      } else if (fase === 'passo_repeticao') {
        let detalhe = request.execucoesConcluidas != null ? `execução ${request.execucoesConcluidas}/${request.vezes || '?'}` : (request.motivo || 'progresso');
        if (request.motivo === 'save_recusado_retry') {
          detalhe = `save recusado${request.statusCode ? ` (${request.statusCode})` : ''}; tentativa ${request.tentativa || '?'}/${request.vezes || '?'} agendada`;
        } else if (request.motivo === 'desafio_enviado') {
          detalhe = 'desafio enviado com sucesso';
        }
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> &nbsp;&nbsp;↳ ${request.nome || ''}: ${detalhe}`);
      } else if (fase === 'passo_fim') {
        if (request.motivo === 'pulado_proximo_ja_viavel') {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ⏭ <b>${request.nome || request.setId}</b> — pulado (o próximo passo já está viável)`);
        } else if (request.motivo === 'ja_completo_sem_repeticao_hoje') {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ⏭ <b>${request.nome || request.setId}</b> — pulado (já concluído neste ciclo, sem repetição disponível)`);
        } else if (request.motivo === 'limite_solucoes_diarias') {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ⏭ <b>${request.nome || request.setId}</b> — pulado (limite de soluções deste DME no ciclo/dia já atingido)`);
        } else if (request.motivo === 'limite_repeats_totais') {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ⏭ <b>${request.nome || request.setId}</b> — pulado (todas as repetições totais deste DME já foram usadas)`);
        } else if (request.motivo === 'expirado') {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ⏭ <b>${request.nome || request.setId}</b> — pulado (DME expirado na EA)`);
        } else if (request.motivo === 'nao_disponivel_webapp') {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ⏭ <b>${request.nome || request.setId}</b> — pulado (DME não está disponível no WebApp)`);
        } else if (request.motivo === 'aguardando_todos_desafios_viaveis') {
          let faltouTodos = '';
          if ($.isArray(request.gaps) && request.gaps.length) {
            const descrs: string[] = [];
            request.gaps.forEach((g: any) => { if (g && g.descricao) descrs.push(String(g.descricao)); });
            if (descrs.length) faltouTodos = ` — falta: ${descrs.join(' · ')}`;
          }
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🔒 <b>${request.nome || request.setId}</b> — pulado (registro exige TODOS os desafios viáveis)${faltouTodos}`);
        } else if (request.motivo === 'sucesso_parcial') {
          // Parte das execuções concluiu (insumo entrou no clube); só o restante falhou.
          let linhaParcial = `<span class="text-muted">[${hora}]</span> <span class="text-warning">◕</span> <b>${request.nome || request.setId}</b> — sucesso PARCIAL: concluiu <b>${request.execucoesConcluidas || 1}</b> execução(ões), o restante não achou solução`;
          if ($.isArray(request.gaps) && request.gaps.length) {
            const faltasP: string[] = [];
            request.gaps.forEach((g: any) => { if (g && g.descricao) faltasP.push(String(g.descricao)); });
            if (faltasP.length) linhaParcial += `<div class="text-warning" style="margin-left: 22px;">faltou p/ continuar: ${faltasP.join(' · ')}</div>`;
          }
          this.labDmeAppendProgresso(linhaParcial);
        } else {
          const icone = request.completo ? '<span class="text-success">✔</span>' : '<span class="text-danger">✖</span>';
          // `0 || 1` mentia "1 execução" em passos que não executaram nada — só assume 1
          // quando o campo realmente não veio no evento.
          const execsConcluidas = request.execucoesConcluidas != null ? request.execucoesConcluidas : 1;
          let linhaPasso = `<span class="text-muted">[${hora}]</span> ${icone} <b>${request.nome || request.setId}</b> — ${request.completo ? `concluído (${execsConcluidas} execução(ões))` : `falhou (${request.motivo || 'sem detalhe'})`}`;
          if (!request.completo && $.isArray(request.gaps) && request.gaps.length) {
            const faltas: string[] = [];
            request.gaps.forEach((g: any) => { if (g && g.descricao) faltas.push(String(g.descricao)); });
            if (faltas.length) {
              linhaPasso += `<div class="text-warning" style="margin-left: 22px;">faltou: ${faltas.join(' · ')}</div>`;
            }
          }
          this.labDmeAppendProgresso(linhaPasso);
        }
      } else if (fase === 'mapa') {
        this.labDmeRenderMapa({ registros: request.mapa, avisos: [], catalogo: { disponivel: true, qtdDmes: (request.mapa || []).length }, clube: { disponivel: true, totalJogadores: '-' }, geradoEm: 'ao vivo (' + hora + ')' });
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🗺 Mapa de viabilidade atualizado com as novas cartas.`);
      } else if (fase === 'conjunto_fim') {
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ■ <b>${request.conjuntoNome || 'Conjunto'}</b> finalizado.`);
      } else if (fase === 'piloto_sugestao') {
        const s = request.sugestao || {};
        this.labDmeRenderSugestao(s);
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🤖 <b>Piloto (passo ${request.passoPiloto || '?'}/${request.totalPassosPiloto || '?'})</b>: ${s.tipo === 'executar_alvo' ? '🎯 colher alvo' : 'preparar com'} <b>${s.nome || s.setId}</b> — <span class="text-muted">${s.motivo || ''}</span>`);
      } else if (fase === 'piloto_alvo_colhido') {
        // Marco no meio do voo (o piloto CONTINUA até o ciclo esgotar): celebra sem parar.
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🤖 <b class="text-success">🎯 Alvo colhido: ${request.nome || request.setId}</b> (${request.alvosColhidos || 1}º do voo) — o piloto segue para o próximo passo.`);
      } else if (fase === 'piloto_revisando_exclusoes') {
        const sRevisao = request.sugestao || {};
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> ↻ Exclusões temporárias revisadas; <b>${sRevisao.nome || sRevisao.setId}</b> voltou a ser candidato.`);
      } else if (fase === 'piloto_fim') {
        const motivoPiloto = String(request.motivo || 'fim');
        const rotulos: any = {
          sem_sugestao: '✅ Ciclo esgotado — sem mais sugestões (fim natural do dia).',
          sem_sugestao_nao_comprovada: '⚠ O mapa não encontrou sugestão, mas os snapshots atuais não permitiram comprovar o esgotamento.',
          teto_de_passos: '⏸ Teto de passos por sessão atingido — nada foi descartado; a conta continua o restante na próxima abertura.',
          falhas_consecutivas_temporario: '🚨 Falhas temporárias seguidas — rede, navegador ou solver; o ciclo não foi declarado esgotado.',
          sem_progresso_temporario: '⚠ Rodadas seguidas sem progresso; execução pausada sem declarar o ciclo esgotado.',
          snapshot_dmes_indisponivel: '⚠ Não foi possível confirmar a lista atual de DMEs; execução pausada temporariamente.',
          snapshot_pool_indisponivel: '⚠ Não foi possível confirmar o clube atual; execução pausada temporariamente.',
          estado_ciclo_inconsistente: '⚠ O mapa ainda sugere uma fonte que atingiu o teto de segurança; estado do ciclo precisa ser revisto.',
          parado_pelo_usuario: 'Parado pelo usuário.',
          sessao_em_uso_por_outra_tarefa: 'Sessão ocupada por outra tarefa.',
          sessao_ea_expirada: '🔐 Sessão EA expirada (401 em sequência) — o ciclo foi interrompido; a conta fecha e continua na próxima abertura.',
        };
        const rotulo = rotulos[motivoPiloto] || motivoPiloto;
        const fimBom = motivoPiloto === 'sem_sugestao';
        const alvosResumo = request.alvosColhidos != null ? ` · alvos colhidos: ${request.alvosColhidos}` : '';
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🤖 <b class="text-${fimBom ? 'success' : 'warning'}">Piloto finalizado após ${request.passoPiloto || 0} passo(s)${alvosResumo}: ${rotulo}</b>${request.mensagem ? ` — ${request.mensagem}` : ''}`);
        toastr[fimBom ? 'success' : 'warning'](`Piloto finalizado: ${rotulo}`, "Modo Execução Auto DME");
        this.labDmePilotoAtivo = false;
        $('.btn-lab-dme-resolver-linha').removeClass('disabled');
        this.labDmeMapear();
      } else if (fase === 'piloto_conjunto_inicio') {
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🧠 <b>Ordem inteligente</b> — o Piloto vai escolher a ordem e a quantidade rumo ao 🎯 alvo (só com os DMEs deste conjunto).`);
      } else if (fase === 'piloto_conjunto_sugestao') {
        const sConj = request.sugestao || {};
        const rotuloAcao = request.semAlvoForcado
          ? '▶ rodar viável (alvo não acionável)'
          : (sConj.tipo === 'executar_alvo' ? '🎯 colher alvo' : 'preparar com');
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🧠 Piloto: ${rotuloAcao} <b>${sConj.nome || sConj.setId}</b>${sConj.motivo ? ` <span class="text-muted">— ${sConj.motivo}</span>` : ''}`);
      } else if (fase === 'piloto_conjunto_fim') {
        if (request.alvoJaCompleto) {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🧠 <b>Ordem inteligente</b>: 🎯 alvo já concluído neste ciclo — nada a fazer neste conjunto (renova na virada diária da EA).`);
        } else {
          this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> 🧠 <b>Ordem inteligente</b> finalizada (${request.execucoes || 0} execução(ões)${request.alvoColhido ? ', 🎯 alvo colhido' : ''}).`);
        }
      } else if (fase === 'concluido' || fase === 'erro') {
        const resumo = request.resumo || {};
        const cor = fase === 'concluido' ? 'success' : 'danger';
        const titulo = fase === 'concluido' ? 'Execução concluída' : `Execução encerrada (${request.motivo || 'erro'})`;
        this.labDmeAppendProgresso(`<span class="text-muted">[${hora}]</span> <b class="text-${cor}">${titulo}</b>${request.mensagem ? ` — ${request.mensagem}` : ''}`);
        let falhasHtml = '';
        if ($.isArray(resumo.falhas) && resumo.falhas.length) {
          const linhasFalhas: string[] = [];
          resumo.falhas.forEach((f: any) => {
            let linhaF = `• <b>${f.nome || f.setId}</b> <span class="text-muted">(${f.conjuntoNome || 'conjunto ' + f.conjuntoIndex} · rodada ${f.repeticaoConjunto} · passo ${f.passoIndex})</span> — ${f.motivo || 'sem motivo'}`;
            if ($.isArray(f.gaps) && f.gaps.length) {
              const faltasF: string[] = [];
              f.gaps.forEach((g: any) => { if (g && g.descricao) faltasF.push(String(g.descricao)); });
              if (faltasF.length) linhaF += `<div class="text-muted" style="margin-left: 14px;">faltou: ${faltasF.join(' · ')}</div>`;
            }
            linhasFalhas.push(`<div class="small mt-1">${linhaF}</div>`);
          });
          falhasHtml = `<div class="mt-2 pt-2 border-top"><b>⚠ O que quebrou a sequência:</b>${linhasFalhas.join('')}</div>`;
        }
        $("#labDmeResumoExecucao").html(`
          <div class="alert alert-${cor === 'success' ? 'success' : 'warning'} small mb-0">
            <b>${titulo}.</b>
            Passos: <b>${resumo.passosExecutados || 0}</b> · Sucesso: <b>${resumo.passosComSucesso || 0}</b> ·
            Falha: <b>${resumo.passosComFalha || 0}</b> · Pulados: <b>${resumo.passosPulados || 0}</b> ·
            Execuções de DME: <b>${resumo.execucoesDesafio || 0}</b>
            ${falhasHtml}
            <div class="mt-1">Clique em <b>Mapear agora</b> para conferir os novos viáveis com as cartas recebidas.</div>
          </div>`);
        if (!this.labDmePilotoAtivo) {
          $('.btn-lab-dme-resolver-linha').removeClass('disabled');
        }
        if (fase === 'concluido') {
          // Remapeia automaticamente com as cartas novas (ação 72, sem navegador — barato).
          this.labDmeMapear();
        }
      }
    }

    private async aoResetarTentativasAutoDmeContas(e: JQueryEventObject) {
      e.preventDefault();
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Reset Auto DME");
        return;
      }

      const ids = this.getIdsContasSelecionadas();
      if (!ids || !ids.length) {
        toastr.warning("Selecione uma ou mais contas.", "Reset Auto DME");
        return;
      }

      const result = await swal.fire({
        title: 'Resetar tentativas Auto DME?',
        text: `Isso remove falhas/tentativas abertas do ciclo EA atual em ${ids.length} conta(s) selecionada(s) e recoloca DMEs bloqueados na fila quando possivel. Sucessos ja registrados continuam preservados.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2dce89',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, resetar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      $("#modalAcoesContas").modal("hide");
      Util.exibirModalPaginaCarregando();
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_RESETAR_TENTATIVAS_AUTO_DME_CONTA, { ids }, (response: IRespostaMensagem) => {
        Util.ocultarModalPaginaCarregando();
        if (!response || !response.status) {
          const msgErro = response && response.result && response.result.mensagem
            ? response.result.mensagem
            : "Nao foi possivel resetar as tentativas Auto DME das contas selecionadas.";
          toastr.warning(msgErro, "Atencao");
          return;
        }

        const resultado: any = response.result || {};
        const removidos = typeof resultado.removidos !== "undefined"
          ? Number(resultado.removidos) || 0
          : 0;
        const contasAtualizadas = $.isArray(resultado.contasAtualizadas)
          ? resultado.contasAtualizadas
          : (resultado.contaAtualizada ? [resultado.contaAtualizada] : []);
        $.each(contasAtualizadas, (_idx: number, contaAtualizada: IConta) => {
          if (contaAtualizada) {
            this.updateContaDatatable(contaAtualizada);
          }
        });

        const contasSnapshotLimpo = $.isArray(resultado.contasSnapshotLimpo)
          ? resultado.contasSnapshotLimpo
          : (resultado.snapshotLimpo ? [ids[0]] : []);
        const falhas = $.isArray(resultado.falhas) ? resultado.falhas : [];
        const contasProcessadas = typeof resultado.contasProcessadas !== "undefined"
          ? Number(resultado.contasProcessadas) || 0
          : contasAtualizadas.length;

        let msgSnapshot = "";
        if (contasSnapshotLimpo.length) {
          msgSnapshot = ` Snapshot Auto DME limpo em ${contasSnapshotLimpo.length} conta(s) para reextrair os DMEs na proxima abertura/tarefa.`;
        } else {
          msgSnapshot = " DMEs bloqueados voltam para a fila quando elegiveis.";
        }
        toastr.success(`${removidos} tentativa(s) falha(s)/aberta(s) removida(s) em ${contasProcessadas} conta(s).${msgSnapshot}`, "Reset concluido");
        if (falhas.length) {
          toastr.warning(`${falhas.length} conta(s) nao puderam ser resetadas.`, "Reset parcial");
        }

        const modal = $("#modalContaDiagnostico");
        if (ids.length === 1 && modal.length && modal.is(":visible")) {
          this.prepararEstadoAutoDmeModal(modal);
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_ESTADO_AUTO_DME_CONTA, { id: ids[0] }, (respEstado: IRespostaMensagem) => {
            if (respEstado && respEstado.status && respEstado.result) {
              this.diagnosticoContaTarefasAtual = respEstado.result;
              this.renderizarEstadoAutoDmeModal(modal, this.diagnosticoContaTarefasAtual);
            }
          });
        }
      });
    }

    private aoTrocarAbaDiagnosticoTarefa(e: JQueryEventObject) {
      e.preventDefault();
      const alvo = $(e.currentTarget);
      const tarefa = alvo.data("tarefa");
      if (!this.diagnosticoContaTarefasAtual || !tarefa) return;
      $("#modalContaDiagnostico").find(".js-tab-diagnostico-tarefa").removeClass("active");
      alvo.addClass("active");
      this.renderizarPainelDiagnosticoTarefa($("#modalContaDiagnostico"), tarefa, this.diagnosticoContaTarefasAtual);
    }

    private prepararEstadoAutoDmeModal(modal: JQuery) {
      this.diagnosticoContaTarefasAtual = null;
      modal.find(".js-conta-diagnostico-loading").show();
      modal.find(".js-conta-diagnostico-erro").hide().html("");
      modal.find(".js-conta-diagnostico-conteudo").hide();
      modal.find(".js-conta-diagnostico-data-consulta").html("-");
      modal.find(".js-tab-diagnostico-tarefa").removeClass("active");
      modal.find(".js-tab-diagnostico-tarefa[data-tarefa='autoDme']").addClass("active");
      modal.find(".js-estado-tarefa-pool-forragens-wrap").hide();
      modal.find(".js-estado-tarefa-pool-forragens-body").html("");
      modal.find(".js-estado-tarefa-monitor-sniper-wrap").hide();
      modal.find(".js-estado-tarefa-scheduler-sniper-wrap").hide();
      modal.find(".js-sniper-scheduler-slots-wrap").hide();
      modal.find(".js-sniper-scheduler-slots-body").html("");
    }

    private exibirErroEstadoAutoDmeModal(modal: JQuery, mensagem: string) {
      modal.find(".js-conta-diagnostico-loading").hide();
      modal.find(".js-conta-diagnostico-conteudo").hide();
      modal.find(".js-conta-diagnostico-erro").show().html(mensagem);
    }

    private renderizarEstadoAutoDmeModal(modal: JQuery, dados: any) {
      modal.find(".js-conta-diagnostico-loading").hide();
      modal.find(".js-conta-diagnostico-erro").hide().html("");
      modal.find(".js-conta-diagnostico-conteudo").show();

      const autoDmeDados = dados && dados.tarefas && dados.tarefas.autoDme ? dados.tarefas.autoDme : dados;
      const elegivel = !!autoDmeDados.elegivel;
      let emailConta = "-";
      let nomeConta = "-";
      if (dados.conta) {
        if (dados.conta.nome) {
          nomeConta = dados.conta.nome;
        }
        if (dados.conta.email) {
          emailConta = dados.conta.email;
        } else if (dados.conta.id) {
          emailConta = `#${dados.conta.id}`;
        }
      }
      modal.find(".js-conta-diagnostico-conta-nome").html(nomeConta);
      modal.find(".js-conta-diagnostico-conta-email").html(emailConta);

      const podeCompleto = typeof autoDmeDados.podeExecutarTarefaAutoDmeCompleto !== "undefined" ? !!autoDmeDados.podeExecutarTarefaAutoDmeCompleto : elegivel;
      let hint = "";
      if (typeof autoDmeDados.tarefaAutoDmePodeRodarNoPlugin !== "undefined" && !autoDmeDados.tarefaAutoDmePodeRodarNoPlugin && elegivel) {
        hint = "A tarefa Auto DME esta bloqueada nas configuracoes globais do plugin (limite, intervalo ou throttle), apesar do perfil desta conta.";
      } else if (typeof autoDmeDados.tarefaAutoDmePodeRodarNoPlugin !== "undefined" && autoDmeDados.tarefaAutoDmePodeRodarNoPlugin && !elegivel) {
        hint = "O plugin permitiria a tarefa, mas esta conta nao atende as regras do perfil ou da fila.";
      }
      modal.find(".js-conta-diagnostico-badge")
        .removeClass("badge-success badge-danger")
        .addClass(podeCompleto ? "badge-success" : "badge-danger")
        .html(podeCompleto ? "Pode executar Auto DME agora" : "Nao pode executar Auto DME agora");
      modal.find(".js-conta-diagnostico-hint").html(hint ? hint : "&nbsp;");

      modal.find(".js-conta-diagnostico-data-consulta").html(this.formatarDataEstadoAutoDme(
        (dados && dados.dataConsulta) ? dados.dataConsulta : null
      ));
      this.renderizarPainelDiagnosticoTarefa(modal, "autoDme", dados);
    }

    private atualizarCabecalhoDiagnosticoTarefa(modal: JQuery, tarefa: string, dados: any) {
      let ok = !!dados.elegivel;
      let texto = ok ? "Pode executar agora" : "Nao pode executar agora";
      let hint = "";
      let classe = ok ? "badge-success" : "badge-danger";

      if (tarefa == "autoDme") {
        const podeCompleto = typeof dados.podeExecutarTarefaAutoDmeCompleto !== "undefined" ? !!dados.podeExecutarTarefaAutoDmeCompleto : !!dados.elegivel;
        ok = podeCompleto;
        texto = podeCompleto ? "Pode executar Auto DME agora" : "Nao pode executar Auto DME agora";
        classe = podeCompleto ? "badge-success" : "badge-danger";
        if (typeof dados.tarefaAutoDmePodeRodarNoPlugin !== "undefined" && !dados.tarefaAutoDmePodeRodarNoPlugin && dados.elegivel) {
          hint = "A tarefa Auto DME esta bloqueada nas configuracoes globais do plugin (limite, intervalo ou throttle), apesar do perfil desta conta.";
        } else if (typeof dados.tarefaAutoDmePodeRodarNoPlugin !== "undefined" && dados.tarefaAutoDmePodeRodarNoPlugin && !dados.elegivel) {
          hint = "O plugin permitiria a tarefa, mas esta conta nao atende as regras do perfil ou da fila.";
        }
      } else if (tarefa == "sniper") {
        const monitoramento = dados.monitoramento || null;
        if (monitoramento) {
          ok = monitoramento.falhaReal !== true;
          texto = monitoramento.falhaReal ? "Falha real no Sniper automatico" : "Monitor Sniper sem falha real";
          classe = monitoramento.falhaReal ? "badge-danger" : (monitoramento.estadoFinal === "bloqueio_legitimo" ? "badge-warning" : "badge-success");
          hint = monitoramento.motivoAtual || monitoramento.motivo || "";
        } else {
          const scheduler = dados.scheduler || null;
          if (scheduler) {
            ok = scheduler.podeIniciarAgora === true;
            const motivo = scheduler.motivoBloqueioScheduler || null;
            if (ok) {
              texto = "Conta pode iniciar Sniper agora";
              classe = "badge-success";
            } else if (motivo === "aguardando_prioridade_fila") {
              texto = "Conta OK, mas ha outras contas antes na fila";
              classe = "badge-warning";
            } else if (motivo === "cap_sniper_cheio" || motivo === "partilha_desligada_vaga_dme_ociosa" || motivo === "partilha_ligada_auto_dme_tem_fila_protegida") {
              texto = "Conta OK, mas cap Sniper esta cheio";
              classe = "badge-danger";
            } else if (motivo === "possivel_slot_sniper_preso") {
              texto = scheduler.slotSniperSemTimer ? "Possivel slot Sniper sem timer" : "Possivel slot Sniper preso";
              classe = "badge-warning";
            } else {
              texto = "Sniper nao inicia agora";
              classe = "badge-danger";
            }
            hint = scheduler.resumo || "";
          } else {
            texto = dados.elegivel ? "Conta elegivel para Sniper" : "Conta nao elegivel para Sniper";
            classe = dados.elegivel ? "badge-success" : "badge-danger";
          }
        }
      } else if (tarefa == "vendaCoins") {
        texto = dados.elegivel ? "Pode executar Venda Coins agora" : "Nao pode executar Venda Coins agora";
        classe = dados.elegivel ? "badge-success" : "badge-danger";
      }

      modal.find(".js-conta-diagnostico-badge")
        .removeClass("badge-success badge-danger badge-warning badge-info")
        .addClass(classe)
        .html(texto);
      modal.find(".js-conta-diagnostico-hint").html(hint ? this.escapeHtmlEstadoDme(hint) : "&nbsp;");
    }

    private renderizarPainelDiagnosticoTarefa(modal: JQuery, tarefa: string, payload: any) {
      const tarefas = payload && payload.tarefas ? payload.tarefas : { autoDme: payload };
      let dados = tarefas[tarefa] || {};
      this.atualizarCabecalhoDiagnosticoTarefa(modal, tarefa, dados);
      let labels = {
        m1: "Métrica 1", m2: "Métrica 2", m3: "Métrica 3",
        t1: "Tempo 1", t2: "Tempo 2", extra: "Extra"
      };
      let v1: any = 0, v2: any = 0, v3: any = 0, tv1: any = "-", tv2: any = "-", extra: any = "-";

      if (tarefa == "autoDme") {
        const elegTab = !!dados.elegivel;
        let hintTab = "";
        if (typeof dados.tarefaAutoDmePodeRodarNoPlugin !== "undefined" && !dados.tarefaAutoDmePodeRodarNoPlugin && elegTab) {
          hintTab = "A tarefa Auto DME esta bloqueada nas configuracoes globais do plugin (limite, intervalo ou throttle), apesar do perfil desta conta.";
        } else if (typeof dados.tarefaAutoDmePodeRodarNoPlugin !== "undefined" && dados.tarefaAutoDmePodeRodarNoPlugin && !elegTab) {
          hintTab = "O plugin permitiria a tarefa, mas esta conta nao atende as regras do perfil ou da fila.";
        }
        modal.find(".js-conta-diagnostico-hint").html(hintTab || "&nbsp;");
        labels = {
          m1: "DMEs (ciclo EA)", m2: "Tentativas (ciclo EA)", m3: "Desafios (ciclo EA)",
          t1: "Minutos desde ultimo envio", t2: "Ultima execucao auto dme", extra: "Ultimo desafio especifico executado"
        };
        const md = dados.metricasDia || dados.metricas24h;
        v1 = (md && typeof md.quantidadeDMEsHoje !== "undefined") ? md.quantidadeDMEsHoje
          : (md && typeof md.quantidadeDMEsUltimas24Horas !== "undefined") ? md.quantidadeDMEsUltimas24Horas : 0;
        v2 = (md && typeof md.quantidadeTentativasHoje !== "undefined") ? md.quantidadeTentativasHoje
          : (md && typeof md.quantidadeTentativasUltimas24Horas !== "undefined") ? md.quantidadeTentativasUltimas24Horas : 0;
        v3 = (md && typeof md.quantidadeDesafiosDMEsHoje !== "undefined") ? md.quantidadeDesafiosDMEsHoje
          : (md && typeof md.quantidadeDesafiosDMEsUltimas24Horas !== "undefined") ? md.quantidadeDesafiosDMEsUltimas24Horas : 0;

        let minutosUltimoDme = "-";
        if (dados.tempo && typeof dados.tempo.minutosCorridosUltimoDmeEnviadoPorConta !== "undefined" && dados.tempo.minutosCorridosUltimoDmeEnviadoPorConta !== null) {
          minutosUltimoDme = dados.tempo.minutosCorridosUltimoDmeEnviadoPorConta;
        }
        tv1 = `${minutosUltimoDme} min`;

        let ultimaExecucaoAutoDmeConta = "-";
        if (dados.tempo && typeof dados.tempo.ultimaExecucaoAutoDmeConta !== "undefined" && dados.tempo.ultimaExecucaoAutoDmeConta !== null) {
          ultimaExecucaoAutoDmeConta = this.formatarDataEstadoAutoDme(dados.tempo.ultimaExecucaoAutoDmeConta);
        }
        tv2 = ultimaExecucaoAutoDmeConta;

        let desafio = null;
        if (dados.tempo && typeof dados.tempo.ultimaExecucaoDesafioEspecifico !== "undefined" && dados.tempo.ultimaExecucaoDesafioEspecifico !== null) {
          desafio = dados.tempo.ultimaExecucaoDesafioEspecifico;
        }
        if (desafio && desafio.createdAt) {
          extra = `DME #${typeof desafio.idDme !== "undefined" && desafio.idDme !== null ? desafio.idDme : "-"} em ${this.formatarDataEstadoAutoDme(desafio.createdAt)}`;
        } else {
          extra = "-";
        }
        // Softban de ENVIO de desafio (DME) reativo: sinal durável (o badge da lista some ao abrir p/ sniper).
        if (dados.tempo && dados.tempo.softbanDmeReativo === true && dados.tempo.softbanDmeOcorridoEm) {
          extra = `⛔ Softban DME desde ${this.formatarDataEstadoAutoDme(dados.tempo.softbanDmeOcorridoEm)} · ${extra}`;
        }
      } else if (tarefa == "vendaCoins") {
        labels = {
          m1: "Cartas transferidas hoje", m2: "Coins atuais", m3: "Elegibilidade",
          t1: "Minutos desde ultima venda", t2: "Ultima execucao", extra: "Limite cartas dia"
        };
        v1 = (dados.metricas24h && typeof dados.metricas24h.totalCartasTransferidasHoje !== "undefined") ? dados.metricas24h.totalCartasTransferidasHoje : 0;
        let coinsStr = "0";
        if (dados.limites && typeof dados.limites.coins !== "undefined" && dados.limites.coins !== null) {
          coinsStr = String(dados.limites.coins).split(" ")[0];
        }
        v2 = Number(coinsStr) || 0;
        v3 = dados.elegivel ? "OK" : "BLOQ";

        let minutosUltimaVenda = "-";
        if (dados.tempo && typeof dados.tempo.minutosCorridosUltimaVendaCoins !== "undefined" && dados.tempo.minutosCorridosUltimaVendaCoins !== null) {
          minutosUltimaVenda = dados.tempo.minutosCorridosUltimaVendaCoins;
        }
        tv1 = `${minutosUltimaVenda} min`;

        let ultimaExecucaoVendaCoinsConta = "-";
        if (dados.tempo && typeof dados.tempo.ultimaExecucaoVendaCoinsConta !== "undefined" && dados.tempo.ultimaExecucaoVendaCoinsConta !== null) {
          ultimaExecucaoVendaCoinsConta = this.formatarDataEstadoAutoDme(dados.tempo.ultimaExecucaoVendaCoinsConta);
        }
        tv2 = ultimaExecucaoVendaCoinsConta;

        if (dados.limites && typeof dados.limites.cartasTransferidasDia !== "undefined" && dados.limites.cartasTransferidasDia !== null) {
          extra = dados.limites.cartasTransferidasDia;
        } else {
          extra = "-";
        }
      } else if (tarefa == "sniper") {
        labels = {
          m1: "Requests hoje", m2: "Status conta", m3: "Elegibilidade",
          t1: "Ultima execucao", t2: "Softban ocorrido", extra: "Janela limite tarefa"
        };
        v1 = (dados.metricas24h && typeof dados.metricas24h.requestsHoje !== "undefined") ? dados.metricas24h.requestsHoje : 0;
        let contaStatus = "-";
        if (payload && payload.conta && typeof payload.conta.status !== "undefined" && payload.conta.status !== null) {
          contaStatus = payload.conta.status;
        }
        v2 = contaStatus;
        v3 = dados.elegivel ? "OK" : "BLOQ";

        let ultimaExecucaoSniperConta = "-";
        if (dados.tempo && typeof dados.tempo.ultimaExecucaoSniperConta !== "undefined" && dados.tempo.ultimaExecucaoSniperConta !== null) {
          ultimaExecucaoSniperConta = this.formatarDataEstadoAutoDme(dados.tempo.ultimaExecucaoSniperConta);
        }
        tv1 = ultimaExecucaoSniperConta;

        let softbanOcorridoEm = "-";
        if (dados.tempo && typeof dados.tempo.softbanOcorridoEm !== "undefined" && dados.tempo.softbanOcorridoEm !== null) {
          softbanOcorridoEm = this.formatarDataEstadoAutoDme(dados.tempo.softbanOcorridoEm);
        }
        tv2 = softbanOcorridoEm;

        if (dados.limites && typeof dados.limites.limiteUltimaExecucao !== "undefined" && dados.limites.limiteUltimaExecucao !== null) {
          extra = this.formatarDataEstadoAutoDme(dados.limites.limiteUltimaExecucao);
        } else {
          extra = "-";
        }
      }

      modal.find(".js-estado-tarefa-metrica1-label").html(labels.m1);
      modal.find(".js-estado-tarefa-metrica2-label").html(labels.m2);
      modal.find(".js-estado-tarefa-metrica3-label").html(labels.m3);
      modal.find(".js-estado-tarefa-tempo1-label").html(labels.t1);
      modal.find(".js-estado-tarefa-tempo2-label").html(labels.t2);
      modal.find(".js-estado-tarefa-extra-label").html(labels.extra);

      modal.find(".js-estado-tarefa-metrica1-valor").html(String(v1).toLocaleString ? (typeof v1 === "number" ? v1.toLocaleString("pt-BR") : String(v1)) : String(v1));
      modal.find(".js-estado-tarefa-metrica2-valor").html(typeof v2 === "number" ? v2.toLocaleString("pt-BR") : String(v2));
      modal.find(".js-estado-tarefa-metrica3-valor").html(typeof v3 === "number" ? v3.toLocaleString("pt-BR") : String(v3));
      modal.find(".js-estado-tarefa-tempo1-valor").html(String(tv1));
      modal.find(".js-estado-tarefa-tempo2-valor").html(String(tv2));
      modal.find(".js-estado-tarefa-extra-valor").html(String(extra));

      const regras: any[] = Array.isArray(dados.diagnostico) ? dados.diagnostico : [];
      let htmlRegras = `<div class="text-muted font-size-12">Sem regras avaliadas.</div>`;
      if (regras.length) {
        htmlRegras = `
          <div class="row">
            ${regras.map((regra: any) => {
          const classe = regra.ok ? "success" : "danger";
          const titulo = regra.ok ? "OK" : "BLOQUEADA";
          return `
            <div class="col-12 col-md-6 mb-2">
              <div class="alert alert-${classe} py-2 px-3 mb-0 h-100">
                <div class="d-flex justify-content-between align-items-start flex-wrap">
                  <span class="font-weight-600 pr-2">${typeof regra.chave !== "undefined" && regra.chave !== null ? regra.chave : "regra"}</span>
                  <span class="badge badge-${classe} flex-shrink-0">${titulo}</span>
                </div>
                <div class="font-size-12 mt-2 pt-2 border-top">${typeof regra.motivo !== "undefined" && regra.motivo !== null ? regra.motivo : "-"}</div>
              </div>
            </div>
          `;
        }).join("")}
          </div>`;
      }
      modal.find(".js-estado-tarefa-regras").html(htmlRegras);

      if (tarefa == "sniper") {
        this.renderizarMonitorSniperDiagnostico(modal, dados.monitoramento || null);
        this.renderizarSchedulerSniperDiagnostico(modal, dados.scheduler || null);
      } else {
        modal.find(".js-estado-tarefa-monitor-sniper-wrap").hide();
        modal.find(".js-estado-tarefa-scheduler-sniper-wrap").hide();
        modal.find(".js-sniper-scheduler-slots-wrap").hide();
        modal.find(".js-sniper-scheduler-slots-body").html("");
      }

      if (tarefa == "autoDme") {
        this.renderizarLimitesAutoDmeDiagnostico(modal, dados);
        const contaDiag = this.diagnosticoContaTarefasAtual && this.diagnosticoContaTarefasAtual.conta
          ? this.diagnosticoContaTarefasAtual.conta
          : null;
        const dmesConta: IDmeContaItem[] = (contaDiag && Array.isArray(contaDiag.dmes)) ? contaDiag.dmes : [];
        const mdTab = dados.metricasDia || dados.metricas24h;
        const detalhesDme = (mdTab && mdTab.detalhesPorDmeHoje) ? mdTab.detalhesPorDmeHoje
          : (mdTab && mdTab.detalhesPorDme24h) ? mdTab.detalhesPorDme24h : [];
        this.renderizarTabelaUnificadaDmesAutoDme(modal, dados.selecaoDmePorPrioridade || null, detalhesDme, dmesConta, dados);
        this.renderizarPoolForragensAutoDme(modal, dados);
        this.renderizarRegrasAplicadasAutoDme(modal, dados);
        this.renderizarEventosAutoDmeRecentes(modal, dados);
      } else {
        modal.find(".js-conta-diagnostico-limites-globais-wrap").hide();
        modal.find(".js-conta-diagnostico-limites-conta-wrap").hide();
        modal.find(".js-estado-tarefa-dmes-unificados-container").hide();
        modal.find(".js-estado-tarefa-dmes-unificados-body").html("");
        modal.find(".js-estado-tarefa-pool-forragens-wrap").hide();
        modal.find(".js-estado-tarefa-pool-forragens-body").html("");
        modal.find(".js-estado-tarefa-regras-aplicadas-wrap").hide();
        modal.find(".js-estado-tarefa-eventos-autodme-wrap").hide();
      }
    }

    private formatarIdadeSlotScheduler(ms: any): string {
      const valor = Number(ms);
      if (!Number.isFinite(valor) || valor < 0) return "-";
      if (valor >= 3600000) return `${Math.floor(valor / 3600000)}h ${Math.floor((valor % 3600000) / 60000)}min`;
      if (valor >= 60000) return `${Math.floor(valor / 60000)}min`;
      return `${Math.max(0, Math.floor(valor / 1000))}s`;
    }

    private renderizarMonitorSniperDiagnostico(modal: JQuery, monitoramento: any) {
      const wrap = modal.find(".js-estado-tarefa-monitor-sniper-wrap");
      if (!monitoramento) {
        wrap.hide();
        return;
      }

      wrap.show();
      const contaApta = monitoramento.existeContaAptaAgora === true
        ? `<span class="text-success">Sim (${monitoramento.contasAptas || 0}/${monitoramento.totalContas || 0})</span>`
        : `<span class="text-danger">Nao</span>`;
      const estadoClasse = monitoramento.falhaReal
        ? "text-danger"
        : (monitoramento.estadoFinal === "bloqueio_legitimo" ? "text-warning" : "text-success");
      const estadoTexto = monitoramento.falhaReal
        ? "Falha real"
        : (monitoramento.estadoFinal === "bloqueio_legitimo" ? "Bloqueio legitimo" : "Normal");
      const motivo = monitoramento.motivoAtual || monitoramento.motivo || "-";
      const conta = monitoramento.contaAptaExemplo
        ? `${monitoramento.contaAptaExemplo.clube || "-"} (${monitoramento.contaAptaExemplo.email || monitoramento.contaAptaExemplo.id || "-"})`
        : "-";
      const candidatoScheduler = monitoramento.ultimoSinalScheduler && monitoramento.ultimoSinalScheduler.ultimaContaCandidata
        ? (monitoramento.ultimoSinalScheduler.ultimaContaCandidata.email || monitoramento.ultimoSinalScheduler.ultimaContaCandidata.id || "-")
        : "-";
      const slotSemTimer = monitoramento.schedulerIndicaSlotSniperSemTimer === true
        || (monitoramento.ultimoSinalScheduler && monitoramento.ultimoSinalScheduler.possivel_slot_sniper_sem_timer === true);
      const falhaConcorrente = monitoramento.ultimaFalhaTarefaConcorrente
        ? `${monitoramento.ultimaFalhaTarefaConcorrente.tipo || "-"}: ${monitoramento.ultimaFalhaTarefaConcorrente.motivo || "-"}`
        : "-";

      modal.find(".js-sniper-monitor-conta-apta").html(contaApta);
      modal.find(".js-sniper-monitor-sem-inicio").html(`${monitoramento.minutosSemInicioReal != null ? monitoramento.minutosSemInicioReal : "-"} min`);
      modal.find(".js-sniper-monitor-sem-timer").html(`${monitoramento.minutosSemTimerAtivo != null ? monitoramento.minutosSemTimerAtivo : "-"} min`);
      modal.find(".js-sniper-monitor-estado").html(`<span class="${estadoClasse}">${estadoTexto}</span>`);
      modal.find(".js-sniper-monitor-resumo").html(this.escapeHtmlEstadoDme(
        `Motivo: ${motivo}. Snipers em andamento: ${monitoramento.snipersEmAndamento || 0}. Timers ativos: ${monitoramento.timersSniperAtivos || 0}. Conta exemplo: ${conta}. Candidato scheduler: ${candidatoScheduler}. Slot Sniper sem timer: ${slotSemTimer ? "sim" : "nao"}. Falha concorrente recente: ${falhaConcorrente}.`
      ));
    }

    private renderizarSchedulerSniperDiagnostico(modal: JQuery, scheduler: any) {
      const wrap = modal.find(".js-estado-tarefa-scheduler-sniper-wrap");
      if (!scheduler) {
        wrap.hide();
        modal.find(".js-sniper-scheduler-slots-wrap").hide();
        modal.find(".js-sniper-scheduler-slots-body").html("");
        return;
      }

      wrap.show();
      const slots = scheduler.slots || {};
      const badgeBool = (valor: boolean) => valor ? "<span class=\"text-success\">Sim</span>" : "<span class=\"text-danger\">Nao</span>";
      modal.find(".js-sniper-scheduler-conta-elegivel").html(badgeBool(scheduler.contaElegivel === true));
      modal.find(".js-sniper-scheduler-tarefa-ligada").html(badgeBool(scheduler.tarefaLigada === true));
      modal.find(".js-sniper-scheduler-vagas-sniper").html(`${slots.nSniper || 0}/${scheduler.capSniperAplicavel || 0} <span class="text-muted font-size-11">(base ${scheduler.capSniper || 0})</span>`);
      modal.find(".js-sniper-scheduler-vagas-globais").html(`${slots.totalOcc || 0}/${scheduler.poolTotal || 0} <span class="text-muted font-size-11">livres ${scheduler.espacoGlobalLivre || 0}</span>`);

      let textoPartilha = scheduler.reusoLigado ? "Ligada" : "Desligada";
      if (scheduler.reusoLigado) {
        textoPartilha += scheduler.sniperUsaVagasDme
          ? " - Sniper pode usar DME"
          : ` - ${scheduler.motivoSniperNaoEmprestaDme || "DME protegido"}`;
      }
      if (scheduler.pausaViradaCicloUk) {
        textoPartilha += scheduler.sniperPodeUsarVagasDmeDurantePausa
          ? " - Auto DME pausado UK, Sniper pode usar vaga DME"
          : " - Auto DME pausado UK";
      }
      modal.find(".js-sniper-scheduler-partilha").html(this.escapeHtmlEstadoDme(textoPartilha));

      const decisaoClasse = scheduler.podeIniciarAgora ? "text-success" : (scheduler.motivoBloqueioScheduler === "possivel_slot_sniper_preso" ? "text-warning" : "text-danger");
      const decisaoTexto = scheduler.podeIniciarAgora
        ? "Pode iniciar"
        : (scheduler.podeReavaliarAgora ? "Reavaliar agora" : "Bloqueado");
      modal.find(".js-sniper-scheduler-decisao").html(`<span class="${decisaoClasse}">${decisaoTexto}</span>`);
      modal.find(".js-sniper-scheduler-resumo").html(scheduler.resumo ? this.escapeHtmlEstadoDme(scheduler.resumo) : "&nbsp;");

      const detalhes = Array.isArray(scheduler.detalhesSlots) ? scheduler.detalhesSlots : [];
      if (!detalhes.length) {
        modal.find(".js-sniper-scheduler-slots-wrap").hide();
        modal.find(".js-sniper-scheduler-slots-body").html("");
        return;
      }

      const linhas = detalhes.map((slot: any) => {
        const idade = slot.slotSniperSemTimer
          ? this.formatarIdadeSlotScheduler(slot.idadeSlotSniperSemTimerMs)
          : slot.fonte === "reserva"
          ? this.formatarIdadeSlotScheduler(slot.idadeReservaMs)
          : this.formatarIdadeSlotScheduler(slot.idadeIniciandoMs);
        const statusPartes: string[] = [];
        if (slot.iniciando) statusPartes.push("iniciando");
        if (slot.sessaoViva === true) statusPartes.push("sessao viva");
        if (slot.navegadorVivo === true) statusPartes.push("browser vivo");
        if (slot.timerSniperAtivo === true) statusPartes.push("timer sniper");
        if (slot.slotSniperSemTimer === true) statusPartes.push("sniper sem timer");
        if (slot.deveLiberarSlotSniper === true) statusPartes.push("liberavel");
        if (slot.possivelStale) statusPartes.push("suspeito");
        if (slot.origemSlotSniper) statusPartes.push(slot.origemSlotSniper);
        const status = statusPartes.length ? statusPartes.join(", ") : "-";
        const conta = slot.email || (slot.idConta != null ? `#${slot.idConta}` : "-");
        return `
          <tr>
            <td>${this.escapeHtmlEstadoDme(slot.fonte || "-")}</td>
            <td>${this.escapeHtmlEstadoDme(conta)}</td>
            <td>${this.escapeHtmlEstadoDme(slot.tipo || "-")}</td>
            <td>${this.escapeHtmlEstadoDme(idade)}</td>
            <td>${this.escapeHtmlEstadoDme(status)}</td>
          </tr>
        `;
      });

      modal.find(".js-sniper-scheduler-slots-wrap").show();
      modal.find(".js-sniper-scheduler-slots-body").html(linhas.join(""));
    }

    private renderizarLimitesAutoDmeDiagnostico(modal: JQuery, dados: any) {
      const g = dados.limitesGlobais;
      const p = dados.limitesPorConta;
      if (!g) {
        modal.find(".js-conta-diagnostico-limites-globais-wrap").hide();
      } else {
        modal.find(".js-conta-diagnostico-limites-globais-wrap").show();
        const th = g.throttlePluginMinutos;
        const t = g.tarefaLigadaAutoDme;
        const d = g.dmesUnicosHojePlugin != null ? g.dmesUnicosHojePlugin : g.dmesUnicos24hPlugin;
        const des = g.desafiosHojePlugin != null ? g.desafiosHojePlugin : g.desafios24hPlugin;
        const iv = g.intervaloMinutosExecucaoAutodmeContaGlobal;
        const rowsG: string[] = [];
        rowsG.push(`<div class="mb-2 p-2 border rounded"><strong>Throttle entre tentativas da tarefa (plugin)</strong>: ${th.ok ? "<span class=\"text-success\">OK</span>" : "<span class=\"text-danger\">Bloqueado</span>"} — minimo ${th.exigido} min desde a ultima vez que a tarefa Auto DME foi agendada.${th.decorrido != null ? ` Decorridos: ${(th.decorrido as number).toFixed(1)} min.` : ""}${th.faltamMinutos != null ? ` Faltam ~${(th.faltamMinutos as number).toFixed(1)} min.` : ""}</div>`);
        rowsG.push(`<div class="mb-2 p-2 border rounded"><strong>Tarefa Auto DME nas configuracoes</strong>: ${t.ok ? "<span class=\"text-success\">Ligada</span>" : "<span class=\"text-danger\">Desligada</span>"}.</div>`);
        rowsG.push(`<div class="mb-2 p-2 border rounded"><strong>DMEs unicos no ciclo EA (todas as contas)</strong>: ${d.uso}${d.limiteAtivo ? ` / ${d.limite} (${d.percentual != null ? d.percentual : 0}%)` : " (limite desativado)"} — ${d.atingido ? "<span class=\"text-danger\">Limite atingido</span>" : "<span class=\"text-success\">Abaixo do limite</span>"}${d.restante != null && d.limiteAtivo ? ` — restam ${d.restante} ate o limite.` : ""}</div>`);
        rowsG.push(`<div class="mb-2 p-2 border rounded"><strong>Desafios no ciclo EA (plugin)</strong>: ${des.uso}${des.limiteAtivo ? ` / ${des.limite} (${des.percentual != null ? des.percentual : 0}%)` : " (limite desativado)"} — ${des.atingido ? "<span class=\"text-danger\">Limite atingido</span>" : "<span class=\"text-success\">Abaixo do limite</span>"}${des.restante != null && des.limiteAtivo ? ` — restam ${des.restante}.` : ""}</div>`);
        const minGlob = iv.minutosDesdeUltimoEnvioQualquerConta;
        const minGlobStr = minGlob != null && Number.isFinite(minGlob) ? `${(minGlob as number).toFixed(1)} min` : "sem registo / primeiro envio";
        const minInicio = (iv as any).minutosDesdeUltimoInicioTarefaDme;
        const minInicioStr = minInicio != null && Number.isFinite(minInicio) ? `${(minInicio as number).toFixed(1)} min` : "nunca (tarefa do ciclo EA ainda nao iniciou DME nesta sessao)";
        const minRef = (iv as any).minutosReferenciaIntervalo;
        const minRefStr = minRef != null && Number.isFinite(minRef) ? `${(minRef as number).toFixed(1)} min` : "-";
        rowsG.push(`<div class="mb-2 p-2 border rounded"><strong>Intervalo entre DMEs (qualquer conta)</strong>: ${iv.minutosExigidos != null ? `exige ${iv.minutosExigidos} min desde o evento mais recente (envio em BD ou inicio de tarefa Auto DME)` : "sem intervalo configurado"}<br/>Ultimo envio (BD): ${minGlobStr}. Ultimo inicio de tarefa DME (diaria): ${minInicioStr}.<br/><strong>Referencia usada</strong>: ${minRefStr} — ${iv.ok ? "<span class=\"text-success\">OK</span>" : "<span class=\"text-danger\">Aguardando intervalo</span>"}${iv.faltamMinutos != null && Number.isFinite(iv.faltamMinutos) ? ` — faltam ~${(iv.faltamMinutos as number).toFixed(1)} min.` : ""}</div>`);
        modal.find(".js-conta-diagnostico-limites-globais").html(rowsG.join(""));
      }
      if (!p) {
        modal.find(".js-conta-diagnostico-limites-conta-wrap").hide();
      } else {
        modal.find(".js-conta-diagnostico-limites-conta-wrap").show();
        const s = p.solucoesDmesDia != null ? p.solucoesDmesDia : (p.solucoesDmes24h != null ? p.solucoesDmes24h : null);
        const tt = p.tentativasDia != null ? p.tentativasDia : (p.tentativas24h != null ? p.tentativas24h : null);
        const df = p.desafiosDia != null ? p.desafiosDia : (p.desafios24h != null ? p.desafios24h : null);
        const is = p.intervaloProximaSolucaoDme || null;
        const it = p.intervaloProximaTentativa || null;
        const rowsP: string[] = [];
        const renderContador = (label: string, obj: any) => {
          if (!obj) return `<div class="mb-2 p-2 border rounded text-muted font-size-12"><strong>${label}</strong>: dados não disponíveis.</div>`;
          return `<div class="mb-2 p-2 border rounded"><strong>${label}</strong>: ${obj.uso != null ? obj.uso : 0}${obj.limiteAtivo ? ` / ${obj.limite} (${obj.percentual != null ? obj.percentual : 0}%)` : ""} — ${obj.atingido ? "<span class=\"text-danger\">Limite atingido</span>" : "<span class=\"text-success\">OK</span>"}${obj.restante != null && obj.limiteAtivo ? ` — restam ${obj.restante}.` : ""}</div>`;
        };
        rowsP.push(renderContador("Solucoes DME (ciclo EA, conta)", s));
        rowsP.push(renderContador("Tentativas DME (ciclo EA)", tt));
        rowsP.push(renderContador("Desafios (ciclo EA)", df));
        if (is) {
          const minE = is.minutosDesdeUltimoEnvio;
          const minEStr = minE != null && Number.isFinite(minE) ? `${(minE as number).toFixed(1)} min desde o ultimo` : "";
          rowsP.push(`<div class="mb-2 p-2 border rounded"><strong>Intervalo entre envios (perfil)</strong>: minimo ${is.minutosExigidos} min — ${is.ok ? "<span class=\"text-success\">OK</span>" : "<span class=\"text-danger\">Envio recente</span>"}${minEStr ? ` — ${minEStr}` : ""}${is.faltamMinutos != null && Number.isFinite(is.faltamMinutos) ? ` — faltam ~${(is.faltamMinutos as number).toFixed(1)} min.` : ""}</div>`);
        }
        if (it) {
          rowsP.push(`<div class="mb-2 p-2 border rounded"><strong>Intervalo entre tentativas (perfil)</strong>: minimo ${it.minutosExigidos} min — ${it.ok ? "<span class=\"text-success\">OK</span>" : "<span class=\"text-danger\">Tentativa recente</span>"}.</div>`);
        }
        modal.find(".js-conta-diagnostico-limites-conta").html(rowsP.join(""));
      }
    }

    private escapeHtmlEstadoDme(s: string): string {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    private normalizarNumeroEstadoDme(valor: any): number | null {
      if (valor === null || typeof valor === "undefined" || valor === "") return null;
      if (typeof valor === "number") return Number.isFinite(valor) ? valor : null;
      const texto = String(valor).trim();
      if (!texto) return null;
      const direto = Number(texto);
      if (Number.isFinite(direto)) return direto;
      const normalizado = texto.replace(/\./g, "").replace(",", ".").replace(/[^\d.-]/g, "");
      if (!normalizado || normalizado === "-" || normalizado === ".") return null;
      const n = Number(normalizado);
      return Number.isFinite(n) ? n : null;
    }

    private obterLucroPrevistoEstadoAutoDme(meta: any, det: any = null): number | null {
      const fontes: any[] = [];
      if (meta) {
        fontes.push(meta.lucro_previsto_hoje, meta.lucroPrevistoHoje, meta.lucro_previsto, meta.lucroPrevisto);
      }
      if (det && det !== meta) {
        fontes.push(det.lucroPrevistoHoje, det.lucro_previsto_hoje, det.lucroPrevisto, det.lucro_previsto);
      }
      for (let i = 0; i < fontes.length; i++) {
        const n = this.normalizarNumeroEstadoDme(fontes[i]);
        if (n !== null) return n;
      }
      return null;
    }

    private renderizarLucroPrevistoAutoDme(meta: any, det: any = null): string {
      const lucro = this.obterLucroPrevistoEstadoAutoDme(meta, det);
      if (lucro === null) {
        return `<span class="text-muted font-size-11">-</span>`;
      }
      const classe = lucro > 0 ? "text-success" : (lucro < 0 ? "text-danger" : "text-muted");
      const sinal = lucro > 0 ? "+" : "";
      const count = meta && meta.lucro_previsto_count_hoje != null
        ? Number(meta.lucro_previsto_count_hoje)
        : (det && det.quantidadeLucrosPrevistosHoje != null ? Number(det.quantidadeLucrosPrevistosHoje) : 0);
      const gasto = this.normalizarNumeroEstadoDme(
        meta && meta.gasto_total_hoje != null ? meta.gasto_total_hoje : (det ? det.gastoTotalHoje : null)
      );
      let titulo = "Lucro previsto acumulado hoje para este DME.";
      if (count > 1) titulo += " " + count + " envios com lucro conhecido.";
      if (gasto !== null && gasto > 0) titulo += " Gasto total hoje: " + Math.round(gasto).toLocaleString("pt-BR") + " coins.";
      return `<span class="${classe} font-weight-600 font-size-12" title="${this.escapeHtmlEstadoDme(titulo)}">${sinal}${Math.round(lucro).toLocaleString("pt-BR")}</span><div class="text-muted font-size-10">coins</div>`;
    }

    private renderizarTabelaDmesCadastradosPerfil(modal: JQuery, itens: any[]) {
      const body = modal.find(".js-estado-tarefa-dmes-cadastrados-body");
      modal.find(".js-estado-tarefa-dmes-cadastrados-container").show();
      if (!Array.isArray(itens) || !itens.length) {
        body.html(`<tr><td colspan="4" class="text-muted font-size-12">Nenhum DME cadastrado no perfil desta conta.</td></tr>`);
        return;
      }
      const linhas = itens.map((item: any) => {
        const ordem = (typeof item.ordem !== "undefined" && item.ordem !== null) ? item.ordem : "-";
        const nome = (typeof item.nome !== "undefined" && item.nome !== null && String(item.nome).trim())
          ? this.escapeHtmlEstadoDme(String(item.nome).trim())
          : `<span class="text-muted">-</span>`;
        const qtd = (typeof item.qtdPeriodos !== "undefined" && item.qtdPeriodos !== null) ? item.qtdPeriodos : 0;
        const ativo = !!item.ativo;
        const badgeAtivo = ativo
          ? `<span class="badge badge-success">Sim</span>`
          : `<span class="badge badge-secondary">Nao</span>`;
        return `
          <tr>
            <td>${ordem}</td>
            <td>${nome}</td>
            <td>${qtd}</td>
            <td>${badgeAtivo}</td>
          </tr>
        `;
      }).join("");
      body.html(linhas);
    }

    private badgeDiagnosticoAutoDme(ok: boolean): string {
      return ok
        ? `<span class="badge badge-success">Sim</span>`
        : `<span class="badge badge-danger">Nao</span>`;
    }

    private getMotivoElegibilidadeSelecaoPrioridade(item: any): string {
      if (!item) return "-";
      if (item.motivoRecorrencia && String(item.motivoRecorrencia).trim() && item.motivoRecorrencia !== "ok") {
        const m = String(item.motivoRecorrencia).trim();
        if (m === "aguardando_dmes_anteriores_finalizarem") return "Aguardando: DMEs de prioridade anterior ainda podem rodar ou estao em cooldown.";
        if (m === "nao_repetivel") return "Bloqueado: DME nao repetivel (NON_REPEATABLE) — ja foi concluido e nao pode ser feito novamente neste ciclo.";
        if (m === "limite_diario_atingido") {
          const lim = item.limiteSolucoesDiariasCadastro != null ? item.limiteSolucoesDiariasCadastro : "-";
          const uso = item.solucoesHoje != null ? item.solucoesHoje : 0;
          return `Bloqueado: limite diario de solucoes atingido (${uso}/${lim}).`;
        }
        if (m === "aguardando_refresh") {
          const repeats = item.repeats != null ? item.repeats : "-";
          const vezes = item.timesCompletedNoCiclo != null ? item.timesCompletedNoCiclo : "-";
          return `Bloqueado: limite de repeticoes do ciclo atingido (${vezes}/${repeats} completados). Aguardando janela de refresh para reiniciar o ciclo.`;
        }
        if (m === "limite_repeticoes_ciclo") {
          const repeats = item.repeats != null ? item.repeats : "-";
          const vezes = item.timesCompletedNoCiclo != null ? item.timesCompletedNoCiclo : "-";
          return `Bloqueado: limite de repeticoes do ciclo atingido (${vezes}/${repeats}). Aguardando refresh.`;
        }
      }
      if (!!item.elegivelPorPrioridade) {
        return "Elegivel: atende todas as regras.";
      }
      if (!item.idValido) return "Bloqueado: id_dme invalido ou nao informado.";
      if (!item.disponivelNoWebApp) return "Bloqueado: DME nao disponivel no WebApp agora.";
      if (!item.dentroPeriodo) return "Bloqueado: fora do periodo configurado.";
      return "Bloqueado por regra de selecao.";
    }

    private renderizarTabelaSelecaoPrioridadeAutoDme(modal: JQuery, selecao: any) {
      const container = modal.find(".js-estado-tarefa-selecao-prioridade-container");
      const resumo = modal.find(".js-estado-tarefa-selecao-prioridade-resumo");
      const body = modal.find(".js-estado-tarefa-selecao-prioridade-body");

      if (!selecao || !Array.isArray(selecao.itens)) {
        container.hide();
        resumo.html("-");
        body.html("");
        return;
      }

      container.show();
      const totalConfigurados = typeof selecao.totalConfigurados === "number" ? selecao.totalConfigurados : selecao.itens.length;
      const totalElegiveis = typeof selecao.totalElegiveis === "number" ? selecao.totalElegiveis : 0;
      const escolhido = selecao.dmeEscolhido || null;
      const nomeEscolhido = escolhido && escolhido.nome ? String(escolhido.nome) : null;
      const idEscolhido = escolhido && escolhido.id_dme != null ? `#${escolhido.id_dme}` : "#-";
      const priEscolhida = escolhido && escolhido.prioridade != null ? ` (prioridade ${escolhido.prioridade})` : "";
      const textoEscolhido = escolhido
        ? `${nomeEscolhido ? this.escapeHtmlEstadoDme(nomeEscolhido) + " " : ""}${idEscolhido}${priEscolhida}`
        : `<span class="text-danger">nenhum DME elegivel no momento</span>`;

      resumo.html(`Configurados: <strong>${totalConfigurados}</strong> | Elegiveis: <strong>${totalElegiveis}</strong> | Próximo a executar: <strong>${textoEscolhido}</strong>`);

      if (!selecao.itens.length) {
        body.html(`<tr><td colspan="10" class="text-muted font-size-12">Sem itens configurados para avaliar prioridade.</td></tr>`);
        return;
      }

      const linhas = selecao.itens.map((item: any) => {
        const ordem = (typeof item.ordem !== "undefined" && item.ordem !== null) ? item.ordem : "-";
        const idDme = item.id_dme != null ? item.id_dme : "-";
        const nome = (typeof item.nome !== "undefined" && item.nome !== null && String(item.nome).trim())
          ? this.escapeHtmlEstadoDme(String(item.nome).trim())
          : `<span class="text-muted">-</span>`;
        const prioridade = (typeof item.prioridade !== "undefined" && item.prioridade !== null) ? item.prioridade : 1;
        const dmeCell = `<div class="font-weight-600">${nome}</div><small class="text-muted">#${idDme}</small>`;
        const motivoElegibilidade = this.escapeHtmlEstadoDme(this.getMotivoElegibilidadeSelecaoPrioridade(item));

        // Modo de recorrência com badge colorido
        const modoRaw = String(item.repeatabilityMode || "NON_REPEATABLE").toUpperCase();
        let modoBadge = "";
        if (modoRaw === "NON_REPEATABLE") {
          modoBadge = `<span class="badge badge-secondary" title="Executa apenas uma vez">Único</span>`;
        } else if (modoRaw === "UNLIMITED") {
          modoBadge = `<span class="badge badge-info" title="Pode repetir infinitamente">Ilimitado</span>`;
        } else if (modoRaw === "REFRESH") {
          const repeats = item.repeats != null ? item.repeats : "?";
          modoBadge = `<span class="badge badge-primary" title="Repete ${repeats}x por ciclo, reinicia após refresh">Refresh (${repeats}x)</span>`;
        } else {
          modoBadge = `<span class="badge badge-light">${modoRaw}</span>`;
        }

        // Soluções hoje
        const solucoesHoje = item.solucoesHoje != null ? item.solucoesHoje : "-";
        const limiteDiario = item.limiteSolucoesDiariasCadastro != null ? item.limiteSolucoesDiariasCadastro : null;
        const solucoesHojeStr = limiteDiario != null
          ? `${solucoesHoje}/${limiteDiario}`
          : `${solucoesHoje}`;

        // Restante no ciclo (apenas para REFRESH)
        let restanteCicloCell = `<span class="text-muted">-</span>`;
        if (modoRaw === "REFRESH" || modoRaw === "UNLIMITED") {
          const restante = item.restanteHoje != null ? item.restanteHoje : null;
          const repeats = item.repeats != null ? item.repeats : null;
          const feitos = item.timesCompletedNoCiclo != null ? item.timesCompletedNoCiclo : null;
          if (repeats != null && feitos != null) {
            const restCiclo = Math.max(0, repeats - feitos);
            const classeRestante = restCiclo > 0 ? "text-success" : "text-danger";
            restanteCicloCell = `<span class="${classeRestante} font-weight-600">${restCiclo}</span><small class="text-muted"> (${feitos}/${repeats})</small>`;
          } else if (modoRaw === "UNLIMITED") {
            restanteCicloCell = `<span class="text-info">∞</span>`;
          }
        }

        const rowClass = item.elegivelPorPrioridade ? "" : "text-muted";

        return `
          <tr class="${rowClass}" ${item.elegivelPorPrioridade ? 'style="background-color: rgba(168, 168, 168, 0.3);"' : ''}>
            <td>${ordem}</td>
            <td><span class="badge badge-primary">${prioridade}</span></td>
            <td>${dmeCell}</td>
            <td>${this.badgeDiagnosticoAutoDme(!!item.disponivelNoWebApp)}</td>
            <td>${this.badgeDiagnosticoAutoDme(!!item.dentroPeriodo)}</td>
            <td>${modoBadge}</td>
            <td>${solucoesHojeStr}</td>
            <td>${restanteCicloCell}</td>
            <td>${this.badgeDiagnosticoAutoDme(!!item.elegivelPorPrioridade)}</td>
            <td><span class="font-size-12">${motivoElegibilidade}</span></td>
          </tr>
        `;
      }).join("");

      body.html(linhas);
    }

    private renderizarTabelaDmesAutoDme(modal: JQuery, itens: any[]) {
      const body = modal.find(".js-estado-tarefa-dmes-body");
      if (!Array.isArray(itens) || !itens.length) {
        modal.find(".js-estado-tarefa-dmes-container").show();
        body.html(`<tr><td colspan="7" class="text-muted font-size-12">Sem dados por DME hoje.</td></tr>`);
        return;
      }

      const linhas = itens.map((item: any) => {
        const idDme = (item.idDme != null) ? item.idDme : "-";
        const nomeDme = item.nomeDme ? String(item.nomeDme).trim() : "";
        const celulaDesafio = nomeDme
          ? `<div class="font-weight-600">${this.escapeHtmlEstadoDme(nomeDme)}</div><small class="text-muted">#${idDme}</small>`
          : `<span class="text-muted">#${idDme}</span>`;

        // Prioridade
        const prio = (item.prioridade != null) ? item.prioridade : "-";
        const celulaPrio = `<span class="badge badge-secondary font-size-11">${prio}</span>`;

        // Soluções hoje com barra de limite diário
        const desafios = item.quantidadeDesafiosHoje || 0;
        const limDiario = (item.limiteSolucoesDiarias != null && item.limiteSolucoesDiarias > 0) ? item.limiteSolucoesDiarias : null;
        let celulaDesafios: string;
        if (limDiario !== null) {
          const pct = Math.min(100, Math.round((desafios / limDiario) * 100));
          const corBarra = desafios >= limDiario ? "bg-success" : (desafios > 0 ? "bg-success" : "bg-secondary");
          celulaDesafios = `
            <span class="font-weight-600">${desafios}/${limDiario}</span>
            <div class="progress mt-1" style="height:4px;width:60px">
              <div class="progress-bar ${corBarra}" style="width:${pct}%"></div>
            </div>`;
        } else {
          celulaDesafios = `<span class="${desafios > 0 ? "text-success font-weight-600" : ""}">${desafios}</span>`;
        }

        // Tentativas
        const tentativas = item.quantidadeTentativasHoje || 0;
        const celulaTentativas = `<span>${tentativas}</span>`;

        // Sucesso / Falha
        const sucesso = item.quantidadeTentativasSucessoHoje || 0;
        const falha = item.quantidadeTentativasFalhaHoje || 0;
        const celulaOkFalha = `<span class="text-success font-weight-600">${sucesso}</span> / <span class="text-danger">${falha}</span>`;

        // Ciclo atual do REFRESH
        const mode = item.repeatabilityMode || null;
        const timesNoCiclo = item.timesCompletedNoCiclo;
        const repeats = item.repeats;
        let celulaCiclo: string;
        if (mode === "REFRESH" && repeats != null && repeats > 0) {
          const cicloAtual = (timesNoCiclo != null) ? timesNoCiclo : "?";
          const cicloPct = timesNoCiclo != null ? Math.min(100, Math.round((timesNoCiclo / repeats) * 100)) : 0;
          const corCiclo = timesNoCiclo >= repeats ? "bg-success" : (timesNoCiclo > 0 ? "bg-info" : "bg-secondary");
          celulaCiclo = `
            <span class="font-size-12">${cicloAtual}/${repeats}</span>
            <div class="progress mt-1" style="height:4px;width:50px">
              <div class="progress-bar ${corCiclo}" style="width:${cicloPct}%"></div>
            </div>`;
        } else if (mode === "UNLIMITED") {
          celulaCiclo = `<span class="text-muted font-size-12" title="Ilimitado">∞</span>`;
        } else if (mode === "NON_REPEATABLE") {
          celulaCiclo = `<span class="text-muted font-size-12">Único</span>`;
        } else {
          celulaCiclo = `<span class="text-muted font-size-12">-</span>`;
        }

        // Último envio
        const ultimo = item.ultimaExecucaoDesafio ? this.formatarDataEstadoAutoDme(item.ultimaExecucaoDesafio) : "-";

        return `
          <tr>
            <td>${celulaPrio}</td>
            <td>${celulaDesafio}</td>
            <td>${celulaDesafios}</td>
            <td>${celulaTentativas}</td>
            <td>${celulaOkFalha}</td>
            <td>${celulaCiclo}</td>
            <td class="font-size-11 text-muted">${ultimo}</td>
          </tr>
        `;
      }).join("");

      modal.find(".js-estado-tarefa-dmes-container").show();
      body.html(linhas);
    }

    /**
     * Renderiza a tabela unificada do modal de diagnóstico Auto DME consumindo
     * exclusivamente `conta.dmes` (IDmeContaItem[] — objeto EA nativo + `_autodme`).
     *
     * Layout (cabeçalho em `estado-auto-dme.blade.php`):
     *   DME | Ciclo EA | Solucoes ciclo | Tentativas | OK/Falha | Ultima tentativa | Disp./Periodo | Motivo
     *
     * - "Ciclo EA" é o progresso do ciclo 18:00 Europe/London conforme SBCRepeatabilityMode
     *   (NON_REPEATABLE/LIMITED/REFRESH/UNLIMITED).
     * - "Disp./Período" deriva dos motivos de bloqueio (`nao_disponivel_webapp`,
     *   `fora_periodo`) produzidos pelo backend em `AutoDmeEstado.decidirStatusDme`.
     * - "Tentativas" usa `_autodme.tentativas_hoje` confrontado com o limite por-DME
     *   vindo de `dados.limitesPorConta.tentativasHojeConta.limitePorDme`.
     */
    private renderizarTabelaUnificadaDmesAutoDmeNova(modal: JQuery, selecao: any, dmesConta: IDmeContaItem[], dados: any = null) {
      const container = modal.find(".js-estado-tarefa-dmes-unificados-container");
      const resumoEl = modal.find(".js-estado-tarefa-dmes-unificados-resumo");
      const body = modal.find(".js-estado-tarefa-dmes-unificados-body");

      container.show();

      if (!dmesConta.length) {
        resumoEl.html('<span class="text-muted">Nenhum DME sincronizado em conta.dmes.</span>');
        body.html(`<tr><td colspan="10" class="text-muted font-size-12">Sem dados.</td></tr>`);
        return;
      }

      const agoraMs = Date.now();

      const limitePorDmeTentativasFallback: number | null =
        dados && dados.limitesPorConta && dados.limitesPorConta.tentativasHojeConta
          ? (dados.limitesPorConta.tentativasHojeConta.limitePorDme != null
            ? Number(dados.limitesPorConta.tentativasHojeConta.limitePorDme)
            : null)
          : null;

      const ordemPrioridadeStatus: Record<string, number> = {
        pendente: 0,
        em_andamento: 1,
        bloqueado: 2,
        completo: 3,
      };

      const ordenados = [...dmesConta].sort((a, b) => {
        const pa = a._autodme && a._autodme.prioridade_autodme != null ? a._autodme.prioridade_autodme : 9999;
        const pb = b._autodme && b._autodme.prioridade_autodme != null ? b._autodme.prioridade_autodme : 9999;
        if (pa !== pb) return pa - pb;
        const sa = a._autodme && a._autodme.status ? a._autodme.status : "PENDENTE";
        const sb = b._autodme && b._autodme.status ? b._autodme.status : "PENDENTE";
        const osa = Object.prototype.hasOwnProperty.call(ordemPrioridadeStatus, sa) ? ordemPrioridadeStatus[sa] : 9;
        const osb = Object.prototype.hasOwnProperty.call(ordemPrioridadeStatus, sb) ? ordemPrioridadeStatus[sb] : 9;
        return osa - osb;
      });


      const totalConfigurados = ordenados.length;
      const totalElegiveis = ordenados.filter(d => {
        const meta: any = d._autodme || {};
        const mr = App.Business.autoDmeModoRepeatabilityNormalizado(d);
        if (!App.Business.autoDmeModoRepeatabilityConhecido(mr)) return false;
        if (App.Business.dmeExpiradoHeuristica(d, agoraMs)) return false;
        return meta.status === "pendente" && (!meta.proximo_elegivel_ts || Number(meta.proximo_elegivel_ts) <= agoraMs);
      }).length;

      const escolhido = selecao ? (selecao.dmeEscolhido || null) : null;
      let nomeEscolhido = "";
      if (escolhido) {
        const nomeEsc = escolhido.nome ? this.escapeHtmlEstadoDme(String(escolhido.nome)) : "";
        const idEsc = (typeof escolhido.id_dme !== "undefined" && escolhido.id_dme !== null) ? escolhido.id_dme : "-";
        const prioEsc = (typeof escolhido.prioridade !== "undefined" && escolhido.prioridade !== null) ? escolhido.prioridade : "-";
        nomeEscolhido = `${nomeEsc ? nomeEsc + " " : ""}#${idEsc} (prior. ${prioEsc})`;
      } else if (totalElegiveis > 0) {
        const primeiroEleg = ordenados.find(d => {
          const meta: any = d._autodme || {};
          const mr = App.Business.autoDmeModoRepeatabilityNormalizado(d);
          if (!App.Business.autoDmeModoRepeatabilityConhecido(mr)) return false;
          if (App.Business.dmeExpiradoHeuristica(d, agoraMs)) return false;
          return meta.status === "pendente" && (!meta.proximo_elegivel_ts || Number(meta.proximo_elegivel_ts) <= agoraMs);
        });
        if (primeiroEleg) {
          const nomeE = this.escapeHtmlEstadoDme(String(primeiroEleg.nameptbr || primeiroEleg.name || "—"));
          nomeEscolhido = `${nomeE} #${primeiroEleg.setId || "-"}`;
        } else {
          nomeEscolhido = `<span class="text-danger font-size-12">nenhum elegível agora</span>`;
        }
      } else {
        nomeEscolhido = `<span class="text-danger font-size-12">nenhum elegível agora</span>`;
      }
      resumoEl.html(`Configurados: <strong>${totalConfigurados}</strong> | Elegíveis: <strong>${totalElegiveis}</strong> | Próximo: <strong>${nomeEscolhido}</strong>`);

      const linhas = ordenados.map((dme) => {
        const meta: any = dme._autodme || {};
        const modoRaw = App.Business.autoDmeModoRepeatabilityNormalizado(dme);
        const prioridade = meta.prioridade_autodme != null ? meta.prioridade_autodme : "-";
        const nome = this.escapeHtmlEstadoDme(String(dme.nameptbr || dme.name || "—"));
        const idDme = (dme as any).setId || (dme as any).id || "-";
        const celulaIdNome = `<div class="font-weight-600 font-size-12">${nome}</div><small class="text-muted">#${idDme}</small>`;

        const repeats = Math.max(0, Number(dme.repeats || 0));

        let modoBadge = "";
        if (modoRaw === "NON_REPEATABLE") {
          modoBadge = `<span class="badge badge-secondary font-size-10" title="Executa uma única vez por ciclo">Único</span>`;
        } else if (modoRaw === "LIMITED") {
          modoBadge = `<span class="badge badge-warning font-size-10" title="Limitado vitalício: ${repeats || "?"} execução(ões) permitidas">Limitado${repeats ? ` (${repeats}x)` : ""}</span>`;
        } else if (modoRaw === "REFRESH") {
          modoBadge = `<span class="badge badge-primary font-size-10" title="Repete ${repeats || "?"}x por ciclo">Refresh${repeats ? ` (${repeats}x)` : ""}</span>`;
        } else if (modoRaw === "UNLIMITED") {
          modoBadge = `<span class="badge badge-info font-size-10" title="Repetições ilimitadas">Ilimitado</span>`;
        } else {
          const desconhecido = modoRaw === "" || modoRaw === "UNKNOWN";
          const ausenteWebApp = String(meta.motivo_bloqueio || "") === "nao_disponivel_webapp";
          const texto = desconhecido ? (ausenteWebApp ? "Indisponível" : "Desconhecido") : modoRaw;
          const cor = desconhecido ? "badge-warning" : "badge-light";
          const tituloModoDesconhecido = ausenteWebApp
            ? "DME configurado, mas ausente no snapshot atual da EA para esta conta"
            : "SBCRepeatabilityMode ausente ou UNKNOWN no snapshot da EA";
          modoBadge = `<span class="badge ${cor} font-size-10" title="${desconhecido ? tituloModoDesconhecido : ""}">${texto}</span>`;
        }

        const expirado = App.Business.dmeExpiradoHeuristica(dme, agoraMs);
        const statusRaw: string = expirado ? "expirado" : (meta.status || "pendente");

        const sucessosHoje = meta.sucessos_hoje != null ? Number(meta.sucessos_hoje) : 0;
        const tentativasHoje = meta.tentativas_hoje != null ? Number(meta.tentativas_hoje) : 0;
        const falhasHoje = meta.falhas_hoje != null
          ? Math.max(0, Number(meta.falhas_hoje) || 0)
          : Math.max(0, tentativasHoje - sucessosHoje);
        const limiteTentativasDme = meta.limite_tentativas_dia != null
          ? Number(meta.limite_tentativas_dia)
          : limitePorDmeTentativasFallback;
        const solucoesHoje = meta.solucoes_hoje != null ? Math.max(0, Number(meta.solucoes_hoje) || 0) : sucessosHoje;
        const limiteSolucoesDiarias = meta.limite_solucoes_diarias_efetivo != null
          ? Math.max(0, Number(meta.limite_solucoes_diarias_efetivo) || 0)
          : (meta.limite_solucoes_diarias != null
            ? Math.max(0, Number(meta.limite_solucoes_diarias) || 0)
            : ((dme as any).limiteSolucoesDiariasCadastro != null ? Math.max(0, Number((dme as any).limiteSolucoesDiariasCadastro) || 0) : 0));
        const limiteSolucoesConfigurado = meta.limite_solucoes_diarias_configurado != null
          ? Math.max(0, Number(meta.limite_solucoes_diarias_configurado) || 0)
          : limiteSolucoesDiarias;
        const faixasForragens = Array.isArray(meta.limites_solucoes_por_forragens) ? meta.limites_solucoes_por_forragens : [];
        const usaLimiteForragens = faixasForragens.length > 0;
        const forragensTotal = meta.forragens_clube_total != null ? Number(meta.forragens_clube_total) : null;
        let limiteCicloEfetivo = meta.limite_ciclo_efetivo != null ? Math.max(0, Number(meta.limite_ciclo_efetivo) || 0) : 0;
        if (!limiteCicloEfetivo) {
          if (modoRaw === "UNLIMITED") {
            limiteCicloEfetivo = limiteSolucoesDiarias;
          } else if (modoRaw === "REFRESH" || modoRaw === "LIMITED") {
            if (repeats > 0 && limiteSolucoesDiarias > 0) limiteCicloEfetivo = Math.min(repeats, limiteSolucoesDiarias);
            else limiteCicloEfetivo = repeats || limiteSolucoesDiarias;
          }
        }

        let cicloCelula = "";
        if (!App.Business.autoDmeModoRepeatabilityConhecido(modoRaw)) {
          cicloCelula = `<span class="text-muted font-size-11">-</span>`;
        } else if (modoRaw === "NON_REPEATABLE") {
          if (statusRaw === "completo") {
            cicloCelula = `<span class="badge badge-success font-size-10">✓ Concluído</span>`;
          } else if (statusRaw === "em_andamento" || Number(dme.challengesCompletedCount || 0) > 0) {
            const total = Math.max(1, Number(dme.challengesCount || 1));
            const feitos = Math.min(Number(dme.challengesCompletedCount || 0), total);
            const pct = Math.round((feitos / total) * 100);
            cicloCelula = `
              <span class="badge badge-info font-size-10" title="${feitos}/${total} desafios">🔄 ${feitos}/${total} desafios</span>
              <div class="progress mt-1" style="height:4px;width:56px">
                <div class="progress-bar bg-info" style="width:${pct}%"></div>
              </div>`;
          } else {
            cicloCelula = `<span class="badge badge-secondary font-size-10">○ Pendente</span>`;
          }
        } else if (modoRaw === "LIMITED") {
          const total = Math.max(1, limiteCicloEfetivo || repeats || 1);
          const feitosBase = limiteSolucoesDiarias > 0 && repeats > 0 && limiteSolucoesDiarias <= repeats
            ? solucoesHoje
            : Number(dme.timesCompleted || 0);
          const feitos = Math.min(feitosBase, total);
          const pct = Math.round((feitos / total) * 100);
          const cor = feitos >= total ? "bg-success" : (feitos > 0 ? "bg-info" : "bg-secondary");
          const titleLimite = limiteSolucoesDiarias > 0
            ? `Limite diario do cadastro: ${limiteSolucoesDiarias}; limite EA: ${repeats || "?"}`
            : `Limitado vitalicio: ${feitos} de ${total}`;
          cicloCelula = `
            <span class="font-weight-600 font-size-12" title="${titleLimite}">${feitos}/${total}${limiteSolucoesDiarias > 0 && limiteSolucoesDiarias <= repeats ? "" : " (vitalicio)"}</span>
            <div class="progress mt-1" style="height:4px;width:56px">
              <div class="progress-bar ${cor}" style="width:${pct}%"></div>
            </div>`;
        } else if (modoRaw === "REFRESH") {
          const total = Math.max(1, limiteCicloEfetivo || repeats || 1);
          const feitosRaw = Number(dme.timesCompletedInInterval || 0);
          const sucessosCiclo = Math.min(solucoesHoje, total);
          const proximoElegivelRefresh = meta.proximo_elegivel_ts != null ? Number(meta.proximo_elegivel_ts) : 0;
          const snapshotRefreshAntigo = statusRaw !== "completo" && proximoElegivelRefresh <= agoraMs && feitosRaw >= total;
          const feitos = snapshotRefreshAntigo ? sucessosCiclo : Math.min(Math.max(feitosRaw, solucoesHoje), total);
          const pct = Math.round((feitos / total) * 100);
          const cor = feitos >= total ? "bg-success" : (feitos > 0 ? "bg-info" : "bg-secondary");
          const riSeg = Number(dme.refreshInterval || dme.repeatRefreshInterval) || 0;
          let cicloInfo = "";
          if (riSeg === 86400) {
            cicloInfo = ` · ciclo diário`;
          } else if (riSeg === 172800) {
            cicloInfo = ` · ciclo 2 dias`;
          } else if (riSeg > 0) {
            cicloInfo = ` · ciclo ${App.Business.formatarTempoRestanteCurto(riSeg * 1000)}`;
          }
          const titleLimiteRefresh = limiteSolucoesDiarias > 0
            ? `Ciclo atual: ${feitos} de ${total}; limite diario do cadastro: ${limiteSolucoesDiarias}; limite EA: ${repeats || "?"}${cicloInfo}`
            : `Ciclo atual: ${feitos} de ${total}${cicloInfo}`;
          let cicloRenovacaoHtml = "";
          if (feitos >= total && meta.proximo_elegivel_ts != null) {
            const tsRen = Number(meta.proximo_elegivel_ts);
            if (Number.isFinite(tsRen) && tsRen > 0) {
              const utcLeg = new Date(tsRen).toISOString().replace("T", " ").slice(0, 19);
              let ukLeg = "";
              try {
                const optsUk: any = { timeZone: "Europe/London", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false };
                ukLeg = new Date(tsRen).toLocaleString("pt-BR", optsUk).replace(",", "");
              } catch (e) { }
              const renovacao = ukLeg ? `18:00 UK (${ukLeg}) | ${utcLeg} UTC` : `18:00 UK | ${utcLeg} UTC`;
              cicloRenovacaoHtml = `<div class="font-size-10 text-muted mt-1" title="Proximo ciclo REFRESH (18:00 UK)">↻ ${renovacao}</div>`;
            }
          }
          cicloCelula = `
            <span class="font-weight-600 font-size-12" title="${titleLimiteRefresh}">${feitos}/${total}${cicloInfo ? ` <small class="text-muted">${cicloInfo}</small>` : ""}</span>
            <div class="progress mt-1" style="height:4px;width:56px">
              <div class="progress-bar ${cor}" style="width:${pct}%"></div>
            </div>${cicloRenovacaoHtml}`;
        }

        if (modoRaw === "UNLIMITED") {
          const totalUnlimited = Math.max(1, limiteCicloEfetivo || limiteSolucoesDiarias || solucoesHoje || 1);
          const pctUnlimited = solucoesHoje > 0 ? Math.min(100, Math.round((solucoesHoje / totalUnlimited) * 100)) : 0;
          const completoUnlimited = limiteCicloEfetivo > 0 && solucoesHoje >= limiteCicloEfetivo;
          const totalDesafios = Math.max(1, Number(dme.challengesCount || 1));
          const desafiosFeitos = Math.min(Math.max(0, Number(dme.challengesCompletedCount || 0)), totalDesafios);
          const desafiosLocaisHoje = Math.max(0, Number(meta.desafios_locais_hoje || 0));
          const desafiosPorCiclo = Math.max(1, Number(meta.desafios_por_ciclo || totalDesafios || 1));
          const parciaisCicloAtual = meta.desafios_parciais_ciclo_atual != null
            ? Math.max(0, Number(meta.desafios_parciais_ciclo_atual) || 0)
            : (desafiosLocaisHoje % desafiosPorCiclo);
          const rodadaEaAtual = `${desafiosFeitos}/${totalDesafios}`;
          const rodadaAtual = totalDesafios > 1
            ? `<div class="font-size-10 text-muted mt-1" title="Rodada atual no WebApp">Rodada atual: ${desafiosFeitos}/${totalDesafios} desafios</div>`
            : "";
          const totalLabel = limiteCicloEfetivo > 0 ? limiteCicloEfetivo : "&#8734;";
          cicloCelula = `
            <span class="font-weight-600 font-size-12" title="DME ilimitado: ciclos completos hoje UK por desafios enviados. Desafios enviados hoje: ${desafiosLocaisHoje}; desafios por ciclo: ${desafiosPorCiclo}; parcial atual local: ${parciaisCicloAtual}/${desafiosPorCiclo}; rodada EA atual: ${rodadaEaAtual}.">Hoje UK: ${solucoesHoje}/${totalLabel}</span>
            <div class="progress mt-1" style="height:4px;width:56px">
              <div class="progress-bar ${completoUnlimited ? "bg-success" : (solucoesHoje > 0 ? "bg-info" : "bg-secondary")}" style="width:${pctUnlimited}%"></div>
            </div>${rodadaAtual}`;
        }

        const celulaTentativas = limiteTentativasDme != null && Number.isFinite(limiteTentativasDme) && limiteTentativasDme > 0
          ? `<span title="Falhas no ciclo EA para este DME nesta conta (limite de falhas: ${limiteTentativasDme}; tentativas totais: ${tentativasHoje})">${falhasHoje}/${limiteTentativasDme}</span><br/><small class="text-muted font-size-10">${tentativasHoje} tent.</small>`
          : `<span title="Tentativas totais no ciclo EA para este DME nesta conta">${tentativasHoje}</span>`;

        const detalheForragens = usaLimiteForragens
          ? `<div class="font-size-10 text-muted" title="Forragens atuais / faixas / limite diario efetivo">${forragensTotal != null && Number.isFinite(forragensTotal) ? forragensTotal : "-"} | ${faixasForragens.map((f: any) => `${f.solucoes || 0}<${f.abaixo_de || 0}`).join("; ")} =&gt; ${limiteSolucoesDiarias}</div>`
          : "";
        const tituloSolucoes = usaLimiteForragens
          ? `${modoRaw === "UNLIMITED" ? "Hoje UK por ciclos completos locais" : "Hoje EA"} / limite diario efetivo por forragens. Limite fixo configurado: ${limiteSolucoesConfigurado}. OK/Falha usa memoria local do plugin.`
          : `${modoRaw === "UNLIMITED" ? "Hoje UK por ciclos completos locais" : "Hoje EA"} / limite diario configurado. OK/Falha usa memoria local do plugin.`;
        const celulaSolucoesDia = limiteSolucoesDiarias > 0
          ? `<span class="${solucoesHoje >= limiteSolucoesDiarias ? "text-success font-weight-600" : ""}" title="${tituloSolucoes}">${solucoesHoje}/${limiteSolucoesDiarias}</span>${detalheForragens}`
          : `<span title="${tituloSolucoes}">${solucoesHoje}</span>${detalheForragens}`;
        const celulaLucroPrevisto = this.renderizarLucroPrevistoAutoDme(meta, null);

        const celulaOkFalha = (tentativasHoje > 0)
          ? `<span class="text-success font-weight-600">${sucessosHoje}</span> / <span class="text-danger">${falhasHoje}</span>${this.renderizarDiagnosticosFalhaAutoDme(meta, falhasHoje)}`
          : `<span class="text-muted">-</span>`;

        const ultimaTentativa = meta.ultima_tentativa_ts
          ? `<span class="font-size-11" title="${new Date(Number(meta.ultima_tentativa_ts)).toISOString()}">${this.formatarDataEstadoAutoDme(Number(meta.ultima_tentativa_ts))}</span>`
          : `<span class="text-muted font-size-11">-</span>`;

        const motivoCodigo: string = meta.motivo_bloqueio ? String(meta.motivo_bloqueio) : "";
        meta.modoRaw = modoRaw;
        meta.repeatabilityMode = modoRaw;
        const disponivelWebApp = motivoCodigo !== "nao_disponivel_webapp";
        const dentroPeriodo = motivoCodigo !== "fora_periodo";
        const badgeDisp = disponivelWebApp
          ? `<span class="badge badge-success" title="Disponível no WebApp">Sim</span>`
          : `<span class="badge badge-danger" title="Não disponível no WebApp">Não</span>`;
        const badgePeriodo = dentroPeriodo
          ? `<span class="badge badge-success" title="Dentro do período configurado">Sim</span>`
          : `<span class="badge badge-danger" title="Fora do período configurado">Não</span>`;
        const celulaDispPeriodo = `${badgeDisp} ${badgePeriodo}`;

        const modoEaConhecido = App.Business.autoDmeModoRepeatabilityConhecido(modoRaw);
        const elegivel = modoEaConhecido
          && statusRaw === "pendente"
          && (!meta.proximo_elegivel_ts || Number(meta.proximo_elegivel_ts) <= agoraMs);
        const celulaElegivel = this.badgeDiagnosticoAutoDme(elegivel);

        const motivoTexto = this.motivoAutoDmeParaHumano(statusRaw, motivoCodigo, meta, agoraMs, expirado, modoRaw);
        const badgeAposAnteriores = meta && meta.executar_somente_quando_dme_anteriores_finalizados
          ? `<span class="badge badge-secondary font-size-10" title="Executa somente quando os DMEs de prioridade menor estiverem concluidos, esgotados ou bloqueados para agora. Cooldown de DME anterior tambem faz este aguardar.">Apos anteriores</span>`
          : "";
        const celulaDetalhes = `
          <div class="conta-diagnostico-detalhes font-size-11">
            <span class="text-muted font-weight-600">Cartas:</span><span>${this.renderizarSuficienciaCartasDme(dme)}</span>
            <span class="text-muted font-weight-600">Ultima:</span><span>${ultimaTentativa}</span>
            <span class="text-muted font-weight-600">Motivo:</span><span>${motivoTexto}</span>
          </div>`;
        const celulaDme = `
          ${celulaIdNome}
          <div class="mt-1">
            <span class="badge badge-primary font-size-10" title="Prioridade: menor numero executa primeiro">Prior. ${prioridade}</span>
            ${modoBadge}
            ${badgeAposAnteriores}
            <span title="Elegivel para execucao agora" class="font-size-10 text-muted">Elegivel a Execucao:</span> ${celulaElegivel}
          </div>`;

        let rowStyle = elegivel ? 'style="background-color: rgba(40,167,69,0.05);"' : "";
        if (!elegivel && motivoCodigo === "limite_tentativas_dme_dia") {
          if (modoRaw === "UNLIMITED" && sucessosHoje > 0) {
            rowStyle = 'style="background-color: rgba(40,167,69,0.06);"';
          } else if (sucessosHoje > 0 && falhasHoje === 0) {
            rowStyle = 'style="background-color: rgba(40,167,69,0.06);"';
          } else if (falhasHoje > 0) {
            rowStyle = 'style="background-color: rgba(255,193,7,0.08);"';
          }
        }
        if (!elegivel && motivoCodigo === "limite_solucoes_dme_dia") {
          rowStyle = 'style="background-color: rgba(40,167,69,0.06);"';
        }
        if (!elegivel && (motivoCodigo === "limite_forragens_clube" || motivoCodigo === "sem_scan_forragens_clube")) {
          rowStyle = 'style="background-color: rgba(255,193,7,0.08);"';
        }

        return `
          <tr ${rowStyle}>
            <td>${celulaDme}</td>
            <td class="col-ciclo">${cicloCelula}</td>
            <td>${celulaSolucoesDia}</td>
            <td class="col-lucro-previsto">${celulaLucroPrevisto}</td>
            <td>${celulaTentativas}</td>
            <td class="col-ok-falha"><div class="conta-diagnostico-ok-falha-scroll">${celulaOkFalha}</div></td>
            <td>${celulaDispPeriodo}</td>
            <td class="col-detalhes">${celulaDetalhes}</td>
          </tr>
        `;
      }).join("");

      body.html(linhas);
    }

    /** Valores `SBCRepeatabilityMode` que permitem ciclo/elegibilidade no diagnóstico (alinhado ao plugin-server). */
    public static autoDmeModoRepeatabilityConhecido(modoUpper: string): boolean {
      const m = (modoUpper || "").toUpperCase();
      return m === "NON_REPEATABLE" || m === "LIMITED" || m === "REFRESH" || m === "UNLIMITED";
    }

    /** `repeatabilityMode` do objeto EA em maiúsculas; string vazia = ausente. */
    public static autoDmeModoRepeatabilityNormalizado(dme: any): string {
      const raw = dme && dme.repeatabilityMode;
      if (raw == null || String(raw).trim() === "") return "";
      return String(raw).trim().toUpperCase();
    }

    /**
     * Heurística de expiração alinhada com `AutoDmeEstado.dmeExpirado` no backend.
     *
     * EA's `endTime` no SBC retornado pelo WebApp pode ser interpretado de duas formas:
     *  - **Unix timestamp em segundos** (>= 1_000_000_000): data/hora absoluta em que o DME expira.
     *  - **Countdown em segundos** (< 1_000_000_000): tempo restante até expirar.
     *
     * Tratar countdown como timestamp unix causa falso "expirado" (o valor em ms fica no passado).
     * Essa função espelha a mesma lógica usada no servidor para manter a UI consistente.
     */
    public static dmeExpiradoHeuristica(dme: any, agoraMs: number): boolean {
      if (!dme) return false;
      if (dme.notExpirable === true) return false;
      const endTime = Number(dme.endTime) || 0;
      if (endTime <= 0) return false;
      const LIMIAR_UNIX_SEGUNDOS = 1000000000;
      if (endTime < LIMIAR_UNIX_SEGUNDOS) {
        return false;
      }
      return endTime * 1000 < agoraMs;
    }

    /** Traduz status + motivo_bloqueio de `_autodme` em frase curta para a coluna "Motivo". */
    private motivoAutoDmeParaHumano(
      status: string,
      motivo: string,
      meta: any,
      agoraMs: number,
      expirado: boolean,
      repeatabilityModeUpper: string = "",
    ): string {
      const modoU = (repeatabilityModeUpper || "").toUpperCase();
      const modoEaOk = App.Business.autoDmeModoRepeatabilityConhecido(modoU);

      if (expirado) return "Bloqueado: DME expirado.";
      if (status === "completo") {
        if (motivo === "limite_solucoes_dme_dia") {
          return this.motivoLimiteSolucoesDmeParaHumano(meta);
        }
        if (modoU === "REFRESH" && meta && meta.proximo_elegivel_ts != null) {
          const ts = Number(meta.proximo_elegivel_ts);
          if (Number.isFinite(ts) && ts > 0) {
            const utcLeg = new Date(ts).toISOString().replace("T", " ").slice(0, 19);
            const localLeg = this.formatarDataEstadoAutoDme(ts);
            let ukLeg = "";
            try {
              const optsUk: any = { timeZone: "Europe/London", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false };
              ukLeg = new Date(ts).toLocaleString("pt-BR", optsUk).replace(",", "");
            } catch (e) { }
            const cicloUk = ukLeg ? `18:00 UK (${ukLeg})` : "18:00 UK";
            const falta = ts > agoraMs
              ? ` Faltam ~${App.Business.formatarTempoRestanteCurto(ts - agoraMs)}.`
              : " Horario de renovacao do ciclo EA ja passou - aguarde novo snapshot da EA.";
            return `DME concluido no ciclo atual (REFRESH). Proxima renovacao do ciclo EA (${cicloUk}): ${utcLeg} UTC | fuso local: ${localLeg}.${falta}`;
          }
        }
        return "DME concluído neste ciclo.";
      }
      if (status === "em_andamento") {
        if (!modoEaOk) {
          return "Execução em andamento; modo EA desconhecido — aguarde snapshot completo.";
        }
        return "Execução em andamento.";
      }
      if (status === "pendente") {
        if (!modoEaOk) {
          if (meta && meta.proximo_elegivel_ts && Number(meta.proximo_elegivel_ts) > agoraMs) {
            return `Em cooldown — libera em ${App.Business.formatarTempoRestanteCurto(Number(meta.proximo_elegivel_ts) - agoraMs)}.`;
          }
          if (modoU === "UNKNOWN") {
            return "Não elegível: Desconhecido no WebApp.";
          }
          if (modoU === "") {
            return "Não elegível: modo de repetição ausente no snapshot da EA.";
          }
          return `Não elegível: modo "${modoU}" não reconhecido para execução automática.`;
        }
        if (meta && meta.proximo_elegivel_ts && Number(meta.proximo_elegivel_ts) > agoraMs) {
          return `Em cooldown — libera em ${App.Business.formatarTempoRestanteCurto(Number(meta.proximo_elegivel_ts) - agoraMs)}.`;
        }
        return "Elegível: atende todas as regras.";
      }
      switch (motivo) {
        case "autodme_inativo": return "Bloqueado: Auto DME desativado no perfil.";
        case "nao_disponivel_webapp": return "Bloqueado: DME não disponível no WebApp agora.";
        case "expirado": return "Bloqueado: DME expirado.";
        case "sem_coins": return "Bloqueado: coins abaixo do mínimo configurado.";
        case "fora_periodo": return "Bloqueado: fora do período de execução configurado.";
        case "limite_solucoes_conta_dia": return "Bloqueado: limite de soluções da conta hoje atingido.";
        case "limite_solucoes_dme_dia": return this.motivoLimiteSolucoesDmeParaHumano(meta);
        case "limite_desafios_conta_dia": return "Bloqueado: limite de desafios da conta hoje atingido.";
        case "limite_tentativas_dme_dia": return this.motivoLimiteTentativasDmeParaHumano(meta);
        case "sem_scan_forragens_clube": return "Inviável: sem scan local de forragens do clube. Sincronize os jogadores do clube para recalcular.";
        case "jogadores_insuficientes_clube": return "Bloqueado: faltaram jogadores suficientes no clube na ultima tentativa. Resete as tentativas Auto DME da conta ou aguarde a virada do dia.";
        case "solver_timeout_temporario": {
          const faltam = meta && meta.proximo_elegivel_ts ? Number(meta.proximo_elegivel_ts) - agoraMs : 0;
          return `Aguardando timeout do solver${faltam > 0 ? ` - libera em ${App.Business.formatarTempoRestanteCurto(faltam)}` : ""}.`;
        }
        case "aguardando_dmes_anteriores_finalizarem": return "Aguardando: DMEs de prioridade anterior ainda podem rodar ou estao em cooldown.";
        case "limite_forragens_clube": {
          const total = meta && meta.forragens_clube_total != null ? Number(meta.forragens_clube_total) : null;
          const faixas = meta && Array.isArray(meta.limites_solucoes_por_forragens) ? meta.limites_solucoes_por_forragens : [];
          const detalhes = faixas.length ? `; faixas ${faixas.map((f: any) => `${f.solucoes || 0}<${f.abaixo_de || 0}`).join("; ")}` : "";
          return `Inviável: forragens insuficientes no clube${total != null && Number.isFinite(total) ? ` (${total})` : ""}${detalhes}.`;
        }
        case "cooldown_tentativa": {
          const faltam = meta && meta.proximo_elegivel_ts ? Number(meta.proximo_elegivel_ts) - agoraMs : 0;
          return `Aguardando intervalo entre tentativas${faltam > 0 ? ` — libera em ${App.Business.formatarTempoRestanteCurto(faltam)}` : ""}.`;
        }
        case "cooldown_dme": {
          const faltam = meta && meta.proximo_elegivel_ts ? Number(meta.proximo_elegivel_ts) - agoraMs : 0;
          return `Aguardando intervalo entre envios${faltam > 0 ? ` — libera em ${App.Business.formatarTempoRestanteCurto(faltam)}` : ""}.`;
        }
        case "limite_global_sistema": return "Bloqueado: limite global do sistema atingido.";
        case "limite_repeats_totais": return "Bloqueado: todas as repetições vitalícias já foram executadas.";
        default: return motivo ? `Bloqueado: ${motivo}.` : "Bloqueado.";
      }
    }

    /**
     * Seção "Regras aplicadas" do modal: confronta limites configurados (perfil + sistema)
     * com os valores atuais do dia para esta conta, indicando quais regras estão atendidas
     * ou bloqueando a execução.
     */
    private renderizarRegrasAplicadasAutoDme(modal: JQuery, dados: any) {
      const wrap = modal.find(".js-estado-tarefa-regras-aplicadas-wrap");
      const body = modal.find(".js-estado-tarefa-regras-aplicadas-body");
      if (!dados) { wrap.hide(); return; }

      const linhas: string[] = [];
      const renderLinha = (regra: string, configurado: string | number, atual: string | number, status: "ok" | "warn" | "bad" | "info") => {
        const badgeClass = status === "ok" ? "badge-success" : (status === "bad" ? "badge-danger" : (status === "warn" ? "badge-warning" : "badge-secondary"));
        const badgeText = status === "ok" ? "OK" : (status === "bad" ? "Bloqueado" : (status === "warn" ? "Atenção" : "Info"));
        linhas.push(`
          <tr>
            <td class="font-size-12">${regra}</td>
            <td class="font-size-12">${configurado}</td>
            <td class="font-size-12">${atual}</td>
            <td><span class="badge ${badgeClass} font-size-10">${badgeText}</span></td>
          </tr>
        `);
      };

      const g = dados.limitesGlobais;
      if (g) {
        if (g.tarefaLigadaAutoDme) {
          renderLinha("Tarefa Auto DME (sistema)", g.tarefaLigadaAutoDme.exigido ? "Ligada" : "—", g.tarefaLigadaAutoDme.ok ? "Ligada" : "Desligada", g.tarefaLigadaAutoDme.ok ? "ok" : "bad");
        }
        if (g.dmesUnicosHojePlugin || g.dmesUnicos24hPlugin) {
          const d = g.dmesUnicosHojePlugin || g.dmesUnicos24hPlugin;
          const cfg = d.limiteAtivo ? String(d.limite) : "desativado";
          renderLinha("DMEs únicos hoje (plugin)", cfg, String(d.uso), d.atingido ? "bad" : "ok");
        }
        if (g.desafiosHojePlugin || g.desafios24hPlugin) {
          const d = g.desafiosHojePlugin || g.desafios24hPlugin;
          const cfg = d.limiteAtivo ? String(d.limite) : "desativado";
          renderLinha("Desafios hoje (plugin)", cfg, String(d.uso), d.atingido ? "bad" : "ok");
        }
        if (g.intervaloMinutosExecucaoAutodmeContaGlobal) {
          const iv = g.intervaloMinutosExecucaoAutodmeContaGlobal;
          const cfg = iv.minutosExigidos != null ? `${iv.minutosExigidos} min` : "sem intervalo";
          const atual = iv.minutosReferenciaIntervalo != null && Number.isFinite(iv.minutosReferenciaIntervalo)
            ? `${(iv.minutosReferenciaIntervalo as number).toFixed(1)} min desde último`
            : "-";
          renderLinha("Intervalo entre DMEs (sistema)", cfg, atual, iv.ok ? "ok" : "warn");
        }
      }

      const p = dados.limitesPorConta;
      if (p) {
        const s = p.solucoesDmesDia || p.solucoesDmes24h;
        if (s) {
          const cfg = s.limiteAtivo ? String(s.limite) : "desativado";
          renderLinha("Soluções de DME (conta/dia)", cfg, String(s.uso), s.atingido ? "bad" : "ok");
        }
        const tt = p.tentativasDia || p.tentativas24h;
        if (tt) {
          const rotulo = tt.porDme ? "Tentativas por DME (conta+DME/dia)" : "Tentativas DME (conta/dia)";
          const cfg = tt.limiteAtivo ? String(tt.limite) : "desativado";
          renderLinha(rotulo, cfg, String(tt.uso), tt.atingido ? "bad" : "ok");
        }
        const df = p.desafiosDia || p.desafios24h;
        if (df) {
          const cfg = df.limiteAtivo ? String(df.limite) : "desativado";
          renderLinha("Desafios (conta/dia)", cfg, String(df.uso), df.atingido ? "bad" : "ok");
        }
        const is = p.intervaloProximaSolucaoDme;
        if (is) {
          const cfg = is.minutosExigidos != null ? `${is.minutosExigidos} min` : "sem intervalo";
          const atual = is.minutosDesdeUltimoEnvio != null && Number.isFinite(is.minutosDesdeUltimoEnvio)
            ? `${(is.minutosDesdeUltimoEnvio as number).toFixed(1)} min`
            : "-";
          renderLinha("Intervalo entre envios (perfil)", cfg, atual, is.ok ? "ok" : "warn");
        }
        const it = p.intervaloProximaTentativa;
        if (it) {
          const cfg = it.minutosExigidos != null ? `${it.minutosExigidos} min` : "sem intervalo";
          renderLinha("Intervalo entre tentativas (perfil)", cfg, it.ok ? "OK" : "Aguardando", it.ok ? "ok" : "warn");
        }
      }

      if (!linhas.length) {
        wrap.hide();
        return;
      }
      body.html(linhas.join(""));
      wrap.show();
    }

    /**
     * Seção "Eventos recentes Auto DME" (observabilidade): renderiza os últimos logs
     * AUTO_DME_DECISAO emitidos pelo backend para a conta em foco. O backend expõe estes
     * eventos no campo `dados.eventosAutoDmeRecentes` do diagnóstico.
     */
    private renderizarEventosAutoDmeRecentes(modal: JQuery, dados: any) {
      const wrap = modal.find(".js-estado-tarefa-eventos-autodme-wrap");
      const body = modal.find(".js-estado-tarefa-eventos-autodme-body");
      const payloadTop = this.diagnosticoContaTarefasAtual || {};
      const eventos: any[] = Array.isArray(payloadTop.eventosAutoDmeRecentes)
        ? payloadTop.eventosAutoDmeRecentes
        : (Array.isArray(dados && dados.eventosAutoDmeRecentes) ? dados.eventosAutoDmeRecentes : []);
      if (!eventos.length) {
        wrap.hide();
        body.html("");
        return;
      }

      const linhas = eventos.map((ev: any) => {
        const when = ev.ts ? this.formatarDataEstadoAutoDme(ev.ts) : "-";
        const decisao = ev.decisao ? this.escapeHtmlEstadoDme(String(ev.decisao)) : "-";
        const dmeNome = ev.nome_dme ? this.escapeHtmlEstadoDme(String(ev.nome_dme)) : "";
        const idDme = ev.id_dme != null ? `#${ev.id_dme}` : "";
        const celulaDme = `${dmeNome} <small class="text-muted">${idDme}</small>`;
        const detalhes = ev.detalhes ? this.escapeHtmlEstadoDme(String(ev.detalhes)) : (ev.motivo ? this.escapeHtmlEstadoDme(String(ev.motivo)) : "-");
        return `
          <tr>
            <td class="font-size-12 text-muted">${when}</td>
            <td class="font-size-12"><span class="badge badge-primary">${decisao}</span></td>
            <td class="font-size-12">${celulaDme}</td>
            <td class="font-size-12">${detalhes}</td>
          </tr>`;
      }).join("");

      body.html(linhas);
      wrap.show();
    }

    /**
     * Tabela unificada do modal de diagnóstico Auto DME.
     *
     * Consome prioritariamente `dmesConta` (IDmeContaItem[] — objeto EA nativo + _autodme)
     * vindo direto do backend na nova arquitetura Auto DME. Quando ausente, faz fallback
     * ao caminho legado (selecao.itens + detalhesPorDmeHoje) para compatibilidade durante a
     * transição.
     *
     * Conceito de progresso (alinhado ao backend/`AutoDmeEstado`):
     *  - NON_REPEATABLE → challengesCompletedCount / challengesCount
     *  - LIMITED        → timesCompleted / repeats  (cumulativo vitalício)
     *  - REFRESH        → timesCompletedInInterval / repeats  (dentro do ciclo atual)
     *  - UNLIMITED      → ciclos completos hoje UK por desafios enviados; OK/Falha usa memoria local
     */
    private renderizarTabelaUnificadaDmesAutoDme(modal: JQuery, selecao: any, detalhesDme: any[], dmesConta: IDmeContaItem[] = [], dados: any = null) {
      if (Array.isArray(dmesConta) && dmesConta.length > 0) {
        this.renderizarTabelaUnificadaDmesAutoDmeNova(modal, selecao, dmesConta, dados);
        return;
      }
      const container = modal.find(".js-estado-tarefa-dmes-unificados-container");
      const resumoEl = modal.find(".js-estado-tarefa-dmes-unificados-resumo");
      const body = modal.find(".js-estado-tarefa-dmes-unificados-body");

      // Indexa detalhes do dia por idDme para mesclagem
      const detalhePorIdDme = new Map<number, any>();
      if (Array.isArray(detalhesDme)) {
        detalhesDme.forEach((d: any) => {
          if (d.idDme != null) detalhePorIdDme.set(Number(d.idDme), d);
        });
      }

      // Usa itens da seleção como base; complementa com itens do dia que não estejam na seleção
      let itensBase: any[] = [];
      const idsVistos = new Set<number>();

      if (selecao && Array.isArray(selecao.itens) && selecao.itens.length) {
        itensBase = selecao.itens;
        selecao.itens.forEach((i: any) => { if (i.id_dme != null) idsVistos.add(Number(i.id_dme)); });
      }

      // Adiciona DMEs que aparecem apenas nos detalhes do dia (não configurados no perfil)
      detalhesDme.forEach((d: any) => {
        const id = Number(d.idDme);
        if (!idsVistos.has(id)) {
          itensBase.push({ id_dme: id, nomeDme: d.nomeDme, prioridade: d.prioridade, somenteDia: true });
        }
      });

      if (!itensBase.length) {
        container.show();
        resumoEl.html('<span class="text-muted">Nenhum DME configurado no perfil desta conta.</span>');
        body.html(`<tr><td colspan="10" class="text-muted font-size-12">Sem DMEs configurados.</td></tr>`);
        return;
      }

      const totalConfigurados = selecao ? (selecao.totalConfigurados || itensBase.length) : itensBase.length;
      const totalElegiveis = selecao ? (selecao.totalElegiveis || 0) : 0;
      const escolhido = selecao ? (selecao.dmeEscolhido || null) : null;
      const nomeEscolhido = escolhido
        ? `${escolhido.nome ? this.escapeHtmlEstadoDme(String(escolhido.nome)) + " " : ""}#${(typeof escolhido.id_dme !== "undefined" && escolhido.id_dme !== null) ? escolhido.id_dme : "-"} (prior. ${(typeof escolhido.prioridade !== "undefined" && escolhido.prioridade !== null) ? escolhido.prioridade : "-"})`
        : `<span class="text-danger font-size-12">nenhum elegível agora</span>`;
      resumoEl.html(`Configurados: <strong>${totalConfigurados}</strong> | Elegíveis: <strong>${totalElegiveis}</strong> | Próximo: <strong>${nomeEscolhido}</strong>`);


      const linhas = itensBase.map((item: any) => {
        const idDme = item.id_dme != null ? Number(item.id_dme) : null;
        const det = idDme != null ? (detalhePorIdDme.get(idDme) || null) : null;

        const prioridade = item.prioridade != null ? item.prioridade : (det && typeof det.prioridade !== "undefined" && det.prioridade !== null ? det.prioridade : "-");
        const nome = (item.nome && String(item.nome).trim())
          ? this.escapeHtmlEstadoDme(String(item.nome).trim())
          : (det && det.nomeDme ? this.escapeHtmlEstadoDme(String(det.nomeDme)) : `<span class="text-muted">-</span>`);
        const celulaIdNome = `<div class="font-weight-600 font-size-12">${nome}</div><small class="text-muted">#${idDme !== null ? idDme : "-"}</small>`;

        // Modo de recorrência
        let repeatabilityModeSource: any = "NON_REPEATABLE";
        if (typeof item.repeatabilityMode !== "undefined" && item.repeatabilityMode !== null) {
          repeatabilityModeSource = item.repeatabilityMode;
        } else if (det && typeof det.repeatabilityMode !== "undefined" && det.repeatabilityMode !== null) {
          repeatabilityModeSource = det.repeatabilityMode;
        }
        const modoRaw = String(repeatabilityModeSource).toUpperCase();
        let modoBadge: string;
        if (modoRaw === "NON_REPEATABLE") {
          modoBadge = `<span class="badge badge-secondary font-size-10" title="Executa uma única vez por ciclo">Único</span>`;
        } else if (modoRaw === "UNLIMITED") {
          modoBadge = `<span class="badge badge-info font-size-10" title="Repetições ilimitadas">Ilimitado</span>`;
        } else if (modoRaw === "REFRESH") {
          let rep = (typeof item.repeats !== "undefined" && item.repeats !== null) ? item.repeats : (det && typeof det.repeats !== "undefined" && det.repeats !== null ? det.repeats : undefined);
          modoBadge = `<span class="badge badge-primary font-size-10" title="Repete ${typeof rep !== "undefined" ? rep : "?"}x por ciclo">${typeof rep !== "undefined" && rep !== null ? `Refresh (${rep}x)` : "Refresh"}</span>`;
        } else {
          const desconhecido = modoRaw === "" || modoRaw === "UNKNOWN";
          const texto = desconhecido ? "Desconhecido" : modoRaw;
          const cor = desconhecido ? "badge-warning" : "badge-light";
          modoBadge = `<span class="badge ${cor} font-size-10">${texto}</span>`;
        }

        // Ciclo EA — progresso consolidado pela renovacao 18:00 UK
        const desafiosHoje = det && typeof det.quantidadeDesafiosHoje !== "undefined" && det.quantidadeDesafiosHoje !== null ? det.quantidadeDesafiosHoje : 0;
        let tcCiclo = null;
        if (det && typeof det.timesCompletedNoCiclo !== "undefined" && det.timesCompletedNoCiclo !== null) {
          tcCiclo = det.timesCompletedNoCiclo;
        } else if (typeof item.timesCompletedNoCiclo !== "undefined" && item.timesCompletedNoCiclo !== null) {
          tcCiclo = item.timesCompletedNoCiclo;
        }
        let repeats = (typeof item.repeats !== "undefined" && item.repeats !== null) ? item.repeats : (det && typeof det.repeats !== "undefined" && det.repeats !== null ? det.repeats : null);
        let limiteDiario = null;
        if (typeof item.limiteSolucoesDiariasCadastro !== "undefined" && item.limiteSolucoesDiariasCadastro !== null) {
          limiteDiario = item.limiteSolucoesDiariasCadastro;
        } else if (det && typeof det.limiteSolucoesDiarias !== "undefined" && det.limiteSolucoesDiarias !== null) {
          limiteDiario = det.limiteSolucoesDiarias;
        }

        let celulaCiclo: string;
        if (modoRaw === "NON_REPEATABLE") {
          // Tenta obter o total de desafios do DME (snapshot do jogo via det ou item)
          const totalDesafiosDet = det && typeof det.totalDesafiosDme === "number" && det.totalDesafiosDme > 0
            ? det.totalDesafiosDme
            : null;
          const totalDesafiosItem = typeof (item as any).totalDesafiosDme === "number" && (item as any).totalDesafiosDme > 0
            ? (item as any).totalDesafiosDme
            : null;
          const totalDesafiosSnap: number | null = totalDesafiosDet !== null ? totalDesafiosDet : totalDesafiosItem;
          const concluidoNoDia = det && typeof det.concluidoNoDia !== "undefined" ? !!det.concluidoNoDia : desafiosHoje > 0;
          if (totalDesafiosSnap !== null && totalDesafiosSnap > 1) {
            // DME único com múltiplos desafios — mostra X/N com barra
            const feitosClip = Math.min(desafiosHoje, totalDesafiosSnap);
            const pct = Math.min(100, Math.round((feitosClip / totalDesafiosSnap) * 100));
            const cor = feitosClip >= totalDesafiosSnap ? "bg-success" : (feitosClip > 0 ? "bg-info" : "bg-secondary");
            celulaCiclo = `
              <span class="font-weight-600 font-size-12">${feitosClip}/${totalDesafiosSnap} desafios</span>
              <div class="progress mt-1" style="height:4px;width:56px">
                <div class="progress-bar ${cor}" style="width:${pct}%"></div>
              </div>`;
          } else {
            celulaCiclo = concluidoNoDia
              ? `<span class="badge badge-success font-size-10">✓ Concluído</span>`
              : (desafiosHoje > 0
                ? `<span class="badge badge-info font-size-10">${desafiosHoje} desafio(s)</span>`
                : `<span class="badge badge-secondary font-size-10">○ Pendente</span>`);
          }
        } else if (modoRaw === "REFRESH" && repeats !== null) {
          const feitas = tcCiclo !== null ? tcCiclo : desafiosHoje;
          const pct = Math.min(100, Math.round((feitas / repeats) * 100));
          const cor = feitas >= repeats ? "bg-success" : (feitas > 0 ? "bg-info" : "bg-secondary");
          celulaCiclo = `
            <span class="font-weight-600 font-size-12">${feitas}/${repeats}</span>
            <div class="progress mt-1" style="height:4px;width:56px">
              <div class="progress-bar ${cor}" style="width:${pct}%"></div>
            </div>`;
        } else if (modoRaw === "UNLIMITED") {
          const meta = limiteDiario !== null ? limiteDiario : null;
          const metaAuto = (item as any)._autodme || {};
          const totalDesafiosCiclo = Math.max(1, Number(metaAuto.desafios_por_ciclo || (item as any).challengesCount || (item as any).totalDesafiosDme || (det && det.totalDesafiosDme) || 1));
          const desafiosLocaisHoje = Math.max(0, Number(metaAuto.desafios_locais_hoje != null ? metaAuto.desafios_locais_hoje : desafiosHoje) || 0);
          const parciaisCicloAtual = metaAuto.desafios_parciais_ciclo_atual != null
            ? Math.max(0, Number(metaAuto.desafios_parciais_ciclo_atual) || 0)
            : (desafiosLocaisHoje % totalDesafiosCiclo);
          const solucoesHojeEa = Math.max(0, Number(
            metaAuto.solucoes_hoje != null
              ? metaAuto.solucoes_hoje
              : Math.floor(desafiosLocaisHoje / totalDesafiosCiclo)
          ) || 0);
          const totalLabel = meta !== null && Number(meta) > 0 ? String(meta) : "&#8734;";
          const pctBase = meta !== null && Number(meta) > 0 ? Number(meta) : Math.max(1, solucoesHojeEa || 1);
          const pct = solucoesHojeEa > 0 ? Math.min(100, Math.round((solucoesHojeEa / pctBase) * 100)) : 0;
          const cor = meta !== null && Number(meta) > 0 && solucoesHojeEa >= Number(meta) ? "bg-success" : (solucoesHojeEa > 0 ? "bg-info" : "bg-secondary");
          const titleHojeUk = `DME ilimitado: ciclos completos hoje UK por desafios enviados. Desafios enviados hoje: ${desafiosLocaisHoje}; desafios por ciclo: ${totalDesafiosCiclo}; parcial atual local: ${parciaisCicloAtual}/${totalDesafiosCiclo}.`;
          if (meta !== null) {
            celulaCiclo = `
              <span class="font-weight-600 font-size-12" title="${titleHojeUk}">Hoje UK: ${solucoesHojeEa}/${totalLabel}</span>
              <div class="progress mt-1" style="height:4px;width:56px">
                <div class="progress-bar ${cor}" style="width:${pct}%"></div>
              </div>`;
          } else {
            celulaCiclo = `
              <span class="font-weight-600 font-size-12" title="${titleHojeUk}">Hoje UK: ${solucoesHojeEa}/${totalLabel}</span>
              <div class="progress mt-1" style="height:4px;width:56px">
                <div class="progress-bar ${cor}" style="width:${pct}%"></div>
              </div>`;
          }
        } else {
          celulaCiclo = `<span class="text-muted font-size-12">-</span>`;
        }

        // Tentativas
        let tentativasHoje = 0;
        if (typeof item.tentativasHoje !== "undefined" && item.tentativasHoje !== null) {
          tentativasHoje = item.tentativasHoje;
        } else if (det && typeof det.quantidadeTentativasHoje !== "undefined" && det.quantidadeTentativasHoje !== null) {
          tentativasHoje = det.quantidadeTentativasHoje;
        }

        // OK / Falha
        const metaDiagFalha = (item as any).ultimoDiagnostico || (item as any).ultimo_diagnostico || (item as any).diagnostic || ((item as any)._autodme ? ((item as any)._autodme.ultimo_diagnostico || (item as any)._autodme.diagnostic) : null);
        const sucesso = det && typeof det.quantidadeTentativasSucessoHoje !== "undefined" && det.quantidadeTentativasSucessoHoje !== null
          ? det.quantidadeTentativasSucessoHoje
          : (typeof item.sucessosHoje !== "undefined" && item.sucessosHoje !== null ? item.sucessosHoje : ((item as any)._autodme && (item as any)._autodme.sucessos_hoje != null ? (item as any)._autodme.sucessos_hoje : 0));
        let falha = det && typeof det.quantidadeTentativasFalhaHoje !== "undefined" && det.quantidadeTentativasFalhaHoje !== null
          ? det.quantidadeTentativasFalhaHoje
          : (typeof item.falhasHoje !== "undefined" && item.falhasHoje !== null ? item.falhasHoje : ((item as any)._autodme && (item as any)._autodme.falhas_hoje != null ? (item as any)._autodme.falhas_hoje : 0));
        if (falha <= 0 && sucesso <= 0 && tentativasHoje > 0 && metaDiagFalha) {
          falha = Math.max(1, tentativasHoje);
        }

        const limiteTent = (typeof item.limiteTentativasDia !== "undefined" && item.limiteTentativasDia !== null) ? item.limiteTentativasDia : null;
        let celulaTentativas: string;
        if (limiteTent !== null) {
          const cor = falha >= limiteTent ? "text-danger font-weight-600" : (falha > 0 ? "text-warning" : "");
          celulaTentativas = `<span class="${cor}" title="Falhas no ciclo EA / limite de falhas. Tentativas totais: ${tentativasHoje}">${falha}/${limiteTent}</span><br/><small class="text-muted font-size-10">${tentativasHoje} tent.</small>`;
          if (falha >= limiteTent) {
            celulaTentativas += `<br/><small class="text-danger font-size-10">Limite de falhas atingido</small>`;
          }
        } else {
          celulaTentativas = `<span title="Tentativas totais no ciclo EA">${tentativasHoje}</span>`;
        }

        const celulaOkFalha = (sucesso + falha) > 0
          ? `<span class="text-success font-weight-600">${sucesso}</span> / <span class="text-danger">${falha}</span>${this.renderizarDiagnosticosFalhaAutoDme(Object.assign({}, item, (item as any)._autodme || {}), falha)}`
          : `<span class="text-muted">-</span>`;

        // Última tentativa
        const metaLucroPrevisto = Object.assign({}, det || {}, item || {}, (item as any)._autodme || {});
        const celulaLucroPrevisto = this.renderizarLucroPrevistoAutoDme(metaLucroPrevisto, det);

        let ultimaTentativa = null;
        if (typeof item.ultimaTentativa !== "undefined" && item.ultimaTentativa !== null) {
          ultimaTentativa = item.ultimaTentativa;
        } else if (det && typeof det.ultimaExecucaoDesafio !== "undefined" && det.ultimaExecucaoDesafio !== null) {
          ultimaTentativa = det.ultimaExecucaoDesafio;
        }
        const celulaUltima = ultimaTentativa ? `<span class="font-size-11 text-muted">${this.formatarDataEstadoAutoDme(ultimaTentativa)}</span>` : `<span class="text-muted font-size-11">-</span>`;

        // Disponível / Período
        const dispNoWebApp = !!item.disponivelNoWebApp;
        const dentroPeriodo = item.dentroPeriodo !== false;
        let celulaDisp: string;
        if (!item.somenteDia) {
          celulaDisp = `${this.badgeDiagnosticoAutoDme(dispNoWebApp)} ${this.badgeDiagnosticoAutoDme(dentroPeriodo)}`;
        } else {
          celulaDisp = `<span class="text-muted font-size-11">-</span>`;
        }

        // Elegível
        const elegivel = !!item.elegivelPorPrioridade;
        const celulaElegivel = item.somenteDia ? `<span class="text-muted font-size-11">-</span>` : this.badgeDiagnosticoAutoDme(elegivel);

        // Motivo
        const motivoTexto = item.somenteDia
          ? "Apenas estatística do dia — não configurado no perfil"
          : this.escapeHtmlEstadoDme(this.getMotivoElegibilidadeSelecaoPrioridadeUnificado(item));
        const badgeAposAnteriores = item && (item.executar_somente_quando_dme_anteriores_finalizados || (item._autodme && item._autodme.executar_somente_quando_dme_anteriores_finalizados))
          ? `<span class="badge badge-secondary font-size-10" title="Executa somente quando os DMEs de prioridade menor estiverem concluidos, esgotados ou bloqueados para agora. Cooldown de DME anterior tambem faz este aguardar.">Apos anteriores</span>`
          : "";
        const celulaDetalhes = `
          <div class="conta-diagnostico-detalhes font-size-11">
            <span class="text-muted font-weight-600">Cartas:</span><span>${this.renderizarSuficienciaCartasDme(item)}</span>
            <span class="text-muted font-weight-600">Ultima:</span><span>${celulaUltima}</span>
            <span class="text-muted font-weight-600">Motivo:</span><span>${motivoTexto}</span>
          </div>`;
        const celulaDme = `
          ${celulaIdNome}
          <div class="mt-1">
            <span class="badge badge-primary font-size-10" title="Prioridade: menor numero executa primeiro">Prior. ${prioridade}</span>
            ${modoBadge}
            ${badgeAposAnteriores}
            <span title="Elegivel para execucao agora" class="font-size-10 text-muted">Elegivel a Execucao:</span> ${celulaElegivel}
          </div>`;

        const rowClass = elegivel ? "" : (item.somenteDia ? "text-muted" : "");
        const rowStyle = elegivel ? 'style="background-color: rgba(40,167,69,0.05);"' : "";

        return `
          <tr class="${rowClass}" ${rowStyle}>
            <td>${celulaDme}</td>
            <td class="col-ciclo">${celulaCiclo}</td>
            <td><span class="text-muted font-size-11">-</span></td>
            <td class="col-lucro-previsto">${celulaLucroPrevisto}</td>
            <td>${celulaTentativas}</td>
            <td class="col-ok-falha"><div class="conta-diagnostico-ok-falha-scroll">${celulaOkFalha}</div></td>
            <td>${celulaDisp}</td>
            <td class="col-detalhes">${celulaDetalhes}</td>
          </tr>
        `;
      }).join("");

      container.show();
      body.html(linhas);
    }

    private getMotivoElegibilidadeSelecaoPrioridadeUnificado(item: any): string {
      if (!item) return "-";
      const metaDiag = (item as any).ultimoDiagnostico || (item as any).ultimo_diagnostico || (item as any).diagnostic || ((item as any)._autodme ? ((item as any)._autodme.ultimo_diagnostico || (item as any)._autodme.diagnostic) : null);
      const diagTitle = metaDiag && (metaDiag.diagnosticTitle || metaDiag.diagnosticCode)
        ? Business.normalizarTextoDiagnosticoAutoDme(metaDiag.diagnosticTitle || metaDiag.diagnosticCode)
        : "";
      const diagMessage = metaDiag && metaDiag.diagnosticMessage
        ? Business.normalizarTextoDiagnosticoAutoDme(metaDiag.diagnosticMessage)
        : "";
      if (item.limiteTentativasAtingido) {
        return this.motivoLimiteTentativasDmeParaHumano(this.metaLegadoLimiteTentativasDme(item, metaDiag));
      }
      if (item.motivoRecorrencia && String(item.motivoRecorrencia).trim() === "limite_tentativas_dme_atingido") {
        return this.motivoLimiteTentativasDmeParaHumano(this.metaLegadoLimiteTentativasDme(item, metaDiag));
      }
      if (item.motivoRecorrencia && String(item.motivoRecorrencia).trim() && item.motivoRecorrencia !== "ok") {
        const m = String(item.motivoRecorrencia).trim();
        if (m === "aguardando_dmes_anteriores_finalizarem") return "Aguardando: DMEs de prioridade anterior ainda podem rodar ou estao em cooldown.";
        if (m === "nao_repetivel_ja_concluido" || m === "nao_repetivel") return "Bloqueado: DME único já concluído neste ciclo.";
        if (m === "limite_diario_atingido") {
          const lim = (typeof item.limiteSolucoesDiariasCadastro !== "undefined" && item.limiteSolucoesDiariasCadastro !== null) ? item.limiteSolucoesDiariasCadastro : "-";
          const uso = (typeof item.solucoesHoje !== "undefined" && item.solucoesHoje !== null) ? item.solucoesHoje : 0;
          return `Bloqueado: limite diário de soluções atingido (${uso}/${lim}).`;
        }
        if (m === "aguardando_refresh" || m === "limite_repeticoes_ciclo") {
          const rep = (typeof item.repeats !== "undefined" && item.repeats !== null) ? item.repeats : "-";
          const feitas = (typeof item.timesCompletedNoCiclo !== "undefined" && item.timesCompletedNoCiclo !== null) ? item.timesCompletedNoCiclo : "-";
          return `Bloqueado: ciclo completo (${feitas}/${rep} feitos). Aguardando janela de refresh.`;
        }
      }
      if (item.elegivelPorPrioridade) return "Elegível: atende todas as regras.";
      if (diagTitle || diagMessage) return `${diagTitle || "Diagnóstico"}${diagMessage ? `: ${diagMessage}` : ""}`;
      if (!item.idValido) return "Bloqueado: id_dme inválido ou não informado.";
      if (!item.disponivelNoWebApp) return "Bloqueado: DME não disponível no WebApp agora.";
      if (!item.dentroPeriodo) return "Bloqueado: fora do período configurado.";
      return "Bloqueado por regra de seleção.";
    }

    private metaLegadoLimiteTentativasDme(item: any, diagnostico: any): any {
      const meta = item && item._autodme ? item._autodme : {};
      return {
        tentativas_hoje: (typeof item.tentativasHoje !== "undefined" && item.tentativasHoje !== null)
          ? item.tentativasHoje
          : (meta.tentativas_hoje != null ? meta.tentativas_hoje : 0),
        sucessos_hoje: (typeof item.sucessosHoje !== "undefined" && item.sucessosHoje !== null)
          ? item.sucessosHoje
          : (meta.sucessos_hoje != null ? meta.sucessos_hoje : 0),
        falhas_hoje: (typeof item.falhasHoje !== "undefined" && item.falhasHoje !== null)
          ? item.falhasHoje
          : (meta.falhas_hoje != null ? meta.falhas_hoje : null),
        limite_tentativas_dia: (typeof item.limiteTentativasDia !== "undefined" && item.limiteTentativasDia !== null)
          ? item.limiteTentativasDia
          : (meta.limite_tentativas_dia != null ? meta.limite_tentativas_dia : null),
        ultimo_diagnostico: diagnostico || meta.ultimo_diagnostico || meta.diagnostic || null,
        repeatabilityMode: item.repeatabilityMode || meta.repeatabilityMode || meta.modoRaw || "",
      };
    }

    private formatarDataEstadoAutoDme(data: any): string {
      if (data == null || data === "" || data === 0) return "-";
      try {
        const n = typeof data === "number" ? data : (typeof data === "string" && /^\d{10,}$/.test(data.trim()) ? Number(data) : NaN);
        if (!isNaN(n) && n > 0) {
          return new Date(n).toLocaleString("pt-BR");
        }
        const parsed = new Date(`${data} UTC`);
        if (!isNaN(parsed.getTime())) return parsed.toLocaleString("pt-BR");
        const parsed2 = new Date(data);
        if (!isNaN(parsed2.getTime())) return parsed2.toLocaleString("pt-BR");
        return "-";
      } catch (e) {
        return "-";
      }
    }

    private iniciarEstatisticas(historicoConsolidado: IContaConsolidado[]) {
      if (!historicoConsolidado.length) {
        return;
      }

      historicoConsolidado = historicoConsolidado.map((consolidado: IContaConsolidado) => {
        const scansClube = Number(consolidado.scans_clube);
        return {
          ...consolidado,
          scans_clube: Number.isFinite(scansClube) ? scansClube : 0,
        };
      });

      this.chartJsLucro = this.iniciarEstatiticasDinamico("graficoEstatisticasLucro", historicoConsolidado, 'lucro', 'Lucro', 'Lucro Diário', this.chartJsLucro)
      this.chartJsCaptchas = this.iniciarEstatiticasDinamico("graficoEstatisticasCaptchas", historicoConsolidado, 'captchas', 'Captchas', 'Captchas Diário', this.chartJsCaptchas, null, null, null, { positivo: "#ffb60094", negativo: "#c6c6c694" })
      this.chartJsRequests = this.iniciarEstatiticasDinamico("graficoEstatisticasRequests", historicoConsolidado, 'requests', 'Requests', 'Requests Diário', this.chartJsRequests, null, null, null, { positivo: "#da6aff94", negativo: "#c6c6c694" })

      this.chartJsScansClube = this.iniciarEstatiticasDinamico("graficoEstatisticasScansClube", historicoConsolidado, 'scans_clube', 'Scans Clube', 'Scans Clube Diário', this.chartJsScansClube, null, null, null, { positivo: "#67d6e894", negativo: "#c6c6c694" })

      if (!this.infoPlanoAtual.ehPlanoCloud) {
        this.chartJsVendasApi = this.iniciarEstatiticasDinamico("graficoEstatisticasVendasApi", historicoConsolidado, 'venda_coins.itens_vendidos', 'Vendas Api', 'Vendas Api Diária', this.chartJsVendasApi, null, null, null, { positivo: "#aac18a", negativo: "#c6c6c694" })
      }

      this.chartJsTempoUso = this.iniciarEstatiticasDinamico("graficoEstatisticasTempoUso", historicoConsolidado, 'tempo_execucao', 'Tempo Uso', 'Tempo uso diário', this.chartJsTempoUso, null, (tempo_execucao: any) => {
        var consolidadoProgressoTempoExecucao = this.getProgressoConsolidadoTempoExecucao(tempo_execucao)
        return consolidadoProgressoTempoExecucao.tempo + ' ' + consolidadoProgressoTempoExecucao.labelAbreviado;
      }, (mediaTotal: any) => {
        var mili = Util.parseSegundosParaMilisegundos(mediaTotal)
        return Util.getDescricaoHumanaMilissegundos(mili);
      }, { positivo: "#d9bd8494", negativo: "#c6c6c694" })

      this.chartJsComprasBuscas = this.iniciarEstatiticasComprasBuscas("graficoEstatisticasComprasBuscas", historicoConsolidado, this.chartJsComprasBuscas, null, (valor: any, context: any) => {
        // return valor + " " + context.dataset.label;
        return valor;
      })

      $("#modalEstatisticas").modal("show")
    }

    private iniciarEstatiticasComprasBuscas(seletorId: string, historicoConsolidado: any[], varGlobal: any = null, metodoFormatValue: any = null, metodoFormatDataLabels: any = null) {
      let labels = [];
      let backgroundColorsCompras = [];
      let backgroundColorsBuscas = [];
      let dadosCompras = [];
      let dadosBuscas = [];
      let totalCompras: any = 0;
      let totalBuscas: any = 0;
      let mediaCompras: any = 0;
      let mediaBuscas: any = 0;
      for (let consolidado of historicoConsolidado) {
        labels.push(consolidado.created_at)
        let dadoHistCompras = metodoFormatValue ? metodoFormatValue(consolidado.compras) : consolidado.compras;
        let dadoHistBuscas = metodoFormatValue ? metodoFormatValue(consolidado.buscas) : consolidado.buscas;
        totalCompras += dadoHistCompras
        totalBuscas += dadoHistBuscas
        dadosCompras.push(metodoFormatValue ? metodoFormatValue(consolidado.compras) : consolidado.compras)
        dadosBuscas.push(metodoFormatValue ? metodoFormatValue(consolidado.buscas) : consolidado.buscas)
        if (dadoHistCompras < 0) {
          backgroundColorsCompras.push("#f7446a94")
        } else {
          backgroundColorsCompras.push("#55f1cd9c")
        }
        if (dadoHistBuscas < 0) {
          backgroundColorsBuscas.push("##ffb60094")
        } else {
          backgroundColorsBuscas.push("#5c9aff9c")
        }
      }
      mediaCompras = totalCompras / historicoConsolidado.length
      mediaBuscas = totalBuscas / historicoConsolidado.length
      this.updateViewItemEstatistica(parseInt(totalCompras), $(`.info-total-compras`));
      this.updateViewItemEstatistica(parseInt(mediaCompras), $(`.info-media-compras`));

      this.updateViewItemEstatistica(parseInt(totalBuscas), $(`.info-total-buscas`));
      this.updateViewItemEstatistica(parseInt(mediaBuscas), $(`.info-media-buscas`));

      let data = {
        labels: labels,
        datasets: [{
          label: "Compras",
          data: dadosCompras,
          backgroundColor: backgroundColorsCompras,
          borderColor: backgroundColorsCompras,
          borderWidth: 0
        },
        {
          label: "Buscas",
          data: dadosBuscas,
          backgroundColor: backgroundColorsBuscas,
          borderColor: backgroundColorsBuscas,
          borderWidth: 0
        }]
      }

      if (varGlobal) {
        varGlobal.destroy();
        varGlobal = null
      }

      let classChartJs = new ChartJs();
      varGlobal = classChartJs.inicializarCampo(seletorId, data, "Compras / Buscas", metodoFormatDataLabels);
      return varGlobal
    }

    private iniciarEstatiticasDinamico(seletorId: string, historicoConsolidado: any[], chave: any, label: string, text: string, varGlobal: any = null, metodoFormatValue: any = null, metodoFormatDataLabels: any = null, metodoFormatMediaTotal: any = null, objCores: { negativo: string, positivo: string } = { negativo: "#f7446a94", positivo: "#55f1cd9c" }) {
      let labels = [];
      let dados = [];
      let backgroundColors = [];
      let total: any = 0;
      let media: any = 0;
      const partesChave = String(chave).split('.');
      const chavePrincipal = partesChave[0];
      const subChave = partesChave.length > 1 ? partesChave[1] : null;
      for (let consolidado of historicoConsolidado) {
        const valorOriginal = subChave ? ((consolidado[chavePrincipal] || {})[subChave]) : consolidado[chavePrincipal];
        let dadoHist = metodoFormatValue ? metodoFormatValue(valorOriginal) : valorOriginal;
        dadoHist = dadoHist == null ? 0 : dadoHist;
        const valorNumerico = Number(dadoHist);
        const valorCalculo = Number.isFinite(valorNumerico) ? valorNumerico : 0;

        total += valorCalculo
        labels.push(consolidado.created_at)
        dados.push(dadoHist)
        if (valorCalculo < 0) {
          backgroundColors.push(objCores.negativo)
        } else {
          backgroundColors.push(objCores.positivo)
        }
      }
      media = total / historicoConsolidado.length
      this.updateViewItemEstatistica(metodoFormatMediaTotal ? metodoFormatMediaTotal(total) : parseInt(total), $(`.info-total-${chavePrincipal}`));
      this.updateViewItemEstatistica(metodoFormatMediaTotal ? metodoFormatMediaTotal(media) : parseInt(media), $(`.info-media-${chavePrincipal}`));

      let data = {
        labels: labels,
        datasets: [{
          label: label,
          data: dados,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors,
          borderWidth: 0
        }]
      }

      if (varGlobal) {
        varGlobal.destroy();
        varGlobal = null
      }

      let classChartJs = new ChartJs();
      varGlobal = classChartJs.inicializarCampo(seletorId, data, text, metodoFormatDataLabels);
      return varGlobal
    }

    private updateViewItemEstatistica(valor: number, el: JQuery) {
      let simbolo = '<i class="fas fa-arrow-up text-success mr-1"></i>'
      if (valor == 0) {
        simbolo = '<i class="fas fa-arrow-up text-white mr-1"></i>'
      } else if (valor < 0) {
        simbolo = '<i class="fas fa-arrow-down text-danger mr-1"></i>'
      }
      el.html(valor.toLocaleString('pt-BR'))
    }

    private getDadosEncontrarJogadoresParaSniper(idConta: number) {
      let elementoFormEncontrarJogSniper = $(`#formEncontrarJogadorParaSniper${(idConta)}`);

      return {
        id: idConta,
        url: elementoFormEncontrarJogSniper.find('input[name=url]').val() || null,
        overal: elementoFormEncontrarJogSniper.find('input[name=overal]').val() || null,
        precoProcura: elementoFormEncontrarJogSniper.find('input[name=preco_procura]').val() || null,
        lucroPorCarta: parseInt(elementoFormEncontrarJogSniper.find('input[name=lucro_por_carta]').val() || 500),
        tempoMinimoAtualizacaoPreco: (elementoFormEncontrarJogSniper.find('input[name=tempo_minimo_atualizacao_preco]').val() || 30) * 60,
        tentativas: parseInt(elementoFormEncontrarJogSniper.find('input[name=tentativas]').val() || 1)
      }
    }

    private aoBuscarJogadoresParaSnipar(e: JQueryEventObject) {
      let btnEncontrarJogador = $(e.currentTarget)
      btnEncontrarJogador.prop("disabled", true)
      let modalContexto = $(e.currentTarget).parents(".modal")
      let loader = modalContexto.find('.loader-modal')
      loader.show()
      var idConta = $(e.currentTarget).data('idContaEa');
      //console.log("aoBuscarJogadoresParaSnipar", idConta, this.getDadosEncontrarJogadoresParaSniper(idConta))
      $(`#tableJogadoresParaSniper${idConta} tbody tr`).remove();
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_JOGADORES_PARA_SNIPAR, this.getDadosEncontrarJogadoresParaSniper(idConta), async (response: IRespostaMensagem) => {
        btnEncontrarJogador.prop("disabled", false)
        loader.hide()
        //console.log("RESP", response)
        if (response.result && response.result.length) {
          for await (const jogador of response.result) {
            $(`#tableJogadoresParaSniper${idConta} tbody`).append(`
            <tr>
              <td><a target="_blank" href="${jogador.url}"><b>${jogador.nome}</b></a><i class="fa-solid fa-link ml-1"></i></td>
                <td>${jogador.rating}</td>
                <td>${jogador.precoFutbin} coins</td>
                <td><b>${jogador.precoEa} coins</b></td>
                <td class="td-actions text-right">
                    <button type="button" rel="tooltip"
                        class="btn btn-success btn-icon btn-sm btn-aplicar-jogador-filtro" data-id-conta-ea="${idConta}" data-preco-ea="${jogador.precoEa}" data-preco-futbin="${jogador.precoFutbin}" data-id-jogador="${jogador.assetId}" data-original-title=""
                        title="">
                        <i class="fa fa-check pt-1"></i>
                    </button>
              </td>
            </tr>`);
          }
          $(`#tableJogadoresParaSniper${idConta}`).show()
        } else {
          toastr.warning(`Nenhum jogador para sniper encontrado com essa url.`, "Nada encontrado!");
          $(`#tableJogadoresParaSniper${idConta}`).hide()
        }
      });
    }

    private async aplicarJogadorFiltroSniper(jogadoresIds: any[], precoCompra: any = null) {
      var modalSniperPro = $("#modalSniperPro");
      let arrIdsAntigos = modalSniperPro.find('select[name="maskedDefId[]"]').val()
      let precoCompraAtual = modalSniperPro.find('input[name="maxBuyNow"]').val()
      jogadoresIds = jogadoresIds.concat(arrIdsAntigos);
      modalSniperPro.find("#searchclearSniperPro").click();
      this.filtrosEa.setCampoJogadorFiltroPro(jogadoresIds, App.Util.objPlayers, modalSniperPro.find('select[name="maskedDefId[]"]'), "#searchclearSniperPro");
      this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", true);
      this.filtrosEa.setCampoInputCheckbox("precoInteligente", true);
      if (precoCompra && (jogadoresIds.length == 1 || precoCompra <= precoCompraAtual)) {
        this.filtrosEa.setCampoInputName("maxBuyNow", precoCompra);
      }
    }

    private async aoAplicarjogadorFiltro(e: JQueryEventObject) {
      let modalJogadoresEncontradosSniper = $(e.currentTarget).parents('.modal');
      let idConta = $(e.currentTarget).data('idContaEa');
      let idJogador = $(e.currentTarget).data('idJogador');
      let precoFutbin = $(e.currentTarget).data('precoFutbin');
      //console.log([idJogador], idConta)
      await this.aplicarJogadorFiltroSniper([idJogador], precoFutbin)

      modalJogadoresEncontradosSniper.modal('hide')
      $(`#abrirSniper${idConta}`).click()
    }

    private mostrarTelaWebApp(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_MOSTRAR_WEBAPP, { id: idConta }, (response: IRespostaMensagem) => { });
    }

    private aoSelecionarLigarDesligarTarefa(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_LIGAR_DESLIGAR_TAREFA, { status: $(e.target).is(':checked') }, (response: IRespostaMensagem) => {
        let campoSelecionado = $('input[name=tarefa_ligada]').is(':checked')
        if (response.result.tarefa_ligada) {
          toastr.success("Suas contas serão executadas de acordo com as configurações de perfil se existir.", "Tarefas ligada!")
          if (!campoSelecionado) {
            $('input[name=tarefa_ligada]').prop("checked", true)
          }
        } else {
          toastr.warning("Nenhuma de suas conta serão executadas enquanto essa opção estiver desligada.", "Tarefas desligada!")
          if (campoSelecionado) {
            $('input[name=tarefa_ligada]').prop("checked", false)
          }
        }
      });
    }

    private aoSelecionarAtivarProxyServer(e: JQueryEventObject) {
      let statusSelecionado = $(e.target).is(':checked');
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATIVAR_PROXY_SERVER, { status: statusSelecionado, proxy_server_port: this.getProxyServerPortConfig(), usuario_email: this.getUsuarioEmailConfig() }, (response: IRespostaMensagem) => {
        let resultado = response && response.result ? response.result : {};
        if (!response || !response.status) {
          $('input[name=ativar_proxy_server]').prop("checked", false);
          toastr.error(resultado.erro || "Nao foi possivel alterar o proxy server.", "Proxy server");
          return;
        }

        let proxyAtivo = !!resultado.proxy_server_ativo;
        $('input[name=ativar_proxy_server]').prop("checked", proxyAtivo);

        if (proxyAtivo) {
          this.salvarProxyServidor(resultado.proxy_server);
          const mensagemProxyAtivo = "Proxy gerado/ativado e salvo na aba Proxy. Para testar, abra a aba Proxy e clique no link/botao Testar proxy na tabela.";
          toastr.success(mensagemProxyAtivo, "Proxy server", { timeOut: 12000, extendedTimeOut: 12000 });
          swal.fire({
            icon: "success",
            title: "Proxy gerado/ativado",
            html: "O proxy foi salvo na aba <b>Proxy</b>.<br><br>Para conferir se esta funcionando, clique no link/botao <b>Testar proxy</b> na tabela de proxys.",
            confirmButtonText: "Entendi"
          });
        } else {
          toastr.warning("Proxy server desligado nesse servidor.", "Proxy server");
        }
      });
    }

    private getProxyServerPortConfig(): number {
      const campoConfigServidor = $('#formConfigServidor input[name=proxy_server_port]');
      if (campoConfigServidor.length && $("#modalConfigServidor").hasClass("show")) {
        return this.normalizarProxyServerPortConfig(campoConfigServidor.val(), 4500);
      }

      const valorCampo = $('input[name=proxy_server_port]').val();
      const portaCampo = this.normalizarProxyServerPortConfig(valorCampo, 0);
      if (portaCampo > 0) {
        return portaCampo;
      }

      const valorConfig = this.configuracoesGeraisExecucao && this.configuracoesGeraisExecucao.proxy_server_port;
      return this.normalizarProxyServerPortConfig(valorConfig, 4500);
    }

    private getUsuarioEmailConfig(): string {
      try {
        const config: any = App.Util.config;
        return config && config.usuario && config.usuario.email
          ? String(config.usuario.email)
          : "";
      } catch (e) {
        return "";
      }
    }

    private atualizarProxyFutTransfer(e: JQueryEventObject) {
      e.preventDefault();

      if (!this.pluginLigado) {
        toastr.warning("Plugin desconectado.", "Fut Transfer");
        return;
      }

      const proxyServerAtivo = this.normalizarBooleanConfigGeral(this.configuracoesGeraisExecucao && this.configuracoesGeraisExecucao.ativar_proxy_server, false);
      if (!proxyServerAtivo) {
        toastr.warning("Ative o proxy em Config Servidor antes de atualizar a Fut Transfer.", "Fut Transfer");
        return;
      }

      const ids = this.getIdsAllContas();
      if (!ids || !ids.length) {
        toastr.warning("Nenhuma conta encontrada para analisar.", "Fut Transfer");
        return;
      }

      App.Util.exibirModalPaginaCarregando();
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ATUALIZAR_PROXY_FUT_TRANSFER, { ids: ids }, (response: IRespostaMensagem) => {
        App.Util.ocultarModalPaginaCarregando();
        const result = response && response.result ? response.result : {};

        if (!response || !response.status) {
          toastr.warning(result.erro || "Nao foi possivel atualizar o proxy na Fut Transfer.", "Fut Transfer");
          return;
        }

        toastr.success(`Proxy Fut Transfer atualizado. Enviados: ${result.enviados || 0}. Ignorados: ${result.ignorados || 0}. Erros: ${result.erros || 0}.`, "Fut Transfer");
      });
    }

    private salvarProxyServidor(proxyServer: any) {
      if (!proxyServer || !App.Util.config.urlPostSalvarProxyServidor) {
        return;
      }

      if (!this.ajax) {
        this.ajax = new App.Ajax();
      }

      this.ajax.postAcao(App.Util.config.urlPostSalvarProxyServidor, {
        protocolo: proxyServer.protocolo || "http",
        address: proxyServer.IP || proxyServer.address,
        port: proxyServer.port,
        login: proxyServer.user || proxyServer.login,
        password: proxyServer.pass || proxyServer.password
      }, null, null, false, false);
    }

    private testarProxy(e: JQueryEventObject) {
      e.preventDefault();
      const proxyString = String($(e.currentTarget).data("proxy") || "");
      const url = String($(e.currentTarget).attr("href") || "https://iproyal.com/online-proxy-checker/");

      if (!proxyString) {
        toastr.warning("Dados do proxy incompletos.", "Testar proxy");
        return;
      }

      this.copiarTexto(proxyString);
      toastr.success("Proxy copiado no formato HOST:PORT:USER:PASS.", "Testar proxy");
      window.open(url, "_blank");
    }

    private copiarTexto(texto: string) {
      try {
        const clipboard = (navigator as any).clipboard;
        if (clipboard && clipboard.writeText) {
          clipboard.writeText(texto);
          return;
        }
      } catch (e) { }

      try {
        const textarea = document.createElement("textarea");
        textarea.value = texto;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      } catch (e) { }
    }

    private obterConfiguracaoGeralLocalAtualizada(callback: any = null) {
      App.Util.exibirLoadingFormModal($('.loading-form-modal'))
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONFIGURACAO_GERAL, {}, (response: IRespostaMensagem) => {
        App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
        if (response.status) {
          this.preencherConfiguracaoGeral(response.result);
        }
        if (callback) {
          callback()
        }
      });
    }

    private obterConfiguracaoServidorLocalAtualizada(callback: any = null) {
      const form = $("#formConfigServidor");
      App.Util.exibirLoadingFormModal(form.find(".loading-form-modal"));
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_CONFIGURACAO_GERAL, {}, (response: IRespostaMensagem) => {
        App.Util.ocultarLoadingFormModal(form.find(".loading-form-modal"));
        if (response.status) {
          this.preencherConfiguracaoServidor(response.result);
        }
        if (callback) {
          callback();
        }
      });
    }

    private obterConfiguracaoGeralAtualizada(callback: any = null) {
      try {
        App.Util.exibirLoadingFormModal($('.loading-form-modal'))
        this.obterConfiguracaoGeralRemotaAtualizada((dadosSucesso: IRespostaSucessoAjx) => {
          App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
          let dadosConfig: IConfiguracaoGeralBaseRemota = dadosSucesso ? dadosSucesso.dadosRetornados : null
          // console.log("DADOS CHEGOU obterConfiguracaoGeralAtualizada", dadosSucesso, dadosConfig)
          // Só PREENCHE. Antes isto chamava `aoAtivarDesativarConfigRemota`, que GRAVA configuração —
          // uma escrita silenciosa a cada abertura do modal, inaceitável agora que salvar/aplicar
          // mexe em qual configuração cada VPS usa.
          if (dadosConfig && dadosConfig.dados) {
            this.preencherConfiguracaoGeral(dadosConfig.dados);
            if (callback) {
              callback()
            }
          } else {
            if (callback) {
              this.obterConfiguracaoGeralLocalAtualizada(callback)
            }
          }
        })
      } catch (e) {
        console.log("ERROR: obterConfiguracaoGeralAtualizada", e)
      }
    }

    private normalizarPrioridadeTarefasAutomaticas(configs: any): string[] {
      const padrao = ["sniper", "auto_dme", "venda_coins"];
      const raw = configs && configs.prioridade_tarefas_automaticas;
      const itens = Array.isArray(raw)
        ? raw
        : (typeof raw === "string" ? raw.split(/[,\|;]/) : []);
      const normalizadas: string[] = [];
      itens.forEach((item: any) => {
        const chave = String(item || "").trim().toLowerCase().replace("-", "_");
        if (padrao.indexOf(chave) >= 0 && normalizadas.indexOf(chave) < 0) {
          normalizadas.push(chave);
        }
      });
      padrao.forEach((item) => {
        if (normalizadas.indexOf(item) < 0) normalizadas.push(item);
      });
      return normalizadas;
    }

    private preencherConfiguracaoGeral(configs: IConfiguracoesGeraisExecucao) {
      if (!configs) {
        return;
      }
      const usandoConfigRemota = this.usandoConfiguracaoGeralRemota();
      const baseConfigs: any = usandoConfigRemota
        ? this.removerCamposServidorLocalConfigGeral($.extend(true, {}, this.configuracoesGeraisExecucao || {}))
        : this.configuracoesGeraisExecucao;
      const configsEntrada: any = usandoConfigRemota
        ? this.removerCamposServidorLocalConfigGeral($.extend(true, {}, configs))
        : configs;
      const configsNormalizadas: IConfiguracoesGeraisExecucao = $.extend(true, {}, baseConfigs, configsEntrada);
      if (!Object.prototype.hasOwnProperty.call(configs, "tarefa_ligada_venda_coins")) {
        configsNormalizadas.tarefa_ligada_venda_coins = false;
      }
      if (!Object.prototype.hasOwnProperty.call(configs, "tarefa_ligada_sniper")) {
        configsNormalizadas.tarefa_ligada_sniper = true;
      }
      if (!Object.prototype.hasOwnProperty.call(configs, "tarefa_ligada_auto_dme")) {
        configsNormalizadas.tarefa_ligada_auto_dme = true;
      }
      if (!Object.prototype.hasOwnProperty.call(configs, "tarefas_simultaneas_auto_dme")) {
        configsNormalizadas.tarefas_simultaneas_auto_dme = 1;
      }
      if (!Object.prototype.hasOwnProperty.call(configs, "reutilizar_vagas_auto_dme_outras_tarefas")) {
        configsNormalizadas.reutilizar_vagas_auto_dme_outras_tarefas = false;
      }
      if (!Object.prototype.hasOwnProperty.call(configs, "iniciar_tarefa_imediata_apos_fechamento_conta")) {
        configsNormalizadas.iniciar_tarefa_imediata_apos_fechamento_conta = false;
      }
      const normalizarBooleanConfig = (valor: any, fallback: boolean): boolean => {
        if (valor === true || valor === 1) return true;
        if (valor === null || valor === undefined) return fallback;
        if (valor === false || valor === 0) return false;
        if (typeof valor === "string") {
          const texto = valor.trim().toLowerCase();
          if (texto === "1" || texto === "true" || texto === "on" || texto === "yes") return true;
          if (texto === "0" || texto === "false" || texto === "off" || texto === "no" || texto === "") return false;
        }
        return fallback;
      };
      const normalizarNumeroIntervalo = (valor: any, fallback: number, minimo: number, maximo: number): number => {
        const numero = Math.floor(Number(valor));
        if (!isFinite(numero)) {
          return fallback;
        }

        return Math.min(maximo, Math.max(minimo, numero));
      };
      configsNormalizadas.tarefa_ligada_sniper = normalizarBooleanConfig(configsNormalizadas.tarefa_ligada_sniper, true);
      configsNormalizadas.tarefa_ligada_auto_dme = normalizarBooleanConfig(configsNormalizadas.tarefa_ligada_auto_dme, true);
      configsNormalizadas.tarefa_ligada_venda_coins = normalizarBooleanConfig(configsNormalizadas.tarefa_ligada_venda_coins, false);
      configsNormalizadas.reutilizar_vagas_auto_dme_outras_tarefas = normalizarBooleanConfig(configsNormalizadas.reutilizar_vagas_auto_dme_outras_tarefas, false);
      configsNormalizadas.iniciar_tarefa_imediata_apos_fechamento_conta = normalizarBooleanConfig(configsNormalizadas.iniciar_tarefa_imediata_apos_fechamento_conta, false);
      configsNormalizadas.dias_log_retencao = normalizarNumeroIntervalo((configsNormalizadas as any).dias_log_retencao, 1, 1, 7);
      configsNormalizadas.prioridade_tarefas_automaticas = this.normalizarPrioridadeTarefasAutomaticas(configsNormalizadas);
      this.normalizarConfiguracaoAutoDmeGeral(configsNormalizadas, null, !usandoConfigRemota);
      const configsFormulario: any = usandoConfigRemota
        ? this.removerCamposServidorLocalConfigGeral(configsNormalizadas)
        : configsNormalizadas;
      const configsFormularioCampos: any = $.extend(true, {}, configsFormulario);
      configsFormularioCampos.prioridade_tarefas_automaticas = this.normalizarPrioridadeTarefasAutomaticas(configsFormularioCampos).join(",");

      this.configuracoesGeraisExecucao = usandoConfigRemota
        ? $.extend(true, {}, this.configuracoesGeraisExecucao || {}, configsFormulario)
        : configsFormulario
      var form = $(`#formConfiguracoesGeralBot`)

      Util.preencherFormularioComCamposAninhados(form, configsFormularioCampos)
      this.atualizarResumoPoolConfigGeralModal();
      if (Business.objDataTableContas instanceof $.fn.dataTable.Api) {
        Business.objDataTableContas.rows().invalidate().draw(false);
      }
    }

    /**
     * O toggle "Config. online" deixou de existir: quem define é o `#selectConfiguracaoPro`. Uma
     * configuração remota selecionada => modo remoto; "local" (só legado, VPS que ainda não optou)
     * => modo local. Plano cloud continua sempre remoto.
     */
    private usandoConfiguracaoGeralRemota(): boolean {
      if (this.infoPlanoAtual && this.infoPlanoAtual.ehPlanoCloud) {
        return true;
      }
      const valor = String($('#selectConfiguracaoPro').val() || '');
      return !!(valor && valor !== 'local' && valor !== 'nova');
    }

    private preencherConfiguracaoServidor(configs: IConfiguracoesGeraisExecucao) {
      if (!configs) {
        return;
      }

      const configsNormalizadas: any = $.extend(true, {}, this.configuracoesGeraisExecucao || {}, configs);
      configsNormalizadas.ativar_proxy_server = this.normalizarBooleanConfigGeral(configsNormalizadas.ativar_proxy_server, false);
      configsNormalizadas.usar_chrome_default = this.normalizarBooleanConfigGeral(configsNormalizadas.usar_chrome_default, false);
      configsNormalizadas.reiniciar_plugin_monitor_sniper = this.normalizarBooleanConfigGeral(configsNormalizadas.reiniciar_plugin_monitor_sniper, true);
      configsNormalizadas.proxy_server_port = this.normalizarProxyServerPortConfig(configsNormalizadas.proxy_server_port, 4500);
      this.normalizarConfiguracaoAutoDmeGeral(configsNormalizadas, this.getConfiguracaoAutoDmeAtual());

      this.configuracoesGeraisExecucao = configsNormalizadas;

      const form = $("#formConfigServidor");
      Util.preencherFormularioComCamposAninhados(form, configsNormalizadas);
      form.find("input[name=ativar_proxy_server]").prop("checked", !!configsNormalizadas.ativar_proxy_server);
      form.find("input[name=usar_chrome_default]").prop("checked", !!configsNormalizadas.usar_chrome_default);
      form.find("input[name=reiniciar_plugin_monitor_sniper]").prop("checked", !!configsNormalizadas.reiniciar_plugin_monitor_sniper);
      form.find("input[name=proxy_server_port]").val(configsNormalizadas.proxy_server_port);
    }

    private atualizarResumoPoolConfigGeralModal(): void {
      const form = $("#formConfiguracoesGeralBot");
      if (!form.length) return;
      const parseN = (v: any) => {
        const s = v == null || v === "" ? "0" : String(v);
        const n = parseInt(s, 10);
        return Math.max(0, Math.floor(isNaN(n) ? 0 : n));
      };
      const cs = parseN(form.find("[name=contas_simultaneas]").val());
      const td = parseN(form.find("[name=tarefas_simultaneas_auto_dme]").val());
      const ligS = form.find("[name=tarefa_ligada_sniper]").is(":checked");
      const ligD = form.find("[name=tarefa_ligada_auto_dme]").is(":checked");
      const reutilizarVagas = form.find("[name=reutilizar_vagas_auto_dme_outras_tarefas]").is(":checked");
      const poolTotal = cs + td;
      let effS = 0;
      let effD = 0;
      if (ligS && ligD) {
        effS = cs;
        effD = td;
      } else if (!ligS && ligD) {
        effD = poolTotal;
      } else if (ligS && !ligD) {
        effS = poolTotal;
      }
      $("#resumo-pool-total-num").text(String(poolTotal));
      const pctS = poolTotal > 0 ? (effS / poolTotal) * 100 : 0;
      const pctD = poolTotal > 0 ? (effD / poolTotal) * 100 : 0;
      $("#bar-pool-sniper").css("width", pctS + "%");
      $("#bar-pool-dme").css("width", pctD + "%");
      $("#legend-pool-sniper").text("Contas Simultâneas Sniper: " + effS);
      $("#legend-pool-dme").text("Contas Simultâneas Auto DME: " + effD);
      let txt = "";
      if (!ligS && ligD) {
        txt = "Tarefa sniper desligada: as " + poolTotal + " vagas do pool ficam disponíveis para Auto DME.";
      } else if (ligS && !ligD) {
        txt = "Auto DME desligado: as " + poolTotal + " vagas do pool ficam disponíveis para Sniper.";
      } else if (!ligS && !ligD) {
        txt = "Sniper e Auto DME desligados: o pool não é usado por essas tarefas até você ativar pelo menos uma.";
      } else if (reutilizarVagas) {
        txt = "Ambas ligadas: até " + cs + " conta(s) sniper e " + td + " conta(s) auto DME, total " + poolTotal + " (vagas não usadas por uma fila podem ser preenchidas pela outra quando não houver contas elegíveis).";
      } else {
        txt = "Ambas ligadas com reserva estrita: no máximo " + cs + " sniper e " + td + " auto DME (total " + poolTotal + "). Cada fila só usa as suas vagas; as da outra podem ficar ociosas.";
      }
      $("#resumo-pool-texto").text(txt);
    }

    private static readonly LS_MODAL_CONTAS_SNIPER = "futsniper.modalConfig.contas_simultaneas.sniperToggle";
    private static readonly LS_MODAL_SLOTS_AUTO_DME = "futsniper.modalConfig.tarefas_simultaneas_auto_dme.toggle";

    private gravarSlotModalLocalStorage(chave: string, valor: string): void {
      try {
        localStorage.setItem(chave, valor);
      } catch (e) { /* quota / modo privado */ }
    }

    private lerSlotModalLocalStorage(chave: string): string | null {
      try {
        return localStorage.getItem(chave);
      } catch (e) {
        return null;
      }
    }

    private aoToggleTarefaSniperConfigGeral(el: JQuery): void {
      const form = $("#formConfiguracoesGeralBot");
      const lig = el.is(":checked");
      const inp = form.find("[name=contas_simultaneas]");
      if (!lig) {
        this.gravarSlotModalLocalStorage(Business.LS_MODAL_CONTAS_SNIPER, String(inp.val() == null ? "" : inp.val()));
      } else {
        const b = this.lerSlotModalLocalStorage(Business.LS_MODAL_CONTAS_SNIPER);
        if (b != null && String(b).trim() !== "") {
          inp.val(b);
        }
      }
      this.atualizarResumoPoolConfigGeralModal();
    }

    private aoToggleTarefaAutoDmeConfigGeral(el: JQuery): void {
      const form = $("#formConfiguracoesGeralBot");
      const lig = el.is(":checked");
      const inp = form.find("[name=tarefas_simultaneas_auto_dme]");
      if (!lig) {
        this.gravarSlotModalLocalStorage(Business.LS_MODAL_SLOTS_AUTO_DME, String(inp.val() == null ? "" : inp.val()));
      } else {
        const b = this.lerSlotModalLocalStorage(Business.LS_MODAL_SLOTS_AUTO_DME);
        if (b != null && String(b).trim() !== "") {
          inp.val(b);
        }
      }
      this.atualizarResumoPoolConfigGeralModal();
    }

    private normalizarBooleanConfigGeral(valor: any, fallback: boolean): boolean {
      if (valor === true || valor === 1) return true;
      if (valor === false || valor === 0) return false;
      if (valor === null || valor === undefined) return fallback;
      if (typeof valor === "string") {
        const texto = valor.trim().toLowerCase();
        if (texto === "1" || texto === "true" || texto === "on" || texto === "yes") return true;
        if (texto === "0" || texto === "false" || texto === "off" || texto === "no" || texto === "") return false;
      }
      return fallback;
    }

    private getConfiguracaoAutoDmeAtual(): any {
      return this.configuracoesGeraisExecucao ? (this.configuracoesGeraisExecucao as any).configuracao_auto_dme : null;
    }

    private removerCamposServidorLocalConfigGeral(config: any): any {
      const dados = $.extend(true, {}, config || {});
      delete dados.ativar_proxy_server;
      delete dados.proxy_server_port;
      delete dados.usar_chrome_default;
      delete dados.reiniciar_plugin_monitor_sniper;

      return dados;
    }

    private normalizarProxyServerPortConfig(valor: any, fallback: number = 4500): number {
      const porta = Number(valor);
      if (isFinite(porta) && porta > 0 && porta <= 65535) {
        return Math.floor(porta);
      }

      return fallback;
    }

    private normalizarConfiguracaoAutoDmeGeral(dados: IConfiguracoesGeraisExecucao, fallbackConfigAutoDme: any = null, respeitarModoServidor: boolean = true): IConfiguracoesGeraisExecucao {
      const cfg: any = {
        ...(fallbackConfigAutoDme || {}),
        ...((dados as any).configuracao_auto_dme || {}),
      };
      (dados as any).configuracao_auto_dme = cfg;

      return dados;
    }

    private aoSelecionarTodosOsFiltros(e: JQueryEventObject) {
      try {
        var options = $('#filtro option');
        $('#filtro').val(options.map(function () { return this.value; }).get()).trigger('change');
      } catch (e) {
      }
    }
    private aoApagarTodosOsFiltros(e: JQueryEventObject) {
      try {
        $('#filtro').val("").trigger('change');
      } catch (e) {
      }
    }

    private aoClicarAjustarLucro(e: JQueryEventObject) {
      let form = $("#formAjustarLucro");
      let idConta = $(e.currentTarget).data('idContaEa');
      let ajusteLucro = $(e.currentTarget).data('ajusteLucro');
      form.find("input[name=id]").val(idConta)
      form.find("input[name=ajuste_lucro]").val(ajusteLucro ? ajusteLucro : "")
      $("#modalAjustarLucro").modal("show")
    }

    private ajustarLucro(e: JQueryEventObject) {
      let form = $(e.currentTarget).parents("form");
      let dadosForm: any = this.ajax.convertFormToJSON(form)
      let idConta = form.find("input[name=id]").val()
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_AJUSTAR_LUCRO, dadosForm, (response: IRespostaMensagem) => {
        //console.log("acrescerDecrescerLucro", response)
        if (response.status) {
          this.atualizarConsolidadoDaConta(idConta, response.result)
          toastr.success("Ajuste foi feito", "Sucessso!");
          $("#modalAjustarLucro").modal("hide")
        } else {
          toastr.warning("Verifique se sua conta já foi iniciada no dia de hoje, se não, inicie antes de ajustar o lucro.", "Ajuste não foi feito!");
        }
      });
    }

    // ─── Transfer Between Accounts — beta ─────────────────────────────────────
    private abrirModalTransfer() {
      if (!this.conectado) {
        toastr.warning('Plugin não conectado.');
        return;
      }
      if (!this.transferCoins) {
        return;
      }
      this.transferCoins.setComunicacao(this.comunicacao);
      const ids = this.getIdsContasSelecionadas();
      if (ids.length > 2) {
        Util.exibirAlertaNotificacaoToastr('Muitas contas selecionadas', 'Selecione no máximo 2 contas, ou nenhuma para usar só credenciais fora do cadastro.', 'warning');
        return;
      }
      $('#modalAcoesContas').modal('hide');
      if (this.arrayContas) this.transferCoins.setArrayContas(this.arrayContas);
      // 0 contas → A e B fora do cadastro (listas no modal)
      // 1 conta → vendedora (A) cadastrada; compradora (B) no modal
      // 2 contas → vendedora + compradora cadastradas
      if (ids.length === 0) {
        this.transferCoins.abrirModal(undefined, undefined);
      } else {
        this.transferCoins.abrirModal(ids[0], ids.length === 2 ? ids[1] : undefined);
      }
    }
    // ───────────────────────────────────────────────────────────────────────────

    private abrirContas() {
      if (!this.conectado) {
        return
      }

      let ids = this.getIdsContasSelecionadas()
      //console.log("abrirContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_ABRIR_CONTAS, ids, (response: IRespostaMensagem) => {
        //console.log("IMEDIATO::", response)
      });
    }

    private executarTarefaContas() {
      if (!this.conectado) {
        return
      }

      let ids = this.getIdsContasSelecionadas()
      //console.log("executarTarefaContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INICIAR_TAREFA_IMEDIATA, ids, (response: IRespostaMensagem) => {
        //console.log("IMEDIATO::", response)
      });
    }

    private executarAutoDmeImediatoContas() {
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Auto DME imediato");
        return
      }

      let ids = this.getIdsContasSelecionadas()
      if (!ids || !ids.length) {
        toastr.warning("Selecione uma ou mais contas.", "Auto DME imediato");
        return
      }

      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_AUTO_DME_IMEDIATO, { ids, imediato: true }, (response: IRespostaMensagem) => {
        const result: any = response ? (response as any).result : null;
        const mensagem = result && result.mensagem ? result.mensagem : "Solicitacao enviada ao plugin.";
        if (response && response.status) {
          toastr.success(mensagem, "Auto DME imediato");
        } else {
          toastr.warning(mensagem, "Auto DME imediato");
        }
      });
    }

    private executarResgateRecompensasConta(idConta: number): Promise<IRespostaMensagem> {
      return new Promise((resolve) => {
        this.exibirLoadListConta(idConta, "Resgatando recompensas")
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, {
          acao: Util.ID_TIPO_ACAO_UNICA_RESGATAR_RECOMPENSAS,
          id: idConta
        }, (response: IRespostaMensagem) => {
          this.ocultarLoadListConta(idConta)
          resolve(response || { status: false, result: { mensagem: "Sem resposta do plugin." } })
        });
      });
    }

    private async executarResgateRecompensasIdsContas() {
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Resgatar recompensas");
        return
      }

      if (this.executandoResgateRecompensas) {
        toastr.warning("Ja existe um resgate de recompensas em andamento.", "Resgatar recompensas");
        return
      }

      const ids = this.getIdsContasSelecionadas()
      if (!ids || !ids.length) {
        toastr.warning("Selecione uma ou mais contas.", "Resgatar recompensas");
        return
      }

      this.executandoResgateRecompensas = true
      $("#modalAcoesContas").modal("hide")

      let concluidas = 0
      let recompensas = 0
      const falhas: any[] = []

      try {
        for (const id of ids) {
          const response = await this.executarResgateRecompensasConta(id)
          const result: any = response ? response.result : null
          const sucesso = !!(response && response.status && (!result || result.status !== false))

          if (sucesso) {
            concluidas++
            recompensas += Number(result && result.claimedCount || 0)
          } else {
            falhas.push({ id, mensagem: result && (result.mensagem || result.erro) || "Nao foi possivel resgatar recompensas." })
          }

          if (ids.length > 1) {
            await this.util.esperar(3000)
          }
        }

        if (concluidas > 0) {
          const detalhe = recompensas > 0 ? ` (${recompensas} acao(oes) de resgate)` : ""
          toastr.success(`${concluidas} conta(s) processada(s)${detalhe}.`, "Resgatar recompensas")
        }

        if (falhas.length > 0) {
          toastr.warning(`${falhas.length} conta(s) nao puderam ser processadas.`, "Resgatar recompensas")
          console.log("RESGATAR_RECOMPENSAS_FALHAS", falhas)
        }
      } catch (e) {
        console.log("ERROR Resgatar recompensas lista contas::", e)
        toastr.warning("Ocorreu um erro ao resgatar recompensas.", "Resgatar recompensas")
      } finally {
        this.executandoResgateRecompensas = false
      }
    }

    private async executarVendaCoinsIdsContas() {
      try {
        if (!this.conectado) {
          return
        }

        let ids = this.getIdsContasSelecionadas()
        this.vendendoCoinsContaLista = true
        $("#modalAcoesContas").modal("hide")
        for await (let id of ids) {
          if (!this.vendendoCoinsContaLista) {
            return
          }

          let rowConta = App.Business.objDataTableContas.row(`#${id}`)
          if (rowConta.length) {
            let objConta: IConta = rowConta.data()
            if (objConta && objConta.dadosEa && objConta.perfil && objConta.perfil.api_venda_coins && objConta.perfil.api_venda_coins.dados && objConta.dadosEa.coins >= objConta.perfil.api_venda_coins.dados.minimo_coins_na_conta) {
              console.log("OBJ CONTA ROW::", objConta.perfil.api_venda_coins.dados.minimo_coins_na_conta, objConta.dadosEa.coins)
              $(`#${id} .btn-iniciar-venda-de-coins-imediata`).click()
              await this.util.esperar(App.Business.tempoMilisegundoEntreAberturaContaVendaCoins || 40000)
            }
          }
        }
      } catch (e) {
        console.log("ERROR Vender coins lista contas::", e)
      }
    }

    private updateEncontradosPorFiltro() {
      //TODO desabilitado temporariamente
      if (true) {
        return
      }
      try {
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_ENCONTRADOS_POR_FILTRO, {}, (response: IRespostaMensagem) => {
          if (response && response.result) {
            this.updateViewEncontradosPorFiltro(response.result)
          }
        });
      } catch (e) {
        console.log("Erro updateEncontradosPorFiltro::", e)
      }
    }

    private updateViewEncontradosPorFiltro(arrEncontradosPorfiltro: any[]) {
      $("#espacoEncontradosPorFiltro").html('');
      $("#encontradosPorFiltro").hide()

      if (arrEncontradosPorfiltro.length) {
        let col = ``;
        $.each(arrEncontradosPorfiltro, (chave: string, objFt: { nome: string, quantidade: number, snipers: number }) => {
          col = `
          <div class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row pb-2 pt-2 mb-1">
              <i class="fas fa-filter mr-2 pt-1 text-muted"></i>

              <h6 class="mb-0 mr-2 text-muted font-size-8 pt-1">${objFt.nome}</h6>
              <span class="badge badge-pill badge-primary font-size-10 mr-2">${objFt.quantidade}</span>
              <span class="badge badge-pill badge-success font-size-10">${objFt.snipers || 0}</span>
          </div>
          `

          $("#espacoEncontradosPorFiltro").append(col);
        });
        $("#encontradosPorFiltro").show()
      } else {

        $("#espacoEncontradosPorFiltro").html('');
        $("#encontradosPorFiltro").hide()
      }
    }

    private getJogadoresMultRaridadesPorUrlFutbin(e: JQueryEventObject) {
      this.fecharDropdownCriarFiltro()
      let paramsUrl: any = null
      try {
        $('.conteudo-loading-sniper-pro').modal('show')
        var idContaEa: any = $(e.currentTarget).data('idContaEa');
        var menuCriarFiltro: JQuery = $(e.currentTarget).parents('.menu-criar-filtro');
        var modalContentContexto: JQuery = $(e.currentTarget).parents('.modal-content');
        var url = $.trim(String(menuCriarFiltro.find("input[name=campo_url_filtro_futbin]").val() || ''))
        var coinsDisponivel = menuCriarFiltro.find("input[name=campo_coins_disponivel]").val() || 100000
        var apenasPlaystyles = menuCriarFiltro.find("input[name=apenas_playstyles]").prop('checked');
        var urlFutbin = null;

        if (url) {
          try {
            urlFutbin = new URL(url);
          } catch (e) {
            urlFutbin = null;
          }
        }

        var hostFutbin = urlFutbin ? urlFutbin.hostname.toLowerCase() : '';
        var partesPathFutbin = urlFutbin ? urlFutbin.pathname.split('/').filter((parte: string) => parte) : [];
        var pathPlayersFutbin = partesPathFutbin.length === 1 && partesPathFutbin[0] === 'players';
        var pathPlayersTemporadaFutbin = partesPathFutbin.length === 2 && /^\d+$/.test(partesPathFutbin[0]) && partesPathFutbin[1] === 'players';
        var urlFiltroFutbinValida = (hostFutbin === 'futbin.com' || hostFutbin === 'www.futbin.com') && (pathPlayersFutbin || pathPlayersTemporadaFutbin);

        if (!urlFiltroFutbinValida) {
          toastr.warning("Parece que a Url informada não é uma url de filtro de jogadores futbin.", "URL Inválida!");
          $('.conteudo-loading-sniper-pro').modal('hide')
          return;
        }

        paramsUrl = new URLSearchParams(urlFutbin.search);

        // if (paramsUrl.get('position') && (paramsUrl.get('position') as any).includes(",")) {
        //   toastr.warning("Tente usar filtros simples como ligas, clubes, paises ou posicoes. para posições, use as opções comuns aceitas no webapp.", "URL Incorreta!");
        //   $('.conteudo-loading-sniper-pro').modal('hide')
        //   return;
        // }
      } catch (e) {
        $('.conteudo-loading-sniper-pro').modal('hide')
        toastr.warning(`Algum erro ocorreu. ${e.message}`, "Erro!");
        return;
      }

      const tratarRespostaFiltro = (response: IRespostaMensagem) => {
        try {
          if (response.status && response.result && response.result.length) {
            var filtro: IFiltroOptions = {
              id: null, nome: "Criacao de Filtro",
              "data": {
                "maskedDefId": null,
                "minBid": null,
                "maxBid": null,
                "quality": "",
                "icontraits": apenasPlaystyles ? "icontraits" : "",
                "rarity": _.pluck(response.result, 'rarityId'),
                "position": Util.parsePositionFutBinToFilterFsw(paramsUrl.get('position')) as any,
                "chemical": null,
                "nation": paramsUrl.get('nation') as any,
                "league": paramsUrl.get('league') as any,
                "club": paramsUrl.get('club') as any,
                "minBuyNow": null,
                "maxBuyNow": null,
                "variar": null,
                "turbo": null,
                "lucro": 15
              },
              "venda": null
            }
            this.preencherCamposModalSniperTarefaAtual(idContaEa, filtro);
            toastr.success(`O filtro criado foi aplicado, estime o lucro para conferi-lo`, "Filtro Criado!");
            $('.conteudo-loading-sniper-pro').modal('hide')
            this.informarLogFiltroCriado(coinsDisponivel, response.result, modalContentContexto, apenasPlaystyles)
          } else {
            $('.conteudo-loading-sniper-pro').modal('hide')
            toastr.info(`Nenhuma raridade encontrada que se encaixe nesse preço e URL`, "Não foi possível criar o filtro!");
          }
        } catch (e) {
          $('.conteudo-loading-sniper-pro').modal('hide')
          toastr.warning(`Algum erro ocorreu. ${e.message}`, "URL Incorreta!");
        }
      };

      console.log("CHROME::", typeof chrome !== 'undefined', this.idExtensao, chrome.runtime)
      if (this.idExtensao) {
        chrome.runtime.sendMessage(this.idExtensao, {
          evento: "getFiltroMultRaridadeFutbin",
          url: url,
          valo_minimo: coinsDisponivel,
          apenas_playstyles: apenasPlaystyles
        }, (response: IRespostaMensagem) => {
          // Usando o log do sniper para mostrar o erro e a resposta
          console.log("RESPONSE::", response, chrome.runtime.lastError, this.idExtensao)
          let modalSniperProAberto = $('#modalSniperPro:visible');
          let espacoLogEl = modalSniperProAberto.length
            ? modalSniperProAberto.find('.espaco-log-pro')
            : modalContentContexto.find('.espaco-log-pro');

          const deuerro = chrome.runtime.lastError
          if (deuerro) {
            const erroMsg = deuerro ? chrome.runtime.lastError.message : 'Erro desconhecido';
            const respostaStr = response ? JSON.stringify(response, null, 2) : 'Resposta vazia';
            const descricao = `Ocorreu um erro ao buscar os jogadores pela extensão.<br>
            <strong>Erro:</strong> ${erroMsg}
            <br/><strong>ID Extensão:</strong> ${this.idExtensao}
            <br/><pre style="white-space:pre-wrap;">${respostaStr}</pre>`;
            Util.salvarLogSniper(espacoLogEl,
              'badge-danger',
              "Erro Extensão",
              descricao
            );
          }

          if (!response) {
            Util.salvarLogSniper(
              espacoLogEl,
              'badge-danger',
              "Nenhum resultado encontrado",
              "Não foi possível buscar os jogadores do filtro."
            );
          }

          tratarRespostaFiltro(response || { status: false, result: [] });
        });
      } else {
        this.exibirMensagemExtensaoObrigatoriaCriarFiltro();
        console.log("EXTENSAO NAO INSTALADA")
        // this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_FILTRO_MULT_RARIDADE_FUTBIN, { url: url, valo_minimo: coinsDisponivel, apenas_playstyles: apenasPlaystyles }, tratarRespostaFiltro);
      }
    }

    private informarLogFiltroCriado(coinsDisponivel: number, arrJogadoresfiltro: IJogadoresFiltroCriado[], modalContentContexto: JQuery, apenasPlaystyles: boolean = false) {
      let htmlListaJogadores = ``
      let jogadorPrecoMaisBaixo = arrJogadoresfiltro.length ? arrJogadoresfiltro[arrJogadoresfiltro.length - 1] : null

      for (let jogador of arrJogadoresfiltro) {
        const rarityImgUrl = App.Util.tratarTipoRaridade(jogador.rarityId);
        htmlListaJogadores += `<p class="text-xs mt-0 mb-0 ${jogadorPrecoMaisBaixo && jogadorPrecoMaisBaixo.preco <= jogador.minPrice ? 'bg-incompativel' : ''}" style="width: 100%;line-height: 18px;padding: 0px 2px 0px 2px;border: 1px solid #d7d7d7;border-radius: 5px;font-size: 60% !important;background-color: #ffffff;">
        <img src="${rarityImgUrl}" alt="${jogador.rarityNome}" class="mr-1" style="width:20px;height:24px;object-fit:contain;flex-shrink:0" onerror="this.style.display='none'">
        <span class="font-size-13 font-weight-bold">${jogador.nome} (${jogador.rating})</span>,
                                <span class="font-size-13 font-weight-bold" style="color: #00a983;">${jogador.precoDesc}</span><br>
                                <small class="text-default">
                                <span class="font-size-10">&nbsp;MIN: <span class="font-weight-bold font-size-10 ${jogadorPrecoMaisBaixo && jogadorPrecoMaisBaixo.preco <= jogador.minPrice ? 'text-warning' : ''}">${jogador.minPrice}</span></span>
                                &nbsp;|&nbsp;<span class="text-normal"><span class="font-weight-bold text-primary font-size-10">${jogador.rarityNome}</span></span>
                                </small>
                               </p>`
      }
      const filtroComPlayStyles = apenasPlaystyles ? `<span class="font-size-12 font-weight-bold"><img width="25" height="25" src="https://cdn.futbin.com/design/img/icons/playstyles/26/plus/scoring-finesseshot.png">PlayStyles++</span>` : ``
      let htmlLog = `
                <li class="list-group-item px-0 py-1 mt-0 mb-1 lucro-estimado" style="background-color: #fbf8ff;">
                  <div class="ml-3 mb-1">
                      <span class="badge badge-success text-uppercase mb-2">Filtro Criado</span>
                      ${filtroComPlayStyles}
                      <button onclick="$(this).parents('li').remove()" type="button" class="close" style="float: right;"><span>×</span></button>
                  </div>
                  <div class="row col-md-12 p-0 m-0">
                      <div class="col" style="line-height: 13px;">
                          <small style="font-size: 76%;">Preço acima de:</small>
                          <h5 class="mb-0 mt-2">${coinsDisponivel}</h5>
                      </div>
                      <div class="col" style="line-height: 13px;">
                          <small style="font-size: 76%;">Possibilidades:</small>
                          <h5 class="mb-0 mt-2">${arrJogadoresfiltro.length}</h5>
                      </div>
                  </div>
                  <div class="row ml-2 mr-1 mt-2">
                          ${htmlListaJogadores}
                   </div>
                </li>
                `

      this.exibirLogFixo(modalContentContexto, htmlLog, "filtro-criado", true);
    }

    private exibirLogFixo(elfind: JQuery, html: string, classDiv: string = '', remover: boolean = false) {
      if (remover) {
        elfind.find(".espaco-log-pro").find(`.${classDiv}`).remove();
      }

      elfind.find(".espaco-log-pro").prepend(`${html}`);
    }

    private limparLimitesContas(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPAR_LIMITES_CONTAS, this.getIdsContasEaVinculadas(), (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Limites liberados", "Sucessso!");
        }
      })
    }
    private limparLogs(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPAR_LOGS, null, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("registro de logs limpo", "Sucessso!");
        }
      })
    }

    private obterMediaDelay() {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_GET_DELAY, null, (response: IRespostaMensagem) => {
        if (response.status && response.result) {
          $('.info-media-delay').html(`${response.result.toFixed(2)} ms`)
        }
      })
    }

    private imterromperTarefas(el: JQueryEventObject) {
      App.Util.botaoProcessando($(el.currentTarget), true);
      clearInterval(this.intervaloVinculoListaContas)
      this.vendendoCoinsContaLista = false
      this.executandoResolverBugEa = false
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_INTERROMPER_FECHAR_CONTAS, null, (response: IRespostaMensagem) => {
        App.Util.botaoProcessando($(el.currentTarget), false);
        if (response.status) {
          toastr.success("Tarefas interrompidas.", "Sucessso!");
        }
      })
    }

    private reiniciarPlugin(el: JQueryEventObject) {
      clearInterval(this.intervaloVinculoListaContas)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_REINICIAR_PLUGIN, null, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.info("Seu Plugin está sendo reiniciado, considere reativar suas tarefas automaticas caso estivesse ativa antes.", "Aguarde!");
        } else {
          toastr.warning("Algum problema ocorreu e o plugin não pode ser reiniciado, considere fazer isso manualmente desligando-o e ligando novamente.", "Não Reiniciado!");

        }
      })
    }

    private reiniciarPluginsServidores(servidores: Array<{ id: any, nome: string, address: string }> = []) {
      let tabelaServidores = $("#dataTableServidores");
      let urlReiniciarPlugins = tabelaServidores.data("urlReiniciarPlugins");
      if (!urlReiniciarPlugins) {
        toastr.warning("Nao foi possivel encontrar a rota para reiniciar os plugins dos servidores.", "Indisponivel!");
        return;
      }

      let lista = (servidores || []).filter((srv) => srv && srv.id);
      if (!lista.length) {
        swal.fire("Nenhum servidor", "Nenhum servidor encontrado para reiniciar.", "warning");
        return;
      }

      let textoConfirmacao = lista.length === 1
        ? `Reiniciar o plugin do servidor "${lista[0].nome}"?`
        : `Reiniciar o plugin de ${lista.length} servidores?`;

      swal.fire({
        title: "Reiniciar Plugins?",
        text: textoConfirmacao,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, reiniciar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#f5365c"
      }).then((result: any) => {
        if (!result.isConfirmed) {
          return;
        }
        this.exibirProgressoReinicioPluginsServidores(urlReiniciarPlugins, lista);
      });
    }

    private forcarAtualizacaoPluginsServidores(servidores: Array<{ id: any, nome: string, address: string }> = []) {
      let tabelaServidores = $("#dataTableServidores");
      let urlForcarAtualizacao = tabelaServidores.data("urlForcarAtualizacaoPlugins");
      if (!urlForcarAtualizacao) {
        toastr.warning("Nao foi possivel encontrar a rota para forcar atualizacao dos plugins.", "Indisponivel!");
        return;
      }

      let lista = (servidores || []).filter((srv) => srv && srv.id);
      if (!lista.length) {
        swal.fire("Nenhum servidor", "Nenhum servidor encontrado para forcar atualizacao.", "warning");
        return;
      }

      let textoConfirmacao = lista.length === 1
        ? `Isso fechara o plugin e baixara novamente o plugin-start no servidor "${lista[0].nome}".`
        : `Isso fechara o plugin e baixara novamente o plugin-start em ${lista.length} servidores.`;

      swal.fire({
        title: "Forcar Atualizacao?",
        text: textoConfirmacao,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, forcar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#fb6340"
      }).then((result: any) => {
        if (!result.isConfirmed) {
          return;
        }
        this.exibirProgressoReinicioPluginsServidores(urlForcarAtualizacao, lista, {
          tituloModal: "Forcando Atualizacao",
          labelProcessando: "Agendando atualizacao",
          statusProcessando: "Agendando...",
          statusSucesso: "Agendado",
          mensagemFalhaPadrao: "Falha ao forcar atualizacao",
          tituloSucesso: "Atualizacao Agendada",
          tituloFalha: "Atualizacao Falhou",
          tituloParcial: "Atualizacao Parcial",
          sufixoSucesso: "com atualizacao agendada",
        });
      });
    }

    private reiniciarWindowsServidores(servidores: Array<{ id: any, nome: string, address: string }> = []) {
      this.executarComandoManutencaoServidores(servidores, {
        dataUrl: "urlReiniciarWindows",
        mensagemRotaIndisponivel: "Nao foi possivel encontrar a rota para reiniciar o Windows dos servidores.",
        mensagemNenhumServidor: "Nenhum servidor encontrado para reiniciar o Windows.",
        tituloConfirmacao: "Reiniciar Windows?",
        textoConfirmacaoUm: (srv: any) => `Isso reiniciara a VM/Windows do servidor "${srv.nome}" e interrompera contas e tarefas em execucao.`,
        textoConfirmacaoVarios: (total: number) => `Isso reiniciara a VM/Windows de ${total} servidores e interrompera contas e tarefas em execucao.`,
        confirmButtonText: "Sim, reiniciar",
        confirmButtonColor: "#f5365c",
        opcoesProgresso: {
          tituloModal: "Reiniciando Windows",
          labelProcessando: "Agendando reinicio",
          statusProcessando: "Agendando...",
          statusSucesso: "Agendado",
          mensagemFalhaPadrao: "Falha ao reiniciar Windows",
          tituloSucesso: "Reinicio Agendado",
          tituloFalha: "Reinicio Falhou",
          tituloParcial: "Reinicio Parcial",
          sufixoSucesso: "com reinicio do Windows agendado",
        }
      });
    }

    private sincronizarDatabaseServidores(servidores: Array<{ id: any, nome: string, address: string }> = []) {
      this.executarComandoManutencaoServidores(servidores, {
        dataUrl: "urlSincronizarDatabase",
        mensagemRotaIndisponivel: "Nao foi possivel encontrar a rota para sincronizar/limpar cache das contas dos servidores.",
        mensagemNenhumServidor: "Nenhum servidor encontrado para sincronizar/limpar cache das contas.",
        tituloConfirmacao: "Sincronizar/Limpar Cache Contas?",
        textoConfirmacaoUm: (srv: any) => `Isso fechara contas abertas e sincronizara/limpara o cache das contas do servidor "${srv.nome}".`,
        textoConfirmacaoVarios: (total: number) => `Isso fechara contas abertas e sincronizara/limpara o cache das contas de ${total} servidores.`,
        confirmButtonText: "Sim, sincronizar",
        confirmButtonColor: "#11cdef",
        opcoesProgresso: {
          tituloModal: "Sincronizando/Limpando Cache Contas",
          labelProcessando: "Agendando sincronizacao/limpeza",
          statusProcessando: "Agendando...",
          statusSucesso: "Agendado",
          mensagemFalhaPadrao: "Falha ao sincronizar/limpar cache das contas",
          tituloSucesso: "Sincronizacao/Limpeza Agendada",
          tituloFalha: "Sincronizacao/Limpeza Falhou",
          tituloParcial: "Sincronizacao/Limpeza Parcial",
          sufixoSucesso: "com sincronizacao/limpeza agendada",
        }
      });
    }

    /**
     * "Atualizar Contas" em lote: cada VPS selecionada rebusca do central os dados das contas dela
     * (perfil, horarios, filtros) — o mesmo efeito do botao "Atualizar" do dashboard, sem precisar
     * abrir o dashboard de cada servidor. Nao fecha conta nem mexe em tarefa automatica.
     */
    private atualizarContasServidores(servidores: Array<{ id: any, nome: string, address: string }> = []) {
      this.executarComandoManutencaoServidores(servidores, {
        dataUrl: "urlAtualizarContas",
        mensagemRotaIndisponivel: "Nao foi possivel encontrar a rota para atualizar as contas dos servidores.",
        mensagemNenhumServidor: "Nenhum servidor encontrado para atualizar as contas.",
        tituloConfirmacao: "Atualizar Contas?",
        textoConfirmacaoUm: (srv: any) => `Isso fara o servidor "${srv.nome}" rebuscar os dados das contas dele (perfil, horarios e filtros). Nao fecha contas nem interrompe tarefas. A atualizacao e gradual, conta a conta, e pode levar alguns minutos.`,
        textoConfirmacaoVarios: (total: number) => `Isso fara ${total} servidores rebuscarem os dados das contas deles (perfil, horarios e filtros). Nao fecha contas nem interrompe tarefas. A atualizacao e gradual, conta a conta, e pode levar alguns minutos.`,
        confirmButtonText: "Sim, atualizar",
        confirmButtonColor: "#2dce89",
        opcoesProgresso: {
          tituloModal: "Atualizando Contas",
          labelProcessando: "Agendando atualizacao",
          statusProcessando: "Agendando...",
          statusSucesso: "Agendado",
          mensagemFalhaPadrao: "Falha ao atualizar as contas",
          tituloSucesso: "Atualizacao Agendada",
          tituloFalha: "Atualizacao Falhou",
          tituloParcial: "Atualizacao Parcial",
          sufixoSucesso: "com atualizacao das contas agendada",
        }
      });
    }

    private limparDiscoServidores(servidores: Array<{ id: any, nome: string, address: string }> = []) {
      this.executarComandoManutencaoServidores(servidores, {
        dataUrl: "urlLimparDisco",
        mensagemRotaIndisponivel: "Nao foi possivel encontrar a rota para limpar disco dos servidores.",
        mensagemNenhumServidor: "Nenhum servidor encontrado para limpar disco.",
        tituloConfirmacao: "Limpar Disco?",
        textoConfirmacaoUm: (srv: any) => `Isso iniciara a limpeza/liberacao de espaco em disco no servidor "${srv.nome}".`,
        textoConfirmacaoVarios: (total: number) => `Isso iniciara a limpeza/liberacao de espaco em disco em ${total} servidores.`,
        confirmButtonText: "Sim, iniciar",
        confirmButtonColor: "#8898aa",
        opcoesProgresso: {
          tituloModal: "Limpando Disco",
          labelProcessando: "Iniciando limpeza",
          statusProcessando: "Iniciando...",
          statusSucesso: "Iniciada",
          mensagemFalhaPadrao: "Falha ao iniciar limpeza de disco",
          tituloSucesso: "Limpeza Iniciada",
          tituloFalha: "Limpeza Falhou",
          tituloParcial: "Limpeza Parcial",
          sufixoSucesso: "com limpeza iniciada",
        }
      });
    }

    private executarComandoManutencaoServidores(servidores: Array<{ id: any, nome: string, address: string }> = [], opcoes: any = {}) {
      let tabelaServidores = $("#dataTableServidores");
      let url = tabelaServidores.data(opcoes.dataUrl);
      if (!url) {
        toastr.warning(opcoes.mensagemRotaIndisponivel || "Nao foi possivel encontrar a rota da acao.", "Indisponivel!");
        return;
      }

      let lista = (servidores || []).filter((srv) => srv && srv.id);
      if (!lista.length) {
        swal.fire("Nenhum servidor", opcoes.mensagemNenhumServidor || "Nenhum servidor encontrado para executar a acao.", "warning");
        return;
      }

      let textoConfirmacao = lista.length === 1
        ? opcoes.textoConfirmacaoUm(lista[0])
        : opcoes.textoConfirmacaoVarios(lista.length);

      swal.fire({
        title: opcoes.tituloConfirmacao || "Executar acao?",
        text: textoConfirmacao,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: opcoes.confirmButtonText || "Sim, executar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: opcoes.confirmButtonColor || "#5e72e4"
      }).then((result: any) => {
        if (!result.isConfirmed) {
          return;
        }
        this.exibirProgressoReinicioPluginsServidores(url, lista, opcoes.opcoesProgresso || {});
      });
    }

    private obterContainerReinicioPluginsAtual(): JQuery {
      let htmlContainer = swal.getHtmlContainer ? swal.getHtmlContainer() : null;
      if (!htmlContainer) {
        return $();
      }
      return $(htmlContainer).find('.rps-modal');
    }

    private swalAtualEhModalReinicioPlugins(): boolean {
      return this.obterContainerReinicioPluginsAtual().length > 0;
    }

    private fecharSwalSeNaoForModalReinicioPlugins() {
      if (!this.swalAtualEhModalReinicioPlugins()) {
        swal.close();
      }
    }

    // Adaptador de Servidores: mantem a assinatura/callers antigos e delega ao nucleo generico.
    // Os padroes abaixo preservam EXATAMENTE os textos originais do modal de servidores.
    private exibirProgressoReinicioPluginsServidores(url: string, lista: Array<{ id: any, nome: string, address: string }>, opcoes: any = {}) {
      let itens = (lista || []).map((srv: any) => {
        return { id: srv.id, titulo: srv.nome, subtitulo: srv.address, _orig: srv };
      });
      let padroesServidor: any = {
        tituloModal: "Reiniciando Plugins",
        labelProcessando: "Reiniciando",
        statusProcessando: "Reiniciando...",
        statusSucesso: "Reiniciado",
        mensagemFalhaPadrao: "Falha ao reiniciar",
        tituloSucesso: "Reinicio Concluido",
        tituloFalha: "Reinicio Falhou",
        tituloParcial: "Reinicio Parcial",
        sufixoSucesso: "reiniciado(s)",
        substantivoItem: "servidor(es)"
      };
      let opcoesServidor = $.extend({}, padroesServidor, opcoes || {});
      let requestFn = (item: any) => {
        return this.reiniciarPluginServidorUnico(url, item.id);
      };
      this.exibirProgressoLote(itens, opcoesServidor, requestFn);
    }

    // Nucleo generico de progresso em lote (compartilhado por Servidores e Contas).
    // Sequencial por item, com contadores ok/falhas/na fila, cancelamento opcional (opcoes.permitirCancelar),
    // modo agregado opcional (opcoes.enviarLoteUnico = uma unica requisicao para todo o conjunto) e desfecho garantido.
    private exibirProgressoLote(lista: Array<{ id: any, titulo: string, subtitulo: string, _orig?: any }>, opcoes: any = {}, requestFn: (item: any) => any = null) {
      let total = lista.length;
      let estado: any = { cancelado: false };

      let itensHtml = lista.map((item) => {
        let titulo = this.escapeHtml(item.titulo);
        let subtitulo = this.escapeHtml(item.subtitulo || "");
        return `
          <div class="rps-item" id="rps-item-${item.id}" style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;border-radius:10px;margin-bottom:8px;background:#f6f7fb;border:1px solid #eef0f6;transition:background .3s ease;">
            <div style="display:flex;align-items:center;gap:10px;min-width:0;">
              <span class="rps-icone" style="width:22px;flex:0 0 22px;text-align:center;color:#adb5bd;font-size:16px;"><i class="fas fa-clock"></i></span>
              <div style="min-width:0;text-align:left;">
                <div style="font-weight:600;color:#32325d;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${titulo}</div>
                <div style="font-size:12px;color:#8898aa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${subtitulo}</div>
              </div>
            </div>
            <span class="rps-status" style="font-size:12px;font-weight:600;color:#adb5bd;white-space:nowrap;flex:0 0 auto;">Na fila</span>
          </div>`;
      }).join("");

      let botaoPrincipal = opcoes.permitirCancelar
        ? `<button type="button" class="btn btn-outline-danger btn-sm btn-rps-cancelar"><i class="fas fa-ban"></i> Cancelar</button>`
        : `<button type="button" class="btn btn-outline-secondary btn-sm btn-rps-fechar">Fechar</button>`;

      let html = `
        <div class="rps-modal">
          <div style="margin-bottom:16px;">
            <div style="display:flex;justify-content:space-between;align-items:center;font-size:13px;color:#525f7f;margin-bottom:6px;">
              <span class="rps-label" style="font-weight:600;text-align:left;flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${opcoes.labelInicial ? this.escapeHtml(opcoes.labelInicial) : 'Iniciando...'}</span>
              <span class="rps-pct" style="font-weight:700;color:#5e72e4;margin-left:8px;">0%</span>
            </div>
            <div style="height:10px;background:#e9ecef;border-radius:999px;overflow:hidden;">
              <div class="rps-barra" style="height:100%;width:0%;background:linear-gradient(90deg,#5e72e4,#825ee4);border-radius:999px;transition:width .35s ease;"></div>
            </div>
            <div style="display:flex;gap:18px;justify-content:center;margin-top:12px;font-size:12px;font-weight:600;">
              <span style="color:#2dce89;"><i class="fas fa-check-circle"></i> <span class="rps-ok">0</span> ok</span>
              <span style="color:#f5365c;"><i class="fas fa-times-circle"></i> <span class="rps-falha">0</span> falhas</span>
              <span style="color:#8898aa;"><i class="fas fa-clock"></i> <span class="rps-pendentes">${total}</span> na fila</span>
            </div>
          </div>
          <div class="rps-lista" style="max-height:260px;overflow-y:auto;padding-right:4px;">
            ${itensHtml}
          </div>
          <div class="rps-acoes" style="margin-top:16px;display:flex;gap:8px;justify-content:center;flex-wrap:wrap;">
            ${botaoPrincipal}
          </div>
        </div>`;

      swal.fire({
        title: opcoes.tituloModal || "Processando",
        html: html,
        width: 540,
        allowOutsideClick: false,
        allowEscapeKey: true,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          let $c = this.obterContainerReinicioPluginsAtual();
          $c.find('.btn-rps-fechar').on('click', () => {
            swal.close();
          });
          $c.find('.btn-rps-cancelar').on('click', (e: JQueryEventObject) => {
            estado.cancelado = true;
            $(e.currentTarget).prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Cancelando...');
            this.obterContainerReinicioPluginsAtual().find('.rps-label').text('Cancelando... (apos a conta atual)');
          });
          let finalizar = (resumo: any) => {
            this.finalizarProgressoLote(resumo, opcoes, requestFn);
            if (opcoes.aoFinalizar) {
              opcoes.aoFinalizar(resumo);
            }
          };

          // Modo dirigido por EVENTOS do plugin (operacao unica longa, ex.: sincronizar/limpar cache):
          // UMA unica chamada ao plugin; as linhas/contadores sao atualizados pelos eventos
          // 'progresso_sincronizacao_contas' via tratarProgressoSincronizacaoContas. Finaliza no ack
          // (ou no evento 'concluido'), o que vier primeiro, de forma idempotente.
          if (opcoes.progressoPorEvento) {
            let estadoEvento: any = { total: total, ok: 0, falha: 0, concluidos: 0, finalizado: false };
            estadoEvento.finalizarEvento = (info: any) => {
              if (estadoEvento.finalizado) { return; }
              estadoEvento.finalizado = true;
              this.progressoSincronizacaoAtivo = null;
              let falha = estadoEvento.falha;
              // Falha geral (plugin nao processou nada e retornou erro) => marca tudo como falha.
              if (estadoEvento.concluidos === 0 && info && info.falhaGeral) {
                falha = estadoEvento.total;
              }
              finalizar({ total: estadoEvento.total, sucesso: estadoEvento.ok, falha: falha, cancelado: false, resultados: [] });
            };
            this.progressoSincronizacaoAtivo = estadoEvento;
            let promessa = requestFn ? requestFn(null) : null;
            if (promessa && promessa.then) {
              promessa.then((resultado: any) => {
                estadoEvento.finalizarEvento({ falhaGeral: !!(resultado && resultado.ok === false) });
              }, () => {
                estadoEvento.finalizarEvento({ falhaGeral: true });
              });
            } else {
              estadoEvento.finalizarEvento({ falhaGeral: true });
            }
            return;
          }

          this.processarFilaLote(lista, opcoes, requestFn, estado).then((resumo: any) => {
            finalizar(resumo);
          }, () => {
            finalizar({ total: total, sucesso: 0, falha: total, cancelado: false, resultados: [] });
          });
        }
      });
    }

    private processarFilaLote(lista: Array<{ id: any, titulo: string, subtitulo: string, _orig?: any }>, opcoes: any = {}, requestFn: (item: any) => any = null, estado: any = { cancelado: false }) {
      let total = lista.length;
      let ok = 0;
      let falha = 0;
      let resultados: any[] = [];
      let timeoutMs = opcoes.timeoutMs ? opcoes.timeoutMs : 0;

      let atualizarContadores = (concluidos: number) => {
        let $c = this.obterContainerReinicioPluginsAtual();
        let pct = total ? Math.round((concluidos / total) * 100) : 100;
        $c.find('.rps-barra').css('width', pct + '%');
        $c.find('.rps-pct').text(pct + '%');
        $c.find('.rps-ok').text(ok);
        $c.find('.rps-falha').text(falha);
        $c.find('.rps-pendentes').text(total - concluidos);
      };

      let rolarParaItem = ($listaScroll: any, $item: any, ajusteTopo: number, duracao: number) => {
        if (!$listaScroll.length || !$item.length) {
          return;
        }

        let novoScroll = $listaScroll.scrollTop() + $item.position().top - ajusteTopo;
        $listaScroll.stop(true).animate({ scrollTop: Math.max(novoScroll, 0) }, duracao);
      };

      // Executa requestFn com defesa total: nunca rejeita; reject/throw viram falha; se
      // opcoes.timeoutMs > 0 aplica um teto anti-freeze por item (rede de seguranca), garantindo
      // que a fila SEMPRE avanca e nunca fica presa em um item. Servidores nao definem timeoutMs
      // (comportamento identico ao anterior).
      let executarRequisicaoSegura = (alvo: any): any => {
        let deferred = $.Deferred();
        let resolvido = false;
        let timer: any = null;
        let concluir = (resultado: any) => {
          if (resolvido) { return; }
          resolvido = true;
          if (timer) { clearTimeout(timer); }
          deferred.resolve(resultado);
        };
        if (timeoutMs > 0) {
          timer = setTimeout(() => {
            concluir({ ok: false, mensagem: "Sem resposta (tempo esgotado)." });
          }, timeoutMs);
        }
        try {
          let promessa = requestFn ? requestFn(alvo) : null;
          if (promessa && promessa.then) {
            promessa.then((resultado: any) => {
              concluir(resultado ? resultado : { ok: false, mensagem: (opcoes.mensagemFalhaPadrao || "Falha.") });
            }, (erro: any) => {
              concluir({ ok: false, mensagem: (erro && erro.mensagem ? erro.mensagem : (opcoes.mensagemFalhaPadrao || "Falha.")) });
            });
          } else {
            concluir(promessa ? promessa : { ok: false, mensagem: (opcoes.mensagemFalhaPadrao || "Falha.") });
          }
        } catch (e) {
          concluir({ ok: false, mensagem: (opcoes.mensagemFalhaPadrao || "Falha ao executar.") });
        }
        return deferred.promise();
      };

      let aplicarResultadoNoItem = (item: any, resultado: any) => {
        let $c = this.obterContainerReinicioPluginsAtual();
        let $item = $c.find(`#rps-item-${item.id}`);
        if (resultado && resultado.ok) {
          ok++;
          $item.css('background', '#eafaf1');
          $item.find('.rps-icone').html('<i class="fas fa-check-circle" style="color:#2dce89;"></i>');
          $item.find('.rps-status').css('color', '#2dce89').removeAttr('title').text(opcoes.statusSucesso || 'Concluido');
        } else {
          falha++;
          let msg = resultado && resultado.mensagem ? resultado.mensagem : (opcoes.mensagemFalhaPadrao || 'Falhou');
          $item.css('background', '#fdecef');
          $item.find('.rps-icone').html('<i class="fas fa-times-circle" style="color:#f5365c;"></i>');
          $item.find('.rps-status').css('color', '#f5365c').attr('title', msg).text('Falhou');
        }
        resultados.push({
          item: item,
          id: item.id,
          ok: !!(resultado && resultado.ok),
          mensagem: resultado && resultado.mensagem ? resultado.mensagem : null
        });
      };

      // Modo agregado: UMA unica requisicao para todo o conjunto (ex.: sincronizar database e' atomico
      // no plugin). Todas as linhas concluem juntas a partir do resultado unico.
      if (opcoes.enviarLoteUnico) {
        let $cLote = this.obterContainerReinicioPluginsAtual();
        lista.forEach((item) => {
          let $item = $cLote.find(`#rps-item-${item.id}`);
          $item.css('background', '#eef2ff');
          $item.find('.rps-icone').html('<i class="fas fa-spinner fa-spin" style="color:#5e72e4;"></i>');
          $item.find('.rps-status').css('color', '#5e72e4').text(opcoes.statusProcessando || 'Processando...');
        });
        $cLote.find('.rps-label').text(opcoes.labelProcessando || 'Processando');
        $cLote.find('.rps-barra').css('width', '90%');
        $cLote.find('.rps-pct').text('...');
        return executarRequisicaoSegura(lista).then((resultado: any) => {
          lista.forEach((item) => {
            aplicarResultadoNoItem(item, resultado);
          });
          atualizarContadores(total);
          return $.Deferred().resolve({ total: total, sucesso: ok, falha: falha, cancelado: false, resultados: resultados }).promise();
        });
      }

      let processarIndice = (indice: number): any => {
        // Cancelamento solicitado: marca os itens restantes como "Cancelado" e encerra com desfecho claro.
        if (estado && estado.cancelado) {
          let $cCancel = this.obterContainerReinicioPluginsAtual();
          for (let j = indice; j < total; j++) {
            let it = lista[j];
            let $rest = $cCancel.find(`#rps-item-${it.id}`);
            $rest.css('background', '#f1f3f5');
            $rest.find('.rps-icone').html('<i class="fas fa-minus-circle" style="color:#adb5bd;"></i>');
            $rest.find('.rps-status').css('color', '#adb5bd').removeAttr('title').text('Cancelado');
          }
          return $.Deferred().resolve({ total: total, sucesso: ok, falha: falha, cancelado: true, naoProcessadas: total - indice, resultados: resultados }).promise();
        }

        if (indice >= total) {
          return $.Deferred().resolve({ total: total, sucesso: ok, falha: falha, cancelado: false, resultados: resultados }).promise();
        }

        let item = lista[indice];
        let $c = this.obterContainerReinicioPluginsAtual();
        let $item = $c.find(`#rps-item-${item.id}`);

        $item.css('background', '#eef2ff');
        $item.find('.rps-icone').html('<i class="fas fa-spinner fa-spin" style="color:#5e72e4;"></i>');
        $item.find('.rps-status').css('color', '#5e72e4').text(opcoes.statusProcessando || 'Processando...');
        $c.find('.rps-label').text(`${opcoes.labelProcessando || 'Processando'} ${indice + 1} de ${total}: ${item.titulo}`);

        let $listaScroll = $c.find('.rps-lista');
        rolarParaItem($listaScroll, $item, 85, 180);

        return executarRequisicaoSegura(item).then((resultado: any) => {
          aplicarResultadoNoItem(item, resultado);
          atualizarContadores(indice + 1);
          rolarParaItem($listaScroll, $item, 115, 220);

          let proximo = $.Deferred();
          setTimeout(() => {
            processarIndice(indice + 1).then((res: any) => {
              proximo.resolve(res);
            }, (err: any) => {
              proximo.reject(err);
            });
          }, 280);
          return proximo.promise();
        });
      };

      return processarIndice(0);
    }

    private reiniciarPluginServidorUnico(url: string, id: any) {
      return $.ajax({
        url: url,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ ids: [id] }),
        beforeSend: (jqXHR: JQueryXHR) => {
          jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
        }
      }).then((dados: any) => {
        let resumo = dados && dados.dadosResposta ? dados.dadosResposta : dados;
        let resultados = resumo && resumo.resultados ? resumo.resultados : [];
        return resultados.length ? resultados[0] : { ok: false, mensagem: 'Resposta invalida do servidor.' };
      }, () => {
        return { ok: false, mensagem: 'Falha de comunicacao com o painel.' };
      });
    }

    private finalizarProgressoLote(resumo: any, opcoes: any = {}, requestFn: any = null) {
      let total = resumo && resumo.total ? resumo.total : 0;
      let sucesso = resumo && resumo.sucesso ? resumo.sucesso : 0;
      let falha = resumo && resumo.falha ? resumo.falha : 0;
      let cancelado = !!(resumo && resumo.cancelado);
      let naoProcessadas = resumo && resumo.naoProcessadas ? resumo.naoProcessadas : 0;
      let itensFalhados = resumo && resumo.resultados
        ? resumo.resultados.filter((r: any) => r && !r.ok).map((r: any) => r.item).filter((it: any) => it)
        : [];
      let substantivo = opcoes.substantivoItem ? opcoes.substantivoItem : 'item(ns)';

      let $c = this.obterContainerReinicioPluginsAtual();
      if (!$c.length) {
        return;
      }

      let corBarra;
      if (cancelado) {
        corBarra = 'linear-gradient(90deg,#adb5bd,#8898aa)';
      } else if (falha === 0) {
        corBarra = 'linear-gradient(90deg,#2dce89,#2dcecc)';
      } else if (sucesso === 0) {
        corBarra = '#f5365c';
      } else {
        corBarra = 'linear-gradient(90deg,#fb6340,#f5365c)';
      }
      $c.find('.rps-barra').css('width', '100%').css('background', corBarra);
      $c.find('.rps-pct').text('100%');

      let label;
      if (cancelado) {
        label = `Cancelado: ${sucesso} ok, ${falha} falha(s), ${naoProcessadas} nao processada(s).`;
      } else if (falha === 0) {
        label = `Concluido! ${sucesso} ${substantivo} ${opcoes.sufixoSucesso || 'processado(s)'}.`;
      } else if (sucesso === 0) {
        label = `Falhou em ${total} ${substantivo}.`;
      } else {
        label = `Concluido: ${sucesso} ok, ${falha} falha(s).`;
      }
      $c.find('.rps-label').text(label);

      let titulo = swal.getTitle();
      if (titulo) {
        if (cancelado) {
          titulo.textContent = 'Cancelado';
        } else if (falha === 0) {
          titulo.textContent = (opcoes.tituloSucesso || 'Concluido');
        } else if (sucesso === 0) {
          titulo.textContent = (opcoes.tituloFalha || 'Falhou');
        } else {
          titulo.textContent = (opcoes.tituloParcial || 'Parcial');
        }
      }

      $c.find('.rps-acoes').remove();
      let botoesAcoes = '';
      if (itensFalhados.length && requestFn) {
        let textoBotao = itensFalhados.length === 1 ? 'Retentar falha' : `Retentar ${itensFalhados.length} falhas`;
        botoesAcoes += `
          <button type="button" class="btn btn-outline-danger btn-sm btn-rps-retentar-falhas">
            <i class="fas fa-redo-alt"></i> ${textoBotao}
          </button>`;
      }
      botoesAcoes += `
        <button type="button" class="btn btn-primary btn-sm btn-rps-fechar">
          Fechar
        </button>`;

      $c.append(`
        <div class="rps-acoes" style="margin-top:16px;display:flex;gap:8px;justify-content:center;flex-wrap:wrap;">
          ${botoesAcoes}
        </div>
      `);
      $c.find('.btn-rps-retentar-falhas').on('click', (e: JQueryEventObject) => {
        $(e.currentTarget).prop('disabled', true);
        this.exibirProgressoLote(itensFalhados, opcoes, requestFn);
      });
      $c.find('.btn-rps-fechar').on('click', () => {
        swal.close();
      });
    }

    // ===== Helpers de acoes em lote de CONTAS (usam o nucleo generico exibirProgressoLote) =====

    // Embrulha comunicacao.enviar (callback) numa Promise que NUNCA rejeita: erro/excecao/timeout
    // viram { ok:false }, de modo que uma conta com problema jamais trava a fila.
    private enviarAcaoContaComoPromise(acao: any, request: any, timeoutMs: number = 600000): Promise<{ ok: boolean, mensagem: string }> {
      return new Promise((resolve) => {
        let resolvido = false;
        let timer: any = null;
        let finalizar = (ok: boolean, mensagem: string) => {
          if (resolvido) { return; }
          resolvido = true;
          if (timer) { clearTimeout(timer); }
          resolve({ ok: ok, mensagem: mensagem });
        };
        timer = setTimeout(() => {
          finalizar(false, "Sem resposta do plugin (tempo esgotado).");
        }, timeoutMs);
        try {
          this.comunicacao.enviar(acao, request, (response: IRespostaMensagem) => {
            let resultado: any = response && (response as any).result ? (response as any).result : null;
            let ok = !!(response && response.status);
            let mensagem = resultado && resultado.mensagem ? resultado.mensagem
              : (resultado && resultado.erro ? resultado.erro : "");
            finalizar(ok, mensagem);
          });
        } catch (e) {
          finalizar(false, "Falha ao comunicar com o plugin.");
        }
      });
    }

    // Mapeia contas (linhas da DataTable) para itens do modal de progresso.
    private mapearContasParaItensLote(contas: any[]): Array<{ id: any, titulo: string, subtitulo: string, _orig: any }> {
      return (contas || []).filter((c: any) => c && c.id).map((c: any) => {
        let dados: any = c.dadosEa ? c.dadosEa : {};
        let titulo = dados.clubeName ? dados.clubeName : (c.email ? c.email : ("Conta " + c.id));
        let plataforma = dados.plataforma ? dados.plataforma : "";
        let subtitulo = plataforma ? (plataforma + " · " + (c.email ? c.email : "")) : (c.email ? c.email : "");
        return { id: c.id, titulo: titulo, subtitulo: subtitulo, _orig: c };
      });
    }

    // Despacho comum das acoes em lote de contas: guarda de concorrencia, validacao de selecao,
    // log de inicio, e log/reset da guarda garantidos no fim (via opcoes.aoFinalizar).
    private executarAcaoLoteContas(contas: any[], opcoes: any, requestFn: (item: any) => any) {
      let titulo = opcoes.tituloModal ? opcoes.tituloModal : "Acao em lote";
      if (this.executandoAcaoLoteContas) {
        toastr.warning("Ja existe uma acao em lote em andamento. Aguarde terminar.", titulo);
        return;
      }
      let itens = this.mapearContasParaItensLote(contas);
      if (!itens.length) {
        toastr.warning("Selecione uma ou mais contas.", titulo);
        return;
      }
      this.executandoAcaoLoteContas = true;
      $("#modalAcoesContas").modal("hide");

      Util.exibirAlertaNotificacaoToastr(titulo, `Iniciando em ${itens.length} conta(s)...`, "info");
      this.registrarLogAcaoLote(titulo, `Iniciado em ${itens.length} conta(s).`, "info");

      let aoFinalizarOriginal = opcoes.aoFinalizar;
      opcoes.aoFinalizar = (resumo: any) => {
        this.executandoAcaoLoteContas = false;
        this.logarFimAcaoLoteContas(opcoes, resumo);
        if (aoFinalizarOriginal) {
          aoFinalizarOriginal(resumo);
        }
      };

      this.exibirProgressoLote(itens, opcoes, requestFn);
    }

    private logarFimAcaoLoteContas(opcoes: any, resumo: any) {
      let titulo = opcoes.tituloModal ? opcoes.tituloModal : "Acao em lote";
      let ok = resumo && resumo.sucesso ? resumo.sucesso : 0;
      let falha = resumo && resumo.falha ? resumo.falha : 0;
      if (resumo && resumo.cancelado) {
        let naoProc = resumo.naoProcessadas ? resumo.naoProcessadas : 0;
        let msg = `Cancelado: ${ok} ok, ${falha} falha(s), ${naoProc} nao processada(s).`;
        Util.exibirAlertaNotificacaoToastr(titulo, msg, "warning");
        this.registrarLogAcaoLote(titulo, msg, "warning");
      } else if (falha === 0) {
        let msg = `Concluido: ${ok} conta(s) ok.`;
        Util.exibirAlertaNotificacaoToastr(titulo, msg, "success");
        this.registrarLogAcaoLote(titulo, msg, "success");
      } else {
        let msg = `Concluido: ${ok} ok, ${falha} falha(s).`;
        Util.exibirAlertaNotificacaoToastr(titulo, msg, ok === 0 ? "error" : "warning");
        this.registrarLogAcaoLote(titulo, msg, ok === 0 ? "danger" : "warning");
      }
    }

    // Trilha persistente opcional no feed de logs (#espacoLogs), quando presente na pagina.
    private registrarLogAcaoLote(titulo: string, mensagem: string, cor: string = 'info') {
      try {
        let $log = $("#espacoLogs");
        if (!$log.length) {
          return;
        }
        let agora = new Date().toLocaleString();
        $log.prepend(
          '<div class="border-bottom pb-1 mb-1">' +
          '<span class="badge badge-pill badge-' + cor + ' text-uppercase">' + this.escapeHtml(titulo) + '</span>' +
          '<span class="text-muted float-right font-size-10">' + this.escapeHtml(agora) + '</span>' +
          '<p class="m-0 font-size-12">' + this.escapeHtml(mensagem) + '</p>' +
          '</div>'
        );
      } catch (e) { }
    }

    // Recebe os eventos 'progresso_sincronizacao_contas' emitidos pelo plugin durante a sincronizacao
    // (operacao unica que fecha tudo, limpa a pasta e recria o perfil de cada conta) e atualiza o modal
    // de progresso em tempo real. So faz algo se houver um modal de sincronizacao aberto.
    private tratarProgressoSincronizacaoContas(request: any) {
      try {
        if (!request) { return; }
        let estado = this.progressoSincronizacaoAtivo;
        let $c = this.obterContainerReinicioPluginsAtual();
        let fase = request.fase;

        if (fase === 'inicio') {
          if (estado && request.total) { estado.total = request.total; }
          if ($c.length) {
            let total = estado ? estado.total : (request.total ? request.total : 0);
            $c.find('.rps-label').text(`Sincronizando 0 de ${total}...`);
          }
          return;
        }

        if (fase === 'processando') {
          let total = estado ? estado.total : (request.total ? request.total : 0);
          if ($c.length) {
            if (request.id !== null && request.id !== undefined) {
              let $item = $c.find(`#rps-item-${request.id}`);
              $item.css('background', '#eef2ff');
              $item.find('.rps-icone').html('<i class="fas fa-spinner fa-spin" style="color:#5e72e4;"></i>');
              $item.find('.rps-status').css('color', '#5e72e4').removeAttr('title').text('Sincronizando...');
              let $lista = $c.find('.rps-lista');
              if ($lista.length && $item.length) {
                let novoScroll = $lista.scrollTop() + $item.position().top - 85;
                $lista.stop(true).animate({ scrollTop: Math.max(novoScroll, 0) }, 180);
              }
            }
            $c.find('.rps-label').text(`Sincronizando ${request.indice ? request.indice : '?'} de ${total}...`);
          }
          return;
        }

        if (fase === 'ok' || fase === 'falha') {
          if (estado) {
            if (fase === 'ok') { estado.ok++; } else { estado.falha++; }
            estado.concluidos++;
          }
          if ($c.length) {
            if (request.id !== null && request.id !== undefined) {
              let $item = $c.find(`#rps-item-${request.id}`);
              if (fase === 'ok') {
                $item.css('background', '#eafaf1');
                $item.find('.rps-icone').html('<i class="fas fa-check-circle" style="color:#2dce89;"></i>');
                $item.find('.rps-status').css('color', '#2dce89').removeAttr('title').text('Sincronizado');
              } else {
                let msg = request.mensagem ? request.mensagem : 'Falha ao sincronizar';
                $item.css('background', '#fdecef');
                $item.find('.rps-icone').html('<i class="fas fa-times-circle" style="color:#f5365c;"></i>');
                $item.find('.rps-status').css('color', '#f5365c').attr('title', msg).text('Falhou');
              }
            }
            if (estado) {
              let concluidos = estado.concluidos;
              let total = estado.total ? estado.total : 1;
              let pct = Math.round((concluidos / total) * 100);
              if (pct > 100) { pct = 100; }
              $c.find('.rps-barra').css('width', pct + '%');
              $c.find('.rps-pct').text(pct + '%');
              $c.find('.rps-ok').text(estado.ok);
              $c.find('.rps-falha').text(estado.falha);
              $c.find('.rps-pendentes').text(Math.max(total - concluidos, 0));
            }
          }
          return;
        }

        if (fase === 'concluido' || fase === 'erro_geral') {
          if (estado && estado.finalizarEvento) {
            estado.finalizarEvento({ falhaGeral: fase === 'erro_geral' });
          }
          return;
        }
      } catch (e) {
        console.log("ERRO tratarProgressoSincronizacaoContas", e);
      }
    }

    private escapeHtml(valor: any): string {
      return $('<div/>').text(valor === null || valor === undefined ? '' : String(valor)).html();
    }

    /**
     * @deprecated NÃO USAR. O toggle `config_remota` foi removido do modal — quem define a
     * configuração de cada VPS é o `#selectConfiguracaoPro` (+ botão Aplicar). Este método GRAVA
     * configuração e liga/desliga `status` do usuário; chamá-lo de novo reintroduziria o bug de
     * tirar do legado local as VPS que nunca optaram. Mantido só porque o binding legado ainda
     * existe (sobre um seletor vazio, então nunca dispara).
     */
    private aoAtivarDesativarConfigRemota(e: JQueryEventObject, status: boolean = null, config: IConfiguracoesGeraisExecucao = null) {
      let statusConfigRemota: boolean = status != null ? status : $(e.target).is(':checked')
      // console.log("ativou", statusConfigRemota)
      if (statusConfigRemota) {
        $('.info-config-remoto').show()
        $('.info-config-local').hide()
        if (config) {
          this.preencherConfiguracaoGeral(config);
        } else {
          App.Util.exibirLoadingFormModal($('.loading-form-modal'))
          this.obterConfiguracaoGeralRemotaAtualizada((dadosSucesso: IRespostaSucessoAjx) => {
            App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
            let dadosConfig: IConfiguracaoGeralBaseRemota = dadosSucesso.dadosRetornados
            console.log("DADOS CHEGOU aoAtivarDesativarConfigRemota", dadosSucesso, dadosConfig)
            if (dadosConfig && dadosConfig.dados) {
              this.salvarConfiguracaoGeralRemotaAtualizada(statusConfigRemota)
              this.preencherConfiguracaoGeral(dadosConfig.dados);
            } else {
              this.salvarOuAtualizarConfigRemota(statusConfigRemota)
            }
          })
        }
      } else {
        $('.info-config-remoto').hide()
        $('.info-config-local').show()
        this.salvarConfiguracaoGeralRemotaAtualizada(false)
        this.obterConfiguracaoGeralLocalAtualizada()
      }
      // this.ajax = new App.Ajax();
      // this.ajax.postAcao($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id"), status: $(e.target).is(':checked') });
    }

    private obterConfiguracaoGeralRemotaAtualizada(callbackResposta: any) {
      this.ajax.get(`${App.Util.config.urlGetConfiguracaoPro}`, {}, callbackResposta, null, null, false)
    }

    /** `idConfiguracao` null = configuração padrão (fluxo antigo / plano cloud). */
    private salvarOuAtualizarConfigRemota(status: boolean, idConfiguracao: number = null, callbackAtualizacaoConfig: any = null) {
      var form = $(`#formConfiguracoesGeralBot`)
      var dadosForm: IConfiguracoesGeraisExecucao = this.ajax.convertFormAninhadoToJSON(form)
      dadosForm.prioridade_tarefas_automaticas = this.normalizarPrioridadeTarefasAutomaticas(dadosForm);
      this.normalizarConfiguracaoAutoDmeGeral(dadosForm, this.getConfiguracaoAutoDmeAtual(), false);
      // `alterarStatus=false`: salvar configuração nunca liga/desliga o "usar config online" do usuário.
      this.salvarConfiguracaoGeralRemotaAtualizada(status, this.removerCamposServidorLocalConfigGeral(dadosForm), callbackAtualizacaoConfig, idConfiguracao, null, false, false)
    }

    /**
     * `alterarStatus` default true preserva o fluxo antigo (toggle "Config. online" e botão Salvar
     * principal). O seletor de configurações passa `false`: salvar/criar uma configuração NÃO pode
     * ligar o "usar config online" do usuário, senão tira do legado local as VPS que nunca optaram.
     */
    private salvarConfiguracaoGeralRemotaAtualizada(status: boolean, config: IConfiguracoesGeraisExecucao = null, callbackPostConfigRemota: any = null, idConfiguracao: number = null, nomeConfiguracao: string = null, criar: boolean = false, alterarStatus: boolean = true) {
      App.Util.exibirLoadingFormModal($('.loading-form-modal'))
      let dadosPost: any = { status: status, alterar_status: alterarStatus }
      if (config) {
        dadosPost.dados = this.removerCamposServidorLocalConfigGeral(config);
      }
      // Sem `id` e sem `criar`, o backend grava na configuração PADRÃO — que é o comportamento de
      // quando existia uma única configuração por usuário (mantém o fluxo antigo intacto).
      if (idConfiguracao) {
        dadosPost.id = idConfiguracao;
      }
      if (nomeConfiguracao) {
        dadosPost.nome = nomeConfiguracao;
      }
      if (criar) {
        dadosPost.criar = true;
      }

      this.ajax.postAcao(App.Util.config.urlPostConfiguracaoPro, dadosPost, (objRepostaPostConfigRemota: any) => {
        App.Util.ocultarLoadingFormModal($('.loading-form-modal'))
        if (callbackPostConfigRemota) {
          callbackPostConfigRemota(objRepostaPostConfigRemota)
        }
      }, null, false);
    }

    // ─── Configurações remotas nomeadas (N por usuário, uma escolhida por VPS) ───────────────

    /** Id do servidor do dashboard atual; `null` no painel principal, onde não há VPS em contexto. */
    private getIdServidorContextoAtual(): number {
      return this.dadosServidor && this.dadosServidor.id ? this.dadosServidor.id : null;
    }

    /**
     * Popula o seletor do modal. `id_configuracao_efetiva` null = servidor no LEGADO (usando a
     * configuração local da VPS) — nesse caso a opção "Local" continua listada até ele aplicar uma remota.
     */
    private carregarConfiguracoesProDoModal(callback: any = null) {
      const container = $('#containerSeletorConfiguracaoPro');
      if (!container.length) {
        if (callback) { callback() }
        return;
      }

      const idServidor = this.getIdServidorContextoAtual();
      this.ajax.get(App.Util.config.urlGetConfiguracoesPro, idServidor ? { idServidor: idServidor } : {}, (resposta: any) => {
        const dados = resposta && resposta.dadosRetornados ? resposta.dadosRetornados : resposta;
        const configuracoes: any[] = dados && dados.configuracoes ? dados.configuracoes : [];
        this.configuracoesProDisponiveis = configuracoes;
        // A VERDADE de qual configuração a VPS usa está no plugin (dbfs), não no web: a VPS pode nem
        // estar cadastrada em `servidor`. O valor do web serve só de ponto de partida enquanto o
        // plugin não responde (ou quando não há plugin conectado).
        this.idConfiguracaoProEfetiva = dados ? dados.id_configuracao_efetiva : null;

        const select = $('#selectConfiguracaoPro');
        select.empty();
        if (!this.idConfiguracaoProEfetiva) {
          select.append(`<option value="local">Local (somente nesta VPS)</option>`);
        }
        configuracoes.forEach((config: any) => {
          const rotulo = config.padrao ? `${config.nome} (padrão)` : config.nome;
          select.append(`<option value="${config.id}">${rotulo}</option>`);
        });
        select.append(`<option value="nova">+ Nova configuração</option>`);

        // Aplicar depende de haver um PLUGIN conectado (é nele que a escolha é gravada), e não de a
        // VPS estar cadastrada em `servidor` — ela pode não estar.
        $('.btn-aplicar-configuracao-pro').toggle(!!this.conectado);
        // A classe é quem exibe (regra em app.scss). Setar `display` inline aqui não bastava: o tema
        // sobrescreve a largura do `.form-control`, e o CSS precisa vencer com especificidade.
        container.addClass('cfg-configs-visivel');

        // O formulário só é preenchido DEPOIS de saber o id definitivo. Antes o plugin era consultado
        // em paralelo: quando a resposta dele chegava, o seletor mudava mas o formulário continuava
        // com os valores da configuração que o WEB tinha apontado — campos errados na abertura.
        this.resolverConfiguracaoProEfetivaEPreencher(callback);
      }, () => { if (callback) { callback() } }, null, false);
    }

    /**
     * Descobre a configuração REALMENTE em uso (pergunta ao plugin, que é a fonte de verdade) e só
     * então ajusta seletor/selo e carrega os valores no formulário — uma única vez, sem corrida.
     */
    private resolverConfiguracaoProEfetivaEPreencher(callback: any = null) {
      const aplicar = () => {
        $('#selectConfiguracaoPro').val(this.idConfiguracaoProEfetiva ? String(this.idConfiguracaoProEfetiva) : 'local');
        this.atualizarSeloConfiguracaoProEmUso();
        this.sincronizarNomeConfiguracaoProSelecionada();
        if (this.idConfiguracaoProEfetiva) {
          this.carregarValoresConfiguracaoProNoFormulario(this.idConfiguracaoProEfetiva, callback);
        } else {
          this.obterConfiguracaoGeralLocalAtualizada(callback);
        }
      };

      if (!this.conectado) {
        aplicar();
        return;
      }

      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CONFIGURACAO_PRO_SELECIONADA, {}, (response: IRespostaMensagem) => {
        const idDoPlugin = response && response.status && response.result ? Number(response.result.id_configuracao_pro) || null : null;
        const orfa = !!idDoPlugin && !(this.configuracoesProDisponiveis || []).filter((c: any) => Number(c.id) === idDoPlugin)[0];

        // A VPS pode estar apontando para uma configuração que NÃO EXISTE MAIS (foi excluída). O
        // central já degrada para a padrão nesse caso, mas o dbfs do plugin continuava com o id morto
        // — e era ele que voltava aqui, deixando o seletor em branco e o formulário zerado mesmo
        // recarregando a tela. Aqui a VPS é realinhada com o que o web resolveu (a padrão).
        if (orfa) {
          this.corrigirConfiguracaoProOrfaNoPlugin(idDoPlugin, aplicar);
          return;
        }

        if (idDoPlugin) {
          this.idConfiguracaoProEfetiva = idDoPlugin;
        }
        aplicar();
      });
    }

    /**
     * Realinha a VPS quando o id guardado nela aponta para uma configuração inexistente.
     * `idConfiguracaoProEfetiva` já traz o que o web resolveu (a padrão — ou `null`, se este servidor
     * ainda está no legado local): é esse valor que passa a valer nos dois lados.
     */
    private corrigirConfiguracaoProOrfaNoPlugin(idOrfao: number, callbackFinal: any) {
      const idCorrigido = this.idConfiguracaoProEfetiva || null;
      console.log("Configuração remota inexistente no plugin; realinhando esta VPS", { idOrfao: idOrfao, idCorrigido: idCorrigido });
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CONFIGURACAO_PRO_SELECIONADA, { definir: true, id: idCorrigido }, () => {
        callbackFinal();
      });
    }

    /** Grava no plugin (dbfs da VPS) qual configuração usar. É o que faz a seleção valer de fato. */
    private definirConfiguracaoProNoPlugin(idConfiguracao: any, callbackSucesso: any = null) {
      if (!this.conectado) {
        toastr.warning("O plugin desta VPS não está conectado. Abra o dashboard do servidor para aplicar.", "Configuração remota");
        return;
      }
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CONFIGURACAO_PRO_SELECIONADA, { definir: true, id: idConfiguracao }, (response: IRespostaMensagem) => {
        if (!response || !response.status) {
          toastr.error("Não foi possível gravar a configuração no plugin.", "Configuração remota");
          return;
        }
        if (callbackSucesso) { callbackSucesso() }
      });
    }

    private atualizarSeloConfiguracaoProEmUso() {
      const selo = $('.info-config-em-uso');
      if (!selo.length) { return }
      // "Local" = legado (esta VPS ainda não aplicou nenhuma configuração online).
      if (!this.idConfiguracaoProEfetiva) {
        selo.html('Em uso: <span class="badge badge-default">Local</span>').show();
        return;
      }
      const disponiveis = this.configuracoesProDisponiveis || [];
      // Se o id efetivo não estiver na lista, o nome vem da PADRÃO de verdade — antes o selo exibia
      // a palavra "Padrão" fixa, que mentia quando a padrão do usuário tinha outro nome.
      const emUso = disponiveis.filter((c: any) => Number(c.id) === Number(this.idConfiguracaoProEfetiva))[0]
        || disponiveis.filter((c: any) => !!c.padrao)[0];
      const nomeEmUso = this.escapeHtml(emUso ? emUso.nome : 'Padrão');
      selo.html(`Em uso: ${nomeEmUso} <span class="badge badge-info">Online</span>`).show();
    }

    private getConfiguracaoProSelecionada(): any {
      const valor = String($('#selectConfiguracaoPro').val() || '');
      return (this.configuracoesProDisponiveis || []).filter((c: any) => String(c.id) === valor)[0];
    }

    private sincronizarNomeConfiguracaoProSelecionada() {
      const valor = String($('#selectConfiguracaoPro').val() || '');
      const selecionada = this.getConfiguracaoProSelecionada();
      const inputNome = $('#inputNomeConfiguracaoPro');

      // A padrão é a âncora do usuário — é para ela que toda configuração excluída/inexistente
      // degrada, então excluí-la não pode ser oferecido: o botão SOME (e o backend recusa de todo
      // jeito). Some também em "Local"/"+ Nova", onde não há nada gravado para excluir.
      const podeExcluir = !!selecionada && !selecionada.padrao;
      $('.btn-excluir-configuracao-pro').toggle(podeExcluir).prop('disabled', !podeExcluir);

      if (valor === 'nova') {
        inputNome.val('').prop('disabled', false);
        return;
      }

      inputNome.val(selecionada ? selecionada.nome : '');
      // Nome da padrão é fixo.
      inputNome.prop('disabled', !selecionada || !!selecionada.padrao);
    }

    /** Troca de seleção só carrega os valores no formulário — não muda o que a VPS usa. */
    private aoTrocarConfiguracaoProSelecionada() {
      this.sincronizarNomeConfiguracaoProSelecionada();
      const valor = String($('#selectConfiguracaoPro').val() || '');

      // "+ Nova": mantém no formulário os valores que já estão à vista, para servirem de base.
      if (valor === 'nova') {
        $('#inputNomeConfiguracaoPro').focus();
        return;
      }

      if (valor === 'local') {
        this.obterConfiguracaoGeralLocalAtualizada(() => this.atualizarResumoPoolConfigGeralModal());
        return;
      }

      this.carregarValoresConfiguracaoProNoFormulario(valor);
    }

    /** Carrega os valores de uma configuração remota no formulário do modal. */
    private carregarValoresConfiguracaoProNoFormulario(idConfiguracao: any, callback: any = null) {
      this.ajax.get(App.Util.config.urlGetConfiguracaoPro, { id: idConfiguracao }, (resposta: any) => {
        const dados = resposta && resposta.dadosRetornados ? resposta.dadosRetornados : resposta;
        if (dados && dados.dados) {
          this.preencherConfiguracaoGeral(dados.dados);
        }
        this.atualizarResumoPoolConfigGeralModal();
        if (callback) { callback() }
      }, () => { if (callback) { callback() } }, null, false);
    }

    /** Salvar: grava o formulário na configuração selecionada (ou cria, se for "+ Nova"). */
    private salvarConfiguracaoProSelecionada() {
      const valor = String($('#selectConfiguracaoPro').val() || '');
      const nome = String($('#inputNomeConfiguracaoPro').val() || '').trim();
      const selecionada = this.getConfiguracaoProSelecionada();
      const criandoNova = valor === 'nova' || valor === 'local';

      if (criandoNova && !nome) {
        toastr.warning("Informe um nome para a nova configuração.", "Configuração remota");
        return;
      }

      var form = $(`#formConfiguracoesGeralBot`);
      var dadosForm: IConfiguracoesGeraisExecucao = this.ajax.convertFormAninhadoToJSON(form);
      dadosForm.prioridade_tarefas_automaticas = this.normalizarPrioridadeTarefasAutomaticas(dadosForm);
      this.normalizarConfiguracaoAutoDmeGeral(dadosForm, this.getConfiguracaoAutoDmeAtual(), false);

      this.salvarConfiguracaoGeralRemotaAtualizada(true, this.removerCamposServidorLocalConfigGeral(dadosForm), (resposta: any) => {
        const dados = resposta && resposta.dadosRetornados ? resposta.dadosRetornados : resposta;
        // O backend recusa nome vazio/duplicado com 200 + status:false; sem isso o usuário via
        // "salvo com sucesso" e nada teria sido gravado.
        if (dados && dados.status === false) {
          toastr.warning(dados.mensagem || "Não foi possível salvar a configuração.", "Configuração remota");
          return;
        }
        toastr.success(criandoNova ? "Configuração criada." : "Configuração remota salva.", "Sucesso!");
        this.carregarConfiguracoesProDoModal();
      }, criandoNova ? null : (selecionada ? selecionada.id : null), nome, criandoNova, false);
    }

    /**
     * Aplicar: é o único botão que muda qual configuração a VPS usa (e a tira do legado local).
     *
     * Grava SEMPRE no plugin (dbfs da VPS) — é isso que faz valer, e funciona mesmo se a VPS não
     * estiver cadastrada em `servidor`. Quando ela ESTÁ cadastrada, também registra o vínculo no web,
     * que serve de memória para o painel e para o caso de o dbfs do plugin ser restaurado/limpo.
     */
    private aplicarConfiguracaoProNoServidor() {
      const idServidor = this.getIdServidorContextoAtual();
      const valor = String($('#selectConfiguracaoPro').val() || '');

      if (valor === 'local' || valor === 'nova') {
        toastr.info("Selecione uma configuração online para aplicar nesta VPS.", "Configuração remota");
        return;
      }

      const estavaNoLegado = !this.idConfiguracaoProEfetiva;
      const registrarVinculoNoWeb = (idConfiguracao: any, callbackFinal: any) => {
        if (!idServidor) { callbackFinal(); return }
        this.ajax.postAcao(App.Util.config.urlAplicarConfiguracaoProServidor, { idServidor: idServidor, id: idConfiguracao }, () => {
          callbackFinal();
        }, null, false);
      };

      const aplicar = () => {
        this.definirConfiguracaoProNoPlugin(valor, () => {
          registrarVinculoNoWeb(valor, () => {
            toastr.success("Esta VPS passou a usar a configuração selecionada.", "Aplicado!");
            this.carregarConfiguracoesProDoModal();
          });
        });
      };

      if (!estavaNoLegado) {
        aplicar();
        return;
      }

      // Opt-in a partir do legado: oferece preservar o que já estava valendo na VPS, criando uma
      // configuração remota a partir da configuração local atual antes de trocar. Fechar no ESC/clique
      // fora não aplica nada — só os dois botões decidem.
      Util.exibirSweetConfirmacao({
        title: "Sair do modo local?",
        text: "Esta VPS usa configuração local. Criar uma configuração online com os valores que ela já usa hoje (recomendado) ou aplicar a configuração selecionada como está?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Criar a partir da local",
        cancelButtonText: "Aplicar a selecionada",
        reverseButtons: true
      }, (resultado: any) => {
        if (resultado && resultado.value) {
          const nomeSugerido = this.dadosServidor && this.dadosServidor.nome ? this.dadosServidor.nome : 'Configuração do servidor';
          var form = $(`#formConfiguracoesGeralBot`);
          var dadosForm: IConfiguracoesGeraisExecucao = this.ajax.convertFormAninhadoToJSON(form);
          dadosForm.prioridade_tarefas_automaticas = this.normalizarPrioridadeTarefasAutomaticas(dadosForm);
          this.normalizarConfiguracaoAutoDmeGeral(dadosForm, this.getConfiguracaoAutoDmeAtual(), false);
          this.salvarConfiguracaoGeralRemotaAtualizada(true, this.removerCamposServidorLocalConfigGeral(dadosForm), (resposta: any) => {
            const criada = resposta && resposta.dadosRetornados ? resposta.dadosRetornados : null;
            // Sem id na resposta a criação falhou (ex.: nome duplicado); não aplica nada silenciosamente.
            if (!criada || !criada.id) {
              toastr.warning("Não foi possível criar a configuração a partir da local.", "Configuração remota");
              return;
            }
            this.definirConfiguracaoProNoPlugin(criada.id, () => {
              registrarVinculoNoWeb(criada.id, () => {
                toastr.success("Configuração criada a partir da local e aplicada nesta VPS.", "Aplicado!");
                this.carregarConfiguracoesProDoModal();
              });
            });
          }, null, nomeSugerido, true, false);
          return;
        }
        // Só o botão "Aplicar a selecionada" aplica; ESC/clique fora não faz nada.
        if (resultado && resultado.dismiss === "cancel") {
          aplicar();
        }
      });
    }

    private excluirConfiguracaoProSelecionada() {
      const selecionada = this.getConfiguracaoProSelecionada();
      if (!selecionada) {
        toastr.info("Selecione uma configuração salva para excluir.", "Configuração remota");
        return;
      }
      if (selecionada.padrao) {
        toastr.warning("A configuração padrão não pode ser excluída.", "Configuração remota");
        return;
      }

      const executar = () => {
        this.ajax.postAcao(App.Util.config.urlExcluirConfiguracaoPro, { id: selecionada.id }, (resposta: any) => {
          const dados = resposta && resposta.dadosRetornados ? resposta.dadosRetornados : resposta;
          if (dados && dados.status === false) {
            toastr.warning(dados.mensagem || "Não foi possível excluir.", "Configuração remota");
            return;
          }
          toastr.success(dados && dados.mensagem ? dados.mensagem : "Configuração excluída.", "Pronto!");
          this.carregarConfiguracoesProDoModal();
        }, null, false);
      };

      Util.exibirSweetConfirmacao({
        title: "Excluir configuração?",
        text: `Servidores que usam "${selecionada.nome}" voltarão a usar a configuração padrão.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#f5365c",
        reverseButtons: true
      }, (resultado: any) => {
        if (resultado && resultado.value) { executar() }
      });
    }

    private iniciarVisualizacaoTelaWebAppRemota(request: { ip: string, port: string, token: string }) {
      try {
        // console.log("EnderecoWsBrowser", request);
        const url = `/bw-view/?i=${request.ip}&prt=${request.port}&tk=${request.token}`;
        // Obter a largura e a altura da janela atual
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        // Calcular a largura e a altura proporcionais (por exemplo, 80% da janela atual)
        const popupWidth = Math.floor(screenWidth * 0.5);
        const popupHeight = Math.floor(screenHeight * 0.8);

        // Calcular a posição centralizada para a nova janela
        const left = Math.floor((screenWidth - popupWidth) / 2);
        const top = Math.floor((screenHeight - popupHeight) / 2);

        // Abrir a nova janela com as dimensões calculadas
        const popup = window.open(url, '_blank', `width=${popupWidth},height=${popupHeight},left=0,top=0`);

        if (!popup || popup.closed || typeof popup.closed === 'undefined') {
          // Popup blocked or failed, open in a new tab
          window.open(url, '_blank');
        }
      } catch (e) {
        console.log("Error iniciar Visualizacao Browser Remoto", e);
        toastr.warning(`Não foi possível visualizar o WebApp, error: ${e.message}`, "Um Erro ocorreu!");
      }
    }

    private aoAbirFormAddConta(e: JQueryEventObject) {
      e.preventDefault();
      $('#modalAddConta').modal('show');
    }

    public deleteContaDataTable(id: number) {
      if (!App.Business.objDataTableContas) {
        return;
      }
      let rowConta = App.Business.objDataTableContas.row(`#${id}`)
      if (rowConta.length) {
        rowConta.remove().draw();
      }
    }

    /**
     * Callback global de exclusão CRUD (último `ModelView.inicializar` na página).
     * Remove a linha do DOM; se for a listagem Auto DME com DataTables, usa a API da tabela.
     */
    public static removerTrListagemCrudPosExclusao(e: JQueryEventObject): void {
      const $tr = $(e.currentTarget).closest("tr");
      if (!$tr.length) {
        return;
      }
      const tableEl = $tr.closest("table")[0];
      if (tableEl && $(tableEl).hasClass("list-autodme") && $.fn.dataTable && $.fn.dataTable.isDataTable(tableEl)) {
        const dt: any = $(tableEl).DataTable();
        dt.row($tr).remove().draw(false);
        return;
      }
      $tr.remove();
    }

    private aoVincularConta(email: string, callbackVinculo: any) {
      $.ajax({
        url: App.Util.config.urlValidarVinculoConta,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ email: email }),
        beforeSend: function (jqXHR, settings) {
          jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
        },
        success: (resposta) => {
          console.log("resp Validacao Conta", resposta)
          if (resposta) {
            callbackVinculo(resposta)
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.log("erro resp Validacao Conta", jqXHR, textStatus, errorThrown)
        }
      });
    }

    private getDadosPorUrlFiltroFutbin(url: string, callback: any) {
      console.log("getDadosPorUrlFiltroFutbin", url)
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_OBTER_DADOS_FILTRO_FUTBIN, { url: url }, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success(response.status, "Sucessso!");
        }
        console.log("RESP getDadosPorUrlFiltroFutbin", response)
        callback(response)
      })
    }

    private async aoClicarEmailConta(e: JQueryEventObject) {
      const text = $(e.currentTarget).text() || '';
      Util.copyToClipboard(text, () => {
        toastr.success(`Email: ${text} copiado para área de transferência.`, "Copiado!");
      });
    }

    private async atualizarContas() {
      try {
        if (this.atualizandoContas) {
          return
        }

        toastr.info("Atualizando Contas ...", "Iniciou Atualização!");
        this.atualizandoContas = true;
        $('.btn-dt-atualizar').text("Atualizando...");

        let contasSelecionadas = this.getContasSelecionadas()
        let contasIds = contasSelecionadas.count() ? this.getIdsContasSelecionadas() : this.getIdsAllContas();
        console.log("atualizandoContas", contasIds)
        // Sempre sem cache: com `contasIds.length <= 3` o botao "Atualizar" so ignorava o cache de 180s
        // do plugin para poucas contas — acima disso ele podia devolver e REGRAVAR o perfil antigo, o que
        // fazia o proprio workaround do usuario funcionar de forma intermitente.
        await this.atualizarContasNoPluginAposDadosAplicados(contasIds, true)

        $('.btn-dt-atualizar').text("Atualizar");
        this.atualizandoContas = false
        toastr.success("Atualização de contas finalizada.", "Terminou Atualização!");
      } catch (e) {
        toastr.warning("Não foi possível atualizar as contas", "Atualização Incompleta!");
        console.log("ERROR atualizarContas", e)
        $('.btn-dt-atualizar').text("Atualizar");
        this.atualizandoContas = false
      }
    }

    private limparCacheContas() {
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Limpar Cache / Sincronizar")
        return
      }

      let contas = this.getContasSelecionadas().data().toArray()
      let requestFn = (item: any) => this.enviarAcaoContaComoPromise(Util.ACAO_COMUNICACAO_LIMPAR_CACHE_CONTAS, [item.id])
      this.executarAcaoLoteContas(contas, {
        tituloModal: "Limpando Cache / Sincronizando",
        labelProcessando: "Limpando cache",
        statusProcessando: "Limpando...",
        statusSucesso: "Limpo",
        mensagemFalhaPadrao: "Falha ao limpar cache",
        tituloSucesso: "Cache Limpo",
        tituloFalha: "Limpeza Falhou",
        tituloParcial: "Limpeza Parcial",
        sufixoSucesso: "com cache limpo",
        substantivoItem: "conta(s)",
        permitirCancelar: true,
        timeoutMs: 120000
      }, requestFn)
    }

    private limparDmesSnapshotContas() {
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Limpar Snapshot Auto DME")
        return
      }

      let contas = this.getContasSelecionadas().data().toArray()
      let requestFn = (item: any) => this.enviarAcaoContaComoPromise(Util.ACAO_COMUNICACAO_LIMPAR_DMES_CONTAS, [item.id])
      this.executarAcaoLoteContas(contas, {
        tituloModal: "Limpando Snapshot Auto DME",
        labelProcessando: "Limpando snapshot",
        statusProcessando: "Limpando...",
        statusSucesso: "Limpo",
        mensagemFalhaPadrao: "Falha ao limpar snapshot DME",
        tituloSucesso: "Snapshot Limpo",
        tituloFalha: "Limpeza Falhou",
        tituloParcial: "Limpeza Parcial",
        sufixoSucesso: "com snapshot limpo",
        substantivoItem: "conta(s)",
        permitirCancelar: true,
        timeoutMs: 120000
      }, requestFn)
    }

    private async sincronizarDataBaseContas() {
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Sincronizar / Limpar Cache");
        return;
      }

      // Respeita a selecao da tabela: com contas marcadas, sincroniza SO elas; sem selecao, todas
      // (comportamento antigo). O plugin recebe os ids e agora tambem limita a limpeza de perfil a
      // essas contas — antes o delete era sempre total e derrubava o login das demais.
      const idsSelecionados = this.getIdsContasSelecionadas();
      const usarSelecao = !!(idsSelecionados && idsSelecionados.length);
      const totalSelecionadas = usarSelecao ? idsSelecionados.length : 0;

      // Exibe uma confirmação para o usuário
      const result = await swal.fire({
        title: 'Sincronizar/Limpar Cache Contas!',
        html: (usarSelecao
          ? 'Serao sincronizadas as <b>' + totalSelecionadas + '</b> conta(s) selecionada(s). '
          : 'Nenhuma conta selecionada: serao sincronizadas <b>TODAS</b> as contas. ')
          + 'Ao executar, os dados do navegador das contas, como o cache, serao perdidos. Caso nao utilize um autenticador, apos iniciar a conta, um novo codigo de autenticacao da EA sera necessario.'
          + '<div style="margin-top:15px;text-align:left;">'
          + '<label style="font-weight:400;cursor:pointer;margin:0;">'
          + '<input type="checkbox" id="chkLimparProfilesTransferTemp" style="margin-right:6px;">'
          + 'Limpar tambem os perfis de transferencia de coins'
          + '</label>'
          + '<small style="display:block;color:#8898aa;margin-top:4px;">Desmarcado, a pasta e preservada. Marcar derruba qualquer transferencia em andamento.</small>'
          + '</div>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2dce89',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, sincronizar agora!',
        cancelButtonText: 'Não sincronizar!',
        preConfirm: () => {
          const chk = document.getElementById('chkLimparProfilesTransferTemp') as HTMLInputElement;
          return { limparTransferTemp: !!(chk && chk.checked) };
        },
      });

      if (!result.isConfirmed) {
        return;
      }

      const limparTransferTemp = !!(result.value && result.value.limparTransferTemp);

      // A sincronizacao e' ATOMICA no plugin (fecha tudo, apaga a pasta e recria o perfil de cada conta,
      // uma a uma). Roda como UMA unica chamada, MAS o plugin emite 'progresso_sincronizacao_contas' por
      // conta, entao o modal e' atualizado em tempo real (modo progressoPorEvento). Sem cancelar (indivisivel).
      let ids = usarSelecao ? idsSelecionados : this.getIdsAllContas();
      if (!ids || !ids.length) {
        toastr.warning("Nenhuma conta para sincronizar.", "Sincronizar / Limpar Cache");
        return;
      }
      let contas = usarSelecao
        ? this.getContasSelecionadas().data().toArray()
        : this.getAllContas().data().toArray();
      // Timeout backstop (so dispara se o plugin NUNCA responder): escala com a qtd de contas, pois cada
      // conta abre o navegador para recriar o perfil. Enquanto chegam eventos o usuario ve progresso real.
      let totalContas = contas && contas.length ? contas.length : (ids ? ids.length : 0);
      let timeoutSincronizacao = Math.min(180000 + 30000 * totalContas, 3600000);
      // COMPATIBILIDADE: no caso padrao o payload continua sendo o ARRAY de ids, exatamente como
      // antes — plugin antigo usa o request direto como lista e quebraria com um objeto. O formato
      // novo `{ids, limparTransferTemp}` so' vai quando o usuario marca a opcao, que e' recurso
      // novo e portanto exige plugin novo.
      let payloadSincronizacao: any = limparTransferTemp ? { ids: ids, limparTransferTemp: true } : ids;
      let requestFn = (_alvo: any) => this.enviarAcaoContaComoPromise(Util.ACAO_COMUNICACAO_SINCRONIZAR_DATABASE_CONTAS_PLUGIN, payloadSincronizacao, timeoutSincronizacao);
      this.executarAcaoLoteContas(contas, {
        tituloModal: "Sincronizando / Limpando Cache",
        labelInicial: "Preparando: fechando sessoes e limpando dados...",
        labelProcessando: "Sincronizando",
        statusProcessando: "Sincronizando...",
        statusSucesso: "Sincronizado",
        mensagemFalhaPadrao: "Falha ao sincronizar",
        tituloSucesso: "Sincronizacao Concluida",
        tituloFalha: "Sincronizacao Falhou",
        tituloParcial: "Sincronizacao Parcial",
        sufixoSucesso: "sincronizada(s)",
        substantivoItem: "conta(s)",
        progressoPorEvento: true,
        permitirCancelar: false
      }, requestFn);
    }

    private async getProxyById(idProxy: number) {
      return new Promise(async (resolve: any, reject: any) => {
        try {
          if (!this.ajax) {
            this.ajax = new Ajax();
          }

          this.ajax.get(App.Util.config.urlGetProxy, { "id": idProxy }, (dadosSucesso: IRespostaSucessoAjx) => {
            resolve(dadosSucesso.dadosRetornados)
          }, null, null, false)
        } catch (e) {
          resolve(null)
        }
      })
    }

    private sincronizarContaNaMaquinaLocal(e: JQueryEventObject, navegadorVisivel: boolean = false, mostrarTelaWebApp: boolean = false) {
      var idConta = $(e.currentTarget).data('idContaEa');
      if (!this.conectado) {
        return
      }

      Util.exibirModalPaginaCarregando()
      let ids = [idConta]
      //console.log("abrirContas", ids);
      $("#modalAcoesContas").modal("hide")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_SINCRONIZAR_DATABASE_CONTAS_PLUGIN, ids, (response: IRespostaMensagem) => {
        if (ids.length > 1) {
          toastr.success("Contas sincronizadas e cache limpo.", "Sucessso!");
        } else {
          toastr.success("Conta sincronizada e cache limpo.", "Sucessso!");
        }
        Util.ocultarModalPaginaCarregando()
      });
    }

    private executarDesfragmentarLiberarEspacoDisco(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_LIMPEZA_DESFRAGMENTACAO_DE_DISCO, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Limpeza de disco iniciada.", "Sucessso!");
        }
      })
    }

    private adicionarPluginNaInicializacaoWindows(e: JQueryEventObject) {
      swal.fire({
        title: 'Inicialização automática: Login do sistema operacional',
        html: `<small>Para adicionar o plugin na inicialização automática do Windows, forneça as credenciais de login do sistema operacional.
        Isso é necessário para que o windows inicie por completo e o plugin seja iniciado automaticamente.</small>
          <input id="username" class="swal2-input" placeholder="Usuário Windows">
          <input id="password" type="password" class="swal2-input" placeholder="Senha Windows">
        `,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const username = (document.getElementById('username') as HTMLInputElement).value;
          const password = (document.getElementById('password') as HTMLInputElement).value;

          // if (!username || !password) {
          //   swal.showValidationMessage('Usuário e senha são obrigatórios!');
          //   return false;
          // }

          return { username, password };
        },
      }).then((result: any) => {
        if (result.isConfirmed) {
          const { username, password } = result.value!;
          console.log('Dados fornecidos:', { username, password });

          // Envia os dados ao servidor
          this.comunicacao.enviar(Util.ACAO_COMUNICACAO_CRIAR_INICIALIZACAO_AUTOMATICA_PLUGIN, { username, password }, (response: IRespostaMensagem) => {
            if (response.status) {
              toastr.success("Plugin adicionado na inicialização do sistema operacional.", "Sucesso!");
            } else {
              toastr.error("Falha ao adicionar o plugin na inicialização.", "Erro!");
            }
          });
        } else {
          console.log('Operação cancelada pelo usuário.');
        }
      });
    }

    private reiniciarVm(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_REINICIAR_WINDOWS, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Uma reicialização foi solicitada na VM.", "Sucessso!");
        }
      })
    }

    /**
     * "Reinstalar Chrome": fecha as contas, apaga a instalacao do Chrome da VPS e baixa de novo.
     *
     * Serve ao caso em que a instalacao do Chrome corrompe (extracao parcial deixa o chrome.exe no
     * lugar e faltam arquivos) e TODAS as contas passam a falhar na abertura — antes so se resolvia
     * apagando a pasta por RDP na maquina.
     *
     * Vai por promise com timeout largo em vez do `enviar` simples: e um download de navegador
     * inteiro, entao a resposta pode demorar minutos.
     */
    private async reinstalarChrome(e: JQueryEventObject) {
      if (!this.conectado) {
        toastr.warning("Plugin nao conectado.", "Reinstalar Chrome");
        return;
      }

      const result = await swal.fire({
        title: 'Reinstalar Chrome?',
        text: 'Todas as contas serao fechadas, a instalacao do Chrome sera apagada e baixada novamente. Use quando as contas nao abrem por instalacao corrompida do navegador. Pode levar alguns minutos.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#fb6340',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, reinstalar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) {
        return;
      }

      Util.exibirModalPaginaCarregando();
      const resposta = await this.enviarAcaoContaComoPromise(Util.ACAO_COMUNICACAO_REINSTALAR_CHROME, {}, 900000);
      Util.ocultarModalPaginaCarregando();

      if (resposta.ok) {
        toastr.success("Chrome reinstalado com sucesso. As contas ja podem ser iniciadas.", "Sucesso!");
        return;
      }

      if (resposta.mensagem === "database_sync_em_andamento") {
        toastr.warning("Existe uma sincronizacao de contas em andamento. Aguarde o termino e tente de novo.", "Reinstalar Chrome");
        return;
      }
      if (resposta.mensagem === "reinstalacao_chrome_em_andamento") {
        toastr.warning("Ja existe uma reinstalacao do Chrome em andamento.", "Reinstalar Chrome");
        return;
      }
      toastr.error(resposta.mensagem ? resposta.mensagem : "Nao foi possivel reinstalar o Chrome.", "Erro!");
    }

    private otimizarRedeWindows(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_OTIMIZAR_REDE_WINDOWS, {}, (response: IRespostaMensagem) => {
        if (response.status) {
          const status = response.result && response.result.otimizacao_rede_windows_status;
          if (status === 'aplicada') {
            toastr.success("Otimizações de rede aplicadas com sucesso.", "Sucesso!");
          } else if (status === 'nao_windows') {
            toastr.warning("Esta ação só está disponível no Windows.", "Atenção!");
          } else if (status === 'pendente') {
            toastr.info("Otimizações executadas. Pode ser necessário executar o plugin como Administrador para aplicar completamente.", "Info");
          } else {
            toastr.success("Comando de otimização enviado ao plugin.", "Sucesso!");
          }
          if (status) {
            this.atualizarExibicaoOtimizacaoRedeWindows(status);
          }
        } else {
          toastr.warning("Não foi possível executar as otimizações de rede.", "Erro!");
        }
      });
    }

    private removerPluginNaInicializacaoWindows(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_REMOVER_INICIALIZACAO_AUTOMATICA_PLUGIN, App.Business.dadosTeste ? App.Business.dadosTeste : {}, (response: IRespostaMensagem) => {
        if (response.status) {
          toastr.success("Plugin removido da inicialização do sistema operacional.", "Sucessso!");
        }
      })
    }

    private exportarDataBaseLocal(e: JQueryEventObject) {
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXPORTAR_DATABASE_LOCAL, {}, (response: IRespostaMensagem) => {
        if (response.status && response.result && response.result.urlDownload) {
          try {
            toastr.success("Exportando database...", "Sucesso!");

            // Obtém o conteúdo JSON e o IP
            const urlDownload = response.result.urlDownload;
            console.log(`Arquivo  pronto para download.`, urlDownload);
            // Abre o link em uma nova aba para o download
            window.open(urlDownload, '_blank');
          } catch (e) {
            console.log("ERROR exportarDataBaseLocal", e)
            toastr.warning("Algum erro ocorreu, não foi possível exportar a database.", "Erro!");
          }
        } else {
          toastr.warning("Algum erro ocorreu, não foi possível exportar a database.", "Erro!");
        }
      });
    }

    // ─── Backup & Restauração de database (PRO) ─────────────────────────────

    private abrirModalBackupRestauracao(e: JQueryEventObject) {
      if (e && e.preventDefault) e.preventDefault();
      // Gate PRO defensivo (o Blade já esconde para Cloud puro)
      if (this.infoPlanoAtual && this.infoPlanoAtual.ehPlanoCloud) {
        toastr.warning("Funcionalidade disponível apenas para planos PRO.", "Atenção!");
        return;
      }
      this.resetarUIModalRestauracao();
      this.atualizarDisponibilidadeRestauracao();
      $("#modalBackupRestauracao").modal("show");
    }

    /** Habilita/desabilita a importação conforme a conexão com o plugin. */
    private atualizarDisponibilidadeRestauracao() {
      try {
        if (!$("#modalBackupRestauracao").length) return;
        if (this.restauracaoEmAndamento) return;

        const conectado = !!this.conectado;

        const $avisoConexao = $("#backup-restauracao-aviso-conexao");
        const $area = $("#backup-restauracao-import-area");
        const $btnRestaurar = $("#btn-modal-restaurar-database");
        const $file = $("#backup-restauracao-file");

        $avisoConexao.toggleClass("d-none", conectado);
        $file.prop("disabled", !conectado);
        $btnRestaurar.prop("disabled", !conectado || !this.arquivoRestauracaoSelecionado);
        $area.css("opacity", conectado ? "1" : "0.5");
      } catch (e) {
        console.log("atualizarDisponibilidadeRestauracao error", e);
      }
    }

    private aoSelecionarArquivoRestauracao(e: JQueryEventObject) {
      const input = e.currentTarget as HTMLInputElement;
      const file = input && input.files && input.files.length ? input.files[0] : null;
      const $label = $("#backup-restauracao-file-label");

      if (!file) {
        this.arquivoRestauracaoSelecionado = null;
        $label.text("Nenhum arquivo selecionado").removeClass("text-primary").addClass("text-muted");
        $("#btn-modal-restaurar-database").prop("disabled", true);
        return;
      }

      if (!/\.json$/i.test(file.name)) {
        this.arquivoRestauracaoSelecionado = null;
        try { input.value = ""; } catch (err) { }
        $label.text("Nenhum arquivo selecionado").removeClass("text-primary").addClass("text-muted");
        $("#btn-modal-restaurar-database").prop("disabled", true);
        toastr.warning("Selecione um arquivo .json de backup.", "Atenção!");
        return;
      }

      this.arquivoRestauracaoSelecionado = file;
      const tamanhoMb = (file.size / (1024 * 1024)).toFixed(2);
      $label.text(`${file.name} (${tamanhoMb} MB)`).removeClass("text-muted").addClass("text-primary");
      this.atualizarDisponibilidadeRestauracao();
    }

    private async iniciarRestauracaoBackup(e: JQueryEventObject) {
      if (e && e.preventDefault) e.preventDefault();
      if (this.restauracaoEmAndamento) return;

      if (!this.conectado) {
        toastr.warning("O plugin do servidor não está conectado.", "Atenção!");
        return;
      }
      const file = this.arquivoRestauracaoSelecionado;
      if (!file) {
        toastr.warning("Selecione um arquivo de backup (.json).", "Atenção!");
        return;
      }
      const TAMANHO_MAX = 100 * 1024 * 1024; // 100 MB
      if (file.size > TAMANHO_MAX) {
        toastr.error("Arquivo muito grande (máximo 100 MB).", "Erro!");
        return;
      }

      // 1) Ler arquivo
      this.mostrarAreaProgressoRestauracao();
      this.atualizarProgressoRestauracao(3, "Lendo arquivo…");
      let buffer: ArrayBuffer;
      try {
        buffer = await this.lerArquivoComoArrayBuffer(file);
      } catch (err) {
        this.finalizarUIRestauracao("erro", "Não foi possível ler o arquivo selecionado.");
        return;
      }

      // 2) Validação no cliente (pré-checagem)
      this.atualizarProgressoRestauracao(6, "Validando arquivo…");
      try {
        const texto = new TextDecoder("utf-8").decode(buffer);
        const dados = JSON.parse(texto);
        if (!dados || typeof dados !== "object" || Array.isArray(dados) || !dados.hasOwnProperty("configuracao")) {
          this.finalizarUIRestauracao("erro", "O arquivo não parece ser uma database válida do FutSniper.");
          return;
        }
      } catch (err) {
        this.finalizarUIRestauracao("erro", "O arquivo não é um JSON válido.");
        return;
      }

      // Confirmação
      const confirm = await swal.fire({
        title: "Restaurar backup?",
        html: "A database atual do servidor será <strong>substituída</strong>.<br>Uma cópia de segurança será criada automaticamente antes.<br>O plugin será <strong>reiniciado</strong> ao final para aplicar.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2dce89",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, restaurar!",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) {
        this.resetarUIModalRestauracao();
        return;
      }

      this.restauracaoEmAndamento = true;
      this.bloquearControlesRestauracao(true);

      try {
        // 3) Checksum + preparação dos chunks
        this.atualizarProgressoRestauracao(9, "Preparando envio…");
        const checksum = await this.calcularSha256Hex(buffer);
        const bytes = new Uint8Array(buffer);
        const TAMANHO_CHUNK = 512 * 1024;
        const totalChunks = Math.max(1, Math.ceil(bytes.length / TAMANHO_CHUNK));

        // 4) Iniciar sessão no plugin
        const respIniciar = await this.enviarComunicacaoAsync(Util.ACAO_COMUNICACAO_RESTORE_INICIAR, {
          nomeArquivo: file.name,
          tamanhoTotal: bytes.length,
          totalChunks: totalChunks,
          checksum: checksum,
        });
        if (!respIniciar || !respIniciar.status || !respIniciar.result || !respIniciar.result.sessaoId) {
          const motivo = (respIniciar && respIniciar.result && respIniciar.result.motivo)
            ? respIniciar.result.motivo
            : "O plugin não suporta restauração ou recusou a sessão. Verifique se ele está atualizado.";
          this.finalizarUIRestauracao("erro", motivo);
          return;
        }
        const sessaoId = respIniciar.result.sessaoId;

        // 5) Enviar chunks (10% → 70%)
        const enviouTudo = await this.enviarChunksRestore(sessaoId, bytes, totalChunks, TAMANHO_CHUNK);
        if (!enviouTudo) {
          this.finalizarUIRestauracao("erro", "Falha ao enviar o arquivo ao servidor.");
          return;
        }

        // 6) Finalizar: validação forte + staging no servidor
        this.atualizarProgressoRestauracao(72, "Validando no servidor…");
        const respFinal = await this.enviarComunicacaoAsync(Util.ACAO_COMUNICACAO_RESTORE_FINALIZAR, { sessaoId: sessaoId });
        if (!respFinal || !respFinal.status || !respFinal.result || !respFinal.result.pronto) {
          const motivos = (respFinal && respFinal.result && respFinal.result.motivos)
            ? (Array.isArray(respFinal.result.motivos) ? respFinal.result.motivos.join(" ") : respFinal.result.motivos)
            : "O arquivo foi rejeitado na validação do servidor.";
          this.finalizarUIRestauracao("erro", motivos);
          return;
        }

        // 7) Reiniciar plugin para aplicar (o boot aplica o restore preparado, com backup-anterior + rollback)
        // Dispara SEM aguardar o ACK: o socket cai durante o restart e o ACK pode nunca chegar.
        this.atualizarProgressoRestauracao(90, "Reiniciando plugin…");
        this.enviarComunicacaoAsync(Util.ACAO_COMUNICACAO_REINICIAR_PLUGIN, {});
        this.atualizarProgressoRestauracao(95, "Aguardando o plugin reconectar…");

        // Rede de segurança: se não reconectar / não entregar o marcador em 120s
        if (this.restauracaoTimeoutReconexao) clearTimeout(this.restauracaoTimeoutReconexao);
        this.restauracaoTimeoutReconexao = setTimeout(() => {
          if (this.restauracaoEmAndamento) {
            this.finalizarUIRestauracao("aviso", "O plugin está reiniciando. Assim que reconectar, verifique seus dados. Se não reconectar sozinho, reinicie o plugin manualmente.");
          }
        }, 120000);
      } catch (err) {
        console.log("iniciarRestauracaoBackup error", err);
        this.finalizarUIRestauracao("erro", "Ocorreu um erro inesperado durante a restauração.");
      }
    }

    private async enviarChunksRestore(sessaoId: string, bytes: Uint8Array, totalChunks: number, tamanhoChunk: number): Promise<boolean> {
      for (let indice = 0; indice < totalChunks; indice++) {
        const inicio = indice * tamanhoChunk;
        const fim = Math.min(inicio + tamanhoChunk, bytes.length);
        const sub = bytes.subarray(inicio, fim);
        const dados = this.bytesParaBase64(sub);
        const resp = await this.enviarComunicacaoAsync(Util.ACAO_COMUNICACAO_RESTORE_CHUNK, {
          sessaoId: sessaoId,
          indice: indice,
          dados: dados,
        });
        if (!resp || !resp.status || !resp.result || !resp.result.ok) {
          return false;
        }
        const percentual = 10 + Math.round(((indice + 1) / totalChunks) * 60);
        this.atualizarProgressoRestauracao(percentual, `Enviando arquivo… (${indice + 1}/${totalChunks})`);
      }
      return true;
    }

    /** Envolve comunicacao.enviar (callback/ACK) numa Promise. */
    private enviarComunicacaoAsync(acao: number, payload: any): Promise<IRespostaMensagem> {
      return new Promise((resolve) => {
        try {
          this.comunicacao.enviar(acao, payload, (response: IRespostaMensagem) => {
            resolve(response || { status: false, result: null });
          });
        } catch (e) {
          resolve({ status: false, result: null });
        }
      });
    }

    private lerArquivoComoArrayBuffer(file: File): Promise<ArrayBuffer> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as ArrayBuffer);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
      });
    }

    private async calcularSha256Hex(buffer: ArrayBuffer): Promise<string> {
      const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
      const bytes = new Uint8Array(hashBuffer);
      let hex = "";
      for (let i = 0; i < bytes.length; i++) {
        const h = bytes[i].toString(16);
        hex += h.length === 1 ? "0" + h : h;
      }
      return hex;
    }

    private bytesParaBase64(bytes: Uint8Array): string {
      let binario = "";
      const bloco = 0x8000;
      for (let i = 0; i < bytes.length; i += bloco) {
        const sub = bytes.subarray(i, Math.min(i + bloco, bytes.length));
        binario += String.fromCharCode.apply(null, sub as any);
      }
      return btoa(binario);
    }

    private tratarProgressoRestauracao(request: any) {
      try {
        if (!request) return;
        const percentual = typeof request.percentual === "number" ? request.percentual : null;
        const fase = request.mensagem || request.fase || "Processando…";
        this.atualizarProgressoRestauracao(percentual, fase);
      } catch (e) { }
    }

    private tratarConclusaoRestauracao(restauracao: any) {
      try {
        // Idempotente: só finaliza se havia uma restauração em andamento (evita swal duplicado
        // quando o marcador chega logo após o fallback de reconexão, ou em marcadores antigos).
        if (!this.restauracaoEmAndamento) {
          return;
        }
        if (this.restauracaoTimeoutReconexao) {
          clearTimeout(this.restauracaoTimeoutReconexao);
          this.restauracaoTimeoutReconexao = null;
        }
        if (restauracao && restauracao.sucesso) {
          this.finalizarUIRestauracao("sucesso", "Restauração concluída com sucesso! Seus dados foram atualizados.");
        } else {
          const motivo = (restauracao && restauracao.motivo)
            ? restauracao.motivo
            : "A restauração falhou e a database anterior foi mantida.";
          this.finalizarUIRestauracao("erro", motivo);
        }
      } catch (e) { }
    }

    private finalizarUIRestauracao(estado: string, mensagem: string) {
      this.restauracaoEmAndamento = false;
      if (this.restauracaoTimeoutReconexao) {
        clearTimeout(this.restauracaoTimeoutReconexao);
        this.restauracaoTimeoutReconexao = null;
      }
      const $bar = $("#backup-restauracao-progress-bar");
      if (estado === "sucesso") {
        this.atualizarProgressoRestauracao(100, "Concluído");
        $bar.removeClass("bg-primary bg-danger").addClass("bg-success");
      } else if (estado === "erro") {
        $bar.removeClass("bg-primary bg-success").addClass("bg-danger");
      }
      this.bloquearControlesRestauracao(false);

      if (estado === "sucesso") {
        try { toastr.success("Restauração concluída.", "Sucesso!"); } catch (e) { }
        try { $("#modalBackupRestauracao").modal("hide"); } catch (e) { }
        swal.fire({ icon: "success", title: "Restauração concluída!", text: mensagem, confirmButtonColor: "#2dce89" });
      } else if (estado === "erro") {
        swal.fire({ icon: "error", title: "Falha na restauração", text: mensagem, confirmButtonColor: "#d33" });
      } else {
        swal.fire({ icon: "info", title: "Plugin reiniciando", text: mensagem, confirmButtonColor: "#3740FF" });
      }

      this.arquivoRestauracaoSelecionado = null;
      this.atualizarDisponibilidadeRestauracao();
    }

    private mostrarAreaProgressoRestauracao() {
      $("#backup-restauracao-progresso").removeClass("d-none");
      $("#backup-restauracao-progress-bar").removeClass("bg-success bg-danger").addClass("bg-primary");
      this.atualizarProgressoRestauracao(0, "Preparando…");
    }

    private atualizarProgressoRestauracao(percentual: number | null, fase: string) {
      const $bar = $("#backup-restauracao-progress-bar");
      const $fase = $("#backup-restauracao-fase");
      const $pct = $("#backup-restauracao-percentual");
      if (fase != null) $fase.text(fase);
      if (percentual != null && !isNaN(percentual)) {
        const p = Math.max(0, Math.min(100, Math.round(percentual)));
        $bar.css("width", p + "%").attr("aria-valuenow", p);
        $pct.text(p + "%");
      }
    }

    private bloquearControlesRestauracao(bloquear: boolean) {
      $("#backup-restauracao-file").prop("disabled", bloquear);
      $("#btn-modal-restaurar-database").prop("disabled", bloquear);
      $("#btn-modal-exportar-database").prop("disabled", bloquear);
      $("#btn-fechar-backup-restauracao").css("display", bloquear ? "none" : "");
    }

    private resetarUIModalRestauracao() {
      this.arquivoRestauracaoSelecionado = null;
      const $file = $("#backup-restauracao-file");
      try { ($file[0] as HTMLInputElement).value = ""; } catch (e) { }
      $("#backup-restauracao-file-label").text("Nenhum arquivo selecionado").removeClass("text-primary").addClass("text-muted");
      $("#backup-restauracao-progresso").addClass("d-none");
      $("#backup-restauracao-progress-bar").removeClass("bg-success bg-danger").addClass("bg-primary").css("width", "0%").attr("aria-valuenow", 0);
      $("#backup-restauracao-percentual").text("0%");
      $("#backup-restauracao-fase").text("Preparando…");
      $("#btn-fechar-backup-restauracao").css("display", "");
      $("#btn-modal-restaurar-database").prop("disabled", true);
    }

    // ─────────────────────────────────────────────────────────────────────────

    private aoSubstituirFiltroPro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();

      var filtroASerSubstituido: IFiltroOptions = $(e.currentTarget).data('filtro');
      filtroASerSubstituido.id = $(e.currentTarget).data('id');
      filtroASerSubstituido.nome = $(e.currentTarget).data('nome');

      let formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      let dadosForm: any = this.ajax.convertFormToJSON(formSniperPro);
      let nomeFiltro = formSniperPro.find('input[name=campo_nome_filtro]').val()
      console.log("dadosForm", dadosForm, filtroASerSubstituido)

      let dadosFormatado = _.omit(dadosForm, ['descanso', 'intervalo', 'limite_compra', 'piloto_automatico', 'tempo', 'velocidade']);
      dadosFormatado.nome = nomeFiltro ? nomeFiltro : this.obterNomeFiltro("#formSniperPro");

      if (App.Util.validarFiltroSniper(dadosForm)) {
        swal.fire({
          title: `Deseja substituir o filtro selecionado ${filtroASerSubstituido.nome}?`,
          text: `Após confirmar, o filtro selecionado será substituído pelos novos dados de filtro atual do formulário com nome de ${dadosFormatado.nome}.`,
          icon: 'warning',
          confirmButtonText: 'Substituir',
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#db5250",
          allowOutsideClick: true,
          allowEscapeKey: true
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.ajax.postAcaoSemCabecalhoGlobal(formSniperPro.find('.menu-substituir-filtro').data("url-substituir-filtro-modal-sniper") + '/' + filtroASerSubstituido.id, dadosFormatado, (objResposta: IRespostaAjaxPostAcao) => {
              if (objResposta.status == '200' && objResposta.dadosRetornados) {
                toastr.success(`Filtro ${filtroASerSubstituido.nome} substituído por ${dadosFormatado.nome}`, "Sucessso!");
              } else {
                toastr.warning("Algum erro ocorreu, o filtro não pode ser substituído.", "Não Substituído!");
              }
            }, null, false);
          }
        });
      }
    }

    private informarSobreInstalacaoChrome(request: { status: number }) {
      if (request.status == 3) {
        swal.fire({
          icon: 'warning',
          title: 'Erro ao instalar chrome!',
          text: `Reinstale o plugin novamente, acesse o dashboard e aguarde uma nova tentativa de reinstalação do chrome, se o problema persistir, entre em contato com suporte pelo email contato@futsniperweb.com.br.`
        })
      }
    }

    private verificarSituacaoDaConta() {
      try {
        let servidorCloudEmInstalacao = this.infoPlanoAtual.ehPlanoCloud && $('.sniper-page') && $('.sniper-page').data('ehUsuarioCloudComServidor') == '0';
        // console.log("verificarSituacaoDaConta", $('.sniper-page').data('ehUsuarioCloudComServidor'))
        if (servidorCloudEmInstalacao) {
          swal.fire({
            icon: 'warning',
            title: 'Servidor em preparação!',
            html: `Seu servidor Cloud está sendo preparado.<br/>
                 <b>Fique atento ao seu e-mail</b>, você será avisado quando estiver pronto.<br/>Após isso seu plano Cloud estará liberado.<br/><br/>
                 ⏱️ Prazo: em geral leva poucos minutos, podendo levar até 24 horas.`
          })
        }
      } catch (e) {
        console.log("ERROR verificarSituacaoDaConta", e)
      }
    }

    private aoClicarResolverDmeImediato(e: JQueryEventObject) {
      const idConta = $(e.currentTarget).data('idContaEa');
      $("#modalConfigAutoDme").find('.btn-acao-resolver-dme')
        .attr('data-id-conta-ea', idConta)
        .data('idContaEa', idConta); // <-- atualiza o cache do jQuery
      $("#modalConfigAutoDme").modal("show");
    }

    private executarResolverDmeImediato(e: JQueryEventObject, elModal: JQuery = $("#modalConfigAutoDme"), contasIds: number[] = null) {
      let valido = true;
      // PRO usa ids com sufixo (ex.: #precoMaximoDesafio-novo) então validamos por prefixo/atributos.
      elModal.find('input[id^="precoMaximoDesafio"], input[id^="precoMaximoJogadorNegociavel"], input[id^="precoMaximoJogadorInegociavel"], select.js-select-dme-autodme-pro').each(function () {
        if (!$(this).val()) {
          valido = false;
          $(this).addClass('is-invalid');
        } else {
          $(this).removeClass('is-invalid');
        }
      });

      if (!valido) {
        toastr.warning("Preencha todos os campos obrigatórios!", "Dados faltando!");
        return false;
      }

      var idConta = 0;
      if (!contasIds) {
        idConta = $(e.currentTarget).data('idContaEa');
        this.exibirLoadListConta(idConta, "Resolver Dme")
      }

      const dadosDme = App.AutoDme.montarPayloadResolverPro(elModal);
      if (!dadosDme) {
        toastr.warning("Selecione um DME válido para resolver.", "Dados faltando!");
        return false;
      }

      const dadosDmeInicial = App.AutoDme.montarPayloadDmeInicialResolverPro(elModal, dadosDme);
      if (!dadosDmeInicial) {
        toastr.warning("Não foi possível montar o payload do DME Inicial.", "Dados faltando!");
        return false;
      }

      dadosDme.configuracao = dadosDme.configuracao || ({} as any);
      (dadosDme.configuracao as any).execucao_dme_especifico = true;

      console.log("DME", { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_DME, id: idConta || contasIds, dadosDme: dadosDme, dadosDmeInicial: dadosDmeInicial })

      if (contasIds && contasIds.length) {
        elModal.modal("hide");
        for (const idConta of contasIds) {
          this.exibirLoadListConta(idConta, "Resolver Dme")
        }

        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_RESOLVER_DME_CONTAS, { ids: contasIds, dadosDme: dadosDme, dadosDmeInicial: dadosDmeInicial }, (response: IRespostaMensagem) => {
          console.log("RESOLVER_DME_CONTAS", response)
          this.ocultarLoadListConta(idConta)
        });
      } else {
        elModal.modal("hide");
        this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_DME, id: idConta, dadosDme: dadosDme, dadosDmeInicial: dadosDmeInicial }, (response: IRespostaMensagem) => {
          this.ocultarLoadListConta(idConta)
        });
      }
    }

    private executarResolverBugContaEa(e: JQueryEventObject) {
      var idConta = $(e.currentTarget).data('idContaEa');
      this.resolverBugContaEa(idConta);
    }

    private resolverBugContaEa(idConta: number) {
      this.exibirLoadListConta(idConta, "Resolvendo Bug")
      this.comunicacao.enviar(Util.ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA, { acao: Util.ID_TIPO_ACAO_UNICA_RESOLVER_BUG_CONTA_EA, id: idConta }, (response: IRespostaMensagem) => {
        this.ocultarLoadListConta(idConta)
      });
    }

    private async aoAtivaDesativarRegistros(modelViewRegistro: ModelView, status: boolean, ids: number[] = []) {
      this.ajax = new App.Ajax();
      let dadosForm: any = { status: status };

      // Dividir os IDs em lotes de 100
      const lotes = App.Util.chunkArray(ids, 10);

      try {
        // Processar os lotes de forma assíncrona, um por vez
        for (const lote of lotes) {
          // Atualizar os dados do formulário com o lote atual
          dadosForm.ids = lote;

          // Enviar a requisição para o servidor como uma promessa
          console.log(`Enviando lote com ${lote.length} contas...`);
          await this.ativarDesativarRegistrosAsync(modelViewRegistro.ojDataTableCarregado.elDataTable.data('urlStatusMultFiltros'), dadosForm, lote);
        }

        App.Util.ocultarModalPaginaCarregando();
        // Exibir mensagem de sucesso após todos os lotes serem processados
        swal.fire({
          icon: 'success',
          title: 'Registros Alterados!',
          text: 'Registros alterados com sucesso.'
        });

      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        // Tratar erros durante o processamento dos lotes
        console.error(`Erro ao processar lote:`, error);
        swal.fire({
          icon: 'error',
          title: 'Erro ao Alterar Registros Selecionadas',
          text: 'Ocorreu um erro ao processar um dos lotes. Verifique sua conexão e tente novamente.'
        });
      }
    }

    // Função para enviar um lote como uma promessa
    private ativarDesativarRegistrosAsync(url: string, dadosForm: any, lote: any[]): Promise<void> {
      return new Promise((resolve, reject) => {
        this.ajax.postAcao(url, dadosForm, (resposta: { dadosEnviados: any, dadosRetornados: any }) => {
          console.log(`Lote com ${lote.length} registros processado com sucesso.`, resposta);
          if (resposta.dadosRetornados && resposta.dadosRetornados.atualizado) {
            let ids = resposta.dadosRetornados.ids;

            // Atualizar os checkboxes com base nos IDs retornados
            ids.forEach((id: string) => {
              const checkbox = $(`input[data-id="${id}"]`);
              if (checkbox.length) {
                checkbox.prop('checked', resposta.dadosRetornados.status); // Atualiza o estado do checkbox
              }
            });
          }
          resolve(); // Resolve a promessa quando a requisição for concluída
        }, null, true, false);
      });
    }

    private async executarResolverBugIdsContas() {
      try {
        if (!this.conectado) {
          return
        }

        if (this.executandoResolverBugEa) {
          return
        }

        $("#modalAcoesContas").modal("hide")
        this.executandoResolverBugEa = true
        let ids = this.getIdsContasSelecionadas()
        for await (let id of ids) {
          if (!this.executandoResolverBugEa) {
            break;
          }

          this.resolverBugContaEa(id);
          await this.util.esperar(App.Business.tempoMilisegundoEntreAberturaContaVendaCoins || 30000)
        }

        this.executandoResolverBugEa = false
      } catch (e) {
        console.log("ERROR Vender coins lista contas::", e)
      }
    }

    private inicializarSugestaoNomePeriodo() {
      const diasLabelOrdenado: Array<{ bit: number; label: string }> = [
        { bit: 1, label: "Dom" },
        { bit: 2, label: "Seg" },
        { bit: 4, label: "Ter" },
        { bit: 8, label: "Qua" },
        { bit: 16, label: "Qui" },
        { bit: 32, label: "Sex" },
        { bit: 64, label: "Sáb" },
      ];

      const montarSugestao = ($form: JQuery): string => {
        const diasSelecionados: string[] = [];

        diasLabelOrdenado.forEach(d => {
          const checked = $form.find(`input[name="dias[]"][value="${d.bit}"]`).is(":checked");
          if (checked) diasSelecionados.push(d.label);
        });

        const hi = String($form.find('input[name="hora_inicio"]').val() || "").slice(0, 5);
        const hf = String($form.find('input[name="hora_fim"]').val() || "").slice(0, 5);

        const diasTxt = diasSelecionados.length ? diasSelecionados.join(", ") : "Dias Indefinidos";
        const horaTxt = (hi && hf) ? `${hi} - ${hf}` : (hi ? `${hi} - ?` : (hf ? `? - ${hf}` : ""));

        const txt = horaTxt ? `${diasTxt} | ${horaTxt}` : diasTxt;
        return txt.toUpperCase();
      };

      // 1) quando usuário digitar no nome, marca como manual
      $(document).on("input", ".form-step-config-periodo .js-periodo-nome", function () {
        $(this).attr("data-manual", "1");
      });

      // 2) sempre que mudar dias/horas, atualiza sugestão
      const atualizar = ($form: JQuery) => {
        var $id = $form.find('input[type="hidden"][name="id"]');
        var rawId = $id.length ? $id.val() : "0";
        var idVal = parseInt(String(rawId || "0"), 10) || 0;

        var $nome = $form.find(".js-periodo-nome");
        var nomeAtual = String($nome.val() || "").trim();
        var sugestao = montarSugestao($form);
        var manual = String($nome.attr("data-manual") || "0") === "1";
        var padraoNomeAuto = nomeAtual.includes("|") && nomeAtual.includes("-");
        console.log("atualizar sugestao nome periodo", { idVal, nomeAtual, sugestao, manual, padraoNomeAuto });

        if (idVal > 0 && nomeAtual.length > 0 && !padraoNomeAuto) return;

        // Sugere no placeholder sempre
        $nome.attr("placeholder", sugestao);

        // Só escreve no value se o usuário ainda não digitou manualmente
        // if (!manual) {
        $nome.val(sugestao);
        // }
      };

      // change/blur/input (time dispara bem com change)
      $(document).on("change input", ".form-step-config-periodo input[name='hora_inicio'], .form-step-config-periodo input[name='hora_fim']", function () {
        const $form = $(this).closest("form");
        atualizar($form);
      });

      $(document).on("change", ".form-step-config-periodo input[name='dias[]']", function () {
        const $form = $(this).closest("form");
        atualizar($form);
      });

      // 3) quando abrir modal (novo/editar), já calcula uma vez
      // (Bootstrap dispara o evento shown.bs.modal)
      $(document).on("shown.bs.modal", ".parent-periodo", function () {
        const $form = $(this).find("form.form-step-config-periodo");
        // if ($form.length) atualizar($form);
      });
    }

  }
}
